
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1204"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1204"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
'use strict';

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
'use strict';

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
'use strict';
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
'use strict';

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



parcelRegister("4RND8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dflA0"))();

});
parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});



parcelRegister("5fBa6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3d2b2e0733cb3967$var$_react = $3d2b2e0733cb3967$var$_interopRequireDefault((parcelRequire("aqdBs")));

var $3d2b2e0733cb3967$var$_propTypes = $3d2b2e0733cb3967$var$_interopRequireDefault((parcelRequire("4RND8")));
parcelRequire("MQCL2");
var $ebiy2 = parcelRequire("ebiy2");
var $ebiy2 = parcelRequire("ebiy2");
var $3d2b2e0733cb3967$var$_excluded = [
    "children",
    "onClick",
    "replace",
    "to",
    "state",
    "activeClassName",
    "className",
    "activeStyle",
    "style",
    "isActive"
];
function $3d2b2e0733cb3967$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3d2b2e0733cb3967$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3d2b2e0733cb3967$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3d2b2e0733cb3967$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3d2b2e0733cb3967$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3d2b2e0733cb3967$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3d2b2e0733cb3967$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3d2b2e0733cb3967$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3d2b2e0733cb3967$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3d2b2e0733cb3967$var$_typeof(obj);
}
function $3d2b2e0733cb3967$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3d2b2e0733cb3967$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3d2b2e0733cb3967$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3d2b2e0733cb3967$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var $3d2b2e0733cb3967$var$LinkContainer = function LinkContainer(_ref) {
    var children = _ref.children, onClick = _ref.onClick, _ref$replace = _ref.replace, replace = _ref$replace === void 0 ? false : _ref$replace, to = _ref.to, state = _ref.state, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? 'active' : _ref$activeClassName, className = _ref.className, activeStyle = _ref.activeStyle, style = _ref.style, getIsActive = _ref.isActive, props = $3d2b2e0733cb3967$var$_objectWithoutProperties(_ref, $3d2b2e0733cb3967$var$_excluded);
    var path = $3d2b2e0733cb3967$var$_typeof(to) === 'object' ? to.pathname || '' : to;
    var navigate = (0, $ebiy2.useNavigate)();
    var href = (0, $ebiy2.useHref)(typeof to === 'string' ? {
        pathname: to
    } : to);
    var match = (0, $ebiy2.useMatch)(path);
    var location = (0, $ebiy2.useLocation)();
    var child = $3d2b2e0733cb3967$var$_react["default"].Children.only(children);
    var isActive = !!(getIsActive ? typeof getIsActive === 'function' ? getIsActive(match, location) : getIsActive : match);
    var handleClick = function handleClick(event) {
        if (children.props.onClick) children.props.onClick(event);
        if (onClick) onClick(event);
        if (!event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore right clicks
        !$3d2b2e0733cb3967$var$isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    };
    return /*#__PURE__*/ $3d2b2e0733cb3967$var$_react["default"].cloneElement(child, $3d2b2e0733cb3967$var$_objectSpread($3d2b2e0733cb3967$var$_objectSpread({}, props), {}, {
        className: [
            className,
            child.props.className,
            isActive ? activeClassName : null
        ].join(' ').trim(),
        style: isActive ? $3d2b2e0733cb3967$var$_objectSpread($3d2b2e0733cb3967$var$_objectSpread({}, style), activeStyle) : style,
        href: href,
        onClick: handleClick
    }));
};
$3d2b2e0733cb3967$var$LinkContainer.propTypes = {
    children: $3d2b2e0733cb3967$var$_propTypes["default"].element.isRequired,
    onClick: $3d2b2e0733cb3967$var$_propTypes["default"].func,
    replace: $3d2b2e0733cb3967$var$_propTypes["default"].bool,
    to: $3d2b2e0733cb3967$var$_propTypes["default"].oneOfType([
        $3d2b2e0733cb3967$var$_propTypes["default"].string,
        $3d2b2e0733cb3967$var$_propTypes["default"].object
    ]).isRequired,
    state: $3d2b2e0733cb3967$var$_propTypes["default"].object,
    className: $3d2b2e0733cb3967$var$_propTypes["default"].string,
    activeClassName: $3d2b2e0733cb3967$var$_propTypes["default"].string,
    style: $3d2b2e0733cb3967$var$_propTypes["default"].objectOf($3d2b2e0733cb3967$var$_propTypes["default"].oneOfType([
        $3d2b2e0733cb3967$var$_propTypes["default"].string,
        $3d2b2e0733cb3967$var$_propTypes["default"].number
    ])),
    activeStyle: $3d2b2e0733cb3967$var$_propTypes["default"].objectOf($3d2b2e0733cb3967$var$_propTypes["default"].oneOfType([
        $3d2b2e0733cb3967$var$_propTypes["default"].string,
        $3d2b2e0733cb3967$var$_propTypes["default"].number
    ])),
    isActive: $3d2b2e0733cb3967$var$_propTypes["default"].oneOfType([
        $3d2b2e0733cb3967$var$_propTypes["default"].func,
        $3d2b2e0733cb3967$var$_propTypes["default"].bool
    ])
};
var $3d2b2e0733cb3967$var$_default = $3d2b2e0733cb3967$var$LinkContainer;
module.exports["default"] = $3d2b2e0733cb3967$var$_default;

});
parcelRegister("MQCL2", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $092d4ddd3ad595b9$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $092d4ddd3ad595b9$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "Link", () => $092d4ddd3ad595b9$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "ScrollRestoration", () => $092d4ddd3ad595b9$export$11aac1aab828f1fa);
$parcel$export(module.exports, "useHref", () => (parcelRequire("ebiy2")).useHref);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("ebiy2")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("ebiy2")).useNavigate);
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $9FOsn = parcelRequire("9FOsn");
var $ebiy2 = parcelRequire("ebiy2");

var $9FOsn = parcelRequire("9FOsn");
function $092d4ddd3ad595b9$var$_extends() {
    $092d4ddd3ad595b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $092d4ddd3ad595b9$var$_extends.apply(this, arguments);
}
function $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $092d4ddd3ad595b9$var$defaultMethod = "get";
const $092d4ddd3ad595b9$var$defaultEncType = "application/x-www-form-urlencoded";
function $092d4ddd3ad595b9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $092d4ddd3ad595b9$var$isButtonElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $092d4ddd3ad595b9$var$isFormElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $092d4ddd3ad595b9$var$isInputElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $092d4ddd3ad595b9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $092d4ddd3ad595b9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$092d4ddd3ad595b9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $092d4ddd3ad595b9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = null;
function $092d4ddd3ad595b9$var$isFormDataSubmitterSupported() {
    if ($092d4ddd3ad595b9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = true;
    }
    return $092d4ddd3ad595b9$var$_formDataSupportsSubmitter;
}
const $092d4ddd3ad595b9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $092d4ddd3ad595b9$var$getFormEncType(encType) {
    if (encType != null && !$092d4ddd3ad595b9$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $092d4ddd3ad595b9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($092d4ddd3ad595b9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9FOsn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $092d4ddd3ad595b9$var$defaultMethod;
        encType = $092d4ddd3ad595b9$var$getFormEncType(target.getAttribute("enctype")) || $092d4ddd3ad595b9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($092d4ddd3ad595b9$var$isButtonElement(target) || $092d4ddd3ad595b9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9FOsn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $092d4ddd3ad595b9$var$defaultMethod;
        encType = $092d4ddd3ad595b9$var$getFormEncType(target.getAttribute("formenctype")) || $092d4ddd3ad595b9$var$getFormEncType(form.getAttribute("enctype")) || $092d4ddd3ad595b9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$092d4ddd3ad595b9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($092d4ddd3ad595b9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $092d4ddd3ad595b9$var$defaultMethod;
        action = null;
        encType = $092d4ddd3ad595b9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $092d4ddd3ad595b9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $092d4ddd3ad595b9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $092d4ddd3ad595b9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $092d4ddd3ad595b9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $092d4ddd3ad595b9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $092d4ddd3ad595b9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $092d4ddd3ad595b9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $092d4ddd3ad595b9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebiy2.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $092d4ddd3ad595b9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $092d4ddd3ad595b9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $092d4ddd3ad595b9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebiy2.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $092d4ddd3ad595b9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $092d4ddd3ad595b9$var$_extends({}, state, {
        errors: $092d4ddd3ad595b9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $092d4ddd3ad595b9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9FOsn.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $092d4ddd3ad595b9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $aqdBs.createContext({
    isTransitioning: false
});
const $092d4ddd3ad595b9$export$148fd98d095596d4 = /*#__PURE__*/ $aqdBs.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $092d4ddd3ad595b9$var$START_TRANSITION = "startTransition";
const $092d4ddd3ad595b9$var$startTransitionImpl = $aqdBs[$092d4ddd3ad595b9$var$START_TRANSITION];
const $092d4ddd3ad595b9$var$FLUSH_SYNC = "flushSync";
const $092d4ddd3ad595b9$var$flushSyncImpl = $jVlfX[$092d4ddd3ad595b9$var$FLUSH_SYNC];
const $092d4ddd3ad595b9$var$USE_ID = "useId";
const $092d4ddd3ad595b9$var$useIdImpl = $aqdBs[$092d4ddd3ad595b9$var$USE_ID];
function $092d4ddd3ad595b9$var$startTransitionSafe(cb) {
    if ($092d4ddd3ad595b9$var$startTransitionImpl) $092d4ddd3ad595b9$var$startTransitionImpl(cb);
    else cb();
}
function $092d4ddd3ad595b9$var$flushSyncSafe(cb) {
    if ($092d4ddd3ad595b9$var$flushSyncImpl) $092d4ddd3ad595b9$var$flushSyncImpl(cb);
    else cb();
}
class $092d4ddd3ad595b9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $092d4ddd3ad595b9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let [pendingState, setPendingState] = $aqdBs.useState();
    let [vtContext, setVtContext] = $aqdBs.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aqdBs.useState();
    let [transition, setTransition] = $aqdBs.useState();
    let [interruption, setInterruption] = $aqdBs.useState();
    let fetcherData = $aqdBs.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $aqdBs.useCallback((cb)=>{
        if (v7_startTransition) $092d4ddd3ad595b9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $aqdBs.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $092d4ddd3ad595b9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $092d4ddd3ad595b9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $092d4ddd3ad595b9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $092d4ddd3ad595b9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $092d4ddd3ad595b9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $aqdBs.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $092d4ddd3ad595b9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $aqdBs.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $aqdBs.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $092d4ddd3ad595b9$var$MemoizedDataRoutes = /*#__PURE__*/ $aqdBs.memo($092d4ddd3ad595b9$var$DataRoutes);
function $092d4ddd3ad595b9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $ebiy2.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $092d4ddd3ad595b9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $092d4ddd3ad595b9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $092d4ddd3ad595b9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $092d4ddd3ad595b9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $092d4ddd3ad595b9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $092d4ddd3ad595b9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aqdBs.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref7, $092d4ddd3ad595b9$var$_excluded);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $092d4ddd3ad595b9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($092d4ddd3ad595b9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9FOsn.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $ebiy2.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $092d4ddd3ad595b9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aqdBs.createElement("a", $092d4ddd3ad595b9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $092d4ddd3ad595b9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aqdBs.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref8, $092d4ddd3ad595b9$var$_excluded2);
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $ebiy2.useLocation)();
    let routerState = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $092d4ddd3ad595b9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9FOsn.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$a6c7ac8248d6e38a, $092d4ddd3ad595b9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $092d4ddd3ad595b9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aqdBs.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $092d4ddd3ad595b9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref9, $092d4ddd3ad595b9$var$_excluded3);
    let submit = $092d4ddd3ad595b9$export$47c85c6e3a081d3();
    let formAction = $092d4ddd3ad595b9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $aqdBs.createElement("form", $092d4ddd3ad595b9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $092d4ddd3ad595b9$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $092d4ddd3ad595b9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $092d4ddd3ad595b9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($092d4ddd3ad595b9$var$DataRouterHook || ($092d4ddd3ad595b9$var$DataRouterHook = {}));
var $092d4ddd3ad595b9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($092d4ddd3ad595b9$var$DataRouterStateHook || ($092d4ddd3ad595b9$var$DataRouterStateHook = {}));
// Internal hooks
function $092d4ddd3ad595b9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $092d4ddd3ad595b9$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterContext));
    !ctx && (0, $9FOsn.UNSAFE_invariant)(false);
    return ctx;
}
function $092d4ddd3ad595b9$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterStateContext));
    !state && (0, $9FOsn.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $092d4ddd3ad595b9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $ebiy2.useNavigate)();
    let location = (0, $ebiy2.useLocation)();
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: relative
    });
    return $aqdBs.useCallback((event)=>{
        if ($092d4ddd3ad595b9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $9FOsn.createPath)(location) === (0, $9FOsn.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $092d4ddd3ad595b9$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aqdBs.useRef($092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aqdBs.useRef(false);
    let location = (0, $ebiy2.useLocation)();
    let searchParams = $aqdBs.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $092d4ddd3ad595b9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $ebiy2.useNavigate)();
    let setSearchParams = $aqdBs.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $092d4ddd3ad595b9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $092d4ddd3ad595b9$var$fetcherId = 0;
let $092d4ddd3ad595b9$var$getUniqueFetcherId = ()=>"__" + String(++$092d4ddd3ad595b9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $092d4ddd3ad595b9$export$47c85c6e3a081d3() {
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let currentRouteId = (0, $ebiy2.UNSAFE_useRouteId)();
    return $aqdBs.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $092d4ddd3ad595b9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $092d4ddd3ad595b9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $092d4ddd3ad595b9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $092d4ddd3ad595b9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let routeContext = $aqdBs.useContext((0, $ebiy2.UNSAFE_RouteContext));
    !routeContext && (0, $9FOsn.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $092d4ddd3ad595b9$var$_extends({}, (0, $ebiy2.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $ebiy2.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $9FOsn.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $092d4ddd3ad595b9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseFetcher);
    let state = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $aqdBs.useContext($092d4ddd3ad595b9$export$148fd98d095596d4);
    let route = $aqdBs.useContext((0, $ebiy2.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9FOsn.UNSAFE_invariant)(false);
    !route && (0, $9FOsn.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $9FOsn.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $092d4ddd3ad595b9$var$useIdImpl ? $092d4ddd3ad595b9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $aqdBs.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($092d4ddd3ad595b9$var$getUniqueFetcherId());
    // Registration/cleanup
    $aqdBs.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $aqdBs.useCallback((href, opts)=>{
        !routeId && (0, $9FOsn.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $092d4ddd3ad595b9$export$47c85c6e3a081d3();
    let submit = $aqdBs.useCallback((target, opts)=>{
        submitImpl(target, $092d4ddd3ad595b9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $aqdBs.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$a7fed597f4b8afd8, $092d4ddd3ad595b9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9FOsn.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aqdBs.useMemo(()=>$092d4ddd3ad595b9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $092d4ddd3ad595b9$export$fa996778a3a31087() {
    let state = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $092d4ddd3ad595b9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $092d4ddd3ad595b9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $092d4ddd3ad595b9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let location = (0, $ebiy2.useLocation)();
    let matches = (0, $ebiy2.useMatches)();
    let navigation = (0, $ebiy2.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $aqdBs.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $092d4ddd3ad595b9$var$usePageHide($aqdBs.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $092d4ddd3ad595b9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($092d4ddd3ad595b9$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $092d4ddd3ad595b9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($092d4ddd3ad595b9$var$_extends({}, location, {
                    pathname: (0, $9FOsn.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($092d4ddd3ad595b9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $092d4ddd3ad595b9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $092d4ddd3ad595b9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $092d4ddd3ad595b9$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $ebiy2.useBlocker)(when);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $092d4ddd3ad595b9$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $aqdBs.useContext($092d4ddd3ad595b9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9FOsn.UNSAFE_invariant)(false);
    let { basename: basename } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9FOsn.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9FOsn.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9FOsn.matchPath)(path.pathname, nextPath) != null || (0, $9FOsn.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("jVlfX", function(module, exports) {
'use strict';
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

module.exports = (parcelRequire("l8cRS"));

});

parcelRegister("9FOsn", function(module, exports) {

$parcel$export(module.exports, "Action", () => $01d146888511578c$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $01d146888511578c$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $01d146888511578c$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $01d146888511578c$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $01d146888511578c$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $01d146888511578c$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $01d146888511578c$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $01d146888511578c$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $01d146888511578c$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $01d146888511578c$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $01d146888511578c$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $01d146888511578c$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $01d146888511578c$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $01d146888511578c$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $01d146888511578c$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $01d146888511578c$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "redirect", () => $01d146888511578c$export$89e12c5b50f7529d);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $01d146888511578c$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $01d146888511578c$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $01d146888511578c$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $01d146888511578c$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $01d146888511578c$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $01d146888511578c$var$_extends() {
    $01d146888511578c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01d146888511578c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $01d146888511578c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($01d146888511578c$export$e19cd5f9376f8cee || ($01d146888511578c$export$e19cd5f9376f8cee = {}));
const $01d146888511578c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $01d146888511578c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $01d146888511578c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $01d146888511578c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $01d146888511578c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $01d146888511578c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
    }
    return $01d146888511578c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $01d146888511578c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $01d146888511578c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $01d146888511578c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $01d146888511578c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $01d146888511578c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $01d146888511578c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $01d146888511578c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $01d146888511578c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $01d146888511578c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $01d146888511578c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $01d146888511578c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $01d146888511578c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $01d146888511578c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $01d146888511578c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $01d146888511578c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($01d146888511578c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Push;
        let location = $01d146888511578c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $01d146888511578c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        let location = $01d146888511578c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $01d146888511578c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $01d146888511578c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($01d146888511578c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($01d146888511578c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $01d146888511578c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($01d146888511578c$var$ResultType || ($01d146888511578c$var$ResultType = {}));
const $01d146888511578c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $01d146888511578c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $01d146888511578c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $01d146888511578c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $01d146888511578c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($01d146888511578c$var$isIndexRoute(route)) {
            let indexRoute = $01d146888511578c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $01d146888511578c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $01d146888511578c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $01d146888511578c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $01d146888511578c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $01d146888511578c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $01d146888511578c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $01d146888511578c$var$flattenRoutes(routes);
    $01d146888511578c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $01d146888511578c$export$30d21fd6d7295f52(pathname);
        matches = $01d146888511578c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $01d146888511578c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $01d146888511578c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $01d146888511578c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $01d146888511578c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $01d146888511578c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $01d146888511578c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $01d146888511578c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $01d146888511578c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $01d146888511578c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $01d146888511578c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $01d146888511578c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $01d146888511578c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $01d146888511578c$var$paramRe = /^:[\w-]+$/;
const $01d146888511578c$var$dynamicSegmentValue = 3;
const $01d146888511578c$var$indexRouteValue = 2;
const $01d146888511578c$var$emptySegmentValue = 1;
const $01d146888511578c$var$staticSegmentValue = 10;
const $01d146888511578c$var$splatPenalty = -2;
const $01d146888511578c$var$isSplat = (s)=>s === "*";
function $01d146888511578c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($01d146888511578c$var$isSplat)) initialScore += $01d146888511578c$var$splatPenalty;
    if (index) initialScore += $01d146888511578c$var$indexRouteValue;
    return segments.filter((s)=>!$01d146888511578c$var$isSplat(s)).reduce((score, segment)=>score + ($01d146888511578c$var$paramRe.test(segment) ? $01d146888511578c$var$dynamicSegmentValue : segment === "" ? $01d146888511578c$var$emptySegmentValue : $01d146888511578c$var$staticSegmentValue), initialScore);
}
function $01d146888511578c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $01d146888511578c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $01d146888511578c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $01d146888511578c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $01d146888511578c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $01d146888511578c$export$a5c6d149b50c1d86($01d146888511578c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $01d146888511578c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $01d146888511578c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $01d146888511578c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $01d146888511578c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $01d146888511578c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $01d146888511578c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $01d146888511578c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $01d146888511578c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $01d146888511578c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $01d146888511578c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $01d146888511578c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $01d146888511578c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $01d146888511578c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $01d146888511578c$var$normalizeSearch(search),
        hash: $01d146888511578c$var$normalizeHash(hash)
    };
}
function $01d146888511578c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $01d146888511578c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $01d146888511578c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $01d146888511578c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $01d146888511578c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $01d146888511578c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $01d146888511578c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $01d146888511578c$var$_extends({}, toArg);
        $01d146888511578c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $01d146888511578c$var$getInvalidPathError("?", "pathname", "search", to));
        $01d146888511578c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $01d146888511578c$var$getInvalidPathError("#", "pathname", "hash", to));
        $01d146888511578c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $01d146888511578c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $01d146888511578c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $01d146888511578c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $01d146888511578c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $01d146888511578c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $01d146888511578c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $01d146888511578c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $01d146888511578c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $01d146888511578c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $01d146888511578c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $01d146888511578c$export$4051a07651545597(data, init) {
    return new $01d146888511578c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $01d146888511578c$export$42a99a7a4bc0e76a extends Error {
}
class $01d146888511578c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $01d146888511578c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $01d146888511578c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $01d146888511578c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $01d146888511578c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $01d146888511578c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $01d146888511578c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $01d146888511578c$var$unwrapTrackedPromise(value) {
    if (!$01d146888511578c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $01d146888511578c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $01d146888511578c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $01d146888511578c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $01d146888511578c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $01d146888511578c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $01d146888511578c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $01d146888511578c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $01d146888511578c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $01d146888511578c$var$validMutationMethods = new Set($01d146888511578c$var$validMutationMethodsArr);
const $01d146888511578c$var$validRequestMethodsArr = [
    "get",
    ...$01d146888511578c$var$validMutationMethodsArr
];
const $01d146888511578c$var$validRequestMethods = new Set($01d146888511578c$var$validRequestMethodsArr);
const $01d146888511578c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $01d146888511578c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $01d146888511578c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $01d146888511578c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $01d146888511578c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $01d146888511578c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $01d146888511578c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $01d146888511578c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $01d146888511578c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $01d146888511578c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $01d146888511578c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $01d146888511578c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $01d146888511578c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $01d146888511578c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$01d146888511578c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$01d146888511578c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $01d146888511578c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $01d146888511578c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $01d146888511578c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $01d146888511578c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$01d146888511578c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($01d146888511578c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $01d146888511578c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $01d146888511578c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $01d146888511578c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $01d146888511578c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $01d146888511578c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($01d146888511578c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $01d146888511578c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $01d146888511578c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $01d146888511578c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $01d146888511578c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $01d146888511578c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $01d146888511578c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $01d146888511578c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $01d146888511578c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $01d146888511578c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $01d146888511578c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $01d146888511578c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $01d146888511578c$var$findNearestBoundary(matches).route.id,
            {
                type: $01d146888511578c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $01d146888511578c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($01d146888511578c$var$isErrorResult(result) && $01d146888511578c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $01d146888511578c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $01d146888511578c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $01d146888511578c$var$_extends({
            matches: updatedMatches || matches
        }, $01d146888511578c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $01d146888511578c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $01d146888511578c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $01d146888511578c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $01d146888511578c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $01d146888511578c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $01d146888511578c$var$ResultType.error,
            error: $01d146888511578c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($01d146888511578c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $01d146888511578c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($01d146888511578c$var$isDeferredResult(result)) throw $01d146888511578c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($01d146888511578c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $01d146888511578c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $01d146888511578c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $01d146888511578c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($01d146888511578c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $01d146888511578c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $01d146888511578c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $01d146888511578c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $01d146888511578c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $01d146888511578c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $01d146888511578c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $01d146888511578c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $01d146888511578c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$01d146888511578c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $01d146888511578c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $01d146888511578c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $01d146888511578c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $01d146888511578c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $01d146888511578c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $01d146888511578c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $01d146888511578c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $01d146888511578c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $01d146888511578c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $01d146888511578c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($01d146888511578c$var$isRedirectResult(actionResult) || $01d146888511578c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($01d146888511578c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $01d146888511578c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($01d146888511578c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($01d146888511578c$var$isDeferredResult(actionResult)) throw $01d146888511578c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $01d146888511578c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $01d146888511578c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $01d146888511578c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $01d146888511578c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $01d146888511578c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $01d146888511578c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $01d146888511578c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $01d146888511578c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $01d146888511578c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $01d146888511578c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $01d146888511578c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $01d146888511578c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $01d146888511578c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($01d146888511578c$var$isDeferredResult(result)) result = await $01d146888511578c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($01d146888511578c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($01d146888511578c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $01d146888511578c$export$3e9cee6b33872309(!$01d146888511578c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $01d146888511578c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $01d146888511578c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $01d146888511578c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $01d146888511578c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $01d146888511578c$export$e19cd5f9376f8cee.Replace : $01d146888511578c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $01d146888511578c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($01d146888511578c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $01d146888511578c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $01d146888511578c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $01d146888511578c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $01d146888511578c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $01d146888511578c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($01d146888511578c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $01d146888511578c$var$ResultType.redirect,
                response: $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $01d146888511578c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $01d146888511578c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $01d146888511578c$var$ResultType.error,
                    error: $01d146888511578c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $01d146888511578c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $01d146888511578c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $01d146888511578c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $01d146888511578c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $01d146888511578c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $01d146888511578c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $01d146888511578c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $01d146888511578c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $01d146888511578c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $01d146888511578c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $01d146888511578c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $01d146888511578c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $01d146888511578c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$01d146888511578c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $01d146888511578c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $01d146888511578c$export$4d0306f8f6a4585b = Symbol("deferred");
function $01d146888511578c$export$3336b097a6fbc59a(routes, opts) {
    $01d146888511578c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $01d146888511578c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $01d146888511578c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $01d146888511578c$var$createLocation("", $01d146888511578c$export$fe53371bee54353d(url), null, "default");
        let matches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$01d146888511578c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $01d146888511578c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $01d146888511578c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($01d146888511578c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $01d146888511578c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $01d146888511578c$var$createLocation("", $01d146888511578c$export$fe53371bee54353d(url), null, "default");
        let matches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$01d146888511578c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $01d146888511578c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $01d146888511578c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $01d146888511578c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $01d146888511578c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $01d146888511578c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($01d146888511578c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$01d146888511578c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $01d146888511578c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($01d146888511578c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $01d146888511578c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $01d146888511578c$var$isResponse(result) ? result : $01d146888511578c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($01d146888511578c$var$isDataStrategyResult(e) && $01d146888511578c$var$isResponse(e.result)) {
                if (e.type === $01d146888511578c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($01d146888511578c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $01d146888511578c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $01d146888511578c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($01d146888511578c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($01d146888511578c$var$isDeferredResult(result)) {
            let error = $01d146888511578c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $01d146888511578c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($01d146888511578c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($01d146888511578c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $01d146888511578c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $01d146888511578c$var$_extends({}, context, {
                statusCode: $01d146888511578c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $01d146888511578c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $01d146888511578c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $01d146888511578c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $01d146888511578c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $01d146888511578c$var$callDataStrategyImpl(dataStrategy || $01d146888511578c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($01d146888511578c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($01d146888511578c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $01d146888511578c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $01d146888511578c$export$fec11da027c70692(routes, context, error) {
    let newContext = $01d146888511578c$var$_extends({}, context, {
        statusCode: $01d146888511578c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $01d146888511578c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $01d146888511578c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $01d146888511578c$export$cae722b0cc860f13(to ? to : ".", $01d146888511578c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $01d146888511578c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $01d146888511578c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $01d146888511578c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $01d146888511578c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $01d146888511578c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$01d146888511578c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$01d146888511578c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $01d146888511578c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $01d146888511578c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $01d146888511578c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$01d146888511578c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$01d146888511578c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $01d146888511578c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $01d146888511578c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $01d146888511578c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $01d146888511578c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $01d146888511578c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($01d146888511578c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $01d146888511578c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $01d146888511578c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $01d146888511578c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $01d146888511578c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $01d146888511578c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($01d146888511578c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $01d146888511578c$var$shouldRevalidateLoader(match, $01d146888511578c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $01d146888511578c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $01d146888511578c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $01d146888511578c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $01d146888511578c$var$shouldRevalidateLoader(fetcherMatch, $01d146888511578c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $01d146888511578c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $01d146888511578c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $01d146888511578c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $01d146888511578c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $01d146888511578c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$01d146888511578c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $01d146888511578c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $01d146888511578c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$01d146888511578c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $01d146888511578c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $01d146888511578c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $01d146888511578c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$01d146888511578c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $01d146888511578c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $01d146888511578c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $01d146888511578c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $01d146888511578c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $01d146888511578c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $01d146888511578c$var$ResultType.data,
                result: undefined
            });
        };
        return $01d146888511578c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $01d146888511578c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $01d146888511578c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $01d146888511578c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $01d146888511578c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $01d146888511578c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $01d146888511578c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $01d146888511578c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($01d146888511578c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $01d146888511578c$var$ResultType.error,
                error: e
            };
        }
        if (type === $01d146888511578c$var$ResultType.error) return {
            type: $01d146888511578c$var$ResultType.error,
            error: new $01d146888511578c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $01d146888511578c$var$ResultType.error) {
        if ($01d146888511578c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $01d146888511578c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $01d146888511578c$var$ResultType.error,
                error: new $01d146888511578c$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $01d146888511578c$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $01d146888511578c$var$ResultType.error,
            error: result,
            statusCode: $01d146888511578c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($01d146888511578c$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $01d146888511578c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($01d146888511578c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $01d146888511578c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $01d146888511578c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $01d146888511578c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $01d146888511578c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $01d146888511578c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $01d146888511578c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($01d146888511578c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $01d146888511578c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $01d146888511578c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $01d146888511578c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $01d146888511578c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $01d146888511578c$export$3e9cee6b33872309(!$01d146888511578c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($01d146888511578c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $01d146888511578c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $01d146888511578c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($01d146888511578c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $01d146888511578c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $01d146888511578c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($01d146888511578c$var$isErrorResult(result)) {
            let boundaryMatch = $01d146888511578c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $01d146888511578c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($01d146888511578c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $01d146888511578c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($01d146888511578c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $01d146888511578c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $01d146888511578c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $01d146888511578c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $01d146888511578c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $01d146888511578c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $01d146888511578c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $01d146888511578c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $01d146888511578c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $01d146888511578c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($01d146888511578c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $01d146888511578c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(path) : path;
    return $01d146888511578c$export$fe53371bee54353d($01d146888511578c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $01d146888511578c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $01d146888511578c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $01d146888511578c$var$ResultType.data || result.type === $01d146888511578c$var$ResultType.error);
}
function $01d146888511578c$var$isRedirectDataStrategyResultResult(result) {
    return $01d146888511578c$var$isResponse(result.result) && $01d146888511578c$var$redirectStatusCodes.has(result.result.status);
}
function $01d146888511578c$var$isDeferredResult(result) {
    return result.type === $01d146888511578c$var$ResultType.deferred;
}
function $01d146888511578c$var$isErrorResult(result) {
    return result.type === $01d146888511578c$var$ResultType.error;
}
function $01d146888511578c$var$isRedirectResult(result) {
    return (result && result.type) === $01d146888511578c$var$ResultType.redirect;
}
function $01d146888511578c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $01d146888511578c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $01d146888511578c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $01d146888511578c$var$isRedirectResponse(result) {
    if (!$01d146888511578c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $01d146888511578c$var$isValidMethod(method) {
    return $01d146888511578c$var$validRequestMethods.has(method.toLowerCase());
}
function $01d146888511578c$var$isMutationMethod(method) {
    return $01d146888511578c$var$validMutationMethods.has(method.toLowerCase());
}
async function $01d146888511578c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$01d146888511578c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($01d146888511578c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $01d146888511578c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $01d146888511578c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($01d146888511578c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $01d146888511578c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $01d146888511578c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $01d146888511578c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $01d146888511578c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $01d146888511578c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $01d146888511578c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $01d146888511578c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $01d146888511578c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $01d146888511578c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $01d146888511578c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $01d146888511578c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $01d146888511578c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $01d146888511578c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $01d146888511578c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $01d146888511578c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $01d146888511578c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($01d146888511578c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $01d146888511578c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($01d146888511578c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $01d146888511578c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("ebiy2", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $a5307b094a1b61c3$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $a5307b094a1b61c3$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $a5307b094a1b61c3$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $a5307b094a1b61c3$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $a5307b094a1b61c3$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $a5307b094a1b61c3$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $a5307b094a1b61c3$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $a5307b094a1b61c3$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $a5307b094a1b61c3$export$9770f232ac06a008);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $a5307b094a1b61c3$export$5fcee62552a12fbf);
$parcel$export(module.exports, "useRouteError", () => $a5307b094a1b61c3$export$ed527bf60f6e05f2);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $a5307b094a1b61c3$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $a5307b094a1b61c3$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $a5307b094a1b61c3$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $a5307b094a1b61c3$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $a5307b094a1b61c3$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $a5307b094a1b61c3$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $a5307b094a1b61c3$export$910ae8079b2c2852);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $a5307b094a1b61c3$export$52b333d321859367);
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

var $9FOsn = parcelRequire("9FOsn");
function $a5307b094a1b61c3$var$_extends() {
    $a5307b094a1b61c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5307b094a1b61c3$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $a5307b094a1b61c3$export$3add0d5dce533e2e = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$145dfa71566a64dc = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$var$AwaitContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $a5307b094a1b61c3$export$26749e8557646306 = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$c7914228fb69b0f5 = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$9072aa6dd1f93057 = /*#__PURE__*/ $aqdBs.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $a5307b094a1b61c3$var$RouteErrorContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $a5307b094a1b61c3$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $a5307b094a1b61c3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $a5307b094a1b61c3$export$9c954a9d03d32f4a() {
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $a5307b094a1b61c3$export$45d76561a5302f2b() {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $a5307b094a1b61c3$export$1b3f31771c5d07c() {
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $a5307b094a1b61c3$export$6c330e8992e8a295(pattern) {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { pathname: pathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    return $aqdBs.useMemo(()=>(0, $9FOsn.matchPath)(pattern, (0, $9FOsn.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $a5307b094a1b61c3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aqdBs.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $a5307b094a1b61c3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $a5307b094a1b61c3$var$useNavigateStable() : $a5307b094a1b61c3$var$useNavigateUnstable();
}
function $a5307b094a1b61c3$var$useNavigateUnstable() {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let dataRouterContext = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $aqdBs.useRef(false);
    $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $9FOsn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $a5307b094a1b61c3$var$OutletContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $a5307b094a1b61c3$export$4138103a3ae699cc() {
    return $aqdBs.useContext($a5307b094a1b61c3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $a5307b094a1b61c3$export$a3be3530d8e40d0b(context) {
    let outlet = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $a5307b094a1b61c3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $a5307b094a1b61c3$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $aqdBs.useMemo(()=>(0, $9FOsn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $a5307b094a1b61c3$export$5d3fca4a98652595(routes, locationArg) {
    return $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: parentMatches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $9FOsn.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9FOsn.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $9FOsn.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $a5307b094a1b61c3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9FOsn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9FOsn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $a5307b094a1b61c3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9FOsn.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $a5307b094a1b61c3$var$DefaultErrorComponent() {
    let error = $a5307b094a1b61c3$export$ed527bf60f6e05f2();
    let message = (0, $9FOsn.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aqdBs.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aqdBs.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $a5307b094a1b61c3$var$defaultErrorElement = /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$DefaultErrorComponent, null);
class $a5307b094a1b61c3$var$RenderErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $a5307b094a1b61c3$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $a5307b094a1b61c3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $9FOsn.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $a5307b094a1b61c3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $a5307b094a1b61c3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aqdBs.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $a5307b094a1b61c3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($a5307b094a1b61c3$var$DataRouterHook || {});
var $a5307b094a1b61c3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($a5307b094a1b61c3$var$DataRouterStateHook || {});
function $a5307b094a1b61c3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a5307b094a1b61c3$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    !ctx && (0, $9FOsn.UNSAFE_invariant)(false);
    return ctx;
}
function $a5307b094a1b61c3$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext($a5307b094a1b61c3$export$145dfa71566a64dc);
    !state && (0, $9FOsn.UNSAFE_invariant)(false);
    return state;
}
function $a5307b094a1b61c3$var$useRouteContext(hookName) {
    let route = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    !route && (0, $9FOsn.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $a5307b094a1b61c3$var$useCurrentRouteId(hookName) {
    let route = $a5307b094a1b61c3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9FOsn.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $a5307b094a1b61c3$export$5fc8298006ad9e58() {
    return $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $a5307b094a1b61c3$export$d0fd4b7106de2769() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $a5307b094a1b61c3$export$600dc272ed516c15() {
    let dataRouterContext = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseRevalidator);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRevalidator);
    return $aqdBs.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $a5307b094a1b61c3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseMatches);
    return $aqdBs.useMemo(()=>matches.map((m)=>(0, $9FOsn.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $a5307b094a1b61c3$export$1448a5050d252c4d() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $a5307b094a1b61c3$export$fd5d37484eab868d(routeId) {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $a5307b094a1b61c3$export$fdc00f3f26066d5e() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseActionData);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $a5307b094a1b61c3$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aqdBs.useContext($a5307b094a1b61c3$var$RouteErrorContext);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteError);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $a5307b094a1b61c3$export$78a72ddb39bdd145() {
    let value = $aqdBs.useContext($a5307b094a1b61c3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $a5307b094a1b61c3$export$17f53340677d5831() {
    let value = $aqdBs.useContext($a5307b094a1b61c3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $a5307b094a1b61c3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $a5307b094a1b61c3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseBlocker);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aqdBs.useState("");
    let blockerFunction = $aqdBs.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $a5307b094a1b61c3$var$_extends({}, currentLocation, {
                pathname: (0, $9FOsn.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $a5307b094a1b61c3$var$_extends({}, nextLocation, {
                pathname: (0, $9FOsn.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aqdBs.useEffect(()=>{
        let key = String(++$a5307b094a1b61c3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aqdBs.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9FOsn.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $a5307b094a1b61c3$var$useNavigateStable() {
    let { router: router } = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseNavigateStable);
    let id = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aqdBs.useRef(false);
    $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $a5307b094a1b61c3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $a5307b094a1b61c3$var$alreadyWarned$1 = {};
function $a5307b094a1b61c3$var$warningOnce(key, cond, message) {
    if (!cond && !$a5307b094a1b61c3$var$alreadyWarned$1[key]) $a5307b094a1b61c3$var$alreadyWarned$1[key] = true;
}
const $a5307b094a1b61c3$var$alreadyWarned = {};
function $a5307b094a1b61c3$var$warnOnce(key, message) {}
const $a5307b094a1b61c3$var$logDeprecation = (flag, msg, link)=>$a5307b094a1b61c3$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $a5307b094a1b61c3$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $a5307b094a1b61c3$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a5307b094a1b61c3$var$START_TRANSITION = "startTransition";
const $a5307b094a1b61c3$var$startTransitionImpl = $aqdBs[$a5307b094a1b61c3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a5307b094a1b61c3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        if (v7_startTransition && $a5307b094a1b61c3$var$startTransitionImpl) $a5307b094a1b61c3$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $aqdBs.useEffect(()=>$a5307b094a1b61c3$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $a5307b094a1b61c3$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $a5307b094a1b61c3$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $a5307b094a1b61c3$var$startTransitionImpl ? $a5307b094a1b61c3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>$a5307b094a1b61c3$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $a5307b094a1b61c3$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let navigate = $a5307b094a1b61c3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $9FOsn.resolveTo)(to, (0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aqdBs.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $a5307b094a1b61c3$export$910ae8079b2c2852(props) {
    return $a5307b094a1b61c3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $a5307b094a1b61c3$export$e7b0ac011bb776c6(_props) {
    (0, $9FOsn.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $a5307b094a1b61c3$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $9FOsn.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aqdBs.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $a5307b094a1b61c3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9FOsn.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aqdBs.useMemo(()=>{
        let trailingPathname = (0, $9FOsn.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $a5307b094a1b61c3$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $a5307b094a1b61c3$export$5d3fca4a98652595($a5307b094a1b61c3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $a5307b094a1b61c3$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$ResolveAwait, null, children));
}
var $a5307b094a1b61c3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($a5307b094a1b61c3$var$AwaitRenderStatus || {});
const $a5307b094a1b61c3$var$neverSettledPromise = new Promise(()=>{});
class $a5307b094a1b61c3$var$AwaitErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $a5307b094a1b61c3$var$AwaitRenderStatus.error : "_data" in promise ? $a5307b094a1b61c3$var$AwaitRenderStatus.success : $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error && promise._error instanceof (0, $9FOsn.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $a5307b094a1b61c3$var$neverSettledPromise;
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $a5307b094a1b61c3$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $a5307b094a1b61c3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $a5307b094a1b61c3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aqdBs.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aqdBs.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $a5307b094a1b61c3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $a5307b094a1b61c3$export$e7b0ac011bb776c6) && (0, $9FOsn.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $9FOsn.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $a5307b094a1b61c3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $a5307b094a1b61c3$export$daf73786167a7f72(matches) {
    return $a5307b094a1b61c3$var$_renderMatches(matches);
}
function $a5307b094a1b61c3$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aqdBs.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $aqdBs.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aqdBs.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $a5307b094a1b61c3$export$f30f7e456d254e83(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a5307b094a1b61c3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $a5307b094a1b61c3$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});



parcelRegister("eiXmw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", () => $a6a0cb370a3000b6$export$1c00760e9e5a4e95);
$parcel$export(module.exports, "AxiosError", () => $a6a0cb370a3000b6$export$c1fbed17c2f6a328);
$parcel$export(module.exports, "CanceledError", () => $a6a0cb370a3000b6$export$1ab0c6b20d94fa14);
$parcel$export(module.exports, "isCancel", () => $a6a0cb370a3000b6$export$3b22524397b493c6);
$parcel$export(module.exports, "CancelToken", () => $a6a0cb370a3000b6$export$fd08e3cb425f0d61);
$parcel$export(module.exports, "VERSION", () => $a6a0cb370a3000b6$export$a4ad2735b021c132);
$parcel$export(module.exports, "all", () => $a6a0cb370a3000b6$export$84bf76cd7afc7469);
$parcel$export(module.exports, "Cancel", () => $a6a0cb370a3000b6$export$848c9b7ead0df967);
$parcel$export(module.exports, "isAxiosError", () => $a6a0cb370a3000b6$export$fbafdbe06a5b5a9a);
$parcel$export(module.exports, "spread", () => $a6a0cb370a3000b6$export$3ae0fd4797ed47c8);
$parcel$export(module.exports, "toFormData", () => $a6a0cb370a3000b6$export$10ae0d317ea97f8b);
$parcel$export(module.exports, "AxiosHeaders", () => $a6a0cb370a3000b6$export$4e7d6ff0f3e6520);
$parcel$export(module.exports, "HttpStatusCode", () => $a6a0cb370a3000b6$export$a972f69c851492b3);
$parcel$export(module.exports, "formToJSON", () => $a6a0cb370a3000b6$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "getAdapter", () => $a6a0cb370a3000b6$export$17ddc20a97d669e2);
$parcel$export(module.exports, "mergeConfig", () => $a6a0cb370a3000b6$export$7ec1ebcfa9d8bd6a);
$parcel$export(module.exports, "default", () => (parcelRequire("hnjvf")).default);

var $hnjvf = parcelRequire("hnjvf");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $a6a0cb370a3000b6$export$1c00760e9e5a4e95, AxiosError: $a6a0cb370a3000b6$export$c1fbed17c2f6a328, CanceledError: $a6a0cb370a3000b6$export$1ab0c6b20d94fa14, isCancel: $a6a0cb370a3000b6$export$3b22524397b493c6, CancelToken: $a6a0cb370a3000b6$export$fd08e3cb425f0d61, VERSION: $a6a0cb370a3000b6$export$a4ad2735b021c132, all: $a6a0cb370a3000b6$export$84bf76cd7afc7469, Cancel: $a6a0cb370a3000b6$export$848c9b7ead0df967, isAxiosError: $a6a0cb370a3000b6$export$fbafdbe06a5b5a9a, spread: $a6a0cb370a3000b6$export$3ae0fd4797ed47c8, toFormData: $a6a0cb370a3000b6$export$10ae0d317ea97f8b, AxiosHeaders: $a6a0cb370a3000b6$export$4e7d6ff0f3e6520, HttpStatusCode: $a6a0cb370a3000b6$export$a972f69c851492b3, formToJSON: $a6a0cb370a3000b6$export$86d7c59254d6a2c9, getAdapter: $a6a0cb370a3000b6$export$17ddc20a97d669e2, mergeConfig: $a6a0cb370a3000b6$export$7ec1ebcfa9d8bd6a } = (0, $hnjvf.default);

});
parcelRegister("hnjvf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca63b685bc3ade8e$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $2TpI2 = parcelRequire("2TpI2");

var $3aHYf = parcelRequire("3aHYf");

var $83mJk = parcelRequire("83mJk");

var $151sS = parcelRequire("151sS");

var $cQn4z = parcelRequire("cQn4z");

var $fRtRc = parcelRequire("fRtRc");

var $beyAx = parcelRequire("beyAx");

var $ktZ5Z = parcelRequire("ktZ5Z");

var $fs77V = parcelRequire("fs77V");

var $5rtXJ = parcelRequire("5rtXJ");

var $1RZXx = parcelRequire("1RZXx");

var $kHzHP = parcelRequire("kHzHP");

var $3Qei4 = parcelRequire("3Qei4");

var $YvDhC = parcelRequire("YvDhC");

var $9kUFV = parcelRequire("9kUFV");

var $yYcza = parcelRequire("yYcza");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $ca63b685bc3ade8e$var$createInstance(defaultConfig) {
    const context = new (0, $3aHYf.default)(defaultConfig);
    const instance = (0, $2TpI2.default)((0, $3aHYf.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $5V4Df.default).extend(instance, (0, $3aHYf.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $5V4Df.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ca63b685bc3ade8e$var$createInstance((0, $83mJk.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $ca63b685bc3ade8e$var$axios = $ca63b685bc3ade8e$var$createInstance((0, $151sS.default));
// Expose Axios class to allow class inheritance
$ca63b685bc3ade8e$var$axios.Axios = (0, $3aHYf.default);
// Expose Cancel & CancelToken
$ca63b685bc3ade8e$var$axios.CanceledError = (0, $fRtRc.default);
$ca63b685bc3ade8e$var$axios.CancelToken = (0, $beyAx.default);
$ca63b685bc3ade8e$var$axios.isCancel = (0, $ktZ5Z.default);
$ca63b685bc3ade8e$var$axios.VERSION = (0, $fs77V.VERSION);
$ca63b685bc3ade8e$var$axios.toFormData = (0, $5rtXJ.default);
// Expose AxiosError class
$ca63b685bc3ade8e$var$axios.AxiosError = (0, $1RZXx.default);
// alias for CanceledError for backward compatibility
$ca63b685bc3ade8e$var$axios.Cancel = $ca63b685bc3ade8e$var$axios.CanceledError;
// Expose all/spread
$ca63b685bc3ade8e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$ca63b685bc3ade8e$var$axios.spread = (0, $kHzHP.default);
// Expose isAxiosError
$ca63b685bc3ade8e$var$axios.isAxiosError = (0, $3Qei4.default);
// Expose mergeConfig
$ca63b685bc3ade8e$var$axios.mergeConfig = (0, $83mJk.default);
$ca63b685bc3ade8e$var$axios.AxiosHeaders = (0, $YvDhC.default);
$ca63b685bc3ade8e$var$axios.formToJSON = (thing)=>(0, $cQn4z.default)((0, $5V4Df.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$ca63b685bc3ade8e$var$axios.getAdapter = (0, $9kUFV.default).getAdapter;
$ca63b685bc3ade8e$var$axios.HttpStatusCode = (0, $yYcza.default);
$ca63b685bc3ade8e$var$axios.default = $ca63b685bc3ade8e$var$axios;
var // this module should only have a default export
$ca63b685bc3ade8e$export$2e2bcd8739ae039 = $ca63b685bc3ade8e$var$axios;

});
parcelRegister("5V4Df", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f5de6ecd9ad742$export$2e2bcd8739ae039);

var $2TpI2 = parcelRequire("2TpI2");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $44f5de6ecd9ad742$var$toString } = Object.prototype;
const { getPrototypeOf: $44f5de6ecd9ad742$var$getPrototypeOf } = Object;
const { iterator: $44f5de6ecd9ad742$var$iterator, toStringTag: $44f5de6ecd9ad742$var$toStringTag } = Symbol;
const $44f5de6ecd9ad742$var$kindOf = ((cache)=>(thing)=>{
        const str = $44f5de6ecd9ad742$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $44f5de6ecd9ad742$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$44f5de6ecd9ad742$var$kindOf(thing) === type;
};
const $44f5de6ecd9ad742$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $44f5de6ecd9ad742$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $44f5de6ecd9ad742$var$isUndefined = $44f5de6ecd9ad742$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $44f5de6ecd9ad742$var$isBuffer(val) {
    return val !== null && !$44f5de6ecd9ad742$var$isUndefined(val) && val.constructor !== null && !$44f5de6ecd9ad742$var$isUndefined(val.constructor) && $44f5de6ecd9ad742$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $44f5de6ecd9ad742$var$isArrayBuffer = $44f5de6ecd9ad742$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $44f5de6ecd9ad742$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $44f5de6ecd9ad742$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $44f5de6ecd9ad742$var$isString = $44f5de6ecd9ad742$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $44f5de6ecd9ad742$var$isFunction = $44f5de6ecd9ad742$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $44f5de6ecd9ad742$var$isNumber = $44f5de6ecd9ad742$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $44f5de6ecd9ad742$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $44f5de6ecd9ad742$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $44f5de6ecd9ad742$var$isPlainObject = (val)=>{
    if ($44f5de6ecd9ad742$var$kindOf(val) !== "object") return false;
    const prototype = $44f5de6ecd9ad742$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($44f5de6ecd9ad742$var$toStringTag in val) && !($44f5de6ecd9ad742$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $44f5de6ecd9ad742$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$44f5de6ecd9ad742$var$isObject(val) || $44f5de6ecd9ad742$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $44f5de6ecd9ad742$var$isDate = $44f5de6ecd9ad742$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $44f5de6ecd9ad742$var$isFile = $44f5de6ecd9ad742$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $44f5de6ecd9ad742$var$isBlob = $44f5de6ecd9ad742$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $44f5de6ecd9ad742$var$isFileList = $44f5de6ecd9ad742$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $44f5de6ecd9ad742$var$isStream = (val)=>$44f5de6ecd9ad742$var$isObject(val) && $44f5de6ecd9ad742$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $44f5de6ecd9ad742$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $44f5de6ecd9ad742$var$isFunction(thing.append) && ((kind = $44f5de6ecd9ad742$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $44f5de6ecd9ad742$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $44f5de6ecd9ad742$var$isURLSearchParams = $44f5de6ecd9ad742$var$kindOfTest("URLSearchParams");
const [$44f5de6ecd9ad742$var$isReadableStream, $44f5de6ecd9ad742$var$isRequest, $44f5de6ecd9ad742$var$isResponse, $44f5de6ecd9ad742$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($44f5de6ecd9ad742$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $44f5de6ecd9ad742$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $44f5de6ecd9ad742$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($44f5de6ecd9ad742$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($44f5de6ecd9ad742$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $44f5de6ecd9ad742$var$findKey(obj, key) {
    if ($44f5de6ecd9ad742$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $44f5de6ecd9ad742$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $44f5de6ecd9ad742$var$isContextDefined = (context)=>!$44f5de6ecd9ad742$var$isUndefined(context) && context !== $44f5de6ecd9ad742$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $44f5de6ecd9ad742$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $44f5de6ecd9ad742$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        const targetKey = caseless && $44f5de6ecd9ad742$var$findKey(result, key) || key;
        if ($44f5de6ecd9ad742$var$isPlainObject(result[targetKey]) && $44f5de6ecd9ad742$var$isPlainObject(val)) result[targetKey] = $44f5de6ecd9ad742$var$merge(result[targetKey], val);
        else if ($44f5de6ecd9ad742$var$isPlainObject(val)) result[targetKey] = $44f5de6ecd9ad742$var$merge({}, val);
        else if ($44f5de6ecd9ad742$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$44f5de6ecd9ad742$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $44f5de6ecd9ad742$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $44f5de6ecd9ad742$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $44f5de6ecd9ad742$var$forEach(b, (val, key)=>{
        if (thisArg && $44f5de6ecd9ad742$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $2TpI2.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $44f5de6ecd9ad742$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $44f5de6ecd9ad742$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $44f5de6ecd9ad742$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $44f5de6ecd9ad742$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $44f5de6ecd9ad742$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $44f5de6ecd9ad742$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($44f5de6ecd9ad742$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$44f5de6ecd9ad742$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $44f5de6ecd9ad742$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $44f5de6ecd9ad742$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $44f5de6ecd9ad742$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$44f5de6ecd9ad742$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $44f5de6ecd9ad742$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $44f5de6ecd9ad742$var$isHTMLForm = $44f5de6ecd9ad742$var$kindOfTest("HTMLFormElement");
const $44f5de6ecd9ad742$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $44f5de6ecd9ad742$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $44f5de6ecd9ad742$var$isRegExp = $44f5de6ecd9ad742$var$kindOfTest("RegExp");
const $44f5de6ecd9ad742$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $44f5de6ecd9ad742$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $44f5de6ecd9ad742$var$freezeMethods = (obj)=>{
    $44f5de6ecd9ad742$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($44f5de6ecd9ad742$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$44f5de6ecd9ad742$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $44f5de6ecd9ad742$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $44f5de6ecd9ad742$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $44f5de6ecd9ad742$var$noop = ()=>{};
const $44f5de6ecd9ad742$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $44f5de6ecd9ad742$var$isSpecCompliantForm(thing) {
    return !!(thing && $44f5de6ecd9ad742$var$isFunction(thing.append) && thing[$44f5de6ecd9ad742$var$toStringTag] === "FormData" && thing[$44f5de6ecd9ad742$var$iterator]);
}
const $44f5de6ecd9ad742$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($44f5de6ecd9ad742$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($44f5de6ecd9ad742$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $44f5de6ecd9ad742$var$isArray(source) ? [] : {};
                $44f5de6ecd9ad742$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$44f5de6ecd9ad742$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $44f5de6ecd9ad742$var$isAsyncFn = $44f5de6ecd9ad742$var$kindOfTest("AsyncFunction");
const $44f5de6ecd9ad742$var$isThenable = (thing)=>thing && ($44f5de6ecd9ad742$var$isObject(thing) || $44f5de6ecd9ad742$var$isFunction(thing)) && $44f5de6ecd9ad742$var$isFunction(thing.then) && $44f5de6ecd9ad742$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $44f5de6ecd9ad742$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $44f5de6ecd9ad742$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $44f5de6ecd9ad742$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $44f5de6ecd9ad742$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $44f5de6ecd9ad742$var$isFunction($44f5de6ecd9ad742$var$_global.postMessage));
const $44f5de6ecd9ad742$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($44f5de6ecd9ad742$var$_global) : $44f5de6ecd9ad742$var$_setImmediate;
// *********************
const $44f5de6ecd9ad742$var$isIterable = (thing)=>thing != null && $44f5de6ecd9ad742$var$isFunction(thing[$44f5de6ecd9ad742$var$iterator]);
var $44f5de6ecd9ad742$export$2e2bcd8739ae039 = {
    isArray: $44f5de6ecd9ad742$var$isArray,
    isArrayBuffer: $44f5de6ecd9ad742$var$isArrayBuffer,
    isBuffer: $44f5de6ecd9ad742$var$isBuffer,
    isFormData: $44f5de6ecd9ad742$var$isFormData,
    isArrayBufferView: $44f5de6ecd9ad742$var$isArrayBufferView,
    isString: $44f5de6ecd9ad742$var$isString,
    isNumber: $44f5de6ecd9ad742$var$isNumber,
    isBoolean: $44f5de6ecd9ad742$var$isBoolean,
    isObject: $44f5de6ecd9ad742$var$isObject,
    isPlainObject: $44f5de6ecd9ad742$var$isPlainObject,
    isEmptyObject: $44f5de6ecd9ad742$var$isEmptyObject,
    isReadableStream: $44f5de6ecd9ad742$var$isReadableStream,
    isRequest: $44f5de6ecd9ad742$var$isRequest,
    isResponse: $44f5de6ecd9ad742$var$isResponse,
    isHeaders: $44f5de6ecd9ad742$var$isHeaders,
    isUndefined: $44f5de6ecd9ad742$var$isUndefined,
    isDate: $44f5de6ecd9ad742$var$isDate,
    isFile: $44f5de6ecd9ad742$var$isFile,
    isBlob: $44f5de6ecd9ad742$var$isBlob,
    isRegExp: $44f5de6ecd9ad742$var$isRegExp,
    isFunction: $44f5de6ecd9ad742$var$isFunction,
    isStream: $44f5de6ecd9ad742$var$isStream,
    isURLSearchParams: $44f5de6ecd9ad742$var$isURLSearchParams,
    isTypedArray: $44f5de6ecd9ad742$var$isTypedArray,
    isFileList: $44f5de6ecd9ad742$var$isFileList,
    forEach: $44f5de6ecd9ad742$var$forEach,
    merge: $44f5de6ecd9ad742$var$merge,
    extend: $44f5de6ecd9ad742$var$extend,
    trim: $44f5de6ecd9ad742$var$trim,
    stripBOM: $44f5de6ecd9ad742$var$stripBOM,
    inherits: $44f5de6ecd9ad742$var$inherits,
    toFlatObject: $44f5de6ecd9ad742$var$toFlatObject,
    kindOf: $44f5de6ecd9ad742$var$kindOf,
    kindOfTest: $44f5de6ecd9ad742$var$kindOfTest,
    endsWith: $44f5de6ecd9ad742$var$endsWith,
    toArray: $44f5de6ecd9ad742$var$toArray,
    forEachEntry: $44f5de6ecd9ad742$var$forEachEntry,
    matchAll: $44f5de6ecd9ad742$var$matchAll,
    isHTMLForm: $44f5de6ecd9ad742$var$isHTMLForm,
    hasOwnProperty: $44f5de6ecd9ad742$var$hasOwnProperty,
    hasOwnProp: $44f5de6ecd9ad742$var$hasOwnProperty,
    reduceDescriptors: $44f5de6ecd9ad742$var$reduceDescriptors,
    freezeMethods: $44f5de6ecd9ad742$var$freezeMethods,
    toObjectSet: $44f5de6ecd9ad742$var$toObjectSet,
    toCamelCase: $44f5de6ecd9ad742$var$toCamelCase,
    noop: $44f5de6ecd9ad742$var$noop,
    toFiniteNumber: $44f5de6ecd9ad742$var$toFiniteNumber,
    findKey: $44f5de6ecd9ad742$var$findKey,
    global: $44f5de6ecd9ad742$var$_global,
    isContextDefined: $44f5de6ecd9ad742$var$isContextDefined,
    isSpecCompliantForm: $44f5de6ecd9ad742$var$isSpecCompliantForm,
    toJSONObject: $44f5de6ecd9ad742$var$toJSONObject,
    isAsyncFn: $44f5de6ecd9ad742$var$isAsyncFn,
    isThenable: $44f5de6ecd9ad742$var$isThenable,
    setImmediate: $44f5de6ecd9ad742$var$_setImmediate,
    asap: $44f5de6ecd9ad742$var$asap,
    isIterable: $44f5de6ecd9ad742$var$isIterable
};

});
parcelRegister("2TpI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b4a924258bdfc1$export$2e2bcd8739ae039);
'use strict';
function $21b4a924258bdfc1$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("3aHYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $24f469f57d161341$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $1W9Bm = parcelRequire("1W9Bm");

var $lVxGF = parcelRequire("lVxGF");

var $6NXYT = parcelRequire("6NXYT");

var $83mJk = parcelRequire("83mJk");

var $hIYjm = parcelRequire("hIYjm");

var $6B8hO = parcelRequire("6B8hO");

var $YvDhC = parcelRequire("YvDhC");

var $8zEHj = parcelRequire("8zEHj");
'use strict';
const $24f469f57d161341$var$validators = (0, $6B8hO.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $24f469f57d161341$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $lVxGF.default)(),
            response: new (0, $lVxGF.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $83mJk.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6B8hO.default).assertOptions(transitional, {
            silentJSONParsing: $24f469f57d161341$var$validators.transitional($24f469f57d161341$var$validators.boolean),
            forcedJSONParsing: $24f469f57d161341$var$validators.transitional($24f469f57d161341$var$validators.boolean),
            clarifyTimeoutError: $24f469f57d161341$var$validators.transitional($24f469f57d161341$var$validators.boolean),
            legacyInterceptorReqResOrdering: $24f469f57d161341$var$validators.transitional($24f469f57d161341$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $5V4Df.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6B8hO.default).assertOptions(paramsSerializer, {
                encode: $24f469f57d161341$var$validators.function,
                serialize: $24f469f57d161341$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $6B8hO.default).assertOptions(config, {
            baseUrl: $24f469f57d161341$var$validators.spelling('baseURL'),
            withXsrfToken: $24f469f57d161341$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $5V4Df.default).merge(headers.common, headers[config.method]);
        headers && (0, $5V4Df.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $YvDhC.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $8zEHj.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $6NXYT.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $6NXYT.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $83mJk.default)(this.defaults, config);
        const fullPath = (0, $hIYjm.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $1W9Bm.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $5V4Df.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $24f469f57d161341$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $83mJk.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $5V4Df.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $83mJk.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $24f469f57d161341$var$Axios.prototype[method] = generateHTTPMethod();
    $24f469f57d161341$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $24f469f57d161341$export$2e2bcd8739ae039 = $24f469f57d161341$var$Axios;

});
parcelRegister("1W9Bm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1692a7e2cf826190$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $70W0N = parcelRequire("70W0N");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $1692a7e2cf826190$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $1692a7e2cf826190$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $1692a7e2cf826190$var$encode;
    const _options = (0, $5V4Df.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $5V4Df.default).isURLSearchParams(params) ? params.toString() : new (0, $70W0N.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("70W0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b5886ae5a066e7$export$2e2bcd8739ae039);

var $5rtXJ = parcelRequire("5rtXJ");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $51b5886ae5a066e7$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $51b5886ae5a066e7$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5rtXJ.default)(params, this, options);
}
const $51b5886ae5a066e7$var$prototype = $51b5886ae5a066e7$var$AxiosURLSearchParams.prototype;
$51b5886ae5a066e7$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$51b5886ae5a066e7$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $51b5886ae5a066e7$var$encode);
    } : $51b5886ae5a066e7$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $51b5886ae5a066e7$export$2e2bcd8739ae039 = $51b5886ae5a066e7$var$AxiosURLSearchParams;

});
parcelRegister("5rtXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f66b745c212720d$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $1RZXx = parcelRequire("1RZXx");

var $hloFs = parcelRequire("hloFs");

var $cbQCu = parcelRequire("cbQCu");
var $3f66b745c212720d$require$Buffer = $cbQCu.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $3f66b745c212720d$var$isVisitable(thing) {
    return (0, $5V4Df.default).isPlainObject(thing) || (0, $5V4Df.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $3f66b745c212720d$var$removeBrackets(key) {
    return (0, $5V4Df.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $3f66b745c212720d$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $3f66b745c212720d$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $3f66b745c212720d$var$isFlatArray(arr) {
    return (0, $5V4Df.default).isArray(arr) && !arr.some($3f66b745c212720d$var$isVisitable);
}
const $3f66b745c212720d$var$predicates = (0, $5V4Df.default).toFlatObject((0, $5V4Df.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $3f66b745c212720d$var$toFormData(obj, formData, options) {
    if (!(0, $5V4Df.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $hloFs.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $5V4Df.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $5V4Df.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $5V4Df.default).isSpecCompliantForm(formData);
    if (!(0, $5V4Df.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $5V4Df.default).isDate(value)) return value.toISOString();
        if ((0, $5V4Df.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $5V4Df.default).isBlob(value)) throw new (0, $1RZXx.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $5V4Df.default).isArrayBuffer(value) || (0, $5V4Df.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $3f66b745c212720d$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $5V4Df.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $5V4Df.default).isArray(value) && $3f66b745c212720d$var$isFlatArray(value) || ((0, $5V4Df.default).isFileList(value) || (0, $5V4Df.default).endsWith(key, '[]')) && (arr = (0, $5V4Df.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $3f66b745c212720d$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $5V4Df.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $3f66b745c212720d$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($3f66b745c212720d$var$isVisitable(value)) return true;
        formData.append($3f66b745c212720d$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($3f66b745c212720d$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $3f66b745c212720d$var$isVisitable
    });
    function build(value, path) {
        if ((0, $5V4Df.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $5V4Df.default).forEach(value, function each(el, key) {
            const result = !((0, $5V4Df.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $5V4Df.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $5V4Df.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $3f66b745c212720d$export$2e2bcd8739ae039 = $3f66b745c212720d$var$toFormData;

});
parcelRegister("1RZXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $15cacd88254278c5$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");
'use strict';
class $15cacd88254278c5$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $15cacd88254278c5$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [config] The config.
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     *
     * @returns {Error} The created error.
     */ constructor(message, code, config, request, response){
        super(message);
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $5V4Df.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$15cacd88254278c5$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$15cacd88254278c5$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$15cacd88254278c5$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$15cacd88254278c5$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$15cacd88254278c5$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$15cacd88254278c5$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$15cacd88254278c5$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$15cacd88254278c5$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$15cacd88254278c5$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$15cacd88254278c5$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$15cacd88254278c5$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$15cacd88254278c5$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
var $15cacd88254278c5$export$2e2bcd8739ae039 = $15cacd88254278c5$var$AxiosError;

});

parcelRegister("hloFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca078855ba729d14$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $ca078855ba729d14$export$2e2bcd8739ae039 = null;

});

parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("lVxGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff690d6783f0b991$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");
'use strict';
class $ff690d6783f0b991$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $5V4Df.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ff690d6783f0b991$export$2e2bcd8739ae039 = $ff690d6783f0b991$var$InterceptorManager;

});

parcelRegister("6NXYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f45d8abf5a71ac5$export$2e2bcd8739ae039);

var $69IRq = parcelRequire("69IRq");

var $ktZ5Z = parcelRequire("ktZ5Z");

var $151sS = parcelRequire("151sS");

var $fRtRc = parcelRequire("fRtRc");

var $YvDhC = parcelRequire("YvDhC");

var $9kUFV = parcelRequire("9kUFV");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $4f45d8abf5a71ac5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $fRtRc.default)(null, config);
}
function $4f45d8abf5a71ac5$export$2e2bcd8739ae039(config) {
    $4f45d8abf5a71ac5$var$throwIfCancellationRequested(config);
    config.headers = (0, $YvDhC.default).from(config.headers);
    // Transform request data
    config.data = (0, $69IRq.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $9kUFV.default).getAdapter(config.adapter || (0, $151sS.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $4f45d8abf5a71ac5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $69IRq.default).call(config, config.transformResponse, response);
        response.headers = (0, $YvDhC.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ktZ5Z.default)(reason)) {
            $4f45d8abf5a71ac5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $69IRq.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $YvDhC.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("69IRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b661bb2fae4b40$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $151sS = parcelRequire("151sS");

var $YvDhC = parcelRequire("YvDhC");
'use strict';
function $47b661bb2fae4b40$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $151sS.default);
    const context = response || config;
    const headers = (0, $YvDhC.default).from(context.headers);
    let data = context.data;
    (0, $5V4Df.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("151sS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c9764eed1902a3c$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $1RZXx = parcelRequire("1RZXx");

var $8zEHj = parcelRequire("8zEHj");

var $5rtXJ = parcelRequire("5rtXJ");

var $bbLD6 = parcelRequire("bbLD6");

var $d46GZ = parcelRequire("d46GZ");

var $cQn4z = parcelRequire("cQn4z");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $0c9764eed1902a3c$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $5V4Df.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $5V4Df.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $0c9764eed1902a3c$var$defaults = {
    transitional: (0, $8zEHj.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $5V4Df.default).isObject(data);
            if (isObjectPayload && (0, $5V4Df.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $5V4Df.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cQn4z.default)(data)) : data;
            if ((0, $5V4Df.default).isArrayBuffer(data) || (0, $5V4Df.default).isBuffer(data) || (0, $5V4Df.default).isStream(data) || (0, $5V4Df.default).isFile(data) || (0, $5V4Df.default).isBlob(data) || (0, $5V4Df.default).isReadableStream(data)) return data;
            if ((0, $5V4Df.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $5V4Df.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $bbLD6.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $5V4Df.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5rtXJ.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $0c9764eed1902a3c$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $0c9764eed1902a3c$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $5V4Df.default).isResponse(data) || (0, $5V4Df.default).isReadableStream(data)) return data;
            if (data && (0, $5V4Df.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $1RZXx.default).from(e, (0, $1RZXx.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $d46GZ.default).classes.FormData,
        Blob: (0, $d46GZ.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $5V4Df.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $0c9764eed1902a3c$var$defaults.headers[method] = {};
});
var $0c9764eed1902a3c$export$2e2bcd8739ae039 = $0c9764eed1902a3c$var$defaults;

});
parcelRegister("8zEHj", function(module, exports) {

$parcel$export(module.exports, "default", () => $63e1294b3f371480$export$2e2bcd8739ae039);
'use strict';
var $63e1294b3f371480$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};

});

parcelRegister("bbLD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8255ab0a4bedc82f$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $5rtXJ = parcelRequire("5rtXJ");

var $d46GZ = parcelRequire("d46GZ");
'use strict';
function $8255ab0a4bedc82f$export$2e2bcd8739ae039(data, options) {
    return (0, $5rtXJ.default)(data, new (0, $d46GZ.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $d46GZ.default).isNode && (0, $5V4Df.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("d46GZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9830d70956c12753$export$2e2bcd8739ae039);

var $68Gcm = parcelRequire("68Gcm");

var $bsB9B = parcelRequire("bsB9B");
var $9830d70956c12753$export$2e2bcd8739ae039 = {
    ...$bsB9B,
    ...(0, $68Gcm.default)
};

});
parcelRegister("68Gcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $47843920644e9b47$export$2e2bcd8739ae039);

var $fEKyb = parcelRequire("fEKyb");

var $5GtPf = parcelRequire("5GtPf");

var $98xLS = parcelRequire("98xLS");
var $47843920644e9b47$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $fEKyb.default,
        FormData: $5GtPf.default,
        Blob: $98xLS.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("fEKyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65eb360d01a0f5c$export$2e2bcd8739ae039);

var $70W0N = parcelRequire("70W0N");
'use strict';
var $b65eb360d01a0f5c$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $70W0N.default);

});

parcelRegister("5GtPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $423802beb438eaa6$export$2e2bcd8739ae039);
'use strict';
var $423802beb438eaa6$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("98xLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a6f0ea528d5c32c$export$2e2bcd8739ae039);
'use strict';
var $6a6f0ea528d5c32c$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("bsB9B", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $857f2139b0a8e44b$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $857f2139b0a8e44b$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $857f2139b0a8e44b$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $857f2139b0a8e44b$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $857f2139b0a8e44b$export$f710a83a91838a36);
const $857f2139b0a8e44b$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $857f2139b0a8e44b$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $857f2139b0a8e44b$export$c0bcc9250309d66 = $857f2139b0a8e44b$export$c4996c4b7b93b0bf && (!$857f2139b0a8e44b$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($857f2139b0a8e44b$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $857f2139b0a8e44b$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $857f2139b0a8e44b$export$f710a83a91838a36 = $857f2139b0a8e44b$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("cQn4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $959c3d1fb6a044eb$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $959c3d1fb6a044eb$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $5V4Df.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $959c3d1fb6a044eb$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $959c3d1fb6a044eb$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $5V4Df.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $5V4Df.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $5V4Df.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $5V4Df.default).isArray(target[name])) target[name] = $959c3d1fb6a044eb$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $5V4Df.default).isFormData(formData) && (0, $5V4Df.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $5V4Df.default).forEachEntry(formData, (name, value)=>{
            buildPath($959c3d1fb6a044eb$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $959c3d1fb6a044eb$export$2e2bcd8739ae039 = $959c3d1fb6a044eb$var$formDataToJSON;

});


parcelRegister("YvDhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5e24494d6fb48d$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $5WteH = parcelRequire("5WteH");
'use strict';
const $0b5e24494d6fb48d$var$$internals = Symbol('internals');
function $0b5e24494d6fb48d$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $0b5e24494d6fb48d$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $5V4Df.default).isArray(value) ? value.map($0b5e24494d6fb48d$var$normalizeValue) : String(value);
}
function $0b5e24494d6fb48d$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $0b5e24494d6fb48d$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $0b5e24494d6fb48d$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $5V4Df.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $5V4Df.default).isString(value)) return;
    if ((0, $5V4Df.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $5V4Df.default).isRegExp(filter)) return filter.test(value);
}
function $0b5e24494d6fb48d$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $0b5e24494d6fb48d$var$buildAccessors(obj, header) {
    const accessorName = (0, $5V4Df.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $0b5e24494d6fb48d$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $0b5e24494d6fb48d$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $5V4Df.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $0b5e24494d6fb48d$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $5V4Df.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $5V4Df.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $5V4Df.default).isString(header) && (header = header.trim()) && !$0b5e24494d6fb48d$var$isValidHeaderName(header)) setHeaders((0, $5WteH.default)(header), valueOrRewrite);
        else if ((0, $5V4Df.default).isObject(header) && (0, $5V4Df.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $5V4Df.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $5V4Df.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $0b5e24494d6fb48d$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5V4Df.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $0b5e24494d6fb48d$var$parseTokens(value);
                if ((0, $5V4Df.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $5V4Df.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $0b5e24494d6fb48d$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5V4Df.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $0b5e24494d6fb48d$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $0b5e24494d6fb48d$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $5V4Df.default).findKey(self, _header);
                if (key && (!matcher || $0b5e24494d6fb48d$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $5V4Df.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $0b5e24494d6fb48d$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $5V4Df.default).forEach(this, (value, header)=>{
            const key = (0, $5V4Df.default).findKey(headers, header);
            if (key) {
                self[key] = $0b5e24494d6fb48d$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $0b5e24494d6fb48d$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $0b5e24494d6fb48d$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $5V4Df.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $5V4Df.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$0b5e24494d6fb48d$var$$internals] = this[$0b5e24494d6fb48d$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $0b5e24494d6fb48d$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $0b5e24494d6fb48d$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $5V4Df.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$0b5e24494d6fb48d$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $5V4Df.default).reduceDescriptors($0b5e24494d6fb48d$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $5V4Df.default).freezeMethods($0b5e24494d6fb48d$var$AxiosHeaders);
var $0b5e24494d6fb48d$export$2e2bcd8739ae039 = $0b5e24494d6fb48d$var$AxiosHeaders;

});
parcelRegister("5WteH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45390c395bb5410c$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $45390c395bb5410c$var$ignoreDuplicateOf = (0, $5V4Df.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $45390c395bb5410c$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $45390c395bb5410c$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("ktZ5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee95e86065cd07cb$export$2e2bcd8739ae039);
'use strict';
function $ee95e86065cd07cb$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("fRtRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c2f73bc4edc17f$export$2e2bcd8739ae039);

var $1RZXx = parcelRequire("1RZXx");
'use strict';
class $b8c2f73bc4edc17f$var$CanceledError extends (0, $1RZXx.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $1RZXx.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $b8c2f73bc4edc17f$export$2e2bcd8739ae039 = $b8c2f73bc4edc17f$var$CanceledError;

});

parcelRegister("9kUFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc1f1d93b5f170d$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $hloFs = parcelRequire("hloFs");

var $cqfO7 = parcelRequire("cqfO7");

var $ay2ia = parcelRequire("ay2ia");

var $1RZXx = parcelRequire("1RZXx");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const $6cc1f1d93b5f170d$var$knownAdapters = {
    http: (0, $hloFs.default),
    xhr: (0, $cqfO7.default),
    fetch: {
        get: $ay2ia.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $5V4Df.default).forEach($6cc1f1d93b5f170d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const $6cc1f1d93b5f170d$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $6cc1f1d93b5f170d$var$isResolvedHandle = (adapter)=>(0, $5V4Df.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $6cc1f1d93b5f170d$var$getAdapter(adapters, config) {
    adapters = (0, $5V4Df.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$6cc1f1d93b5f170d$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $6cc1f1d93b5f170d$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $1RZXx.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $5V4Df.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($6cc1f1d93b5f170d$var$renderReason).join('\n') : ' ' + $6cc1f1d93b5f170d$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $1RZXx.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $6cc1f1d93b5f170d$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $6cc1f1d93b5f170d$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $6cc1f1d93b5f170d$var$knownAdapters
};

});
parcelRegister("cqfO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b42cbe2ccc4c8d$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $5jOfb = parcelRequire("5jOfb");

var $8zEHj = parcelRequire("8zEHj");

var $1RZXx = parcelRequire("1RZXx");

var $fRtRc = parcelRequire("fRtRc");

var $j6p1s = parcelRequire("j6p1s");

var $d46GZ = parcelRequire("d46GZ");

var $YvDhC = parcelRequire("YvDhC");

var $eC5h6 = parcelRequire("eC5h6");

var $dmu6s = parcelRequire("dmu6s");
const $90b42cbe2ccc4c8d$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $90b42cbe2ccc4c8d$export$2e2bcd8739ae039 = $90b42cbe2ccc4c8d$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $dmu6s.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $YvDhC.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $YvDhC.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5jOfb.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $1RZXx.default)('Request aborted', (0, $1RZXx.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $1RZXx.default)(msg, (0, $1RZXx.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $8zEHj.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $1RZXx.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $1RZXx.default).ETIMEDOUT : (0, $1RZXx.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $5V4Df.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $5V4Df.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $eC5h6.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $eC5h6.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $fRtRc.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $j6p1s.default)(_config.url);
        if (protocol && (0, $d46GZ.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $1RZXx.default)('Unsupported protocol ' + protocol + ':', (0, $1RZXx.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("5jOfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df5b37879fc2f75$export$2e2bcd8739ae039);

var $1RZXx = parcelRequire("1RZXx");
'use strict';
function $3df5b37879fc2f75$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $1RZXx.default)('Request failed with status code ' + response.status, [
        (0, $1RZXx.default).ERR_BAD_REQUEST,
        (0, $1RZXx.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("j6p1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0396bde253a3b236$export$2e2bcd8739ae039);
'use strict';
function $0396bde253a3b236$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("eC5h6", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $aa38b4bffe10a907$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $aa38b4bffe10a907$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $aa38b4bffe10a907$export$5d35863c355a22a9);

var $1fwbW = parcelRequire("1fwbW");

var $hGc2Q = parcelRequire("hGc2Q");

var $5V4Df = parcelRequire("5V4Df");
const $aa38b4bffe10a907$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1fwbW.default)(50, 250);
    return (0, $hGc2Q.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $aa38b4bffe10a907$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $aa38b4bffe10a907$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $5V4Df.default).asap(()=>fn(...args));

});
parcelRegister("1fwbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9029b8acdf1a47$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0e9029b8acdf1a47$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0e9029b8acdf1a47$export$2e2bcd8739ae039 = $0e9029b8acdf1a47$var$speedometer;

});

parcelRegister("hGc2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdefb3c700d0f932$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $cdefb3c700d0f932$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $cdefb3c700d0f932$export$2e2bcd8739ae039 = $cdefb3c700d0f932$var$throttle;

});


parcelRegister("dmu6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba4ae47a0f05b30$export$2e2bcd8739ae039);

var $d46GZ = parcelRequire("d46GZ");

var $5V4Df = parcelRequire("5V4Df");

var $lcmTA = parcelRequire("lcmTA");

var $95r7r = parcelRequire("95r7r");

var $hIYjm = parcelRequire("hIYjm");

var $83mJk = parcelRequire("83mJk");

var $YvDhC = parcelRequire("YvDhC");

var $1W9Bm = parcelRequire("1W9Bm");
var $9ba4ae47a0f05b30$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $83mJk.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $YvDhC.default).from(headers);
    newConfig.url = (0, $1W9Bm.default)((0, $hIYjm.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $5V4Df.default).isFormData(data)) {
        if ((0, $d46GZ.default).hasStandardBrowserEnv || (0, $d46GZ.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $5V4Df.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $d46GZ.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $5V4Df.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $lcmTA.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $95r7r.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("lcmTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6ec7a90811e143e$export$2e2bcd8739ae039);

var $d46GZ = parcelRequire("d46GZ");
var $f6ec7a90811e143e$export$2e2bcd8739ae039 = (0, $d46GZ.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $d46GZ.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $d46GZ.default).origin), (0, $d46GZ.default).navigator && /(msie|trident)/i.test((0, $d46GZ.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("95r7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d99df51c13af2c$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $d46GZ = parcelRequire("d46GZ");
var $69d99df51c13af2c$export$2e2bcd8739ae039 = (0, $d46GZ.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $5V4Df.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $5V4Df.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $5V4Df.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $5V4Df.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("hIYjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7554469cb50bd9$export$2e2bcd8739ae039);

var $310ep = parcelRequire("310ep");

var $bPyaG = parcelRequire("bPyaG");
'use strict';
function $ce7554469cb50bd9$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $310ep.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $bPyaG.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("310ep", function(module, exports) {

$parcel$export(module.exports, "default", () => $2321a509a1db5e13$export$2e2bcd8739ae039);
'use strict';
function $2321a509a1db5e13$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("bPyaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $89cef6d128309811$export$2e2bcd8739ae039);
'use strict';
function $89cef6d128309811$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("83mJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd03c45acacb01a$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");

var $YvDhC = parcelRequire("YvDhC");
"use strict";
const $5dd03c45acacb01a$var$headersToObject = (thing)=>thing instanceof (0, $YvDhC.default) ? {
        ...thing
    } : thing;
function $5dd03c45acacb01a$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $5V4Df.default).isPlainObject(target) && (0, $5V4Df.default).isPlainObject(source)) return (0, $5V4Df.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $5V4Df.default).isPlainObject(source)) return (0, $5V4Df.default).merge({}, source);
        else if ((0, $5V4Df.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $5V4Df.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $5V4Df.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $5V4Df.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $5V4Df.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $5V4Df.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($5dd03c45acacb01a$var$headersToObject(a), $5dd03c45acacb01a$var$headersToObject(b), prop, true)
    };
    (0, $5V4Df.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge = (0, $5V4Df.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $5V4Df.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("ay2ia", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $7adedb831e4cd224$export$3105c6651375d4fa);

var $d46GZ = parcelRequire("d46GZ");

var $5V4Df = parcelRequire("5V4Df");

var $1RZXx = parcelRequire("1RZXx");

var $5qHrs = parcelRequire("5qHrs");

var $ap0GL = parcelRequire("ap0GL");

var $YvDhC = parcelRequire("YvDhC");

var $eC5h6 = parcelRequire("eC5h6");

var $dmu6s = parcelRequire("dmu6s");

var $5jOfb = parcelRequire("5jOfb");
const $7adedb831e4cd224$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $7adedb831e4cd224$var$isFunction } = (0, $5V4Df.default);
const $7adedb831e4cd224$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $5V4Df.default).global);
const { ReadableStream: $7adedb831e4cd224$var$ReadableStream, TextEncoder: $7adedb831e4cd224$var$TextEncoder } = (0, $5V4Df.default).global;
const $7adedb831e4cd224$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $7adedb831e4cd224$var$factory = (env)=>{
    env = (0, $5V4Df.default).merge.call({
        skipUndefined: true
    }, $7adedb831e4cd224$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $7adedb831e4cd224$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $7adedb831e4cd224$var$isFunction(Request);
    const isResponseSupported = $7adedb831e4cd224$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $7adedb831e4cd224$var$isFunction($7adedb831e4cd224$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $7adedb831e4cd224$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $7adedb831e4cd224$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $7adedb831e4cd224$var$test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, $d46GZ.default).origin, {
            body: new $7adedb831e4cd224$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $7adedb831e4cd224$var$test(()=>(0, $5V4Df.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $1RZXx.default)(`Response type '${type}' is not supported`, (0, $1RZXx.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $5V4Df.default).isBlob(body)) return body.size;
        if ((0, $5V4Df.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $d46GZ.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $5V4Df.default).isArrayBufferView(body) || (0, $5V4Df.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $5V4Df.default).isURLSearchParams(body)) body = body + '';
        if ((0, $5V4Df.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $5V4Df.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $dmu6s.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $5qHrs.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, $5V4Df.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $eC5h6.progressEventDecorator)(requestContentLength, (0, $eC5h6.progressEventReducer)((0, $eC5h6.asyncDecorator)(onUploadProgress)));
                    data = (0, $ap0GL.trackStream)(_request.body, $7adedb831e4cd224$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $5V4Df.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $5V4Df.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $eC5h6.progressEventDecorator)(responseContentLength, (0, $eC5h6.progressEventReducer)((0, $eC5h6.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, $ap0GL.trackStream)(response.body, $7adedb831e4cd224$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $5V4Df.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $5jOfb.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $YvDhC.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $1RZXx.default)('Network Error', (0, $1RZXx.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $1RZXx.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $7adedb831e4cd224$var$seedCache = new Map();
const $7adedb831e4cd224$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $7adedb831e4cd224$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $7adedb831e4cd224$var$factory(env));
        map = target;
    }
    return target;
};
const $7adedb831e4cd224$var$adapter = $7adedb831e4cd224$export$3105c6651375d4fa();
var $7adedb831e4cd224$export$2e2bcd8739ae039 = $7adedb831e4cd224$var$adapter;

});
parcelRegister("5qHrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f41141be802db15$export$2e2bcd8739ae039);

var $fRtRc = parcelRequire("fRtRc");

var $1RZXx = parcelRequire("1RZXx");

var $5V4Df = parcelRequire("5V4Df");
const $3f41141be802db15$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $1RZXx.default) ? err : new (0, $fRtRc.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $1RZXx.default)(`timeout of ${timeout}ms exceeded`, (0, $1RZXx.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $5V4Df.default).asap(unsubscribe);
        return signal;
    }
};
var $3f41141be802db15$export$2e2bcd8739ae039 = $3f41141be802db15$var$composeSignals;

});

parcelRegister("ap0GL", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $792cc5f3e3c15b2e$export$b0119225647bd83);
const $792cc5f3e3c15b2e$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $792cc5f3e3c15b2e$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $792cc5f3e3c15b2e$var$readStream(iterable))yield* $792cc5f3e3c15b2e$export$71b051935044bd5d(chunk, chunkSize);
};
const $792cc5f3e3c15b2e$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $792cc5f3e3c15b2e$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $792cc5f3e3c15b2e$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("6B8hO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdca0431e043dac$export$2e2bcd8739ae039);

var $fs77V = parcelRequire("fs77V");

var $1RZXx = parcelRequire("1RZXx");
'use strict';
const $4cdca0431e043dac$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $4cdca0431e043dac$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $4cdca0431e043dac$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $4cdca0431e043dac$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $fs77V.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $1RZXx.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $1RZXx.default).ERR_DEPRECATED);
        if (version && !$4cdca0431e043dac$var$deprecatedWarnings[opt]) {
            $4cdca0431e043dac$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$4cdca0431e043dac$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $4cdca0431e043dac$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $1RZXx.default)('options must be an object', (0, $1RZXx.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $1RZXx.default)('option ' + opt + ' must be ' + result, (0, $1RZXx.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $1RZXx.default)('Unknown option ' + opt, (0, $1RZXx.default).ERR_BAD_OPTION);
    }
}
var $4cdca0431e043dac$export$2e2bcd8739ae039 = {
    assertOptions: $4cdca0431e043dac$var$assertOptions,
    validators: $4cdca0431e043dac$var$validators
};

});
parcelRegister("fs77V", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $b3feffc34ee75161$export$a4ad2735b021c132);
const $b3feffc34ee75161$export$a4ad2735b021c132 = "1.13.5";

});



parcelRegister("beyAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $82dbd508c7c3a54a$export$2e2bcd8739ae039);

var $fRtRc = parcelRequire("fRtRc");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $82dbd508c7c3a54a$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $fRtRc.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $82dbd508c7c3a54a$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $82dbd508c7c3a54a$export$2e2bcd8739ae039 = $82dbd508c7c3a54a$var$CancelToken;

});

parcelRegister("kHzHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1238545488e445d$export$2e2bcd8739ae039);
'use strict';
function $f1238545488e445d$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("3Qei4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc1503b08e56359$export$2e2bcd8739ae039);

var $5V4Df = parcelRequire("5V4Df");
'use strict';
function $2cc1503b08e56359$export$2e2bcd8739ae039(payload) {
    return (0, $5V4Df.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("yYcza", function(module, exports) {

$parcel$export(module.exports, "default", () => $0691dfe3e130f516$export$2e2bcd8739ae039);
const $0691dfe3e130f516$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($0691dfe3e130f516$var$HttpStatusCode).forEach(([key, value])=>{
    $0691dfe3e130f516$var$HttpStatusCode[value] = key;
});
var $0691dfe3e130f516$export$2e2bcd8739ae039 = $0691dfe3e130f516$var$HttpStatusCode;

});



parcelRegister("hUxka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "namespace", () => $d0a18421b9d000ec$export$76a88f7de6507443);
$parcel$export(module.exports, "isNetworkError", () => $d0a18421b9d000ec$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isRetryableError", () => $d0a18421b9d000ec$export$5f1dc21fa925930b);
$parcel$export(module.exports, "isSafeRequestError", () => $d0a18421b9d000ec$export$693cf906fd8817e5);
$parcel$export(module.exports, "isIdempotentRequestError", () => $d0a18421b9d000ec$export$d26799ad4978234d);
$parcel$export(module.exports, "isNetworkOrIdempotentRequestError", () => $d0a18421b9d000ec$export$606bf0a2b170eb2);
$parcel$export(module.exports, "retryAfter", () => $d0a18421b9d000ec$export$e981df388f003617);
$parcel$export(module.exports, "exponentialDelay", () => $d0a18421b9d000ec$export$ce2bf54576c66713);
$parcel$export(module.exports, "linearDelay", () => $d0a18421b9d000ec$export$384f50abe7b57bc7);
$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $d0a18421b9d000ec$export$93ca5d3f8675ae4c);
$parcel$export(module.exports, "default", () => $d0a18421b9d000ec$export$2e2bcd8739ae039);

var $v3TkV = parcelRequire("v3TkV");
const $d0a18421b9d000ec$export$76a88f7de6507443 = 'axios-retry';
function $d0a18421b9d000ec$export$476aa014e2fd89d5(error) {
    const CODE_EXCLUDE_LIST = [
        'ERR_CANCELED',
        'ECONNABORTED'
    ];
    if (error.response) return false;
    if (!error.code) return false;
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) return false;
    // Prevents retrying unsafe errors
    return (0, (/*@__PURE__*/$parcel$interopDefault($v3TkV)))(error);
}
const $d0a18421b9d000ec$var$SAFE_HTTP_METHODS = [
    'get',
    'head',
    'options'
];
const $d0a18421b9d000ec$var$IDEMPOTENT_HTTP_METHODS = $d0a18421b9d000ec$var$SAFE_HTTP_METHODS.concat([
    'put',
    'delete'
]);
function $d0a18421b9d000ec$export$5f1dc21fa925930b(error) {
    return error.code !== 'ECONNABORTED' && (!error.response || error.response.status === 429 || error.response.status >= 500 && error.response.status <= 599);
}
function $d0a18421b9d000ec$export$693cf906fd8817e5(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $d0a18421b9d000ec$export$5f1dc21fa925930b(error) && $d0a18421b9d000ec$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d0a18421b9d000ec$export$d26799ad4978234d(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $d0a18421b9d000ec$export$5f1dc21fa925930b(error) && $d0a18421b9d000ec$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $d0a18421b9d000ec$export$606bf0a2b170eb2(error) {
    return $d0a18421b9d000ec$export$476aa014e2fd89d5(error) || $d0a18421b9d000ec$export$d26799ad4978234d(error);
}
function $d0a18421b9d000ec$export$e981df388f003617(error) {
    const retryAfterHeader = error?.response?.headers['retry-after'];
    if (!retryAfterHeader) return 0;
    // if the retry after header is a number, convert it to milliseconds
    let retryAfterMs = (Number(retryAfterHeader) || 0) * 1000;
    // If the retry after header is a date, get the number of milliseconds until that date
    if (retryAfterMs === 0) retryAfterMs = (new Date(retryAfterHeader).valueOf() || 0) - Date.now();
    return Math.max(0, retryAfterMs);
}
function $d0a18421b9d000ec$var$noDelay(_retryNumber = 0, error) {
    return Math.max(0, $d0a18421b9d000ec$export$e981df388f003617(error));
}
function $d0a18421b9d000ec$export$ce2bf54576c66713(retryNumber = 0, error, delayFactor = 100) {
    const calculatedDelay = 2 ** retryNumber * delayFactor;
    const delay = Math.max(calculatedDelay, $d0a18421b9d000ec$export$e981df388f003617(error));
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
function $d0a18421b9d000ec$export$384f50abe7b57bc7(delayFactor = 100) {
    return (retryNumber = 0, error)=>{
        const delay = retryNumber * delayFactor;
        return Math.max(delay, $d0a18421b9d000ec$export$e981df388f003617(error));
    };
}
const $d0a18421b9d000ec$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $d0a18421b9d000ec$export$606bf0a2b170eb2,
    retryDelay: $d0a18421b9d000ec$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{},
    onMaxRetryTimesExceeded: ()=>{},
    validateResponse: null
};
function $d0a18421b9d000ec$var$getRequestOptions(config, defaultOptions) {
    return {
        ...$d0a18421b9d000ec$export$93ca5d3f8675ae4c,
        ...defaultOptions,
        ...config[$d0a18421b9d000ec$export$76a88f7de6507443]
    };
}
function $d0a18421b9d000ec$var$setCurrentState(config, defaultOptions, resetLastRequestTime = false) {
    const currentState = $d0a18421b9d000ec$var$getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    if (!currentState.lastRequestTime || resetLastRequestTime) currentState.lastRequestTime = Date.now();
    config[$d0a18421b9d000ec$export$76a88f7de6507443] = currentState;
    return currentState;
}
function $d0a18421b9d000ec$var$fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) // @ts-ignore
    delete config.agent;
    if (axiosInstance.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
async function $d0a18421b9d000ec$var$shouldRetry(currentState, error) {
    const { retries: retries, retryCondition: retryCondition } = currentState;
    const shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
    // This could be a promise
    if (typeof shouldRetryOrPromise === 'object') try {
        const shouldRetryPromiseResult = await shouldRetryOrPromise;
        // keep return true unless shouldRetryPromiseResult return false for compatibility
        return shouldRetryPromiseResult !== false;
    } catch (_err) {
        return false;
    }
    return shouldRetryOrPromise;
}
async function $d0a18421b9d000ec$var$handleRetry(axiosInstance, currentState, error, config) {
    currentState.retryCount += 1;
    const { retryDelay: retryDelay, shouldResetTimeout: shouldResetTimeout, onRetry: onRetry } = currentState;
    const delay = retryDelay(currentState.retryCount, error);
    // Axios fails merging this configuration to the default configuration because it has an issue
    // with circular structures: https://github.com/mzabriskie/axios/issues/370
    $d0a18421b9d000ec$var$fixConfig(axiosInstance, config);
    if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
        const lastRequestDuration = Date.now() - currentState.lastRequestTime;
        const timeout = config.timeout - lastRequestDuration - delay;
        if (timeout <= 0) return Promise.reject(error);
        config.timeout = timeout;
    }
    config.transformRequest = [
        (data)=>data
    ];
    await onRetry(currentState.retryCount, error, config);
    if (config.signal?.aborted) return Promise.resolve(axiosInstance(config));
    return new Promise((resolve)=>{
        const abortListener = ()=>{
            clearTimeout(timeout);
            resolve(axiosInstance(config));
        };
        const timeout = setTimeout(()=>{
            resolve(axiosInstance(config));
            if (config.signal?.removeEventListener) config.signal.removeEventListener('abort', abortListener);
        }, delay);
        if (config.signal?.addEventListener) config.signal.addEventListener('abort', abortListener, {
            once: true
        });
    });
}
async function $d0a18421b9d000ec$var$handleMaxRetryTimesExceeded(currentState, error) {
    if (currentState.retryCount >= currentState.retries) await currentState.onMaxRetryTimesExceeded(error, currentState.retryCount);
}
const $d0a18421b9d000ec$var$axiosRetry = (axiosInstance, defaultOptions)=>{
    const requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
        $d0a18421b9d000ec$var$setCurrentState(config, defaultOptions, true);
        if (config[$d0a18421b9d000ec$export$76a88f7de6507443]?.validateResponse) // by setting this, all HTTP responses will be go through the error interceptor first
        config.validateStatus = ()=>false;
        return config;
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use(null, async (error)=>{
        const { config: config } = error;
        // If we have no information to retry the request
        if (!config) return Promise.reject(error);
        const currentState = $d0a18421b9d000ec$var$setCurrentState(config, defaultOptions);
        if (error.response && currentState.validateResponse?.(error.response)) // no issue with response
        return error.response;
        if (await $d0a18421b9d000ec$var$shouldRetry(currentState, error)) return $d0a18421b9d000ec$var$handleRetry(axiosInstance, currentState, error, config);
        await $d0a18421b9d000ec$var$handleMaxRetryTimesExceeded(currentState, error);
        return Promise.reject(error);
    });
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
};
// Compatibility with CommonJS
$d0a18421b9d000ec$var$axiosRetry.isNetworkError = $d0a18421b9d000ec$export$476aa014e2fd89d5;
$d0a18421b9d000ec$var$axiosRetry.isSafeRequestError = $d0a18421b9d000ec$export$693cf906fd8817e5;
$d0a18421b9d000ec$var$axiosRetry.isIdempotentRequestError = $d0a18421b9d000ec$export$d26799ad4978234d;
$d0a18421b9d000ec$var$axiosRetry.isNetworkOrIdempotentRequestError = $d0a18421b9d000ec$export$606bf0a2b170eb2;
$d0a18421b9d000ec$var$axiosRetry.exponentialDelay = $d0a18421b9d000ec$export$ce2bf54576c66713;
$d0a18421b9d000ec$var$axiosRetry.linearDelay = $d0a18421b9d000ec$export$384f50abe7b57bc7;
$d0a18421b9d000ec$var$axiosRetry.isRetryableError = $d0a18421b9d000ec$export$5f1dc21fa925930b;
var $d0a18421b9d000ec$export$2e2bcd8739ae039 = $d0a18421b9d000ec$var$axiosRetry;

});
parcelRegister("v3TkV", function(module, exports) {
'use strict';
const $05d5ea2421009f85$var$denyList = new Set([
    'ENOTFOUND',
    'ENETUNREACH',
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    'UNABLE_TO_GET_ISSUER_CERT',
    'UNABLE_TO_GET_CRL',
    'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
    'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
    'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
    'CERT_SIGNATURE_FAILURE',
    'CRL_SIGNATURE_FAILURE',
    'CERT_NOT_YET_VALID',
    'CERT_HAS_EXPIRED',
    'CRL_NOT_YET_VALID',
    'CRL_HAS_EXPIRED',
    'ERROR_IN_CERT_NOT_BEFORE_FIELD',
    'ERROR_IN_CERT_NOT_AFTER_FIELD',
    'ERROR_IN_CRL_LAST_UPDATE_FIELD',
    'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
    'OUT_OF_MEM',
    'DEPTH_ZERO_SELF_SIGNED_CERT',
    'SELF_SIGNED_CERT_IN_CHAIN',
    'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
    'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
    'CERT_CHAIN_TOO_LONG',
    'CERT_REVOKED',
    'INVALID_CA',
    'PATH_LENGTH_EXCEEDED',
    'INVALID_PURPOSE',
    'CERT_UNTRUSTED',
    'CERT_REJECTED',
    'HOSTNAME_MISMATCH'
]);
// TODO: Use `error?.code` when targeting Node.js 14
module.exports = (error)=>!$05d5ea2421009f85$var$denyList.has(error && error.code);

});


parcelRegister("2YKs8", function(module, exports) {
"use strict";
/**
 * API Response Types for Helpasaur King
 * These types define the standardized response format used across all API endpoints
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RelayEvent = module.exports.ApiResult = module.exports.COMMAND_EDIT_PERMISSIONS = module.exports.hasAnyPermission = module.exports.Permission = void 0;
// Permission Types
var $22b537f31fe59a2e$var$Permission;
(function(Permission) {
    Permission["ADMIN"] = "admin";
    Permission["SERVICE"] = "service";
    Permission["COMMAND_MANAGER"] = "command_manager";
})($22b537f31fe59a2e$var$Permission || (module.exports.Permission = $22b537f31fe59a2e$var$Permission = {}));
const $22b537f31fe59a2e$var$hasAnyPermission = (userPermissions, requiredPermissions)=>{
    return requiredPermissions.some((p)=>userPermissions.includes(p));
};
module.exports.hasAnyPermission = $22b537f31fe59a2e$var$hasAnyPermission;
module.exports.COMMAND_EDIT_PERMISSIONS = [
    $22b537f31fe59a2e$var$Permission.ADMIN,
    $22b537f31fe59a2e$var$Permission.COMMAND_MANAGER
];
var $22b537f31fe59a2e$var$ApiResult;
(function(ApiResult) {
    ApiResult["SUCCESS"] = "success";
    ApiResult["ERROR"] = "error";
    ApiResult["NOOP"] = "noop";
})($22b537f31fe59a2e$var$ApiResult || (module.exports.ApiResult = $22b537f31fe59a2e$var$ApiResult = {}));
// WebSocket Relay Event Types
var $22b537f31fe59a2e$var$RelayEvent;
(function(RelayEvent) {
    RelayEvent["STREAM_ALERT"] = "streamAlert";
    RelayEvent["WEEKLY_RACE_ROOM_CREATED"] = "weeklyRaceRoomCreated";
    RelayEvent["JOIN_TWITCH_CHANNEL"] = "joinChannel";
    RelayEvent["LEAVE_TWITCH_CHANNEL"] = "leaveChannel";
    RelayEvent["TWITCH_BOT_CONFIG_UPDATED"] = "twitchBotConfigUpdated";
})($22b537f31fe59a2e$var$RelayEvent || (module.exports.RelayEvent = $22b537f31fe59a2e$var$RelayEvent = {}));

});

parcelRegister("jAGMp", function(module, exports) {
"use strict";
var $e43290506e0da53c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e43290506e0da53c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e43290506e0da53c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwitchApiClient = void 0;
module.exports.convertTwurpleRawData = $e43290506e0da53c$var$convertTwurpleRawData;

var $a1Whl = parcelRequire("a1Whl");

var $j0DIQ = parcelRequire("j0DIQ");

var $dMHW5 = parcelRequire("dMHW5");
// Helper function to extract raw data from @twurple class instances using official API
function $e43290506e0da53c$var$convertTwurpleRawData(obj) {
    // Use @twurple's official getRawData function
    return (0, $j0DIQ.getRawData)(obj);
}
class $e43290506e0da53c$var$TwitchApiClient {
    apiClient;
    clientId;
    clientSecret;
    eventSubConfig;
    constructor(options){
        this.clientId = options.client_id;
        this.clientSecret = options.client_secret;
        this.eventSubConfig = options.eventSub;
        // Use user access token if provided, otherwise use app token
        const authProvider = options.access_token ? new $dMHW5.StaticAuthProvider(this.clientId, options.access_token, options.scopes) : new $dMHW5.AppTokenAuthProvider(this.clientId, this.clientSecret);
        this.apiClient = new $a1Whl.ApiClient({
            authProvider: authProvider
        });
    }
    async getSubscriptions(params) {
        // Use paginated methods to fetch all pages of results
        if (params?.status) return this.apiClient.eventSub.getSubscriptionsForStatusPaginated(params.status).getAll();
        else if (params?.type) return this.apiClient.eventSub.getSubscriptionsForTypePaginated(params.type).getAll();
        else if (params?.user_id) return this.apiClient.eventSub.getSubscriptionsForUserPaginated(params.user_id).getAll();
        else return this.apiClient.eventSub.getSubscriptionsPaginated().getAll();
    }
    async createSubscription(userId, type, version = "1") {
        if (!this.eventSubConfig) throw new Error("EventSub configuration not provided");
        try {
            const subscription = await this.apiClient.eventSub.createSubscription(type, version, {
                broadcaster_user_id: userId
            }, {
                method: "webhook",
                callback: this.eventSubConfig.webhookUrl,
                secret: this.eventSubConfig.secret
            });
            return subscription;
        } catch (error) {
            console.error(`Failed to create ${type} subscription for user ${userId}:`, error);
            throw error;
        }
    }
    async deleteSubscription(id) {
        try {
            await this.apiClient.eventSub.deleteSubscription(id);
            return {
                success: true
            };
        } catch (error) {
            console.error(`Failed to delete subscription ${id}:`, error);
            throw error;
        }
    }
    async clearSubscriptions() {
        try {
            await this.apiClient.eventSub.deleteAllSubscriptions();
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    async subscribeToStreamEvents(data) {
        const { channel: channel, userId: userId, events: events } = data;
        const subscriptions = events.map((event)=>{
            console.log(`Creating ${event} event subscription for ${channel}`);
            return this.createSubscription(userId, event);
        });
        return await Promise.allSettled(subscriptions);
    }
    async getStreams(filter) {
        try {
            const streams = await this.apiClient.streams.getStreams(filter);
            if (!streams) return [];
            const result = streams.data.map((stream)=>$e43290506e0da53c$var$convertTwurpleRawData(stream));
            return result;
        } catch (error) {
            console.error(`Failed to get streams:`, error);
            return [];
        }
    }
    async getCurrentUserData(accessToken, withEmail = false) {
        try {
            const tokenInfo = await (0, $dMHW5.getTokenInfo)(accessToken);
            if (!tokenInfo || !tokenInfo.userId) {
                const error = `Failed to get current user: no valid token found!`;
                console.error(error);
                throw error;
            }
            const user = await this.apiClient.users.getAuthenticatedUser(tokenInfo.userId, withEmail);
            return $e43290506e0da53c$var$convertTwurpleRawData(user);
        } catch (error) {
            console.error(`Failed to get current user:`, error);
            throw error;
        }
    }
    async getUserByName(name) {
        try {
            const user = await this.apiClient.users.getUserByName(name);
            if (!user) return null;
            return $e43290506e0da53c$var$convertTwurpleRawData(user);
        } catch (error) {
            console.error(`Failed to get user by name ${name}:`, error);
            throw error;
        }
    }
    async getUserById(id) {
        try {
            const user = await this.apiClient.users.getUserById(id);
            if (!user) return null;
            return $e43290506e0da53c$var$convertTwurpleRawData(user);
        } catch (error) {
            console.error(`Failed to get user by id ${id}:`, error);
            throw error;
        }
    }
}
module.exports.TwitchApiClient = $e43290506e0da53c$var$TwitchApiClient;

$e43290506e0da53c$var$__exportStar((parcelRequire("6ZSkA")), module.exports);
module.exports.default = $e43290506e0da53c$var$TwitchApiClient;

});
parcelRegister("a1Whl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixGoal = module.exports.HelixGoalApi = module.exports.HelixGame = module.exports.HelixGameApi = module.exports.HelixExtensionTransaction = module.exports.HelixExtensionBitsProduct = module.exports.HelixExtensionsApi = module.exports.HelixPaginatedEventSubSubscriptionsRequest = module.exports.HelixEventSubSubscription = module.exports.HelixEventSubConduitShard = module.exports.HelixEventSubConduit = module.exports.HelixEventSubApi = module.exports.HelixDropsEntitlement = module.exports.HelixEntitlementApi = module.exports.HelixContentClassificationLabel = module.exports.HelixContentClassificationLabelApi = module.exports.HelixClip = module.exports.HelixClipApi = module.exports.HelixSharedChatSession = module.exports.HelixSharedChatSessionParticipant = module.exports.HelixSentChatMessage = module.exports.HelixPrivilegedChatSettings = module.exports.HelixUserEmote = module.exports.HelixEmoteFromSet = module.exports.HelixChannelEmote = module.exports.HelixEmote = module.exports.HelixChatChatter = module.exports.HelixChatSettings = module.exports.HelixChatBadgeVersion = module.exports.HelixChatBadgeSet = module.exports.HelixChatApi = module.exports.HelixCharityCampaignAmount = module.exports.HelixCharityCampaignDonation = module.exports.HelixCharityCampaign = module.exports.HelixCharityApi = module.exports.HelixCustomRewardRedemption = module.exports.HelixCustomReward = module.exports.HelixChannelPointsApi = module.exports.HelixChannelReference = module.exports.HelixFollowedChannel = module.exports.HelixChannelFollower = module.exports.HelixChannelEditor = module.exports.HelixChannel = module.exports.HelixAdSchedule = module.exports.HelixChannelApi = module.exports.HelixCheermoteList = module.exports.HelixBitsLeaderboardEntry = module.exports.HelixBitsLeaderboard = module.exports.HelixBitsApi = module.exports.ApiClient = void 0;
module.exports.HelixVideo = module.exports.HelixVideoApi = module.exports.HelixUserExtension = module.exports.HelixInstalledExtensionList = module.exports.HelixInstalledExtension = module.exports.HelixBaseExtension = module.exports.HelixUser = module.exports.HelixPrivilegedUser = module.exports.HelixFollow = module.exports.HelixUserBlock = module.exports.HelixUserApi = module.exports.HelixTeamWithUsers = module.exports.HelixTeam = module.exports.HelixTeamApi = module.exports.HelixUserSubscription = module.exports.HelixSubscription = module.exports.HelixSubscriptionApi = module.exports.HelixPaginatedSubscriptionsRequest = module.exports.HelixStreamMarkerWithVideo = module.exports.HelixStreamMarker = module.exports.HelixStream = module.exports.HelixStreamApi = module.exports.HelixChannelSearchResult = module.exports.HelixSearchApi = module.exports.HelixPaginatedScheduleSegmentRequest = module.exports.HelixScheduleSegment = module.exports.HelixSchedule = module.exports.HelixScheduleApi = module.exports.HelixUserRelation = module.exports.HelixRaid = module.exports.HelixRaidApi = module.exports.HelixPredictor = module.exports.HelixPredictionOutcome = module.exports.HelixPrediction = module.exports.HelixPredictionApi = module.exports.HelixPollChoice = module.exports.HelixPoll = module.exports.HelixPollApi = module.exports.HelixWarning = module.exports.HelixUnbanRequest = module.exports.HelixShieldModeStatus = module.exports.HelixBlockedTerm = module.exports.HelixBanUser = module.exports.HelixModeratedChannel = module.exports.HelixModerator = module.exports.HelixBan = module.exports.HelixModerationApi = module.exports.HelixHypeTrainEvent = module.exports.HelixHypeTrainContribution = module.exports.HelixHypeTrainApi = void 0;
module.exports.HellFreezesOverError = module.exports.HelixExtension = module.exports.extractUserName = module.exports.extractUserId = module.exports.HelixPaginatedRequestWithTotal = module.exports.HelixPaginatedRequest = module.exports.ApiReportedRequest = module.exports.StreamNotLiveError = module.exports.ConfigError = module.exports.HelixWhisperApi = void 0;

var $7ceWQ = parcelRequire("7ceWQ");
Object.defineProperty(module.exports, "ApiClient", {
    enumerable: true,
    get: function() {
        return $7ceWQ.ApiClient;
    }
});

var $kVdhx = parcelRequire("kVdhx");
Object.defineProperty(module.exports, "HelixBitsApi", {
    enumerable: true,
    get: function() {
        return $kVdhx.HelixBitsApi;
    }
});

var $dtRP8 = parcelRequire("dtRP8");
Object.defineProperty(module.exports, "HelixBitsLeaderboard", {
    enumerable: true,
    get: function() {
        return $dtRP8.HelixBitsLeaderboard;
    }
});

var $h51sN = parcelRequire("h51sN");
Object.defineProperty(module.exports, "HelixBitsLeaderboardEntry", {
    enumerable: true,
    get: function() {
        return $h51sN.HelixBitsLeaderboardEntry;
    }
});

var $9f9vS = parcelRequire("9f9vS");
Object.defineProperty(module.exports, "HelixCheermoteList", {
    enumerable: true,
    get: function() {
        return $9f9vS.HelixCheermoteList;
    }
});

var $1pTlx = parcelRequire("1pTlx");
Object.defineProperty(module.exports, "HelixChannelApi", {
    enumerable: true,
    get: function() {
        return $1pTlx.HelixChannelApi;
    }
});

var $eLzWu = parcelRequire("eLzWu");
Object.defineProperty(module.exports, "HelixAdSchedule", {
    enumerable: true,
    get: function() {
        return $eLzWu.HelixAdSchedule;
    }
});

var $2LWVd = parcelRequire("2LWVd");
Object.defineProperty(module.exports, "HelixChannel", {
    enumerable: true,
    get: function() {
        return $2LWVd.HelixChannel;
    }
});

var $gezBp = parcelRequire("gezBp");
Object.defineProperty(module.exports, "HelixChannelEditor", {
    enumerable: true,
    get: function() {
        return $gezBp.HelixChannelEditor;
    }
});

var $gILEY = parcelRequire("gILEY");
Object.defineProperty(module.exports, "HelixChannelFollower", {
    enumerable: true,
    get: function() {
        return $gILEY.HelixChannelFollower;
    }
});

var $1AUc7 = parcelRequire("1AUc7");
Object.defineProperty(module.exports, "HelixFollowedChannel", {
    enumerable: true,
    get: function() {
        return $1AUc7.HelixFollowedChannel;
    }
});

var $l6zr1 = parcelRequire("l6zr1");
Object.defineProperty(module.exports, "HelixChannelReference", {
    enumerable: true,
    get: function() {
        return $l6zr1.HelixChannelReference;
    }
});

var $43yGM = parcelRequire("43yGM");
Object.defineProperty(module.exports, "HelixChannelPointsApi", {
    enumerable: true,
    get: function() {
        return $43yGM.HelixChannelPointsApi;
    }
});

var $gCXpe = parcelRequire("gCXpe");
Object.defineProperty(module.exports, "HelixCustomReward", {
    enumerable: true,
    get: function() {
        return $gCXpe.HelixCustomReward;
    }
});

var $dmVKA = parcelRequire("dmVKA");
Object.defineProperty(module.exports, "HelixCustomRewardRedemption", {
    enumerable: true,
    get: function() {
        return $dmVKA.HelixCustomRewardRedemption;
    }
});

var $iyImv = parcelRequire("iyImv");
Object.defineProperty(module.exports, "HelixCharityApi", {
    enumerable: true,
    get: function() {
        return $iyImv.HelixCharityApi;
    }
});

var $2qE8E = parcelRequire("2qE8E");
Object.defineProperty(module.exports, "HelixCharityCampaign", {
    enumerable: true,
    get: function() {
        return $2qE8E.HelixCharityCampaign;
    }
});

var $ab0YV = parcelRequire("ab0YV");
Object.defineProperty(module.exports, "HelixCharityCampaignDonation", {
    enumerable: true,
    get: function() {
        return $ab0YV.HelixCharityCampaignDonation;
    }
});

var $jDlBx = parcelRequire("jDlBx");
Object.defineProperty(module.exports, "HelixCharityCampaignAmount", {
    enumerable: true,
    get: function() {
        return $jDlBx.HelixCharityCampaignAmount;
    }
});

var $39w82 = parcelRequire("39w82");
Object.defineProperty(module.exports, "HelixChatApi", {
    enumerable: true,
    get: function() {
        return $39w82.HelixChatApi;
    }
});

var $b1Ut4 = parcelRequire("b1Ut4");
Object.defineProperty(module.exports, "HelixChatBadgeSet", {
    enumerable: true,
    get: function() {
        return $b1Ut4.HelixChatBadgeSet;
    }
});

var $kEyVe = parcelRequire("kEyVe");
Object.defineProperty(module.exports, "HelixChatBadgeVersion", {
    enumerable: true,
    get: function() {
        return $kEyVe.HelixChatBadgeVersion;
    }
});

var $4lCpS = parcelRequire("4lCpS");
Object.defineProperty(module.exports, "HelixChatSettings", {
    enumerable: true,
    get: function() {
        return $4lCpS.HelixChatSettings;
    }
});

var $eGJRV = parcelRequire("eGJRV");
Object.defineProperty(module.exports, "HelixChatChatter", {
    enumerable: true,
    get: function() {
        return $eGJRV.HelixChatChatter;
    }
});

var $ayCIV = parcelRequire("ayCIV");
Object.defineProperty(module.exports, "HelixEmote", {
    enumerable: true,
    get: function() {
        return $ayCIV.HelixEmote;
    }
});

var $ecrvb = parcelRequire("ecrvb");
Object.defineProperty(module.exports, "HelixChannelEmote", {
    enumerable: true,
    get: function() {
        return $ecrvb.HelixChannelEmote;
    }
});

var $g9mZm = parcelRequire("g9mZm");
Object.defineProperty(module.exports, "HelixEmoteFromSet", {
    enumerable: true,
    get: function() {
        return $g9mZm.HelixEmoteFromSet;
    }
});

var $5erY8 = parcelRequire("5erY8");
Object.defineProperty(module.exports, "HelixUserEmote", {
    enumerable: true,
    get: function() {
        return $5erY8.HelixUserEmote;
    }
});

var $bfwdV = parcelRequire("bfwdV");
Object.defineProperty(module.exports, "HelixPrivilegedChatSettings", {
    enumerable: true,
    get: function() {
        return $bfwdV.HelixPrivilegedChatSettings;
    }
});

var $iRBdv = parcelRequire("iRBdv");
Object.defineProperty(module.exports, "HelixSentChatMessage", {
    enumerable: true,
    get: function() {
        return $iRBdv.HelixSentChatMessage;
    }
});

var $7MYwq = parcelRequire("7MYwq");
Object.defineProperty(module.exports, "HelixSharedChatSessionParticipant", {
    enumerable: true,
    get: function() {
        return $7MYwq.HelixSharedChatSessionParticipant;
    }
});

var $4NFiy = parcelRequire("4NFiy");
Object.defineProperty(module.exports, "HelixSharedChatSession", {
    enumerable: true,
    get: function() {
        return $4NFiy.HelixSharedChatSession;
    }
});

var $fJP1s = parcelRequire("fJP1s");
Object.defineProperty(module.exports, "HelixClipApi", {
    enumerable: true,
    get: function() {
        return $fJP1s.HelixClipApi;
    }
});

var $8UWnv = parcelRequire("8UWnv");
Object.defineProperty(module.exports, "HelixClip", {
    enumerable: true,
    get: function() {
        return $8UWnv.HelixClip;
    }
});

var $2LQEj = parcelRequire("2LQEj");
Object.defineProperty(module.exports, "HelixContentClassificationLabelApi", {
    enumerable: true,
    get: function() {
        return $2LQEj.HelixContentClassificationLabelApi;
    }
});

var $hDi1V = parcelRequire("hDi1V");
Object.defineProperty(module.exports, "HelixContentClassificationLabel", {
    enumerable: true,
    get: function() {
        return $hDi1V.HelixContentClassificationLabel;
    }
});

var $4MAQg = parcelRequire("4MAQg");
Object.defineProperty(module.exports, "HelixEntitlementApi", {
    enumerable: true,
    get: function() {
        return $4MAQg.HelixEntitlementApi;
    }
});

var $hM3JO = parcelRequire("hM3JO");
Object.defineProperty(module.exports, "HelixDropsEntitlement", {
    enumerable: true,
    get: function() {
        return $hM3JO.HelixDropsEntitlement;
    }
});

var $iZjEc = parcelRequire("iZjEc");
Object.defineProperty(module.exports, "HelixEventSubApi", {
    enumerable: true,
    get: function() {
        return $iZjEc.HelixEventSubApi;
    }
});

var $h4D57 = parcelRequire("h4D57");
Object.defineProperty(module.exports, "HelixEventSubConduit", {
    enumerable: true,
    get: function() {
        return $h4D57.HelixEventSubConduit;
    }
});

var $cPjDL = parcelRequire("cPjDL");
Object.defineProperty(module.exports, "HelixEventSubConduitShard", {
    enumerable: true,
    get: function() {
        return $cPjDL.HelixEventSubConduitShard;
    }
});

var $lgnUZ = parcelRequire("lgnUZ");
Object.defineProperty(module.exports, "HelixEventSubSubscription", {
    enumerable: true,
    get: function() {
        return $lgnUZ.HelixEventSubSubscription;
    }
});

var $90YWS = parcelRequire("90YWS");
Object.defineProperty(module.exports, "HelixPaginatedEventSubSubscriptionsRequest", {
    enumerable: true,
    get: function() {
        return $90YWS.HelixPaginatedEventSubSubscriptionsRequest;
    }
});

var $jJLZi = parcelRequire("jJLZi");
Object.defineProperty(module.exports, "HelixExtensionsApi", {
    enumerable: true,
    get: function() {
        return $jJLZi.HelixExtensionsApi;
    }
});

var $2rp28 = parcelRequire("2rp28");
Object.defineProperty(module.exports, "HelixExtensionBitsProduct", {
    enumerable: true,
    get: function() {
        return $2rp28.HelixExtensionBitsProduct;
    }
});

var $kxhgp = parcelRequire("kxhgp");
Object.defineProperty(module.exports, "HelixExtensionTransaction", {
    enumerable: true,
    get: function() {
        return $kxhgp.HelixExtensionTransaction;
    }
});

var $bLRG1 = parcelRequire("bLRG1");
Object.defineProperty(module.exports, "HelixGameApi", {
    enumerable: true,
    get: function() {
        return $bLRG1.HelixGameApi;
    }
});

var $3Udy1 = parcelRequire("3Udy1");
Object.defineProperty(module.exports, "HelixGame", {
    enumerable: true,
    get: function() {
        return $3Udy1.HelixGame;
    }
});

var $5g9IT = parcelRequire("5g9IT");
Object.defineProperty(module.exports, "HelixGoalApi", {
    enumerable: true,
    get: function() {
        return $5g9IT.HelixGoalApi;
    }
});

var $1ULk1 = parcelRequire("1ULk1");
Object.defineProperty(module.exports, "HelixGoal", {
    enumerable: true,
    get: function() {
        return $1ULk1.HelixGoal;
    }
});

var $geW2U = parcelRequire("geW2U");
Object.defineProperty(module.exports, "HelixHypeTrainApi", {
    enumerable: true,
    get: function() {
        return $geW2U.HelixHypeTrainApi;
    }
});

var $kUJaa = parcelRequire("kUJaa");
Object.defineProperty(module.exports, "HelixHypeTrainContribution", {
    enumerable: true,
    get: function() {
        return $kUJaa.HelixHypeTrainContribution;
    }
});

var $eISnG = parcelRequire("eISnG");
Object.defineProperty(module.exports, "HelixHypeTrainEvent", {
    enumerable: true,
    get: function() {
        return $eISnG.HelixHypeTrainEvent;
    }
});

var $l2bqp = parcelRequire("l2bqp");
Object.defineProperty(module.exports, "HelixModerationApi", {
    enumerable: true,
    get: function() {
        return $l2bqp.HelixModerationApi;
    }
});

var $axg0W = parcelRequire("axg0W");
Object.defineProperty(module.exports, "HelixBan", {
    enumerable: true,
    get: function() {
        return $axg0W.HelixBan;
    }
});

var $7AuQT = parcelRequire("7AuQT");
Object.defineProperty(module.exports, "HelixModerator", {
    enumerable: true,
    get: function() {
        return $7AuQT.HelixModerator;
    }
});

var $b7oXt = parcelRequire("b7oXt");
Object.defineProperty(module.exports, "HelixModeratedChannel", {
    enumerable: true,
    get: function() {
        return $b7oXt.HelixModeratedChannel;
    }
});

var $f4oqh = parcelRequire("f4oqh");
Object.defineProperty(module.exports, "HelixBanUser", {
    enumerable: true,
    get: function() {
        return $f4oqh.HelixBanUser;
    }
});

var $d90cS = parcelRequire("d90cS");
Object.defineProperty(module.exports, "HelixBlockedTerm", {
    enumerable: true,
    get: function() {
        return $d90cS.HelixBlockedTerm;
    }
});

var $2BoCE = parcelRequire("2BoCE");
Object.defineProperty(module.exports, "HelixShieldModeStatus", {
    enumerable: true,
    get: function() {
        return $2BoCE.HelixShieldModeStatus;
    }
});

var $elAZM = parcelRequire("elAZM");
Object.defineProperty(module.exports, "HelixUnbanRequest", {
    enumerable: true,
    get: function() {
        return $elAZM.HelixUnbanRequest;
    }
});

var $9OKn1 = parcelRequire("9OKn1");
Object.defineProperty(module.exports, "HelixWarning", {
    enumerable: true,
    get: function() {
        return $9OKn1.HelixWarning;
    }
});

var $htL0z = parcelRequire("htL0z");
Object.defineProperty(module.exports, "HelixPollApi", {
    enumerable: true,
    get: function() {
        return $htL0z.HelixPollApi;
    }
});

var $1ZGB4 = parcelRequire("1ZGB4");
Object.defineProperty(module.exports, "HelixPoll", {
    enumerable: true,
    get: function() {
        return $1ZGB4.HelixPoll;
    }
});

var $7Mv1R = parcelRequire("7Mv1R");
Object.defineProperty(module.exports, "HelixPollChoice", {
    enumerable: true,
    get: function() {
        return $7Mv1R.HelixPollChoice;
    }
});

var $yazN3 = parcelRequire("yazN3");
Object.defineProperty(module.exports, "HelixPredictionApi", {
    enumerable: true,
    get: function() {
        return $yazN3.HelixPredictionApi;
    }
});

var $1MAZj = parcelRequire("1MAZj");
Object.defineProperty(module.exports, "HelixPrediction", {
    enumerable: true,
    get: function() {
        return $1MAZj.HelixPrediction;
    }
});

var $gNeGc = parcelRequire("gNeGc");
Object.defineProperty(module.exports, "HelixPredictionOutcome", {
    enumerable: true,
    get: function() {
        return $gNeGc.HelixPredictionOutcome;
    }
});

var $jaxFs = parcelRequire("jaxFs");
Object.defineProperty(module.exports, "HelixPredictor", {
    enumerable: true,
    get: function() {
        return $jaxFs.HelixPredictor;
    }
});

var $28sHD = parcelRequire("28sHD");
Object.defineProperty(module.exports, "HelixRaidApi", {
    enumerable: true,
    get: function() {
        return $28sHD.HelixRaidApi;
    }
});

var $anYgI = parcelRequire("anYgI");
Object.defineProperty(module.exports, "HelixRaid", {
    enumerable: true,
    get: function() {
        return $anYgI.HelixRaid;
    }
});

var $4yKj5 = parcelRequire("4yKj5");
Object.defineProperty(module.exports, "HelixUserRelation", {
    enumerable: true,
    get: function() {
        return $4yKj5.HelixUserRelation;
    }
});

var $7R0an = parcelRequire("7R0an");
Object.defineProperty(module.exports, "HelixScheduleApi", {
    enumerable: true,
    get: function() {
        return $7R0an.HelixScheduleApi;
    }
});

var $enDAN = parcelRequire("enDAN");
Object.defineProperty(module.exports, "HelixSchedule", {
    enumerable: true,
    get: function() {
        return $enDAN.HelixSchedule;
    }
});

var $gF4Kv = parcelRequire("gF4Kv");
Object.defineProperty(module.exports, "HelixScheduleSegment", {
    enumerable: true,
    get: function() {
        return $gF4Kv.HelixScheduleSegment;
    }
});

var $8hGJ4 = parcelRequire("8hGJ4");
Object.defineProperty(module.exports, "HelixPaginatedScheduleSegmentRequest", {
    enumerable: true,
    get: function() {
        return $8hGJ4.HelixPaginatedScheduleSegmentRequest;
    }
});

var $cEYvo = parcelRequire("cEYvo");
Object.defineProperty(module.exports, "HelixSearchApi", {
    enumerable: true,
    get: function() {
        return $cEYvo.HelixSearchApi;
    }
});

var $dFkCq = parcelRequire("dFkCq");
Object.defineProperty(module.exports, "HelixChannelSearchResult", {
    enumerable: true,
    get: function() {
        return $dFkCq.HelixChannelSearchResult;
    }
});

var $2I7cV = parcelRequire("2I7cV");
Object.defineProperty(module.exports, "HelixStreamApi", {
    enumerable: true,
    get: function() {
        return $2I7cV.HelixStreamApi;
    }
});

var $5xSVZ = parcelRequire("5xSVZ");
Object.defineProperty(module.exports, "HelixStream", {
    enumerable: true,
    get: function() {
        return $5xSVZ.HelixStream;
    }
});

var $dZaqN = parcelRequire("dZaqN");
Object.defineProperty(module.exports, "HelixStreamMarker", {
    enumerable: true,
    get: function() {
        return $dZaqN.HelixStreamMarker;
    }
});

var $5iHqo = parcelRequire("5iHqo");
Object.defineProperty(module.exports, "HelixStreamMarkerWithVideo", {
    enumerable: true,
    get: function() {
        return $5iHqo.HelixStreamMarkerWithVideo;
    }
});

var $312bz = parcelRequire("312bz");
Object.defineProperty(module.exports, "HelixPaginatedSubscriptionsRequest", {
    enumerable: true,
    get: function() {
        return $312bz.HelixPaginatedSubscriptionsRequest;
    }
});

var $ll7Cn = parcelRequire("ll7Cn");
Object.defineProperty(module.exports, "HelixSubscriptionApi", {
    enumerable: true,
    get: function() {
        return $ll7Cn.HelixSubscriptionApi;
    }
});

var $h2Nny = parcelRequire("h2Nny");
Object.defineProperty(module.exports, "HelixSubscription", {
    enumerable: true,
    get: function() {
        return $h2Nny.HelixSubscription;
    }
});

var $8hVFG = parcelRequire("8hVFG");
Object.defineProperty(module.exports, "HelixUserSubscription", {
    enumerable: true,
    get: function() {
        return $8hVFG.HelixUserSubscription;
    }
});

var $8VbMp = parcelRequire("8VbMp");
Object.defineProperty(module.exports, "HelixTeamApi", {
    enumerable: true,
    get: function() {
        return $8VbMp.HelixTeamApi;
    }
});

var $kgm0V = parcelRequire("kgm0V");
Object.defineProperty(module.exports, "HelixTeam", {
    enumerable: true,
    get: function() {
        return $kgm0V.HelixTeam;
    }
});

var $8qcK0 = parcelRequire("8qcK0");
Object.defineProperty(module.exports, "HelixTeamWithUsers", {
    enumerable: true,
    get: function() {
        return $8qcK0.HelixTeamWithUsers;
    }
});

var $3BqLi = parcelRequire("3BqLi");
Object.defineProperty(module.exports, "HelixUserApi", {
    enumerable: true,
    get: function() {
        return $3BqLi.HelixUserApi;
    }
});

var $8dBYL = parcelRequire("8dBYL");
Object.defineProperty(module.exports, "HelixUserBlock", {
    enumerable: true,
    get: function() {
        return $8dBYL.HelixUserBlock;
    }
});

var $jXzvX = parcelRequire("jXzvX");
Object.defineProperty(module.exports, "HelixFollow", {
    enumerable: true,
    get: function() {
        return $jXzvX.HelixFollow;
    }
});

var $c4KWn = parcelRequire("c4KWn");
Object.defineProperty(module.exports, "HelixPrivilegedUser", {
    enumerable: true,
    get: function() {
        return $c4KWn.HelixPrivilegedUser;
    }
});

var $75xqV = parcelRequire("75xqV");
Object.defineProperty(module.exports, "HelixUser", {
    enumerable: true,
    get: function() {
        return $75xqV.HelixUser;
    }
});

var $7SEhe = parcelRequire("7SEhe");
Object.defineProperty(module.exports, "HelixBaseExtension", {
    enumerable: true,
    get: function() {
        return $7SEhe.HelixBaseExtension;
    }
});

var $o7FSU = parcelRequire("o7FSU");
Object.defineProperty(module.exports, "HelixInstalledExtension", {
    enumerable: true,
    get: function() {
        return $o7FSU.HelixInstalledExtension;
    }
});

var $79EnW = parcelRequire("79EnW");
Object.defineProperty(module.exports, "HelixInstalledExtensionList", {
    enumerable: true,
    get: function() {
        return $79EnW.HelixInstalledExtensionList;
    }
});

var $OaXF4 = parcelRequire("OaXF4");
Object.defineProperty(module.exports, "HelixUserExtension", {
    enumerable: true,
    get: function() {
        return $OaXF4.HelixUserExtension;
    }
});

var $9WAZR = parcelRequire("9WAZR");
Object.defineProperty(module.exports, "HelixVideoApi", {
    enumerable: true,
    get: function() {
        return $9WAZR.HelixVideoApi;
    }
});

var $5N1SI = parcelRequire("5N1SI");
Object.defineProperty(module.exports, "HelixVideo", {
    enumerable: true,
    get: function() {
        return $5N1SI.HelixVideo;
    }
});

var $9ZuV6 = parcelRequire("9ZuV6");
Object.defineProperty(module.exports, "HelixWhisperApi", {
    enumerable: true,
    get: function() {
        return $9ZuV6.HelixWhisperApi;
    }
});

var $hivwW = parcelRequire("hivwW");
Object.defineProperty(module.exports, "ConfigError", {
    enumerable: true,
    get: function() {
        return $hivwW.ConfigError;
    }
});

var $d006L = parcelRequire("d006L");
Object.defineProperty(module.exports, "StreamNotLiveError", {
    enumerable: true,
    get: function() {
        return $d006L.StreamNotLiveError;
    }
});

var $ghlvC = parcelRequire("ghlvC");
Object.defineProperty(module.exports, "ApiReportedRequest", {
    enumerable: true,
    get: function() {
        return $ghlvC.ApiReportedRequest;
    }
});

var $6tEA1 = parcelRequire("6tEA1");
Object.defineProperty(module.exports, "HelixPaginatedRequest", {
    enumerable: true,
    get: function() {
        return $6tEA1.HelixPaginatedRequest;
    }
});

var $4W0OK = parcelRequire("4W0OK");
Object.defineProperty(module.exports, "HelixPaginatedRequestWithTotal", {
    enumerable: true,
    get: function() {
        return $4W0OK.HelixPaginatedRequestWithTotal;
    }
});

var $j0DIQ = parcelRequire("j0DIQ");
Object.defineProperty(module.exports, "extractUserId", {
    enumerable: true,
    get: function() {
        return $j0DIQ.extractUserId;
    }
});
Object.defineProperty(module.exports, "extractUserName", {
    enumerable: true,
    get: function() {
        return $j0DIQ.extractUserName;
    }
});
Object.defineProperty(module.exports, "HelixExtension", {
    enumerable: true,
    get: function() {
        return $j0DIQ.HelixExtension;
    }
});
Object.defineProperty(module.exports, "HellFreezesOverError", {
    enumerable: true,
    get: function() {
        return $j0DIQ.HellFreezesOverError;
    }
});

});
parcelRegister("7ceWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApiClient = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $lNLbF = parcelRequire("lNLbF");

var $i34dA = parcelRequire("i34dA");

var $2GTfZ = parcelRequire("2GTfZ");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $hivwW = parcelRequire("hivwW");

var $dLcJ6 = parcelRequire("dLcJ6");

var $81oS5 = parcelRequire("81oS5");

var $e3Lkp = parcelRequire("e3Lkp");

var $5mUg4 = parcelRequire("5mUg4");
/**
 * An API client for the Twitch Helix API and other miscellaneous endpoints.
 *
 * @meta category main
 * @hideProtected
 */ let $53d53fc44a2948d4$var$ApiClient = class ApiClient extends $81oS5.BaseApiClient {
    /**
     * Creates a new API client instance.
     *
     * @param config Configuration for the client instance.
     */ constructor(config){
        if (!config.authProvider) throw new $hivwW.ConfigError('No auth provider given. Please supply the `authProvider` option.');
        const rateLimitLoggerOptions = {
            name: 'twurple:api:rate-limiter',
            ...config.logger
        };
        super(config, (0, $i34dA.createLogger)({
            name: 'twurple:api:client',
            ...config.logger
        }), $lNLbF.isNode ? new $2GTfZ.PartitionedRateLimiter({
            getPartitionKey: (req)=>{
                var _a;
                return (_a = req.userId) !== null && _a !== void 0 ? _a : null;
            },
            createChild: ()=>new $dLcJ6.HelixRateLimiter({
                    logger: rateLimitLoggerOptions
                })
        }) : new $2GTfZ.PartitionedTimeBasedRateLimiter({
            logger: rateLimitLoggerOptions,
            bucketSize: 800,
            timeFrame: 64000,
            doRequest: async ({ options: options, clientId: clientId, accessToken: accessToken, authorizationType: authorizationType, fetchOptions: fetchOptions, mockServerPort: mockServerPort })=>await (0, $4ojlB.callTwitchApiRaw)(options, clientId, accessToken, authorizationType, fetchOptions, mockServerPort),
            getPartitionKey: (req)=>{
                var _a;
                return (_a = req.userId) !== null && _a !== void 0 ? _a : null;
            }
        }));
    }
    /**
     * Creates a contextualized ApiClient that can be used to call the API in the context of a given user.
     *
     * @param user The user to use as context.
     * @param runner The callback to execute.
     *
     * A parameter is passed that should be used in place of the normal `ApiClient`
     * to ensure that all requests are executed in the given user's context.
     *
     * Please note that requests which require scope authorization ignore this context.
     *
     * The return value of your callback will be propagated to the return value of this method.
     */ async asUser(user, runner) {
        const ctx = new $5mUg4.UserContextApiClient(this._config, this._logger, this._rateLimiter, (0, $j0DIQ.extractUserId)(user));
        return await runner(ctx);
    }
    /**
     * Creates a contextualized ApiClient that can be used to call the API in the context of a given intent.
     *
     * @param intents A list of intents. The first one that is found in your auth provider will be used.
     * @param runner The callback to execute.
     *
     * A parameter is passed that should be used in place of the normal `ApiClient`
     * to ensure that all requests are executed in the given user's context.
     *
     * Please note that requests which require scope authorization ignore this context.
     *
     * The return value of your callback will be propagated to the return value of this method.
     */ async asIntent(intents, runner) {
        if (!this._authProvider.getAccessTokenForIntent) throw new Error('Trying to use intents with an auth provider that does not support them');
        for (const intent of intents){
            const user = await this._authProvider.getAccessTokenForIntent(intent);
            if (user) {
                const ctx = new $5mUg4.UserContextApiClient(this._config, this._logger, this._rateLimiter, user.userId);
                return await runner(ctx);
            }
        }
        throw new Error(`Intents [${intents.join(', ')}] not found in auth provider`);
    }
    /**
     * Creates a contextualized ApiClient that can be used to call the API without the context of any user.
     *
     * This usually means that an app access token is used.
     *
     * @param runner The callback to execute.
     *
     * A parameter is passed that should be used in place of the normal `ApiClient`
     * to ensure that all requests are executed without user context.
     *
     * Please note that requests which require scope authorization ignore this context erasure.
     *
     * The return value of your callback will be propagated to the return value of this method.
     */ async withoutUser(runner) {
        const ctx = new $e3Lkp.NoContextApiClient(this._config, this._logger, this._rateLimiter);
        return await runner(ctx);
    }
};
module.exports.ApiClient = $53d53fc44a2948d4$var$ApiClient;
module.exports.ApiClient = $53d53fc44a2948d4$var$ApiClient = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'ApiClient')
], $53d53fc44a2948d4$var$ApiClient);

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__decorate", () => $8e874a2fb001c377$export$29e00dfd3077644b);
$parcel$export(module.exports, "__awaiter", () => $8e874a2fb001c377$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("lNLbF", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $fdf2c6f1823f7716$export$8ee0fc9ee280b4ee, (v) => $fdf2c6f1823f7716$export$8ee0fc9ee280b4ee = v);
var $fdf2c6f1823f7716$export$8ee0fc9ee280b4ee;
$fdf2c6f1823f7716$export$8ee0fc9ee280b4ee = false;

});

parcelRegister("i34dA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevel = module.exports.createLogger = void 0;

var $e9jRd = parcelRequire("e9jRd");
Object.defineProperty(module.exports, "createLogger", {
    enumerable: true,
    get: function() {
        return $e9jRd.createLogger;
    }
});

var $jV6oc = parcelRequire("jV6oc");
Object.defineProperty(module.exports, "LogLevel", {
    enumerable: true,
    get: function() {
        return $jV6oc.LogLevel;
    }
});

});
parcelRegister("e9jRd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createLogger = void 0;

var $lNLbF = parcelRequire("lNLbF");

var $eXZrd = parcelRequire("eXZrd");

var $9z32l = parcelRequire("9z32l");

var $3JOLU = parcelRequire("3JOLU");
function $a4d14f3139e4862e$var$createLogger(options) {
    if (options.custom) return new $9z32l.CustomLoggerWrapper(options);
    if ($lNLbF.isNode) return new $3JOLU.NodeLogger(options);
    return new $eXZrd.BrowserLogger(options);
}
module.exports.createLogger = $a4d14f3139e4862e$var$createLogger;

});
parcelRegister("eXZrd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLogger = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $jV6oc = parcelRequire("jV6oc");

var $7edwh = parcelRequire("7edwh");
var $ae563bad427225b2$var$BrowserLogger = /** @class */ function(_super) {
    $ceFTv.__extends(BrowserLogger, _super);
    function BrowserLogger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserLogger.prototype.log = function(level, message) {
        if (level > this._minLevel) return;
        var logFn = $jV6oc.LogLevelToConsoleFunction[level];
        var formattedMessage = "[".concat(this._name, "] ").concat(message);
        if (this._timestamps) formattedMessage = "[".concat(new Date().toISOString(), "] ").concat(message);
        logFn(formattedMessage);
    };
    return BrowserLogger;
}($7edwh.BaseLogger);
module.exports.BrowserLogger = $ae563bad427225b2$var$BrowserLogger;

});
parcelRegister("jV6oc", function(module, exports) {
"use strict";
var $e8084c005fcc8abf$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LogLevelToConsoleFunction = module.exports.resolveLogLevel = module.exports.LogLevel = void 0;

var $lNLbF = parcelRequire("lNLbF");
var $e8084c005fcc8abf$var$LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["CRITICAL"] = 0] = "CRITICAL";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
    LogLevel[LogLevel["TRACE"] = 7] = "TRACE";
})($e8084c005fcc8abf$var$LogLevel || ($e8084c005fcc8abf$var$LogLevel = {}));
module.exports.LogLevel = $e8084c005fcc8abf$var$LogLevel;
function $e8084c005fcc8abf$var$resolveLogLevel(level) {
    if (typeof level === 'number') {
        if (Object.prototype.hasOwnProperty.call($e8084c005fcc8abf$var$LogLevel, level)) return level;
        var eligibleLevels = Object.keys($e8084c005fcc8abf$var$LogLevel).map(function(k) {
            return parseInt(k, 10);
        }).filter(function(k) {
            return !isNaN(k) && k < level;
        });
        if (!eligibleLevels.length) return $e8084c005fcc8abf$var$LogLevel.WARNING;
        return Math.max.apply(Math, eligibleLevels);
    }
    // TODO drop the replace for next major, it keeps the old deprecated debug1/2/3 levels running
    var strLevel = level.replace(/\d+$/, '').toUpperCase();
    if (!Object.prototype.hasOwnProperty.call($e8084c005fcc8abf$var$LogLevel, strLevel)) throw new Error("Unknown log level string: ".concat(level));
    return $e8084c005fcc8abf$var$LogLevel[strLevel];
}
module.exports.resolveLogLevel = $e8084c005fcc8abf$var$resolveLogLevel;
// Node 8+ defines console.debug as noop, and earlier versions don't define it at all
var $e8084c005fcc8abf$var$debugFunction = $lNLbF.isNode ? console.log.bind(console) : console.debug.bind(console);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
module.exports.LogLevelToConsoleFunction = ($e8084c005fcc8abf$var$_a = {}, $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.CRITICAL] = console.error.bind(console), $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.ERROR] = console.error.bind(console), $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.WARNING] = console.warn.bind(console), $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.INFO] = console.info.bind(console), $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.DEBUG] = $e8084c005fcc8abf$var$debugFunction.bind(console), $e8084c005fcc8abf$var$_a[$e8084c005fcc8abf$var$LogLevel.TRACE] = console.trace.bind(console), $e8084c005fcc8abf$var$_a);

});

parcelRegister("7edwh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseLogger = void 0;

var $bRvJY = parcelRequire("bRvJY");

var $lNLbF = parcelRequire("lNLbF");

var $kJ6ve = parcelRequire("kJ6ve");

var $jV6oc = parcelRequire("jV6oc");
var $543453f44a2d282a$var$BaseLogger = /** @class */ function() {
    function BaseLogger(_a) {
        var name = _a.name, minLevel = _a.minLevel, _b = _a.emoji, emoji = _b === void 0 ? false : _b, colors = _a.colors, _c = _a.timestamps, timestamps = _c === void 0 ? $lNLbF.isNode : _c;
        var _d, _e;
        this._name = name;
        this._minLevel = (_e = (_d = (0, $bRvJY.mapOptional)(minLevel, function(lv) {
            return (0, $jV6oc.resolveLogLevel)(lv);
        })) !== null && _d !== void 0 ? _d : (0, $kJ6ve.getMinLogLevelFromEnv)(name)) !== null && _e !== void 0 ? _e : $jV6oc.LogLevel.WARNING;
        this._emoji = emoji;
        this._colors = colors;
        this._timestamps = timestamps;
    }
    // region convenience methods
    BaseLogger.prototype.crit = function(message) {
        this.log($jV6oc.LogLevel.CRITICAL, message);
    };
    BaseLogger.prototype.error = function(message) {
        this.log($jV6oc.LogLevel.ERROR, message);
    };
    BaseLogger.prototype.warn = function(message) {
        this.log($jV6oc.LogLevel.WARNING, message);
    };
    BaseLogger.prototype.info = function(message) {
        this.log($jV6oc.LogLevel.INFO, message);
    };
    BaseLogger.prototype.debug = function(message) {
        this.log($jV6oc.LogLevel.DEBUG, message);
    };
    BaseLogger.prototype.trace = function(message) {
        this.log($jV6oc.LogLevel.TRACE, message);
    };
    return BaseLogger;
}();
module.exports.BaseLogger = $543453f44a2d282a$var$BaseLogger;

});
parcelRegister("bRvJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utf8Substring = module.exports.utf8Length = module.exports.splitWithLimit = module.exports.padLeft = module.exports.promiseWithResolvers = module.exports.delay = module.exports.mapOptional = module.exports.mapNullable = module.exports.isNullish = module.exports.pick = module.exports.omit = module.exports.mapObject = module.exports.indexBy = module.exports.groupBy = module.exports.forEachObjectEntry = module.exports.entriesToObject = module.exports.arrayToObject = module.exports.fibWithLimit = module.exports.eq = module.exports.match = module.exports.deprecateClass = module.exports.resolveConfigValueSync = module.exports.resolveConfigValue = module.exports.partitionedFlatMap = module.exports.immutableSplice = module.exports.flatten = module.exports.Enumerable = void 0;

var $loJYf = parcelRequire("loJYf");
Object.defineProperty(module.exports, "Enumerable", {
    enumerable: true,
    get: function() {
        return $loJYf.Enumerable;
    }
});

var $57dxb = parcelRequire("57dxb");
Object.defineProperty(module.exports, "flatten", {
    enumerable: true,
    get: function() {
        return $57dxb.flatten;
    }
});

var $hFyPu = parcelRequire("hFyPu");
Object.defineProperty(module.exports, "immutableSplice", {
    enumerable: true,
    get: function() {
        return $hFyPu.immutableSplice;
    }
});

var $46wpN = parcelRequire("46wpN");
Object.defineProperty(module.exports, "partitionedFlatMap", {
    enumerable: true,
    get: function() {
        return $46wpN.partitionedFlatMap;
    }
});

var $iqRWE = parcelRequire("iqRWE");
Object.defineProperty(module.exports, "resolveConfigValue", {
    enumerable: true,
    get: function() {
        return $iqRWE.resolveConfigValue;
    }
});
Object.defineProperty(module.exports, "resolveConfigValueSync", {
    enumerable: true,
    get: function() {
        return $iqRWE.resolveConfigValueSync;
    }
});

var $acMGV = parcelRequire("acMGV");
Object.defineProperty(module.exports, "deprecateClass", {
    enumerable: true,
    get: function() {
        return $acMGV.deprecateClass;
    }
});

var $1lau6 = parcelRequire("1lau6");
Object.defineProperty(module.exports, "match", {
    enumerable: true,
    get: function() {
        return $1lau6.match;
    }
});
Object.defineProperty(module.exports, "eq", {
    enumerable: true,
    get: function() {
        return $1lau6.eq;
    }
});

var $bPwqX = parcelRequire("bPwqX");
Object.defineProperty(module.exports, "fibWithLimit", {
    enumerable: true,
    get: function() {
        return $bPwqX.fibWithLimit;
    }
});

var $fIWSg = parcelRequire("fIWSg");
Object.defineProperty(module.exports, "arrayToObject", {
    enumerable: true,
    get: function() {
        return $fIWSg.arrayToObject;
    }
});

var $a2SZl = parcelRequire("a2SZl");
Object.defineProperty(module.exports, "entriesToObject", {
    enumerable: true,
    get: function() {
        return $a2SZl.entriesToObject;
    }
});

var $3aqj6 = parcelRequire("3aqj6");
Object.defineProperty(module.exports, "forEachObjectEntry", {
    enumerable: true,
    get: function() {
        return $3aqj6.forEachObjectEntry;
    }
});

var $ch6hQ = parcelRequire("ch6hQ");
Object.defineProperty(module.exports, "groupBy", {
    enumerable: true,
    get: function() {
        return $ch6hQ.groupBy;
    }
});

var $es8Cn = parcelRequire("es8Cn");
Object.defineProperty(module.exports, "indexBy", {
    enumerable: true,
    get: function() {
        return $es8Cn.indexBy;
    }
});

var $jYr0q = parcelRequire("jYr0q");
Object.defineProperty(module.exports, "mapObject", {
    enumerable: true,
    get: function() {
        return $jYr0q.mapObject;
    }
});

var $h3YVq = parcelRequire("h3YVq");
Object.defineProperty(module.exports, "omit", {
    enumerable: true,
    get: function() {
        return $h3YVq.omit;
    }
});

var $4YZja = parcelRequire("4YZja");
Object.defineProperty(module.exports, "pick", {
    enumerable: true,
    get: function() {
        return $4YZja.pick;
    }
});

var $dxWMo = parcelRequire("dxWMo");
Object.defineProperty(module.exports, "isNullish", {
    enumerable: true,
    get: function() {
        return $dxWMo.isNullish;
    }
});
Object.defineProperty(module.exports, "mapNullable", {
    enumerable: true,
    get: function() {
        return $dxWMo.mapNullable;
    }
});
Object.defineProperty(module.exports, "mapOptional", {
    enumerable: true,
    get: function() {
        return $dxWMo.mapOptional;
    }
});

var $ii7eo = parcelRequire("ii7eo");
Object.defineProperty(module.exports, "delay", {
    enumerable: true,
    get: function() {
        return $ii7eo.delay;
    }
});

var $OxKG2 = parcelRequire("OxKG2");
Object.defineProperty(module.exports, "promiseWithResolvers", {
    enumerable: true,
    get: function() {
        return $OxKG2.promiseWithResolvers;
    }
});

var $gws33 = parcelRequire("gws33");
Object.defineProperty(module.exports, "padLeft", {
    enumerable: true,
    get: function() {
        return $gws33.padLeft;
    }
});

var $fDgYh = parcelRequire("fDgYh");
Object.defineProperty(module.exports, "splitWithLimit", {
    enumerable: true,
    get: function() {
        return $fDgYh.splitWithLimit;
    }
});

var $PZjUM = parcelRequire("PZjUM");
Object.defineProperty(module.exports, "utf8Length", {
    enumerable: true,
    get: function() {
        return $PZjUM.utf8Length;
    }
});
Object.defineProperty(module.exports, "utf8Substring", {
    enumerable: true,
    get: function() {
        return $PZjUM.utf8Substring;
    }
});

});
parcelRegister("loJYf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Enumerable = void 0;
/* eslint-disable @typescript-eslint/naming-convention */ function $f93f7fafd4912e96$var$Enumerable(enumerable) {
    if (enumerable === void 0) enumerable = true;
    return function(target, key) {
        // first property defined in prototype, that's why we use getters/setters
        // (otherwise assignment in object will override property in prototype)
        Object.defineProperty(target, key, {
            get: function() {
                return;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set: function(val) {
                // here we have a reference to the instance and can set property directly to it
                Object.defineProperty(this, key, {
                    value: val,
                    writable: true,
                    enumerable: enumerable
                });
            },
            enumerable: enumerable
        });
    };
}
module.exports.Enumerable = $f93f7fafd4912e96$var$Enumerable;

});

parcelRegister("57dxb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flatten = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $3b981ad455ce88cd$var$flatten(arr) {
    var _a;
    return (_a = []).concat.apply(_a, $ceFTv.__spreadArray([], $ceFTv.__read(arr), false));
}
module.exports.flatten = $3b981ad455ce88cd$var$flatten;

});

parcelRegister("hFyPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.immutableSplice = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $cdd1486bc55abc17$var$immutableSplice(arr, start, deleteCount) {
    var addItems = [];
    for(var _i = 3; _i < arguments.length; _i++)addItems[_i - 3] = arguments[_i];
    return $ceFTv.__spreadArray($ceFTv.__spreadArray($ceFTv.__spreadArray([], $ceFTv.__read(arr.slice(0, start)), false), $ceFTv.__read(addItems), false), $ceFTv.__read(arr.slice(start + deleteCount)), false);
}
module.exports.immutableSplice = $cdd1486bc55abc17$var$immutableSplice;

});

parcelRegister("46wpN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.partitionedFlatMap = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $2fd0dde8448949e4$var$partitionedFlatMap(arr, keyMapper, valueMapper) {
    var e_1, _a, _b;
    var result = {};
    try {
        for(var arr_1 = $ceFTv.__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var entry = arr_1_1.value;
            var key = keyMapper(entry);
            var values = valueMapper(entry);
            if (!Array.isArray(values)) values = [
                values
            ];
            if (Object.prototype.hasOwnProperty.call(result, key)) (_b = result[key]).push.apply(_b, $ceFTv.__spreadArray([], $ceFTv.__read(values), false));
            else result[key] = values;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
module.exports.partitionedFlatMap = $2fd0dde8448949e4$var$partitionedFlatMap;

});

parcelRegister("iqRWE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveConfigValueSync = module.exports.resolveConfigValue = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $d6b480093d2b4291$var$resolveConfigValue(value) {
    return $ceFTv.__awaiter(this, void 0, void 0, function() {
        return $ceFTv.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(typeof value === 'function')) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value()
                    ];
                case 1:
                    // eslint-disable-next-line @typescript-eslint/ban-types
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        value
                    ];
            }
        });
    });
}
module.exports.resolveConfigValue = $d6b480093d2b4291$var$resolveConfigValue;
function $d6b480093d2b4291$var$resolveConfigValueSync(value) {
    if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/ban-types
    return value();
    return value;
}
module.exports.resolveConfigValueSync = $d6b480093d2b4291$var$resolveConfigValueSync;

});

parcelRegister("acMGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deprecateClass = void 0;

var $ceFTv = parcelRequire("ceFTv");
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/naming-convention
function $76e0cb71946a6113$var$deprecateClass(Base, msg) {
    var deprecateNoticeShown = false;
    return /** @class */ function(_super) {
        $ceFTv.__extends(class_1, _super);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function class_1() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!deprecateNoticeShown) {
                // eslint-disable-next-line no-console
                console.warn(msg);
                deprecateNoticeShown = true;
            }
            return _super.apply(this, $ceFTv.__spreadArray([], $ceFTv.__read(args), false)) || this;
        }
        return class_1;
    }(Base);
}
module.exports.deprecateClass = $76e0cb71946a6113$var$deprecateClass;

});

parcelRegister("1lau6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.match = module.exports.eq = void 0;
var $0f9fe29fdfa27a59$var$matched = function(x) {
    return {
        otherwise: function() {
            return x;
        },
        on: function() {
            return $0f9fe29fdfa27a59$var$matched(x);
        }
    };
};
var $0f9fe29fdfa27a59$var$match = function(x) {
    return {
        on: function(predicate, fn) {
            return predicate(x) ? $0f9fe29fdfa27a59$var$matched(fn(x)) : $0f9fe29fdfa27a59$var$match(x);
        },
        otherwise: function(fn) {
            return fn(x);
        }
    };
};
module.exports.match = $0f9fe29fdfa27a59$var$match;
var $0f9fe29fdfa27a59$var$eq = function(x) {
    return function(y) {
        return x === y;
    };
};
module.exports.eq = $0f9fe29fdfa27a59$var$eq;
$0f9fe29fdfa27a59$var$match.eq = module.exports.eq;

});

parcelRegister("bPwqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fibWithLimit = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $89cd9dca2596da54$var$fibWithLimit(limit) {
    var current, next;
    var _a;
    return $ceFTv.__generator(this, function(_b) {
        switch(_b.label){
            case 0:
                current = 0;
                next = 1;
                _b.label = 1;
            case 1:
                if (!(current < limit)) return [
                    3 /*break*/ ,
                    3
                ];
                return [
                    4 /*yield*/ ,
                    current
                ];
            case 2:
                _b.sent();
                _a = $ceFTv.__read([
                    next,
                    current + next
                ], 2), current = _a[0], next = _a[1];
                return [
                    3 /*break*/ ,
                    1
                ];
            case 3:
                return [
                    4 /*yield*/ ,
                    limit
                ];
            case 4:
                _b.sent();
                return [
                    3 /*break*/ ,
                    3
                ];
            case 5:
                return [
                    2 /*return*/ 
                ];
        }
    });
}
module.exports.fibWithLimit = $89cd9dca2596da54$var$fibWithLimit;

});

parcelRegister("fIWSg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayToObject = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $b728a2478d72d8c7$var$arrayToObject(arr, fn) {
    return Object.assign.apply(Object, $ceFTv.__spreadArray([
        {}
    ], $ceFTv.__read(arr.map(fn)), false));
}
module.exports.arrayToObject = $b728a2478d72d8c7$var$arrayToObject;

});

parcelRegister("a2SZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.entriesToObject = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $fIWSg = parcelRequire("fIWSg");
function $7504bedc6fa353e4$var$entriesToObject(obj) {
    return (0, $fIWSg.arrayToObject)(obj, function(_a) {
        var _b;
        var _c = $ceFTv.__read(_a, 2), key = _c[0], val = _c[1];
        return _b = {}, _b[key] = val, _b;
    });
}
module.exports.entriesToObject = $7504bedc6fa353e4$var$entriesToObject;

});

parcelRegister("3aqj6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forEachObjectEntry = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $24e6b650e34a8a02$var$forEachObjectEntry(obj, fn) {
    Object.entries(obj).forEach(function(_a) {
        var _b = $ceFTv.__read(_a, 2), key = _b[0], value = _b[1];
        return fn(value, key);
    });
}
module.exports.forEachObjectEntry = $24e6b650e34a8a02$var$forEachObjectEntry;

});

parcelRegister("ch6hQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.groupBy = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $8efbf305f908b63e$var$groupBy(arr, keyFn) {
    var e_1, _a;
    var _b;
    if (typeof keyFn !== 'function') {
        var key_1 = keyFn;
        // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-base-to-string
        keyFn = function(value) {
            return value[key_1].toString();
        };
    }
    var result = {};
    try {
        for(var arr_1 = $ceFTv.__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var item = arr_1_1.value;
            var groupKey = keyFn(item);
            ((_b = result[groupKey]) !== null && _b !== void 0 ? _b : result[groupKey] = []).push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
module.exports.groupBy = $8efbf305f908b63e$var$groupBy;

});

parcelRegister("es8Cn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.indexBy = void 0;

var $fIWSg = parcelRequire("fIWSg");
function $a85a5d92c1ddcd3b$var$indexBy(arr, keyFn) {
    if (typeof keyFn !== 'function') {
        var key_1 = keyFn;
        // eslint-disable-next-line @typescript-eslint/ban-types,@typescript-eslint/no-base-to-string
        keyFn = function(value) {
            return value[key_1].toString();
        };
    }
    return (0, $fIWSg.arrayToObject)(arr, function(val) {
        var _a;
        return _a = {}, _a[keyFn(val)] = val, _a;
    });
}
module.exports.indexBy = $a85a5d92c1ddcd3b$var$indexBy;

});

parcelRegister("jYr0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapObject = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $e8a891b5d6a197fd$var$mapObject(obj, fn) {
    var mapped = Object.entries(obj).map(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    function(_a) {
        var _b;
        var _c = $ceFTv.__read(_a, 2), key = _c[0], value = _c[1];
        return _b = {}, _b[key] = fn(value, key), _b;
    });
    return Object.assign.apply(Object, $ceFTv.__spreadArray([
        {}
    ], $ceFTv.__read(mapped), false));
}
module.exports.mapObject = $e8a891b5d6a197fd$var$mapObject;

});

parcelRegister("h3YVq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.omit = void 0;

var $4YZja = parcelRequire("4YZja");
// eslint-disable-next-line @typescript-eslint/ban-types
function $c6c1f9f3a5cd9783$var$omit(obj, keys) {
    return (0, $4YZja.pick)(obj, Object.keys(obj).filter(function(key) {
        return !keys.includes(key);
    }));
}
module.exports.omit = $c6c1f9f3a5cd9783$var$omit;

});
parcelRegister("4YZja", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pick = void 0;

var $ceFTv = parcelRequire("ceFTv");
// eslint-disable-next-line @typescript-eslint/ban-types
function $3a0c528fca02dda1$var$pick(obj, keys) {
    return Object.assign.apply(Object, $ceFTv.__spreadArray([
        {}
    ], $ceFTv.__read(Object.entries(obj).filter(function(_a) {
        var _b = $ceFTv.__read(_a, 1), key = _b[0];
        return keys.includes(key);
    }).map(function(_a) {
        var _b;
        var _c = $ceFTv.__read(_a, 2), key = _c[0], value = _c[1];
        return _b = {}, _b[key] = value, _b;
    })), false));
}
module.exports.pick = $3a0c528fca02dda1$var$pick;

});


parcelRegister("dxWMo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapOptional = module.exports.mapNullable = module.exports.isNullish = void 0;
function $9dcbf3d3e1172602$var$isNullish(value) {
    return value == null;
}
module.exports.isNullish = $9dcbf3d3e1172602$var$isNullish;
function $9dcbf3d3e1172602$var$mapNullable(value, cb) {
    return $9dcbf3d3e1172602$var$isNullish(value) ? null : cb(value);
}
module.exports.mapNullable = $9dcbf3d3e1172602$var$mapNullable;
function $9dcbf3d3e1172602$var$mapOptional(value, cb) {
    return $9dcbf3d3e1172602$var$isNullish(value) ? undefined : cb(value);
}
module.exports.mapOptional = $9dcbf3d3e1172602$var$mapOptional;

});

parcelRegister("ii7eo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $d50f8467ff51f6a5$var$delay(ms) {
    return $ceFTv.__awaiter(this, void 0, void 0, function() {
        return $ceFTv.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, ms);
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.delay = $d50f8467ff51f6a5$var$delay;

});

parcelRegister("OxKG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promiseWithResolvers = void 0;
function $097eda0aa367a7f7$var$promiseWithResolvers() {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    var resolve;
    // eslint-disable-next-line @typescript-eslint/init-declarations
    var reject;
    var promise = new Promise(function(_resolve, _reject) {
        resolve = _resolve;
        reject = _reject;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
module.exports.promiseWithResolvers = $097eda0aa367a7f7$var$promiseWithResolvers;

});

parcelRegister("gws33", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.padLeft = void 0;
function $c075644c66cb5914$var$padLeft(str, length, padding) {
    if (typeof str === 'number') str = str.toString();
    length = length - str.length;
    if (length <= 0) return str;
    if (padding === undefined) padding = ' ';
    var paddingStr = '';
    do {
        /* eslint-disable no-bitwise */ if ((length & 1) === 1) paddingStr += padding;
        length >>= 1;
        if (length) padding += padding;
    /* eslint-enable no-bitwise */ }while (length);
    return paddingStr + str;
}
module.exports.padLeft = $c075644c66cb5914$var$padLeft;

});

parcelRegister("fDgYh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.splitWithLimit = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $b617a9a823fdb5b7$var$splitWithLimit(str, delim, count) {
    var parts = str.split(delim);
    if (parts.length <= count) return parts;
    return $ceFTv.__spreadArray($ceFTv.__spreadArray([], $ceFTv.__read(parts.slice(0, count - 1)), false), [
        parts.slice(count - 1).join(delim)
    ], false);
}
module.exports.splitWithLimit = $b617a9a823fdb5b7$var$splitWithLimit;

});

parcelRegister("PZjUM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utf8Substring = module.exports.utf8Length = void 0;

var $ceFTv = parcelRequire("ceFTv");
function $09c454735b9a55f4$var$utf8Length(str) {
    return $ceFTv.__spreadArray([], $ceFTv.__read(str), false).length;
}
module.exports.utf8Length = $09c454735b9a55f4$var$utf8Length;
function $09c454735b9a55f4$var$utf8Substring(str, start, end) {
    return $ceFTv.__spreadArray([], $ceFTv.__read(str), false).slice(start, end).join('');
}
module.exports.utf8Substring = $09c454735b9a55f4$var$utf8Substring;

});


parcelRegister("kJ6ve", function(module, exports) {
"use strict";
var $f16d0deef68bea7c$var$_a, $f16d0deef68bea7c$var$_b;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMinLogLevelFromEnv = void 0;

var $f16d0deef68bea7c$var$data = [];
var $f16d0deef68bea7c$var$defaultIndex = $f16d0deef68bea7c$var$data.findIndex(function(_a) {
    var nsParts = _a[0];
    return !nsParts;
});
var $f16d0deef68bea7c$var$defaultLevel = undefined;
if ($f16d0deef68bea7c$var$defaultIndex !== -1) {
    $f16d0deef68bea7c$var$defaultLevel = $f16d0deef68bea7c$var$data[$f16d0deef68bea7c$var$defaultIndex][1];
    $f16d0deef68bea7c$var$data.splice($f16d0deef68bea7c$var$defaultIndex);
}
function $f16d0deef68bea7c$var$isPrefix(value, prefix) {
    return prefix.length <= value.length && prefix.every(function(item, i) {
        return item === value[i];
    });
}
function $f16d0deef68bea7c$var$getMinLogLevelFromEnv(name) {
    var nameSplit = name.split(':');
    for(var _i = 0, data_1 = $f16d0deef68bea7c$var$data; _i < data_1.length; _i++){
        var _a = data_1[_i], nsParts = _a[0], level = _a[1];
        if ($f16d0deef68bea7c$var$isPrefix(nameSplit, nsParts)) return level;
    }
    return $f16d0deef68bea7c$var$defaultLevel;
}
module.exports.getMinLogLevelFromEnv = $f16d0deef68bea7c$var$getMinLogLevelFromEnv;

});



parcelRegister("9z32l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomLoggerWrapper = void 0;

var $bRvJY = parcelRequire("bRvJY");

var $kJ6ve = parcelRequire("kJ6ve");

var $jV6oc = parcelRequire("jV6oc");
var $6f69bcfeb89000e2$var$CustomLoggerWrapper = /** @class */ function() {
    function CustomLoggerWrapper(_a) {
        var name = _a.name, minLevel = _a.minLevel, custom = _a.custom;
        var _b;
        this._minLevel = (_b = (0, $bRvJY.mapOptional)(minLevel, function(lv) {
            return (0, $jV6oc.resolveLogLevel)(lv);
        })) !== null && _b !== void 0 ? _b : (0, $kJ6ve.getMinLogLevelFromEnv)(name);
        this._override = typeof custom === 'function' ? {
            log: custom
        } : custom;
    }
    CustomLoggerWrapper.prototype.log = function(level, message) {
        if (this._shouldLog(level)) this._override.log(level, message);
    };
    CustomLoggerWrapper.prototype.crit = function(message) {
        if (!this._override.crit) this.log($jV6oc.LogLevel.CRITICAL, message);
        else if (this._shouldLog($jV6oc.LogLevel.CRITICAL)) this._override.crit(message);
    };
    CustomLoggerWrapper.prototype.error = function(message) {
        if (!this._override.error) this.log($jV6oc.LogLevel.ERROR, message);
        else if (this._shouldLog($jV6oc.LogLevel.ERROR)) this._override.error(message);
    };
    CustomLoggerWrapper.prototype.warn = function(message) {
        if (!this._override.warn) this.log($jV6oc.LogLevel.WARNING, message);
        else if (this._shouldLog($jV6oc.LogLevel.WARNING)) this._override.warn(message);
    };
    CustomLoggerWrapper.prototype.info = function(message) {
        if (!this._override.info) this.log($jV6oc.LogLevel.INFO, message);
        else if (this._shouldLog($jV6oc.LogLevel.INFO)) this._override.info(message);
    };
    CustomLoggerWrapper.prototype.debug = function(message) {
        if (!this._override.debug) this.log($jV6oc.LogLevel.DEBUG, message);
        else if (this._shouldLog($jV6oc.LogLevel.DEBUG)) this._override.debug(message);
    };
    CustomLoggerWrapper.prototype.trace = function(message) {
        if (!this._override.trace) this.log($jV6oc.LogLevel.TRACE, message);
        else if (this._shouldLog($jV6oc.LogLevel.TRACE)) this._override.trace(message);
    };
    CustomLoggerWrapper.prototype._shouldLog = function(level) {
        return this._minLevel === undefined || this._minLevel >= level;
    };
    return CustomLoggerWrapper;
}();
module.exports.CustomLoggerWrapper = $6f69bcfeb89000e2$var$CustomLoggerWrapper;

});

parcelRegister("3JOLU", function(module, exports) {

var $4Jj9n = parcelRequire("4Jj9n");
"use strict";
var $2b8cf54b5e47251b$var$_a, $2b8cf54b5e47251b$var$_b, $2b8cf54b5e47251b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeLogger = module.exports.LogLevelToBackgroundColor = module.exports.LogLevelToColor = module.exports.LogLevelToEmoji = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $jV6oc = parcelRequire("jV6oc");

var $7edwh = parcelRequire("7edwh");
module.exports.LogLevelToEmoji = ($2b8cf54b5e47251b$var$_a = {}, $2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.CRITICAL] = "\uD83D\uDED1", $2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.ERROR] = "\u274C", // these following two need extra spaces at the end because somehow they consume less space in a terminal than they should...
$2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.WARNING] = "\u26A0\uFE0F ", $2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.INFO] = "\u2139\uFE0F ", $2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.DEBUG] = "\uD83D\uDC1E", $2b8cf54b5e47251b$var$_a[$jV6oc.LogLevel.TRACE] = "\uD83D\uDC3E", $2b8cf54b5e47251b$var$_a);
var $2b8cf54b5e47251b$var$colors = {
    black: 30,
    red: 31,
    green: 32,
    yellow: 33,
    blue: 34,
    magenta: 35,
    cyan: 36,
    white: 37,
    blackBright: 90,
    redBright: 91,
    greenBright: 92,
    yellowBright: 93,
    blueBright: 94,
    magentaBright: 95,
    cyanBright: 96,
    whiteBright: 97
};
var $2b8cf54b5e47251b$var$bgColors = {
    bgBlack: 40,
    bgRed: 41,
    bgGreen: 42,
    bgYellow: 43,
    bgBlue: 44,
    bgMagenta: 45,
    bgCyan: 46,
    bgWhite: 47,
    bgBlackBright: 100,
    bgRedBright: 101,
    bgGreenBright: 102,
    bgYellowBright: 103,
    bgBlueBright: 104,
    bgMagentaBright: 105,
    bgCyanBright: 106,
    bgWhiteBright: 107
};
function $2b8cf54b5e47251b$var$createGenericWrapper(color, ending, inner) {
    return function(str) {
        return "\u001B[".concat(color, "m").concat(inner ? inner(str) : str, "\u001B[").concat(ending, "m");
    };
}
function $2b8cf54b5e47251b$var$createColorWrapper(color) {
    return $2b8cf54b5e47251b$var$createGenericWrapper($2b8cf54b5e47251b$var$colors[color], 39);
}
function $2b8cf54b5e47251b$var$createBgWrapper(color, fgWrapper) {
    return $2b8cf54b5e47251b$var$createGenericWrapper($2b8cf54b5e47251b$var$bgColors[color], 49, fgWrapper);
}
module.exports.LogLevelToColor = ($2b8cf54b5e47251b$var$_b = {}, $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.CRITICAL] = $2b8cf54b5e47251b$var$createColorWrapper('red'), $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.ERROR] = $2b8cf54b5e47251b$var$createColorWrapper('redBright'), $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.WARNING] = $2b8cf54b5e47251b$var$createColorWrapper('yellow'), $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.INFO] = $2b8cf54b5e47251b$var$createColorWrapper('blue'), $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.DEBUG] = $2b8cf54b5e47251b$var$createColorWrapper('magenta'), $2b8cf54b5e47251b$var$_b[$jV6oc.LogLevel.TRACE] = $2b8cf54b5e47251b$var$createGenericWrapper(0, 0), $2b8cf54b5e47251b$var$_b);
module.exports.LogLevelToBackgroundColor = ($2b8cf54b5e47251b$var$_c = {}, $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.CRITICAL] = $2b8cf54b5e47251b$var$createBgWrapper('bgRed', $2b8cf54b5e47251b$var$createColorWrapper('white')), $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.ERROR] = $2b8cf54b5e47251b$var$createBgWrapper('bgRedBright', $2b8cf54b5e47251b$var$createColorWrapper('white')), $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.WARNING] = $2b8cf54b5e47251b$var$createBgWrapper('bgYellow', $2b8cf54b5e47251b$var$createColorWrapper('black')), $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.INFO] = $2b8cf54b5e47251b$var$createBgWrapper('bgBlue', $2b8cf54b5e47251b$var$createColorWrapper('white')), $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.DEBUG] = $2b8cf54b5e47251b$var$createBgWrapper('bgMagenta', $2b8cf54b5e47251b$var$createColorWrapper('black')), $2b8cf54b5e47251b$var$_c[$jV6oc.LogLevel.TRACE] = $2b8cf54b5e47251b$var$createGenericWrapper(7, 27), $2b8cf54b5e47251b$var$_c);
var $2b8cf54b5e47251b$var$NodeLogger = /** @class */ function(_super) {
    $ceFTv.__extends(NodeLogger, _super);
    function NodeLogger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeLogger.prototype.log = function(level, message) {
        var _a, _b, _c;
        if (level > this._minLevel) return;
        var logFn = $jV6oc.LogLevelToConsoleFunction[level];
        var builtMessage = '';
        if (this._timestamps) builtMessage += "[".concat(new Date().toISOString(), "] ");
        if (this._emoji) {
            var emoji = module.exports.LogLevelToEmoji[level];
            builtMessage += "".concat(emoji, " ");
        }
        var useColors = (_c = (_a = this._colors) !== null && _a !== void 0 ? _a : (_b = $4Jj9n.stdout) === null || _b === void 0 ? void 0 : _b.isTTY) !== null && _c !== void 0 ? _c : true;
        if (useColors) builtMessage += "".concat(module.exports.LogLevelToBackgroundColor[level](this._name), " ").concat(module.exports.LogLevelToBackgroundColor[level]($jV6oc.LogLevel[level]), " ").concat(module.exports.LogLevelToColor[level](message));
        else builtMessage += "[".concat(this._name, ":").concat($jV6oc.LogLevel[level].toLowerCase(), "] ").concat(message);
        logFn(builtMessage);
    };
    return NodeLogger;
}($7edwh.BaseLogger);
module.exports.NodeLogger = $2b8cf54b5e47251b$var$NodeLogger;

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});




parcelRegister("2GTfZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimedPassthruRateLimiter = module.exports.TimeBasedRateLimiter = module.exports.ResponseBasedRateLimiter = module.exports.PartitionedTimeBasedRateLimiter = module.exports.PartitionedRateLimiter = module.exports.NullRateLimiter = module.exports.RetryAfterError = module.exports.RateLimitReachedError = module.exports.RateLimiterDestroyedError = void 0;

var $ePjyw = parcelRequire("ePjyw");
Object.defineProperty(module.exports, "RateLimiterDestroyedError", {
    enumerable: true,
    get: function() {
        return $ePjyw.RateLimiterDestroyedError;
    }
});

var $9TnVL = parcelRequire("9TnVL");
Object.defineProperty(module.exports, "RateLimitReachedError", {
    enumerable: true,
    get: function() {
        return $9TnVL.RateLimitReachedError;
    }
});

var $hwf3k = parcelRequire("hwf3k");
Object.defineProperty(module.exports, "RetryAfterError", {
    enumerable: true,
    get: function() {
        return $hwf3k.RetryAfterError;
    }
});

var $jTQ6e = parcelRequire("jTQ6e");
Object.defineProperty(module.exports, "NullRateLimiter", {
    enumerable: true,
    get: function() {
        return $jTQ6e.NullRateLimiter;
    }
});

var $6FQz7 = parcelRequire("6FQz7");
Object.defineProperty(module.exports, "PartitionedRateLimiter", {
    enumerable: true,
    get: function() {
        return $6FQz7.PartitionedRateLimiter;
    }
});

var $kpRWR = parcelRequire("kpRWR");
Object.defineProperty(module.exports, "PartitionedTimeBasedRateLimiter", {
    enumerable: true,
    get: function() {
        return $kpRWR.PartitionedTimeBasedRateLimiter;
    }
});

var $bxkeu = parcelRequire("bxkeu");
Object.defineProperty(module.exports, "ResponseBasedRateLimiter", {
    enumerable: true,
    get: function() {
        return $bxkeu.ResponseBasedRateLimiter;
    }
});

var $aDsbR = parcelRequire("aDsbR");
Object.defineProperty(module.exports, "TimeBasedRateLimiter", {
    enumerable: true,
    get: function() {
        return $aDsbR.TimeBasedRateLimiter;
    }
});

var $kIbSf = parcelRequire("kIbSf");
Object.defineProperty(module.exports, "TimedPassthruRateLimiter", {
    enumerable: true,
    get: function() {
        return $kIbSf.TimedPassthruRateLimiter;
    }
});

});
parcelRegister("ePjyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateLimiterDestroyedError = void 0;

var $eYrj0 = parcelRequire("eYrj0");
class $acb4ff791b2baa8b$var$RateLimiterDestroyedError extends $eYrj0.CustomError {
}
module.exports.RateLimiterDestroyedError = $acb4ff791b2baa8b$var$RateLimiterDestroyedError;

});
parcelRegister("eYrj0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomError = void 0;
/** @private */ class $ae6bd9931806bf42$var$CustomError extends Error {
    constructor(...params){
        var _a;
        // @ts-ignore
        super(...params);
        // restore prototype chain
        Object.setPrototypeOf(this, new.target.prototype);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, new.target.constructor);
    }
    get name() {
        return this.constructor.name;
    }
}
module.exports.CustomError = $ae6bd9931806bf42$var$CustomError;

});


parcelRegister("9TnVL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RateLimitReachedError = void 0;

var $eYrj0 = parcelRequire("eYrj0");
class $733bd0392c74acfb$var$RateLimitReachedError extends $eYrj0.CustomError {
}
module.exports.RateLimitReachedError = $733bd0392c74acfb$var$RateLimitReachedError;

});

parcelRegister("hwf3k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RetryAfterError = void 0;

var $eYrj0 = parcelRequire("eYrj0");
class $cc1119fa2cfb032d$var$RetryAfterError extends $eYrj0.CustomError {
    constructor(after){
        super(`Need to retry after ${after} ms`);
        this._retryAt = Date.now() + after;
    }
    get retryAt() {
        return this._retryAt;
    }
}
module.exports.RetryAfterError = $cc1119fa2cfb032d$var$RetryAfterError;

});

parcelRegister("jTQ6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NullRateLimiter = void 0;
class $e7cb91439596b541$var$NullRateLimiter {
    constructor(_callback){
        this._callback = _callback;
    }
    async request(req) {
        return await this._callback(req);
    }
    clear() {
    // noop
    }
    pause() {
    // noop
    }
    resume() {
    // noop
    }
}
module.exports.NullRateLimiter = $e7cb91439596b541$var$NullRateLimiter;

});

parcelRegister("6FQz7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionedRateLimiter = void 0;

var $bxkeu = parcelRequire("bxkeu");
class $4dbf58d369e07c54$var$PartitionedRateLimiter {
    constructor(options){
        this._children = new Map();
        this._paused = false;
        this._partitionKeyCallback = options.getPartitionKey;
        this._createChildCallback = options.createChild;
    }
    async request(req, options) {
        const partitionKey = this._partitionKeyCallback(req);
        const partitionChild = this._getChild(partitionKey);
        return await partitionChild.request(req, options);
    }
    clear() {
        for (const child of this._children.values())child.clear();
    }
    pause() {
        this._paused = true;
        for (const child of this._children.values())child.pause();
    }
    resume() {
        this._paused = false;
        for (const child of this._children.values())child.resume();
    }
    getChildStats(partitionKey) {
        if (!this._children.has(partitionKey)) return null;
        const child = this._children.get(partitionKey);
        if (!(child instanceof $bxkeu.ResponseBasedRateLimiter)) return null;
        return child.stats;
    }
    _getChild(partitionKey) {
        if (this._children.has(partitionKey)) return this._children.get(partitionKey);
        const result = this._createChildCallback(partitionKey);
        if (this._paused) result.pause();
        this._children.set(partitionKey, result);
        return result;
    }
}
module.exports.PartitionedRateLimiter = $4dbf58d369e07c54$var$PartitionedRateLimiter;

});
parcelRegister("bxkeu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponseBasedRateLimiter = void 0;

var $i34dA = parcelRequire("i34dA");

var $bRvJY = parcelRequire("bRvJY");

var $9TnVL = parcelRequire("9TnVL");

var $hwf3k = parcelRequire("hwf3k");
class $86627890ad62db1f$var$ResponseBasedRateLimiter {
    constructor({ logger: logger }){
        this._queue = [];
        this._batchRunning = false;
        this._paused = false;
        this._logger = (0, $i34dA.createLogger)({
            name: 'rate-limiter',
            emoji: true,
            ...logger
        });
    }
    async request(req, options) {
        this._logger.trace('request start');
        return await new Promise((resolve, reject)=>{
            var _a;
            const reqSpec = {
                req: req,
                resolve: resolve,
                reject: reject,
                limitReachedBehavior: (_a = options === null || options === void 0 ? void 0 : options.limitReachedBehavior) !== null && _a !== void 0 ? _a : 'enqueue'
            };
            if (this._batchRunning || !!this._nextBatchTimer || this._paused) {
                this._logger.trace(`request queued batchRunning:${this._batchRunning.toString()} hasNextBatchTimer:${(!!this._nextBatchTimer).toString()} paused:${this._paused.toString()}`);
                this._queue.push(reqSpec);
            } else this._runRequestBatch([
                reqSpec
            ]);
        });
    }
    clear() {
        this._queue = [];
    }
    pause() {
        this._paused = true;
    }
    resume() {
        this._paused = false;
        this._runNextBatch();
    }
    get stats() {
        var _a, _b, _c, _d, _e;
        return {
            lastKnownLimit: (_b = (_a = this._parameters) === null || _a === void 0 ? void 0 : _a.limit) !== null && _b !== void 0 ? _b : null,
            lastKnownRemainingRequests: (_d = (_c = this._parameters) === null || _c === void 0 ? void 0 : _c.remaining) !== null && _d !== void 0 ? _d : null,
            lastKnownResetDate: (0, $bRvJY.mapNullable)((_e = this._parameters) === null || _e === void 0 ? void 0 : _e.resetsAt, (v)=>new Date(v))
        };
    }
    async _runRequestBatch(reqSpecs) {
        this._logger.trace(`runRequestBatch start specs:${reqSpecs.length}`);
        this._batchRunning = true;
        if (this._parameters) this._logger.debug(`Remaining requests: ${this._parameters.remaining}`);
        this._logger.debug(`Doing ${reqSpecs.length} requests, new queue length is ${this._queue.length}`);
        const promises = reqSpecs.map(async (reqSpec)=>{
            const { req: req, resolve: resolve, reject: reject } = reqSpec;
            try {
                const result = await this.doRequest(req);
                const retry = this.needsToRetryAfter(result);
                if (retry !== null) {
                    this._queue.unshift(reqSpec);
                    this._logger.info(`Retrying after ${retry} ms`);
                    throw new $hwf3k.RetryAfterError(retry);
                }
                const params = this.getParametersFromResponse(result);
                resolve(result);
                return params;
            } catch (e) {
                if (e instanceof $hwf3k.RetryAfterError) throw e;
                reject(e);
                return undefined;
            }
        });
        // downleveling problem hack, see https://github.com/es-shims/Promise.allSettled/issues/5
        const settledPromises = await Promise.allSettled(promises);
        const rejectedPromises = settledPromises.filter((p)=>p.status === 'rejected');
        const now = Date.now();
        if (rejectedPromises.length) {
            this._logger.trace('runRequestBatch some rejected');
            const retryAt = Math.max(now, ...rejectedPromises.map((p)=>p.reason.retryAt));
            const retryAfter = retryAt - now;
            this._logger.warn(`Waiting for ${retryAfter} ms because the rate limit was exceeded`);
            this._nextBatchTimer = setTimeout(()=>{
                this._parameters = undefined;
                this._runNextBatch();
            }, retryAfter);
        } else {
            this._logger.trace('runRequestBatch none rejected');
            const params = settledPromises.filter((p)=>p.status === 'fulfilled' && p.value !== undefined).map((p)=>p.value).reduce((carry, v)=>{
                if (!carry) return v;
                // return v.resetsAt > carry.resetsAt ? v : carry;
                return v.remaining < carry.remaining ? v : carry;
            }, undefined);
            this._batchRunning = false;
            if (params) {
                this._parameters = params;
                if (params.resetsAt < now || params.remaining > 0) {
                    this._logger.trace('runRequestBatch canRunMore');
                    this._runNextBatch();
                } else {
                    const delay = params.resetsAt - now;
                    this._logger.trace(`runRequestBatch delay:${delay}`);
                    this._logger.warn(`Waiting for ${delay} ms because the rate limit was reached`);
                    this._queue = this._queue.filter((entry)=>{
                        switch(entry.limitReachedBehavior){
                            case 'enqueue':
                                return true;
                            case 'null':
                                entry.resolve(null);
                                return false;
                            case 'throw':
                                entry.reject(new $9TnVL.RateLimitReachedError('Request removed from queue because the rate limit was reached'));
                                return false;
                            default:
                                throw new Error('this should never happen');
                        }
                    });
                    this._nextBatchTimer = setTimeout(()=>{
                        this._parameters = undefined;
                        this._runNextBatch();
                    }, delay);
                }
            }
        }
        this._logger.trace('runRequestBatch end');
    }
    _runNextBatch() {
        if (this._paused) return;
        this._logger.trace('runNextBatch start');
        if (this._nextBatchTimer) {
            clearTimeout(this._nextBatchTimer);
            this._nextBatchTimer = undefined;
        }
        const amount = this._parameters ? Math.min(this._parameters.remaining, this._parameters.limit / 10) : 1;
        const reqSpecs = this._queue.splice(0, amount);
        if (reqSpecs.length) this._runRequestBatch(reqSpecs);
        this._logger.trace('runNextBatch end');
    }
}
module.exports.ResponseBasedRateLimiter = $86627890ad62db1f$var$ResponseBasedRateLimiter;

});


parcelRegister("kpRWR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionedTimeBasedRateLimiter = void 0;

var $i34dA = parcelRequire("i34dA");

var $9TnVL = parcelRequire("9TnVL");

var $ePjyw = parcelRequire("ePjyw");
class $edcffd753ceead26$var$PartitionedTimeBasedRateLimiter {
    constructor({ logger: logger, bucketSize: bucketSize, timeFrame: timeFrame, doRequest: doRequest, getPartitionKey: getPartitionKey }){
        this._partitionedQueue = new Map();
        this._usedFromBucket = new Map();
        this._counterTimers = new Set();
        this._paused = false;
        this._destroyed = false;
        this._logger = (0, $i34dA.createLogger)({
            name: 'rate-limiter',
            emoji: true,
            ...logger
        });
        this._bucketSize = bucketSize;
        this._timeFrame = timeFrame;
        this._callback = doRequest;
        this._partitionKeyCallback = getPartitionKey;
    }
    async request(req, options) {
        return await new Promise((resolve, reject)=>{
            var _a, _b;
            if (this._destroyed) {
                reject(new $ePjyw.RateLimiterDestroyedError('Rate limiter was destroyed'));
                return;
            }
            const reqSpec = {
                req: req,
                resolve: resolve,
                reject: reject,
                limitReachedBehavior: (_a = options === null || options === void 0 ? void 0 : options.limitReachedBehavior) !== null && _a !== void 0 ? _a : 'enqueue'
            };
            const partitionKey = this._partitionKeyCallback(req);
            const usedFromBucket = (_b = this._usedFromBucket.get(partitionKey)) !== null && _b !== void 0 ? _b : 0;
            if (usedFromBucket >= this._bucketSize || this._paused) switch(reqSpec.limitReachedBehavior){
                case 'enqueue':
                    {
                        const queue = this._getPartitionedQueue(partitionKey);
                        queue.push(reqSpec);
                        if (usedFromBucket + queue.length >= this._bucketSize) this._logger.warn(`Rate limit of ${this._bucketSize} for ${partitionKey ? `partition ${partitionKey}` : 'default partition'} was reached, waiting for ${this._paused ? 'the limiter to be unpaused' : 'a free bucket entry'}; queue size is ${queue.length}`);
                        else this._logger.info(`Enqueueing request for ${partitionKey ? `partition ${partitionKey}` : 'default partition'} because the rate limiter is paused; queue size is ${queue.length}`);
                        break;
                    }
                case 'null':
                    reqSpec.resolve(null);
                    if (this._paused) this._logger.info(`Returning null for request for ${partitionKey ? `partition ${partitionKey}` : 'default partition'} because the rate limiter is paused`);
                    else this._logger.warn(`Rate limit of ${this._bucketSize} for ${partitionKey ? `partition ${partitionKey}` : 'default partition'} was reached, dropping request and returning null`);
                    break;
                case 'throw':
                    reqSpec.reject(new $9TnVL.RateLimitReachedError(`Request dropped because ${this._paused ? 'the rate limiter is paused' : `the rate limit for ${partitionKey ? `partition ${partitionKey}` : 'default partition'} was reached`}`));
                    break;
                default:
                    throw new Error('this should never happen');
            }
            else this._runRequest(reqSpec, partitionKey);
        });
    }
    clear() {
        this._partitionedQueue.clear();
    }
    pause() {
        this._paused = true;
    }
    resume() {
        this._paused = false;
        for (const partitionKey of this._partitionedQueue.keys())this._runNextRequest(partitionKey);
    }
    destroy() {
        this._paused = false;
        this._destroyed = true;
        this._counterTimers.forEach((timer)=>{
            clearTimeout(timer);
        });
        for (const queue of this._partitionedQueue.values())for (const req of queue)req.reject(new $ePjyw.RateLimiterDestroyedError('Rate limiter was destroyed'));
        this._partitionedQueue.clear();
    }
    _getPartitionedQueue(partitionKey) {
        if (this._partitionedQueue.has(partitionKey)) return this._partitionedQueue.get(partitionKey);
        const newQueue = [];
        this._partitionedQueue.set(partitionKey, newQueue);
        return newQueue;
    }
    async _runRequest(reqSpec, partitionKey) {
        var _a;
        const queue = this._getPartitionedQueue(partitionKey);
        this._logger.debug(`doing a request for ${partitionKey ? `partition ${partitionKey}` : 'default partition'}, new queue length is ${queue.length}`);
        this._usedFromBucket.set(partitionKey, ((_a = this._usedFromBucket.get(partitionKey)) !== null && _a !== void 0 ? _a : 0) + 1);
        const { req: req, resolve: resolve, reject: reject } = reqSpec;
        try {
            resolve(await this._callback(req));
        } catch (e) {
            reject(e);
        } finally{
            const counterTimer = setTimeout(()=>{
                this._counterTimers.delete(counterTimer);
                const newUsed = this._usedFromBucket.get(partitionKey) - 1;
                this._usedFromBucket.set(partitionKey, newUsed);
                if (queue.length && newUsed < this._bucketSize) this._runNextRequest(partitionKey);
            }, this._timeFrame);
            this._counterTimers.add(counterTimer);
        }
    }
    _runNextRequest(partitionKey) {
        if (this._paused) return;
        const queue = this._getPartitionedQueue(partitionKey);
        const reqSpec = queue.shift();
        if (reqSpec) this._runRequest(reqSpec, partitionKey);
    }
}
module.exports.PartitionedTimeBasedRateLimiter = $edcffd753ceead26$var$PartitionedTimeBasedRateLimiter;

});

parcelRegister("aDsbR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeBasedRateLimiter = void 0;

var $i34dA = parcelRequire("i34dA");

var $9TnVL = parcelRequire("9TnVL");

var $ePjyw = parcelRequire("ePjyw");
class $7be369e677992ae2$var$TimeBasedRateLimiter {
    constructor({ logger: logger, bucketSize: bucketSize, timeFrame: timeFrame, doRequest: doRequest }){
        this._queue = [];
        this._usedFromBucket = 0;
        this._counterTimers = new Set();
        this._paused = false;
        this._destroyed = false;
        this._logger = (0, $i34dA.createLogger)({
            name: 'rate-limiter',
            emoji: true,
            ...logger
        });
        this._bucketSize = bucketSize;
        this._timeFrame = timeFrame;
        this._callback = doRequest;
    }
    async request(req, options) {
        return await new Promise((resolve, reject)=>{
            var _a;
            if (this._destroyed) {
                reject(new $ePjyw.RateLimiterDestroyedError('Rate limiter was destroyed'));
                return;
            }
            const reqSpec = {
                req: req,
                resolve: resolve,
                reject: reject,
                limitReachedBehavior: (_a = options === null || options === void 0 ? void 0 : options.limitReachedBehavior) !== null && _a !== void 0 ? _a : 'enqueue'
            };
            if (this._usedFromBucket >= this._bucketSize || this._paused) switch(reqSpec.limitReachedBehavior){
                case 'enqueue':
                    this._queue.push(reqSpec);
                    if (this._usedFromBucket + this._queue.length >= this._bucketSize) this._logger.warn(`Rate limit of ${this._bucketSize} was reached, waiting for ${this._paused ? 'the limiter to be unpaused' : 'a free bucket entry'}; queue size is ${this._queue.length}`);
                    else this._logger.info(`Enqueueing request because the rate limiter is paused; queue size is ${this._queue.length}`);
                    break;
                case 'null':
                    reqSpec.resolve(null);
                    this._logger.warn(`Rate limit of ${this._bucketSize} was reached, dropping request and returning null`);
                    if (this._paused) this._logger.info('Returning null for request because the rate limiter is paused');
                    else this._logger.warn(`Rate limit of ${this._bucketSize} was reached, dropping request and returning null`);
                    break;
                case 'throw':
                    reqSpec.reject(new $9TnVL.RateLimitReachedError(`Request dropped because ${this._paused ? 'the rate limiter is paused' : 'the rate limit was reached'}`));
                    break;
                default:
                    throw new Error('this should never happen');
            }
            else this._runRequest(reqSpec);
        });
    }
    clear() {
        this._queue = [];
    }
    pause() {
        this._paused = true;
    }
    resume() {
        this._paused = false;
        this._runNextRequest();
    }
    destroy() {
        this._paused = false;
        this._destroyed = true;
        this._counterTimers.forEach((timer)=>{
            clearTimeout(timer);
        });
        for (const req of this._queue)req.reject(new $ePjyw.RateLimiterDestroyedError('Rate limiter was destroyed'));
        this._queue = [];
    }
    async _runRequest(reqSpec) {
        this._logger.debug(`doing a request, new queue length is ${this._queue.length}`);
        this._usedFromBucket += 1;
        const { req: req, resolve: resolve, reject: reject } = reqSpec;
        try {
            resolve(await this._callback(req));
        } catch (e) {
            reject(e);
        } finally{
            const counterTimer = setTimeout(()=>{
                this._counterTimers.delete(counterTimer);
                this._usedFromBucket -= 1;
                if (this._queue.length && this._usedFromBucket < this._bucketSize) this._runNextRequest();
            }, this._timeFrame);
            this._counterTimers.add(counterTimer);
        }
    }
    _runNextRequest() {
        if (this._paused) return;
        const reqSpec = this._queue.shift();
        if (reqSpec) this._runRequest(reqSpec);
    }
}
module.exports.TimeBasedRateLimiter = $7be369e677992ae2$var$TimeBasedRateLimiter;

});

parcelRegister("kIbSf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimedPassthruRateLimiter = void 0;

var $aDsbR = parcelRequire("aDsbR");
class $f14120a7fb991bb4$var$TimedPassthruRateLimiter extends $aDsbR.TimeBasedRateLimiter {
    constructor(child, config){
        super({
            ...config,
            async doRequest (req, options) {
                return await child.request(req, options);
            }
        });
    }
}
module.exports.TimedPassthruRateLimiter = $f14120a7fb991bb4$var$TimedPassthruRateLimiter;

});


parcelRegister("4ojlB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpStatusCodeError = module.exports.transformTwitchApiResponse = module.exports.handleTwitchApiResponseError = module.exports.createBroadcasterQuery = module.exports.callTwitchApiRaw = module.exports.callTwitchApi = void 0;

var $67UX1 = parcelRequire("67UX1");
Object.defineProperty(module.exports, "callTwitchApi", {
    enumerable: true,
    get: function() {
        return $67UX1.callTwitchApi;
    }
});
Object.defineProperty(module.exports, "callTwitchApiRaw", {
    enumerable: true,
    get: function() {
        return $67UX1.callTwitchApiRaw;
    }
});

var $bsVlE = parcelRequire("bsVlE");
Object.defineProperty(module.exports, "createBroadcasterQuery", {
    enumerable: true,
    get: function() {
        return $bsVlE.createBroadcasterQuery;
    }
});

var $6efZG = parcelRequire("6efZG");
Object.defineProperty(module.exports, "handleTwitchApiResponseError", {
    enumerable: true,
    get: function() {
        return $6efZG.handleTwitchApiResponseError;
    }
});
Object.defineProperty(module.exports, "transformTwitchApiResponse", {
    enumerable: true,
    get: function() {
        return $6efZG.transformTwitchApiResponse;
    }
});

var $aBHck = parcelRequire("aBHck");
Object.defineProperty(module.exports, "HttpStatusCodeError", {
    enumerable: true,
    get: function() {
        return $aBHck.HttpStatusCodeError;
    }
});

});
parcelRegister("67UX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callTwitchApi = module.exports.callTwitchApiRaw = void 0;

var $6CysC = parcelRequire("6CysC");

var $bI2xj = parcelRequire("bI2xj");

var $6efZG = parcelRequire("6efZG");

var $hXSJn = parcelRequire("hXSJn");
/**
 * Makes a call to the Twitch API using the given credentials, returning the raw Response object.
 *
 * @param options The configuration of the call.
 * @param clientId The client ID of your application.
 * @param accessToken The access token to call the API with.
 *
 * You need to obtain one using one of the [Twitch OAuth flows](https://dev.twitch.tv/docs/authentication/getting-tokens-oauth/).
 * @param authorizationType The type of Authorization header to send.
 *
 * Defaults to "Bearer" for Helix and "OAuth" for everything else.
 * @param fetchOptions Additional options to be passed to the `fetch` function.
 * @param mockServerPort
 */ async function $475f92cb9de1065c$var$callTwitchApiRaw(options, clientId, accessToken, authorizationType, fetchOptions = {}, mockServerPort) {
    var _a, _b;
    const type = (_a = options.type) !== null && _a !== void 0 ? _a : 'helix';
    const url = (0, $hXSJn.getTwitchApiUrl)(options.url, type, mockServerPort);
    const params = (0, $bI2xj.stringify)(options.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: true
    });
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const headers = new $6CysC.Headers({
        Accept: 'application/json'
    });
    let body = undefined;
    if (options.jsonBody) {
        body = JSON.stringify(options.jsonBody);
        headers.append('Content-Type', 'application/json');
    }
    if (clientId && type !== 'auth') headers.append('Client-ID', clientId);
    if (accessToken) headers.append('Authorization', `${type === 'helix' ? authorizationType !== null && authorizationType !== void 0 ? authorizationType : 'Bearer' : 'OAuth'} ${accessToken}`);
    const requestOptions = {
        ...fetchOptions,
        method: (_b = options.method) !== null && _b !== void 0 ? _b : 'GET',
        headers: headers,
        body: body
    };
    return await (0, $6CysC.default)(`${url}${params}`, requestOptions);
}
module.exports.callTwitchApiRaw = $475f92cb9de1065c$var$callTwitchApiRaw;
/**
 * Makes a call to the Twitch API using given credentials.
 *
 * @param options The configuration of the call.
 * @param clientId The client ID of your application.
 * @param accessToken The access token to call the API with.
 *
 * You need to obtain one using one of the [Twitch OAuth flows](https://dev.twitch.tv/docs/authentication/getting-tokens-oauth/).
 * @param authorizationType The type of Authorization header to send.
 *
 * Defaults to "Bearer" for Helix and "OAuth" for everything else.
 * @param fetchOptions Additional options to be passed to the `fetch` function.
 */ async function $475f92cb9de1065c$var$callTwitchApi(options, clientId, accessToken, authorizationType, fetchOptions = {}) {
    const response = await $475f92cb9de1065c$var$callTwitchApiRaw(options, clientId, accessToken, authorizationType, fetchOptions);
    await (0, $6efZG.handleTwitchApiResponseError)(response, options);
    return await (0, $6efZG.transformTwitchApiResponse)(response);
}
module.exports.callTwitchApi = $475f92cb9de1065c$var$callTwitchApi;

});
parcelRegister("6CysC", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("bI2xj", function(module, exports) {
'use strict';

var $9Swsl = parcelRequire("9Swsl");

var $ldsRu = parcelRequire("ldsRu");

var $iHtoe = parcelRequire("iHtoe");
module.exports = {
    formats: $iHtoe,
    parse: $ldsRu,
    stringify: $9Swsl
};

});
parcelRegister("9Swsl", function(module, exports) {
'use strict';

var $61U64 = parcelRequire("61U64");

var $iHtoe = parcelRequire("iHtoe");
var $73125557100d9911$var$has = Object.prototype.hasOwnProperty;
var $73125557100d9911$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $73125557100d9911$var$isArray = Array.isArray;
var $73125557100d9911$var$push = Array.prototype.push;
var $73125557100d9911$var$pushToArray = function(arr, valueOrArray) {
    $73125557100d9911$var$push.apply(arr, $73125557100d9911$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $73125557100d9911$var$toISO = Date.prototype.toISOString;
var $73125557100d9911$var$defaultFormat = $iHtoe.default;
var $73125557100d9911$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $61U64.encode,
    encodeValuesOnly: false,
    format: $73125557100d9911$var$defaultFormat,
    formatter: $iHtoe.formatters[$73125557100d9911$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $73125557100d9911$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $73125557100d9911$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $73125557100d9911$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $73125557100d9911$var$isArray(obj)) obj = obj.join(',');
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $73125557100d9911$var$defaults.encoder, charset, 'key') : prefix;
        obj = '';
    }
    if ($73125557100d9911$var$isNonNullishPrimitive(obj) || $61U64.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $73125557100d9911$var$defaults.encoder, charset, 'key');
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $73125557100d9911$var$defaults.encoder, charset, 'value'))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if ($73125557100d9911$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        if ($73125557100d9911$var$isArray(obj)) $73125557100d9911$var$pushToArray(values, stringify(obj[key], typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
        else $73125557100d9911$var$pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $73125557100d9911$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $73125557100d9911$var$defaults;
    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $73125557100d9911$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $iHtoe.default;
    if (typeof opts.format !== 'undefined') {
        if (!$73125557100d9911$var$has.call($iHtoe.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $iHtoe.formatters[format];
    var filter = $73125557100d9911$var$defaults.filter;
    if (typeof opts.filter === 'function' || $73125557100d9911$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $73125557100d9911$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $73125557100d9911$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $73125557100d9911$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $73125557100d9911$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $73125557100d9911$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $73125557100d9911$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $73125557100d9911$var$defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $73125557100d9911$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $73125557100d9911$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $73125557100d9911$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $73125557100d9911$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($73125557100d9911$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $73125557100d9911$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $73125557100d9911$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $73125557100d9911$var$pushToArray(keys, $73125557100d9911$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("61U64", function(module, exports) {
'use strict';
var $463e59c37044706f$var$has = Object.prototype.hasOwnProperty;
var $463e59c37044706f$var$isArray = Array.isArray;
var $463e59c37044706f$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $463e59c37044706f$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($463e59c37044706f$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $463e59c37044706f$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $463e59c37044706f$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object') {
        if ($463e59c37044706f$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$463e59c37044706f$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($463e59c37044706f$var$isArray(target) && !$463e59c37044706f$var$isArray(source)) mergeTarget = $463e59c37044706f$var$arrayToObject(target, options);
    if ($463e59c37044706f$var$isArray(target) && $463e59c37044706f$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($463e59c37044706f$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($463e59c37044706f$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $463e59c37044706f$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $463e59c37044706f$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $463e59c37044706f$var$encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $463e59c37044706f$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($463e59c37044706f$var$hexTable[0xC0 | c >> 6] + $463e59c37044706f$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($463e59c37044706f$var$hexTable[0xE0 | c >> 12] + $463e59c37044706f$var$hexTable[0x80 | c >> 6 & 0x3F] + $463e59c37044706f$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        out += $463e59c37044706f$var$hexTable[0xF0 | c >> 18] + $463e59c37044706f$var$hexTable[0x80 | c >> 12 & 0x3F] + $463e59c37044706f$var$hexTable[0x80 | c >> 6 & 0x3F] + $463e59c37044706f$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $463e59c37044706f$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $463e59c37044706f$var$compactQueue(queue);
    return value;
};
var $463e59c37044706f$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $463e59c37044706f$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $463e59c37044706f$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
module.exports = {
    arrayToObject: $463e59c37044706f$var$arrayToObject,
    assign: $463e59c37044706f$var$assign,
    combine: $463e59c37044706f$var$combine,
    compact: $463e59c37044706f$var$compact,
    decode: $463e59c37044706f$var$decode,
    encode: $463e59c37044706f$var$encode,
    isBuffer: $463e59c37044706f$var$isBuffer,
    isRegExp: $463e59c37044706f$var$isRegExp,
    merge: $463e59c37044706f$var$merge
};

});

parcelRegister("iHtoe", function(module, exports) {
'use strict';
var $03836764923de44f$var$replace = String.prototype.replace;
var $03836764923de44f$var$percentTwenties = /%20/g;

var $61U64 = parcelRequire("61U64");
var $03836764923de44f$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = $61U64.assign({
    'default': $03836764923de44f$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $03836764923de44f$var$replace.call(value, $03836764923de44f$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    }
}, $03836764923de44f$var$Format);

});


parcelRegister("ldsRu", function(module, exports) {
'use strict';

var $61U64 = parcelRequire("61U64");
var $f7213336b402d29a$var$has = Object.prototype.hasOwnProperty;
var $f7213336b402d29a$var$isArray = Array.isArray;
var $f7213336b402d29a$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $61U64.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $f7213336b402d29a$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $f7213336b402d29a$var$parseArrayValue = function(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
var $f7213336b402d29a$var$maybeMap = function maybeMap(val, fn) {
    if ($f7213336b402d29a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $f7213336b402d29a$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $f7213336b402d29a$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $f7213336b402d29a$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $f7213336b402d29a$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $f7213336b402d29a$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $f7213336b402d29a$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $f7213336b402d29a$var$defaults.decoder, charset, 'key');
            val = $f7213336b402d29a$var$maybeMap($f7213336b402d29a$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $f7213336b402d29a$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $f7213336b402d29a$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $f7213336b402d29a$var$isArray(val) ? [
            val
        ] : val;
        if ($f7213336b402d29a$var$has.call(obj, key)) obj[key] = $61U64.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $f7213336b402d29a$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $f7213336b402d29a$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else obj[cleanRoot] = leaf;
        }
        leaf = obj; // eslint-disable-line no-param-reassign
    }
    return leaf;
};
var $f7213336b402d29a$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $f7213336b402d29a$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $f7213336b402d29a$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $f7213336b402d29a$var$parseObject(keys, val, options, valuesParsed);
};
var $f7213336b402d29a$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $f7213336b402d29a$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $f7213336b402d29a$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $f7213336b402d29a$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $f7213336b402d29a$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $f7213336b402d29a$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $f7213336b402d29a$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $f7213336b402d29a$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $f7213336b402d29a$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $61U64.isRegExp(opts.delimiter) ? opts.delimiter : $f7213336b402d29a$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $f7213336b402d29a$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $f7213336b402d29a$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $f7213336b402d29a$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $f7213336b402d29a$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $f7213336b402d29a$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $f7213336b402d29a$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $f7213336b402d29a$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $f7213336b402d29a$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $61U64.merge(obj, newObj, options);
    }
    return $61U64.compact(obj);
};

});


parcelRegister("6efZG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transformTwitchApiResponse = module.exports.handleTwitchApiResponseError = void 0;

var $bI2xj = parcelRequire("bI2xj");

var $aBHck = parcelRequire("aBHck");
/** @private */ async function $489074eace25440c$var$handleTwitchApiResponseError(response, options) {
    var _a;
    if (!response.ok) {
        const isJson = response.headers.get('Content-Type') === 'application/json';
        const text = isJson ? JSON.stringify(await response.json(), null, 2) : await response.text();
        const params = (0, $bI2xj.stringify)(options.query, {
            arrayFormat: 'repeat',
            addQueryPrefix: true
        });
        const fullUrl = `${options.url}${params}`;
        throw new $aBHck.HttpStatusCodeError(response.status, response.statusText, fullUrl, (_a = options.method) !== null && _a !== void 0 ? _a : 'GET', text, isJson);
    }
}
module.exports.handleTwitchApiResponseError = $489074eace25440c$var$handleTwitchApiResponseError;
/** @private */ async function $489074eace25440c$var$transformTwitchApiResponse(response) {
    if (response.status === 204) return undefined; // oof
    const text = await response.text();
    if (!text) return undefined; // mega oof - Twitch doesn't return a response when it should
    return JSON.parse(text);
}
module.exports.transformTwitchApiResponse = $489074eace25440c$var$transformTwitchApiResponse;

});
parcelRegister("aBHck", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpStatusCodeError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever a HTTP error occurs. Some HTTP errors are handled in the library when they're expected.
 */ class $7b8ede4aa9cd9ccc$var$HttpStatusCodeError extends $j0DIQ.CustomError {
    /** @private */ constructor(_statusCode, statusText, _url, _method, _body, isJson){
        super(`Encountered HTTP status code ${_statusCode}: ${statusText}\n\nURL: ${_url}\nMethod: ${_method}\nBody:\n${!isJson && _body.length > 150 ? `${_body.slice(0, 147)}...` : _body}`);
        this._statusCode = _statusCode;
        this._url = _url;
        this._method = _method;
        this._body = _body;
    }
    /**
     * The HTTP status code of the error.
     */ get statusCode() {
        return this._statusCode;
    }
    /**
     * The URL that was requested.
     */ get url() {
        return this._url;
    }
    /**
     * The HTTP method that was used for the request.
     */ get method() {
        return this._method;
    }
    /**
     * The body that was used for the request, as a string.
     */ get body() {
        return this._body;
    }
}
module.exports.HttpStatusCodeError = $7b8ede4aa9cd9ccc$var$HttpStatusCodeError;

});
parcelRegister("j0DIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractUserName = module.exports.extractUserId = module.exports.RelationAssertionError = module.exports.HellFreezesOverError = module.exports.CustomError = module.exports.HelixExtension = module.exports.rtfm = module.exports.checkRelationAssertion = module.exports.rawDataSymbol = module.exports.getRawData = module.exports.DataObject = void 0;

var $fXE6t = parcelRequire("fXE6t");
Object.defineProperty(module.exports, "DataObject", {
    enumerable: true,
    get: function() {
        return $fXE6t.DataObject;
    }
});
Object.defineProperty(module.exports, "getRawData", {
    enumerable: true,
    get: function() {
        return $fXE6t.getRawData;
    }
});
Object.defineProperty(module.exports, "rawDataSymbol", {
    enumerable: true,
    get: function() {
        return $fXE6t.rawDataSymbol;
    }
});

var $9pHKe = parcelRequire("9pHKe");
Object.defineProperty(module.exports, "checkRelationAssertion", {
    enumerable: true,
    get: function() {
        return $9pHKe.checkRelationAssertion;
    }
});

var $9pzzB = parcelRequire("9pzzB");
Object.defineProperty(module.exports, "rtfm", {
    enumerable: true,
    get: function() {
        return $9pzzB.rtfm;
    }
});

var $gEOjw = parcelRequire("gEOjw");
Object.defineProperty(module.exports, "HelixExtension", {
    enumerable: true,
    get: function() {
        return $gEOjw.HelixExtension;
    }
});

var $jGDfl = parcelRequire("jGDfl");
Object.defineProperty(module.exports, "CustomError", {
    enumerable: true,
    get: function() {
        return $jGDfl.CustomError;
    }
});

var $39i9X = parcelRequire("39i9X");
Object.defineProperty(module.exports, "HellFreezesOverError", {
    enumerable: true,
    get: function() {
        return $39i9X.HellFreezesOverError;
    }
});

var $5Zq0Z = parcelRequire("5Zq0Z");
Object.defineProperty(module.exports, "RelationAssertionError", {
    enumerable: true,
    get: function() {
        return $5Zq0Z.RelationAssertionError;
    }
});

var $dciYm = parcelRequire("dciYm");
Object.defineProperty(module.exports, "extractUserId", {
    enumerable: true,
    get: function() {
        return $dciYm.extractUserId;
    }
});
Object.defineProperty(module.exports, "extractUserName", {
    enumerable: true,
    get: function() {
        return $dciYm.extractUserName;
    }
});

});
parcelRegister("fXE6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataObject = module.exports.getRawData = module.exports.rawDataSymbol = void 0;

var $4CNyX = parcelRequire("4CNyX");
/** @private */ module.exports.rawDataSymbol = Symbol('twurpleRawData');
/**
 * Gets the raw data of a data object.
 *
 * @param obj The data object to get the raw data of.
 */ function $02ffab3fa530532d$var$getRawData(obj) {
    return (0, $4CNyX.klona)(obj[module.exports.rawDataSymbol]);
}
module.exports.getRawData = $02ffab3fa530532d$var$getRawData;
/** @private */ class $02ffab3fa530532d$var$DataObject {
    /** @private */ constructor(data){
        this[module.exports.rawDataSymbol] = data;
    }
}
module.exports.DataObject = $02ffab3fa530532d$var$DataObject;

});
parcelRegister("4CNyX", function(module, exports) {

$parcel$export(module.exports, "klona", () => $2f8abb8de5be72a4$export$a963eb2bdf550004);
function $2f8abb8de5be72a4$export$a963eb2bdf550004(x) {
    if (typeof x !== 'object') return x;
    var k, tmp, str = Object.prototype.toString.call(x);
    if (str === '[object Object]') {
        if (x.constructor !== Object && typeof x.constructor === 'function') {
            tmp = new x.constructor();
            for(k in x)if (x.hasOwnProperty(k) && tmp[k] !== x[k]) tmp[k] = $2f8abb8de5be72a4$export$a963eb2bdf550004(x[k]);
        } else {
            tmp = {}; // null
            for(k in x)if (k === '__proto__') Object.defineProperty(tmp, k, {
                value: $2f8abb8de5be72a4$export$a963eb2bdf550004(x[k]),
                configurable: true,
                enumerable: true,
                writable: true
            });
            else tmp[k] = $2f8abb8de5be72a4$export$a963eb2bdf550004(x[k]);
        }
        return tmp;
    }
    if (str === '[object Array]') {
        k = x.length;
        for(tmp = Array(k); k--;)tmp[k] = $2f8abb8de5be72a4$export$a963eb2bdf550004(x[k]);
        return tmp;
    }
    if (str === '[object Set]') {
        tmp = new Set;
        x.forEach(function(val) {
            tmp.add($2f8abb8de5be72a4$export$a963eb2bdf550004(val));
        });
        return tmp;
    }
    if (str === '[object Map]') {
        tmp = new Map;
        x.forEach(function(val, key) {
            tmp.set($2f8abb8de5be72a4$export$a963eb2bdf550004(key), $2f8abb8de5be72a4$export$a963eb2bdf550004(val));
        });
        return tmp;
    }
    if (str === '[object Date]') return new Date(+x);
    if (str === '[object RegExp]') {
        tmp = new RegExp(x.source, x.flags);
        tmp.lastIndex = x.lastIndex;
        return tmp;
    }
    if (str === '[object DataView]') return new x.constructor($2f8abb8de5be72a4$export$a963eb2bdf550004(x.buffer));
    if (str === '[object ArrayBuffer]') return x.slice(0);
    // ArrayBuffer.isView(x)
    // ~> `new` bcuz `Buffer.slice` => ref
    if (str.slice(-6) === 'Array]') return new x.constructor(x);
    return x;
}

});


parcelRegister("9pHKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkRelationAssertion = void 0;

var $5Zq0Z = parcelRequire("5Zq0Z");
/** @private */ function $6da861a27ade5eb9$var$checkRelationAssertion(value) {
    if (value == null) throw new $5Zq0Z.RelationAssertionError();
    return value;
}
module.exports.checkRelationAssertion = $6da861a27ade5eb9$var$checkRelationAssertion;

});
parcelRegister("5Zq0Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RelationAssertionError = void 0;

var $jGDfl = parcelRequire("jGDfl");
/**
 * Thrown when a relation that is expected to never be null does return null.
 */ class $45c6d449b938d79f$var$RelationAssertionError extends $jGDfl.CustomError {
    constructor(){
        super('Relation returned null - this may be a library bug or a race condition in your own code');
    }
}
module.exports.RelationAssertionError = $45c6d449b938d79f$var$RelationAssertionError;

});
parcelRegister("jGDfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CustomError = void 0;
/** @private */ class $e550621b2acc682c$var$CustomError extends Error {
    constructor(message, options){
        var _a;
        super(message, options);
        // restore prototype chain
        Object.setPrototypeOf(this, new.target.prototype);
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (_a = Error.captureStackTrace) === null || _a === void 0 || _a.call(Error, this, new.target.constructor);
    }
    get name() {
        return this.constructor.name;
    }
}
module.exports.CustomError = $e550621b2acc682c$var$CustomError;

});



parcelRegister("9pzzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rtfm = void 0;
/** @private */ function $6da20af75cadf271$var$rtfm(pkg, name, idKey) {
    return (clazz)=>{
        const fn = idKey ? function() {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `[${name}#${this[idKey]} - please check https://twurple.js.org/reference/${pkg}/classes/${name}.html for available properties]`;
        } : function() {
            return `[${name} - please check https://twurple.js.org/reference/${pkg}/classes/${name}.html for available properties]`;
        };
        Object.defineProperty(clazz.prototype, Symbol.for('nodejs.util.inspect.custom'), {
            value: fn,
            enumerable: false
        });
    };
}
module.exports.rtfm = $6da20af75cadf271$var$rtfm;

});

parcelRegister("gEOjw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixExtension = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $fXE6t = parcelRequire("fXE6t");

var $9pzzB = parcelRequire("9pzzB");
/**
 * A Twitch Extension.
 */ let $032126db23f73004$var$HelixExtension = class HelixExtension extends $fXE6t.DataObject {
    /**
     * The name of the extension's author.
     */ get authorName() {
        return this[$fXE6t.rawDataSymbol].author_name;
    }
    /**
     * Whether bits are enabled for the extension.
     */ get bitsEnabled() {
        return this[$fXE6t.rawDataSymbol].bits_enabled;
    }
    /**
     * Whether the extension can be installed.
     */ get installable() {
        return this[$fXE6t.rawDataSymbol].can_install;
    }
    /**
     * The location of the extension's configuration.
     */ get configurationLocation() {
        return this[$fXE6t.rawDataSymbol].configuration_location;
    }
    /**
     * The extension's description.
     */ get description() {
        return this[$fXE6t.rawDataSymbol].description;
    }
    /**
     * The URL of the extension's terms of service.
     */ get tosUrl() {
        return this[$fXE6t.rawDataSymbol].eula_tos_url;
    }
    /**
     * Whether the extension has support for sending chat messages.
     */ get hasChatSupport() {
        return this[$fXE6t.rawDataSymbol].has_chat_support;
    }
    /**
     * The URL of the extension's default sized icon.
     */ get iconUrl() {
        return this[$fXE6t.rawDataSymbol].icon_url;
    }
    /**
     * Gets the URL of the extension's icon in the given size.
     *
     * @param size The size of the icon.
     */ getIconUrl(size) {
        return this[$fXE6t.rawDataSymbol].icon_urls[size];
    }
    /**
     * The extension's ID.
     */ get id() {
        return this[$fXE6t.rawDataSymbol].id;
    }
    /**
     * The extension's name.
     */ get name() {
        return this[$fXE6t.rawDataSymbol].name;
    }
    /**
     * The URL of the extension's privacy policy.
     */ get privacyPolicyUrl() {
        return this[$fXE6t.rawDataSymbol].privacy_policy_url;
    }
    /**
     * Whether the extension requests its users to share their identity with it.
     */ get requestsIdentityLink() {
        return this[$fXE6t.rawDataSymbol].request_identity_link;
    }
    /**
     * The URLs of the extension's screenshots.
     */ get screenshotUrls() {
        return this[$fXE6t.rawDataSymbol].screenshot_urls;
    }
    /**
     * The extension's activity state.
     */ get state() {
        return this[$fXE6t.rawDataSymbol].state;
    }
    /**
     * The extension's level of support for subscriptions.
     */ get subscriptionsSupportLevel() {
        return this[$fXE6t.rawDataSymbol].subscriptions_support_level;
    }
    /**
     * The extension's feature summary.
     */ get summary() {
        return this[$fXE6t.rawDataSymbol].summary;
    }
    /**
     * The extension's support email address.
     */ get supportEmail() {
        return this[$fXE6t.rawDataSymbol].support_email;
    }
    /**
     * The extension's version.
     */ get version() {
        return this[$fXE6t.rawDataSymbol].version;
    }
    /**
     * The extension's feature summary for viewers.
     */ get viewerSummary() {
        return this[$fXE6t.rawDataSymbol].viewer_summary;
    }
    /**
     * The extension's feature summary for viewers.
     *
     * @deprecated Use `viewerSummary` instead.
     */ get viewerSummery() {
        return this[$fXE6t.rawDataSymbol].viewer_summary;
    }
    /**
     * The extension's allowed configuration URLs.
     */ get allowedConfigUrls() {
        return this[$fXE6t.rawDataSymbol].allowlisted_config_urls;
    }
    /**
     * The extension's allowed panel URLs.
     */ get allowedPanelUrls() {
        return this[$fXE6t.rawDataSymbol].allowlisted_panel_urls;
    }
    /**
     * The URL shown when a viewer opens the extension on a mobile device.
     *
     * If the extension does not have a mobile view, this is null.
     */ get mobileViewerUrl() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.mobile) === null || _a === void 0 ? void 0 : _a.viewer_url) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The URL shown to the viewer when the extension is shown as a panel.
     *
     * If the extension does not have a panel view, this is null.
     */ get panelViewerUrl() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.panel) === null || _a === void 0 ? void 0 : _a.viewer_url) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The height of the extension panel.
     *
     * If the extension does not have a panel view, this is null.
     */ get panelHeight() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.panel) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether the extension can link to external content from its panel view.
     *
     * If the extension does not have a panel view, this is null.
     */ get panelCanLinkExternalContent() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.panel) === null || _a === void 0 ? void 0 : _a.can_link_external_content) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The URL shown to the viewer when the extension is shown as a video overlay.
     *
     * If the extension does not have a overlay view, this is null.
     */ get overlayViewerUrl() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.video_overlay) === null || _a === void 0 ? void 0 : _a.viewer_url) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether the extension can link to external content from its overlay view.
     *
     * If the extension does not have a overlay view, this is null.
     */ get overlayCanLinkExternalContent() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.video_overlay) === null || _a === void 0 ? void 0 : _a.can_link_external_content) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The URL shown to the viewer when the extension is shown as a video component.
     *
     * If the extension does not have a component view, this is null.
     */ get componentViewerUrl() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.viewer_url) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The aspect width of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentAspectWidth() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.aspect_width) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The aspect height of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentAspectHeight() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.aspect_height) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The horizontal aspect ratio of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentAspectRatioX() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.aspect_ratio_x) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The vertical aspect ratio of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentAspectRatioY() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.aspect_ratio_y) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether the extension's component view should automatically scale.
     *
     * If the extension does not have a component view, this is null.
     */ get componentAutoScales() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.autoscale) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The base width of the extension's component view to use for scaling.
     *
     * If the extension does not have a component view, this is null.
     */ get componentScalePixels() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.scale_pixels) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The target height of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentTargetHeight() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.target_height) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The size of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentSize() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether zooming is enabled for the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentZoom() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.zoom) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The zoom pixels of the extension's component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentZoomPixels() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.zoom_pixels) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether the extension can link to external content from its component view.
     *
     * If the extension does not have a component view, this is null.
     */ get componentCanLinkExternalContent() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.component) === null || _a === void 0 ? void 0 : _a.can_link_external_content) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The URL shown to the viewer when the extension's configuration page is shown.
     *
     * If the extension does not have a config view, this is null.
     */ get configViewerUrl() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.config) === null || _a === void 0 ? void 0 : _a.viewer_url) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Whether the extension can link to external content from its config view.
     *
     * If the extension does not have a config view, this is null.
     */ get configCanLinkExternalContent() {
        var _a, _b;
        return (_b = (_a = this[$fXE6t.rawDataSymbol].views.config) === null || _a === void 0 ? void 0 : _a.can_link_external_content) !== null && _b !== void 0 ? _b : null;
    }
};
module.exports.HelixExtension = $032126db23f73004$var$HelixExtension;
module.exports.HelixExtension = $032126db23f73004$var$HelixExtension = $ceFTv.__decorate([
    (0, $9pzzB.rtfm)('api', 'HelixExtension', 'id')
], $032126db23f73004$var$HelixExtension);

});

parcelRegister("39i9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HellFreezesOverError = void 0;

var $jGDfl = parcelRequire("jGDfl");
/**
 * These are the kind of errors that should never happen.
 *
 * If you see one thrown, please file a bug in the GitHub issue tracker.
 */ class $24b04c7b67562b70$var$HellFreezesOverError extends $jGDfl.CustomError {
    constructor(message){
        super(`${message} - this should never happen, please file a bug in the GitHub issue tracker`);
    }
}
module.exports.HellFreezesOverError = $24b04c7b67562b70$var$HellFreezesOverError;

});

parcelRegister("dciYm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractUserName = module.exports.extractUserId = void 0;
/**
 * Extracts the user ID from an argument that is possibly an object containing that ID.
 *
 * @param user The user ID or object.
 */ function $99bb1cecbe7be44f$var$extractUserId(user) {
    if (typeof user === 'string') return user;
    if (typeof user === 'number') return user.toString(10);
    return user.id;
}
module.exports.extractUserId = $99bb1cecbe7be44f$var$extractUserId;
/**
 * Extracts the username from an argument that is possibly an object containing that name.
 *
 * @param user The username or object.
 */ function $99bb1cecbe7be44f$var$extractUserName(user) {
    return typeof user === 'string' ? user : user.name;
}
module.exports.extractUserName = $99bb1cecbe7be44f$var$extractUserName;

});




parcelRegister("hXSJn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTwitchApiUrl = void 0;
/** @internal */ function $d14266c57e54db32$var$getTwitchApiUrl(url, type, mockServerPort) {
    switch(type){
        case 'helix':
            {
                const unprefixedUrl = url.replace(/^\//, '');
                if (mockServerPort) {
                    if (unprefixedUrl === 'eventsub/subscriptions') return `http://localhost:${mockServerPort}/${unprefixedUrl}`;
                    return `http://localhost:${mockServerPort}/mock/${unprefixedUrl}`;
                }
                return `https://api.twitch.tv/helix/${unprefixedUrl}`;
            }
        case 'auth':
            return `https://id.twitch.tv/oauth2/${url.replace(/^\//, '')}`;
        case 'custom':
            return url;
        default:
            return url; // wat
    }
}
module.exports.getTwitchApiUrl = $d14266c57e54db32$var$getTwitchApiUrl;

});


parcelRegister("bsVlE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createBroadcasterQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
function $858ecb5ed168cf88$var$createBroadcasterQuery(user) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createBroadcasterQuery = $858ecb5ed168cf88$var$createBroadcasterQuery;

});


parcelRegister("hivwW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever you try using invalid values in the client configuration.
 */ class $c97c93620e76dfad$var$ConfigError extends $j0DIQ.CustomError {
}
module.exports.ConfigError = $c97c93620e76dfad$var$ConfigError;

});

parcelRegister("dLcJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixRateLimiter = void 0;

var $2GTfZ = parcelRequire("2GTfZ");

var $4ojlB = parcelRequire("4ojlB");
/** @internal */ class $a04989620cc36047$var$HelixRateLimiter extends $2GTfZ.ResponseBasedRateLimiter {
    async doRequest({ options: options, clientId: clientId, accessToken: accessToken, authorizationType: authorizationType, fetchOptions: fetchOptions, mockServerPort: mockServerPort }) {
        return await (0, $4ojlB.callTwitchApiRaw)(options, clientId, accessToken, authorizationType, fetchOptions, mockServerPort);
    }
    needsToRetryAfter(res) {
        if (res.status === 429 && (!res.headers.has('ratelimit-remaining') || Number(res.headers.get('ratelimit-remaining')) === 0)) return +res.headers.get('ratelimit-reset') * 1000 - Date.now();
        return null;
    }
    getParametersFromResponse(res) {
        const { headers: headers } = res;
        return {
            limit: +headers.get('ratelimit-limit'),
            remaining: +headers.get('ratelimit-remaining'),
            resetsAt: +headers.get('ratelimit-reset') * 1000
        };
    }
}
module.exports.HelixRateLimiter = $a04989620cc36047$var$HelixRateLimiter;

});

parcelRegister("81oS5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseApiClient = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $cKhNr = parcelRequire("cKhNr");

var $2GTfZ = parcelRequire("2GTfZ");

var $bRvJY = parcelRequire("bRvJY");

var $da2mc = parcelRequire("da2mc");

var $4ojlB = parcelRequire("4ojlB");

var $dMHW5 = parcelRequire("dMHW5");

var $j0DIQ = parcelRequire("j0DIQ");

var $jhTom = parcelRequire("jhTom");

var $kVdhx = parcelRequire("kVdhx");

var $1pTlx = parcelRequire("1pTlx");

var $43yGM = parcelRequire("43yGM");

var $iyImv = parcelRequire("iyImv");

var $39w82 = parcelRequire("39w82");

var $fJP1s = parcelRequire("fJP1s");

var $2LQEj = parcelRequire("2LQEj");

var $4MAQg = parcelRequire("4MAQg");

var $iZjEc = parcelRequire("iZjEc");

var $jJLZi = parcelRequire("jJLZi");

var $bLRG1 = parcelRequire("bLRG1");

var $5g9IT = parcelRequire("5g9IT");

var $geW2U = parcelRequire("geW2U");

var $l2bqp = parcelRequire("l2bqp");

var $htL0z = parcelRequire("htL0z");

var $yazN3 = parcelRequire("yazN3");

var $28sHD = parcelRequire("28sHD");

var $7R0an = parcelRequire("7R0an");

var $cEYvo = parcelRequire("cEYvo");

var $2I7cV = parcelRequire("2I7cV");

var $ll7Cn = parcelRequire("ll7Cn");

var $8VbMp = parcelRequire("8VbMp");

var $3BqLi = parcelRequire("3BqLi");

var $9WAZR = parcelRequire("9WAZR");

var $9ZuV6 = parcelRequire("9ZuV6");

var $ghlvC = parcelRequire("ghlvC");
/** @private */ let $5d71b5aa76ed8f15$var$BaseApiClient = class BaseApiClient extends $da2mc.EventEmitter {
    /** @internal */ constructor(config, logger, rateLimiter){
        super();
        this.onRequest = this.registerEvent();
        this._config = config;
        this._logger = logger;
        this._rateLimiter = rateLimiter;
    }
    /**
     * Requests scopes from the auth provider for the given user.
     *
     * @param user The user to request scopes for.
     * @param scopes The scopes to request.
     */ async requestScopesForUser(user, scopes) {
        await this._config.authProvider.getAccessTokenForUser(user, ...scopes.map((scope)=>[
                scope
            ]));
    }
    /**
     * Gets information about your access token.
     */ async getTokenInfo() {
        try {
            const data = await this.callApi({
                type: 'auth',
                url: 'validate'
            });
            return new $dMHW5.TokenInfo(data);
        } catch (e) {
            if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 401) throw new $dMHW5.InvalidTokenError({
                cause: e
            });
            throw e;
        }
    }
    /**
     * Makes a call to the Twitch API using your access token.
     *
     * @param options The configuration of the call.
     */ async callApi(options) {
        var _a;
        const { authProvider: authProvider } = this._config;
        const shouldAuth = (_a = options.auth) !== null && _a !== void 0 ? _a : true;
        if (!shouldAuth) return await (0, $4ojlB.callTwitchApi)(options, authProvider.clientId, undefined, undefined, this._config.fetchOptions);
        let forceUser = false;
        if (options.forceType) switch(options.forceType){
            case 'app':
                {
                    if (!authProvider.getAppAccessToken) throw new Error('Tried to make an API call that requires an app access token but your auth provider does not support that');
                    const accessToken = await authProvider.getAppAccessToken();
                    return await this._callApiUsingInitialToken(options, accessToken);
                }
            case 'user':
                forceUser = true;
                break;
            default:
                throw new $j0DIQ.HellFreezesOverError(`Unknown forced token type: ${options.forceType}`);
        }
        if (options.scopes) forceUser = true;
        if (forceUser) {
            const contextUserId = options.canOverrideScopedUserContext ? this._getUserIdFromRequestContext(options.userId) : options.userId;
            if (!contextUserId) throw new Error('Tried to make an API call with a user context but no context user ID');
            const accessToken = await authProvider.getAccessTokenForUser(contextUserId, options.scopes);
            if (!accessToken) throw new Error(`Tried to make an API call with a user context for user ID ${contextUserId} but no token was found`);
            if ((0, $dMHW5.accessTokenIsExpired)(accessToken) && authProvider.refreshAccessTokenForUser) {
                const newAccessToken = await authProvider.refreshAccessTokenForUser(contextUserId);
                return await this._callApiUsingInitialToken(options, newAccessToken, true);
            }
            return await this._callApiUsingInitialToken(options, accessToken);
        }
        const requestContextUserId = this._getUserIdFromRequestContext(options.userId);
        const accessToken = requestContextUserId === null ? await authProvider.getAnyAccessToken() : await authProvider.getAnyAccessToken(requestContextUserId !== null && requestContextUserId !== void 0 ? requestContextUserId : options.userId);
        if ((0, $dMHW5.accessTokenIsExpired)(accessToken) && accessToken.userId && authProvider.refreshAccessTokenForUser) {
            const newAccessToken = await authProvider.refreshAccessTokenForUser(accessToken.userId);
            return await this._callApiUsingInitialToken(options, newAccessToken, true);
        }
        return await this._callApiUsingInitialToken(options, accessToken);
    }
    /**
     * The Helix bits API methods.
     */ get bits() {
        return new $kVdhx.HelixBitsApi(this);
    }
    /**
     * The Helix channels API methods.
     */ get channels() {
        return new $1pTlx.HelixChannelApi(this);
    }
    /**
     * The Helix channel points API methods.
     */ get channelPoints() {
        return new $43yGM.HelixChannelPointsApi(this);
    }
    /**
     * The Helix charity API methods.
     */ get charity() {
        return new $iyImv.HelixCharityApi(this);
    }
    /**
     * The Helix chat API methods.
     */ get chat() {
        return new $39w82.HelixChatApi(this);
    }
    /**
     * The Helix clips API methods.
     */ get clips() {
        return new $fJP1s.HelixClipApi(this);
    }
    /**
     * The Helix content classification label API methods.
     */ get contentClassificationLabels() {
        return new $2LQEj.HelixContentClassificationLabelApi(this);
    }
    /**
     * The Helix entitlement API methods.
     */ get entitlements() {
        return new $4MAQg.HelixEntitlementApi(this);
    }
    /**
     * The Helix EventSub API methods.
     */ get eventSub() {
        return new $iZjEc.HelixEventSubApi(this);
    }
    /**
     * The Helix extensions API methods.
     */ get extensions() {
        return new $jJLZi.HelixExtensionsApi(this);
    }
    /**
     * The Helix game API methods.
     */ get games() {
        return new $bLRG1.HelixGameApi(this);
    }
    /**
     * The Helix Hype Train API methods.
     */ get hypeTrain() {
        return new $geW2U.HelixHypeTrainApi(this);
    }
    /**
     * The Helix goal API methods.
     */ get goals() {
        return new $5g9IT.HelixGoalApi(this);
    }
    /**
     * The Helix moderation API methods.
     */ get moderation() {
        return new $l2bqp.HelixModerationApi(this);
    }
    /**
     * The Helix poll API methods.
     */ get polls() {
        return new $htL0z.HelixPollApi(this);
    }
    /**
     * The Helix prediction API methods.
     */ get predictions() {
        return new $yazN3.HelixPredictionApi(this);
    }
    /**
     * The Helix raid API methods.
     */ get raids() {
        return new $28sHD.HelixRaidApi(this);
    }
    /**
     * The Helix schedule API methods.
     */ get schedule() {
        return new $7R0an.HelixScheduleApi(this);
    }
    /**
     * The Helix search API methods.
     */ get search() {
        return new $cEYvo.HelixSearchApi(this);
    }
    /**
     * The Helix stream API methods.
     */ get streams() {
        return new $2I7cV.HelixStreamApi(this);
    }
    /**
     * The Helix subscription API methods.
     */ get subscriptions() {
        return new $ll7Cn.HelixSubscriptionApi(this);
    }
    /**
     * The Helix team API methods.
     */ get teams() {
        return new $8VbMp.HelixTeamApi(this);
    }
    /**
     * The Helix user API methods.
     */ get users() {
        return new $3BqLi.HelixUserApi(this);
    }
    /**
     * The Helix video API methods.
     */ get videos() {
        return new $9WAZR.HelixVideoApi(this);
    }
    /**
     * The API methods that deal with whispers.
     */ get whispers() {
        return new $9ZuV6.HelixWhisperApi(this);
    }
    /**
     * Statistics on the rate limiter for the Helix API.
     */ get rateLimiterStats() {
        if (this._rateLimiter instanceof $2GTfZ.ResponseBasedRateLimiter) return this._rateLimiter.stats;
        return null;
    }
    /** @private */ get _authProvider() {
        return this._config.authProvider;
    }
    /** @private */ get _mockServerPort() {
        return this._config.mockServerPort;
    }
    /** @internal */ get _batchDelay() {
        var _a;
        return (_a = this._config.batchDelay) !== null && _a !== void 0 ? _a : 0;
    }
    // null means app access, undefined means none specified
    /** @internal */ _getUserIdFromRequestContext(contextUserId) {
        return contextUserId;
    }
    async _callApiUsingInitialToken(options, accessToken, wasRefreshed = false) {
        var _a;
        const { authProvider: authProvider } = this._config;
        const { authorizationType: authorizationType } = authProvider;
        let response = await this._callApiInternal(options, authProvider.clientId, accessToken.accessToken, authorizationType);
        if (response.status === 401 && !wasRefreshed) {
            if (accessToken.userId) {
                if (authProvider.refreshAccessTokenForUser) {
                    const token = await authProvider.refreshAccessTokenForUser(accessToken.userId);
                    response = await this._callApiInternal(options, authProvider.clientId, token.accessToken, authorizationType);
                }
            } else if (authProvider.getAppAccessToken) {
                const token = await authProvider.getAppAccessToken(true);
                response = await this._callApiInternal(options, authProvider.clientId, token.accessToken, authorizationType);
            }
        }
        this.emit(this.onRequest, new $ghlvC.ApiReportedRequest(options, response.status, (_a = accessToken.userId) !== null && _a !== void 0 ? _a : null));
        await (0, $4ojlB.handleTwitchApiResponseError)(response, options);
        return await (0, $4ojlB.transformTwitchApiResponse)(response);
    }
    async _callApiInternal(options, clientId, accessToken, authorizationType) {
        var _a, _b, _c;
        const { fetchOptions: fetchOptions, mockServerPort: mockServerPort } = this._config;
        const type = (_a = options.type) !== null && _a !== void 0 ? _a : 'helix';
        this._logger.debug(`Calling ${type} API: ${(_b = options.method) !== null && _b !== void 0 ? _b : 'GET'} ${options.url}`);
        this._logger.trace(`Query: ${JSON.stringify(options.query)}`);
        if (options.jsonBody) this._logger.trace(`Request body: ${JSON.stringify(options.jsonBody)}`);
        const op = $jhTom.operation({
            retries: 3,
            minTimeout: 500,
            factor: 2
        });
        const { promise: promise, resolve: resolve, reject: reject } = (0, $bRvJY.promiseWithResolvers)();
        op.attempt(async ()=>{
            try {
                const response = type === 'helix' ? await this._rateLimiter.request({
                    options: options,
                    clientId: clientId,
                    accessToken: accessToken,
                    authorizationType: authorizationType,
                    fetchOptions: fetchOptions,
                    mockServerPort: mockServerPort
                }) : await (0, $4ojlB.callTwitchApiRaw)(options, clientId, accessToken, authorizationType, fetchOptions, mockServerPort);
                if (!response.ok && response.status >= 500 && response.status < 600) await (0, $4ojlB.handleTwitchApiResponseError)(response, options);
                resolve(response);
            } catch (e) {
                if (op.retry(e)) return;
                reject(op.mainError());
            }
        });
        const result = await promise;
        this._logger.debug(`Called ${type} API: ${(_c = options.method) !== null && _c !== void 0 ? _c : 'GET'} ${options.url} - result: ${result.status}`);
        return result;
    }
};
module.exports.BaseApiClient = $5d71b5aa76ed8f15$var$BaseApiClient;
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "bits", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "channels", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "channelPoints", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "charity", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "chat", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "clips", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "contentClassificationLabels", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "entitlements", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "eventSub", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "extensions", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "games", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "hypeTrain", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "goals", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "moderation", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "polls", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "predictions", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "raids", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "schedule", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "search", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "streams", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "subscriptions", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "teams", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "users", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "videos", null);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $5d71b5aa76ed8f15$var$BaseApiClient.prototype, "whispers", null);
module.exports.BaseApiClient = $5d71b5aa76ed8f15$var$BaseApiClient = $ceFTv.__decorate([
    $cKhNr.Cacheable,
    (0, $j0DIQ.rtfm)('api', 'ApiClient')
], $5d71b5aa76ed8f15$var$BaseApiClient);

});
parcelRegister("cKhNr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCacheKey = module.exports.ClearsCache = module.exports.CachedGetter = module.exports.Cached = module.exports.Cacheable = void 0;

var $3LG6N = parcelRequire("3LG6N");
Object.defineProperty(module.exports, "Cacheable", {
    enumerable: true,
    get: function() {
        return $3LG6N.Cacheable;
    }
});

var $3cC7t = parcelRequire("3cC7t");
Object.defineProperty(module.exports, "Cached", {
    enumerable: true,
    get: function() {
        return $3cC7t.Cached;
    }
});

var $1SJsK = parcelRequire("1SJsK");
Object.defineProperty(module.exports, "CachedGetter", {
    enumerable: true,
    get: function() {
        return $1SJsK.CachedGetter;
    }
});

var $81wOL = parcelRequire("81wOL");
Object.defineProperty(module.exports, "ClearsCache", {
    enumerable: true,
    get: function() {
        return $81wOL.ClearsCache;
    }
});

var $3OSQk = parcelRequire("3OSQk");
Object.defineProperty(module.exports, "createCacheKey", {
    enumerable: true,
    get: function() {
        return $3OSQk.createCacheKey;
    }
});

});
parcelRegister("3LG6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cacheable = void 0;

var $3OSQk = parcelRequire("3OSQk");
const $2be66cc2841a611d$var$cacheSymbol = Symbol('cache');
function $2be66cc2841a611d$var$Cacheable(cls) {
    var _a, _b;
    return _b = class extends cls {
        constructor(){
            super(...arguments);
            this[_a] = new Map();
        }
        getFromCache(cacheKey) {
            this._cleanCache();
            if (this[$2be66cc2841a611d$var$cacheSymbol].has(cacheKey)) {
                const entry = this[$2be66cc2841a611d$var$cacheSymbol].get(cacheKey);
                if (entry) return entry.value;
            }
            return undefined;
        }
        setCache(cacheKey, value, timeInSeconds) {
            this[$2be66cc2841a611d$var$cacheSymbol].set(cacheKey, {
                value: value,
                expires: Date.now() + timeInSeconds * 1000
            });
        }
        removeFromCache(cacheKey, prefix) {
            const internalCacheKey = this._getInternalCacheKey(cacheKey, prefix);
            if (prefix) this[$2be66cc2841a611d$var$cacheSymbol].forEach((val, key)=>{
                if (key.startsWith(internalCacheKey)) this[$2be66cc2841a611d$var$cacheSymbol].delete(key);
            });
            else this[$2be66cc2841a611d$var$cacheSymbol].delete(internalCacheKey);
        }
        _cleanCache() {
            const now = Date.now();
            this[$2be66cc2841a611d$var$cacheSymbol].forEach((val, key)=>{
                if (val.expires < now) this[$2be66cc2841a611d$var$cacheSymbol].delete(key);
            });
        }
        _getInternalCacheKey(cacheKey, prefix) {
            if (typeof cacheKey === 'string') {
                let internalCacheKey = cacheKey;
                if (!internalCacheKey.endsWith('/')) internalCacheKey += '/';
                return internalCacheKey;
            } else {
                const propName = cacheKey.shift();
                return (0, $3OSQk.createCacheKey)(propName, cacheKey, prefix);
            }
        }
    }, _a = $2be66cc2841a611d$var$cacheSymbol, _b;
}
module.exports.Cacheable = $2be66cc2841a611d$var$Cacheable;

});
parcelRegister("3OSQk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCacheKey = void 0;
function $2c8095459cddfed6$var$createSingleCacheKey(param) {
    // noinspection FallThroughInSwitchStatementJS
    switch(typeof param){
        case 'undefined':
            return '';
        case 'object':
            {
                if (param === null) return '';
                if ('cacheKey' in param) return param.cacheKey;
                const objKey = JSON.stringify(param);
                if (objKey !== '{}') return objKey;
            }
        // fallthrough
        default:
            return param.toString();
    }
}
function $2c8095459cddfed6$var$createCacheKey(propName, params, prefix) {
    return [
        propName,
        ...params.map($2c8095459cddfed6$var$createSingleCacheKey)
    ].join('/') + (prefix ? '/' : '');
}
module.exports.createCacheKey = $2c8095459cddfed6$var$createCacheKey;

});


parcelRegister("3cC7t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cached = void 0;

var $3OSQk = parcelRequire("3OSQk");
function $25500fd6c681d73c$var$Cached(timeInSeconds = Infinity, cacheFailures = false) {
    return function(target, propName, descriptor) {
        const origFn = descriptor.value;
        descriptor.value = async function(...params) {
            const cacheKey = (0, $3OSQk.createCacheKey)(propName, params);
            const cachedValue = this.getFromCache(cacheKey);
            if (cachedValue) return cachedValue;
            const result = await origFn.apply(this, params);
            if (result != null || cacheFailures) this.setCache(cacheKey, result, timeInSeconds);
            return result;
        };
        return descriptor;
    };
}
module.exports.Cached = $25500fd6c681d73c$var$Cached;

});

parcelRegister("1SJsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedGetter = void 0;

var $3OSQk = parcelRequire("3OSQk");
function $15ee198c1ee0889e$var$CachedGetter(timeInSeconds = Infinity) {
    return function(target, propName, descriptor) {
        if (descriptor.get) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const origFn = descriptor.get;
            descriptor.get = function() {
                const cacheKey = (0, $3OSQk.createCacheKey)(propName, []);
                const cachedValue = this.getFromCache(cacheKey);
                if (cachedValue) return cachedValue;
                const result = origFn.call(this);
                this.setCache(cacheKey, result, timeInSeconds);
                return result;
            };
        }
        return descriptor;
    };
}
module.exports.CachedGetter = $15ee198c1ee0889e$var$CachedGetter;

});

parcelRegister("81wOL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClearsCache = void 0;
function $5d77dfa23b8416fa$var$ClearsCache(cacheName, numberOfArguments) {
    return function(target, propName, descriptor) {
        const origFn = descriptor.value;
        descriptor.value = async function(...params) {
            const result = await origFn.apply(this, params);
            const args = numberOfArguments === undefined ? params.slice() : params.slice(0, numberOfArguments);
            this.removeFromCache([
                cacheName,
                ...args
            ], true);
            return result;
        };
        return descriptor;
    };
}
module.exports.ClearsCache = $5d77dfa23b8416fa$var$ClearsCache;

});


parcelRegister("da2mc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Listener = module.exports.EventEmitter = void 0;

var $6Dqz5 = parcelRequire("6Dqz5");
Object.defineProperty(module.exports, "EventEmitter", {
    enumerable: true,
    get: function() {
        return $6Dqz5.EventEmitter;
    }
});

var $i09kQ = parcelRequire("i09kQ");
Object.defineProperty(module.exports, "Listener", {
    enumerable: true,
    get: function() {
        return $i09kQ.Listener;
    }
});

});
parcelRegister("6Dqz5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventEmitter = void 0;

var $i09kQ = parcelRequire("i09kQ");
class $4d4afdd645b52d86$var$EventEmitter {
    constructor(){
        this._eventListeners = new Map();
        this._internalEventListeners = new Map();
    }
    on(event, listener) {
        return this._addListener(false, event, listener);
    }
    addListener(event, listener) {
        return this._addListener(false, event, listener);
    }
    removeListener(idOrEvent, listener) {
        this._removeListener(false, idOrEvent, listener);
    }
    registerEvent() {
        const eventBinder = (handler)=>this.addListener(eventBinder, handler);
        return eventBinder;
    }
    emit(event, ...args) {
        if (this._eventListeners.has(event)) for (const listener of this._eventListeners.get(event))listener(...args);
        if (this._internalEventListeners.has(event)) for (const listener of this._internalEventListeners.get(event))listener(...args);
    }
    registerInternalEvent() {
        const eventBinder = (handler)=>this.addInternalListener(eventBinder, handler);
        return eventBinder;
    }
    addInternalListener(event, listener) {
        return this._addListener(true, event, listener);
    }
    removeInternalListener(idOrEvent, listener) {
        this._removeListener(true, idOrEvent, listener);
    }
    _addListener(internal, event, listener) {
        const listenerMap = internal ? this._eventListeners : this._internalEventListeners;
        if (listenerMap.has(event)) listenerMap.get(event).push(listener);
        else listenerMap.set(event, [
            listener
        ]);
        return new $i09kQ.Listener(this, event, listener, internal);
    }
    _removeListener(internal, idOrEvent, listener) {
        const listenerMap = internal ? this._eventListeners : this._internalEventListeners;
        if (!idOrEvent) listenerMap.clear();
        else if (typeof idOrEvent === 'object') {
            const id = idOrEvent;
            this._removeListener(id._internal, id.event, id.listener);
        } else {
            const event = idOrEvent;
            if (listenerMap.has(event)) {
                if (listener) {
                    const listeners = listenerMap.get(event);
                    let idx = 0;
                    while((idx = listeners.indexOf(listener)) !== -1)listeners.splice(idx, 1);
                } else listenerMap.delete(event);
            }
        }
    }
}
module.exports.EventEmitter = $4d4afdd645b52d86$var$EventEmitter;

});
parcelRegister("i09kQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Listener = void 0;
class $d1af77e08660c72e$var$Listener {
    /** @private */ constructor(owner, event, listener, /** @private */ _internal = false){
        this.owner = owner;
        this.event = event;
        this.listener = listener;
        this._internal = _internal;
    }
    unbind() {
        this.owner.removeListener(this);
    }
}
module.exports.Listener = $d1af77e08660c72e$var$Listener;

});



parcelRegister("dMHW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownIntentError = module.exports.InvalidTokenTypeError = module.exports.InvalidTokenError = module.exports.IntermediateUserRemovalError = module.exports.CachedRefreshFailureError = module.exports.StaticAuthProvider = module.exports.RefreshingAuthProvider = module.exports.AppTokenAuthProvider = module.exports.TokenInfo = module.exports.TokenFetcher = module.exports.revokeToken = module.exports.refreshUserToken = module.exports.getValidTokenFromProviderForIntent = module.exports.getValidTokenFromProviderForUser = module.exports.getTokenInfo = module.exports.getAppToken = module.exports.exchangeCode = module.exports.getExpiryDateOfAccessToken = module.exports.accessTokenIsExpired = void 0;

var $7Oold = parcelRequire("7Oold");
Object.defineProperty(module.exports, "accessTokenIsExpired", {
    enumerable: true,
    get: function() {
        return $7Oold.accessTokenIsExpired;
    }
});
Object.defineProperty(module.exports, "getExpiryDateOfAccessToken", {
    enumerable: true,
    get: function() {
        return $7Oold.getExpiryDateOfAccessToken;
    }
});

var $hfptp = parcelRequire("hfptp");
Object.defineProperty(module.exports, "exchangeCode", {
    enumerable: true,
    get: function() {
        return $hfptp.exchangeCode;
    }
});
Object.defineProperty(module.exports, "getAppToken", {
    enumerable: true,
    get: function() {
        return $hfptp.getAppToken;
    }
});
Object.defineProperty(module.exports, "getTokenInfo", {
    enumerable: true,
    get: function() {
        return $hfptp.getTokenInfo;
    }
});
Object.defineProperty(module.exports, "getValidTokenFromProviderForUser", {
    enumerable: true,
    get: function() {
        return $hfptp.getValidTokenFromProviderForUser;
    }
});
Object.defineProperty(module.exports, "getValidTokenFromProviderForIntent", {
    enumerable: true,
    get: function() {
        return $hfptp.getValidTokenFromProviderForIntent;
    }
});
Object.defineProperty(module.exports, "refreshUserToken", {
    enumerable: true,
    get: function() {
        return $hfptp.refreshUserToken;
    }
});
Object.defineProperty(module.exports, "revokeToken", {
    enumerable: true,
    get: function() {
        return $hfptp.revokeToken;
    }
});

var $6LWj6 = parcelRequire("6LWj6");
Object.defineProperty(module.exports, "TokenFetcher", {
    enumerable: true,
    get: function() {
        return $6LWj6.TokenFetcher;
    }
});

var $gEmcl = parcelRequire("gEmcl");
Object.defineProperty(module.exports, "TokenInfo", {
    enumerable: true,
    get: function() {
        return $gEmcl.TokenInfo;
    }
});

var $5lB76 = parcelRequire("5lB76");
Object.defineProperty(module.exports, "AppTokenAuthProvider", {
    enumerable: true,
    get: function() {
        return $5lB76.AppTokenAuthProvider;
    }
});

var $3MTnk = parcelRequire("3MTnk");
Object.defineProperty(module.exports, "RefreshingAuthProvider", {
    enumerable: true,
    get: function() {
        return $3MTnk.RefreshingAuthProvider;
    }
});

var $5yFCY = parcelRequire("5yFCY");
Object.defineProperty(module.exports, "StaticAuthProvider", {
    enumerable: true,
    get: function() {
        return $5yFCY.StaticAuthProvider;
    }
});

var $1WdjY = parcelRequire("1WdjY");
Object.defineProperty(module.exports, "CachedRefreshFailureError", {
    enumerable: true,
    get: function() {
        return $1WdjY.CachedRefreshFailureError;
    }
});

var $7Ohsa = parcelRequire("7Ohsa");
Object.defineProperty(module.exports, "IntermediateUserRemovalError", {
    enumerable: true,
    get: function() {
        return $7Ohsa.IntermediateUserRemovalError;
    }
});

var $luukc = parcelRequire("luukc");
Object.defineProperty(module.exports, "InvalidTokenError", {
    enumerable: true,
    get: function() {
        return $luukc.InvalidTokenError;
    }
});

var $bWRUw = parcelRequire("bWRUw");
Object.defineProperty(module.exports, "InvalidTokenTypeError", {
    enumerable: true,
    get: function() {
        return $bWRUw.InvalidTokenTypeError;
    }
});

var $hacSE = parcelRequire("hacSE");
Object.defineProperty(module.exports, "UnknownIntentError", {
    enumerable: true,
    get: function() {
        return $hacSE.UnknownIntentError;
    }
});

});
parcelRegister("7Oold", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accessTokenIsExpired = module.exports.getExpiryDateOfAccessToken = void 0;

var $bRvJY = parcelRequire("bRvJY");
// one minute
const $5b00158da5300991$var$EXPIRY_GRACE_PERIOD = 60000;
function $5b00158da5300991$var$getExpiryMillis(token) {
    return (0, $bRvJY.mapNullable)(token.expiresIn, (_)=>token.obtainmentTimestamp + _ * 1000 - $5b00158da5300991$var$EXPIRY_GRACE_PERIOD);
}
/**
 * Calculates the date when the access token will expire.
 *
 * A one-minute grace period is applied for smooth handling of API latency.
 *
 * May be `null`, in which case the token does not expire.
 * This can only be the case with very old Client IDs.
 *
 * @param token The access token.
 */ function $5b00158da5300991$var$getExpiryDateOfAccessToken(token) {
    return (0, $bRvJY.mapNullable)($5b00158da5300991$var$getExpiryMillis(token), (_)=>new Date(_));
}
module.exports.getExpiryDateOfAccessToken = $5b00158da5300991$var$getExpiryDateOfAccessToken;
/**
 * Calculates whether the given access token is expired.
 *
 * A one-minute grace period is applied for smooth handling of API latency.
 *
 * @param token The access token.
 */ function $5b00158da5300991$var$accessTokenIsExpired(token) {
    var _a;
    return (_a = (0, $bRvJY.mapNullable)($5b00158da5300991$var$getExpiryMillis(token), (_)=>Date.now() > _)) !== null && _a !== void 0 ? _a : false;
}
module.exports.accessTokenIsExpired = $5b00158da5300991$var$accessTokenIsExpired;

});

parcelRegister("hfptp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.loadAndCompareTokenInfo = module.exports.compareScopeSets = module.exports.compareScopes = module.exports.getValidTokenFromProviderForIntent = module.exports.getValidTokenFromProviderForUser = module.exports.getTokenInfo = module.exports.revokeToken = module.exports.refreshUserToken = module.exports.getAppToken = module.exports.exchangeCode = void 0;

var $4ojlB = parcelRequire("4ojlB");

var $luukc = parcelRequire("luukc");

var $bWRUw = parcelRequire("bWRUw");

var $2mCoV = parcelRequire("2mCoV");

var $gEmcl = parcelRequire("gEmcl");
/** @internal */ function $c8e798dde0973534$var$createAccessTokenFromData(data) {
    var _a, _b;
    return {
        accessToken: data.access_token,
        refreshToken: data.refresh_token || null,
        scope: (_a = data.scope) !== null && _a !== void 0 ? _a : [],
        expiresIn: (_b = data.expires_in) !== null && _b !== void 0 ? _b : null,
        obtainmentTimestamp: Date.now()
    };
}
/**
 * Gets an access token with your client credentials and an authorization code.
 *
 * @param clientId The client ID of your application.
 * @param clientSecret The client secret of your application.
 * @param code The authorization code.
 * @param redirectUri The redirect URI.
 *
 * This serves no real purpose here, but must still match one of the redirect URIs you configured in the Twitch Developer dashboard.
 */ async function $c8e798dde0973534$var$exchangeCode(clientId, clientSecret, code, redirectUri) {
    return $c8e798dde0973534$var$createAccessTokenFromData(await (0, $4ojlB.callTwitchApi)({
        type: 'auth',
        url: 'token',
        method: 'POST',
        query: (0, $2mCoV.createExchangeCodeQuery)(clientId, clientSecret, code, redirectUri)
    }));
}
module.exports.exchangeCode = $c8e798dde0973534$var$exchangeCode;
/**
 * Gets an app access token with your client credentials.
 *
 * @param clientId The client ID of your application.
 * @param clientSecret The client secret of your application.
 */ async function $c8e798dde0973534$var$getAppToken(clientId, clientSecret) {
    return $c8e798dde0973534$var$createAccessTokenFromData(await (0, $4ojlB.callTwitchApi)({
        type: 'auth',
        url: 'token',
        method: 'POST',
        query: (0, $2mCoV.createGetAppTokenQuery)(clientId, clientSecret)
    }));
}
module.exports.getAppToken = $c8e798dde0973534$var$getAppToken;
/**
 * Refreshes an expired access token with your client credentials and the refresh token that was given by the initial authentication.
 *
 * @param clientId The client ID of your application.
 * @param clientSecret The client secret of your application.
 * @param refreshToken The refresh token.
 */ async function $c8e798dde0973534$var$refreshUserToken(clientId, clientSecret, refreshToken) {
    return $c8e798dde0973534$var$createAccessTokenFromData(await (0, $4ojlB.callTwitchApi)({
        type: 'auth',
        url: 'token',
        method: 'POST',
        query: (0, $2mCoV.createRefreshTokenQuery)(clientId, clientSecret, refreshToken)
    }));
}
module.exports.refreshUserToken = $c8e798dde0973534$var$refreshUserToken;
/**
 * Revokes an access token.
 *
 * @param clientId The client ID of your application.
 * @param accessToken The access token.
 */ async function $c8e798dde0973534$var$revokeToken(clientId, accessToken) {
    await (0, $4ojlB.callTwitchApi)({
        type: 'auth',
        url: 'revoke',
        method: 'POST',
        query: (0, $2mCoV.createRevokeTokenQuery)(clientId, accessToken)
    });
}
module.exports.revokeToken = $c8e798dde0973534$var$revokeToken;
/**
 * Gets information about an access token.
 *
 * @param accessToken The access token to get the information of.
 * @param clientId The client ID of your application.
 *
 * You need to obtain one using one of the [Twitch OAuth flows](https://dev.twitch.tv/docs/authentication/getting-tokens-oauth/).
 */ async function $c8e798dde0973534$var$getTokenInfo(accessToken, clientId) {
    try {
        const data = await (0, $4ojlB.callTwitchApi)({
            type: 'auth',
            url: 'validate'
        }, clientId, accessToken);
        return new $gEmcl.TokenInfo(data);
    } catch (e) {
        if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 401) throw new $luukc.InvalidTokenError({
            cause: e
        });
        throw e;
    }
}
module.exports.getTokenInfo = $c8e798dde0973534$var$getTokenInfo;
/** @private */ async function $c8e798dde0973534$var$getValidTokenFromProviderForUser(provider, userId, scopes, logger) {
    let lastTokenError = null;
    let foundUser = false;
    try {
        const accessToken = await provider.getAccessTokenForUser(userId, scopes);
        if (accessToken) {
            foundUser = true;
            // check validity
            const tokenInfo = await $c8e798dde0973534$var$getTokenInfo(accessToken.accessToken);
            return {
                accessToken: accessToken,
                tokenInfo: tokenInfo
            };
        }
    } catch (e) {
        if (e instanceof $luukc.InvalidTokenError) lastTokenError = e;
        else logger === null || logger === void 0 || logger.error(`Retrieving an access token failed: ${e.message}`);
    }
    if (foundUser) {
        logger === null || logger === void 0 || logger.warn('No valid token available; trying to refresh');
        if (provider.refreshAccessTokenForUser) try {
            const newToken = await provider.refreshAccessTokenForUser(userId);
            // check validity
            const tokenInfo = await $c8e798dde0973534$var$getTokenInfo(newToken.accessToken);
            return {
                accessToken: newToken,
                tokenInfo: tokenInfo
            };
        } catch (e) {
            if (e instanceof $luukc.InvalidTokenError) lastTokenError = e;
            else logger === null || logger === void 0 || logger.error(`Refreshing the access token failed: ${e.message}`);
        }
    }
    throw lastTokenError !== null && lastTokenError !== void 0 ? lastTokenError : new Error('Could not retrieve a valid token');
}
module.exports.getValidTokenFromProviderForUser = $c8e798dde0973534$var$getValidTokenFromProviderForUser;
/** @private */ async function $c8e798dde0973534$var$getValidTokenFromProviderForIntent(provider, intent, scopes, logger) {
    let lastTokenError = null;
    let foundUser = false;
    if (!provider.getAccessTokenForIntent) throw new $bWRUw.InvalidTokenTypeError(`This call requires an AuthProvider that supports intents.
Please use an auth provider that does, such as \`RefreshingAuthProvider\`.`);
    try {
        const accessToken = await provider.getAccessTokenForIntent(intent, scopes);
        if (accessToken) {
            foundUser = true;
            // check validity
            const tokenInfo = await $c8e798dde0973534$var$getTokenInfo(accessToken.accessToken);
            return {
                accessToken: accessToken,
                tokenInfo: tokenInfo
            };
        }
    } catch (e) {
        if (e instanceof $luukc.InvalidTokenError) lastTokenError = e;
        else logger === null || logger === void 0 || logger.error(`Retrieving an access token failed: ${e.message}`);
    }
    if (foundUser) {
        logger === null || logger === void 0 || logger.warn('No valid token available; trying to refresh');
        if (provider.refreshAccessTokenForIntent) try {
            const newToken = await provider.refreshAccessTokenForIntent(intent);
            // check validity
            const tokenInfo = await $c8e798dde0973534$var$getTokenInfo(newToken.accessToken);
            return {
                accessToken: newToken,
                tokenInfo: tokenInfo
            };
        } catch (e) {
            if (e instanceof $luukc.InvalidTokenError) lastTokenError = e;
            else logger === null || logger === void 0 || logger.error(`Refreshing the access token failed: ${e.message}`);
        }
    }
    throw lastTokenError !== null && lastTokenError !== void 0 ? lastTokenError : new Error('Could not retrieve a valid token');
}
module.exports.getValidTokenFromProviderForIntent = $c8e798dde0973534$var$getValidTokenFromProviderForIntent;
const $c8e798dde0973534$var$scopeEquivalencies = new Map([
    [
        'channel_commercial',
        [
            'channel:edit:commercial'
        ]
    ],
    [
        'channel_editor',
        [
            'channel:manage:broadcast'
        ]
    ],
    [
        'channel_read',
        [
            'channel:read:stream_key'
        ]
    ],
    [
        'channel_subscriptions',
        [
            'channel:read:subscriptions'
        ]
    ],
    [
        'user_blocks_read',
        [
            'user:read:blocked_users'
        ]
    ],
    [
        'user_blocks_edit',
        [
            'user:manage:blocked_users'
        ]
    ],
    [
        'user_follows_edit',
        [
            'user:edit:follows'
        ]
    ],
    [
        'user_read',
        [
            'user:read:email'
        ]
    ],
    [
        'user_subscriptions',
        [
            'user:read:subscriptions'
        ]
    ],
    [
        'user:edit:broadcast',
        [
            'channel:manage:broadcast',
            'channel:manage:extensions'
        ]
    ]
]);
/**
 * Compares scopes for a non-upgradable {@link AuthProvider} instance.
 *
 * @param scopesToCompare The scopes to compare against.
 * @param requestedScopes The scopes you requested.
 */ function $c8e798dde0973534$var$compareScopes(scopesToCompare, requestedScopes) {
    if (requestedScopes === null || requestedScopes === void 0 ? void 0 : requestedScopes.length) {
        const scopes = new Set(scopesToCompare.flatMap((scope)=>{
            var _a;
            return [
                scope,
                ...(_a = $c8e798dde0973534$var$scopeEquivalencies.get(scope)) !== null && _a !== void 0 ? _a : []
            ];
        }));
        if (requestedScopes.every((scope)=>!scopes.has(scope))) {
            const scopesStr = requestedScopes.join(', ');
            throw new Error(`This token does not have any of the requested scopes (${scopesStr}) and can not be upgraded.
If you need dynamically upgrading scopes, please implement the AuthProvider interface accordingly:

\thttps://twurple.js.org/reference/auth/interfaces/AuthProvider.html`);
        }
    }
}
module.exports.compareScopes = $c8e798dde0973534$var$compareScopes;
/**
 * Compares scope sets for a non-upgradable {@link AuthProvider} instance.
 *
 * @param scopesToCompare The scopes to compare against.
 * @param requestedScopeSets The scope sets you requested.
 */ function $c8e798dde0973534$var$compareScopeSets(scopesToCompare, requestedScopeSets) {
    for (const requestedScopes of requestedScopeSets)$c8e798dde0973534$var$compareScopes(scopesToCompare, requestedScopes);
}
module.exports.compareScopeSets = $c8e798dde0973534$var$compareScopeSets;
/**
 * Compares scopes for a non-upgradable `AuthProvider` instance, loading them from the token if necessary,
 * and returns them together with the user ID.
 *
 * @param clientId The client ID of your application.
 * @param token The access token.
 * @param userId The user ID that was already loaded.
 * @param loadedScopes The scopes that were already loaded.
 * @param requestedScopeSets The scope sets you requested.
 */ async function $c8e798dde0973534$var$loadAndCompareTokenInfo(clientId, token, userId, loadedScopes, requestedScopeSets) {
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if ((requestedScopeSets === null || requestedScopeSets === void 0 ? void 0 : requestedScopeSets.length) || !userId) {
        const userInfo = await $c8e798dde0973534$var$getTokenInfo(token, clientId);
        if (!userInfo.userId) throw new Error('Trying to use an app access token as a user access token');
        const scopesToCompare = loadedScopes !== null && loadedScopes !== void 0 ? loadedScopes : userInfo.scopes;
        if (requestedScopeSets) $c8e798dde0973534$var$compareScopeSets(scopesToCompare, requestedScopeSets.filter((val)=>Boolean(val)));
        return [
            scopesToCompare,
            userInfo.userId
        ];
    }
    return [
        loadedScopes,
        userId
    ];
}
module.exports.loadAndCompareTokenInfo = $c8e798dde0973534$var$loadAndCompareTokenInfo;

});
parcelRegister("luukc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTokenError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever an invalid token is supplied.
 */ class $fa53ec320003452e$var$InvalidTokenError extends $j0DIQ.CustomError {
    /** @private */ constructor(options){
        super('Invalid token supplied', options);
    }
}
module.exports.InvalidTokenError = $fa53ec320003452e$var$InvalidTokenError;

});

parcelRegister("bWRUw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidTokenTypeError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever a different token type (user vs. app) is expected in the method you're calling.
 */ class $8b2eee03624e432b$var$InvalidTokenTypeError extends $j0DIQ.CustomError {
}
module.exports.InvalidTokenTypeError = $8b2eee03624e432b$var$InvalidTokenTypeError;

});

parcelRegister("2mCoV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRevokeTokenQuery = module.exports.createRefreshTokenQuery = module.exports.createGetAppTokenQuery = module.exports.createExchangeCodeQuery = void 0;
/** @internal */ function $1b8b6c7664077829$var$createExchangeCodeQuery(clientId, clientSecret, code, redirectUri) {
    return {
        grant_type: 'authorization_code',
        client_id: clientId,
        client_secret: clientSecret,
        code: code,
        redirect_uri: redirectUri
    };
}
module.exports.createExchangeCodeQuery = $1b8b6c7664077829$var$createExchangeCodeQuery;
/** @internal */ function $1b8b6c7664077829$var$createGetAppTokenQuery(clientId, clientSecret) {
    return {
        grant_type: 'client_credentials',
        client_id: clientId,
        client_secret: clientSecret
    };
}
module.exports.createGetAppTokenQuery = $1b8b6c7664077829$var$createGetAppTokenQuery;
/** @internal */ function $1b8b6c7664077829$var$createRefreshTokenQuery(clientId, clientSecret, refreshToken) {
    return {
        grant_type: 'refresh_token',
        client_id: clientId,
        client_secret: clientSecret,
        refresh_token: refreshToken
    };
}
module.exports.createRefreshTokenQuery = $1b8b6c7664077829$var$createRefreshTokenQuery;
/** @internal */ function $1b8b6c7664077829$var$createRevokeTokenQuery(clientId, accessToken) {
    return {
        client_id: clientId,
        token: accessToken
    };
}
module.exports.createRevokeTokenQuery = $1b8b6c7664077829$var$createRevokeTokenQuery;

});

parcelRegister("gEmcl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenInfo = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about an access token.
 */ let $c1f199d47b2db3ce$var$TokenInfo = class TokenInfo extends $j0DIQ.DataObject {
    /** @internal */ constructor(data){
        super(data);
        this._obtainmentDate = new Date();
    }
    /**
     * The client ID.
     */ get clientId() {
        return this[$j0DIQ.rawDataSymbol].client_id;
    }
    /**
     * The ID of the authenticated user.
     */ get userId() {
        var _a;
        return (_a = this[$j0DIQ.rawDataSymbol].user_id) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * The name of the authenticated user.
     */ get userName() {
        var _a;
        return (_a = this[$j0DIQ.rawDataSymbol].login) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * The scopes for which the token is valid.
     */ get scopes() {
        return this[$j0DIQ.rawDataSymbol].scopes;
    }
    /**
     * The time when the token will expire.
     *
     * If this returns null, it means that the token never expires (happens with some old client IDs).
     */ get expiryDate() {
        return (0, $bRvJY.mapNullable)(this[$j0DIQ.rawDataSymbol].expires_in, (v)=>new Date(this._obtainmentDate.getTime() + v * 1000));
    }
};
module.exports.TokenInfo = $c1f199d47b2db3ce$var$TokenInfo;
module.exports.TokenInfo = $c1f199d47b2db3ce$var$TokenInfo = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('auth', 'TokenInfo', 'clientId')
], $c1f199d47b2db3ce$var$TokenInfo);

});


parcelRegister("6LWj6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenFetcher = void 0;

var $bRvJY = parcelRequire("bRvJY");
class $4ee45c72385008c7$var$TokenFetcher {
    constructor(executor){
        this._newTokenScopeSets = [];
        this._newTokenPromise = null;
        this._queuedScopeSets = [];
        this._queueExecutor = null;
        this._queuePromise = null;
        this._executor = executor;
    }
    async fetch(...scopeSets) {
        var _a;
        const filteredScopeSets = scopeSets.filter((val)=>Boolean(val));
        if (this._newTokenPromise) {
            if (!filteredScopeSets.length) return await this._newTokenPromise;
            if (this._queueExecutor) this._queuedScopeSets.push(...filteredScopeSets);
            else this._queuedScopeSets = [
                ...filteredScopeSets
            ];
            if (!this._queuePromise) {
                const { promise: promise, resolve: resolve, reject: reject } = (0, $bRvJY.promiseWithResolvers)();
                this._queuePromise = promise;
                this._queueExecutor = async ()=>{
                    var _a;
                    if (!this._queuePromise) return;
                    this._newTokenScopeSets = this._queuedScopeSets;
                    this._queuedScopeSets = [];
                    this._newTokenPromise = this._queuePromise;
                    this._queuePromise = null;
                    this._queueExecutor = null;
                    try {
                        resolve(await this._executor(this._newTokenScopeSets));
                    } catch (e) {
                        reject(e);
                    } finally{
                        this._newTokenPromise = null;
                        this._newTokenScopeSets = [];
                        (_a = this._queueExecutor) === null || _a === void 0 || _a.call(this);
                    }
                };
            }
            return await this._queuePromise;
        }
        this._newTokenScopeSets = [
            ...filteredScopeSets
        ];
        const { promise: promise, resolve: resolve, reject: reject } = (0, $bRvJY.promiseWithResolvers)();
        this._newTokenPromise = promise;
        try {
            resolve(await this._executor(this._newTokenScopeSets));
        } catch (e) {
            reject(e);
        } finally{
            this._newTokenPromise = null;
            this._newTokenScopeSets = [];
            (_a = this._queueExecutor) === null || _a === void 0 || _a.call(this);
        }
        return await promise;
    }
}
module.exports.TokenFetcher = $4ee45c72385008c7$var$TokenFetcher;

});

parcelRegister("5lB76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppTokenAuthProvider = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $7Oold = parcelRequire("7Oold");

var $hfptp = parcelRequire("hfptp");

var $6LWj6 = parcelRequire("6LWj6");
/**
 * An auth provider that gets tokens using client credentials.
 */ let $3e4bb3e605dba848$var$AppTokenAuthProvider = class AppTokenAuthProvider {
    /**
     * Creates a new auth provider to receive an application token with using the client ID and secret.
     *
     * @param clientId The client ID of your application.
     * @param clientSecret The client secret of your application.
     * @param impliedScopes The scopes that are implied for your application,
     * for example an extension that is allowed to access subscriptions.
     */ constructor(clientId, clientSecret, impliedScopes = []){
        this._clientId = clientId;
        this._clientSecret = clientSecret;
        this._impliedScopes = impliedScopes;
        this._fetcher = new $6LWj6.TokenFetcher(async (scopes)=>await this._fetch(scopes));
    }
    /**
     * The client ID.
     */ get clientId() {
        return this._clientId;
    }
    /**
     * The scopes that are currently available using the access token.
     */ get currentScopes() {
        return this._impliedScopes;
    }
    /**
     * Can only get tokens for implied scopes (i.e. extension subscription support).
     *
     * The consumer is expected to take care that this is actually set up in the Twitch developer console.
     *
     * @param user The user to get an access token for.
     * @param scopeSets The requested scopes.
     */ async getAccessTokenForUser(user, ...scopeSets) {
        if (scopeSets.every((scopeSet)=>{
            var _a;
            return (_a = scopeSet === null || scopeSet === void 0 ? void 0 : scopeSet.some((scope)=>this._impliedScopes.includes(scope))) !== null && _a !== void 0 ? _a : true;
        })) {
            const appToken = await this.getAppAccessToken();
            return {
                ...appToken,
                userId: (0, $j0DIQ.extractUserId)(user)
            };
        }
        throw new Error('Can not get user access token for AppTokenAuthProvider');
    }
    /**
     * Throws, because this auth provider does not support user authentication.
     */ getCurrentScopesForUser() {
        return this._impliedScopes;
    }
    /**
     * Fetches an app access token.
     */ async getAnyAccessToken() {
        return await this._fetcher.fetch();
    }
    /**
     * Fetches an app access token.
     *
     * @param forceNew Whether to always get a new token, even if the old one is still deemed valid internally.
     */ async getAppAccessToken(forceNew = false) {
        if (forceNew) this._token = undefined;
        return await this._fetcher.fetch();
    }
    async _fetch(scopeSets) {
        if (scopeSets.length > 0) for (const scopes of scopeSets){
            if (this._impliedScopes.length) {
                if (scopes.every((scope)=>!this._impliedScopes.includes(scope))) throw new Error(`One of the scopes ${scopes.join(', ')} requested but only the scope ${this._impliedScopes.join(', ')} is implied`);
            } else throw new Error(`One of the scopes ${scopes.join(', ')} requested but the client credentials flow does not support scopes`);
        }
        if (!this._token || (0, $7Oold.accessTokenIsExpired)(this._token)) return this._token = await (0, $hfptp.getAppToken)(this._clientId, this._clientSecret);
        return this._token;
    }
};
module.exports.AppTokenAuthProvider = $3e4bb3e605dba848$var$AppTokenAuthProvider;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $3e4bb3e605dba848$var$AppTokenAuthProvider.prototype, "_clientSecret", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $3e4bb3e605dba848$var$AppTokenAuthProvider.prototype, "_token", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $3e4bb3e605dba848$var$AppTokenAuthProvider.prototype, "_fetcher", void 0);
module.exports.AppTokenAuthProvider = $3e4bb3e605dba848$var$AppTokenAuthProvider = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('auth', 'AppTokenAuthProvider', 'clientId')
], $3e4bb3e605dba848$var$AppTokenAuthProvider);

});

parcelRegister("3MTnk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RefreshingAuthProvider = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $da2mc = parcelRequire("da2mc");

var $j0DIQ = parcelRequire("j0DIQ");

var $7Oold = parcelRequire("7Oold");

var $1WdjY = parcelRequire("1WdjY");

var $7Ohsa = parcelRequire("7Ohsa");

var $luukc = parcelRequire("luukc");

var $bWRUw = parcelRequire("bWRUw");

var $hacSE = parcelRequire("hacSE");

var $hfptp = parcelRequire("hfptp");

var $6LWj6 = parcelRequire("6LWj6");
/**
 * An auth provider with the ability to make use of refresh tokens,
 * automatically refreshing the access token whenever necessary.
 */ let $2c20cf2769862815$var$RefreshingAuthProvider = class RefreshingAuthProvider extends $da2mc.EventEmitter {
    /**
     * Creates a new auth provider based on the given one that can automatically
     * refresh access tokens.
     *
     * @param refreshConfig The information necessary to automatically refresh an access token.
     */ constructor(refreshConfig){
        var _a;
        super();
        /** @internal */ this._userAccessTokens = new Map();
        /** @internal */ this._userTokenFetchers = new Map();
        this._intentToUserId = new Map();
        this._userIdToIntents = new Map();
        this._cachedRefreshFailures = new Set();
        /**
         * Fires when a user token is refreshed.
         *
         * @param userId The ID of the user whose token was successfully refreshed.
         * @param token The refreshed token data.
         */ this.onRefresh = this.registerEvent();
        /**
         * Fires when a user token fails to refresh.
         *
         * @param userId The ID of the user whose token wasn't successfully refreshed.
         */ this.onRefreshFailure = this.registerEvent();
        this._clientId = refreshConfig.clientId;
        this._clientSecret = refreshConfig.clientSecret;
        this._redirectUri = refreshConfig.redirectUri;
        this._appImpliedScopes = (_a = refreshConfig.appImpliedScopes) !== null && _a !== void 0 ? _a : [];
        this._appTokenFetcher = new $6LWj6.TokenFetcher(async (scopes)=>await this._fetchAppToken(scopes));
    }
    /**
     * Adds the given user with their corresponding token to the provider.
     *
     * @param user The user to add.
     * @param initialToken The token for the user.
     * @param intents The intents to add to the user.
     *
     * Any intents that were already set before will be overwritten to point to this user instead.
     */ addUser(user, initialToken, intents) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        if (!initialToken.refreshToken) throw new Error(`Trying to add user ${userId} without refresh token`);
        this._cachedRefreshFailures.delete(userId);
        this._userAccessTokens.set(userId, {
            ...initialToken,
            userId: userId
        });
        if (!this._userTokenFetchers.has(userId)) this._userTokenFetchers.set(userId, new $6LWj6.TokenFetcher(async (scopes)=>await this._fetchUserToken(userId, scopes)));
        if (intents) this.addIntentsToUser(user, intents);
    }
    /**
     * Figures out the user associated to the given token and adds them to the provider.
     *
     * If you already know the ID of the user you're adding,
     * consider using {@link RefreshingAuthProvider#addUser} instead.
     *
     * @param initialToken The token for the user.
     * @param intents The intents to add to the user.
     *
     * Any intents that were already set before will be overwritten to point to the associated user instead.
     */ async addUserForToken(initialToken, intents) {
        let tokenWithInfo = null;
        if (initialToken.accessToken && !(0, $7Oold.accessTokenIsExpired)(initialToken)) try {
            const tokenInfo = await (0, $hfptp.getTokenInfo)(initialToken.accessToken);
            tokenWithInfo = [
                initialToken,
                tokenInfo
            ];
        } catch (e) {
            if (!(e instanceof $luukc.InvalidTokenError)) throw e;
        }
        if (!tokenWithInfo) {
            if (!initialToken.refreshToken) throw new $luukc.InvalidTokenError();
            const refreshedToken = await (0, $hfptp.refreshUserToken)(this._clientId, this._clientSecret, initialToken.refreshToken);
            const tokenInfo = await (0, $hfptp.getTokenInfo)(refreshedToken.accessToken);
            this.emit(this.onRefresh, tokenInfo.userId, refreshedToken);
            tokenWithInfo = [
                refreshedToken,
                tokenInfo
            ];
        }
        const [tokenToAdd, tokenInfo] = tokenWithInfo;
        if (!tokenInfo.userId) throw new $bWRUw.InvalidTokenTypeError('Could not determine a user ID for your token; you might be trying to disguise an app token as a user token.');
        const token = tokenToAdd.scope ? tokenToAdd : {
            ...tokenToAdd,
            scope: tokenInfo.scopes
        };
        this.addUser(tokenInfo.userId, token, intents);
        return tokenInfo.userId;
    }
    /**
     * Gets an OAuth token from the given authorization code and adds the user to the provider.
     *
     * An authorization code can be obtained using the
     * [OAuth Authorization Code flow](https://dev.twitch.tv/docs/authentication/getting-tokens-oauth/#authorization-code-grant-flow).
     *
     * @param code The authorization code.
     * @param intents The intents to add to the user.
     *
     * Any intents that were already set before will be overwritten to point to the associated user instead.
     */ async addUserForCode(code, intents) {
        if (!this._redirectUri) throw new Error('This method requires you to pass a `redirectUri` as a configuration property');
        const token = await (0, $hfptp.exchangeCode)(this._clientId, this._clientSecret, code, this._redirectUri);
        return await this.addUserForToken(token, intents);
    }
    /**
     * Checks whether a user was added to the provider.
     *
     * @param user The user to check.
     */ hasUser(user) {
        return this._userTokenFetchers.has((0, $j0DIQ.extractUserId)(user));
    }
    /**
     * Removes a user from the provider.
     *
     * This also makes all intents this user was assigned to unusable.
     *
     * @param user The user to remove.
     */ removeUser(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        if (this._userIdToIntents.has(userId)) {
            const intents = this._userIdToIntents.get(userId);
            for (const intent of intents)this._intentToUserId.delete(intent);
            this._userIdToIntents.delete(userId);
        }
        this._userAccessTokens.delete(userId);
        this._userTokenFetchers.delete(userId);
        this._cachedRefreshFailures.delete(userId);
    }
    /**
     * Adds intents to a user.
     *
     * Any intents that were already set before will be overwritten to point to this user instead.
     *
     * @param user The user to add intents to.
     * @param intents The intents to add to the user.
     */ addIntentsToUser(user, intents) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        if (!this._userAccessTokens.has(userId)) throw new Error('Trying to add intents to a user that was not added to this provider');
        for (const intent of intents){
            if (this._intentToUserId.has(intent)) this._userIdToIntents.get(this._intentToUserId.get(intent)).delete(intent);
            this._intentToUserId.set(intent, userId);
            if (this._userIdToIntents.has(userId)) this._userIdToIntents.get(userId).add(intent);
            else this._userIdToIntents.set(userId, new Set([
                intent
            ]));
        }
    }
    /**
     * Gets all intents assigned to the given user.
     *
     * @param user The user to get intents of.
     */ getIntentsForUser(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return this._userIdToIntents.has(userId) ? Array.from(this._userIdToIntents.get(userId)) : [];
    }
    /**
     * Removes all given intents from any user who they might be assigned to.
     *
     * Intents that have not been assigned are silently ignored.
     *
     * @param intents The intents to remove.
     */ removeIntents(intents) {
        var _a;
        for (const intent of intents)if (this._intentToUserId.has(intent)) {
            const userId = this._intentToUserId.get(intent);
            (_a = this._userIdToIntents.get(userId)) === null || _a === void 0 || _a.delete(intent);
            this._intentToUserId.delete(intent);
        }
    }
    /**
     * Requests that the provider fetches a new token from Twitch for the given user.
     *
     * @param user The user to refresh the token for.
     */ async refreshAccessTokenForUser(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        if (this._cachedRefreshFailures.has(userId)) throw new $1WdjY.CachedRefreshFailureError(userId);
        const previousTokenData = this._userAccessTokens.get(userId);
        if (!previousTokenData) throw new Error('Trying to refresh token for user that was not added to the provider');
        const tokenData = await this._refreshUserTokenWithCallback(userId, previousTokenData.refreshToken);
        this._checkIntermediateUserRemoval(userId);
        this._userAccessTokens.set(userId, {
            ...tokenData,
            userId: userId
        });
        this.emit(this.onRefresh, userId, tokenData);
        return {
            ...tokenData,
            userId: userId
        };
    }
    /**
     * Requests that the provider fetches a new token from Twitch for the given intent.
     *
     * @param intent The intent to refresh the token for.
     */ async refreshAccessTokenForIntent(intent) {
        if (!this._intentToUserId.has(intent)) throw new $hacSE.UnknownIntentError(intent);
        const userId = this._intentToUserId.get(intent);
        return await this.refreshAccessTokenForUser(userId);
    }
    /**
     * The client ID.
     */ get clientId() {
        return this._clientId;
    }
    /**
     * Gets the scopes that are currently available using the access token.
     *
     * @param user The user to get the current scopes for.
     */ getCurrentScopesForUser(user) {
        var _a;
        const token = this._userAccessTokens.get((0, $j0DIQ.extractUserId)(user));
        if (!token) throw new Error('Trying to get scopes for user that was not added to the provider');
        return (_a = token.scope) !== null && _a !== void 0 ? _a : [];
    }
    /**
     * Gets an access token for the given user.
     *
     * @param user The user to get an access token for.
     * @param scopeSets The requested scopes.
     */ async getAccessTokenForUser(user, ...scopeSets) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const fetcher = this._userTokenFetchers.get(userId);
        if (!fetcher) return null;
        if (this._cachedRefreshFailures.has(userId)) throw new $1WdjY.CachedRefreshFailureError(userId);
        (0, $hfptp.compareScopeSets)(this.getCurrentScopesForUser(userId), scopeSets.filter(Boolean));
        return await fetcher.fetch(...scopeSets);
    }
    /**
     * Fetches a token for a user identified by the given intent.
     *
     * @param intent The intent to fetch a token for.
     * @param scopeSets The requested scopes.
     */ async getAccessTokenForIntent(intent, ...scopeSets) {
        if (!this._intentToUserId.has(intent)) return null;
        const userId = this._intentToUserId.get(intent);
        const newToken = await this.getAccessTokenForUser(userId, ...scopeSets);
        if (!newToken) throw new $j0DIQ.HellFreezesOverError(`Found intent ${intent} corresponding to user ID ${userId} but no token was found`);
        return {
            ...newToken,
            userId: userId
        };
    }
    /**
     * Fetches any token to use with a request that supports both user and app tokens,
     * i.e. public data relating to a user.
     *
     * @param user The user.
     */ async getAnyAccessToken(user) {
        if (user) {
            const userId = (0, $j0DIQ.extractUserId)(user);
            if (this._userAccessTokens.has(userId)) {
                const token = await this.getAccessTokenForUser(userId);
                if (!token) throw new $j0DIQ.HellFreezesOverError(`Token for user ID ${userId} exists but nothing was returned by getAccessTokenForUser`);
                return {
                    ...token,
                    userId: userId
                };
            }
        }
        return await this.getAppAccessToken();
    }
    /**
     * Fetches an app access token.
     *
     * @param forceNew Whether to always get a new token, even if the old one is still deemed valid internally.
     */ async getAppAccessToken(forceNew = false) {
        if (forceNew) this._appAccessToken = undefined;
        return await this._appTokenFetcher.fetch(...this._appImpliedScopes.map((scopes)=>[
                scopes
            ]));
    }
    _checkIntermediateUserRemoval(userId) {
        if (!this._userTokenFetchers.has(userId)) {
            this._cachedRefreshFailures.delete(userId);
            throw new $7Ohsa.IntermediateUserRemovalError(userId);
        }
    }
    async _fetchUserToken(userId, scopeSets) {
        const previousToken = this._userAccessTokens.get(userId);
        if (!previousToken) throw new Error('Trying to get token for user that was not added to the provider');
        // if we don't have a current token, we just pass this and refresh right away
        if (previousToken.accessToken && !(0, $7Oold.accessTokenIsExpired)(previousToken)) try {
            // don't create new object on every get
            if (previousToken.scope) {
                (0, $hfptp.compareScopeSets)(previousToken.scope, scopeSets);
                return previousToken;
            }
            const [scope = []] = await (0, $hfptp.loadAndCompareTokenInfo)(this._clientId, previousToken.accessToken, userId, previousToken.scope, scopeSets);
            const newToken = {
                ...previousToken,
                scope: scope
            };
            this._checkIntermediateUserRemoval(userId);
            this._userAccessTokens.set(userId, newToken);
            return newToken;
        } catch (e) {
            // if loading scopes failed, ignore InvalidTokenError and proceed with refreshing
            if (!(e instanceof $luukc.InvalidTokenError)) throw e;
        }
        this._checkIntermediateUserRemoval(userId);
        const refreshedToken = await this.refreshAccessTokenForUser(userId);
        (0, $hfptp.compareScopeSets)(refreshedToken.scope, scopeSets);
        return refreshedToken;
    }
    async _refreshUserTokenWithCallback(userId, refreshToken) {
        try {
            return await (0, $hfptp.refreshUserToken)(this.clientId, this._clientSecret, refreshToken);
        } catch (e) {
            this._cachedRefreshFailures.add(userId);
            this.emit(this.onRefreshFailure, userId, e);
            throw e;
        }
    }
    async _fetchAppToken(scopeSets) {
        if (scopeSets.length > 0) for (const scopes of scopeSets){
            if (this._appImpliedScopes.length) {
                if (scopes.every((scope)=>!this._appImpliedScopes.includes(scope))) throw new Error(`One of the scopes ${scopes.join(', ')} requested but only the scope ${this._appImpliedScopes.join(', ')} is implied`);
            } else throw new Error(`One of the scopes ${scopes.join(', ')} requested but the client credentials flow does not support scopes`);
        }
        if (!this._appAccessToken || (0, $7Oold.accessTokenIsExpired)(this._appAccessToken)) return await this._refreshAppToken();
        return this._appAccessToken;
    }
    async _refreshAppToken() {
        return this._appAccessToken = await (0, $hfptp.getAppToken)(this._clientId, this._clientSecret);
    }
};
module.exports.RefreshingAuthProvider = $2c20cf2769862815$var$RefreshingAuthProvider;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2c20cf2769862815$var$RefreshingAuthProvider.prototype, "_clientSecret", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2c20cf2769862815$var$RefreshingAuthProvider.prototype, "_userAccessTokens", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2c20cf2769862815$var$RefreshingAuthProvider.prototype, "_userTokenFetchers", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2c20cf2769862815$var$RefreshingAuthProvider.prototype, "_appAccessToken", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2c20cf2769862815$var$RefreshingAuthProvider.prototype, "_appTokenFetcher", void 0);
module.exports.RefreshingAuthProvider = $2c20cf2769862815$var$RefreshingAuthProvider = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('auth', 'RefreshingAuthProvider', 'clientId')
], $2c20cf2769862815$var$RefreshingAuthProvider);

});
parcelRegister("1WdjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CachedRefreshFailureError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever you try to execute an action in the context of a user
 * who is already known to have an invalid token saved in its {@link AuthProvider}.
 */ class $16958a8c7f839567$var$CachedRefreshFailureError extends $j0DIQ.CustomError {
    constructor(userId){
        super(`The user context for the user ${userId} has been disabled.
This happened because the access token became invalid (e.g. by expiry) and refreshing it failed (e.g. because the account's password was changed).

Use .addUser(), .addUserForToken() or .addUserForCode() for the same user context to re-enable the user with a new, valid token.`);
        this.userId = userId;
    }
}
module.exports.CachedRefreshFailureError = $16958a8c7f839567$var$CachedRefreshFailureError;

});

parcelRegister("7Ohsa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntermediateUserRemovalError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever a user is removed from an {@link AuthProvider}
 * and at the same time you try to execute an action in that user's context.
 */ class $5afabdc871a15f60$var$IntermediateUserRemovalError extends $j0DIQ.CustomError {
    constructor(userId){
        super(`User ${userId} was removed while trying to fetch a token.

Make sure you're not executing any actions when you want to remove a user.`);
        this.userId = userId;
    }
}
module.exports.IntermediateUserRemovalError = $5afabdc871a15f60$var$IntermediateUserRemovalError;

});

parcelRegister("hacSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownIntentError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown when an intent is requested that was not recognized by the {@link AuthProvider}.
 */ class $c7ed5c9e5695d1ae$var$UnknownIntentError extends $j0DIQ.CustomError {
    /** @private */ constructor(intent){
        super(`Unknown intent: ${intent}`);
        this.intent = intent;
    }
}
module.exports.UnknownIntentError = $c7ed5c9e5695d1ae$var$UnknownIntentError;

});


parcelRegister("5yFCY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StaticAuthProvider = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $hfptp = parcelRequire("hfptp");
/**
 * An auth provider that always returns the same initially given credentials.
 *
 * You are advised to roll your own auth provider that can handle scope upgrades,
 * or to plan ahead and supply only access tokens that account for all scopes
 * you will ever need.
 */ let $40c06b153aa3089a$var$StaticAuthProvider = class StaticAuthProvider {
    /**
     * Creates a new auth provider with static credentials.
     *
     * @param clientId The client ID of your application.
     * @param accessToken The access token to provide.
     *
     * You need to obtain one using one of the [Twitch OAuth flows](https://dev.twitch.tv/docs/authentication/getting-tokens-oauth/).
     * @param scopes The scopes the supplied token has.
     *
     * If this argument is given, the scopes need to be correct, or weird things might happen. If it's not (i.e. it's `undefined`), we fetch the correct scopes for you.
     *
     * If you can't exactly say which scopes your token has, don't use this parameter/set it to `undefined`.
     */ constructor(clientId, accessToken, scopes){
        this._clientId = clientId || '';
        this._accessToken = typeof accessToken === 'string' ? {
            accessToken: accessToken,
            refreshToken: null,
            scope: scopes !== null && scopes !== void 0 ? scopes : [],
            expiresIn: null,
            obtainmentTimestamp: Date.now()
        } : accessToken;
        this._scopes = scopes;
    }
    /**
     * The client ID.
     */ get clientId() {
        return this._clientId;
    }
    /**
     * Gets the static access token.
     *
     * If the current access token does not have the requested scopes, this method throws.
     * This makes supplying an access token with the correct scopes from the beginning necessary.
     *
     * @param user Ignored.
     * @param scopeSets The requested scopes.
     */ async getAccessTokenForUser(user, ...scopeSets) {
        return await this._getAccessToken(scopeSets);
    }
    /**
     * Gets the static access token.
     *
     * If the current access token does not have the requested scopes, this method throws.
     * This makes supplying an access token with the correct scopes from the beginning necessary.
     *
     * @param intent Ignored.
     * @param scopeSets The requested scopes.
     */ async getAccessTokenForIntent(intent, ...scopeSets) {
        return await this._getAccessToken(scopeSets);
    }
    /**
     * Gets the static access token.
     */ async getAnyAccessToken() {
        return await this._getAccessToken();
    }
    /**
     * The scopes that are currently available using the access token.
     */ getCurrentScopesForUser() {
        var _a;
        return (_a = this._scopes) !== null && _a !== void 0 ? _a : [];
    }
    async _getAccessToken(requestedScopeSets) {
        const [scopes, userId] = await (0, $hfptp.loadAndCompareTokenInfo)(this._clientId, this._accessToken.accessToken, this._userId, this._scopes, requestedScopeSets);
        this._scopes = scopes;
        this._userId = userId;
        return {
            ...this._accessToken,
            userId: userId
        };
    }
};
module.exports.StaticAuthProvider = $40c06b153aa3089a$var$StaticAuthProvider;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $40c06b153aa3089a$var$StaticAuthProvider.prototype, "_clientId", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $40c06b153aa3089a$var$StaticAuthProvider.prototype, "_accessToken", void 0);
module.exports.StaticAuthProvider = $40c06b153aa3089a$var$StaticAuthProvider = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('auth', 'StaticAuthProvider', 'clientId')
], $40c06b153aa3089a$var$StaticAuthProvider);

});


parcelRegister("jhTom", function(module, exports) {

module.exports = (parcelRequire("7tzHO"));

});
parcelRegister("7tzHO", function(module, exports) {

var $dO3In = parcelRequire("dO3In");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $dO3In(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("dO3In", function(module, exports) {
function $a0d2d391900010e2$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $a0d2d391900010e2$var$RetryOperation;
$a0d2d391900010e2$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$a0d2d391900010e2$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$a0d2d391900010e2$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$a0d2d391900010e2$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$a0d2d391900010e2$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$a0d2d391900010e2$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$a0d2d391900010e2$var$RetryOperation.prototype.start = $a0d2d391900010e2$var$RetryOperation.prototype.try;
$a0d2d391900010e2$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$a0d2d391900010e2$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$a0d2d391900010e2$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});



parcelRegister("kVdhx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBitsApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $gcAlN = parcelRequire("gcAlN");

var $lq7i7 = parcelRequire("lq7i7");

var $dtRP8 = parcelRequire("dtRP8");

var $9f9vS = parcelRequire("9f9vS");
/**
 * The Helix API methods that deal with bits.
 *
 * Can be accessed using `client.bits` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const leaderboard = await api.bits.getLeaderboard({ period: 'day' });
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Bits
 */ let $f3b36f02c7551b2e$var$HelixBitsApi = class HelixBitsApi extends $lq7i7.BaseApi {
    /**
     * Gets a bits leaderboard of your channel.
     *
     * @param broadcaster The user to get the leaderboard of.
     * @param params
     * @expandParams
     */ async getLeaderboard(broadcaster, params = {}) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'bits/leaderboard',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'bits:read'
            ],
            query: (0, $gcAlN.createBitsLeaderboardQuery)(params)
        });
        return new $dtRP8.HelixBitsLeaderboard(result, this._client);
    }
    /**
     * Gets all available cheermotes.
     *
     * @param broadcaster The broadcaster to include custom cheermotes of.
     *
     * If not given, only get global cheermotes.
     */ async getCheermotes(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'bits/cheermotes',
            userId: (0, $bRvJY.mapOptional)(broadcaster, $j0DIQ.extractUserId),
            query: (0, $bRvJY.mapOptional)(broadcaster, $4ojlB.createBroadcasterQuery)
        });
        return new $9f9vS.HelixCheermoteList(result.data);
    }
};
module.exports.HelixBitsApi = $f3b36f02c7551b2e$var$HelixBitsApi;
module.exports.HelixBitsApi = $f3b36f02c7551b2e$var$HelixBitsApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixBitsApi')
], $f3b36f02c7551b2e$var$HelixBitsApi);

});
parcelRegister("gcAlN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createBitsLeaderboardQuery = void 0;
/** @internal */ function $bcb9f6c782b0c5f3$var$createBitsLeaderboardQuery(params = {}) {
    const { count: count = 10, period: period = 'all', startDate: startDate, contextUserId: contextUserId } = params;
    return {
        count: count.toString(),
        period: period,
        started_at: startDate === null || startDate === void 0 ? void 0 : startDate.toISOString(),
        user_id: contextUserId
    };
}
module.exports.createBitsLeaderboardQuery = $bcb9f6c782b0c5f3$var$createBitsLeaderboardQuery;

});

parcelRegister("lq7i7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");
/** @private */ class $f981ae9547c585dc$var$BaseApi {
    /** @internal */ constructor(client){
        this._client = client;
    }
    /** @internal */ _getUserContextIdWithDefault(userId) {
        var _a;
        return (_a = this._client._getUserIdFromRequestContext(userId)) !== null && _a !== void 0 ? _a : userId;
    }
}
module.exports.BaseApi = $f981ae9547c585dc$var$BaseApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $f981ae9547c585dc$var$BaseApi.prototype, "_client", void 0);

});

parcelRegister("dtRP8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBitsLeaderboard = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $cKhNr = parcelRequire("cKhNr");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $h51sN = parcelRequire("h51sN");
/**
 * A leaderboard where the users who used the most bits to a broadcaster are listed.
 */ let $9d07bc0fbb00488d$var$HelixBitsLeaderboard = class HelixBitsLeaderboard extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The entries of the leaderboard.
     */ get entries() {
        return this[$j0DIQ.rawDataSymbol].data.map((entry)=>new $h51sN.HelixBitsLeaderboardEntry(entry, this._client));
    }
    /**
     * The total amount of people on the requested leaderboard.
     */ get totalCount() {
        return this[$j0DIQ.rawDataSymbol].total;
    }
};
module.exports.HelixBitsLeaderboard = $9d07bc0fbb00488d$var$HelixBitsLeaderboard;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $9d07bc0fbb00488d$var$HelixBitsLeaderboard.prototype, "_client", void 0);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $9d07bc0fbb00488d$var$HelixBitsLeaderboard.prototype, "entries", null);
module.exports.HelixBitsLeaderboard = $9d07bc0fbb00488d$var$HelixBitsLeaderboard = $ceFTv.__decorate([
    $cKhNr.Cacheable,
    (0, $j0DIQ.rtfm)('api', 'HelixBitsLeaderboard')
], $9d07bc0fbb00488d$var$HelixBitsLeaderboard);

});
parcelRegister("h51sN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBitsLeaderboardEntry = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Bits leaderboard entry.
 */ let $c6f409eb7587af1c$var$HelixBitsLeaderboardEntry = class HelixBitsLeaderboardEntry extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user on the leaderboard.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user on the leaderboard.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user on the leaderboard.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * The position of the user on the leaderboard.
     */ get rank() {
        return this[$j0DIQ.rawDataSymbol].rank;
    }
    /**
     * The amount of bits used in the given period of time.
     */ get amount() {
        return this[$j0DIQ.rawDataSymbol].score;
    }
    /**
     * Gets the user of entry on the leaderboard.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixBitsLeaderboardEntry = $c6f409eb7587af1c$var$HelixBitsLeaderboardEntry;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c6f409eb7587af1c$var$HelixBitsLeaderboardEntry.prototype, "_client", void 0);
module.exports.HelixBitsLeaderboardEntry = $c6f409eb7587af1c$var$HelixBitsLeaderboardEntry = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixBitsLeaderboardEntry', 'userId')
], $c6f409eb7587af1c$var$HelixBitsLeaderboardEntry);

});


parcelRegister("9f9vS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCheermoteList = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A list of cheermotes you can use globally or in a specific channel, depending on how you fetched the list.
 *
 * @inheritDoc
 */ let $6bace4dfbfbed61f$var$HelixCheermoteList = class HelixCheermoteList extends $j0DIQ.DataObject {
    /** @internal */ constructor(data){
        super((0, $bRvJY.indexBy)(data, (action)=>action.prefix.toLowerCase()));
    }
    /**
     * Gets the URL and color needed to properly represent a cheer of the given amount of bits with the given prefix.
     *
     * @param name The name/prefix of the cheermote.
     * @param bits The amount of bits cheered.
     * @param format The format of the cheermote you want to request.
     */ getCheermoteDisplayInfo(name, bits, format) {
        name = name.toLowerCase();
        const { background: background, state: state, scale: scale } = format;
        const { tiers: tiers } = this[$j0DIQ.rawDataSymbol][name];
        const correctTier = tiers.sort((a, b)=>b.min_bits - a.min_bits).find((tier)=>tier.min_bits <= bits);
        if (!correctTier) throw new $j0DIQ.HellFreezesOverError(`Cheermote "${name}" does not have an applicable tier for ${bits} bits`);
        return {
            url: correctTier.images[background][state][scale],
            color: correctTier.color
        };
    }
    /**
     * Gets all possible cheermote names.
     */ getPossibleNames() {
        return Object.keys(this[$j0DIQ.rawDataSymbol]);
    }
};
module.exports.HelixCheermoteList = $6bace4dfbfbed61f$var$HelixCheermoteList;
module.exports.HelixCheermoteList = $6bace4dfbfbed61f$var$HelixCheermoteList = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCheermoteList')
], $6bace4dfbfbed61f$var$HelixCheermoteList);

});


parcelRegister("1pTlx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $k0o6h = parcelRequire("k0o6h");

var $78zDw = parcelRequire("78zDw");

var $4yKj5 = parcelRequire("4yKj5");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $4W0OK = parcelRequire("4W0OK");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $2LWVd = parcelRequire("2LWVd");

var $gezBp = parcelRequire("gezBp");

var $gILEY = parcelRequire("gILEY");

var $1AUc7 = parcelRequire("1AUc7");

var $eLzWu = parcelRequire("eLzWu");

var $l5sc0 = parcelRequire("l5sc0");
/**
 * The Helix API methods that deal with channels.
 *
 * Can be accessed using `client.channels` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const channel = await api.channels.getChannelInfoById('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Channels
 */ let $10830ee4fac97e99$var$HelixChannelApi = class HelixChannelApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getChannelByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'channels'
        }, 'broadcaster_id', 'broadcaster_id', this._client, (data)=>new $2LWVd.HelixChannel(data, this._client));
    }
    /**
     * Gets the channel data for the given user.
     *
     * @param user The user you want to get channel info for.
     */ async getChannelInfoById(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels',
            userId: userId,
            query: (0, $4ojlB.createBroadcasterQuery)(userId)
        });
        return (0, $bRvJY.mapNullable)(result.data[0], (data)=>new $2LWVd.HelixChannel(data, this._client));
    }
    /**
     * Gets the channel data for the given user, batching multiple calls into fewer requests as the API allows.
     *
     * @param user The user you want to get channel info for.
     */ async getChannelInfoByIdBatched(user) {
        return await this._getChannelByIdBatcher.request((0, $j0DIQ.extractUserId)(user));
    }
    /**
     * Gets the channel data for the given users.
     *
     * @param users The users you want to get channel info for.
     */ async getChannelInfoByIds(users) {
        const userIds = users.map($j0DIQ.extractUserId);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels',
            query: (0, $78zDw.createSingleKeyQuery)('broadcaster_id', userIds)
        });
        return result.data.map((data)=>new $2LWVd.HelixChannel(data, this._client));
    }
    /**
     * Updates the given user's channel data.
     *
     * @param user The user you want to update channel info for.
     * @param data The channel info to set.
     */ async updateChannelInfo(user, data) {
        await this._client.callApi({
            type: 'helix',
            url: 'channels',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'channel:manage:broadcast'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(user),
            jsonBody: (0, $k0o6h.createChannelUpdateBody)(data)
        });
    }
    /**
     * Starts a commercial on a channel.
     *
     * @param broadcaster The broadcaster on whose channel the commercial is started.
     * @param length The length of the commercial, in seconds.
     */ async startChannelCommercial(broadcaster, length) {
        await this._client.callApi({
            type: 'helix',
            url: 'channels/commercial',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:edit:commercial'
            ],
            jsonBody: (0, $k0o6h.createChannelCommercialBody)(broadcaster, length)
        });
    }
    /**
     * Gets a list of users who have editor permissions on your channel.
     *
     * @param broadcaster The broadcaster to retreive the editors for.
     */ async getChannelEditors(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels/editors',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:editors'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return result.data.map((data)=>new $gezBp.HelixChannelEditor(data, this._client));
    }
    /**
     * Gets a list of VIPs in a channel.
     *
     * @param broadcaster The owner of the channel to get VIPs for.
     * @param pagination
     *
     * @expandParams
     */ async getVips(broadcaster, pagination) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'channels/vips',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:vips',
                'channel:manage:vips'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(response, $4yKj5.HelixUserRelation, this._client);
    }
    /**
     * Creates a paginator for VIPs in a channel.
     *
     * @param broadcaster The owner of the channel to get VIPs for.
     */ getVipsPaginated(broadcaster) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'channels/vips',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:vips',
                'channel:manage:vips'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        }, this._client, (data)=>new $4yKj5.HelixUserRelation(data, this._client));
    }
    /**
     * Checks the VIP status of a list of users in a channel.
     *
     * @param broadcaster The owner of the channel to check VIP status in.
     * @param users The users to check.
     */ async checkVipForUsers(broadcaster, users) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'channels/vips',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:vips',
                'channel:manage:vips'
            ],
            query: (0, $78zDw.createChannelUsersCheckQuery)(broadcaster, users)
        });
        return response.data.map((data)=>new $4yKj5.HelixUserRelation(data, this._client));
    }
    /**
     * Checks the VIP status of a user in a channel.
     *
     * @param broadcaster The owner of the channel to check VIP status in.
     * @param user The user to check.
     */ async checkVipForUser(broadcaster, user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this.checkVipForUsers(broadcaster, [
            userId
        ]);
        return result.some((rel)=>rel.id === userId);
    }
    /**
     * Adds a VIP to the broadcaster’s chat room.
     *
     * @param broadcaster The broadcaster that’s granting VIP status to the user. This ID must match the user ID in the access token.
     * @param user The user to add as a VIP in the broadcaster’s chat room.
     */ async addVip(broadcaster, user) {
        await this._client.callApi({
            type: 'helix',
            url: 'channels/vips',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:vips'
            ],
            query: (0, $k0o6h.createChannelVipUpdateQuery)(broadcaster, user)
        });
    }
    /**
     * Removes a VIP from the broadcaster’s chat room.
     *
     * @param broadcaster The broadcaster that’s removing VIP status from the user. This ID must match the user ID in the access token.
     * @param user The user to remove as a VIP from the broadcaster’s chat room.
     */ async removeVip(broadcaster, user) {
        await this._client.callApi({
            type: 'helix',
            url: 'channels/vips',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:vips'
            ],
            query: (0, $k0o6h.createChannelVipUpdateQuery)(broadcaster, user)
        });
    }
    /**
     * Gets the total number of users that follow the specified broadcaster.
     *
     * @param broadcaster The broadcaster you want to get the number of followers of.
     */ async getChannelFollowerCount(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels/followers',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: {
                ...(0, $k0o6h.createChannelFollowerQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)({
                    limit: 1
                })
            }
        });
        return result.total;
    }
    /**
     * Gets a list of users that follow the specified broadcaster.
     * You can also use this endpoint to see whether a specific user follows the broadcaster.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster you want to get a list of followers for.
     * @param user An optional user to determine if this user follows the broadcaster.
     * If specified, the response contains this user if they follow the broadcaster.
     * If not specified, the response contains all users that follow the broadcaster.
     * @param pagination
     *
     * @expandParams
     */ async getChannelFollowers(broadcaster, user, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels/followers',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:read:followers'
            ],
            query: {
                ...(0, $k0o6h.createChannelFollowerQuery)(broadcaster, user),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResultWithTotal)(result, $gILEY.HelixChannelFollower, this._client);
    }
    /**
     * Creates a paginator for users that follow the specified broadcaster.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster for whom you are getting a list of followers.
     *
     * @expandParams
     */ getChannelFollowersPaginated(broadcaster) {
        return new $4W0OK.HelixPaginatedRequestWithTotal({
            url: 'channels/followers',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:read:followers'
            ],
            query: (0, $k0o6h.createChannelFollowerQuery)(broadcaster)
        }, this._client, (data)=>new $gILEY.HelixChannelFollower(data, this._client));
    }
    /**
     * Gets a list of broadcasters that the specified user follows.
     * You can also use this endpoint to see whether the user follows a specific broadcaster.
     *
     * @param user The user that's getting a list of followed channels.
     * This ID must match the user ID in the access token.
     * @param broadcaster An optional broadcaster to determine if the user follows this broadcaster.
     * If specified, the response contains this broadcaster if the user follows them.
     * If not specified, the response contains all broadcasters that the user follows.
     * @param pagination
     * @returns
     */ async getFollowedChannels(user, broadcaster, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channels/followed',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:follows'
            ],
            query: {
                ...(0, $k0o6h.createFollowedChannelQuery)(user, broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResultWithTotal)(result, $1AUc7.HelixFollowedChannel, this._client);
    }
    /**
     * Creates a paginator for broadcasters that the specified user follows.
     *
     * @param user The user that's getting a list of followed channels.
     * The token of this user will be used to get the list of followed channels.
     * @param broadcaster An optional broadcaster to determine if the user follows this broadcaster.
     * If specified, the response contains this broadcaster if the user follows them.
     * If not specified, the response contains all broadcasters that the user follows.
     * @returns
     */ getFollowedChannelsPaginated(user, broadcaster) {
        return new $4W0OK.HelixPaginatedRequestWithTotal({
            url: 'channels/followed',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:follows'
            ],
            query: (0, $k0o6h.createFollowedChannelQuery)(user, broadcaster)
        }, this._client, (data)=>new $1AUc7.HelixFollowedChannel(data, this._client));
    }
    /**
     * Gets information about the broadcaster's ad schedule.
     *
     * @param broadcaster The broadcaster to get ad schedule information about.
     */ async getAdSchedule(broadcaster) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'channels/ads',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:ads'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return new $eLzWu.HelixAdSchedule(response.data[0]);
    }
    /**
     * Snoozes the broadcaster's next ad, if a snooze is available.
     *
     * @param broadcaster The broadcaster to get ad schedule information about.
     */ async snoozeNextAd(broadcaster) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'channels/ads/schedule/snooze',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:ads'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return new $l5sc0.HelixSnoozeNextAdResult(response.data[0]);
    }
};
module.exports.HelixChannelApi = $10830ee4fac97e99$var$HelixChannelApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $10830ee4fac97e99$var$HelixChannelApi.prototype, "_getChannelByIdBatcher", void 0);
module.exports.HelixChannelApi = $10830ee4fac97e99$var$HelixChannelApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelApi')
], $10830ee4fac97e99$var$HelixChannelApi);

});
parcelRegister("k0o6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFollowedChannelQuery = module.exports.createChannelFollowerQuery = module.exports.createChannelVipUpdateQuery = module.exports.createChannelCommercialBody = module.exports.createChannelUpdateBody = void 0;

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $e9068090c6713d0e$var$createChannelUpdateBody(data) {
    var _a;
    return {
        game_id: data.gameId,
        broadcaster_language: data.language,
        title: data.title,
        delay: (_a = data.delay) === null || _a === void 0 ? void 0 : _a.toString(),
        tags: data.tags,
        content_classification_labels: data.contentClassificationLabels,
        is_branded_content: data.isBrandedContent
    };
}
module.exports.createChannelUpdateBody = $e9068090c6713d0e$var$createChannelUpdateBody;
/** @internal */ function $e9068090c6713d0e$var$createChannelCommercialBody(broadcaster, length) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        length: length
    };
}
module.exports.createChannelCommercialBody = $e9068090c6713d0e$var$createChannelCommercialBody;
/** @internal */ function $e9068090c6713d0e$var$createChannelVipUpdateQuery(broadcaster, user) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        user_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createChannelVipUpdateQuery = $e9068090c6713d0e$var$createChannelVipUpdateQuery;
/** @internal */ function $e9068090c6713d0e$var$createChannelFollowerQuery(broadcaster, user) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        user_id: (0, $bRvJY.mapOptional)(user, $j0DIQ.extractUserId)
    };
}
module.exports.createChannelFollowerQuery = $e9068090c6713d0e$var$createChannelFollowerQuery;
/** @internal */ function $e9068090c6713d0e$var$createFollowedChannelQuery(user, broadcaster) {
    return {
        broadcaster_id: (0, $bRvJY.mapOptional)(broadcaster, $j0DIQ.extractUserId),
        user_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createFollowedChannelQuery = $e9068090c6713d0e$var$createFollowedChannelQuery;

});

parcelRegister("78zDw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createChannelUsersCheckQuery = module.exports.createGetByIdsQuery = module.exports.createModeratorActionQuery = module.exports.createUserQuery = module.exports.createSingleKeyQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $5324ec6c9e8f1584$var$createSingleKeyQuery(key, value) {
    return {
        [key]: value
    };
}
module.exports.createSingleKeyQuery = $5324ec6c9e8f1584$var$createSingleKeyQuery;
/** @internal */ function $5324ec6c9e8f1584$var$createUserQuery(user) {
    return {
        user_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createUserQuery = $5324ec6c9e8f1584$var$createUserQuery;
/** @internal */ function $5324ec6c9e8f1584$var$createModeratorActionQuery(broadcaster, moderatorId) {
    return {
        broadcaster_id: broadcaster,
        moderator_id: moderatorId
    };
}
module.exports.createModeratorActionQuery = $5324ec6c9e8f1584$var$createModeratorActionQuery;
/** @internal */ function $5324ec6c9e8f1584$var$createGetByIdsQuery(broadcaster, rewardIds) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        id: rewardIds
    };
}
module.exports.createGetByIdsQuery = $5324ec6c9e8f1584$var$createGetByIdsQuery;
/** @internal */ function $5324ec6c9e8f1584$var$createChannelUsersCheckQuery(broadcaster, users) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        user_id: users.map($j0DIQ.extractUserId)
    };
}
module.exports.createChannelUsersCheckQuery = $5324ec6c9e8f1584$var$createChannelUsersCheckQuery;

});

parcelRegister("4yKj5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserRelation = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A relation of anything with a user.
 */ let $351e41fd77229171$var$HelixUserRelation = class HelixUserRelation extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets additional information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixUserRelation = $351e41fd77229171$var$HelixUserRelation;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $351e41fd77229171$var$HelixUserRelation.prototype, "_client", void 0);
module.exports.HelixUserRelation = $351e41fd77229171$var$HelixUserRelation = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserRelation', 'id')
], $351e41fd77229171$var$HelixUserRelation);

});

parcelRegister("4p0mB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixRequestBatcher = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");
/** @internal */ class $3349c76754e9dd83$var$HelixRequestBatcher {
    constructor(_callOptions, _queryParamName, _matchKey, client, _mapper, _limitPerRequest = 100){
        this._callOptions = _callOptions;
        this._queryParamName = _queryParamName;
        this._matchKey = _matchKey;
        this._mapper = _mapper;
        this._limitPerRequest = _limitPerRequest;
        this._requestedIds = [];
        this._requestResolversById = new Map();
        this._waitTimer = null;
        this._client = client;
        this._delay = client._batchDelay;
    }
    async request(id) {
        const { promise: promise, resolve: resolve, reject: reject } = (0, $bRvJY.promiseWithResolvers)();
        if (!this._requestedIds.includes(id)) this._requestedIds.push(id);
        if (this._requestResolversById.has(id)) this._requestResolversById.get(id).push({
            resolve: resolve,
            reject: reject
        });
        else this._requestResolversById.set(id, [
            {
                resolve: resolve,
                reject: reject
            }
        ]);
        if (this._waitTimer) {
            clearTimeout(this._waitTimer);
            this._waitTimer = null;
        }
        if (this._requestedIds.length >= this._limitPerRequest) this._handleBatch(this._requestedIds.splice(0, this._limitPerRequest));
        else this._waitTimer = setTimeout(()=>{
            this._handleBatch(this._requestedIds.splice(0, this._limitPerRequest));
        }, this._delay);
        return await promise;
    }
    async _handleBatch(ids) {
        var _a;
        try {
            const { data: data } = await this._doRequest(ids);
            const dataById = (0, $bRvJY.indexBy)(data, this._matchKey);
            for (const id of ids){
                for (const resolver of (_a = this._requestResolversById.get(id)) !== null && _a !== void 0 ? _a : [])if (Object.prototype.hasOwnProperty.call(dataById, id)) resolver.resolve(this._mapper(dataById[id]));
                else resolver.resolve(null);
                this._requestResolversById.delete(id);
            }
        } catch (e) {
            await Promise.all(ids.map(async (id)=>{
                var _a, _b;
                try {
                    const result = await this._doRequest([
                        id
                    ]);
                    for (const resolver of (_a = this._requestResolversById.get(id)) !== null && _a !== void 0 ? _a : [])resolver.resolve(result.data.length ? this._mapper(result.data[0]) : null);
                } catch (e_) {
                    for (const resolver of (_b = this._requestResolversById.get(id)) !== null && _b !== void 0 ? _b : [])resolver.reject(e_);
                }
                this._requestResolversById.delete(id);
            }));
        }
    }
    async _doRequest(ids) {
        return await this._client.callApi({
            type: 'helix',
            ...this._callOptions,
            query: {
                ...this._callOptions.query,
                [this._queryParamName]: ids
            }
        });
    }
}
module.exports.HelixRequestBatcher = $3349c76754e9dd83$var$HelixRequestBatcher;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $3349c76754e9dd83$var$HelixRequestBatcher.prototype, "_client", void 0);

});

parcelRegister("6tEA1", function(module, exports) {
"use strict";
var $4b74eddca733aa22$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPaginatedRequest = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
if (!Object.prototype.hasOwnProperty.call(Symbol, 'asyncIterator')) // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unnecessary-condition,@typescript-eslint/no-unsafe-member-access
Symbol.asyncIterator = ($4b74eddca733aa22$var$_a = Symbol.asyncIterator) !== null && $4b74eddca733aa22$var$_a !== void 0 ? $4b74eddca733aa22$var$_a : Symbol.for('Symbol.asyncIterator');
/**
 * Represents a request to the new Twitch API (Helix) that utilizes a cursor to paginate through its results.
 *
 * Aside from the methods described below, you can also utilize the async iterator using `for await .. of`:
 *
 * ```ts
 * const result = client.videos.getVideosByUserPaginated('125328655');
 * for await (const video of result) {
 *     console.log(video.title);
 * }
 * ```
 */ let $4b74eddca733aa22$var$HelixPaginatedRequest = class HelixPaginatedRequest {
    /** @internal */ constructor(_callOptions, client, _mapper, _limitPerPage = 100){
        this._callOptions = _callOptions;
        this._mapper = _mapper;
        this._limitPerPage = _limitPerPage;
        /** @internal */ this._isFinished = false;
        this._client = client;
    }
    /**
     * The last fetched page of data associated to the requested resource.
     *
     * Only works with {@link HelixPaginatedRequest#getNext}} and not with any other methods of data fetching.
     */ get current() {
        var _a;
        return (_a = this._currentData) === null || _a === void 0 ? void 0 : _a.data;
    }
    /**
     * Gets the next available page of data associated to the requested resource, or an empty array if there are no more available pages.
     */ async getNext() {
        var _a;
        if (this._isFinished) return [];
        const result = await this._fetchData();
        // should never be null, but in practice is sometimes
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.length)) {
            this._isFinished = true;
            return [];
        }
        return this._processResult(result);
    }
    /**
     * Gets all data associated to the requested resource.
     *
     * Be aware that this makes multiple calls to the Twitch API. Due to this, you might be more suspectible to rate limits.
     *
     * Also be aware that this resets the internal cursor, so avoid using this and {@link HelixPaginatedRequest#getNext}} together.
     */ async getAll() {
        this.reset();
        const result = [];
        do {
            const data = await this.getNext();
            if (!data.length) break;
            result.push(...data);
        }while (this._currentCursor);
        this.reset();
        return result;
    }
    /**
     * Gets the current cursor.
     *
     * Only useful if you want to make manual requests to the API.
     */ get currentCursor() {
        return this._currentCursor;
    }
    /**
     * Resets the internal cursor.
     *
     * This will make {@link HelixPaginatedRequest#getNext}} start from the first page again.
     */ reset() {
        this._currentCursor = undefined;
        this._isFinished = false;
        this._currentData = undefined;
    }
    async *[Symbol.asyncIterator]() {
        this.reset();
        while(true){
            const data = await this.getNext();
            if (!data.length) break;
            yield* data[Symbol.iterator]();
        }
    }
    /** @internal */ async _fetchData(additionalOptions = {}) {
        return await this._client.callApi({
            type: 'helix',
            ...this._callOptions,
            ...additionalOptions,
            query: {
                ...this._callOptions.query,
                after: this._currentCursor,
                first: this._limitPerPage.toString(),
                ...additionalOptions.query
            }
        });
    }
    /** @internal */ _processResult(result) {
        var _a;
        this._currentCursor = typeof result.pagination === 'string' ? result.pagination : (_a = result.pagination) === null || _a === void 0 ? void 0 : _a.cursor;
        if (this._currentCursor === undefined) this._isFinished = true;
        this._currentData = result;
        return result.data.reduce((acc, elem)=>{
            const mapped = this._mapper(elem);
            return Array.isArray(mapped) ? [
                ...acc,
                ...mapped
            ] : [
                ...acc,
                mapped
            ];
        }, []);
    }
};
module.exports.HelixPaginatedRequest = $4b74eddca733aa22$var$HelixPaginatedRequest;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $4b74eddca733aa22$var$HelixPaginatedRequest.prototype, "_client", void 0);
module.exports.HelixPaginatedRequest = $4b74eddca733aa22$var$HelixPaginatedRequest = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPaginatedRequest')
], $4b74eddca733aa22$var$HelixPaginatedRequest);

});

parcelRegister("4W0OK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPaginatedRequestWithTotal = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $6tEA1 = parcelRequire("6tEA1");
/**
 * A special case of {@link HelixPaginatedRequest} with support for fetching the total number of entities, whenever an endpoint supports it.
 *
 * @inheritDoc
 */ let $397d368ccc68aa9d$var$HelixPaginatedRequestWithTotal = class HelixPaginatedRequestWithTotal extends $6tEA1.HelixPaginatedRequest {
    /**
     * Gets the total number of entities existing in the queried result set.
     */ async getTotalCount() {
        var _a;
        const data = (_a = this._currentData) !== null && _a !== void 0 ? _a : await this._fetchData({
            query: {
                after: undefined
            }
        });
        return data.total;
    }
};
module.exports.HelixPaginatedRequestWithTotal = $397d368ccc68aa9d$var$HelixPaginatedRequestWithTotal;
module.exports.HelixPaginatedRequestWithTotal = $397d368ccc68aa9d$var$HelixPaginatedRequestWithTotal = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPaginatedRequestWithTotal')
], $397d368ccc68aa9d$var$HelixPaginatedRequestWithTotal);

});

parcelRegister("7rg9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createPaginatedResultWithTotal = module.exports.createPaginatedResult = void 0;
/** @internal */ function $56a79643757292ab$var$createPaginatedResult(response, type, client) {
    var _a;
    let dataCache = undefined;
    return {
        get data () {
            var _a1, _b;
            return dataCache !== null && dataCache !== void 0 ? dataCache : dataCache = (_b = (_a1 = response.data) === null || _a1 === void 0 ? void 0 : _a1.map((data)=>new type(data, client))) !== null && _b !== void 0 ? _b : [];
        },
        cursor: typeof response.pagination === 'string' ? response.pagination : (_a = response.pagination) === null || _a === void 0 ? void 0 : _a.cursor
    };
}
module.exports.createPaginatedResult = $56a79643757292ab$var$createPaginatedResult;
/** @internal */ function $56a79643757292ab$var$createPaginatedResultWithTotal(response, type, client) {
    let dataCache = undefined;
    return {
        get data () {
            var _a, _b;
            return dataCache !== null && dataCache !== void 0 ? dataCache : dataCache = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.map((data)=>new type(data, client))) !== null && _b !== void 0 ? _b : [];
        },
        cursor: response.pagination.cursor,
        total: response.total
    };
}
module.exports.createPaginatedResultWithTotal = $56a79643757292ab$var$createPaginatedResultWithTotal;

});

parcelRegister("4AsKM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createPaginationQuery = void 0;
/** @internal */ function $3570d4102a5e88e5$var$createPaginationQuery({ after: after, before: before, limit: limit } = {}) {
    return {
        after: after,
        before: before,
        first: limit === null || limit === void 0 ? void 0 : limit.toString()
    };
}
module.exports.createPaginationQuery = $3570d4102a5e88e5$var$createPaginationQuery;

});

parcelRegister("2LWVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannel = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Twitch channel.
 */ let $204dad2f57ec630a$var$HelixChannel = class HelixChannel extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the channel.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the channel.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the channel.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster of the channel.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The language of the channel.
     */ get language() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_language;
    }
    /**
     * The ID of the game currently played on the channel.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * The name of the game currently played on the channel.
     */ get gameName() {
        return this[$j0DIQ.rawDataSymbol].game_name;
    }
    /**
     * Gets information about the game that is being played on the stream.
     */ async getGame() {
        return this[$j0DIQ.rawDataSymbol].game_id ? (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id)) : null;
    }
    /**
     * The title of the channel.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The stream delay of the channel, in seconds.
     *
     * If you didn't request this with broadcaster access, this is always zero.
     */ get delay() {
        return this[$j0DIQ.rawDataSymbol].delay;
    }
    /**
     * The tags applied to the channel.
     */ get tags() {
        return this[$j0DIQ.rawDataSymbol].tags;
    }
    /**
     * The content classification labels applied to the channel.
     */ get contentClassificationLabels() {
        return this[$j0DIQ.rawDataSymbol].content_classification_labels;
    }
    /**
     * Whether the channel currently displays branded content (as specified by the broadcaster).
     */ get isBrandedContent() {
        return this[$j0DIQ.rawDataSymbol].is_branded_content;
    }
};
module.exports.HelixChannel = $204dad2f57ec630a$var$HelixChannel;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $204dad2f57ec630a$var$HelixChannel.prototype, "_client", void 0);
module.exports.HelixChannel = $204dad2f57ec630a$var$HelixChannel = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannel', 'id')
], $204dad2f57ec630a$var$HelixChannel);

});

parcelRegister("gezBp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelEditor = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An editor of a previously given channel.
 */ let $bd19920dfd1d972b$var$HelixChannelEditor = class HelixChannelEditor extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The display name of the user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets additional information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The date when the user was given editor status.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
};
module.exports.HelixChannelEditor = $bd19920dfd1d972b$var$HelixChannelEditor;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $bd19920dfd1d972b$var$HelixChannelEditor.prototype, "_client", void 0);
module.exports.HelixChannelEditor = $bd19920dfd1d972b$var$HelixChannelEditor = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelEditor', 'userId')
], $bd19920dfd1d972b$var$HelixChannelEditor);

});

parcelRegister("gILEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelFollower = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents a user that follows a channel.
 */ let $c2c5b9aabbe52368$var$HelixChannelFollower = class HelixChannelFollower extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets additional information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The date when the user followed the broadcaster.
     */ get followDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].followed_at);
    }
};
module.exports.HelixChannelFollower = $c2c5b9aabbe52368$var$HelixChannelFollower;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c2c5b9aabbe52368$var$HelixChannelFollower.prototype, "_client", void 0);
module.exports.HelixChannelFollower = $c2c5b9aabbe52368$var$HelixChannelFollower = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelFollower', 'userId')
], $c2c5b9aabbe52368$var$HelixChannelFollower);

});

parcelRegister("1AUc7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixFollowedChannel = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents a broadcaster that a user follows.
 */ let $1294be44c7ebfc6b$var$HelixFollowedChannel = class HelixFollowedChannel extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets additional information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The date when the user followed the broadcaster.
     */ get followDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].followed_at);
    }
};
module.exports.HelixFollowedChannel = $1294be44c7ebfc6b$var$HelixFollowedChannel;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $1294be44c7ebfc6b$var$HelixFollowedChannel.prototype, "_client", void 0);
module.exports.HelixFollowedChannel = $1294be44c7ebfc6b$var$HelixFollowedChannel = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixFollowedChannel', 'broadcasterId')
], $1294be44c7ebfc6b$var$HelixFollowedChannel);

});

parcelRegister("eLzWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixAdSchedule = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents a broadcaster's ad schedule.
 */ let $ac0155dc9d70d6ec$var$HelixAdSchedule = class HelixAdSchedule extends $j0DIQ.DataObject {
    /**
     * The number of snoozes available for the broadcaster.
     */ get snoozeCount() {
        return this[$j0DIQ.rawDataSymbol].snooze_count;
    }
    /**
     * The date and time when the broadcaster will gain an additional snooze.
     * Returns `null` if all snoozes are already available.
     */ get snoozeRefreshDate() {
        return this[$j0DIQ.rawDataSymbol].snooze_refresh_at ? new Date(this[$j0DIQ.rawDataSymbol].snooze_refresh_at * 1000) : null;
    }
    /**
     * The date and time of the broadcaster's next scheduled ad.
     * Returns `null` if channel is not live or has no ad scheduled.
     */ get nextAdDate() {
        return this[$j0DIQ.rawDataSymbol].next_ad_at ? new Date(this[$j0DIQ.rawDataSymbol].next_ad_at * 1000) : null;
    }
    /**
     * The length in seconds of the scheduled upcoming ad break.
     */ get duration() {
        return this[$j0DIQ.rawDataSymbol].duration;
    }
    /**
     * The date and time of the broadcaster's last ad-break.
     * Returns `null` if channel is not live or has not run an ad.
     */ get lastAdDate() {
        return this[$j0DIQ.rawDataSymbol].last_ad_at ? new Date(this[$j0DIQ.rawDataSymbol].last_ad_at * 1000) : null;
    }
    /**
     * The amount of pre-roll free time remaining for the channel in seconds.
     */ get prerollFreeTime() {
        return this[$j0DIQ.rawDataSymbol].preroll_free_time;
    }
};
module.exports.HelixAdSchedule = $ac0155dc9d70d6ec$var$HelixAdSchedule;
module.exports.HelixAdSchedule = $ac0155dc9d70d6ec$var$HelixAdSchedule = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixAdSchedule')
], $ac0155dc9d70d6ec$var$HelixAdSchedule);

});

parcelRegister("l5sc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSnoozeNextAdResult = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents the result after a call to snooze the broadcaster's ad schedule.
 */ let $f59fef12e230f910$var$HelixSnoozeNextAdResult = class HelixSnoozeNextAdResult extends $j0DIQ.DataObject {
    /**
     * The number of snoozes remaining for the broadcaster.
     */ get snoozeCount() {
        return this[$j0DIQ.rawDataSymbol].snooze_count;
    }
    /**
     * The date and time when the broadcaster will gain an additional snooze.
     */ get snoozeRefreshDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].snooze_refresh_at * 1000);
    }
    /**
     * The date and time of the broadcaster's next scheduled ad.
     */ get nextAdDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].next_ad_at * 1000);
    }
};
module.exports.HelixSnoozeNextAdResult = $f59fef12e230f910$var$HelixSnoozeNextAdResult;
module.exports.HelixSnoozeNextAdResult = $f59fef12e230f910$var$HelixSnoozeNextAdResult = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSnoozeNextAdResult')
], $f59fef12e230f910$var$HelixSnoozeNextAdResult);

});


parcelRegister("43yGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelPointsApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $lCOM5 = parcelRequire("lCOM5");

var $78zDw = parcelRequire("78zDw");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $gCXpe = parcelRequire("gCXpe");

var $dmVKA = parcelRequire("dmVKA");
/**
 * The Helix API methods that deal with channel points.
 *
 * Can be accessed using `client.channelPoints` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const rewards = await api.channelPoints.getCustomRewards('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Channel points
 */ let $2f4259bd6d5f3fc8$var$HelixChannelPointsApi = class HelixChannelPointsApi extends $lq7i7.BaseApi {
    /**
     * Gets all custom rewards for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get the rewards for.
     * @param onlyManageable Whether to only get rewards that can be managed by the API.
     */ async getCustomRewards(broadcaster, onlyManageable) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:redemptions',
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createCustomRewardsQuery)(broadcaster, onlyManageable)
        });
        return result.data.map((data)=>new $gCXpe.HelixCustomReward(data, this._client));
    }
    /**
     * Gets custom rewards by IDs.
     *
     * @param broadcaster The broadcaster to get the rewards for.
     * @param rewardIds The IDs of the rewards.
     */ async getCustomRewardsByIds(broadcaster, rewardIds) {
        if (!rewardIds.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:redemptions',
                'channel:manage:redemptions'
            ],
            query: (0, $78zDw.createGetByIdsQuery)(broadcaster, rewardIds)
        });
        return result.data.map((data)=>new $gCXpe.HelixCustomReward(data, this._client));
    }
    /**
     * Gets a custom reward by ID.
     *
     * @param broadcaster The broadcaster to get the reward for.
     * @param rewardId The ID of the reward.
     */ async getCustomRewardById(broadcaster, rewardId) {
        const rewards = await this.getCustomRewardsByIds(broadcaster, [
            rewardId
        ]);
        return rewards.length ? rewards[0] : null;
    }
    /**
     * Creates a new custom reward.
     *
     * @param broadcaster The broadcaster to create the reward for.
     * @param data The reward data.
     *
     * @expandParams
     */ async createCustomReward(broadcaster, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:redemptions'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster),
            jsonBody: (0, $lCOM5.createCustomRewardBody)(data)
        });
        return new $gCXpe.HelixCustomReward(result.data[0], this._client);
    }
    /**
     * Updates a custom reward.
     *
     * @param broadcaster The broadcaster to update the reward for.
     * @param rewardId The ID of the reward.
     * @param data The reward data.
     */ async updateCustomReward(broadcaster, rewardId, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createCustomRewardChangeQuery)(broadcaster, rewardId),
            jsonBody: (0, $lCOM5.createCustomRewardBody)(data)
        });
        return new $gCXpe.HelixCustomReward(result.data[0], this._client);
    }
    /**
     * Deletes a custom reward.
     *
     * @param broadcaster The broadcaster to delete the reward for.
     * @param rewardId The ID of the reward.
     */ async deleteCustomReward(broadcaster, rewardId) {
        await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createCustomRewardChangeQuery)(broadcaster, rewardId)
        });
    }
    /**
     * Gets custom reward redemptions by IDs.
     *
     * @param broadcaster The broadcaster to get the redemptions for.
     * @param rewardId The ID of the reward.
     * @param redemptionIds The IDs of the redemptions.
     */ async getRedemptionsByIds(broadcaster, rewardId, redemptionIds) {
        if (!redemptionIds.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards/redemptions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:redemptions',
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createRewardRedemptionsByIdsQuery)(broadcaster, rewardId, redemptionIds)
        });
        return result.data.map((data)=>new $dmVKA.HelixCustomRewardRedemption(data, this._client));
    }
    /**
     * Gets a custom reward redemption by ID.
     *
     * @param broadcaster The broadcaster to get the redemption for.
     * @param rewardId The ID of the reward.
     * @param redemptionId The ID of the redemption.
     */ async getRedemptionById(broadcaster, rewardId, redemptionId) {
        const redemptions = await this.getRedemptionsByIds(broadcaster, rewardId, [
            redemptionId
        ]);
        return redemptions.length ? redemptions[0] : null;
    }
    /**
     * Gets custom reward redemptions for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get the redemptions for.
     * @param rewardId The ID of the reward.
     * @param status The status of the redemptions to get.
     * @param filter
     *
     * @expandParams
     */ async getRedemptionsForBroadcaster(broadcaster, rewardId, status, filter) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards/redemptions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:redemptions',
                'channel:manage:redemptions'
            ],
            query: {
                ...(0, $lCOM5.createRedemptionsForBroadcasterQuery)(broadcaster, rewardId, status, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $dmVKA.HelixCustomRewardRedemption, this._client);
    }
    /**
     * Creates a paginator for custom reward redemptions for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get the redemptions for.
     * @param rewardId The ID of the reward.
     * @param status The status of the redemptions to get.
     * @param filter
     *
     * @expandParams
     */ getRedemptionsForBroadcasterPaginated(broadcaster, rewardId, status, filter) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'channel_points/custom_rewards/redemptions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:redemptions',
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createRedemptionsForBroadcasterQuery)(broadcaster, rewardId, status, filter)
        }, this._client, (data)=>new $dmVKA.HelixCustomRewardRedemption(data, this._client), 50);
    }
    /**
     * Updates the status of the given redemptions by IDs.
     *
     * @param broadcaster The broadcaster to update the redemptions for.
     * @param rewardId The ID of the reward.
     * @param redemptionIds The IDs of the redemptions to update.
     * @param status The status to set for the redemptions.
     */ async updateRedemptionStatusByIds(broadcaster, rewardId, redemptionIds, status) {
        if (!redemptionIds.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'channel_points/custom_rewards/redemptions',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:redemptions'
            ],
            query: (0, $lCOM5.createRewardRedemptionsByIdsQuery)(broadcaster, rewardId, redemptionIds),
            jsonBody: {
                status: status
            }
        });
        return result.data.map((data)=>new $dmVKA.HelixCustomRewardRedemption(data, this._client));
    }
};
module.exports.HelixChannelPointsApi = $2f4259bd6d5f3fc8$var$HelixChannelPointsApi;
module.exports.HelixChannelPointsApi = $2f4259bd6d5f3fc8$var$HelixChannelPointsApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelPointsApi')
], $2f4259bd6d5f3fc8$var$HelixChannelPointsApi);

});
parcelRegister("lCOM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRedemptionsForBroadcasterQuery = module.exports.createRewardRedemptionsByIdsQuery = module.exports.createCustomRewardBody = module.exports.createCustomRewardChangeQuery = module.exports.createCustomRewardsQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $fbe4885f58f3d033$var$createCustomRewardsQuery(broadcaster, onlyManageable) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        only_manageable_rewards: onlyManageable === null || onlyManageable === void 0 ? void 0 : onlyManageable.toString()
    };
}
module.exports.createCustomRewardsQuery = $fbe4885f58f3d033$var$createCustomRewardsQuery;
/** @internal */ function $fbe4885f58f3d033$var$createCustomRewardChangeQuery(broadcaster, rewardId) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        id: rewardId
    };
}
module.exports.createCustomRewardChangeQuery = $fbe4885f58f3d033$var$createCustomRewardChangeQuery;
/** @internal */ function $fbe4885f58f3d033$var$createCustomRewardBody(data) {
    var _a, _b, _c;
    const result = {
        title: data.title,
        cost: data.cost,
        prompt: data.prompt,
        background_color: data.backgroundColor,
        is_enabled: data.isEnabled,
        is_user_input_required: data.userInputRequired,
        should_redemptions_skip_request_queue: data.autoFulfill
    };
    if (data.maxRedemptionsPerStream !== undefined) {
        result.is_max_per_stream_enabled = !!data.maxRedemptionsPerStream;
        result.max_per_stream = (_a = data.maxRedemptionsPerStream) !== null && _a !== void 0 ? _a : 0;
    }
    if (data.maxRedemptionsPerUserPerStream !== undefined) {
        result.is_max_per_user_per_stream_enabled = !!data.maxRedemptionsPerUserPerStream;
        result.max_per_user_per_stream = (_b = data.maxRedemptionsPerUserPerStream) !== null && _b !== void 0 ? _b : 0;
    }
    if (data.globalCooldown !== undefined) {
        result.is_global_cooldown_enabled = !!data.globalCooldown;
        result.global_cooldown_seconds = (_c = data.globalCooldown) !== null && _c !== void 0 ? _c : 0;
    }
    if ('isPaused' in data) result.is_paused = data.isPaused;
    return result;
}
module.exports.createCustomRewardBody = $fbe4885f58f3d033$var$createCustomRewardBody;
/** @internal */ function $fbe4885f58f3d033$var$createRewardRedemptionsByIdsQuery(broadcaster, rewardId, redemptionIds) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        reward_id: rewardId,
        id: redemptionIds
    };
}
module.exports.createRewardRedemptionsByIdsQuery = $fbe4885f58f3d033$var$createRewardRedemptionsByIdsQuery;
/** @internal */ function $fbe4885f58f3d033$var$createRedemptionsForBroadcasterQuery(broadcaster, rewardId, status, filter) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        reward_id: rewardId,
        status: status,
        sort: filter.newestFirst ? 'NEWEST' : 'OLDEST'
    };
}
module.exports.createRedemptionsForBroadcasterQuery = $fbe4885f58f3d033$var$createRedemptionsForBroadcasterQuery;

});

parcelRegister("gCXpe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCustomReward = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A custom Channel Points reward.
 */ let $c1ae46c31796cb6c$var$HelixCustomReward = class HelixCustomReward extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the reward.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster the reward belongs to.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster the reward belongs to.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster the reward belongs to.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the reward's broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * Gets the URL of the image of the reward in the given scale.
     *
     * @param scale The scale of the image.
     */ getImageUrl(scale) {
        var _a, _b;
        const urlProp = `url_${scale}x`;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].image) === null || _a === void 0 ? void 0 : _a[urlProp]) !== null && _b !== void 0 ? _b : this[$j0DIQ.rawDataSymbol].default_image[urlProp];
    }
    /**
     * The background color of the reward.
     */ get backgroundColor() {
        return this[$j0DIQ.rawDataSymbol].background_color;
    }
    /**
     * Whether the reward is enabled (shown to users).
     */ get isEnabled() {
        return this[$j0DIQ.rawDataSymbol].is_enabled;
    }
    /**
     * The channel points cost of the reward.
     */ get cost() {
        return this[$j0DIQ.rawDataSymbol].cost;
    }
    /**
     * The title of the reward.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The prompt shown to users when redeeming the reward.
     */ get prompt() {
        return this[$j0DIQ.rawDataSymbol].prompt;
    }
    /**
     * Whether the reward requires user input to be redeemed.
     */ get userInputRequired() {
        return this[$j0DIQ.rawDataSymbol].is_user_input_required;
    }
    /**
     * The maximum number of redemptions of the reward per stream. `null` means no limit.
     */ get maxRedemptionsPerStream() {
        return this[$j0DIQ.rawDataSymbol].max_per_stream_setting.is_enabled ? this[$j0DIQ.rawDataSymbol].max_per_stream_setting.max_per_stream : null;
    }
    /**
     * The maximum number of redemptions of the reward per stream for each user. `null` means no limit.
     */ get maxRedemptionsPerUserPerStream() {
        return this[$j0DIQ.rawDataSymbol].max_per_user_per_stream_setting.is_enabled ? this[$j0DIQ.rawDataSymbol].max_per_user_per_stream_setting.max_per_user_per_stream : null;
    }
    /**
     * The cooldown between two redemptions of the reward, in seconds. `null` means no cooldown.
     */ get globalCooldown() {
        return this[$j0DIQ.rawDataSymbol].global_cooldown_setting.is_enabled ? this[$j0DIQ.rawDataSymbol].global_cooldown_setting.global_cooldown_seconds : null;
    }
    /**
     * Whether the reward is paused. If true, users can't redeem it.
     */ get isPaused() {
        return this[$j0DIQ.rawDataSymbol].is_paused;
    }
    /**
     * Whether the reward is currently in stock.
     */ get isInStock() {
        return this[$j0DIQ.rawDataSymbol].is_in_stock;
    }
    /**
     * How often the reward was already redeemed this stream.
     *
     * Only available when the stream is live and `maxRedemptionsPerStream` is set. Otherwise, this is `null`.
     */ get redemptionsThisStream() {
        return this[$j0DIQ.rawDataSymbol].redemptions_redeemed_current_stream;
    }
    /**
     * Whether redemptions should automatically be marked as fulfilled.
     */ get autoFulfill() {
        return this[$j0DIQ.rawDataSymbol].should_redemptions_skip_request_queue;
    }
    /**
     * The time when the cooldown ends. `null` means there is currently no cooldown.
     */ get cooldownExpiryDate() {
        return this[$j0DIQ.rawDataSymbol].cooldown_expires_at ? new Date(this[$j0DIQ.rawDataSymbol].cooldown_expires_at) : null;
    }
};
module.exports.HelixCustomReward = $c1ae46c31796cb6c$var$HelixCustomReward;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c1ae46c31796cb6c$var$HelixCustomReward.prototype, "_client", void 0);
module.exports.HelixCustomReward = $c1ae46c31796cb6c$var$HelixCustomReward = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCustomReward', 'id')
], $c1ae46c31796cb6c$var$HelixCustomReward);

});

parcelRegister("dmVKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCustomRewardRedemption = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A redemption of a custom Channel Points reward.
 */ let $9bba207a12a0e00f$var$HelixCustomRewardRedemption = class HelixCustomRewardRedemption extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the redemption.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster where the reward was redeemed.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster where the reward was redeemed.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster where the reward was redeemed.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster where the reward was redeemed.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The ID of the user that redeemed the reward.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user that redeemed the reward.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user that redeemed the reward.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the user that redeemed the reward.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The text the user wrote when redeeming the reward.
     */ get userInput() {
        return this[$j0DIQ.rawDataSymbol].user_input;
    }
    /**
     * Whether the redemption was fulfilled.
     */ get isFulfilled() {
        return this[$j0DIQ.rawDataSymbol].status === 'FULFILLED';
    }
    /**
     * Whether the redemption was canceled.
     */ get isCanceled() {
        return this[$j0DIQ.rawDataSymbol].status === 'CANCELED';
    }
    /**
     * The date and time when the reward was redeemed.
     */ get redemptionDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].redeemed_at);
    }
    /**
     * The ID of the reward that was redeemed.
     */ get rewardId() {
        return this[$j0DIQ.rawDataSymbol].reward.id;
    }
    /**
     * The title of the reward that was redeemed.
     */ get rewardTitle() {
        return this[$j0DIQ.rawDataSymbol].reward.title;
    }
    /**
     * The prompt of the reward that was redeemed.
     */ get rewardPrompt() {
        return this[$j0DIQ.rawDataSymbol].reward.prompt;
    }
    /**
     * The cost of the reward that was redeemed.
     */ get rewardCost() {
        return this[$j0DIQ.rawDataSymbol].reward.cost;
    }
    /**
     * Gets more information about the reward that was redeemed.
     */ async getReward() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.channelPoints.getCustomRewardById(this[$j0DIQ.rawDataSymbol].broadcaster_id, this[$j0DIQ.rawDataSymbol].reward.id));
    }
    /**
     * Updates the redemption's status.
     *
     * @param newStatus The status the redemption should have.
     */ async updateStatus(newStatus) {
        const result = await this._client.channelPoints.updateRedemptionStatusByIds(this[$j0DIQ.rawDataSymbol].broadcaster_id, this[$j0DIQ.rawDataSymbol].reward.id, [
            this[$j0DIQ.rawDataSymbol].id
        ], newStatus);
        return result[0];
    }
};
module.exports.HelixCustomRewardRedemption = $9bba207a12a0e00f$var$HelixCustomRewardRedemption;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $9bba207a12a0e00f$var$HelixCustomRewardRedemption.prototype, "_client", void 0);
module.exports.HelixCustomRewardRedemption = $9bba207a12a0e00f$var$HelixCustomRewardRedemption = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCustomRewardRedemption', 'id')
], $9bba207a12a0e00f$var$HelixCustomRewardRedemption);

});


parcelRegister("iyImv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCharityApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $2qE8E = parcelRequire("2qE8E");

var $ab0YV = parcelRequire("ab0YV");
/**
 * The Helix API methods that deal with charity campaigns.
 *
 * Can be accessed using `client.charity` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const charityCampaign = await api.charity.getCharityCampaign('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Charity Campaigns
 */ let $d82dd058d5bda37e$var$HelixCharityApi = class HelixCharityApi extends $lq7i7.BaseApi {
    /**
     * Gets information about the charity campaign that a broadcaster is running.
     * Returns null if the specified broadcaster has no active charity campaign.
     *
     * @param broadcaster The broadcaster to get charity campaign information about.
     */ async getCharityCampaign(broadcaster) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'charity/campaigns',
            method: 'GET',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:charity'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return new $2qE8E.HelixCharityCampaign(response.data[0], this._client);
    }
    /**
     * Gets the list of donations that users have made to the broadcaster’s active charity campaign.
     *
     * @param broadcaster The broadcaster to get charity campaign donation information about.
     * @param pagination
     *
     * @expandParams
     */ async getCharityCampaignDonations(broadcaster, pagination) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'charity/donations',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:charity'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(response, $ab0YV.HelixCharityCampaignDonation, this._client);
    }
};
module.exports.HelixCharityApi = $d82dd058d5bda37e$var$HelixCharityApi;
module.exports.HelixCharityApi = $d82dd058d5bda37e$var$HelixCharityApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCharityApi')
], $d82dd058d5bda37e$var$HelixCharityApi);

});
parcelRegister("2qE8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCharityCampaign = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $jDlBx = parcelRequire("jDlBx");
/**
 * A charity campaign in a Twitch channel.
 */ let $1c4d25289d25e2de$var$HelixCharityCampaign = class HelixCharityCampaign extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * An ID that identifies the charity campaign.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The name of the charity.
     */ get charityName() {
        return this[$j0DIQ.rawDataSymbol].charity_name;
    }
    /**
     * A description of the charity.
     */ get charityDescription() {
        return this[$j0DIQ.rawDataSymbol].charity_description;
    }
    /**
     * A URL to an image of the charity's logo. The image’s type is PNG and its size is 100px X 100px.
     */ get charityLogo() {
        return this[$j0DIQ.rawDataSymbol].charity_logo;
    }
    /**
     * A URL to the charity’s website.
     */ get charityWebsite() {
        return this[$j0DIQ.rawDataSymbol].charity_website;
    }
    /**
     * An object that contains the current amount of donations that the campaign has received.
     */ get currentAmount() {
        return new $jDlBx.HelixCharityCampaignAmount(this[$j0DIQ.rawDataSymbol].current_amount);
    }
    /**
     * An object that contains the campaign’s target fundraising goal.
     */ get targetAmount() {
        return new $jDlBx.HelixCharityCampaignAmount(this[$j0DIQ.rawDataSymbol].target_amount);
    }
};
module.exports.HelixCharityCampaign = $1c4d25289d25e2de$var$HelixCharityCampaign;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $1c4d25289d25e2de$var$HelixCharityCampaign.prototype, "_client", void 0);
module.exports.HelixCharityCampaign = $1c4d25289d25e2de$var$HelixCharityCampaign = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCharityCampaign', 'id')
], $1c4d25289d25e2de$var$HelixCharityCampaign);

});
parcelRegister("jDlBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCharityCampaignAmount = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An object representing monetary amount and currency information for charity donations/goals.
 */ let $e4b26b0f0d14ef88$var$HelixCharityCampaignAmount = class HelixCharityCampaignAmount extends $j0DIQ.DataObject {
    /**
     * The monetary amount. The amount is specified in the currency’s minor unit.
     * For example, the minor units for USD is cents, so if the amount is $5.50 USD, `value` is set to 550.
     */ get value() {
        return this[$j0DIQ.rawDataSymbol].value;
    }
    /**
     * The number of decimal places used by the currency. For example, USD uses two decimal places.
     * Use this number to translate `value` from minor units to major units by using the formula:
     *
     * `value / 10^decimalPlaces`
     */ get decimalPlaces() {
        return this[$j0DIQ.rawDataSymbol].decimal_places;
    }
    /**
     * The localized monetary amount based on the value and the decimal places of the currency.
     * For example, the minor units for USD is cents which uses two decimal places, so if `value` is 550, `localizedValue` is set to 5.50.
     */ get localizedValue() {
        return this.value / 10 ** this.decimalPlaces;
    }
    /**
     * The ISO-4217 three-letter currency code that identifies the type of currency in `value`.
     */ get currency() {
        return this[$j0DIQ.rawDataSymbol].currency;
    }
};
module.exports.HelixCharityCampaignAmount = $e4b26b0f0d14ef88$var$HelixCharityCampaignAmount;
module.exports.HelixCharityCampaignAmount = $e4b26b0f0d14ef88$var$HelixCharityCampaignAmount = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCharityCampaignAmount')
], $e4b26b0f0d14ef88$var$HelixCharityCampaignAmount);

});


parcelRegister("ab0YV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixCharityCampaignDonation = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $jDlBx = parcelRequire("jDlBx");
/**
 * A donation to a charity campaign in a Twitch channel.
 */ let $768bb16b12410c61$var$HelixCharityCampaignDonation = class HelixCharityCampaignDonation extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * An ID that identifies the charity campaign.
     */ get campaignId() {
        return this[$j0DIQ.rawDataSymbol].campaign_id;
    }
    /**
     * The ID of the donating user.
     */ get donorId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the donating user.
     */ get donorName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the donating user.
     */ get donorDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the donating user.
     */ async getDonor() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * An object that contains the amount of money that the user donated.
     */ get amount() {
        return new $jDlBx.HelixCharityCampaignAmount(this[$j0DIQ.rawDataSymbol].amount);
    }
};
module.exports.HelixCharityCampaignDonation = $768bb16b12410c61$var$HelixCharityCampaignDonation;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $768bb16b12410c61$var$HelixCharityCampaignDonation.prototype, "_client", void 0);
module.exports.HelixCharityCampaignDonation = $768bb16b12410c61$var$HelixCharityCampaignDonation = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixCharityCampaignDonation')
], $768bb16b12410c61$var$HelixCharityCampaignDonation);

});


parcelRegister("39w82", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChatApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $f9a9I = parcelRequire("f9a9I");

var $78zDw = parcelRequire("78zDw");

var $6tEA1 = parcelRequire("6tEA1");

var $4W0OK = parcelRequire("4W0OK");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $ecrvb = parcelRequire("ecrvb");

var $b1Ut4 = parcelRequire("b1Ut4");

var $eGJRV = parcelRequire("eGJRV");

var $4lCpS = parcelRequire("4lCpS");

var $ayCIV = parcelRequire("ayCIV");

var $g9mZm = parcelRequire("g9mZm");

var $5erY8 = parcelRequire("5erY8");

var $bfwdV = parcelRequire("bfwdV");

var $iRBdv = parcelRequire("iRBdv");

var $3gWS4 = parcelRequire("3gWS4");

var $4NFiy = parcelRequire("4NFiy");
/**
 * The Helix API methods that deal with chat.
 *
 * Can be accessed using `client.chat` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const rewards = await api.chat.getChannelBadges('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Chat
 */ let $24bb226fa9266b70$var$HelixChatApi = class HelixChatApi extends $lq7i7.BaseApi {
    /**
     * Gets the list of users that are connected to the broadcaster’s chat session.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster whose list of chatters you want to get.
     * @param pagination
     *
     * @expandParams
     */ async getChatters(broadcaster, pagination) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/chatters',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:read:chatters'
            ],
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResultWithTotal)(result, $eGJRV.HelixChatChatter, this._client);
    }
    /**
     * Creates a paginator for users that are connected to the broadcaster’s chat session.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster whose list of chatters you want to get.
     *
     * @expandParams
     */ getChattersPaginated(broadcaster) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return new $4W0OK.HelixPaginatedRequestWithTotal({
            url: 'chat/chatters',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:read:chatters'
            ],
            query: this._createModeratorActionQuery(broadcasterId)
        }, this._client, (data)=>new $eGJRV.HelixChatChatter(data, this._client), 1000);
    }
    /**
     * Gets all global badges.
     */ async getGlobalBadges() {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/badges/global'
        });
        return result.data.map((data)=>new $b1Ut4.HelixChatBadgeSet(data));
    }
    /**
     * Gets all badges specific to the given broadcaster.
     *
     * @param broadcaster The broadcaster to get badges for.
     */ async getChannelBadges(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/badges',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return result.data.map((data)=>new $b1Ut4.HelixChatBadgeSet(data));
    }
    /**
     * Gets all global emotes.
     */ async getGlobalEmotes() {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/emotes/global'
        });
        return result.data.map((data)=>new $ayCIV.HelixEmote(data));
    }
    /**
     * Gets all emotes specific to the given broadcaster.
     *
     * @param broadcaster The broadcaster to get emotes for.
     */ async getChannelEmotes(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/emotes',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return result.data.map((data)=>new $ecrvb.HelixChannelEmote(data, this._client));
    }
    /**
     * Gets all emotes from a list of emote sets.
     *
     * @param setIds The IDs of the emote sets to get emotes from.
     */ async getEmotesFromSets(setIds) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/emotes/set',
            query: (0, $78zDw.createSingleKeyQuery)('emote_set_id', setIds)
        });
        return result.data.map((data)=>new $g9mZm.HelixEmoteFromSet(data, this._client));
    }
    /**
     * Gets emotes available to the user across all channels.
     *
     * @param user The ID of the user to get available emotes of.
     * @param filter Additional query filters.
     */ async getUserEmotes(user, filter) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/emotes/user',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:emotes'
            ],
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('user_id', userId),
                ...(0, $78zDw.createSingleKeyQuery)('broadcasterId', (filter === null || filter === void 0 ? void 0 : filter.broadcaster) ? (0, $j0DIQ.extractUserId)(filter.broadcaster) : undefined),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $5erY8.HelixUserEmote, this._client);
    }
    /**
     * Creates a paginator for emotes available to the user across all channels.
     *
     * @param user The ID of the user to get available emotes of.
     * @param broadcaster The ID of a broadcaster you wish to get follower emotes of. Using this query parameter will
     * guarantee inclusion of the broadcaster’s follower emotes in the response body.
     *
     * If the user who retrieves their emotes is subscribed to the broadcaster specified, their follower emotes will
     * appear in the response body regardless of whether this query parameter is used.
     */ getUserEmotesPaginated(user, broadcaster) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return new $6tEA1.HelixPaginatedRequest({
            url: 'chat/emotes/user',
            userId: userId,
            scopes: [
                'user:read:emotes'
            ],
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('user_id', userId),
                ...(0, $78zDw.createSingleKeyQuery)('broadcasterId', broadcaster ? (0, $j0DIQ.extractUserId)(broadcaster) : undefined)
            }
        }, this._client, (data)=>new $5erY8.HelixUserEmote(data, this._client));
    }
    /**
     * Gets the settings of a broadcaster's chat.
     *
     * @param broadcaster The broadcaster the chat belongs to.
     */ async getSettings(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/settings',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return new $4lCpS.HelixChatSettings(result.data[0]);
    }
    /**
     * Gets the settings of a broadcaster's chat, including the delay settings.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster the chat belongs to.
     */ async getSettingsPrivileged(broadcaster) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/settings',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:read:chat_settings'
            ],
            query: this._createModeratorActionQuery(broadcasterId)
        });
        return new $bfwdV.HelixPrivilegedChatSettings(result.data[0]);
    }
    /**
     * Updates the settings of a broadcaster's chat.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @expandParams
     *
     * @param broadcaster The broadcaster the chat belongs to.
     * @param settings The settings to change.
     */ async updateSettings(broadcaster, settings) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/settings',
            method: 'PATCH',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:manage:chat_settings'
            ],
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: (0, $f9a9I.createChatSettingsUpdateBody)(settings)
        });
        return new $bfwdV.HelixPrivilegedChatSettings(result.data[0]);
    }
    /**
     * Sends a chat message to a broadcaster's chat.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @expandParams
     *
     * @param broadcaster The broadcaster the chat belongs to.
     * @param message The message to send.
     * @param params
     */ async sendChatMessage(broadcaster, message, params) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/messages',
            method: 'POST',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'user:write:chat'
            ],
            query: (0, $f9a9I.createSendChatMessageQuery)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)),
            jsonBody: (0, $f9a9I.createSendChatMessageBody)(message, params)
        });
        return new $iRBdv.HelixSentChatMessage(result.data[0]);
    }
    /**
     * Sends a chat message to a broadcaster's chat, using an app token.
     *
     * This requires the scopes `user:write:chat` and `user:bot` for the `user` and `channel:bot` for the `broadcaster`.
     * `channel:bot` is not required if the `user` has moderator privileges in the `broadcaster`'s channel.
     *
     * These scope requirements can not be checked by the library, so they are just assumed.
     * Make sure to catch authorization errors yourself.
     *
     * @expandParams
     *
     * @param user The user to send the chat message from.
     * @param broadcaster The broadcaster the chat belongs to.
     * @param message The message to send.
     * @param params
     */ async sendChatMessageAsApp(user, broadcaster, message, params) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'chat/messages',
            method: 'POST',
            forceType: 'app',
            query: (0, $f9a9I.createSendChatMessageQuery)(broadcasterId, userId),
            jsonBody: (0, $f9a9I.createSendChatMessageAsAppBody)(message, params)
        });
        return new $iRBdv.HelixSentChatMessage(result.data[0]);
    }
    /**
     * Sends an announcement to a broadcaster's chat.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster the chat belongs to.
     * @param announcement The announcement to send.
     */ async sendAnnouncement(broadcaster, announcement) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        await this._client.callApi({
            type: 'helix',
            url: 'chat/announcements',
            method: 'POST',
            userId: broadcasterId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:manage:announcements'
            ],
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: {
                message: announcement.message,
                color: announcement.color
            }
        });
    }
    /**
     * Gets the chat colors for a list of users.
     *
     * Returns a Map with user IDs as keys and their colors as values.
     * The value is a color hex code, or `null` if the user did not set a color,
     * and unknown users will not be present in the map.
     *
     * @param users The users to get the chat colors of.
     */ async getColorsForUsers(users) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'chat/color',
            query: (0, $78zDw.createSingleKeyQuery)('user_id', users.map($j0DIQ.extractUserId))
        });
        return new Map(response.data.map((data)=>[
                data.user_id,
                data.color || null
            ]));
    }
    /**
     * Gets the chat color for a user.
     *
     * Returns the color as hex code, `null` if the user did not set a color, or `undefined` if the user is unknown.
     *
     * @param user The user to get the chat color of.
     */ async getColorForUser(user) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'chat/color',
            userId: (0, $j0DIQ.extractUserId)(user),
            query: (0, $78zDw.createSingleKeyQuery)('user_id', (0, $j0DIQ.extractUserId)(user))
        });
        if (!response.data.length) return undefined;
        return response.data[0].color || null;
    }
    /**
     * Changes the chat color for a user.
     *
     * @param user The user to change the color of.
     * @param color The color to set.
     *
     * Note that hex codes can only be used by users that have a Prime or Turbo subscription.
     */ async setColorForUser(user, color) {
        await this._client.callApi({
            type: 'helix',
            url: 'chat/color',
            method: 'PUT',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:manage:chat_color'
            ],
            query: (0, $f9a9I.createChatColorUpdateQuery)(user, color)
        });
    }
    /**
     * Sends a shoutout to the specified broadcaster.
     * The broadcaster may send a shoutout once every 2 minutes. They may send the same broadcaster a shoutout once every 60 minutes.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param from The ID of the broadcaster that’s sending the shoutout.
     * @param to The ID of the broadcaster that’s receiving the shoutout.
     */ async shoutoutUser(from, to) {
        const fromId = (0, $j0DIQ.extractUserId)(from);
        await this._client.callApi({
            type: 'helix',
            url: 'chat/shoutouts',
            method: 'POST',
            userId: fromId,
            canOverrideScopedUserContext: true,
            scopes: [
                'moderator:manage:shoutouts'
            ],
            query: (0, $f9a9I.createShoutoutQuery)(from, to, this._getUserContextIdWithDefault(fromId))
        });
    }
    /**
     * Gets the active shared chat session for a channel.
     *
     * Returns `null` if there is no active shared chat session in the channel.
     *
     * @param broadcaster The broadcaster to get the active shared chat session for.
     */ async getSharedChatSession(broadcaster) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const response = await this._client.callApi({
            type: 'helix',
            url: 'shared_chat/session',
            userId: broadcasterId,
            query: (0, $3gWS4.createSharedChatSessionQuery)(broadcasterId)
        });
        if (response.data.length === 0) return null;
        return new $4NFiy.HelixSharedChatSession(response.data[0], this._client);
    }
    _createModeratorActionQuery(broadcasterId) {
        return (0, $78zDw.createModeratorActionQuery)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId));
    }
};
module.exports.HelixChatApi = $24bb226fa9266b70$var$HelixChatApi;
module.exports.HelixChatApi = $24bb226fa9266b70$var$HelixChatApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChatApi')
], $24bb226fa9266b70$var$HelixChatApi);

});
parcelRegister("f9a9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSendChatMessageAsAppBody = module.exports.createSendChatMessageBody = module.exports.createSendChatMessageQuery = module.exports.createShoutoutQuery = module.exports.createChatColorUpdateQuery = module.exports.createChatSettingsUpdateBody = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $b06f9300d000604c$var$createChatSettingsUpdateBody(settings) {
    return {
        slow_mode: settings.slowModeEnabled,
        slow_mode_wait_time: settings.slowModeDelay,
        follower_mode: settings.followerOnlyModeEnabled,
        follower_mode_duration: settings.followerOnlyModeDelay,
        subscriber_mode: settings.subscriberOnlyModeEnabled,
        emote_mode: settings.emoteOnlyModeEnabled,
        unique_chat_mode: settings.uniqueChatModeEnabled,
        non_moderator_chat_delay: settings.nonModeratorChatDelayEnabled,
        non_moderator_chat_delay_duration: settings.nonModeratorChatDelay
    };
}
module.exports.createChatSettingsUpdateBody = $b06f9300d000604c$var$createChatSettingsUpdateBody;
/** @internal */ function $b06f9300d000604c$var$createChatColorUpdateQuery(user, color) {
    return {
        user_id: (0, $j0DIQ.extractUserId)(user),
        color: color
    };
}
module.exports.createChatColorUpdateQuery = $b06f9300d000604c$var$createChatColorUpdateQuery;
/** @internal */ function $b06f9300d000604c$var$createShoutoutQuery(from, to, moderatorId) {
    return {
        from_broadcaster_id: (0, $j0DIQ.extractUserId)(from),
        to_broadcaster_id: (0, $j0DIQ.extractUserId)(to),
        moderator_id: moderatorId
    };
}
module.exports.createShoutoutQuery = $b06f9300d000604c$var$createShoutoutQuery;
/** @internal */ function $b06f9300d000604c$var$createSendChatMessageQuery(broadcaster, sender) {
    return {
        broadcaster_id: broadcaster,
        sender_id: sender
    };
}
module.exports.createSendChatMessageQuery = $b06f9300d000604c$var$createSendChatMessageQuery;
/** @internal */ function $b06f9300d000604c$var$createSendChatMessageBody(message, params) {
    return {
        message: message,
        reply_parent_message_id: params === null || params === void 0 ? void 0 : params.replyParentMessageId
    };
}
module.exports.createSendChatMessageBody = $b06f9300d000604c$var$createSendChatMessageBody;
/** @internal */ function $b06f9300d000604c$var$createSendChatMessageAsAppBody(message, params) {
    return {
        message: message,
        reply_parent_message_id: params === null || params === void 0 ? void 0 : params.replyParentMessageId,
        for_source_only: params === null || params === void 0 ? void 0 : params.forSourceOnly
    };
}
module.exports.createSendChatMessageAsAppBody = $b06f9300d000604c$var$createSendChatMessageAsAppBody;

});

parcelRegister("ecrvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelEmote = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $ayCIV = parcelRequire("ayCIV");
/**
 * A Twitch Channel emote.
 *
 * @inheritDoc
 */ let $a5678502c7edd0be$var$HelixChannelEmote = class HelixChannelEmote extends $ayCIV.HelixEmote {
    constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The subscription tier necessary to unlock the emote, or null if the emote is not a subscription emote.
     */ get tier() {
        return this[$j0DIQ.rawDataSymbol].tier || null;
    }
    /**
     * The type of the emote.
     *
     * There are many types of emotes that Twitch seems to arbitrarily assign. Do not rely on this value.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].emote_type;
    }
    /**
     * The ID of the emote set the emote is part of.
     */ get emoteSetId() {
        return this[$j0DIQ.rawDataSymbol].emote_set_id;
    }
    /**
     * Gets all emotes from the emote's set.
     */ async getAllEmotesFromSet() {
        return await this._client.chat.getEmotesFromSets([
            this[$j0DIQ.rawDataSymbol].emote_set_id
        ]);
    }
};
module.exports.HelixChannelEmote = $a5678502c7edd0be$var$HelixChannelEmote;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $a5678502c7edd0be$var$HelixChannelEmote.prototype, "_client", void 0);
module.exports.HelixChannelEmote = $a5678502c7edd0be$var$HelixChannelEmote = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelEmote', 'id')
], $a5678502c7edd0be$var$HelixChannelEmote);

});
parcelRegister("ayCIV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEmote = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $4LCgs = parcelRequire("4LCgs");
/**
 * A Twitch emote.
 */ let $7afb1e1196bdcb28$var$HelixEmote = class HelixEmote extends $4LCgs.HelixEmoteBase {
    /**
     * Gets the URL of the emote image in the given scale.
     *
     * @param scale The scale of the image.
     */ getImageUrl(scale) {
        return this[$j0DIQ.rawDataSymbol].images[`url_${scale}x`];
    }
};
module.exports.HelixEmote = $7afb1e1196bdcb28$var$HelixEmote;
module.exports.HelixEmote = $7afb1e1196bdcb28$var$HelixEmote = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEmote', 'id')
], $7afb1e1196bdcb28$var$HelixEmote);

});
parcelRegister("4LCgs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEmoteBase = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @private */ class $37893bbfbb2741ac$var$HelixEmoteBase extends $j0DIQ.DataObject {
    /**
     * The ID of the emote.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the emote.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].name;
    }
    /**
     * The formats that the emote is available in.
     */ get formats() {
        return this[$j0DIQ.rawDataSymbol].format;
    }
    /**
     * The scales that the emote is available in.
     */ get scales() {
        return this[$j0DIQ.rawDataSymbol].scale;
    }
    /**
     * The theme modes that the emote is available in.
     */ get themeModes() {
        return this[$j0DIQ.rawDataSymbol].theme_mode;
    }
    /**
     * Gets the URL of the emote image in static format at the given scale and theme mode, or null if a static emote image at that scale/theme mode doesn't exist.
     *
     * @param scale The scale of the image.
     * @param themeMode The theme mode of the image, either `light` or `dark`.
     */ getStaticImageUrl(scale = '1.0', themeMode = 'light') {
        if (this[$j0DIQ.rawDataSymbol].format.includes('static') && this[$j0DIQ.rawDataSymbol].scale.includes(scale)) return this.getFormattedImageUrl(scale, 'static', themeMode);
        return null;
    }
    /**
     * Gets the URL of the emote image in animated format at the given scale and theme mode, or null if an animated emote image at that scale/theme mode doesn't exist.
     *
     * @param scale The scale of the image.
     * @param themeMode The theme mode of the image, either `light` or `dark`.
     */ getAnimatedImageUrl(scale = '1.0', themeMode = 'light') {
        if (this[$j0DIQ.rawDataSymbol].format.includes('animated') && this[$j0DIQ.rawDataSymbol].scale.includes(scale)) return this.getFormattedImageUrl(scale, 'animated', themeMode);
        return null;
    }
    /**
     * Gets the URL of the emote image in the given scale, format, and theme mode.
     *
     * @param scale The scale of the image, either `1.0` (small), `2.0` (medium), or `3.0` (large).
     * @param format The format of the image, either `static` or `animated`.
     * @param themeMode The theme mode of the image, either `light` or `dark`.
     */ getFormattedImageUrl(scale = '1.0', format = 'static', themeMode = 'light') {
        return `https://static-cdn.jtvnw.net/emoticons/v2/${this[$j0DIQ.rawDataSymbol].id}/${format}/${themeMode}/${scale}`;
    }
}
module.exports.HelixEmoteBase = $37893bbfbb2741ac$var$HelixEmoteBase;

});



parcelRegister("b1Ut4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChatBadgeSet = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $cKhNr = parcelRequire("cKhNr");

var $j0DIQ = parcelRequire("j0DIQ");

var $kEyVe = parcelRequire("kEyVe");
/**
 * A version of a chat badge.
 */ let $807b970935629d71$var$HelixChatBadgeSet = class HelixChatBadgeSet extends $j0DIQ.DataObject {
    /**
     * The badge set ID.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].set_id;
    }
    /**
     * All versions of the badge.
     */ get versions() {
        return this[$j0DIQ.rawDataSymbol].versions.map((data)=>new $kEyVe.HelixChatBadgeVersion(data));
    }
    /**
     * Gets a specific version of the badge.
     *
     * @param versionId The ID of the version.
     */ getVersion(versionId) {
        var _a;
        return (_a = this.versions.find((v)=>v.id === versionId)) !== null && _a !== void 0 ? _a : null;
    }
};
module.exports.HelixChatBadgeSet = $807b970935629d71$var$HelixChatBadgeSet;
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $807b970935629d71$var$HelixChatBadgeSet.prototype, "versions", null);
module.exports.HelixChatBadgeSet = $807b970935629d71$var$HelixChatBadgeSet = $ceFTv.__decorate([
    $cKhNr.Cacheable,
    (0, $j0DIQ.rtfm)('api', 'HelixChatBadgeSet', 'id')
], $807b970935629d71$var$HelixChatBadgeSet);

});
parcelRegister("kEyVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChatBadgeVersion = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A version of a chat badge.
 */ let $f092a1de0a604569$var$HelixChatBadgeVersion = class HelixChatBadgeVersion extends $j0DIQ.DataObject {
    /**
     * The badge version ID.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * Gets an image URL for the given scale.
     *
     * @param scale The scale of the badge image.
     */ getImageUrl(scale) {
        return this[$j0DIQ.rawDataSymbol][`image_url_${scale}x`];
    }
    /**
     * The title of the badge.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The description of the badge.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
    /**
     * The action to take when clicking on the badge. Set to `null` if no action is specified.
     */ get clickAction() {
        return this[$j0DIQ.rawDataSymbol].click_action;
    }
    /**
     * The URL to navigate to when clicking on the badge. Set to `null` if no URL is specified.
     */ get clickUrl() {
        return this[$j0DIQ.rawDataSymbol].click_url;
    }
};
module.exports.HelixChatBadgeVersion = $f092a1de0a604569$var$HelixChatBadgeVersion;
module.exports.HelixChatBadgeVersion = $f092a1de0a604569$var$HelixChatBadgeVersion = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChatBadgeVersion', 'id')
], $f092a1de0a604569$var$HelixChatBadgeVersion);

});


parcelRegister("eGJRV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChatChatter = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A user connected to a Twitch channel's chat session.
 */ let $ab189189792e5c69$var$HelixChatChatter = class HelixChatChatter extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixChatChatter = $ab189189792e5c69$var$HelixChatChatter;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $ab189189792e5c69$var$HelixChatChatter.prototype, "_client", void 0);
module.exports.HelixChatChatter = $ab189189792e5c69$var$HelixChatChatter = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChatChatter')
], $ab189189792e5c69$var$HelixChatChatter);

});

parcelRegister("4lCpS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChatSettings = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * The settings of a broadcaster's chat.
 */ let $32a6ec485a1e5509$var$HelixChatSettings = class HelixChatSettings extends $j0DIQ.DataObject {
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * Whether slow mode is enabled.
     */ get slowModeEnabled() {
        return this[$j0DIQ.rawDataSymbol].slow_mode;
    }
    /**
     * The time to wait between messages in slow mode, in seconds.
     *
     * Is `null` if slow mode is not enabled.
     */ get slowModeDelay() {
        return this[$j0DIQ.rawDataSymbol].slow_mode_wait_time;
    }
    /**
     * Whether follower only mode is enabled.
     */ get followerOnlyModeEnabled() {
        return this[$j0DIQ.rawDataSymbol].follower_mode;
    }
    /**
     * The time after which users are able to send messages after following, in minutes.
     *
     * Is `null` if follower only mode is not enabled,
     * but may also be `0` if you can send messages immediately after following.
     */ get followerOnlyModeDelay() {
        return this[$j0DIQ.rawDataSymbol].follower_mode_duration;
    }
    /**
     * Whether subscriber only mode is enabled.
     */ get subscriberOnlyModeEnabled() {
        return this[$j0DIQ.rawDataSymbol].subscriber_mode;
    }
    /**
     * Whether emote only mode is enabled.
     */ get emoteOnlyModeEnabled() {
        return this[$j0DIQ.rawDataSymbol].emote_mode;
    }
    /**
     * Whether unique chat mode is enabled.
     */ get uniqueChatModeEnabled() {
        return this[$j0DIQ.rawDataSymbol].unique_chat_mode;
    }
};
module.exports.HelixChatSettings = $32a6ec485a1e5509$var$HelixChatSettings;
module.exports.HelixChatSettings = $32a6ec485a1e5509$var$HelixChatSettings = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChatSettings', 'broadcasterId')
], $32a6ec485a1e5509$var$HelixChatSettings);

});

parcelRegister("g9mZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEmoteFromSet = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $ayCIV = parcelRequire("ayCIV");
/**
 * A Twitch Channel emote.
 *
 * @inheritDoc
 */ let $bc1f51b4a2654f52$var$HelixEmoteFromSet = class HelixEmoteFromSet extends $ayCIV.HelixEmote {
    constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The type of the emote.
     *
     * Known values are: `subscriptions`, `bitstier`, `follower`, `rewards`, `globals`, `smilies`, `prime`, `limitedtime`.
     *
     * This list may be non-exhaustive.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].emote_type;
    }
    /**
     * The ID of the emote set the emote is part of.
     */ get emoteSetId() {
        return this[$j0DIQ.rawDataSymbol].emote_set_id;
    }
    /**
     * The ID of the user that owns the emote, or null if the emote is not owned by a user.
     */ get ownerId() {
        switch(this[$j0DIQ.rawDataSymbol].owner_id){
            case '0':
            case 'twitch':
                return null;
            default:
                return this[$j0DIQ.rawDataSymbol].owner_id;
        }
    }
    /**
     * Gets more information about the user that owns the emote, or null if the emote is not owned by a user.
     */ async getOwner() {
        switch(this[$j0DIQ.rawDataSymbol].owner_id){
            case '0':
            case 'twitch':
                return null;
            default:
                return await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].owner_id);
        }
    }
};
module.exports.HelixEmoteFromSet = $bc1f51b4a2654f52$var$HelixEmoteFromSet;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $bc1f51b4a2654f52$var$HelixEmoteFromSet.prototype, "_client", void 0);
module.exports.HelixEmoteFromSet = $bc1f51b4a2654f52$var$HelixEmoteFromSet = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEmoteFromSet', 'id')
], $bc1f51b4a2654f52$var$HelixEmoteFromSet);

});

parcelRegister("5erY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserEmote = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $4LCgs = parcelRequire("4LCgs");

var $bRvJY = parcelRequire("bRvJY");
/**
 * A Twitch user emote.
 */ let $3cf3f499941da2cb$var$HelixUserEmote = class HelixUserEmote extends $4LCgs.HelixEmoteBase {
    constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The type of the emote.
     *
     * There are many types of emotes that Twitch seems to arbitrarily assign.
     * Check the relevant values in the official documentation.
     *
     * @see https://dev.twitch.tv/docs/api/reference/#get-user-emotes
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].emote_type;
    }
    /**
     * The ID that identifies the emote set that the emote belongs to, or `null` if the emote is not from any set.
     */ get emoteSetId() {
        return this[$j0DIQ.rawDataSymbol].emote_set_id || null;
    }
    /**
     * The ID of the broadcaster who owns the emote, or `null` if the emote has no owner, e.g. it's a global emote.
     */ get ownerId() {
        return this[$j0DIQ.rawDataSymbol].owner_id || null;
    }
    /**
     * Gets all emotes from the emotes set, or `null` if emote is not from any set.
     */ async getAllEmotesFromSet() {
        return this[$j0DIQ.rawDataSymbol].emote_set_id ? await this._client.chat.getEmotesFromSets([
            this[$j0DIQ.rawDataSymbol].emote_set_id
        ]) : null;
    }
    /**
     * Gets more information about the user that owns the emote, or `null` if the emote is not owned by a user.
     */ async getOwner() {
        return this[$j0DIQ.rawDataSymbol].owner_id ? await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].owner_id) : null;
    }
};
module.exports.HelixUserEmote = $3cf3f499941da2cb$var$HelixUserEmote;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $3cf3f499941da2cb$var$HelixUserEmote.prototype, "_client", void 0);
module.exports.HelixUserEmote = $3cf3f499941da2cb$var$HelixUserEmote = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserEmote', 'id')
], $3cf3f499941da2cb$var$HelixUserEmote);

});

parcelRegister("bfwdV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPrivilegedChatSettings = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $4lCpS = parcelRequire("4lCpS");
/**
 * The settings of a broadcaster's chat, with additional privileged data.
 */ let $830a1762425df737$var$HelixPrivilegedChatSettings = class HelixPrivilegedChatSettings extends $4lCpS.HelixChatSettings {
    /**
     * Whether non-moderator messages are delayed.
     */ get nonModeratorChatDelayEnabled() {
        return this[$j0DIQ.rawDataSymbol].non_moderator_chat_delay;
    }
    /**
     * The delay of non-moderator messages, in seconds.
     *
     * Is `null` if non-moderator message delay is disabled.
     */ get nonModeratorChatDelay() {
        return this[$j0DIQ.rawDataSymbol].non_moderator_chat_delay_duration;
    }
};
module.exports.HelixPrivilegedChatSettings = $830a1762425df737$var$HelixPrivilegedChatSettings;
module.exports.HelixPrivilegedChatSettings = $830a1762425df737$var$HelixPrivilegedChatSettings = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPrivilegedChatSettings', 'broadcasterId')
], $830a1762425df737$var$HelixPrivilegedChatSettings);

});

parcelRegister("iRBdv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSentChatMessage = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about a sent Twitch chat message.
 */ let $dbba0bbb1837d2cf$var$HelixSentChatMessage = class HelixSentChatMessage extends $j0DIQ.DataObject {
    /**
     * The message ID of the sent message.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].message_id;
    }
    /**
     * If the message passed all checks and was sent.
     */ get isSent() {
        return this[$j0DIQ.rawDataSymbol].is_sent;
    }
    /**
     * The reason code for why the chat message was dropped, if dropped.
     */ get dropReasonCode() {
        var _a;
        return (_a = this[$j0DIQ.rawDataSymbol].drop_reason) === null || _a === void 0 ? void 0 : _a.code;
    }
    /**
     * The reason message for why the chat message was dropped, if dropped.
     */ get dropReasonMessage() {
        var _a;
        return (_a = this[$j0DIQ.rawDataSymbol].drop_reason) === null || _a === void 0 ? void 0 : _a.message;
    }
};
module.exports.HelixSentChatMessage = $dbba0bbb1837d2cf$var$HelixSentChatMessage;
module.exports.HelixSentChatMessage = $dbba0bbb1837d2cf$var$HelixSentChatMessage = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSentChatMessage', 'id')
], $dbba0bbb1837d2cf$var$HelixSentChatMessage);

});

parcelRegister("3gWS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSharedChatSessionQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $262088508ba97f7f$var$createSharedChatSessionQuery(broadcaster) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster)
    };
}
module.exports.createSharedChatSessionQuery = $262088508ba97f7f$var$createSharedChatSessionQuery;

});

parcelRegister("4NFiy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSharedChatSession = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $7MYwq = parcelRequire("7MYwq");
/**
 * A shared chat session.
 */ let $37ebc5fbedf98daa$var$HelixSharedChatSession = class HelixSharedChatSession extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The unique identifier for the shared chat session.
     */ get sessionId() {
        return this[$j0DIQ.rawDataSymbol].session_id;
    }
    /**
     * The ID of the host broadcaster.
     */ get hostBroadcasterId() {
        return this[$j0DIQ.rawDataSymbol].host_broadcaster_id;
    }
    /**
     * Gets information about the host broadcaster.
     */ async getHostBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].host_broadcaster_id));
    }
    /**
     * The list of participants in the session.
     */ get participants() {
        return this[$j0DIQ.rawDataSymbol].participants.map((data)=>new $7MYwq.HelixSharedChatSessionParticipant(data, this._client));
    }
    /**
     * The date for when the session was created.
     */ get createdDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date for when the session was updated.
     */ get updatedDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].updated_at);
    }
};
module.exports.HelixSharedChatSession = $37ebc5fbedf98daa$var$HelixSharedChatSession;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $37ebc5fbedf98daa$var$HelixSharedChatSession.prototype, "_client", void 0);
module.exports.HelixSharedChatSession = $37ebc5fbedf98daa$var$HelixSharedChatSession = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSharedChatSession', 'sessionId')
], $37ebc5fbedf98daa$var$HelixSharedChatSession);

});
parcelRegister("7MYwq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSharedChatSessionParticipant = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A shared chat session participant.
 */ let $5abbf67eac92d775$var$HelixSharedChatSessionParticipant = class HelixSharedChatSessionParticipant extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the participant broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * Gets information about the participant broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
};
module.exports.HelixSharedChatSessionParticipant = $5abbf67eac92d775$var$HelixSharedChatSessionParticipant;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $5abbf67eac92d775$var$HelixSharedChatSessionParticipant.prototype, "_client", void 0);
module.exports.HelixSharedChatSessionParticipant = $5abbf67eac92d775$var$HelixSharedChatSessionParticipant = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSharedChatSessionParticipant', 'broadcasterId')
], $5abbf67eac92d775$var$HelixSharedChatSessionParticipant);

});



parcelRegister("fJP1s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixClipApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $4DWkQ = parcelRequire("4DWkQ");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $8UWnv = parcelRequire("8UWnv");
/**
 * The Helix API methods that deal with clips.
 *
 * Can be accessed using `client.clips` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const clipId = await api.clips.createClip({ channel: '125328655' });
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Clips
 */ let $b752a2fd6f3c3092$var$HelixClipApi = class HelixClipApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getClipByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'clips'
        }, 'id', 'id', this._client, (data)=>new $8UWnv.HelixClip(data, this._client));
    }
    /**
     * Gets clips for the specified broadcaster in descending order of views.
     *
     * @param broadcaster The broadcaster to fetch clips for.
     * @param filter
     *
     * @expandParams
     */ async getClipsForBroadcaster(broadcaster, filter = {}) {
        return await this._getClips({
            ...filter,
            filterType: 'broadcaster_id',
            ids: (0, $j0DIQ.extractUserId)(broadcaster),
            userId: (0, $j0DIQ.extractUserId)(broadcaster)
        });
    }
    /**
     * Creates a paginator for clips for the specified broadcaster.
     *
     * @param broadcaster The broadcaster to fetch clips for.
     * @param filter
     *
     * @expandParams
     */ getClipsForBroadcasterPaginated(broadcaster, filter = {}) {
        return this._getClipsPaginated({
            ...filter,
            filterType: 'broadcaster_id',
            ids: (0, $j0DIQ.extractUserId)(broadcaster),
            userId: (0, $j0DIQ.extractUserId)(broadcaster)
        });
    }
    /**
     * Gets clips for the specified game in descending order of views.
     *
     * @param gameId The game ID.
     * @param filter
     *
     * @expandParams
     */ async getClipsForGame(gameId, filter = {}) {
        return await this._getClips({
            ...filter,
            filterType: 'game_id',
            ids: gameId
        });
    }
    /**
     * Creates a paginator for clips for the specified game.
     *
     * @param gameId The game ID.
     * @param filter
     *
     * @expandParams
     */ getClipsForGamePaginated(gameId, filter = {}) {
        return this._getClipsPaginated({
            ...filter,
            filterType: 'game_id',
            ids: gameId
        });
    }
    /**
     * Gets the clips identified by the given IDs.
     *
     * @param ids The clip IDs.
     */ async getClipsByIds(ids) {
        const result = await this._getClips({
            filterType: 'id',
            ids: ids
        });
        return result.data;
    }
    /**
     * Gets the clip identified by the given ID.
     *
     * @param id The clip ID.
     */ async getClipById(id) {
        const clips = await this.getClipsByIds([
            id
        ]);
        return clips.length ? clips[0] : null;
    }
    /**
     * Gets the clip identified by the given ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param id The clip ID.
     */ async getClipByIdBatched(id) {
        return await this._getClipByIdBatcher.request(id);
    }
    /**
     * Creates a clip of a running stream.
     *
     * Returns the ID of the clip.
     *
     * @param params
     * @expandParams
     */ async createClip(params) {
        const { channel: channel, createAfterDelay: createAfterDelay = false } = params;
        const result = await this._client.callApi({
            type: 'helix',
            url: 'clips',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'clips:edit'
            ],
            canOverrideScopedUserContext: true,
            query: (0, $4DWkQ.createClipCreateQuery)(channel, createAfterDelay)
        });
        return result.data[0].id;
    }
    async _getClips(params) {
        if (!params.ids.length) return {
            data: []
        };
        const result = await this._client.callApi({
            type: 'helix',
            url: 'clips',
            userId: params.userId,
            query: {
                ...(0, $4DWkQ.createClipQuery)(params),
                ...(0, $4AsKM.createPaginationQuery)(params)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $8UWnv.HelixClip, this._client);
    }
    _getClipsPaginated(params) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'clips',
            userId: params.userId,
            query: (0, $4DWkQ.createClipQuery)(params)
        }, this._client, (data)=>new $8UWnv.HelixClip(data, this._client));
    }
};
module.exports.HelixClipApi = $b752a2fd6f3c3092$var$HelixClipApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $b752a2fd6f3c3092$var$HelixClipApi.prototype, "_getClipByIdBatcher", void 0);
module.exports.HelixClipApi = $b752a2fd6f3c3092$var$HelixClipApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixClipApi')
], $b752a2fd6f3c3092$var$HelixClipApi);

});
parcelRegister("4DWkQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createClipQuery = module.exports.createClipCreateQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $36180e1a8283fbb3$var$createClipCreateQuery(channel, createAfterDelay) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(channel),
        has_delay: createAfterDelay.toString()
    };
}
module.exports.createClipCreateQuery = $36180e1a8283fbb3$var$createClipCreateQuery;
/** @internal */ function $36180e1a8283fbb3$var$createClipQuery(params) {
    const { filterType: filterType, ids: ids, startDate: startDate, endDate: endDate, isFeatured: isFeatured } = params;
    return {
        [filterType]: ids,
        started_at: startDate,
        ended_at: endDate,
        is_featured: isFeatured === null || isFeatured === void 0 ? void 0 : isFeatured.toString()
    };
}
module.exports.createClipQuery = $36180e1a8283fbb3$var$createClipQuery;

});

parcelRegister("8UWnv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixClip = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A clip from a Twitch stream.
 */ let $67e0d65be9f3b197$var$HelixClip = class HelixClip extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The clip ID.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The URL of the clip.
     */ get url() {
        return this[$j0DIQ.rawDataSymbol].url;
    }
    /**
     * The embed URL of the clip.
     */ get embedUrl() {
        return this[$j0DIQ.rawDataSymbol].embed_url;
    }
    /**
     * The user ID of the broadcaster of the stream where the clip was created.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The display name of the broadcaster of the stream where the clip was created.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets information about the broadcaster of the stream where the clip was created.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The user ID of the creator of the clip.
     */ get creatorId() {
        return this[$j0DIQ.rawDataSymbol].creator_id;
    }
    /**
     * The display name of the creator of the clip.
     */ get creatorDisplayName() {
        return this[$j0DIQ.rawDataSymbol].creator_name;
    }
    /**
     * Gets information about the creator of the clip.
     */ async getCreator() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].creator_id));
    }
    /**
     * The ID of the video the clip is taken from.
     */ get videoId() {
        return this[$j0DIQ.rawDataSymbol].video_id;
    }
    /**
     * Gets information about the video the clip is taken from.
     */ async getVideo() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.videos.getVideoById(this[$j0DIQ.rawDataSymbol].video_id));
    }
    /**
     * The ID of the game that was being played when the clip was created.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * Gets information about the game that was being played when the clip was created.
     */ async getGame() {
        return this[$j0DIQ.rawDataSymbol].game_id ? (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id)) : null;
    }
    /**
     * The language of the stream where the clip was created.
     */ get language() {
        return this[$j0DIQ.rawDataSymbol].language;
    }
    /**
     * The title of the clip.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The number of views of the clip.
     */ get views() {
        return this[$j0DIQ.rawDataSymbol].view_count;
    }
    /**
     * The date when the clip was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The URL of the thumbnail of the clip.
     */ get thumbnailUrl() {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url;
    }
    /**
     * The duration of the clip in seconds (up to 0.1 precision).
     */ get duration() {
        return this[$j0DIQ.rawDataSymbol].duration;
    }
    /**
     * The offset of the clip from the start of the corresponding VOD, in seconds.
     *
     * This may be null if there is no VOD or if the clip is created from a live broadcast,
     * in which case it may take a few minutes to associate with the VOD.
     */ get vodOffset() {
        return this[$j0DIQ.rawDataSymbol].vod_offset;
    }
    /**
     * Whether the clip is featured.
     */ get isFeatured() {
        return this[$j0DIQ.rawDataSymbol].is_featured;
    }
};
module.exports.HelixClip = $67e0d65be9f3b197$var$HelixClip;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $67e0d65be9f3b197$var$HelixClip.prototype, "_client", void 0);
module.exports.HelixClip = $67e0d65be9f3b197$var$HelixClip = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixClip', 'id')
], $67e0d65be9f3b197$var$HelixClip);

});


parcelRegister("2LQEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixContentClassificationLabelApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $lq7i7 = parcelRequire("lq7i7");

var $hDi1V = parcelRequire("hDi1V");
/**
 * The Helix API methods that deal with content classification labels.
 *
 * Can be accessed using `client.contentClassificationLabels` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const labels = await api.contentClassificationLabels.getAll();
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Content classification labels
 */ let $2048cf91cf1e3390$var$HelixContentClassificationLabelApi = class HelixContentClassificationLabelApi extends $lq7i7.BaseApi {
    /**
     * Fetches a list of all content classification labels.
     *
     * @param locale The locale for the content classification labels.
     */ async getAll(locale) {
        const result = await this._client.callApi({
            url: 'content_classification_labels',
            query: {
                locale: locale
            }
        });
        return result.data.map((data)=>new $hDi1V.HelixContentClassificationLabel(data));
    }
};
module.exports.HelixContentClassificationLabelApi = $2048cf91cf1e3390$var$HelixContentClassificationLabelApi;
module.exports.HelixContentClassificationLabelApi = $2048cf91cf1e3390$var$HelixContentClassificationLabelApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixContentClassificationLabelApi')
], $2048cf91cf1e3390$var$HelixContentClassificationLabelApi);

});
parcelRegister("hDi1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixContentClassificationLabel = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A content classification label that can be applied to a Twitch stream.
 */ class $cd641099ac9c767a$var$HelixContentClassificationLabel extends $j0DIQ.DataObject {
    /**
     * The ID of the content classification label.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the content classification label.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].name;
    }
    /**
     * The description of the content classification label.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
}
module.exports.HelixContentClassificationLabel = $cd641099ac9c767a$var$HelixContentClassificationLabel;

});


parcelRegister("4MAQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEntitlementApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $ap6kI = parcelRequire("ap6kI");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $hM3JO = parcelRequire("hM3JO");
/**
 * The Helix API methods that deal with entitlements (drops).
 *
 * Can be accessed using `client.entitlements` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const clipId = await api.entitlements.getDropsEntitlements();
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Entitlements (Drops)
 */ let $37b83929a080cd29$var$HelixEntitlementApi = class HelixEntitlementApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getDropsEntitlementByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'entitlements/drops'
        }, 'id', 'id', this._client, (data)=>new $hM3JO.HelixDropsEntitlement(data, this._client));
    }
    /**
     * Gets the drops entitlements for the given filter.
     *
     * @expandParams
     *
     * @param filter
     * @param alwaysApp Whether an app token should always be used, even if a user filter is given.
     */ async getDropsEntitlements(filter, alwaysApp = false) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'entitlements/drops',
            userId: (0, $bRvJY.mapOptional)(filter.user, $j0DIQ.extractUserId),
            forceType: filter.user && alwaysApp ? 'app' : undefined,
            query: {
                ...(0, $ap6kI.createDropsEntitlementQuery)(filter, alwaysApp),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(response, $hM3JO.HelixDropsEntitlement, this._client);
    }
    /**
     * Creates a paginator for drops entitlements for the given filter.
     *
     * @expandParams
     *
     * @param filter
     * @param alwaysApp Whether an app token should always be used, even if a user filter is given.
     */ getDropsEntitlementsPaginated(filter, alwaysApp = false) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'entitlements/drops',
            userId: (0, $bRvJY.mapOptional)(filter.user, $j0DIQ.extractUserId),
            forceType: filter.user && alwaysApp ? 'app' : undefined,
            query: (0, $ap6kI.createDropsEntitlementQuery)(filter, alwaysApp)
        }, this._client, (data)=>new $hM3JO.HelixDropsEntitlement(data, this._client));
    }
    /**
     * Gets the drops entitlements for the given IDs.
     *
     * @param ids The IDs to fetch.
     */ async getDropsEntitlementsByIds(ids) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'entitlements/drops',
            query: {
                id: ids
            }
        });
        return response.data.map((data)=>new $hM3JO.HelixDropsEntitlement(data, this._client));
    }
    /**
     * Gets the drops entitlement for the given ID.
     *
     * @param id The ID to fetch.
     */ async getDropsEntitlementById(id) {
        var _a;
        const result = await this.getDropsEntitlementsByIds([
            id
        ]);
        return (_a = result[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Gets the drops entitlement for the given ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param id The ID to fetch.
     */ async getDropsEntitlementByIdBatched(id) {
        return await this._getDropsEntitlementByIdBatcher.request(id);
    }
    /**
     * Updates the status of a list of drops entitlements.
     *
     * Returns a map that associates each given ID with its update status.
     *
     * @param ids The IDs of the entitlements.
     * @param fulfillmentStatus The fulfillment status to set the entitlements to.
     */ async updateDropsEntitlements(ids, fulfillmentStatus) {
        const response = await this._client.callApi({
            type: 'helix',
            url: 'entitlements/drops',
            method: 'PATCH',
            jsonBody: (0, $ap6kI.createDropsEntitlementUpdateBody)(ids, fulfillmentStatus)
        });
        return new Map(response.data.flatMap((entry)=>entry.ids.map((id)=>[
                    id,
                    entry.status
                ])));
    }
};
module.exports.HelixEntitlementApi = $37b83929a080cd29$var$HelixEntitlementApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $37b83929a080cd29$var$HelixEntitlementApi.prototype, "_getDropsEntitlementByIdBatcher", void 0);
module.exports.HelixEntitlementApi = $37b83929a080cd29$var$HelixEntitlementApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEntitlementApi')
], $37b83929a080cd29$var$HelixEntitlementApi);

});
parcelRegister("ap6kI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDropsEntitlementUpdateBody = module.exports.createDropsEntitlementQuery = void 0;

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $793126cd5a682fe9$var$createDropsEntitlementQuery(filters, alwaysApp) {
    return {
        user_id: alwaysApp ? (0, $bRvJY.mapOptional)(filters.user, $j0DIQ.extractUserId) : undefined,
        game_id: filters.gameId,
        fulfillment_status: filters.fulfillmentStatus
    };
}
module.exports.createDropsEntitlementQuery = $793126cd5a682fe9$var$createDropsEntitlementQuery;
/** @internal */ function $793126cd5a682fe9$var$createDropsEntitlementUpdateBody(ids, fulfillmentStatus) {
    return {
        fulfillment_status: fulfillmentStatus,
        entitlement_ids: ids
    };
}
module.exports.createDropsEntitlementUpdateBody = $793126cd5a682fe9$var$createDropsEntitlementUpdateBody;

});

parcelRegister("hM3JO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixDropsEntitlement = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An entitlement for a drop.
 */ let $cf09d1a4cd5052b6$var$HelixDropsEntitlement = class HelixDropsEntitlement extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the entitlement.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the reward.
     */ get rewardId() {
        return this[$j0DIQ.rawDataSymbol].benefit_id;
    }
    /**
     * The date when the entitlement was granted.
     */ get grantDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].timestamp);
    }
    /**
     * The ID of the entitled user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * Gets more information about the entitled user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The ID of the game the entitlement was granted for.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * Gets more information about the game the entitlement was granted for.
     */ async getGame() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id));
    }
    /**
     * The fulfillment status of the entitlement.
     */ get fulfillmentStatus() {
        return this[$j0DIQ.rawDataSymbol].fulfillment_status;
    }
    /**
     * The date when the entitlement was last updated.
     */ get updateDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].last_updated);
    }
};
module.exports.HelixDropsEntitlement = $cf09d1a4cd5052b6$var$HelixDropsEntitlement;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $cf09d1a4cd5052b6$var$HelixDropsEntitlement.prototype, "_client", void 0);
module.exports.HelixDropsEntitlement = $cf09d1a4cd5052b6$var$HelixDropsEntitlement = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixDropsEntitlement')
], $cf09d1a4cd5052b6$var$HelixDropsEntitlement);

});


parcelRegister("iZjEc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEventSubApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $6PgY9 = parcelRequire("6PgY9");

var $78zDw = parcelRequire("78zDw");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $lgnUZ = parcelRequire("lgnUZ");

var $90YWS = parcelRequire("90YWS");

var $h4D57 = parcelRequire("h4D57");

var $cPjDL = parcelRequire("cPjDL");
/**
 * The API methods that deal with EventSub.
 *
 * Can be accessed using `client.eventSub` on an {@link ApiClient} instance.
 *
 * ## Before using these methods...
 *
 * All methods in this class assume that you are already running a working EventSub listener reachable using the given transport.
 *
 * If you don't already have one, we recommend use of the `@twurple/eventsub-http` or `@twurple/eventsub-ws` libraries,
 * which handle subscribing and unsubscribing to these topics automatically.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * await api.eventSub.subscribeToUserFollowsTo('125328655', { callbackUrl: 'https://example.com' });
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle EventSub
 */ let $03913e9d34951e33$var$HelixEventSubApi = class HelixEventSubApi extends $lq7i7.BaseApi {
    /**
     * Gets the current EventSub subscriptions for the current client.
     *
     * @param pagination
     *
     * @expandParams
     */ async getSubscriptions(pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            query: (0, $4AsKM.createPaginationQuery)(pagination)
        });
        return {
            ...(0, $7rg9J.createPaginatedResultWithTotal)(result, $lgnUZ.HelixEventSubSubscription, this._client),
            totalCost: result.total_cost,
            maxTotalCost: result.max_total_cost
        };
    }
    /**
     * Creates a paginator for the current EventSub subscriptions for the current client.
     */ getSubscriptionsPaginated() {
        return new $90YWS.HelixPaginatedEventSubSubscriptionsRequest({}, undefined, this._client);
    }
    /**
     * Gets the current EventSub subscriptions with the given status for the current client.
     *
     * @param status The status of the subscriptions to get.
     * @param pagination
     *
     * @expandParams
     */ async getSubscriptionsForStatus(status, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            query: {
                ...(0, $4AsKM.createPaginationQuery)(pagination),
                status: status
            }
        });
        return {
            ...(0, $7rg9J.createPaginatedResultWithTotal)(result, $lgnUZ.HelixEventSubSubscription, this._client),
            totalCost: result.total_cost,
            maxTotalCost: result.max_total_cost
        };
    }
    /**
     * Creates a paginator for the current EventSub subscriptions with the given status for the current client.
     *
     * @param status The status of the subscriptions to get.
     */ getSubscriptionsForStatusPaginated(status) {
        return new $90YWS.HelixPaginatedEventSubSubscriptionsRequest({
            status: status
        }, undefined, this._client);
    }
    /**
     * Gets the current EventSub subscriptions with the given type for the current client.
     *
     * @param type The type of the subscriptions to get.
     * @param pagination
     *
     * @expandParams
     */ async getSubscriptionsForType(type, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            query: {
                ...(0, $4AsKM.createPaginationQuery)(pagination),
                type: type
            }
        });
        return {
            ...(0, $7rg9J.createPaginatedResultWithTotal)(result, $lgnUZ.HelixEventSubSubscription, this._client),
            totalCost: result.total_cost,
            maxTotalCost: result.max_total_cost
        };
    }
    /**
     * Creates a paginator for the current EventSub subscriptions with the given type for the current client.
     *
     * @param type The type of the subscriptions to get.
     */ getSubscriptionsForTypePaginated(type) {
        return new $90YWS.HelixPaginatedEventSubSubscriptionsRequest({
            type: type
        }, undefined, this._client);
    }
    /**
     * Gets the current EventSub subscriptions for the current user and client.
     *
     * @param user The user to get subscriptions for.
     * @param pagination
     *
     * @expandParams
     */ async getSubscriptionsForUser(user, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            userId: (0, $j0DIQ.extractUserId)(user),
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('user_id', (0, $j0DIQ.extractUserId)(user)),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return {
            ...(0, $7rg9J.createPaginatedResultWithTotal)(result, $lgnUZ.HelixEventSubSubscription, this._client),
            totalCost: result.total_cost,
            maxTotalCost: result.max_total_cost
        };
    }
    /**
     * Creates a paginator for the current EventSub subscriptions with the given type for the current client.
     *
     * @param user The user to get subscriptions for.
     */ getSubscriptionsForUserPaginated(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return new $90YWS.HelixPaginatedEventSubSubscriptionsRequest((0, $78zDw.createSingleKeyQuery)('user_id', userId), userId, this._client);
    }
    /**
     * Sends an arbitrary request to subscribe to an event.
     *
     * You can only create WebHook transport subscriptions using app tokens
     * and WebSocket transport subscriptions using user tokens.
     *
     * @param type The type of the event.
     * @param version The version of the event.
     * @param condition The condition of the subscription.
     * @param transport The transport of the subscription.
     * @param user The user to create the subscription in context of.
     * @param requiredScopeSet The scope set required by the subscription. Will only be checked for applicable transports.
     * @param canOverrideScopedUserContext Whether the auth user context can be overridden.
     * @param isBatched Whether to enable batching for the subscription. Is only supported for select topics.
     */ async createSubscription(type, version, condition, transport, user, requiredScopeSet, canOverrideScopedUserContext, isBatched) {
        const usesAppAuth = transport.method === 'webhook' || transport.method === 'conduit';
        const scopes = usesAppAuth ? undefined : requiredScopeSet;
        if (!usesAppAuth && !user) throw new Error(`Transport ${transport.method} can only handle subscriptions with user context`);
        const jsonBody = {
            type: type,
            version: version,
            condition: condition,
            transport: transport
        };
        if (isBatched) jsonBody.is_batching_enabled = true;
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            method: 'POST',
            scopes: scopes,
            userId: (0, $bRvJY.mapOptional)(user, $j0DIQ.extractUserId),
            canOverrideScopedUserContext: canOverrideScopedUserContext,
            forceType: usesAppAuth ? 'app' : 'user',
            jsonBody: jsonBody
        });
        return new $lgnUZ.HelixEventSubSubscription(result.data[0], this._client);
    }
    /**
     * Deletes a subscription.
     *
     * @param id The ID of the subscription.
     */ async deleteSubscription(id) {
        await this._client.callApi({
            type: 'helix',
            url: 'eventsub/subscriptions',
            method: 'DELETE',
            query: {
                id: id
            }
        });
    }
    /**
     * Deletes *all* subscriptions.
     */ async deleteAllSubscriptions() {
        await this._deleteSubscriptionsWithCondition();
    }
    /**
     * Deletes all broken subscriptions, i.e. all that are not enabled or pending verification.
     */ async deleteBrokenSubscriptions() {
        await this._deleteSubscriptionsWithCondition((sub)=>sub.status !== 'enabled' && sub.status !== 'webhook_callback_verification_pending');
    }
    /**
     * Subscribe to events that represent a stream going live.
     *
     * @param broadcaster The broadcaster you want to listen to online events for.
     * @param transport The transport options.
     */ async subscribeToStreamOnlineEvents(broadcaster, transport) {
        return await this.createSubscription('stream.online', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster);
    }
    /**
     * Subscribe to events that represent a stream going offline.
     *
     * @param broadcaster The broadcaster you want to listen to online events for.
     * @param transport The transport options.
     */ async subscribeToStreamOfflineEvents(broadcaster, transport) {
        return await this.createSubscription('stream.offline', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster);
    }
    /**
     * Subscribe to events that represent a channel updating their metadata.
     *
     * @param broadcaster The broadcaster you want to listen to update events for.
     * @param transport The transport options.
     */ async subscribeToChannelUpdateEvents(broadcaster, transport) {
        return await this.createSubscription('channel.update', '2', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster);
    }
    /**
     * Subscribe to events that represent a user following a channel.
     *
     * @param broadcaster The broadcaster you want to listen to follow events for.
     * @param transport The transport options.
     */ async subscribeToChannelFollowEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.follow', '2', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcasterId, [
            'moderator:read:followers'
        ], true);
    }
    /**
     * Subscribe to events that represent a user subscribing to a channel.
     *
     * @param broadcaster The broadcaster you want to listen to subscribe events for.
     * @param transport The transport options.
     */ async subscribeToChannelSubscriptionEvents(broadcaster, transport) {
        return await this.createSubscription('channel.subscribe', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:subscriptions'
        ]);
    }
    /**
     * Subscribe to events that represent a user gifting another user a subscription to a channel.
     *
     * @param broadcaster The broadcaster you want to listen to subscription gift events for.
     * @param transport The transport options.
     */ async subscribeToChannelSubscriptionGiftEvents(broadcaster, transport) {
        return await this.createSubscription('channel.subscription.gift', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:subscriptions'
        ]);
    }
    /**
     * Subscribe to events that represent a user's subscription to a channel being announced.
     *
     * @param broadcaster The broadcaster you want to listen to subscription message events for.
     * @param transport The transport options.
     */ async subscribeToChannelSubscriptionMessageEvents(broadcaster, transport) {
        return await this.createSubscription('channel.subscription.message', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:subscriptions'
        ]);
    }
    /**
     * Subscribe to events that represent a user's subscription to a channel ending.
     *
     * @param broadcaster The broadcaster you want to listen to subscription end events for.
     * @param transport The transport options.
     */ async subscribeToChannelSubscriptionEndEvents(broadcaster, transport) {
        return await this.createSubscription('channel.subscription.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:subscriptions'
        ]);
    }
    /**
     * Subscribe to events that represent a user cheering bits to a channel.
     *
     * @param broadcaster The broadcaster you want to listen to cheer events for.
     * @param transport The transport options.
     */ async subscribeToChannelCheerEvents(broadcaster, transport) {
        return await this.createSubscription('channel.cheer', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'bits:read'
        ]);
    }
    /**
     * Subscribe to events that represent a charity campaign starting in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to charity donation events for.
     * @param transport The transport options.
     */ async subscribeToChannelCharityCampaignStartEvents(broadcaster, transport) {
        return await this.createSubscription('channel.charity_campaign.start', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:charity'
        ]);
    }
    /**
     * Subscribe to events that represent a charity campaign ending in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to charity donation events for.
     * @param transport The transport options.
     */ async subscribeToChannelCharityCampaignStopEvents(broadcaster, transport) {
        return await this.createSubscription('channel.charity_campaign.stop', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:charity'
        ]);
    }
    /**
     * Subscribe to events that represent a user donating to a charity campaign in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to charity donation events for.
     * @param transport The transport options.
     */ async subscribeToChannelCharityDonationEvents(broadcaster, transport) {
        return await this.createSubscription('channel.charity_campaign.donate', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:charity'
        ]);
    }
    /**
     * Subscribe to events that represent a charity campaign progressing in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to charity donation events for.
     * @param transport The transport options.
     */ async subscribeToChannelCharityCampaignProgressEvents(broadcaster, transport) {
        return await this.createSubscription('channel.charity_campaign.progress', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:charity'
        ]);
    }
    /**
     * Subscribe to events that represent a user being banned in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to ban events for.
     * @param transport The transport options.
     */ async subscribeToChannelBanEvents(broadcaster, transport) {
        return await this.createSubscription('channel.ban', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:moderate'
        ]);
    }
    /**
     * Subscribe to events that represent a user being unbanned in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to unban events for.
     * @param transport The transport options.
     */ async subscribeToChannelUnbanEvents(broadcaster, transport) {
        return await this.createSubscription('channel.unban', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:moderate'
        ]);
    }
    /**
     * Subscribe to events that represent Shield Mode being activated in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to Shield Mode activation events for.
     * @param transport The transport options.
     */ async subscribeToChannelShieldModeBeginEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shield_mode.begin', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcasterId, [
            'moderator:read:shield_mode',
            'moderator:manage:shield_mode'
        ], true);
    }
    /**
     * Subscribe to events that represent Shield Mode being deactivated in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to Shield Mode deactivation events for.
     * @param transport The transport options.
     */ async subscribeToChannelShieldModeEndEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shield_mode.end', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcasterId, [
            'moderator:read:shield_mode',
            'moderator:manage:shield_mode'
        ], true);
    }
    /**
     * Subscribe to events that represent a moderator being added to a channel.
     *
     * @param broadcaster The broadcaster you want to listen for moderator add events for.
     * @param transport The transport options.
     */ async subscribeToChannelModeratorAddEvents(broadcaster, transport) {
        return await this.createSubscription('channel.moderator.add', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'moderation:read'
        ]);
    }
    /**
     * Subscribe to events that represent a moderator being removed from a channel.
     *
     * @param broadcaster The broadcaster you want to listen for moderator remove events for.
     * @param transport The transport options.
     */ async subscribeToChannelModeratorRemoveEvents(broadcaster, transport) {
        return await this.createSubscription('channel.moderator.remove', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'moderation:read'
        ]);
    }
    /**
     * Subscribe to events that represent a broadcaster raiding another broadcaster.
     *
     * @param broadcaster The broadcaster you want to listen to outgoing raid events for.
     * @param transport The transport options.
     */ async subscribeToChannelRaidEventsFrom(broadcaster, transport) {
        return await this.createSubscription('channel.raid', '1', (0, $78zDw.createSingleKeyQuery)('from_broadcaster_user_id', (0, $j0DIQ.extractUserId)(broadcaster)), transport, broadcaster);
    }
    /**
     * Subscribe to events that represent a broadcaster being raided by another broadcaster.
     *
     * @param broadcaster The broadcaster you want to listen to incoming raid events for.
     * @param transport The transport options.
     */ async subscribeToChannelRaidEventsTo(broadcaster, transport) {
        return await this.createSubscription('channel.raid', '1', (0, $78zDw.createSingleKeyQuery)('to_broadcaster_user_id', (0, $j0DIQ.extractUserId)(broadcaster)), transport, broadcaster);
    }
    /**
     * Subscribe to events that represent a Channel Points reward being added to a channel.
     *
     * @param broadcaster The broadcaster you want to listen to reward add events for.
     * @param transport The transport options.
     */ async subscribeToChannelRewardAddEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward.add', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points reward being updated in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to reward update events for.
     * @param transport The transport options.
     */ async subscribeToChannelRewardUpdateEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward.update', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a specific Channel Points reward being updated.
     *
     * @param broadcaster The broadcaster you want to listen to reward update events for.
     * @param rewardId The ID of the reward you want to listen to update events for.
     * @param transport The transport options.
     */ async subscribeToChannelRewardUpdateEventsForReward(broadcaster, rewardId, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward.update', '1', (0, $6PgY9.createEventSubRewardCondition)(broadcaster, rewardId), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points reward being removed from a channel.
     *
     * @param broadcaster The broadcaster you want to listen to reward remove events for.
     * @param transport The transport options.
     */ async subscribeToChannelRewardRemoveEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward.remove', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a specific Channel Points reward being removed from a channel.
     *
     * @param broadcaster The broadcaster you want to listen to reward remove events for.
     * @param rewardId The ID of the reward you want to listen to remove events for.
     * @param transport The transport options.
     */ async subscribeToChannelRewardRemoveEventsForReward(broadcaster, rewardId, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward.remove', '1', (0, $6PgY9.createEventSubRewardCondition)(broadcaster, rewardId), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points reward being redeemed.
     *
     * @param broadcaster The broadcaster you want to listen to redemption events for.
     * @param transport The transport options.
     */ async subscribeToChannelRedemptionAddEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward_redemption.add', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a specific Channel Points reward being redeemed.
     *
     * @param broadcaster The broadcaster you want to listen to redemption events for.
     * @param rewardId The ID of the reward you want to listen to redemption events for.
     * @param transport The transport options.
     */ async subscribeToChannelRedemptionAddEventsForReward(broadcaster, rewardId, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward_redemption.add', '1', (0, $6PgY9.createEventSubRewardCondition)(broadcaster, rewardId), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points redemption being updated.
     *
     * @param broadcaster The broadcaster you want to listen to redemption update events for.
     * @param transport The transport options.
     */ async subscribeToChannelRedemptionUpdateEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward_redemption.update', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a specific Channel Points reward's redemption being updated.
     *
     * @param broadcaster The broadcaster you want to listen to redemption update events for.
     * @param rewardId The ID of the reward you want to listen to redemption updates for.
     * @param transport The transport options.
     */ async subscribeToChannelRedemptionUpdateEventsForReward(broadcaster, rewardId, transport) {
        return await this.createSubscription('channel.channel_points_custom_reward_redemption.update', '1', (0, $6PgY9.createEventSubRewardCondition)(broadcaster, rewardId), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points automatic reward being redeemed.
     *
     * @param broadcaster The broadcaster you want to listen to automatic reward redemption events for.
     * @param transport The transport options.
     */ async subscribeToChannelAutomaticRewardRedemptionAddEvents(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_automatic_reward_redemption.add', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a Channel Points automatic reward being redeemed.
     *
     * @param broadcaster The broadcaster you want to listen to automatic reward redemption events for.
     * @param transport The transport options.
     */ async subscribeToChannelAutomaticRewardRedemptionAddV2Events(broadcaster, transport) {
        return await this.createSubscription('channel.channel_points_automatic_reward_redemption.add', '2', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:redemptions',
            'channel:manage:redemptions'
        ]);
    }
    /**
     * Subscribe to events that represent a poll starting in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to poll begin events for.
     * @param transport The transport options.
     */ async subscribeToChannelPollBeginEvents(broadcaster, transport) {
        return await this.createSubscription('channel.poll.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:polls',
            'channel:manage:polls'
        ]);
    }
    /**
     * Subscribe to events that represent a poll being voted on in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to poll progress events for.
     * @param transport The transport options.
     */ async subscribeToChannelPollProgressEvents(broadcaster, transport) {
        return await this.createSubscription('channel.poll.progress', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:polls',
            'channel:manage:polls'
        ]);
    }
    /**
     * Subscribe to events that represent a poll ending in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to poll end events for.
     * @param transport The transport options.
     */ async subscribeToChannelPollEndEvents(broadcaster, transport) {
        return await this.createSubscription('channel.poll.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:polls',
            'channel:manage:polls'
        ]);
    }
    /**
     * Subscribe to events that represent a prediction starting in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to prediction begin events for.
     * @param transport The transport options.
     */ async subscribeToChannelPredictionBeginEvents(broadcaster, transport) {
        return await this.createSubscription('channel.prediction.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:predictions',
            'channel:manage:predictions'
        ]);
    }
    /**
     * Subscribe to events that represent a prediction being voted on in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to prediction preogress events for.
     * @param transport The transport options.
     */ async subscribeToChannelPredictionProgressEvents(broadcaster, transport) {
        return await this.createSubscription('channel.prediction.progress', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:predictions',
            'channel:manage:predictions'
        ]);
    }
    /**
     * Subscribe to events that represent a prediction being locked in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to prediction lock events for.
     * @param transport The transport options.
     */ async subscribeToChannelPredictionLockEvents(broadcaster, transport) {
        return await this.createSubscription('channel.prediction.lock', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:predictions',
            'channel:manage:predictions'
        ]);
    }
    /**
     * Subscribe to events that represent a prediction ending in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to prediction end events for.
     * @param transport The transport options.
     */ async subscribeToChannelPredictionEndEvents(broadcaster, transport) {
        return await this.createSubscription('channel.prediction.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:predictions',
            'channel:manage:predictions'
        ]);
    }
    /**
     * Subscribe to events that represent the beginning of a creator goal event in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to goal begin events for.
     * @param transport The transport options.
     */ async subscribeToChannelGoalBeginEvents(broadcaster, transport) {
        return await this.createSubscription('channel.goal.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:goals'
        ]);
    }
    /**
     * Subscribe to events that represent progress towards a creator goal.
     *
     * @param broadcaster The broadcaster for which you want to listen to goal progress events.
     * @param transport The transport options.
     */ async subscribeToChannelGoalProgressEvents(broadcaster, transport) {
        return await this.createSubscription('channel.goal.progress', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:goals'
        ]);
    }
    /**
     * Subscribe to events that represent the end of a creator goal event.
     *
     * @param broadcaster The broadcaster for which you want to listen to goal end events.
     * @param transport The transport options.
     */ async subscribeToChannelGoalEndEvents(broadcaster, transport) {
        return await this.createSubscription('channel.goal.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:goals'
        ]);
    }
    /**
     * Subscribe to events that represent the beginning of a Hype Train event in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to Hype train begin events for.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainBeginEvents(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent progress towards the Hype Train goal.
     *
     * @param broadcaster The broadcaster for which you want to listen to Hype Train progress events.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainProgressEvents(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.progress', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent the end of a Hype Train event.
     *
     * @param broadcaster The broadcaster for which you want to listen to Hype Train end events.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainEndEvents(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent the beginning of a Hype Train event in a channel.
     *
     * @param broadcaster The broadcaster you want to listen to Hype train begin events for.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainBeginV2Events(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.begin', '2', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent progress towards the Hype Train goal.
     *
     * @param broadcaster The broadcaster for which you want to listen to Hype Train progress events.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainProgressV2Events(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.progress', '2', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent the end of a Hype Train event.
     *
     * @param broadcaster The broadcaster for which you want to listen to Hype Train end events.
     * @param transport The transport options.
     */ async subscribeToChannelHypeTrainEndV2Events(broadcaster, transport) {
        return await this.createSubscription('channel.hype_train.end', '2', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:hype_train'
        ]);
    }
    /**
     * Subscribe to events that represent a broadcaster shouting out another broadcaster.
     *
     * @param broadcaster The broadcaster for which you want to listen to outgoing shoutout events.
     * @param transport The transport options.
     */ async subscribeToChannelShoutoutCreateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shoutout.create', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcasterId, [
            'moderator:read:shoutouts',
            'moderator:manage:shoutouts'
        ], true);
    }
    /**
     * Subscribe to events that represent a broadcaster being shouting out by another broadcaster.
     *
     * @param broadcaster The broadcaster for which you want to listen to incoming shoutout events.
     * @param transport The transport options.
     */ async subscribeToChannelShoutoutReceiveEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shoutout.receive', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcasterId, [
            'moderator:read:shoutouts',
            'moderator:manage:shoutouts'
        ], true);
    }
    /**
     * Subscribe to events that represent an ad break beginning in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to ad break begin events.
     * @param transport The transport options.
     */ async subscribeToChannelAdBreakBeginEvents(broadcaster, transport) {
        return await this.createSubscription('channel.ad_break.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:ads'
        ]);
    }
    /**
     * Subscribe to events that represent a channel's chat being cleared.
     *
     * @param broadcaster The broadcaster for which you want to listen to chat clear events.
     * @param transport The transport options.
     */ async subscribeToChannelChatClearEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.clear', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent a user's chat messages being cleared in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to user chat message clear events.
     * @param transport The transport options.
     */ async subscribeToChannelChatClearUserMessagesEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.clear_user_messages', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent a chat message being deleted in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to chat message delete events.
     * @param transport The transport options.
     */ async subscribeToChannelChatMessageDeleteEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.message_delete', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent a chat notification in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to chat notification events.
     * @param transport The transport options.
     */ async subscribeToChannelChatNotificationEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.notification', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent a chat message in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to chat message events.
     * @param transport The transport options.
     */ async subscribeToChannelChatMessageEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.message', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent chat settings being updated in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to chat settings update events.
     * @param transport The transport options.
     */ async subscribeToChannelChatSettingsUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat_settings.update', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribe to events that represent a created unban requests in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to unban requests.
     * @param transport The transport options.
     */ async subscribeToChannelUnbanRequestCreateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.unban_request.create', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:unban_requests',
            'moderator:manage:unban_requests'
        ], true);
    }
    /**
     * Subscribe to events that represent a resolved unban requests in a channel.
     *
     * @param broadcaster The broadcaster for which you want to listen to unban requests.
     * @param transport The transport options.
     */ async subscribeToChannelUnbanRequestResolveEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.unban_request.resolve', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:unban_requests',
            'moderator:manage:unban_requests'
        ], true);
    }
    /**
     * Subscribe to events that represent a moderator performing an action on a channel.
     *
     * This requires the following scopes:
     * - `moderator:read:blocked_terms` OR `moderator:manage:blocked_terms`
     * - `moderator:read:chat_settings` OR `moderator:manage:chat_settings`
     * - `moderator:read:unban_requests` OR `moderator:manage:unban_requests`
     * - `moderator:read:banned_users` OR `moderator:manage:banned_users`
     * - `moderator:read:chat_messages` OR `moderator:manage:chat_messages`
     * - `moderator:read:warnings` OR `moderator:manage:warnings`
     * - `moderator:read:moderators`
     * - `moderator:read:vips`
     *
     * These scope requirements cannot be checked by the library, so they are just assumed.
     * Make sure to catch authorization errors yourself.
     *
     * @param broadcaster The broadcaster for which you want to listen to moderation events.
     * @param transport The transport options.
     */ async subscribeToChannelModerateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.moderate', '2', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [], true);
    }
    /**
     * Subscribe to events that represent a warning being acknowledged by a user.
     *
     * @param broadcaster The broadcaster for whom you want to listen to warnings.
     * @param transport The transport options.
     */ async subscribeToChannelWarningAcknowledgeEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.warning.acknowledge', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:warnings',
            'moderator:manage:warnings'
        ], true);
    }
    /**
     * Subscribe to events that represent a warning sent to a user.
     *
     * @param broadcaster The broadcaster for whom you want to listen to warnings.
     * @param transport The transport options.
     */ async subscribeToChannelWarningSendEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.warning.send', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:warnings',
            'moderator:manage:warnings'
        ], true);
    }
    /**
     * Subscribe to events that represent a VIP being added to a channel.
     *
     * @param broadcaster The broadcaster you want to listen for VIP add events for.
     * @param transport The transport options.
     */ async subscribeToChannelVipAddEvents(broadcaster, transport) {
        return await this.createSubscription('channel.vip.add', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:vips',
            'channel:manage:vips'
        ]);
    }
    /**
     * Subscribe to events that represent a VIP being removed from a channel.
     *
     * @param broadcaster The broadcaster you want to listen for VIP remove events for.
     * @param transport The transport options.
     */ async subscribeToChannelVipRemoveEvents(broadcaster, transport) {
        return await this.createSubscription('channel.vip.remove', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcaster), transport, broadcaster, [
            'channel:read:vips',
            'channel:manage:vips'
        ]);
    }
    /**
     * Subscribe to events that represent an extension Bits transaction.
     *
     * @param clientId The Client ID for the extension you want to listen to Bits transactions for.
     * @param transport The transport options.
     */ async subscribeToExtensionBitsTransactionCreateEvents(clientId, transport) {
        return await this.createSubscription('extension.bits_transaction.create', '1', (0, $78zDw.createSingleKeyQuery)('extension_client_id', clientId), transport);
    }
    /**
     * Subscribe to events that represent a user granting authorization to an application.
     *
     * @param clientId The Client ID for the application you want to listen to authorization grant events for.
     * @param transport The transport options.
     */ async subscribeToUserAuthorizationGrantEvents(clientId, transport) {
        return await this.createSubscription('user.authorization.grant', '1', (0, $78zDw.createSingleKeyQuery)('client_id', clientId), transport);
    }
    /**
     * Subscribe to events that represent a user revoking their authorization from an application.
     *
     * @param clientId The Client ID for the application you want to listen to authorization revoke events for.
     * @param transport The transport options.
     */ async subscribeToUserAuthorizationRevokeEvents(clientId, transport) {
        return await this.createSubscription('user.authorization.revoke', '1', (0, $78zDw.createSingleKeyQuery)('client_id', clientId), transport);
    }
    /**
     * Subscribe to events that represent a user updating their account details.
     *
     * @param user The user you want to listen to user update events for.
     * @param transport The transport options.
     * @param withEmail Whether to request adding the email address of the user to the notification.
     *
     * Only has an effect with the websocket transport.
     * With the webhook transport, this depends solely on the previous authorization given by the user.
     */ async subscribeToUserUpdateEvents(user, transport, withEmail) {
        return await this.createSubscription('user.update', '1', (0, $78zDw.createSingleKeyQuery)('user_id', (0, $j0DIQ.extractUserId)(user)), transport, user, withEmail ? [
            'user:read:email'
        ] : undefined);
    }
    /**
     * Subscribe to events that represent a user receiving a whisper message from another user.
     *
     * @param user The user you want to listen to whisper message events for.
     * @param transport The transport options.
     */ async subscribeToUserWhisperMessageEvents(user, transport) {
        return await this.createSubscription('user.whisper.message', '1', (0, $78zDw.createSingleKeyQuery)('user_id', (0, $j0DIQ.extractUserId)(user)), transport, user, [
            'user:read:whispers',
            'user:manage:whispers'
        ]);
    }
    /**
     * Subscribe to events that represent a drop entitlement being granted.
     *
     * @expandParams
     *
     * @param filter
     * @param transport The transport options.
     */ async subscribeToDropEntitlementGrantEvents(filter, transport) {
        return await this.createSubscription('drop.entitlement.grant', '1', (0, $6PgY9.createEventSubDropEntitlementGrantCondition)(filter), transport, undefined, undefined, false, true);
    }
    /**
     * Subscribes to events that represent a chat message being held by AutoMod.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message hold events for.
     * @param transport The transport options.
     */ async subscribeToAutoModMessageHoldEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.message.hold', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:manage:automod'
        ], true);
    }
    /**
     * Subscribes to events that represent a held chat message by AutoMod being resolved.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message resolution events for.
     * @param transport The transport options.
     */ async subscribeToAutoModMessageUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.message.update', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:manage:automod'
        ], true);
    }
    /**
     * Subscribes to events (v2) that represent a chat message being held by AutoMod.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message hold events for.
     * @param transport The transport options.
     */ async subscribeToAutoModMessageHoldV2Events(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.message.hold', '2', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:manage:automod'
        ], true);
    }
    /**
     * Subscribes to events (v2) that represent a held chat message by AutoMod being resolved.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message resolution events for.
     * @param transport The transport options.
     */ async subscribeToAutoModMessageUpdateV2Events(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.message.update', '2', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:manage:automod'
        ], true);
    }
    /**
     * Subscribes to events that represent the AutoMod settings being updated.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod settings update events.
     * @param transport The transport options.
     */ async subscribeToAutoModSettingsUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.settings.update', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:automod_settings'
        ], true);
    }
    /**
     * Subscribes to events that represent the AutoMod terms being updated.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod terms update events.
     * @param transport The transport options.
     */ async subscribeToAutoModTermsUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('automod.terms.update', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:manage:automod'
        ], true);
    }
    /**
     * Subscribes to events that represent a user's notification about their message being held by AutoMod.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message hold events for.
     * @param transport The transport options.
     */ async subscribeToChannelChatUserMessageHoldEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.user_message_hold', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribes to events that represent a user's notification about a held chat message by AutoMod being resolved.
     *
     * @param broadcaster The broadcaster you want to listen to AutoMod message resolution events for.
     * @param transport The transport options.
     */ async subscribeToChannelChatUserMessageUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.chat.user_message_update', '1', (0, $6PgY9.createEventSubUserCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'user:read:chat'
        ], true);
    }
    /**
     * Subscribes to events that represent a suspicious user updated in a channel.
     *
     * @param broadcaster The broadcaster you want to listen for suspicious user update events.
     * @param transport The transport options.
     */ async subscribeToChannelSuspiciousUserUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.suspicious_user.update', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:suspicious_users'
        ], true);
    }
    /**
     * Subscribes to events that represent a message sent by a suspicious user.
     *
     * @param broadcaster The broadcaster you want to listen for messages sent by suspicious users.
     * @param transport The transport options.
     */ async subscribeToChannelSuspiciousUserMessageEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.suspicious_user.message', '1', (0, $6PgY9.createEventSubModeratorCondition)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId)), transport, broadcaster, [
            'moderator:read:suspicious_users'
        ], true);
    }
    /**
     * Subscribes to events indicating that a shared chat session has begun in a channel.
     *
     * @param broadcaster The broadcaster for whom shared chat session begin events should be listened to.
     * @param transport The transport options to use for the subscription.
     */ async subscribeToChannelSharedChatSessionBeginEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shared_chat.begin', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcasterId), transport, broadcasterId);
    }
    /**
     * Subscribes to events indicating that a shared chat session has been updated in a channel.
     *
     * @param broadcaster The broadcaster for whom shared chat session update events should be listened to.
     * @param transport The transport options to use for the subscription.
     */ async subscribeToChannelSharedChatSessionUpdateEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shared_chat.update', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcasterId), transport, broadcasterId);
    }
    /**
     * Subscribes to events indicating that a shared chat session has ended in a channel.
     *
     * @param broadcaster The broadcaster for whom shared chat session end events should be listened to.
     * @param transport The transport options to use for the subscription.
     */ async subscribeToChannelSharedChatSessionEndEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.shared_chat.end', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcasterId), transport, broadcasterId);
    }
    /**
     * Subscribes to events indicating that bits are used in a channel.
     *
     * @param broadcaster The broadcaster for whom you want to listen to bits usage events.
     * @param transport The transport options to use for the subscription.
     */ async subscribeToChannelBitsUseEvents(broadcaster, transport) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return await this.createSubscription('channel.bits.use', '1', (0, $6PgY9.createEventSubBroadcasterCondition)(broadcasterId), transport, broadcasterId, [
            'bits:read'
        ]);
    }
    /**
     * Gets the current EventSub conduits for the current client.
     *
     */ async getConduits() {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits'
        });
        return result.data.map((data)=>new $h4D57.HelixEventSubConduit(data, this._client));
    }
    /**
     * Creates a new EventSub conduit for the current client.
     *
     * @param shardCount The number of shards to create for this conduit.
     */ async createConduit(shardCount) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits',
            method: 'POST',
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('shard_count', shardCount.toString())
            }
        });
        return new $h4D57.HelixEventSubConduit(result.data[0], this._client);
    }
    /**
     * Updates an EventSub conduit for the current client.
     *
     * @param id The ID of the conduit to update.
     * @param shardCount The number of shards to update for this conduit.
     */ async updateConduit(id, shardCount) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits',
            method: 'PATCH',
            query: (0, $6PgY9.createEventSubConduitUpdateCondition)(id, shardCount)
        });
        return new $h4D57.HelixEventSubConduit(result.data[0], this._client);
    }
    /**
     * Deletes an EventSub conduit for the current client.
     *
     * @param id The ID of the conduit to delete.
     */ async deleteConduit(id) {
        await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits',
            method: 'DELETE',
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('id', id)
            }
        });
    }
    /**
     * Gets the shards of an EventSub conduit for the current client.
     *
     * @param conduitId The ID of the conduit to get shards for.
     * @param status The status of the shards to filter by.
     * @param pagination
     */ async getConduitShards(conduitId, status, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits/shards',
            query: {
                ...(0, $6PgY9.createEventSubConduitCondition)(conduitId, status),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return {
            ...(0, $7rg9J.createPaginatedResult)(result, $cPjDL.HelixEventSubConduitShard, this._client)
        };
    }
    /**
     * Creates a paginator for the shards of an EventSub conduit for the current client.
     *
     * @param conduitId The ID of the conduit to get shards for.
     * @param status The status of the shards to filter by.
     */ getConduitShardsPaginated(conduitId, status) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'eventsub/conduits/shards',
            query: (0, $6PgY9.createEventSubConduitCondition)(conduitId, status)
        }, this._client, (data)=>new $cPjDL.HelixEventSubConduitShard(data));
    }
    /**
     * Updates shards of an EventSub conduit for the current client.
     *
     * @param conduitId The ID of the conduit to update shards for.
     * @param shards List of shards to update
     */ async updateConduitShards(conduitId, shards) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'eventsub/conduits/shards',
            method: 'PATCH',
            jsonBody: (0, $6PgY9.createEventSubConduitShardsUpdateCondition)(conduitId, shards)
        });
        return result.data.map((data)=>new $cPjDL.HelixEventSubConduitShard(data));
    }
    async _deleteSubscriptionsWithCondition(cond) {
        const subsPaginator = this.getSubscriptionsPaginated();
        for await (const sub of subsPaginator)if (!cond || cond(sub)) await sub.unsubscribe();
    }
};
module.exports.HelixEventSubApi = $03913e9d34951e33$var$HelixEventSubApi;
module.exports.HelixEventSubApi = $03913e9d34951e33$var$HelixEventSubApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEventSubApi')
], $03913e9d34951e33$var$HelixEventSubApi);

});
parcelRegister("6PgY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createEventSubConduitShardsUpdateCondition = module.exports.createEventSubConduitUpdateCondition = module.exports.createEventSubConduitCondition = module.exports.createEventSubDropEntitlementGrantCondition = module.exports.createEventSubUserCondition = module.exports.createEventSubModeratorCondition = module.exports.createEventSubRewardCondition = module.exports.createEventSubBroadcasterCondition = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubBroadcasterCondition(broadcaster) {
    return {
        broadcaster_user_id: (0, $j0DIQ.extractUserId)(broadcaster)
    };
}
module.exports.createEventSubBroadcasterCondition = $4f84ab3b8e1a2e44$var$createEventSubBroadcasterCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubRewardCondition(broadcaster, rewardId) {
    return {
        broadcaster_user_id: (0, $j0DIQ.extractUserId)(broadcaster),
        reward_id: rewardId
    };
}
module.exports.createEventSubRewardCondition = $4f84ab3b8e1a2e44$var$createEventSubRewardCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubModeratorCondition(broadcasterId, moderatorId) {
    return {
        broadcaster_user_id: broadcasterId,
        moderator_user_id: moderatorId
    };
}
module.exports.createEventSubModeratorCondition = $4f84ab3b8e1a2e44$var$createEventSubModeratorCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubUserCondition(broadcasterId, userId) {
    return {
        broadcaster_user_id: broadcasterId,
        user_id: userId
    };
}
module.exports.createEventSubUserCondition = $4f84ab3b8e1a2e44$var$createEventSubUserCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubDropEntitlementGrantCondition(filter) {
    return {
        organization_id: filter.organizationId,
        category_id: filter.categoryId,
        campaign_id: filter.campaignId
    };
}
module.exports.createEventSubDropEntitlementGrantCondition = $4f84ab3b8e1a2e44$var$createEventSubDropEntitlementGrantCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubConduitCondition(conduitId, status) {
    return {
        conduit_id: conduitId,
        status: status
    };
}
module.exports.createEventSubConduitCondition = $4f84ab3b8e1a2e44$var$createEventSubConduitCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubConduitUpdateCondition(conduitId, shardCount) {
    return {
        id: conduitId,
        shard_count: shardCount.toString()
    };
}
module.exports.createEventSubConduitUpdateCondition = $4f84ab3b8e1a2e44$var$createEventSubConduitUpdateCondition;
/** @internal */ function $4f84ab3b8e1a2e44$var$createEventSubConduitShardsUpdateCondition(conduitId, shards) {
    return {
        conduit_id: conduitId,
        shards: shards
    };
}
module.exports.createEventSubConduitShardsUpdateCondition = $4f84ab3b8e1a2e44$var$createEventSubConduitShardsUpdateCondition;

});

parcelRegister("lgnUZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEventSubSubscription = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An EventSub subscription.
 */ let $f7ada54504d1f16b$var$HelixEventSubSubscription = class HelixEventSubSubscription extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the subscription.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The status of the subscription.
     */ get status() {
        return this[$j0DIQ.rawDataSymbol].status;
    }
    /**
     * The event type that the subscription is listening to.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The cost of the subscription.
     */ get cost() {
        return this[$j0DIQ.rawDataSymbol].cost;
    }
    /**
     * The condition of the subscription.
     */ get condition() {
        return this[$j0DIQ.rawDataSymbol].condition;
    }
    /**
     * The date and time of creation of the subscription.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The transport method of the subscription.
     */ get transportMethod() {
        return this[$j0DIQ.rawDataSymbol].transport.method;
    }
    /**
     * End the EventSub subscription.
     */ async unsubscribe() {
        await this._client.eventSub.deleteSubscription(this[$j0DIQ.rawDataSymbol].id);
    }
    /** @private */ get _transport() {
        return this[$j0DIQ.rawDataSymbol].transport;
    }
    /** @private */ set _status(status) {
        this[$j0DIQ.rawDataSymbol].status = status;
    }
};
module.exports.HelixEventSubSubscription = $f7ada54504d1f16b$var$HelixEventSubSubscription;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $f7ada54504d1f16b$var$HelixEventSubSubscription.prototype, "_client", void 0);
module.exports.HelixEventSubSubscription = $f7ada54504d1f16b$var$HelixEventSubSubscription = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEventSubSubscription', 'id')
], $f7ada54504d1f16b$var$HelixEventSubSubscription);

});

parcelRegister("90YWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPaginatedEventSubSubscriptionsRequest = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $4W0OK = parcelRequire("4W0OK");

var $lgnUZ = parcelRequire("lgnUZ");
/**
 * A special case of {@link HelixPaginatedRequestWithTotal} with support for fetching the total cost and cost limit
 * of EventSub subscriptions.
 *
 * @inheritDoc
 */ let $69036446a68a4f31$var$HelixPaginatedEventSubSubscriptionsRequest = class HelixPaginatedEventSubSubscriptionsRequest extends $4W0OK.HelixPaginatedRequestWithTotal {
    /** @internal */ constructor(query, userId, client){
        super({
            url: 'eventsub/subscriptions',
            userId: userId,
            query: query
        }, client, (data)=>new $lgnUZ.HelixEventSubSubscription(data, client));
    }
    /**
     * Gets the total cost of EventSub subscriptions.
     */ async getTotalCost() {
        var _a;
        const data = (_a = this._currentData) !== null && _a !== void 0 ? _a : await this._fetchData({
            query: {
                after: undefined
            }
        });
        return data.total_cost;
    }
    /**
     * Gets the cost limit of EventSub subscriptions.
     */ async getMaxTotalCost() {
        var _a;
        const data = (_a = this._currentData) !== null && _a !== void 0 ? _a : await this._fetchData({
            query: {
                after: undefined
            }
        });
        return data.max_total_cost;
    }
};
module.exports.HelixPaginatedEventSubSubscriptionsRequest = $69036446a68a4f31$var$HelixPaginatedEventSubSubscriptionsRequest;
module.exports.HelixPaginatedEventSubSubscriptionsRequest = $69036446a68a4f31$var$HelixPaginatedEventSubSubscriptionsRequest = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPaginatedEventSubSubscriptionsRequest')
], $69036446a68a4f31$var$HelixPaginatedEventSubSubscriptionsRequest);

});

parcelRegister("h4D57", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEventSubConduit = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents an EventSub conduit.
 */ let $c6e1202c381d91b5$var$HelixEventSubConduit = class HelixEventSubConduit extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the conduit.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The shard count of the conduit.
     */ get shardCount() {
        return this[$j0DIQ.rawDataSymbol].shard_count;
    }
    /**
     * Update the conduit.
     *
     * @param shardCount The new shard count.
     */ async update(shardCount) {
        return await this._client.eventSub.updateConduit(this[$j0DIQ.rawDataSymbol].id, shardCount);
    }
    /**
     * Delete the conduit.
     */ async delete() {
        await this._client.eventSub.deleteConduit(this[$j0DIQ.rawDataSymbol].id);
    }
    /**
     * Get the conduit shards.
     */ async getShards() {
        return await this._client.eventSub.getConduitShards(this[$j0DIQ.rawDataSymbol].id);
    }
};
module.exports.HelixEventSubConduit = $c6e1202c381d91b5$var$HelixEventSubConduit;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c6e1202c381d91b5$var$HelixEventSubConduit.prototype, "_client", void 0);
module.exports.HelixEventSubConduit = $c6e1202c381d91b5$var$HelixEventSubConduit = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEventSubConduit')
], $c6e1202c381d91b5$var$HelixEventSubConduit);

});

parcelRegister("cPjDL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixEventSubConduitShard = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Represents an EventSub conduit shard.
 */ let $95697ba477138d5c$var$HelixEventSubConduitShard = class HelixEventSubConduitShard extends $j0DIQ.DataObject {
    /**
     * The ID of the shard.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The status of the shard.
     */ get status() {
        return this[$j0DIQ.rawDataSymbol].status;
    }
    /**
     * The transport method of the shard.
     */ get transportMethod() {
        return this[$j0DIQ.rawDataSymbol].transport.method;
    }
};
module.exports.HelixEventSubConduitShard = $95697ba477138d5c$var$HelixEventSubConduitShard;
module.exports.HelixEventSubConduitShard = $95697ba477138d5c$var$HelixEventSubConduitShard = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixEventSubConduitShard')
], $95697ba477138d5c$var$HelixEventSubConduitShard);

});


parcelRegister("jJLZi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixExtensionsApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $bUH1q = parcelRequire("bUH1q");

var $78zDw = parcelRequire("78zDw");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $l6zr1 = parcelRequire("l6zr1");

var $2rp28 = parcelRequire("2rp28");

var $kxhgp = parcelRequire("kxhgp");
/**
 * The Helix API methods that deal with extensions.
 *
 * Can be accessed using `client.extensions` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const transactions = await api.extionsions.getExtensionTransactions('abcd');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Extensions
 */ let $e5e771a5a929b432$var$HelixExtensionsApi = class HelixExtensionsApi extends $lq7i7.BaseApi {
    /**
     * Gets a released extension by ID.
     *
     * @param extensionId The ID of the extension.
     * @param version The version of the extension. If not given, gets the latest version.
     */ async getReleasedExtension(extensionId, version) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'extensions/released',
            query: (0, $bUH1q.createReleasedExtensionFilter)(extensionId, version)
        });
        return new $j0DIQ.HelixExtension(result.data[0]);
    }
    /**
     * Gets a list of channels that are currently live and have the given extension installed.
     *
     * @param extensionId The ID of the extension.
     * @param pagination
     *
     * @expandParams
     */ async getLiveChannelsWithExtension(extensionId, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'extensions/live',
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('extension_id', extensionId),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $l6zr1.HelixChannelReference, this._client);
    }
    /**
     * Creates a paginator for channels that are currently live and have the given extension installed.
     *
     * @param extensionId The ID of the extension.
     */ getLiveChannelsWithExtensionPaginated(extensionId) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'extensions/live',
            query: (0, $78zDw.createSingleKeyQuery)('extension_id', extensionId)
        }, this._client, (data)=>new $l6zr1.HelixChannelReference(data, this._client));
    }
    /**
     * Gets an extension's Bits products.
     *
     * This only works if the provided token belongs to an extension's client ID,
     * and will return the products for that extension.
     *
     * @param includeDisabled Whether to include disabled/expired products.
     */ async getExtensionBitsProducts(includeDisabled) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'bits/extensions',
            forceType: 'app',
            query: (0, $78zDw.createSingleKeyQuery)('should_include_all', includeDisabled === null || includeDisabled === void 0 ? void 0 : includeDisabled.toString())
        });
        return result.data.map((data)=>new $2rp28.HelixExtensionBitsProduct(data));
    }
    /**
     * Creates or updates a Bits product of an extension.
     *
     * This only works if the provided token belongs to an extension's client ID,
     * and will create/update a product for that extension.
     *
     * @param data
     *
     * @expandParams
     */ async putExtensionBitsProduct(data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'bits/extensions',
            method: 'PUT',
            forceType: 'app',
            jsonBody: (0, $bUH1q.createExtensionProductBody)(data)
        });
        return new $2rp28.HelixExtensionBitsProduct(result.data[0]);
    }
    /**
     * Gets a list of transactions for the given extension.
     *
     * @param extensionId The ID of the extension to get transactions for.
     * @param filter Additional filters.
     */ async getExtensionTransactions(extensionId, filter = {}) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'extensions/transactions',
            forceType: 'app',
            query: {
                ...(0, $bUH1q.createExtensionTransactionQuery)(extensionId, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $kxhgp.HelixExtensionTransaction, this._client);
    }
    /**
     * Creates a paginator for transactions for the given extension.
     *
     * @param extensionId The ID of the extension to get transactions for.
     * @param filter Additional filters.
     */ getExtensionTransactionsPaginated(extensionId, filter = {}) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'extensions/transactions',
            forceType: 'app',
            query: (0, $bUH1q.createExtensionTransactionQuery)(extensionId, filter)
        }, this._client, (data)=>new $kxhgp.HelixExtensionTransaction(data, this._client));
    }
};
module.exports.HelixExtensionsApi = $e5e771a5a929b432$var$HelixExtensionsApi;
module.exports.HelixExtensionsApi = $e5e771a5a929b432$var$HelixExtensionsApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixExtensionsApi')
], $e5e771a5a929b432$var$HelixExtensionsApi);

});
parcelRegister("bUH1q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createExtensionTransactionQuery = module.exports.createExtensionProductBody = module.exports.createReleasedExtensionFilter = void 0;
/** @internal */ function $8ac64bf29a4e4a20$var$createReleasedExtensionFilter(extensionId, version) {
    return {
        extension_id: extensionId,
        extension_version: version
    };
}
module.exports.createReleasedExtensionFilter = $8ac64bf29a4e4a20$var$createReleasedExtensionFilter;
/** @internal */ function $8ac64bf29a4e4a20$var$createExtensionProductBody(data) {
    return {
        sku: data.sku,
        cost: {
            amount: data.cost,
            type: 'bits'
        },
        display_name: data.displayName,
        in_development: data.inDevelopment,
        expiration: data.expirationDate,
        is_broadcast: data.broadcast
    };
}
module.exports.createExtensionProductBody = $8ac64bf29a4e4a20$var$createExtensionProductBody;
/** @internal */ function $8ac64bf29a4e4a20$var$createExtensionTransactionQuery(extensionId, filter) {
    return {
        extension_id: extensionId,
        id: filter.transactionIds
    };
}
module.exports.createExtensionTransactionQuery = $8ac64bf29a4e4a20$var$createExtensionTransactionQuery;

});

parcelRegister("l6zr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelReference = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A reference to a Twitch channel.
 */ let $f5d5a526301cbf34$var$HelixChannelReference = class HelixChannelReference extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the channel.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The display name of the channel.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the channel.
     */ async getChannel() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.channels.getChannelInfoById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * Gets more information about the broadcaster of the channel.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The ID of the game currently played on the channel.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * The name of the game currently played on the channel.
     */ get gameName() {
        return this[$j0DIQ.rawDataSymbol].game_name;
    }
    /**
     * Gets information about the game that is being played on the stream.
     */ async getGame() {
        return this[$j0DIQ.rawDataSymbol].game_id ? (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id)) : null;
    }
    /**
     * The title of the channel.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
};
module.exports.HelixChannelReference = $f5d5a526301cbf34$var$HelixChannelReference;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $f5d5a526301cbf34$var$HelixChannelReference.prototype, "_client", void 0);
module.exports.HelixChannelReference = $f5d5a526301cbf34$var$HelixChannelReference = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelReference', 'id')
], $f5d5a526301cbf34$var$HelixChannelReference);

});

parcelRegister("2rp28", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixExtensionBitsProduct = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An extension's product to purchase with Bits.
 */ let $1c71857d041613ac$var$HelixExtensionBitsProduct = class HelixExtensionBitsProduct extends $j0DIQ.DataObject {
    /**
     * The product's unique identifier.
     */ get sku() {
        return this[$j0DIQ.rawDataSymbol].sku;
    }
    /**
     * The product's cost, in bits.
     */ get cost() {
        return this[$j0DIQ.rawDataSymbol].cost.amount;
    }
    /**
     * The product's display name.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].display_name;
    }
    /**
     * Whether the product is in development.
     */ get inDevelopment() {
        return this[$j0DIQ.rawDataSymbol].in_development;
    }
    /**
     * Whether the product's purchases is broadcast to all users.
     */ get isBroadcast() {
        return this[$j0DIQ.rawDataSymbol].is_broadcast;
    }
    /**
     * The product's expiration date. If the product never expires, this is null.
     */ get expirationDate() {
        return (0, $bRvJY.mapNullable)(this[$j0DIQ.rawDataSymbol].expiration, (exp)=>new Date(exp));
    }
};
module.exports.HelixExtensionBitsProduct = $1c71857d041613ac$var$HelixExtensionBitsProduct;
module.exports.HelixExtensionBitsProduct = $1c71857d041613ac$var$HelixExtensionBitsProduct = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixExtensionBitsProduct', 'sku')
], $1c71857d041613ac$var$HelixExtensionBitsProduct);

});

parcelRegister("kxhgp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixExtensionTransaction = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A bits transaction made inside an extension.
 */ let $ef3447e4a50c786f$var$HelixExtensionTransaction = class HelixExtensionTransaction extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the transaction.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The time when the transaction was made.
     */ get transactionDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].timestamp);
    }
    /**
     * The ID of the broadcaster that runs the extension on their channel.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster that runs the extension on their channel.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * The display name of the broadcaster that runs the extension on their channel.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets information about the broadcaster that runs the extension on their channel.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The ID of the user that made the transaction.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user that made the transaction.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user that made the transaction.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets information about the user that made the transaction.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The product type. Currently always BITS_IN_EXTENSION.
     */ get productType() {
        return this[$j0DIQ.rawDataSymbol].product_type;
    }
    /**
     * The product SKU.
     */ get productSku() {
        return this[$j0DIQ.rawDataSymbol].product_data.sku;
    }
    /**
     * The cost of the product, in bits.
     */ get productCost() {
        return this[$j0DIQ.rawDataSymbol].product_data.cost.amount;
    }
    /**
     * The display name of the product.
     */ get productDisplayName() {
        return this[$j0DIQ.rawDataSymbol].product_data.displayName;
    }
    /**
     * Whether the product is in development.
     */ get productInDevelopment() {
        return this[$j0DIQ.rawDataSymbol].product_data.inDevelopment;
    }
};
module.exports.HelixExtensionTransaction = $ef3447e4a50c786f$var$HelixExtensionTransaction;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $ef3447e4a50c786f$var$HelixExtensionTransaction.prototype, "_client", void 0);
module.exports.HelixExtensionTransaction = $ef3447e4a50c786f$var$HelixExtensionTransaction = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixExtensionTransaction', 'id')
], $ef3447e4a50c786f$var$HelixExtensionTransaction);

});


parcelRegister("bLRG1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixGameApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $3Udy1 = parcelRequire("3Udy1");
/**
 * The Helix API methods that deal with games.
 *
 * Can be accessed using `client.games` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const game = await api.games.getGameByName('Hearthstone');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Games
 */ let $891db89376187c75$var$HelixGameApi = class HelixGameApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getGameByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'games'
        }, 'id', 'id', this._client, (data)=>new $3Udy1.HelixGame(data, this._client));
        /** @internal */ this._getGameByNameBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'games'
        }, 'name', 'name', this._client, (data)=>new $3Udy1.HelixGame(data, this._client));
        /** @internal */ this._getGameByIgdbIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'games'
        }, 'igdb_id', 'igdb_id', this._client, (data)=>new $3Udy1.HelixGame(data, this._client));
    }
    /**
     * Gets the game data for the given list of game IDs.
     *
     * @param ids The game IDs you want to look up.
     */ async getGamesByIds(ids) {
        return await this._getGames('id', ids);
    }
    /**
     * Gets the game data for the given list of game names.
     *
     * @param names The game names you want to look up.
     */ async getGamesByNames(names) {
        return await this._getGames('name', names);
    }
    /**
     * Gets the game data for the given list of IGDB IDs.
     *
     * @param igdbIds The IGDB IDs you want to look up.
     */ async getGamesByIgdbIds(igdbIds) {
        return await this._getGames('igdb_id', igdbIds);
    }
    /**
     * Gets the game data for the given game ID.
     *
     * @param id The game ID you want to look up.
     */ async getGameById(id) {
        var _a;
        const games = await this._getGames('id', [
            id
        ]);
        return (_a = games[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Gets the game data for the given game name.
     *
     * @param name The game name you want to look up.
     */ async getGameByName(name) {
        var _a;
        const games = await this._getGames('name', [
            name
        ]);
        return (_a = games[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Gets the game data for the given IGDB ID.
     *
     * @param igdbId The IGDB ID you want to look up.
     */ async getGameByIgdbId(igdbId) {
        var _a;
        const games = await this._getGames('igdb_id', [
            igdbId
        ]);
        return (_a = games[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Gets the game data for the given game ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param id The game ID you want to look up.
     */ async getGameByIdBatched(id) {
        return await this._getGameByIdBatcher.request(id);
    }
    /**
     * Gets the game data for the given game name, batching multiple calls into fewer requests as the API allows.
     *
     * @param name The game name you want to look up.
     */ async getGameByNameBatched(name) {
        return await this._getGameByNameBatcher.request(name);
    }
    /**
     * Gets the game data for the given IGDB ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param igdbId The IGDB ID you want to look up.
     */ async getGameByIgdbIdBatched(igdbId) {
        return await this._getGameByIgdbIdBatcher.request(igdbId);
    }
    /**
     * Gets a list of the most viewed games at the moment.
     *
     * @param pagination
     *
     * @expandParams
     */ async getTopGames(pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'games/top',
            query: (0, $4AsKM.createPaginationQuery)(pagination)
        });
        return (0, $7rg9J.createPaginatedResult)(result, $3Udy1.HelixGame, this._client);
    }
    /**
     * Creates a paginator for the most viewed games at the moment.
     */ getTopGamesPaginated() {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'games/top'
        }, this._client, (data)=>new $3Udy1.HelixGame(data, this._client));
    }
    /** @internal */ async _getGames(filterType, filterValues) {
        if (!filterValues.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'games',
            query: {
                [filterType]: filterValues
            }
        });
        return result.data.map((entry)=>new $3Udy1.HelixGame(entry, this._client));
    }
};
module.exports.HelixGameApi = $891db89376187c75$var$HelixGameApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $891db89376187c75$var$HelixGameApi.prototype, "_getGameByIdBatcher", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $891db89376187c75$var$HelixGameApi.prototype, "_getGameByNameBatcher", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $891db89376187c75$var$HelixGameApi.prototype, "_getGameByIgdbIdBatcher", void 0);
module.exports.HelixGameApi = $891db89376187c75$var$HelixGameApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixGameApi')
], $891db89376187c75$var$HelixGameApi);

});
parcelRegister("3Udy1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixGame = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A game as displayed on Twitch.
 */ let $2d811c5f66514789$var$HelixGame = class HelixGame extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the game.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the game.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].name;
    }
    /**
     * The URL of the box art of the game.
     */ get boxArtUrl() {
        return this[$j0DIQ.rawDataSymbol].box_art_url;
    }
    /**
     * The IGDB ID of the game, or null if the game doesn't have an IGDB ID assigned at Twitch.
     */ get igdbId() {
        return this[$j0DIQ.rawDataSymbol].igdb_id || null;
    }
    /**
     * Builds the URL of the box art of the game using the given dimensions.
     *
     * @param width The width of the box art.
     * @param height The height of the box art.
     */ getBoxArtUrl(width, height) {
        return this[$j0DIQ.rawDataSymbol].box_art_url.replace('{width}', width.toString()).replace('{height}', height.toString());
    }
    /**
     * Gets streams that are currently playing the game.
     *
     * @param pagination
     * @expandParams
     */ async getStreams(pagination) {
        return await this._client.streams.getStreams({
            ...pagination,
            game: this[$j0DIQ.rawDataSymbol].id
        });
    }
    /**
     * Creates a paginator for streams that are currently playing the game.
     */ getStreamsPaginated() {
        return this._client.streams.getStreamsPaginated({
            game: this[$j0DIQ.rawDataSymbol].id
        });
    }
};
module.exports.HelixGame = $2d811c5f66514789$var$HelixGame;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $2d811c5f66514789$var$HelixGame.prototype, "_client", void 0);
module.exports.HelixGame = $2d811c5f66514789$var$HelixGame = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixGame', 'id')
], $2d811c5f66514789$var$HelixGame);

});


parcelRegister("5g9IT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixGoalApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $lq7i7 = parcelRequire("lq7i7");

var $1ULk1 = parcelRequire("1ULk1");
/**
 * The Helix API methods that deal with creator goals.
 *
 * Can be accessed using `client.goals` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: goals } = await api.helix.goals.getGoals('61369223');
 *
 * @meta category helix
 * @meta categorizedTitle Goals
 */ let $3d45fd2c9289e75c$var$HelixGoalApi = class HelixGoalApi extends $lq7i7.BaseApi {
    async getGoals(broadcaster) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'goals',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:goals'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return result.data.map((data)=>new $1ULk1.HelixGoal(data, this._client));
    }
};
module.exports.HelixGoalApi = $3d45fd2c9289e75c$var$HelixGoalApi;
module.exports.HelixGoalApi = $3d45fd2c9289e75c$var$HelixGoalApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixGoalApi')
], $3d45fd2c9289e75c$var$HelixGoalApi);

});
parcelRegister("1ULk1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixGoal = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A creator goal.
 */ let $164fba8d011f7e1e$var$HelixGoal = class HelixGoal extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the goal.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster the goal belongs to.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The display name of the broadcaster the goal belongs to.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * The name of the broadcaster the goal belongs to.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The type of the goal.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The description of the goal.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
    /**
     * The current value of the goal.
     */ get currentAmount() {
        return this[$j0DIQ.rawDataSymbol].current_amount;
    }
    /**
     * The target value of the goal.
     */ get targetAmount() {
        return this[$j0DIQ.rawDataSymbol].target_amount;
    }
    /**
     * The date and time when the goal was created.
     */ get creationDate() {
        return this[$j0DIQ.rawDataSymbol].created_at;
    }
};
module.exports.HelixGoal = $164fba8d011f7e1e$var$HelixGoal;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $164fba8d011f7e1e$var$HelixGoal.prototype, "_client", void 0);
module.exports.HelixGoal = $164fba8d011f7e1e$var$HelixGoal = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixGoal', 'id')
], $164fba8d011f7e1e$var$HelixGoal);

});


parcelRegister("geW2U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixHypeTrainApi = void 0;

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $eISnG = parcelRequire("eISnG");
/**
 * The Helix API methods that deal with Hype Trains.
 *
 * Can be accessed using `client.hypeTrain` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: events } = await api.hypeTrain.getHypeTrainEventsForBroadcaster('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Hype Trains
 */ class $bd2afadcc2ae9d9d$var$HelixHypeTrainApi extends $lq7i7.BaseApi {
    /**
     * Gets the events of the current or latest Hype Train for the specified broadcaster.
     *
     * @param broadcaster The broadcaster to fetch Hype Train events for.
     * @param pagination
     *
     * @expandParams
     */ async getHypeTrainEventsForBroadcaster(broadcaster, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'hypetrain/events',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:hype_train'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $eISnG.HelixHypeTrainEvent, this._client);
    }
    /**
     * Creates a paginator for the events of the current or latest Hype Train for the specified broadcaster.
     *
     * @param broadcaster The broadcaster to fetch Hype Train events for.
     */ getHypeTrainEventsForBroadcasterPaginated(broadcaster) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'hypetrain/events',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:hype_train'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        }, this._client, (data)=>new $eISnG.HelixHypeTrainEvent(data, this._client));
    }
}
module.exports.HelixHypeTrainApi = $bd2afadcc2ae9d9d$var$HelixHypeTrainApi;

});
parcelRegister("eISnG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixHypeTrainEvent = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $kUJaa = parcelRequire("kUJaa");
/**
 * A Hype Train event.
 */ let $ab7f5bb1193a1674$var$HelixHypeTrainEvent = class HelixHypeTrainEvent extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The unique ID of the Hype Train event.
     */ get eventId() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The type of the Hype Train event.
     */ get eventType() {
        return this[$j0DIQ.rawDataSymbol].event_type;
    }
    /**
     * The date of the Hype Train event.
     */ get eventDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].event_timestamp);
    }
    /**
     * The version of the Hype Train event.
     */ get eventVersion() {
        return this[$j0DIQ.rawDataSymbol].version;
    }
    /**
     * The unique ID of the Hype Train.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].event_data.id;
    }
    /**
     * The user ID of the broadcaster where the Hype Train event was triggered.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].event_data.broadcaster_id;
    }
    /**
     * Gets more information about the broadcaster where the Hype Train event was triggered.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].event_data.broadcaster_id));
    }
    /**
     * The level of the Hype Train event.
     */ get level() {
        return this[$j0DIQ.rawDataSymbol].event_data.level;
    }
    /**
     * The time when the Hype Train started.
     */ get startDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].event_data.started_at);
    }
    /**
     * The time when the Hype Train is set to expire.
     */ get expiryDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].event_data.expires_at);
    }
    /**
     * The time when the Hype Train cooldown will end.
     */ get cooldownDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].event_data.cooldown_end_time);
    }
    /**
     * The total amount of progress points of the Hype Train event.
     */ get total() {
        return this[$j0DIQ.rawDataSymbol].event_data.total;
    }
    /**
     * The progress points goal to reach the next Hype Train level.
     */ get goal() {
        return this[$j0DIQ.rawDataSymbol].event_data.goal;
    }
    /**
     * The last contribution to the Hype Train event.
     */ get lastContribution() {
        return new $kUJaa.HelixHypeTrainContribution(this[$j0DIQ.rawDataSymbol].event_data.last_contribution, this._client);
    }
    /**
     * Array list of the top contributions to the Hype Train event for bits and subs.
     */ get topContributions() {
        return this[$j0DIQ.rawDataSymbol].event_data.top_contributions.map((cont)=>new $kUJaa.HelixHypeTrainContribution(cont, this._client));
    }
};
module.exports.HelixHypeTrainEvent = $ab7f5bb1193a1674$var$HelixHypeTrainEvent;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $ab7f5bb1193a1674$var$HelixHypeTrainEvent.prototype, "_client", void 0);
module.exports.HelixHypeTrainEvent = $ab7f5bb1193a1674$var$HelixHypeTrainEvent = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixHypeTrainEvent', 'id')
], $ab7f5bb1193a1674$var$HelixHypeTrainEvent);

});
parcelRegister("kUJaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixHypeTrainContribution = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Hype Train contributor.
 */ let $f39c1208784e4f6d$var$HelixHypeTrainContribution = class HelixHypeTrainContribution extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user contributing to the Hype Train.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user;
    }
    /**
     * Gets additional information about the user contributing to the Hype Train.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user));
    }
    /**
     * The Hype Train event type.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The total contribution amount in subs or bits.
     */ get total() {
        return this[$j0DIQ.rawDataSymbol].total;
    }
};
module.exports.HelixHypeTrainContribution = $f39c1208784e4f6d$var$HelixHypeTrainContribution;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $f39c1208784e4f6d$var$HelixHypeTrainContribution.prototype, "_client", void 0);
module.exports.HelixHypeTrainContribution = $f39c1208784e4f6d$var$HelixHypeTrainContribution = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixHypeTrainContribution', 'userId')
], $f39c1208784e4f6d$var$HelixHypeTrainContribution);

});



parcelRegister("l2bqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixModerationApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $hlADN = parcelRequire("hlADN");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $h1fOH = parcelRequire("h1fOH");

var $af5sI = parcelRequire("af5sI");

var $axg0W = parcelRequire("axg0W");

var $f4oqh = parcelRequire("f4oqh");

var $d90cS = parcelRequire("d90cS");

var $b7oXt = parcelRequire("b7oXt");

var $7AuQT = parcelRequire("7AuQT");

var $2BoCE = parcelRequire("2BoCE");

var $elAZM = parcelRequire("elAZM");

var $9OKn1 = parcelRequire("9OKn1");
/**
 * The Helix API methods that deal with moderation.
 *
 * Can be accessed using `client.moderation` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: users } = await api.moderation.getBannedUsers('61369223');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Moderation
 */ let $f502a5a15e2efe5d$var$HelixModerationApi = class HelixModerationApi extends $lq7i7.BaseApi {
    /**
     * Gets a list of banned users in a given channel.
     *
     * @param channel The channel to get the banned users from.
     * @param filter Additional filters for the result set.
     *
     * @expandParams
     */ async getBannedUsers(channel, filter) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/banned',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'moderation:read'
            ],
            query: {
                ...(0, $hlADN.createModerationUserListQuery)(channel, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $axg0W.HelixBan, this._client);
    }
    /**
     * Creates a paginator for banned users in a given channel.
     *
     * @param channel The channel to get the banned users from.
     */ getBannedUsersPaginated(channel) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'moderation/banned',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'moderation:read'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(channel)
        }, this._client, (data)=>new $axg0W.HelixBan(data, this._client), 50);
    }
    /**
     * Checks whether a given user is banned in a given channel.
     *
     * @param channel The channel to check for a ban of the given user.
     * @param user The user to check for a ban in the given channel.
     */ async checkUserBan(channel, user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this.getBannedUsers(channel, {
            userId: userId
        });
        return result.data.some((ban)=>ban.userId === userId);
    }
    /**
     * Gets a list of moderators in a given channel.
     *
     * @param channel The channel to get moderators from.
     * @param filter Additional filters for the result set.
     *
     * @expandParams
     */ async getModerators(channel, filter) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/moderators',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'moderation:read',
                'channel:manage:moderators'
            ],
            query: {
                ...(0, $hlADN.createModerationUserListQuery)(channel, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $7AuQT.HelixModerator, this._client);
    }
    /**
     * Creates a paginator for moderators in a given channel.
     *
     * @param channel The channel to get moderators from.
     */ getModeratorsPaginated(channel) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'moderation/moderators',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'moderation:read',
                'channel:manage:moderators'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(channel)
        }, this._client, (data)=>new $7AuQT.HelixModerator(data, this._client));
    }
    /**
     * Gets a list of channels where the specified user has moderator privileges.
     *
     * @param user The user for whom to return a list of channels where they have moderator privileges.
     * This ID must match the user ID in the access token.
     * @param filter
     *
     * @expandParams
     *
     * @returns A paginated list of channels where the user has moderator privileges.
     */ async getModeratedChannels(user, filter) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/channels',
            userId: userId,
            scopes: [
                'user:read:moderated_channels'
            ],
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('user_id', userId),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $b7oXt.HelixModeratedChannel, this._client);
    }
    /**
     * Creates a paginator for channels where the specified user has moderator privileges.
     *
     * @param user The user for whom to return the list of channels where they have moderator privileges.
     * This ID must match the user ID in the access token.
     */ getModeratedChannelsPaginated(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return new $6tEA1.HelixPaginatedRequest({
            url: 'moderation/channels',
            userId: userId,
            scopes: [
                'user:read:moderated_channels'
            ],
            query: (0, $78zDw.createSingleKeyQuery)('user_id', userId)
        }, this._client, (data)=>new $b7oXt.HelixModeratedChannel(data, this._client));
    }
    /**
     * Checks whether a given user is a moderator of a given channel.
     *
     * @param channel The channel to check.
     * @param user The user to check.
     */ async checkUserMod(channel, user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this.getModerators(channel, {
            userId: userId
        });
        return result.data.some((mod)=>mod.userId === userId);
    }
    /**
     * Adds a moderator to the broadcaster’s chat room.
     *
     * @param broadcaster The broadcaster that owns the chat room. This ID must match the user ID in the access token.
     * @param user The user to add as a moderator in the broadcaster’s chat room.
     */ async addModerator(broadcaster, user) {
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/moderators',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:moderators'
            ],
            query: (0, $hlADN.createModeratorModifyQuery)(broadcaster, user)
        });
    }
    /**
     * Removes a moderator from the broadcaster’s chat room.
     *
     * @param broadcaster The broadcaster that owns the chat room. This ID must match the user ID in the access token.
     * @param user The user to remove as a moderator from the broadcaster’s chat room.
     */ async removeModerator(broadcaster, user) {
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/moderators',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:moderators'
            ],
            query: (0, $hlADN.createModeratorModifyQuery)(broadcaster, user)
        });
    }
    /**
     * Determines whether a string message meets the channel's AutoMod requirements.
     *
     * @param channel The channel in which the messages to check are posted.
     * @param data An array of message data objects.
     */ async checkAutoModStatus(channel, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/enforcements/status',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(channel),
            scopes: [
                'moderation:read'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(channel),
            jsonBody: (0, $hlADN.createCheckAutoModStatusBody)(data)
        });
        return result.data.map((statusData)=>new $af5sI.HelixAutoModStatus(statusData));
    }
    /**
     * Processes a message held by AutoMod.
     *
     * @param user The user who is processing the message.
     * @param msgId The ID of the message.
     * @param allow Whether to allow the message - `true` allows, and `false` denies.
     */ async processHeldAutoModMessage(user, msgId, allow) {
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/automod/message',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'moderator:manage:automod'
            ],
            jsonBody: (0, $hlADN.createAutoModProcessBody)(user, msgId, allow)
        });
    }
    /**
     * Gets the AutoMod settings for a broadcaster.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster to get the AutoMod settings for.
     */ async getAutoModSettings(broadcaster) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/automod/settings',
            userId: broadcasterId,
            scopes: [
                'moderator:read:automod_settings'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId)
        });
        return result.data.map((data)=>new $h1fOH.HelixAutoModSettings(data));
    }
    /**
     * Updates the AutoMod settings for a broadcaster.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster for which the AutoMod settings are updated.
     * @param data The updated AutoMod settings that replace the current AutoMod settings.
     */ async updateAutoModSettings(broadcaster, data) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/automod/settings',
            method: 'PUT',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:automod_settings'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: (0, $hlADN.createAutoModSettingsBody)(data)
        });
        return result.data.map((settingsData)=>new $h1fOH.HelixAutoModSettings(settingsData));
    }
    /**
     * Bans or times out a user in a channel.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster in whose channel the user will be banned/timed out.
     * @param data
     *
     * @expandParams
     *
     * @returns The result data from the ban/timeout request.
     */ async banUser(broadcaster, data) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/bans',
            method: 'POST',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:banned_users'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: (0, $hlADN.createBanUserBody)(data)
        });
        return result.data.map((banData)=>new $f4oqh.HelixBanUser(banData, banData.end_time, this._client));
    }
    /**
     * Unbans/removes the timeout for a user in a channel.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster in whose channel the user will be unbanned/removed from timeout.
     * @param user The user who will be unbanned/removed from timeout.
     */ async unbanUser(broadcaster, user) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/bans',
            method: 'DELETE',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:banned_users'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $78zDw.createSingleKeyQuery)('user_id', (0, $j0DIQ.extractUserId)(user))
            }
        });
    }
    /**
     * Gets the broadcaster’s list of non-private, blocked words or phrases.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster to get their channel's blocked terms for.
     * @param pagination
     *
     * @expandParams
     *
     * @returns A paginated list of blocked term data in the broadcaster's channel.
     */ async getBlockedTerms(broadcaster, pagination) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/blocked_terms',
            userId: broadcasterId,
            scopes: [
                'moderator:read:blocked_terms'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $d90cS.HelixBlockedTerm, this._client);
    }
    /**
     * Adds a blocked term to the broadcaster's channel.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster in whose channel the term will be blocked.
     * @param text The word or phrase to block from being used in the broadcaster's channel.
     *
     * @returns Information about the term that has been blocked.
     */ async addBlockedTerm(broadcaster, text) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/blocked_terms',
            method: 'POST',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:blocked_terms'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: {
                text: text
            }
        });
        return result.data.map((blockedTermData)=>new $d90cS.HelixBlockedTerm(blockedTermData));
    }
    /**
     * Removes a blocked term from the broadcaster's channel.
     *
     * @param broadcaster The broadcaster in whose channel the term will be unblocked.
     * @param moderator A user that has permission to unblock terms in the broadcaster's channel.
     * The token of this user will be used to remove the blocked term.
     * @param id The ID of the term that should be unblocked.
     */ async removeBlockedTerm(broadcaster, moderator, id) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/blocked_terms',
            method: 'DELETE',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:blocked_terms'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                id: id
            }
        });
    }
    /**
     * Removes a single chat message or all chat messages from the broadcaster’s chat room.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster the chat belongs to.
     * @param messageId The ID of the message to remove. If not specified, the request removes all messages in the broadcaster’s chat room.
     */ async deleteChatMessages(broadcaster, messageId) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        await this._client.callApi({
            type: 'helix',
            url: 'moderation/chat',
            method: 'DELETE',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:chat_messages'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $78zDw.createSingleKeyQuery)('message_id', messageId)
            }
        });
    }
    /**
     * Gets the broadcaster's Shield Mode activation status.
     *
     * @param broadcaster The broadcaster whose Shield Mode activation status you want to get.
     */ async getShieldModeStatus(broadcaster) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/shield_mode',
            method: 'GET',
            userId: broadcasterId,
            scopes: [
                'moderator:read:shield_mode',
                'moderator:manage:shield_mode'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId)
        });
        return new $2BoCE.HelixShieldModeStatus(result.data[0], this._client);
    }
    /**
     * Activates or deactivates the broadcaster's Shield Mode.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The broadcaster whose Shield Mode you want to activate or deactivate.
     * @param activate The desired Shield Mode status on the broadcaster's channel.
     */ async updateShieldModeStatus(broadcaster, activate) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/shield_mode',
            method: 'PUT',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:shield_mode'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: (0, $hlADN.createUpdateShieldModeStatusBody)(activate)
        });
        return new $2BoCE.HelixShieldModeStatus(result.data[0], this._client);
    }
    /**
     * Gets a list of unban requests.
     *
     * @param broadcaster The broadcaster to get unban requests of.
     * @param status The status of unban requests to retrieve.
     * @param filter Additional filters for the result set.
     */ async getUnbanRequests(broadcaster, status, filter) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/unban_requests',
            method: 'GET',
            userId: broadcasterId,
            scopes: [
                'moderator:read:unban_requests',
                'moderator:manage:unban_requests'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $78zDw.createSingleKeyQuery)('status', status),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $elAZM.HelixUnbanRequest, this._client);
    }
    /**
     * Creates a paginator for unban requests.
     *
     * @param broadcaster The broadcaster to get unban requests of.
     * @param status The status of unban requests to retrieve.
     */ getUnbanRequestsPaginated(broadcaster, status) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        return new $6tEA1.HelixPaginatedRequest({
            url: 'moderation/unban_requests',
            method: 'GET',
            userId: broadcasterId,
            scopes: [
                'moderator:read:unban_requests',
                'moderator:manage:unban_requests'
            ],
            canOverrideScopedUserContext: true,
            query: {
                ...this._createModeratorActionQuery(broadcasterId),
                ...(0, $78zDw.createSingleKeyQuery)('status', status)
            }
        }, this._client, (data)=>new $elAZM.HelixUnbanRequest(data, this._client));
    }
    /**
     * Resolves an unban request by approving or denying it.
     *
     * This uses the token of the broadcaster by default.
     * If you want to execute this in the context of another user (who has to be moderator of the channel)
     * you can do so using [user context overrides](/docs/auth/concepts/context-switching).
     *
     * @param broadcaster The ID of the broadcaster whose channel is approving or denying the unban request.
     * @param unbanRequestId The ID of the unban request to resolve.
     * @param approved Whether to approve or deny the unban request.
     * @param resolutionMessage Message supplied by the unban request resolver.
     *
     * The message is limited to a maximum of 500 characters.
     */ async resolveUnbanRequest(broadcaster, unbanRequestId, approved, resolutionMessage) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/unban_requests',
            method: 'PATCH',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:unban_requests'
            ],
            canOverrideScopedUserContext: true,
            query: (0, $hlADN.createResolveUnbanRequestQuery)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId), unbanRequestId, approved, resolutionMessage === null || resolutionMessage === void 0 ? void 0 : resolutionMessage.slice(0, 500))
        });
        return new $elAZM.HelixUnbanRequest(result.data[0], this._client);
    }
    /**
     * Warns a user in the specified broadcaster’s chat room, preventing them from chat interaction until the
     * warning is acknowledged.
     *
     * New warnings can be issued to a user when they already have a warning in the channel
     * (new warning will replace old warning).
     *
     * @param broadcaster The ID of the broadcaster in which channel the warning will take effect.
     * @param user The ID of the user to be warned.
     * @param reason A custom reason for the warning. Max 500 chars.
     */ async warnUser(broadcaster, user, reason) {
        const broadcasterId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'moderation/warnings',
            method: 'POST',
            userId: broadcasterId,
            scopes: [
                'moderator:manage:warnings'
            ],
            canOverrideScopedUserContext: true,
            query: this._createModeratorActionQuery(broadcasterId),
            jsonBody: (0, $hlADN.createWarnUserBody)(user, reason.slice(0, 500))
        });
        return new $9OKn1.HelixWarning(result.data[0], this._client);
    }
    _createModeratorActionQuery(broadcasterId) {
        return (0, $78zDw.createModeratorActionQuery)(broadcasterId, this._getUserContextIdWithDefault(broadcasterId));
    }
};
module.exports.HelixModerationApi = $f502a5a15e2efe5d$var$HelixModerationApi;
module.exports.HelixModerationApi = $f502a5a15e2efe5d$var$HelixModerationApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixModerationApi')
], $f502a5a15e2efe5d$var$HelixModerationApi);

});
parcelRegister("hlADN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createWarnUserBody = module.exports.createCheckAutoModStatusBody = module.exports.createUpdateShieldModeStatusBody = module.exports.createBanUserBody = module.exports.createAutoModSettingsBody = module.exports.createAutoModProcessBody = module.exports.createResolveUnbanRequestQuery = module.exports.createModeratorModifyQuery = module.exports.createModerationUserListQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $ca10d1f0d0dca238$var$createModerationUserListQuery(channel, filter) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(channel),
        user_id: filter === null || filter === void 0 ? void 0 : filter.userId
    };
}
module.exports.createModerationUserListQuery = $ca10d1f0d0dca238$var$createModerationUserListQuery;
/** @internal */ function $ca10d1f0d0dca238$var$createModeratorModifyQuery(broadcaster, user) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        user_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createModeratorModifyQuery = $ca10d1f0d0dca238$var$createModeratorModifyQuery;
/** @internal */ function $ca10d1f0d0dca238$var$createResolveUnbanRequestQuery(broadcaster, moderator, unbanRequestId, approved, resolutionMessage) {
    return {
        unban_request_id: unbanRequestId,
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        moderator_id: (0, $j0DIQ.extractUserId)(moderator),
        status: approved ? 'approved' : 'denied',
        resolution_text: resolutionMessage
    };
}
module.exports.createResolveUnbanRequestQuery = $ca10d1f0d0dca238$var$createResolveUnbanRequestQuery;
/** @internal */ function $ca10d1f0d0dca238$var$createAutoModProcessBody(user, msgId, allow) {
    return {
        user_id: (0, $j0DIQ.extractUserId)(user),
        msg_id: msgId,
        action: allow ? 'ALLOW' : 'DENY'
    };
}
module.exports.createAutoModProcessBody = $ca10d1f0d0dca238$var$createAutoModProcessBody;
/** @internal */ function $ca10d1f0d0dca238$var$createAutoModSettingsBody(data) {
    return {
        overall_level: data.overallLevel,
        aggression: data.aggression,
        bullying: data.bullying,
        disability: data.disability,
        misogyny: data.misogyny,
        race_ethnicity_or_religion: data.raceEthnicityOrReligion,
        sex_based_terms: data.sexBasedTerms,
        sexuality_sex_or_gender: data.sexualitySexOrGender,
        swearing: data.swearing
    };
}
module.exports.createAutoModSettingsBody = $ca10d1f0d0dca238$var$createAutoModSettingsBody;
/** @internal */ function $ca10d1f0d0dca238$var$createBanUserBody(data) {
    return {
        data: {
            duration: data.duration,
            reason: data.reason,
            user_id: (0, $j0DIQ.extractUserId)(data.user)
        }
    };
}
module.exports.createBanUserBody = $ca10d1f0d0dca238$var$createBanUserBody;
/** @internal */ function $ca10d1f0d0dca238$var$createUpdateShieldModeStatusBody(activate) {
    return {
        is_active: activate
    };
}
module.exports.createUpdateShieldModeStatusBody = $ca10d1f0d0dca238$var$createUpdateShieldModeStatusBody;
/** @internal */ function $ca10d1f0d0dca238$var$createCheckAutoModStatusBody(data) {
    return {
        data: data.map((entry)=>({
                msg_id: entry.messageId,
                msg_text: entry.messageText
            }))
    };
}
module.exports.createCheckAutoModStatusBody = $ca10d1f0d0dca238$var$createCheckAutoModStatusBody;
/** @internal */ function $ca10d1f0d0dca238$var$createWarnUserBody(user, reason) {
    return {
        data: {
            user_id: (0, $j0DIQ.extractUserId)(user),
            reason: reason
        }
    };
}
module.exports.createWarnUserBody = $ca10d1f0d0dca238$var$createWarnUserBody;

});

parcelRegister("h1fOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixAutoModSettings = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * The AutoMod settings of a channel.
 */ let $c63ecc8a094bad43$var$HelixAutoModSettings = class HelixAutoModSettings extends $j0DIQ.DataObject {
    /**
     * The ID of the broadcaster for which the AutoMod settings were fetched.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The ID of a user that has permission to moderate the broadcaster's chat room.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * The default AutoMod level for the broadcaster. This is null if the broadcaster changed individual settings.
     */ get overallLevel() {
        return this[$j0DIQ.rawDataSymbol].overall_level ? this[$j0DIQ.rawDataSymbol].overall_level : null;
    }
    /**
     * The AutoMod level for discrimination against disability.
     */ get disability() {
        return this[$j0DIQ.rawDataSymbol].disability;
    }
    /**
     * The AutoMod level for hostility involving aggression.
     */ get aggression() {
        return this[$j0DIQ.rawDataSymbol].aggression;
    }
    /**
     * The AutoMod level for discrimination based on sexuality, sex, or gender.
     */ get sexualitySexOrGender() {
        return this[$j0DIQ.rawDataSymbol].sexuality_sex_or_gender;
    }
    /**
     * The AutoMod level for discrimination against women.
     */ get misogyny() {
        return this[$j0DIQ.rawDataSymbol].misogyny;
    }
    /**
     * The AutoMod level for hostility involving name calling or insults.
     */ get bullying() {
        return this[$j0DIQ.rawDataSymbol].bullying;
    }
    /**
     * The AutoMod level for profanity.
     */ get swearing() {
        return this[$j0DIQ.rawDataSymbol].swearing;
    }
    /**
     * The AutoMod level for racial discrimination.
     */ get raceEthnicityOrReligion() {
        return this[$j0DIQ.rawDataSymbol].race_ethnicity_or_religion;
    }
    /**
     * The AutoMod level for sexual content.
     */ get sexBasedTerms() {
        return this[$j0DIQ.rawDataSymbol].sex_based_terms;
    }
};
module.exports.HelixAutoModSettings = $c63ecc8a094bad43$var$HelixAutoModSettings;
module.exports.HelixAutoModSettings = $c63ecc8a094bad43$var$HelixAutoModSettings = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixAutoModSettings', 'broadcasterId')
], $c63ecc8a094bad43$var$HelixAutoModSettings);

});

parcelRegister("af5sI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixAutoModStatus = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * The status of a message that says whether it is permitted by AutoMod or not.
 */ let $774f8ac5665e4902$var$HelixAutoModStatus = class HelixAutoModStatus extends $j0DIQ.DataObject {
    /**
     * The developer-generated ID that was sent with the request data.
     */ get messageId() {
        return this[$j0DIQ.rawDataSymbol].msg_id;
    }
    /**
     * Whether the message is permitted by AutoMod or not.
     */ get isPermitted() {
        return this[$j0DIQ.rawDataSymbol].is_permitted;
    }
};
module.exports.HelixAutoModStatus = $774f8ac5665e4902$var$HelixAutoModStatus;
module.exports.HelixAutoModStatus = $774f8ac5665e4902$var$HelixAutoModStatus = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixAutoModStatus', 'messageId')
], $774f8ac5665e4902$var$HelixAutoModStatus);

});

parcelRegister("axg0W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBan = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $f4oqh = parcelRequire("f4oqh");
/**
 * Information about the ban of a user.
 *
 * @inheritDoc
 */ let $7ab96884881e85d2$var$HelixBan = class HelixBan extends $f4oqh.HelixBanUser {
    /** @internal */ constructor(data, client){
        super(data, data.expires_at || null, client);
    }
    /**
     * The name of the user that was banned or put in a timeout.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user that was banned or put in a timeout.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * The name of the moderator that banned or put the user in the timeout.
     */ get moderatorName() {
        return this[$j0DIQ.rawDataSymbol].moderator_login;
    }
    /**
     * The display name of the moderator that banned or put the user in the timeout.
     */ get moderatorDisplayName() {
        return this[$j0DIQ.rawDataSymbol].moderator_name;
    }
    /**
     * The reason why the user was banned or timed out. Returns `null` if no reason was given.
     */ get reason() {
        return this[$j0DIQ.rawDataSymbol].reason || null;
    }
};
module.exports.HelixBan = $7ab96884881e85d2$var$HelixBan;
module.exports.HelixBan = $7ab96884881e85d2$var$HelixBan = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixBan', 'userId')
], $7ab96884881e85d2$var$HelixBan);

});
parcelRegister("f4oqh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBanUser = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about a user who has been banned/timed out.
 *
 * @hideProtected
 */ let $af8a2ca058679a43$var$HelixBanUser = class HelixBanUser extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, expiryTimestamp, client){
        super(data);
        this._expiryTimestamp = expiryTimestamp;
        this._client = client;
    }
    /**
     * The date and time that the ban/timeout was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date and time that the timeout will end. Is `null` if the user was banned instead of put in a timeout.
     */ get expiryDate() {
        return (0, $bRvJY.mapNullable)(this._expiryTimestamp, (ts)=>new Date(ts));
    }
    /**
     * The ID of the moderator that banned or put the user in the timeout.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * Gets more information about the moderator that banned or put the user in the timeout.
     */ async getModerator() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].moderator_id));
    }
    /**
     * The ID of the user that was banned or put in a timeout.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * Gets more information about the user that was banned or put in a timeout.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixBanUser = $af8a2ca058679a43$var$HelixBanUser;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $af8a2ca058679a43$var$HelixBanUser.prototype, "_client", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $af8a2ca058679a43$var$HelixBanUser.prototype, "_expiryTimestamp", void 0);
module.exports.HelixBanUser = $af8a2ca058679a43$var$HelixBanUser = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixBanUser', 'userId')
], $af8a2ca058679a43$var$HelixBanUser);

});


parcelRegister("d90cS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBlockedTerm = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about a word or phrase blocked in a broadcaster's channel.
 */ let $991c46a6db1cbf9d$var$HelixBlockedTerm = class HelixBlockedTerm extends $j0DIQ.DataObject {
    /**
     * The ID of the broadcaster that owns the list of blocked terms.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The date and time of when the term was blocked.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date and time of when the blocked term is set to expire. After the block expires, users will be able to use the term in the broadcaster’s chat room.
     * Is `null` if the term was added manually or permanently blocked by AutoMod.
     */ get expirationDate() {
        return this[$j0DIQ.rawDataSymbol].expires_at ? new Date(this[$j0DIQ.rawDataSymbol].expires_at) : null;
    }
    /**
     * An ID that uniquely identifies this blocked term.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the moderator that blocked the word or phrase from being used in the broadcaster’s chat room.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * The blocked word or phrase.
     */ get text() {
        return this[$j0DIQ.rawDataSymbol].text;
    }
    /**
     * The date and time of when the term was updated.
     */ get updatedDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].updated_at);
    }
};
module.exports.HelixBlockedTerm = $991c46a6db1cbf9d$var$HelixBlockedTerm;
module.exports.HelixBlockedTerm = $991c46a6db1cbf9d$var$HelixBlockedTerm = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixBlockedTerm', 'id')
], $991c46a6db1cbf9d$var$HelixBlockedTerm);

});

parcelRegister("b7oXt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixModeratedChannel = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A reference to a Twitch channel where a user is a moderator.
 */ let $8183b556cccdd3b7$var$HelixModeratedChannel = class HelixModeratedChannel extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the channel.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the channel.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the channel.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the channel.
     */ async getChannel() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.channels.getChannelInfoById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * Gets more information about the broadcaster of the channel.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
};
module.exports.HelixModeratedChannel = $8183b556cccdd3b7$var$HelixModeratedChannel;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $8183b556cccdd3b7$var$HelixModeratedChannel.prototype, "_client", void 0);
module.exports.HelixModeratedChannel = $8183b556cccdd3b7$var$HelixModeratedChannel = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixModeratedChannel', 'id')
], $8183b556cccdd3b7$var$HelixModeratedChannel);

});

parcelRegister("7AuQT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixModerator = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about the moderator status of a user.
 */ let $5863d3ca12ceaac2$var$HelixModerator = class HelixModerator extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixModerator = $5863d3ca12ceaac2$var$HelixModerator;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $5863d3ca12ceaac2$var$HelixModerator.prototype, "_client", void 0);
module.exports.HelixModerator = $5863d3ca12ceaac2$var$HelixModerator = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixModerator', 'userId')
], $5863d3ca12ceaac2$var$HelixModerator);

});

parcelRegister("2BoCE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixShieldModeStatus = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about the Shield Mode status of a channel.
 */ let $1e5222fbd0572a79$var$HelixShieldModeStatus = class HelixShieldModeStatus extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * Whether Shield Mode is active.
     */ get isActive() {
        return this[$j0DIQ.rawDataSymbol].is_active;
    }
    /**
     * The ID of the moderator that last activated Shield Mode.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * The name of the moderator that last activated Shield Mode.
     */ get moderatorName() {
        return this[$j0DIQ.rawDataSymbol].moderator_login;
    }
    /**
     * The display name of the moderator that last activated Shield Mode.
     */ get moderatorDisplayName() {
        return this[$j0DIQ.rawDataSymbol].moderator_name;
    }
    /**
     * Gets more information about the moderator that last activated Shield Mode.
     */ async getModerator() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].moderator_id));
    }
    /**
     * The date when Shield Mode was last activated. `null` indicates Shield Mode hasn't been previously activated.
     */ get lastActivationDate() {
        return this[$j0DIQ.rawDataSymbol].last_activated_at === '' ? null : new Date(this[$j0DIQ.rawDataSymbol].last_activated_at);
    }
};
module.exports.HelixShieldModeStatus = $1e5222fbd0572a79$var$HelixShieldModeStatus;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $1e5222fbd0572a79$var$HelixShieldModeStatus.prototype, "_client", void 0);
module.exports.HelixShieldModeStatus = $1e5222fbd0572a79$var$HelixShieldModeStatus = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixShieldModeStatus')
], $1e5222fbd0572a79$var$HelixShieldModeStatus);

});

parcelRegister("elAZM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUnbanRequest = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A request from a user to be unbanned from a channel.
 */ let $a71fb963d4554de6$var$HelixUnbanRequest = class HelixUnbanRequest extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * Unban request ID.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster whose channel is receiving the unban request.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster whose channel is receiving the unban request.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The display name of the broadcaster whose channel is receiving the unban request.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The ID of the moderator who resolved the unban request.
     *
     * Can be `null` if the request is not resolved.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * The name of the moderator who resolved the unban request.
     *
     * Can be `null` if the request is not resolved.
     */ get moderatorName() {
        return this[$j0DIQ.rawDataSymbol].moderator_login;
    }
    /**
     * The display name of the moderator who resolved the unban request.
     *
     * Can be `null` if the request is not resolved.
     */ get moderatorDisplayName() {
        return this[$j0DIQ.rawDataSymbol].moderator_name;
    }
    /**
     * Gets more information about the moderator.
     */ async getModerator() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].moderator_id));
    }
    /**
     * The ID of the user who requested to be unbanned.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user who requested to be unbanned.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user who requested to be unbanned.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * Text message of the unban request from the requesting user.
     */ get message() {
        return this[$j0DIQ.rawDataSymbol].text;
    }
    /**
     * The date of when the unban request was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The message written by the moderator who resolved the unban request, or `null` if it has not been resolved yet.
     */ get resolutionMessage() {
        // Can be empty string and null
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return this[$j0DIQ.rawDataSymbol].resolution_text || null;
    }
    /**
     * The date when the unban request was resolved, or `null` if it has not been resolved yet.
     */ get resolutionDate() {
        return (0, $bRvJY.mapNullable)(this[$j0DIQ.rawDataSymbol].resolved_at, (val)=>new Date(val));
    }
};
module.exports.HelixUnbanRequest = $a71fb963d4554de6$var$HelixUnbanRequest;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $a71fb963d4554de6$var$HelixUnbanRequest.prototype, "_client", void 0);
module.exports.HelixUnbanRequest = $a71fb963d4554de6$var$HelixUnbanRequest = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUnbanRequest', 'id')
], $a71fb963d4554de6$var$HelixUnbanRequest);

});

parcelRegister("9OKn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixWarning = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Information about the warning.
 */ let $725cc0bfd0abc861$var$HelixWarning = class HelixWarning extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the channel in which the warning will take effect.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The ID of the user who applied the warning.
     */ get moderatorId() {
        return this[$j0DIQ.rawDataSymbol].moderator_id;
    }
    /**
     * Gets more information about the moderator.
     */ async getModerator() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].moderator_id));
    }
    /**
     * The ID of the warned user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * Gets more information about the user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The reason provided for the warning.
     */ get reason() {
        return this[$j0DIQ.rawDataSymbol].reason;
    }
};
module.exports.HelixWarning = $725cc0bfd0abc861$var$HelixWarning;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $725cc0bfd0abc861$var$HelixWarning.prototype, "_client", void 0);
module.exports.HelixWarning = $725cc0bfd0abc861$var$HelixWarning = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixWarning', 'userId')
], $725cc0bfd0abc861$var$HelixWarning);

});


parcelRegister("htL0z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPollApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $c2dYb = parcelRequire("c2dYb");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $1ZGB4 = parcelRequire("1ZGB4");
/**
 * The Helix API methods that deal with polls.
 *
 * Can be accessed using `client.polls` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: polls } = await api.helix.polls.getPolls('61369223');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Polls
 */ let $cb999bef13c0080c$var$HelixPollApi = class HelixPollApi extends $lq7i7.BaseApi {
    /**
     * Gets a list of polls for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get polls for.
     * @param pagination
     *
     * @expandParams
     */ async getPolls(broadcaster, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'polls',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:polls',
                'channel:manage:polls'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $1ZGB4.HelixPoll, this._client);
    }
    /**
     * Creates a paginator for polls for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get polls for.
     */ getPollsPaginated(broadcaster) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'polls',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:polls',
                'channel:manage:polls'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        }, this._client, (data)=>new $1ZGB4.HelixPoll(data, this._client), 20);
    }
    /**
     * Gets polls by IDs.
     *
     * @param broadcaster The broadcaster to get the polls for.
     * @param ids The IDs of the polls.
     */ async getPollsByIds(broadcaster, ids) {
        if (!ids.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'polls',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:polls',
                'channel:manage:polls'
            ],
            query: (0, $78zDw.createGetByIdsQuery)(broadcaster, ids)
        });
        return result.data.map((data)=>new $1ZGB4.HelixPoll(data, this._client));
    }
    /**
     * Gets a poll by ID.
     *
     * @param broadcaster The broadcaster to get the poll for.
     * @param id The ID of the poll.
     */ async getPollById(broadcaster, id) {
        const polls = await this.getPollsByIds(broadcaster, [
            id
        ]);
        return polls.length ? polls[0] : null;
    }
    /**
     * Creates a new poll.
     *
     * @param broadcaster The broadcaster to create the poll for.
     * @param data
     *
     * @expandParams
     */ async createPoll(broadcaster, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'polls',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:polls'
            ],
            jsonBody: (0, $c2dYb.createPollBody)(broadcaster, data)
        });
        return new $1ZGB4.HelixPoll(result.data[0], this._client);
    }
    /**
     * Ends a poll.
     *
     * @param broadcaster The broadcaster to end the poll for.
     * @param id The ID of the poll to end.
     * @param showResult Whether to allow the result to be viewed publicly.
     */ async endPoll(broadcaster, id, showResult = true) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'polls',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:polls'
            ],
            jsonBody: (0, $c2dYb.createPollEndBody)(broadcaster, id, showResult)
        });
        return new $1ZGB4.HelixPoll(result.data[0], this._client);
    }
};
module.exports.HelixPollApi = $cb999bef13c0080c$var$HelixPollApi;
module.exports.HelixPollApi = $cb999bef13c0080c$var$HelixPollApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPollApi')
], $cb999bef13c0080c$var$HelixPollApi);

});
parcelRegister("c2dYb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createPollEndBody = module.exports.createPollBody = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $8c30820786038c5f$var$createPollBody(broadcaster, data) {
    var _a;
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        title: data.title,
        choices: data.choices.map((title)=>({
                title: title
            })),
        duration: data.duration,
        channel_points_voting_enabled: data.channelPointsPerVote != null,
        channel_points_per_vote: (_a = data.channelPointsPerVote) !== null && _a !== void 0 ? _a : 0
    };
}
module.exports.createPollBody = $8c30820786038c5f$var$createPollBody;
/** @internal */ function $8c30820786038c5f$var$createPollEndBody(broadcaster, id, showResult) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        id: id,
        status: showResult ? 'TERMINATED' : 'ARCHIVED'
    };
}
module.exports.createPollEndBody = $8c30820786038c5f$var$createPollEndBody;

});

parcelRegister("1ZGB4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPoll = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $7Mv1R = parcelRequire("7Mv1R");
/**
 * A channel poll.
 */ let $173c87d5468ad9eb$var$HelixPoll = class HelixPoll extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the poll.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The title of the poll.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * Whether voting with channel points is enabled for the poll.
     */ get isChannelPointsVotingEnabled() {
        return this[$j0DIQ.rawDataSymbol].channel_points_voting_enabled;
    }
    /**
     * The amount of channel points that a vote costs.
     */ get channelPointsPerVote() {
        return this[$j0DIQ.rawDataSymbol].channel_points_per_vote;
    }
    /**
     * The status of the poll.
     */ get status() {
        return this[$j0DIQ.rawDataSymbol].status;
    }
    /**
     * The duration of the poll, in seconds.
     */ get durationInSeconds() {
        return this[$j0DIQ.rawDataSymbol].duration;
    }
    /**
     * The date when the poll started.
     */ get startDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].started_at);
    }
    /**
     * The date when the poll ended or will end.
     */ get endDate() {
        return new Date(this.startDate.getTime() + this[$j0DIQ.rawDataSymbol].duration * 1000);
    }
    /**
     * The choices of the poll.
     */ get choices() {
        return this[$j0DIQ.rawDataSymbol].choices.map((data)=>new $7Mv1R.HelixPollChoice(data));
    }
};
module.exports.HelixPoll = $173c87d5468ad9eb$var$HelixPoll;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $173c87d5468ad9eb$var$HelixPoll.prototype, "_client", void 0);
module.exports.HelixPoll = $173c87d5468ad9eb$var$HelixPoll = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPoll', 'id')
], $173c87d5468ad9eb$var$HelixPoll);

});
parcelRegister("7Mv1R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPollChoice = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A choice in a channel poll.
 */ let $5aa515ce8afc99a7$var$HelixPollChoice = class HelixPollChoice extends $j0DIQ.DataObject {
    /**
     * The ID of the choice.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The title of the choice.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The total votes the choice received.
     */ get totalVotes() {
        return this[$j0DIQ.rawDataSymbol].votes;
    }
    /**
     * The votes the choice received by spending channel points.
     */ get channelPointsVotes() {
        return this[$j0DIQ.rawDataSymbol].channel_points_votes;
    }
};
module.exports.HelixPollChoice = $5aa515ce8afc99a7$var$HelixPollChoice;
module.exports.HelixPollChoice = $5aa515ce8afc99a7$var$HelixPollChoice = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPollChoice', 'id')
], $5aa515ce8afc99a7$var$HelixPollChoice);

});



parcelRegister("yazN3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPredictionApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $aBiTe = parcelRequire("aBiTe");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $1MAZj = parcelRequire("1MAZj");
/**
 * The Helix API methods that deal with predictions.
 *
 * Can be accessed using `client.predictions` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: predictions } = await api.helix.predictions.getPredictions('61369223');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Predictions
 */ let $066b6150e51d8e47$var$HelixPredictionApi = class HelixPredictionApi extends $lq7i7.BaseApi {
    /**
     * Gets a list of predictions for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get predictions for.
     * @param pagination
     *
     * @expandParams
     */ async getPredictions(broadcaster, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'predictions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:predictions'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $1MAZj.HelixPrediction, this._client);
    }
    /**
     * Creates a paginator for predictions for the given broadcaster.
     *
     * @param broadcaster The broadcaster to get predictions for.
     */ getPredictionsPaginated(broadcaster) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'predictions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:predictions'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        }, this._client, (data)=>new $1MAZj.HelixPrediction(data, this._client), 20);
    }
    /**
     * Gets predictions by IDs.
     *
     * @param broadcaster The broadcaster to get the predictions for.
     * @param ids The IDs of the predictions.
     */ async getPredictionsByIds(broadcaster, ids) {
        if (!ids.length) return [];
        const result = await this._client.callApi({
            type: 'helix',
            url: 'predictions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:predictions'
            ],
            query: (0, $78zDw.createGetByIdsQuery)(broadcaster, ids)
        });
        return result.data.map((data)=>new $1MAZj.HelixPrediction(data, this._client));
    }
    /**
     * Gets a prediction by ID.
     *
     * @param broadcaster The broadcaster to get the prediction for.
     * @param id The ID of the prediction.
     */ async getPredictionById(broadcaster, id) {
        const predictions = await this.getPredictionsByIds(broadcaster, [
            id
        ]);
        return predictions.length ? predictions[0] : null;
    }
    /**
     * Creates a new prediction.
     *
     * @param broadcaster The broadcaster to create the prediction for.
     * @param data
     *
     * @expandParams
     */ async createPrediction(broadcaster, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'predictions',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:predictions'
            ],
            jsonBody: (0, $aBiTe.createPredictionBody)(broadcaster, data)
        });
        return new $1MAZj.HelixPrediction(result.data[0], this._client);
    }
    /**
     * Locks a prediction.
     *
     * @param broadcaster The broadcaster to lock the prediction for.
     * @param id The ID of the prediction to lock.
     */ async lockPrediction(broadcaster, id) {
        return await this._endPrediction(broadcaster, id, 'LOCKED');
    }
    /**
     * Resolves a prediction.
     *
     * @param broadcaster The broadcaster to resolve the prediction for.
     * @param id The ID of the prediction to resolve.
     * @param outcomeId The ID of the winning outcome.
     */ async resolvePrediction(broadcaster, id, outcomeId) {
        return await this._endPrediction(broadcaster, id, 'RESOLVED', outcomeId);
    }
    /**
     * Cancels a prediction.
     *
     * @param broadcaster The broadcaster to cancel the prediction for.
     * @param id The ID of the prediction to cancel.
     */ async cancelPrediction(broadcaster, id) {
        return await this._endPrediction(broadcaster, id, 'CANCELED');
    }
    async _endPrediction(broadcaster, id, status, outcomeId) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'predictions',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:predictions'
            ],
            jsonBody: (0, $aBiTe.createEndPredictionBody)(broadcaster, id, status, outcomeId)
        });
        return new $1MAZj.HelixPrediction(result.data[0], this._client);
    }
};
module.exports.HelixPredictionApi = $066b6150e51d8e47$var$HelixPredictionApi;
module.exports.HelixPredictionApi = $066b6150e51d8e47$var$HelixPredictionApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPredictionApi')
], $066b6150e51d8e47$var$HelixPredictionApi);

});
parcelRegister("aBiTe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createEndPredictionBody = module.exports.createPredictionBody = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $7b7c0338f8dfa7b1$var$createPredictionBody(broadcaster, data) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        title: data.title,
        outcomes: data.outcomes.map((title)=>({
                title: title
            })),
        prediction_window: data.autoLockAfter
    };
}
module.exports.createPredictionBody = $7b7c0338f8dfa7b1$var$createPredictionBody;
/** @internal */ function $7b7c0338f8dfa7b1$var$createEndPredictionBody(broadcaster, id, status, outcomeId) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        id: id,
        status: status,
        winning_outcome_id: outcomeId
    };
}
module.exports.createEndPredictionBody = $7b7c0338f8dfa7b1$var$createEndPredictionBody;

});

parcelRegister("1MAZj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPrediction = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $gNeGc = parcelRequire("gNeGc");
/**
 * A channel prediction.
 */ let $14c6f7290b2ebe55$var$HelixPrediction = class HelixPrediction extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the prediction.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The title of the prediction.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The status of the prediction.
     */ get status() {
        return this[$j0DIQ.rawDataSymbol].status;
    }
    /**
     * The time after which the prediction will be automatically locked, in seconds from creation.
     */ get autoLockAfter() {
        return this[$j0DIQ.rawDataSymbol].prediction_window;
    }
    /**
     * The date when the prediction started.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date when the prediction ended, or null if it didn't end yet.
     */ get endDate() {
        return this[$j0DIQ.rawDataSymbol].ended_at ? new Date(this[$j0DIQ.rawDataSymbol].ended_at) : null;
    }
    /**
     * The date when the prediction was locked, or null if it wasn't locked yet.
     */ get lockDate() {
        return this[$j0DIQ.rawDataSymbol].locked_at ? new Date(this[$j0DIQ.rawDataSymbol].locked_at) : null;
    }
    /**
     * The possible outcomes of the prediction.
     */ get outcomes() {
        return this[$j0DIQ.rawDataSymbol].outcomes.map((data)=>new $gNeGc.HelixPredictionOutcome(data, this._client));
    }
    /**
     * The ID of the winning outcome, or null if the prediction is currently running or was canceled.
     */ get winningOutcomeId() {
        // can apparently be empty string
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return this[$j0DIQ.rawDataSymbol].winning_outcome_id || null;
    }
    /**
     * The winning outcome, or null if the prediction is currently running or was canceled.
     */ get winningOutcome() {
        if (!this[$j0DIQ.rawDataSymbol].winning_outcome_id) return null;
        const found = this[$j0DIQ.rawDataSymbol].outcomes.find((o)=>o.id === this[$j0DIQ.rawDataSymbol].winning_outcome_id);
        if (!found) throw new $j0DIQ.HellFreezesOverError('Winning outcome not found in outcomes array');
        return new $gNeGc.HelixPredictionOutcome(found, this._client);
    }
};
module.exports.HelixPrediction = $14c6f7290b2ebe55$var$HelixPrediction;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $14c6f7290b2ebe55$var$HelixPrediction.prototype, "_client", void 0);
module.exports.HelixPrediction = $14c6f7290b2ebe55$var$HelixPrediction = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPrediction', 'id')
], $14c6f7290b2ebe55$var$HelixPrediction);

});
parcelRegister("gNeGc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPredictionOutcome = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $jaxFs = parcelRequire("jaxFs");
/**
 * A possible outcome in a channel prediction.
 */ let $c39c9c00290a0f35$var$HelixPredictionOutcome = class HelixPredictionOutcome extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the outcome.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The title of the outcome.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The number of users that guessed the outcome.
     */ get users() {
        return this[$j0DIQ.rawDataSymbol].users;
    }
    /**
     * The total number of channel points that were spent on guessing the outcome.
     */ get totalChannelPoints() {
        return this[$j0DIQ.rawDataSymbol].channel_points;
    }
    /**
     * The color of the outcome.
     */ get color() {
        return this[$j0DIQ.rawDataSymbol].color;
    }
    /**
     * The top predictors of the outcome.
     */ get topPredictors() {
        var _a, _b;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].top_predictors) === null || _a === void 0 ? void 0 : _a.map((data)=>new $jaxFs.HelixPredictor(data, this._client))) !== null && _b !== void 0 ? _b : [];
    }
};
module.exports.HelixPredictionOutcome = $c39c9c00290a0f35$var$HelixPredictionOutcome;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c39c9c00290a0f35$var$HelixPredictionOutcome.prototype, "_client", void 0);
module.exports.HelixPredictionOutcome = $c39c9c00290a0f35$var$HelixPredictionOutcome = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPredictionOutcome', 'id')
], $c39c9c00290a0f35$var$HelixPredictionOutcome);

});
parcelRegister("jaxFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPredictor = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A user that took part in a prediction.
 */ let $df491134e461009f$var$HelixPredictor = class HelixPredictor extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The user ID of the predictor.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the predictor.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the predictor.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the predictor.
     */ async getUser() {
        return await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id);
    }
    /**
     * The amount of channel points the predictor used for the prediction.
     */ get channelPointsUsed() {
        return this[$j0DIQ.rawDataSymbol].channel_points_used;
    }
    /**
     * The amount of channel points the predictor won for the prediction, or null if the prediction is not resolved yet, was cancelled or lost.
     */ get channelPointsWon() {
        return this[$j0DIQ.rawDataSymbol].channel_points_won;
    }
};
module.exports.HelixPredictor = $df491134e461009f$var$HelixPredictor;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $df491134e461009f$var$HelixPredictor.prototype, "_client", void 0);
module.exports.HelixPredictor = $df491134e461009f$var$HelixPredictor = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPredictor', 'userId')
], $df491134e461009f$var$HelixPredictor);

});




parcelRegister("28sHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixRaidApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $fSyHF = parcelRequire("fSyHF");

var $lq7i7 = parcelRequire("lq7i7");

var $anYgI = parcelRequire("anYgI");
/**
 * The Helix API methods that deal with raids.
 *
 * Can be accessed using `client.raids` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const raid = await api.raids.startRaid('125328655', '61369223');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Raids
 */ let $18e297e5ef475069$var$HelixRaidApi = class HelixRaidApi extends $lq7i7.BaseApi {
    /**
     * Initiate a raid from a live broadcaster to another live broadcaster.
     *
     * @param from The raiding broadcaster.
     * @param to The raid target.
     */ async startRaid(from, to) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'raids',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(from),
            scopes: [
                'channel:manage:raids'
            ],
            query: (0, $fSyHF.createRaidStartQuery)(from, to)
        });
        return new $anYgI.HelixRaid(result.data[0]);
    }
    /**
     * Cancels an initiated raid.
     *
     * @param from The raiding broadcaster.
     */ async cancelRaid(from) {
        await this._client.callApi({
            type: 'helix',
            url: 'raids',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(from),
            scopes: [
                'channel:manage:raids'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(from)
        });
    }
};
module.exports.HelixRaidApi = $18e297e5ef475069$var$HelixRaidApi;
module.exports.HelixRaidApi = $18e297e5ef475069$var$HelixRaidApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixRaidApi')
], $18e297e5ef475069$var$HelixRaidApi);

});
parcelRegister("fSyHF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRaidStartQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $b8f6d1885f8022a1$var$createRaidStartQuery(from, to) {
    return {
        from_broadcaster_id: (0, $j0DIQ.extractUserId)(from),
        to_broadcaster_id: (0, $j0DIQ.extractUserId)(to)
    };
}
module.exports.createRaidStartQuery = $b8f6d1885f8022a1$var$createRaidStartQuery;

});

parcelRegister("anYgI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixRaid = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A result of a successful raid initiation.
 */ let $78facd6f2737a122$var$HelixRaid = class HelixRaid extends $j0DIQ.DataObject {
    /**
     * The date when the raid was initiated.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * Whether the raid target channel is intended for mature audiences.
     */ get targetIsMature() {
        return this[$j0DIQ.rawDataSymbol].is_mature;
    }
};
module.exports.HelixRaid = $78facd6f2737a122$var$HelixRaid;
module.exports.HelixRaid = $78facd6f2737a122$var$HelixRaid = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixRaid')
], $78facd6f2737a122$var$HelixRaid);

});


parcelRegister("7R0an", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixScheduleApi = void 0;

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $WR9i7 = parcelRequire("WR9i7");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $8hGJ4 = parcelRequire("8hGJ4");

var $enDAN = parcelRequire("enDAN");

var $gF4Kv = parcelRequire("gF4Kv");
/**
 * The Helix API methods that deal with schedules.
 *
 * Can be accessed using `client.schedule` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: schedule } = await api.helix.schedule.getSchedule('61369223');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Schedule
 */ class $5b7d9ca976a34fb8$var$HelixScheduleApi extends $lq7i7.BaseApi {
    /**
     * Gets the schedule for a given broadcaster.
     *
     * @param broadcaster The broadcaster to get the schedule of.
     * @param filter
     *
     * @expandParams
     */ async getSchedule(broadcaster, filter) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'schedule',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: {
                ...(0, $WR9i7.createScheduleQuery)(broadcaster, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return {
            data: new $enDAN.HelixSchedule(result.data, this._client),
            cursor: result.pagination.cursor
        };
    }
    /**
     * Creates a paginator for schedule segments for a given broadcaster.
     *
     * @param broadcaster The broadcaster to get the schedule segments of.
     * @param filter
     *
     * @expandParams
     */ getScheduleSegmentsPaginated(broadcaster, filter) {
        return new $8hGJ4.HelixPaginatedScheduleSegmentRequest(broadcaster, this._client, filter);
    }
    /**
     * Gets a set of schedule segments by IDs.
     *
     * @param broadcaster The broadcaster to get schedule segments of.
     * @param ids The IDs of the schedule segments.
     */ async getScheduleSegmentsByIds(broadcaster, ids) {
        var _a, _b;
        const result = await this._client.callApi({
            type: 'helix',
            url: 'schedule',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $78zDw.createGetByIdsQuery)(broadcaster, ids)
        });
        return (_b = (_a = result.data.segments) === null || _a === void 0 ? void 0 : _a.map((data)=>new $gF4Kv.HelixScheduleSegment(data, this._client))) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * Gets a single schedule segment by ID.
     *
     * @param broadcaster The broadcaster to get a schedule segment of.
     * @param id The ID of the schedule segment.
     */ async getScheduleSegmentById(broadcaster, id) {
        const segments = await this.getScheduleSegmentsByIds(broadcaster, [
            id
        ]);
        return segments.length ? segments[0] : null;
    }
    /**
     * Gets the schedule for a given broadcaster in iCal format.
     *
     * @param broadcaster The broadcaster to get the schedule for.
     */ async getScheduleAsIcal(broadcaster) {
        return await this._client.callApi({
            type: 'helix',
            url: 'schedule/icalendar',
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
    }
    /**
     * Updates the schedule settings of a given broadcaster.
     *
     * @param broadcaster The broadcaster to update the schedule settings for.
     * @param settings
     *
     * @expandParams
     */ async updateScheduleSettings(broadcaster, settings) {
        await this._client.callApi({
            type: 'helix',
            url: 'schedule/settings',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:schedule'
            ],
            query: (0, $WR9i7.createScheduleSettingsUpdateQuery)(broadcaster, settings)
        });
    }
    /**
     * Creates a new segment in a given broadcaster's schedule.
     *
     * @param broadcaster The broadcaster to create a new schedule segment for.
     * @param data
     *
     * @expandParams
     */ async createScheduleSegment(broadcaster, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'schedule/segment',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:schedule'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster),
            jsonBody: (0, $WR9i7.createScheduleSegmentBody)(data)
        });
        return new $gF4Kv.HelixScheduleSegment(result.data.segments[0], this._client);
    }
    /**
     * Updates a segment in a given broadcaster's schedule.
     *
     * @param broadcaster The broadcaster to create a new schedule segment for.
     * @param segmentId The ID of the segment to update.
     * @param data
     *
     * @expandParams
     */ async updateScheduleSegment(broadcaster, segmentId, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'schedule/segment',
            method: 'PATCH',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:schedule'
            ],
            query: (0, $WR9i7.createScheduleSegmentModifyQuery)(broadcaster, segmentId),
            jsonBody: (0, $WR9i7.createScheduleSegmentUpdateBody)(data)
        });
        return new $gF4Kv.HelixScheduleSegment(result.data.segments[0], this._client);
    }
    /**
     * Deletes a segment in a given broadcaster's schedule.
     *
     * @param broadcaster The broadcaster to create a new schedule segment for.
     * @param segmentId The ID of the segment to update.
     */ async deleteScheduleSegment(broadcaster, segmentId) {
        await this._client.callApi({
            type: 'helix',
            url: 'schedule/segment',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:schedule'
            ],
            query: (0, $WR9i7.createScheduleSegmentModifyQuery)(broadcaster, segmentId)
        });
    }
}
module.exports.HelixScheduleApi = $5b7d9ca976a34fb8$var$HelixScheduleApi;

});
parcelRegister("WR9i7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createScheduleSegmentUpdateBody = module.exports.createScheduleSegmentModifyQuery = module.exports.createScheduleSegmentBody = module.exports.createScheduleSettingsUpdateQuery = module.exports.createScheduleQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $0b0ea5267593a598$var$createScheduleQuery(broadcaster, filter) {
    var _a;
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        start_time: filter === null || filter === void 0 ? void 0 : filter.startDate,
        utc_offset: (_a = filter === null || filter === void 0 ? void 0 : filter.utcOffset) === null || _a === void 0 ? void 0 : _a.toString()
    };
}
module.exports.createScheduleQuery = $0b0ea5267593a598$var$createScheduleQuery;
/** @internal */ function $0b0ea5267593a598$var$createScheduleSettingsUpdateQuery(broadcaster, settings) {
    if (settings.vacation) return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        is_vacation_enabled: 'true',
        vacation_start_time: settings.vacation.startDate,
        vacation_end_time: settings.vacation.endDate,
        timezone: settings.vacation.timezone
    };
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        is_vacation_enabled: 'false'
    };
}
module.exports.createScheduleSettingsUpdateQuery = $0b0ea5267593a598$var$createScheduleSettingsUpdateQuery;
/** @internal */ function $0b0ea5267593a598$var$createScheduleSegmentBody(data) {
    return {
        start_time: data.startDate,
        timezone: data.timezone,
        is_recurring: data.isRecurring,
        duration: data.duration,
        category_id: data.categoryId,
        title: data.title
    };
}
module.exports.createScheduleSegmentBody = $0b0ea5267593a598$var$createScheduleSegmentBody;
/** @internal */ function $0b0ea5267593a598$var$createScheduleSegmentModifyQuery(broadcaster, segmentId) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        id: segmentId
    };
}
module.exports.createScheduleSegmentModifyQuery = $0b0ea5267593a598$var$createScheduleSegmentModifyQuery;
/** @internal */ function $0b0ea5267593a598$var$createScheduleSegmentUpdateBody(data) {
    return {
        start_time: data.startDate,
        timezone: data.timezone,
        is_canceled: data.isCanceled,
        duration: data.duration,
        category_id: data.categoryId,
        title: data.title
    };
}
module.exports.createScheduleSegmentUpdateBody = $0b0ea5267593a598$var$createScheduleSegmentUpdateBody;

});

parcelRegister("8hGJ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPaginatedScheduleSegmentRequest = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $WR9i7 = parcelRequire("WR9i7");

var $6tEA1 = parcelRequire("6tEA1");

var $gF4Kv = parcelRequire("gF4Kv");
/**
 * A paginator specifically for schedule segments.
 */ let $60810dc0665ffb24$var$HelixPaginatedScheduleSegmentRequest = class HelixPaginatedScheduleSegmentRequest extends $6tEA1.HelixPaginatedRequest {
    /** @internal */ constructor(broadcaster, client, filter){
        super({
            url: 'schedule',
            query: (0, $WR9i7.createScheduleQuery)(broadcaster, filter)
        }, client, (data)=>new $gF4Kv.HelixScheduleSegment(data, client), 25);
    }
    // sadly, this hack is necessary to work around the weird data model of schedules
    // while still keeping the pagination code as generic as possible
    /** @internal */ async _fetchData(additionalOptions = {}) {
        var _a;
        const origData = await super._fetchData(additionalOptions);
        return {
            data: (_a = origData.data.segments) !== null && _a !== void 0 ? _a : [],
            pagination: origData.pagination
        };
    }
};
module.exports.HelixPaginatedScheduleSegmentRequest = $60810dc0665ffb24$var$HelixPaginatedScheduleSegmentRequest;
module.exports.HelixPaginatedScheduleSegmentRequest = $60810dc0665ffb24$var$HelixPaginatedScheduleSegmentRequest = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPaginatedScheduleSegmentRequest')
], $60810dc0665ffb24$var$HelixPaginatedScheduleSegmentRequest);

});
parcelRegister("gF4Kv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixScheduleSegment = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A segment of a schedule.
 */ let $c21428bcf79b3b66$var$HelixScheduleSegment = class HelixScheduleSegment extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the segment.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The date when the segment starts.
     */ get startDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].start_time);
    }
    /**
     * The date when the segment ends.
     */ get endDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].end_time);
    }
    /**
     * The title of the segment.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The date up to which the segment is canceled.
     */ get cancelEndDate() {
        return (0, $bRvJY.mapNullable)(this[$j0DIQ.rawDataSymbol].canceled_until, (v)=>new Date(v));
    }
    /**
     * The ID of the category the segment is scheduled for, or null if no category is specified.
     */ get categoryId() {
        var _a, _b;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].category) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * The name of the category the segment is scheduled for, or null if no category is specified.
     */ get categoryName() {
        var _a, _b;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].category) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Gets more information about the category the segment is scheduled for, or null if no category is specified.
     */ async getCategory() {
        var _a;
        const categoryId = (_a = this[$j0DIQ.rawDataSymbol].category) === null || _a === void 0 ? void 0 : _a.id;
        return categoryId ? await this._client.games.getGameById(categoryId) : null;
    }
    /**
     * Whether the segment is recurring every week.
     */ get isRecurring() {
        return this[$j0DIQ.rawDataSymbol].is_recurring;
    }
};
module.exports.HelixScheduleSegment = $c21428bcf79b3b66$var$HelixScheduleSegment;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $c21428bcf79b3b66$var$HelixScheduleSegment.prototype, "_client", void 0);
module.exports.HelixScheduleSegment = $c21428bcf79b3b66$var$HelixScheduleSegment = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixScheduleSegment', 'id')
], $c21428bcf79b3b66$var$HelixScheduleSegment);

});


parcelRegister("enDAN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSchedule = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $gF4Kv = parcelRequire("gF4Kv");
/**
 * A schedule of a channel.
 */ let $a781ece853f86624$var$HelixSchedule = class HelixSchedule extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The segments of the schedule.
     */ get segments() {
        var _a, _b;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].segments) === null || _a === void 0 ? void 0 : _a.map((data)=>new $gF4Kv.HelixScheduleSegment(data, this._client))) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * The ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The date when the current vacation started, or null if the schedule is not in vacation mode.
     */ get vacationStartDate() {
        var _a;
        const timestamp = (_a = this[$j0DIQ.rawDataSymbol].vacation) === null || _a === void 0 ? void 0 : _a.start_time;
        return timestamp ? new Date(timestamp) : null;
    }
    /**
     * The date when the current vacation ends, or null if the schedule is not in vacation mode.
     */ get vacationEndDate() {
        var _a;
        const timestamp = (_a = this[$j0DIQ.rawDataSymbol].vacation) === null || _a === void 0 ? void 0 : _a.end_time;
        return timestamp ? new Date(timestamp) : null;
    }
};
module.exports.HelixSchedule = $a781ece853f86624$var$HelixSchedule;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $a781ece853f86624$var$HelixSchedule.prototype, "_client", void 0);
module.exports.HelixSchedule = $a781ece853f86624$var$HelixSchedule = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSchedule', 'broadcasterId')
], $a781ece853f86624$var$HelixSchedule);

});


parcelRegister("cEYvo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSearchApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $emmwC = parcelRequire("emmwC");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $3Udy1 = parcelRequire("3Udy1");

var $dFkCq = parcelRequire("dFkCq");
/**
 * The Helix API methods that run searches.
 *
 * Can be accessed using `client.search` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const channels = await api.search.searchChannels('pear');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Search
 */ let $9378278c1fe148a9$var$HelixSearchApi = class HelixSearchApi extends $lq7i7.BaseApi {
    /**
     * Search categories/games for an exact or partial match.
     *
     * @param query The search term.
     * @param pagination
     *
     * @expandParams
     */ async searchCategories(query, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'search/categories',
            query: {
                query: query,
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $3Udy1.HelixGame, this._client);
    }
    /**
     * Creates a paginator for a category/game search.
     *
     * @param query The search term.
     */ searchCategoriesPaginated(query) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'search/categories',
            query: {
                query: query
            }
        }, this._client, (data)=>new $3Udy1.HelixGame(data, this._client));
    }
    /**
     * Search channels for an exact or partial match.
     *
     * @param query The search term.
     * @param filter
     *
     * @expandParams
     */ async searchChannels(query, filter = {}) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'search/channels',
            query: {
                ...(0, $emmwC.createSearchChannelsQuery)(query, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $dFkCq.HelixChannelSearchResult, this._client);
    }
    /**
     * Creates a paginator for a channel search.
     *
     * @param query The search term.
     * @param filter
     *
     * @expandParams
     */ searchChannelsPaginated(query, filter = {}) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'search/channels',
            query: (0, $emmwC.createSearchChannelsQuery)(query, filter)
        }, this._client, (data)=>new $dFkCq.HelixChannelSearchResult(data, this._client));
    }
};
module.exports.HelixSearchApi = $9378278c1fe148a9$var$HelixSearchApi;
module.exports.HelixSearchApi = $9378278c1fe148a9$var$HelixSearchApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSearchApi')
], $9378278c1fe148a9$var$HelixSearchApi);

});
parcelRegister("emmwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSearchChannelsQuery = void 0;
/** @internal */ function $a74497c1937aa287$var$createSearchChannelsQuery(query, filter) {
    var _a;
    return {
        query: query,
        live_only: (_a = filter.liveOnly) === null || _a === void 0 ? void 0 : _a.toString()
    };
}
module.exports.createSearchChannelsQuery = $a74497c1937aa287$var$createSearchChannelsQuery;

});

parcelRegister("dFkCq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixChannelSearchResult = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * The result of a channel search.
 */ let $9f2f192bb757e167$var$HelixChannelSearchResult = class HelixChannelSearchResult extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The language of the channel.
     */ get language() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_language;
    }
    /**
     * The ID of the channel.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the channel.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the channel.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].display_name;
    }
    /**
     * Gets additional information about the owner of the channel.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].id));
    }
    /**
     * The ID of the game currently played on the channel.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * The name of the game currently played on the channel.
     */ get gameName() {
        return this[$j0DIQ.rawDataSymbol].game_name;
    }
    /**
     * Gets information about the game that is being played on the stream.
     */ async getGame() {
        return this[$j0DIQ.rawDataSymbol].game_id ? (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id)) : null;
    }
    /**
     * Whether the channel is currently live.
     */ get isLive() {
        return this[$j0DIQ.rawDataSymbol].is_live;
    }
    /**
     * The tags applied to the channel.
     */ get tags() {
        return this[$j0DIQ.rawDataSymbol].tags;
    }
    /**
     * The thumbnail URL of the stream.
     */ get thumbnailUrl() {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url;
    }
    /**
     * The start date of the stream. Returns `null` if the stream is not live.
     */ get startDate() {
        return this[$j0DIQ.rawDataSymbol].is_live ? new Date(this[$j0DIQ.rawDataSymbol].started_at) : null;
    }
};
module.exports.HelixChannelSearchResult = $9f2f192bb757e167$var$HelixChannelSearchResult;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $9f2f192bb757e167$var$HelixChannelSearchResult.prototype, "_client", void 0);
module.exports.HelixChannelSearchResult = $9f2f192bb757e167$var$HelixChannelSearchResult = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixChannelSearchResult', 'id')
], $9f2f192bb757e167$var$HelixChannelSearchResult);

});


parcelRegister("2I7cV", function(module, exports) {
"use strict";
var $1f95481bbdfb4d5d$var$HelixStreamApi_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixStreamApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $d006L = parcelRequire("d006L");

var $78zDw = parcelRequire("78zDw");

var $56UDi = parcelRequire("56UDi");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $5xSVZ = parcelRequire("5xSVZ");

var $dZaqN = parcelRequire("dZaqN");

var $5iHqo = parcelRequire("5iHqo");
/**
 * The Helix API methods that deal with streams.
 *
 * Can be accessed using `client.streams` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const stream = await api.streams.getStreamByUserId('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Streams
 */ let $1f95481bbdfb4d5d$var$HelixStreamApi = $1f95481bbdfb4d5d$var$HelixStreamApi_1 = class HelixStreamApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getStreamByUserIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'streams'
        }, 'user_id', 'user_id', this._client, (data)=>new $5xSVZ.HelixStream(data, this._client));
        /** @internal */ this._getStreamByUserNameBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'streams'
        }, 'user_login', 'user_login', this._client, (data)=>new $5xSVZ.HelixStream(data, this._client));
    }
    /**
     * Gets a list of streams.
     *
     * @param filter
     * @expandParams
     */ async getStreams(filter = {}) {
        const result = await this._client.callApi({
            url: 'streams',
            type: 'helix',
            query: {
                ...(0, $56UDi.createStreamQuery)(filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $5xSVZ.HelixStream, this._client);
    }
    /**
     * Creates a paginator for streams.
     *
     * @param filter
     * @expandParams
     */ getStreamsPaginated(filter = {}) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'streams',
            query: (0, $56UDi.createStreamQuery)(filter)
        }, this._client, (data)=>new $5xSVZ.HelixStream(data, this._client));
    }
    /**
     * Gets the current streams for the given usernames.
     *
     * @param users The username to get the streams for.
     */ async getStreamsByUserNames(users) {
        const result = await this.getStreams({
            userName: users.map($j0DIQ.extractUserName)
        });
        return result.data;
    }
    /**
     * Gets the current stream for the given username.
     *
     * @param user The username to get the stream for.
     */ async getStreamByUserName(user) {
        var _a;
        const result = await this.getStreamsByUserNames([
            user
        ]);
        return (_a = result[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Gets the current stream for the given username, batching multiple calls into fewer requests as the API allows.
     *
     * @param user The username to get the stream for.
     */ async getStreamByUserNameBatched(user) {
        return await this._getStreamByUserNameBatcher.request((0, $j0DIQ.extractUserName)(user));
    }
    /**
     * Gets the current streams for the given user IDs.
     *
     * @param users The user IDs to get the streams for.
     */ async getStreamsByUserIds(users) {
        const result = await this.getStreams({
            userId: users.map($j0DIQ.extractUserId)
        });
        return result.data;
    }
    /**
     * Gets the current stream for the given user ID.
     *
     * @param user The user ID to get the stream for.
     */ async getStreamByUserId(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            url: 'streams',
            type: 'helix',
            userId: userId,
            query: (0, $56UDi.createStreamQuery)({
                userId: userId
            })
        });
        return (0, $bRvJY.mapNullable)(result.data[0], (data)=>new $5xSVZ.HelixStream(data, this._client));
    }
    /**
     * Gets the current stream for the given user ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param user The user ID to get the stream for.
     */ async getStreamByUserIdBatched(user) {
        return await this._getStreamByUserIdBatcher.request((0, $j0DIQ.extractUserId)(user));
    }
    /**
     * Gets a list of all stream markers for a user.
     *
     * @param user The user to list the stream markers for.
     * @param pagination
     *
     * @expandParams
     */ async getStreamMarkersForUser(user, pagination) {
        var _a;
        const result = await this._client.callApi({
            url: 'streams/markers',
            type: 'helix',
            query: {
                ...(0, $78zDw.createUserQuery)(user),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            },
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:broadcast'
            ],
            canOverrideScopedUserContext: true
        });
        return {
            data: (0, $bRvJY.flatten)(result.data.map((data)=>$1f95481bbdfb4d5d$var$HelixStreamApi_1._mapGetStreamMarkersResult(data, this._client))),
            cursor: (_a = result.pagination) === null || _a === void 0 ? void 0 : _a.cursor
        };
    }
    /**
     * Creates a paginator for all stream markers for a user.
     *
     * @param user The user to list the stream markers for.
     */ getStreamMarkersForUserPaginated(user) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'streams/markers',
            query: (0, $78zDw.createUserQuery)(user),
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:broadcast'
            ],
            canOverrideScopedUserContext: true
        }, this._client, (data)=>$1f95481bbdfb4d5d$var$HelixStreamApi_1._mapGetStreamMarkersResult(data, this._client));
    }
    /**
     * Gets a list of all stream markers for a video.
     *
     * @param user The user the video belongs to.
     * @param videoId The video to list the stream markers for.
     * @param pagination
     *
     * @expandParams
     */ async getStreamMarkersForVideo(user, videoId, pagination) {
        var _a;
        const result = await this._client.callApi({
            url: 'streams/markers',
            type: 'helix',
            query: {
                ...(0, $56UDi.createVideoQuery)(videoId),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            },
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:broadcast'
            ],
            canOverrideScopedUserContext: true
        });
        return {
            data: (0, $bRvJY.flatten)(result.data.map((data)=>$1f95481bbdfb4d5d$var$HelixStreamApi_1._mapGetStreamMarkersResult(data, this._client))),
            cursor: (_a = result.pagination) === null || _a === void 0 ? void 0 : _a.cursor
        };
    }
    /**
     * Creates a paginator for all stream markers for a video.
     *
     * @param user The user the video belongs to.
     * @param videoId The video to list the stream markers for.
     */ getStreamMarkersForVideoPaginated(user, videoId) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'streams/markers',
            query: (0, $56UDi.createVideoQuery)(videoId),
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:broadcast'
            ],
            canOverrideScopedUserContext: true
        }, this._client, (data)=>$1f95481bbdfb4d5d$var$HelixStreamApi_1._mapGetStreamMarkersResult(data, this._client));
    }
    /**
     * Creates a new stream marker.
     *
     * Only works while the specified user's stream is live.
     *
     * @param broadcaster The broadcaster to create a stream marker for.
     * @param description The description of the marker.
     */ async createStreamMarker(broadcaster, description) {
        try {
            const result = await this._client.callApi({
                url: 'streams/markers',
                method: 'POST',
                type: 'helix',
                userId: (0, $j0DIQ.extractUserId)(broadcaster),
                scopes: [
                    'channel:manage:broadcast'
                ],
                canOverrideScopedUserContext: true,
                jsonBody: (0, $56UDi.createStreamMarkerBody)(broadcaster, description)
            });
            return new $dZaqN.HelixStreamMarker(result.data[0], this._client);
        } catch (e) {
            if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 404) throw new $d006L.StreamNotLiveError({
                cause: e
            });
            throw e;
        }
    }
    /**
     * Gets the stream key of a stream.
     *
     * @param broadcaster The broadcaster to get the stream key for.
     */ async getStreamKey(broadcaster) {
        const userId = (0, $j0DIQ.extractUserId)(broadcaster);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'streams/key',
            userId: userId,
            scopes: [
                'channel:read:stream_key'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return result.data[0].stream_key;
    }
    /**
     * Gets the streams that are currently live and are followed by the given user.
     *
     * @param user The user to check followed streams for.
     * @param pagination
     *
     * @expandParams
     */ async getFollowedStreams(user, pagination) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'streams/followed',
            userId: userId,
            scopes: [
                'user:read:follows'
            ],
            query: {
                ...(0, $78zDw.createSingleKeyQuery)('user_id', userId),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $5xSVZ.HelixStream, this._client);
    }
    /**
     * Creates a paginator for the streams that are currently live and are followed by the given user.
     *
     * @param user The user to check followed streams for.
     */ getFollowedStreamsPaginated(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return new $6tEA1.HelixPaginatedRequest({
            url: 'streams/followed',
            userId: userId,
            scopes: [
                'user:read:follows'
            ],
            query: (0, $78zDw.createSingleKeyQuery)('user_id', userId)
        }, this._client, (data)=>new $5xSVZ.HelixStream(data, this._client));
    }
    static _mapGetStreamMarkersResult(data, client) {
        return data.videos.reduce((result, video)=>[
                ...result,
                ...video.markers.map((marker)=>new $5iHqo.HelixStreamMarkerWithVideo(marker, video.video_id, client))
            ], []);
    }
};
module.exports.HelixStreamApi = $1f95481bbdfb4d5d$var$HelixStreamApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $1f95481bbdfb4d5d$var$HelixStreamApi.prototype, "_getStreamByUserIdBatcher", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $1f95481bbdfb4d5d$var$HelixStreamApi.prototype, "_getStreamByUserNameBatcher", void 0);
module.exports.HelixStreamApi = $1f95481bbdfb4d5d$var$HelixStreamApi = $1f95481bbdfb4d5d$var$HelixStreamApi_1 = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixStreamApi')
], $1f95481bbdfb4d5d$var$HelixStreamApi);

});
parcelRegister("d006L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamNotLiveError = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * Thrown whenever you try something that requires your own stream to be live.
 */ class $976b5bea1a7ce682$var$StreamNotLiveError extends $j0DIQ.CustomError {
    /** @private */ constructor(options){
        super('Your stream needs to be live to do this', options);
    }
}
module.exports.StreamNotLiveError = $976b5bea1a7ce682$var$StreamNotLiveError;

});

parcelRegister("56UDi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVideoQuery = module.exports.createStreamMarkerBody = module.exports.createStreamQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $3b89715ee5d2f6ca$var$createStreamQuery(filter) {
    return {
        game_id: filter.game,
        language: filter.language,
        type: filter.type,
        user_id: filter.userId,
        user_login: filter.userName
    };
}
module.exports.createStreamQuery = $3b89715ee5d2f6ca$var$createStreamQuery;
/** @internal */ function $3b89715ee5d2f6ca$var$createStreamMarkerBody(broadcaster, description) {
    return {
        user_id: (0, $j0DIQ.extractUserId)(broadcaster),
        description: description
    };
}
module.exports.createStreamMarkerBody = $3b89715ee5d2f6ca$var$createStreamMarkerBody;
/** @internal */ function $3b89715ee5d2f6ca$var$createVideoQuery(id) {
    return {
        video_id: id
    };
}
module.exports.createVideoQuery = $3b89715ee5d2f6ca$var$createVideoQuery;

});

parcelRegister("5xSVZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixStream = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Twitch stream.
 */ let $409aa5a695104fbb$var$HelixStream = class HelixStream extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The stream ID.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The user ID.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The user's name.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The user's display name.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets information about the user broadcasting the stream.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The game ID, or an empty string if the stream doesn't currently have a game.
     */ get gameId() {
        return this[$j0DIQ.rawDataSymbol].game_id;
    }
    /**
     * The game name, or an empty string if the stream doesn't currently have a game.
     */ get gameName() {
        return this[$j0DIQ.rawDataSymbol].game_name;
    }
    /**
     * Gets information about the game that is being played on the stream.
     *
     * Returns null if the stream doesn't currently have a game.
     */ async getGame() {
        return this[$j0DIQ.rawDataSymbol].game_id ? (0, $j0DIQ.checkRelationAssertion)(await this._client.games.getGameById(this[$j0DIQ.rawDataSymbol].game_id)) : null;
    }
    /**
     * The type of the stream.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The title of the stream.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The number of viewers the stream currently has.
     */ get viewers() {
        return this[$j0DIQ.rawDataSymbol].viewer_count;
    }
    /**
     * The time when the stream started.
     */ get startDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].started_at);
    }
    /**
     * The language of the stream.
     */ get language() {
        return this[$j0DIQ.rawDataSymbol].language;
    }
    /**
     * The URL of the thumbnail of the stream.
     *
     * This URL includes the placeholders `{width}` and `{height}`
     * which you must replace with the desired dimensions of the thumbnail (in pixels).
     *
     * You can also use {@link HelixStream#getThumbnailUrl} to do this replacement.
     */ get thumbnailUrl() {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url;
    }
    /**
     * Builds the thumbnail URL of the stream using the given dimensions.
     *
     * @param width The width of the thumbnail.
     * @param height The height of the thumbnail.
     */ getThumbnailUrl(width, height) {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url.replace('{width}', width.toString()).replace('{height}', height.toString());
    }
    /**
     * The tags applied to the stream.
     */ get tags() {
        return this[$j0DIQ.rawDataSymbol].tags;
    }
    /**
     * Whether the stream is set to be targeted to mature audiences only.
     */ get isMature() {
        return this[$j0DIQ.rawDataSymbol].is_mature;
    }
};
module.exports.HelixStream = $409aa5a695104fbb$var$HelixStream;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $409aa5a695104fbb$var$HelixStream.prototype, "_client", void 0);
module.exports.HelixStream = $409aa5a695104fbb$var$HelixStream = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixStream', 'id')
], $409aa5a695104fbb$var$HelixStream);

});

parcelRegister("dZaqN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixStreamMarker = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A stream marker.
 */ let $a2e9104490875be0$var$HelixStreamMarker = class HelixStreamMarker extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the marker.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The date and time when the marker was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The description of the marker.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
    /**
     * The position in the stream when the marker was created, in seconds.
     */ get positionInSeconds() {
        return this[$j0DIQ.rawDataSymbol].position_seconds;
    }
};
module.exports.HelixStreamMarker = $a2e9104490875be0$var$HelixStreamMarker;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $a2e9104490875be0$var$HelixStreamMarker.prototype, "_client", void 0);
module.exports.HelixStreamMarker = $a2e9104490875be0$var$HelixStreamMarker = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixStreamMarker', 'id')
], $a2e9104490875be0$var$HelixStreamMarker);

});

parcelRegister("5iHqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixStreamMarkerWithVideo = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $dZaqN = parcelRequire("dZaqN");
/**
 * A stream marker, also containing some video data.
 *
 * @inheritDoc
 */ let $3dc0516c36a185c8$var$HelixStreamMarkerWithVideo = class HelixStreamMarkerWithVideo extends $dZaqN.HelixStreamMarker {
    /** @internal */ constructor(data, _videoId, client){
        super(data, client);
        this._videoId = _videoId;
    }
    /**
     * The URL of the video, which will start playing at the position of the stream marker.
     */ get url() {
        return this[$j0DIQ.rawDataSymbol].URL;
    }
    /**
     * The ID of the video.
     */ get videoId() {
        return this._videoId;
    }
    /**
     * Gets the video data of the video the marker was set in.
     */ async getVideo() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.videos.getVideoById(this._videoId));
    }
};
module.exports.HelixStreamMarkerWithVideo = $3dc0516c36a185c8$var$HelixStreamMarkerWithVideo;
module.exports.HelixStreamMarkerWithVideo = $3dc0516c36a185c8$var$HelixStreamMarkerWithVideo = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixStreamMarkerWithVideo', 'id')
], $3dc0516c36a185c8$var$HelixStreamMarkerWithVideo);

});


parcelRegister("ll7Cn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSubscriptionApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $50MeY = parcelRequire("50MeY");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $312bz = parcelRequire("312bz");

var $h2Nny = parcelRequire("h2Nny");

var $8hVFG = parcelRequire("8hVFG");
/**
 * The Helix API methods that deal with subscriptions.
 *
 * Can be accessed using `client.subscriptions` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const subscription = await api.subscriptions.getSubscriptionForUser('61369223', '125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Subscriptions
 */ let $f89177e3149d6690$var$HelixSubscriptionApi = class HelixSubscriptionApi extends $lq7i7.BaseApi {
    /**
     * Gets a list of all subscriptions to a given broadcaster.
     *
     * @param broadcaster The broadcaster to list subscriptions to.
     * @param pagination
     *
     * @expandParams
     */ async getSubscriptions(broadcaster, pagination) {
        const result = await this._client.callApi({
            url: 'subscriptions',
            scopes: [
                'channel:read:subscriptions'
            ],
            type: 'helix',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(broadcaster),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return {
            ...(0, $7rg9J.createPaginatedResultWithTotal)(result, $h2Nny.HelixSubscription, this._client),
            points: result.points
        };
    }
    /**
     * Creates a paginator for all subscriptions to a given broadcaster.
     *
     * @param broadcaster The broadcaster to list subscriptions to.
     */ getSubscriptionsPaginated(broadcaster) {
        return new $312bz.HelixPaginatedSubscriptionsRequest(broadcaster, this._client);
    }
    /**
     * Gets the subset of the given user list that is subscribed to the given broadcaster.
     *
     * @param broadcaster The broadcaster to find subscriptions to.
     * @param users The users that should be checked for subscriptions.
     */ async getSubscriptionsForUsers(broadcaster, users) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'subscriptions',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:read:subscriptions'
            ],
            query: (0, $78zDw.createChannelUsersCheckQuery)(broadcaster, users)
        });
        return result.data.map((data)=>new $h2Nny.HelixSubscription(data, this._client));
    }
    /**
     * Gets the subscription data for a given user to a given broadcaster.
     *
     * This checks with the authorization of a broadcaster.
     * If you only have the authorization of a user, check {@link HelixSubscriptionApi#checkUserSubscription}}.
     *
     * @param broadcaster The broadcaster to check.
     * @param user The user to check.
     */ async getSubscriptionForUser(broadcaster, user) {
        const list = await this.getSubscriptionsForUsers(broadcaster, [
            user
        ]);
        return list.length ? list[0] : null;
    }
    /**
     * Checks if a given user is subscribed to a given broadcaster. Returns null if not subscribed.
     *
     * This checks with the authorization of a user.
     * If you only have the authorization of a broadcaster, check {@link HelixSubscriptionApi#getSubscriptionForUser}}.
     *
     * @param user The user to check.
     * @param broadcaster The broadcaster to check the user's subscription for.
     */ async checkUserSubscription(user, broadcaster) {
        try {
            const result = await this._client.callApi({
                type: 'helix',
                url: 'subscriptions/user',
                userId: (0, $j0DIQ.extractUserId)(user),
                scopes: [
                    'user:read:subscriptions'
                ],
                query: (0, $50MeY.createSubscriptionCheckQuery)(broadcaster, user)
            });
            return new $8hVFG.HelixUserSubscription(result.data[0], this._client);
        } catch (e) {
            if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 404) return null;
            throw e;
        }
    }
};
module.exports.HelixSubscriptionApi = $f89177e3149d6690$var$HelixSubscriptionApi;
module.exports.HelixSubscriptionApi = $f89177e3149d6690$var$HelixSubscriptionApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSubscriptionApi')
], $f89177e3149d6690$var$HelixSubscriptionApi);

});
parcelRegister("50MeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSubscriptionCheckQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $3a625f68c258159c$var$createSubscriptionCheckQuery(broadcaster, user) {
    return {
        broadcaster_id: (0, $j0DIQ.extractUserId)(broadcaster),
        user_id: (0, $j0DIQ.extractUserId)(user)
    };
}
module.exports.createSubscriptionCheckQuery = $3a625f68c258159c$var$createSubscriptionCheckQuery;

});

parcelRegister("312bz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPaginatedSubscriptionsRequest = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $4W0OK = parcelRequire("4W0OK");

var $h2Nny = parcelRequire("h2Nny");
/**
 * A special case of {@link HelixPaginatedRequestWithTotal}
 * with support for fetching the total sub points of a broadcaster.
 *
 * @inheritDoc
 */ let $23232921c406e334$var$HelixPaginatedSubscriptionsRequest = class HelixPaginatedSubscriptionsRequest extends $4W0OK.HelixPaginatedRequestWithTotal {
    /** @internal */ constructor(broadcaster, client){
        super({
            url: 'subscriptions',
            scopes: [
                'channel:read:subscriptions'
            ],
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        }, client, (data)=>new $h2Nny.HelixSubscription(data, client));
    }
    /**
     * Gets the total sub points of the broadcaster.
     */ async getPoints() {
        var _a;
        const data = (_a = this._currentData) !== null && _a !== void 0 ? _a : await this._fetchData({
            query: {
                after: undefined
            }
        });
        return data.points;
    }
};
module.exports.HelixPaginatedSubscriptionsRequest = $23232921c406e334$var$HelixPaginatedSubscriptionsRequest;
module.exports.HelixPaginatedSubscriptionsRequest = $23232921c406e334$var$HelixPaginatedSubscriptionsRequest = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPaginatedSubscriptionsRequest')
], $23232921c406e334$var$HelixPaginatedSubscriptionsRequest);

});
parcelRegister("h2Nny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixSubscription = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $8hVFG = parcelRequire("8hVFG");
/**
 * A (paid) subscription of a user to a broadcaster.
 *
 * @inheritDoc
 */ let $c688ed318f4041e1$var$HelixSubscription = class HelixSubscription extends $8hVFG.HelixUserSubscription {
    /**
     * The user ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id));
    }
    /**
     * The user ID of the gifter.
     */ get gifterId() {
        return this[$j0DIQ.rawDataSymbol].is_gift ? this[$j0DIQ.rawDataSymbol].gifter_id : null;
    }
    /**
     * The name of the gifter.
     */ get gifterName() {
        return this[$j0DIQ.rawDataSymbol].is_gift ? this[$j0DIQ.rawDataSymbol].gifter_login : null;
    }
    /**
     * The display name of the gifter.
     */ get gifterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].is_gift ? this[$j0DIQ.rawDataSymbol].gifter_name : null;
    }
    /**
     * Gets more information about the gifter.
     */ async getGifter() {
        return this[$j0DIQ.rawDataSymbol].is_gift ? (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].gifter_id)) : null;
    }
    /**
     * The user ID of the subscribed user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the subscribed user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the subscribed user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets more information about the subscribed user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixSubscription = $c688ed318f4041e1$var$HelixSubscription;
module.exports.HelixSubscription = $c688ed318f4041e1$var$HelixSubscription = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixSubscription', 'userId')
], $c688ed318f4041e1$var$HelixSubscription);

});
parcelRegister("8hVFG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserSubscription = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * The user info about a (paid) subscription to a broadcaster.
 */ let $018ea7d4e3ae43c5$var$HelixUserSubscription = class HelixUserSubscription extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The user ID of the broadcaster.
     */ get broadcasterId() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_id;
    }
    /**
     * The name of the broadcaster.
     */ get broadcasterName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_login;
    }
    /**
     * The display name of the broadcaster.
     */ get broadcasterDisplayName() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_name;
    }
    /**
     * Gets more information about the broadcaster.
     */ async getBroadcaster() {
        return await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].broadcaster_id);
    }
    /**
     * Whether the subscription has been gifted by another user.
     */ get isGift() {
        return this[$j0DIQ.rawDataSymbol].is_gift;
    }
    /**
     * The tier of the subscription.
     */ get tier() {
        return this[$j0DIQ.rawDataSymbol].tier;
    }
};
module.exports.HelixUserSubscription = $018ea7d4e3ae43c5$var$HelixUserSubscription;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $018ea7d4e3ae43c5$var$HelixUserSubscription.prototype, "_client", void 0);
module.exports.HelixUserSubscription = $018ea7d4e3ae43c5$var$HelixUserSubscription = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserSubscription', 'broadcasterId')
], $018ea7d4e3ae43c5$var$HelixUserSubscription);

});




parcelRegister("8VbMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixTeamApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $lq7i7 = parcelRequire("lq7i7");

var $kgm0V = parcelRequire("kgm0V");

var $8qcK0 = parcelRequire("8qcK0");
/**
 * The Helix API methods that deal with teams.
 *
 * Can be accessed using `client.teams` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const tags = await api.teams.getChannelTeams('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Teams
 */ let $67ecc8d4ed11d043$var$HelixTeamApi = class HelixTeamApi extends $lq7i7.BaseApi {
    /**
     * Gets a list of all teams a broadcaster is a member of.
     *
     * @param broadcaster The broadcaster to get the teams of.
     */ async getTeamsForBroadcaster(broadcaster) {
        var _a, _b;
        const result = await this._client.callApi({
            type: 'helix',
            url: 'teams/channel',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: (0, $4ojlB.createBroadcasterQuery)(broadcaster)
        });
        return (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.map((data)=>new $kgm0V.HelixTeam(data, this._client))) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * Gets a team by ID.
     *
     * Returns null if there is no team with the given ID.
     *
     * @param id The ID of the team.
     */ async getTeamById(id) {
        try {
            const result = await this._client.callApi({
                type: 'helix',
                url: 'teams',
                query: {
                    id: id
                }
            });
            return new $8qcK0.HelixTeamWithUsers(result.data[0], this._client);
        } catch (e) {
            // Twitch, please...
            if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 500) return null;
            throw e;
        }
    }
    /**
     * Gets a team by name.
     *
     * Returns null if there is no team with the given name.
     *
     * @param name The name of the team.
     */ async getTeamByName(name) {
        try {
            const result = await this._client.callApi({
                type: 'helix',
                url: 'teams',
                query: {
                    name: name
                }
            });
            return new $8qcK0.HelixTeamWithUsers(result.data[0], this._client);
        } catch (e) {
            // ...but this one is fine
            if (e instanceof $4ojlB.HttpStatusCodeError && e.statusCode === 404) return null;
            throw e;
        }
    }
};
module.exports.HelixTeamApi = $67ecc8d4ed11d043$var$HelixTeamApi;
module.exports.HelixTeamApi = $67ecc8d4ed11d043$var$HelixTeamApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixTeamApi')
], $67ecc8d4ed11d043$var$HelixTeamApi);

});
parcelRegister("kgm0V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixTeam = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Stream Team.
 */ let $ec0660cad3940232$var$HelixTeam = class HelixTeam extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the team.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the team.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].team_name;
    }
    /**
     * The display name of the team.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].team_display_name;
    }
    /**
     * The URL of the background image of the team.
     */ get backgroundImageUrl() {
        return this[$j0DIQ.rawDataSymbol].background_image_url;
    }
    /**
     * The URL of the banner of the team.
     */ get bannerUrl() {
        return this[$j0DIQ.rawDataSymbol].banner;
    }
    /**
     * The date when the team was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date when the team was last updated.
     */ get updateDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].updated_at);
    }
    /**
     * The info of the team.
     *
     * May contain HTML tags.
     */ get info() {
        return this[$j0DIQ.rawDataSymbol].info;
    }
    /**
     * The URL of the thumbnail of the team's logo.
     */ get logoThumbnailUrl() {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url;
    }
    /**
     * Gets the relations to the members of the team.
     */ async getUserRelations() {
        const teamWithUsers = await this._client.teams.getTeamById(this.id);
        return teamWithUsers.userRelations;
    }
};
module.exports.HelixTeam = $ec0660cad3940232$var$HelixTeam;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $ec0660cad3940232$var$HelixTeam.prototype, "_client", void 0);
module.exports.HelixTeam = $ec0660cad3940232$var$HelixTeam = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixTeam', 'id')
], $ec0660cad3940232$var$HelixTeam);

});

parcelRegister("8qcK0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixTeamWithUsers = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $4yKj5 = parcelRequire("4yKj5");

var $kgm0V = parcelRequire("kgm0V");
/**
 * A Stream Team with its member relations.
 *
 * @inheritDoc
 */ let $621aa28e793f12e8$var$HelixTeamWithUsers = class HelixTeamWithUsers extends $kgm0V.HelixTeam {
    /**
     * The relations to the members of the team.
     */ get userRelations() {
        return this[$j0DIQ.rawDataSymbol].users.map((data)=>new $4yKj5.HelixUserRelation(data, this._client));
    }
};
module.exports.HelixTeamWithUsers = $621aa28e793f12e8$var$HelixTeamWithUsers;
module.exports.HelixTeamWithUsers = $621aa28e793f12e8$var$HelixTeamWithUsers = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixTeamWithUsers', 'id')
], $621aa28e793f12e8$var$HelixTeamWithUsers);

});


parcelRegister("3BqLi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $4ojlB = parcelRequire("4ojlB");

var $j0DIQ = parcelRequire("j0DIQ");

var $78zDw = parcelRequire("78zDw");

var $3FZU6 = parcelRequire("3FZU6");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $79EnW = parcelRequire("79EnW");

var $OaXF4 = parcelRequire("OaXF4");

var $c4KWn = parcelRequire("c4KWn");

var $75xqV = parcelRequire("75xqV");

var $8dBYL = parcelRequire("8dBYL");
/**
 * The Helix API methods that deal with users.
 *
 * Can be accessed using `client.users` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const user = await api.users.getUserById('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Users
 */ let $29f996256d1d7fc7$var$HelixUserApi = class HelixUserApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getUserByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'users'
        }, 'id', 'id', this._client, (data)=>new $75xqV.HelixUser(data, this._client));
        /** @internal */ this._getUserByNameBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'users'
        }, 'login', 'login', this._client, (data)=>new $75xqV.HelixUser(data, this._client));
    }
    /**
     * Gets the user data for the given list of user IDs.
     *
     * @param userIds The user IDs you want to look up.
     */ async getUsersByIds(userIds) {
        return await this._getUsers('id', userIds.map($j0DIQ.extractUserId));
    }
    /**
     * Gets the user data for the given list of usernames.
     *
     * @param userNames The usernames you want to look up.
     */ async getUsersByNames(userNames) {
        return await this._getUsers('login', userNames.map($j0DIQ.extractUserName));
    }
    /**
     * Gets the user data for the given user ID.
     *
     * @param user The user ID you want to look up.
     */ async getUserById(user) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users',
            userId: userId,
            query: {
                id: userId
            }
        });
        return (0, $bRvJY.mapNullable)(result.data[0], (data)=>new $75xqV.HelixUser(data, this._client));
    }
    /**
     * Gets the user data for the given user ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param user The user ID you want to look up.
     */ async getUserByIdBatched(user) {
        return await this._getUserByIdBatcher.request((0, $j0DIQ.extractUserId)(user));
    }
    /**
     * Gets the user data for the given username.
     *
     * @param userName The username you want to look up.
     */ async getUserByName(userName) {
        const users = await this._getUsers('login', [
            (0, $j0DIQ.extractUserName)(userName)
        ]);
        return users.length ? users[0] : null;
    }
    /**
     * Gets the user data for the given username, batching multiple calls into fewer requests as the API allows.
     *
     * @param user The username you want to look up.
     */ async getUserByNameBatched(user) {
        return await this._getUserByNameBatcher.request((0, $j0DIQ.extractUserName)(user));
    }
    /**
     * Gets the user data of the given authenticated user.
     *
     * @param user The user to get data for.
     * @param withEmail Whether you need the user's email address.
     */ async getAuthenticatedUser(user, withEmail = false) {
        var _a;
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users',
            forceType: 'user',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: withEmail ? [
                'user:read:email'
            ] : undefined
        });
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.length)) throw new $j0DIQ.HellFreezesOverError('Could not get authenticated user');
        return new $c4KWn.HelixPrivilegedUser(result.data[0], this._client);
    }
    /**
     * Updates the given authenticated user's data.
     *
     * @param user The user to update.
     * @param data The data to update.
     */ async updateAuthenticatedUser(user, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users',
            method: 'PUT',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:edit'
            ],
            query: {
                description: data.description
            }
        });
        return new $c4KWn.HelixPrivilegedUser(result.data[0], this._client);
    }
    /**
     * Gets a list of users blocked by the given user.
     *
     * @param user The user to get blocks for.
     * @param pagination
     *
     * @expandParams
     */ async getBlocks(user, pagination) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users/blocks',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:blocked_users'
            ],
            query: {
                ...(0, $4ojlB.createBroadcasterQuery)(user),
                ...(0, $4AsKM.createPaginationQuery)(pagination)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $8dBYL.HelixUserBlock, this._client);
    }
    /**
     * Creates a paginator for users blocked by the given user.
     *
     * @param user The user to get blocks for.
     */ getBlocksPaginated(user) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'users/blocks',
            userId: (0, $j0DIQ.extractUserId)(user),
            scopes: [
                'user:read:blocked_users'
            ],
            query: (0, $4ojlB.createBroadcasterQuery)(user)
        }, this._client, (data)=>new $8dBYL.HelixUserBlock(data, this._client));
    }
    /**
     * Blocks the given user.
     *
     * @param broadcaster The user to add the block to.
     * @param target The user to block.
     * @param additionalInfo Additional info to give context to the block.
     *
     * @expandParams
     */ async createBlock(broadcaster, target, additionalInfo = {}) {
        await this._client.callApi({
            type: 'helix',
            url: 'users/blocks',
            method: 'PUT',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'user:manage:blocked_users'
            ],
            query: (0, $3FZU6.createUserBlockCreateQuery)(target, additionalInfo)
        });
    }
    /**
     * Unblocks the given user.
     *
     * @param broadcaster The user to remove the block from.
     * @param target The user to unblock.
     */ async deleteBlock(broadcaster, target) {
        await this._client.callApi({
            type: 'helix',
            url: 'users/blocks',
            method: 'DELETE',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'user:manage:blocked_users'
            ],
            query: (0, $3FZU6.createUserBlockDeleteQuery)(target)
        });
    }
    /**
     * Gets a list of all extensions for the given authenticated user.
     *
     * @param broadcaster The broadcaster to get the list of extensions for.
     * @param withInactive Whether to include inactive extensions.
     */ async getExtensionsForAuthenticatedUser(broadcaster, withInactive = false) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users/extensions/list',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: withInactive ? [
                'channel:manage:extensions'
            ] : [
                'user:read:broadcast',
                'channel:manage:extensions'
            ]
        });
        return result.data.map((data)=>new $OaXF4.HelixUserExtension(data));
    }
    /**
     * Gets a list of all installed extensions for the given user.
     *
     * @param user The user to get the installed extensions for.
     * @param withDev Whether to include extensions that are in development.
     */ async getActiveExtensions(user, withDev = false) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users/extensions',
            userId: userId,
            scopes: withDev ? [
                'user:read:broadcast',
                'channel:manage:extensions'
            ] : undefined,
            query: (0, $78zDw.createSingleKeyQuery)('user_id', userId)
        });
        return new $79EnW.HelixInstalledExtensionList(result.data);
    }
    /**
     * Updates the installed extensions for the given authenticated user.
     *
     * @param broadcaster The user to update the installed extensions for.
     * @param data The extension installation payload.
     *
     * The format is shown on the [Twitch documentation](https://dev.twitch.tv/docs/api/reference#update-user-extensions).
     * Don't use the "data" wrapper though.
     */ async updateActiveExtensionsForAuthenticatedUser(broadcaster, data) {
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users/extensions',
            method: 'PUT',
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            scopes: [
                'channel:manage:extensions'
            ],
            jsonBody: {
                data: data
            }
        });
        return new $79EnW.HelixInstalledExtensionList(result.data);
    }
    async _getUsers(lookupType, param) {
        if (param.length === 0) return [];
        const query = {
            [lookupType]: param
        };
        const result = await this._client.callApi({
            type: 'helix',
            url: 'users',
            query: query
        });
        return result.data.map((userData)=>new $75xqV.HelixUser(userData, this._client));
    }
};
module.exports.HelixUserApi = $29f996256d1d7fc7$var$HelixUserApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $29f996256d1d7fc7$var$HelixUserApi.prototype, "_getUserByIdBatcher", void 0);
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $29f996256d1d7fc7$var$HelixUserApi.prototype, "_getUserByNameBatcher", void 0);
module.exports.HelixUserApi = $29f996256d1d7fc7$var$HelixUserApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserApi')
], $29f996256d1d7fc7$var$HelixUserApi);

});
parcelRegister("3FZU6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUserBlockDeleteQuery = module.exports.createUserBlockCreateQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $2ad5383f9154031e$var$createUserBlockCreateQuery(target, additionalInfo) {
    return {
        target_user_id: (0, $j0DIQ.extractUserId)(target),
        source_context: additionalInfo.sourceContext,
        reason: additionalInfo.reason
    };
}
module.exports.createUserBlockCreateQuery = $2ad5383f9154031e$var$createUserBlockCreateQuery;
/** @internal */ function $2ad5383f9154031e$var$createUserBlockDeleteQuery(target) {
    return {
        target_user_id: (0, $j0DIQ.extractUserId)(target)
    };
}
module.exports.createUserBlockDeleteQuery = $2ad5383f9154031e$var$createUserBlockDeleteQuery;

});

parcelRegister("79EnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixInstalledExtensionList = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $o7FSU = parcelRequire("o7FSU");
/**
 * A list of extensions installed in a channel.
 */ let $5358b3526b71bf4c$var$HelixInstalledExtensionList = class HelixInstalledExtensionList extends $j0DIQ.DataObject {
    getExtensionAtSlot(type, slotId) {
        const data = this[$j0DIQ.rawDataSymbol][type][slotId];
        return data.active ? new $o7FSU.HelixInstalledExtension(type, slotId, data) : null;
    }
    getExtensionsForSlotType(type) {
        return [
            ...Object.entries(this[$j0DIQ.rawDataSymbol][type])
        ].filter((entry)=>entry[1].active).map(([slotId, slotData])=>new $o7FSU.HelixInstalledExtension(type, slotId, slotData));
    }
    getAllExtensions() {
        return [
            ...Object.entries(this[$j0DIQ.rawDataSymbol])
        ].flatMap(([type, typeEntries])=>[
                ...Object.entries(typeEntries)
            ].filter((entry)=>entry[1].active).map(([slotId, slotData])=>new $o7FSU.HelixInstalledExtension(type, slotId, slotData)));
    }
};
module.exports.HelixInstalledExtensionList = $5358b3526b71bf4c$var$HelixInstalledExtensionList;
module.exports.HelixInstalledExtensionList = $5358b3526b71bf4c$var$HelixInstalledExtensionList = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixInstalledExtensionList')
], $5358b3526b71bf4c$var$HelixInstalledExtensionList);

});
parcelRegister("o7FSU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixInstalledExtension = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $7SEhe = parcelRequire("7SEhe");
/**
 * A Twitch Extension that is installed in a slot of a channel.
 *
 * @inheritDoc
 */ let $04883203646a3264$var$HelixInstalledExtension = class HelixInstalledExtension extends $7SEhe.HelixBaseExtension {
    /** @internal */ constructor(slotType, slotId, data){
        super(data);
        this._slotType = slotType;
        this._slotId = slotId;
    }
    /**
     * The type of the slot the extension is in.
     */ get slotType() {
        return this._slotType;
    }
    /**
     * The ID of the slot the extension is in.
     */ get slotId() {
        return this._slotId;
    }
};
module.exports.HelixInstalledExtension = $04883203646a3264$var$HelixInstalledExtension;
module.exports.HelixInstalledExtension = $04883203646a3264$var$HelixInstalledExtension = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixInstalledExtension', 'id')
], $04883203646a3264$var$HelixInstalledExtension);

});
parcelRegister("7SEhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixBaseExtension = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @protected */ class $5bccd1b8dcdb70b9$var$HelixBaseExtension extends $j0DIQ.DataObject {
    /**
     * The ID of the extension.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The version of the extension.
     */ get version() {
        return this[$j0DIQ.rawDataSymbol].version;
    }
    /**
     * The name of the extension.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].name;
    }
}
module.exports.HelixBaseExtension = $5bccd1b8dcdb70b9$var$HelixBaseExtension;

});



parcelRegister("OaXF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserExtension = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $7SEhe = parcelRequire("7SEhe");
/**
 * A Twitch Extension that was installed by a user.
 *
 * @inheritDoc
 */ let $096d2c4f07746dba$var$HelixUserExtension = class HelixUserExtension extends $7SEhe.HelixBaseExtension {
    /**
     * Whether the user has configured the extension to be able to activate it.
     */ get canActivate() {
        return this[$j0DIQ.rawDataSymbol].can_activate;
    }
    /**
     * The available types of the extension.
     */ get types() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
};
module.exports.HelixUserExtension = $096d2c4f07746dba$var$HelixUserExtension;
module.exports.HelixUserExtension = $096d2c4f07746dba$var$HelixUserExtension = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserExtension', 'id')
], $096d2c4f07746dba$var$HelixUserExtension);

});

parcelRegister("c4KWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixPrivilegedUser = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $75xqV = parcelRequire("75xqV");
/**
 * A user you have extended privilges for, i.e. yourself.
 *
 * @inheritDoc
 */ let $8caa4529434f6f42$var$HelixPrivilegedUser = class HelixPrivilegedUser extends $75xqV.HelixUser {
    /**
     * The email address of the user.
     */ get email() {
        return this[$j0DIQ.rawDataSymbol].email;
    }
    /**
     * Changes the description of the user.
     *
     * @param description The new description.
     */ async setDescription(description) {
        return await this._client.users.updateAuthenticatedUser(this, {
            description: description
        });
    }
};
module.exports.HelixPrivilegedUser = $8caa4529434f6f42$var$HelixPrivilegedUser;
module.exports.HelixPrivilegedUser = $8caa4529434f6f42$var$HelixPrivilegedUser = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixPrivilegedUser', 'id')
], $8caa4529434f6f42$var$HelixPrivilegedUser);

});
parcelRegister("75xqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUser = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A Twitch user.
 */ let $5292ef33e31371bf$var$HelixUser = class HelixUser extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the user.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The name of the user.
     */ get name() {
        return this[$j0DIQ.rawDataSymbol].login;
    }
    /**
     * The display name of the user.
     */ get displayName() {
        return this[$j0DIQ.rawDataSymbol].display_name;
    }
    /**
     * The description of the user.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
    /**
     * The type of the user.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The type of the broadcaster.
     */ get broadcasterType() {
        return this[$j0DIQ.rawDataSymbol].broadcaster_type;
    }
    /**
     * The URL of the profile picture of the user.
     */ get profilePictureUrl() {
        return this[$j0DIQ.rawDataSymbol].profile_image_url;
    }
    /**
     * The URL of the offline video placeholder of the user.
     */ get offlinePlaceholderUrl() {
        return this[$j0DIQ.rawDataSymbol].offline_image_url;
    }
    /**
     * The date when the user was created, i.e. when they registered on Twitch.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * Gets the channel's stream data.
     */ async getStream() {
        return await this._client.streams.getStreamByUserId(this);
    }
    /**
     * Gets a list of broadcasters the user follows.
     */ async getFollowedChannels() {
        return await this._client.channels.getFollowedChannels(this);
    }
    /**
     * Gets the follow data of the user to the given broadcaster, or `null` if the user doesn't follow the broadcaster.
     *
     * This requires user authentication.
     * For broadcaster authentication, you can use `getChannelFollower` while switching `this` and the parameter.
     *
     * @param broadcaster The broadcaster to check the follow to.
     */ async getFollowedChannel(broadcaster) {
        var _a;
        const result = await this._client.channels.getFollowedChannels(this, broadcaster);
        return (_a = result.data[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Checks whether the user is following the given broadcaster.
     *
     * This requires user authentication.
     * For broadcaster authentication, you can use `isFollowedBy` while switching `this` and the parameter.
     *
     * @param broadcaster The broadcaster to check the user's follow to.
     */ async follows(broadcaster) {
        return await this.getFollowedChannel(broadcaster) !== null;
    }
    /**
     * Gets a list of users that follow the broadcaster.
     */ async getChannelFollowers() {
        return await this._client.channels.getChannelFollowers(this);
    }
    /**
     * Gets the follow data of the given user to the broadcaster, or `null` if the user doesn't follow the broadcaster.
     *
     * This requires broadcaster authentication.
     * For user authentication, you can use `getFollowedChannel` while switching `this` and the parameter.
     *
     * @param user The user to check the follow from.
     */ async getChannelFollower(user) {
        var _a;
        const result = await this._client.channels.getChannelFollowers(this, user);
        return (_a = result.data[0]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Checks whether the given user is following the broadcaster.
     *
     * This requires broadcaster authentication.
     * For user authentication, you can use `follows` while switching `this` and the parameter.
     *
     * @param user The user to check the broadcaster's follow from.
     */ async isFollowedBy(user) {
        return await this.getChannelFollower(user) !== null;
    }
    /**
     * Gets the subscription data for the user to the given broadcaster, or `null` if the user is not subscribed.
     *
     * This requires user authentication.
     * For broadcaster authentication, you can use `getSubscriber` while switching `this` and the parameter.
     *
     * @param broadcaster The broadcaster you want to get the subscription data for.
     */ async getSubscriptionTo(broadcaster) {
        return await this._client.subscriptions.checkUserSubscription(this, broadcaster);
    }
    /**
     * Checks whether the user is subscribed to the given broadcaster.
     *
     * This requires user authentication.
     * For broadcaster authentication, you can use `hasSubscriber` while switching `this` and the parameter.
     *
     * @param broadcaster The broadcaster you want to check the subscription for.
     */ async isSubscribedTo(broadcaster) {
        return await this.getSubscriptionTo(broadcaster) !== null;
    }
    /**
     * Gets the subscription data for the given user to the broadcaster, or `null` if the user is not subscribed.
     *
     * This requires broadcaster authentication.
     * For user authentication, you can use `getSubscriptionTo` while switching `this` and the parameter.
     *
     * @param user The user you want to get the subscription data for.
     */ async getSubscriber(user) {
        return await this._client.subscriptions.getSubscriptionForUser(this, user);
    }
    /**
     * Checks whether the given user is subscribed to the broadcaster.
     *
     * This requires broadcaster authentication.
     * For user authentication, you can use `isSubscribedTo` while switching `this` and the parameter.
     *
     * @param user The user you want to check the subscription for.
     */ async hasSubscriber(user) {
        return await this.getSubscriber(user) !== null;
    }
};
module.exports.HelixUser = $5292ef33e31371bf$var$HelixUser;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $5292ef33e31371bf$var$HelixUser.prototype, "_client", void 0);
module.exports.HelixUser = $5292ef33e31371bf$var$HelixUser = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUser', 'id')
], $5292ef33e31371bf$var$HelixUser);

});


parcelRegister("8dBYL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixUserBlock = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * An user blocked by a previously given user.
 */ let $5fbcff75c02b4c0a$var$HelixUserBlock = class HelixUserBlock extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the blocked user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the blocked user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the blocked user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].display_name;
    }
    /**
     * Gets additional information about the blocked user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
};
module.exports.HelixUserBlock = $5fbcff75c02b4c0a$var$HelixUserBlock;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $5fbcff75c02b4c0a$var$HelixUserBlock.prototype, "_client", void 0);
module.exports.HelixUserBlock = $5fbcff75c02b4c0a$var$HelixUserBlock = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixUserBlock', 'userId')
], $5fbcff75c02b4c0a$var$HelixUserBlock);

});


parcelRegister("9WAZR", function(module, exports) {
"use strict";
var $73d63aa3a8baea8f$var$HelixVideoApi_1;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixVideoApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");

var $4p0mB = parcelRequire("4p0mB");

var $6tEA1 = parcelRequire("6tEA1");

var $7rg9J = parcelRequire("7rg9J");

var $4AsKM = parcelRequire("4AsKM");

var $lq7i7 = parcelRequire("lq7i7");

var $5N1SI = parcelRequire("5N1SI");
/**
 * The Helix API methods that deal with videos.
 *
 * Can be accessed using `client.videos` on an {@link ApiClient} instance.
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * const { data: videos } = await api.videos.getVideosByUser('125328655');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Videos
 */ let $73d63aa3a8baea8f$var$HelixVideoApi = $73d63aa3a8baea8f$var$HelixVideoApi_1 = class HelixVideoApi extends $lq7i7.BaseApi {
    constructor(){
        super(...arguments);
        /** @internal */ this._getVideoByIdBatcher = new $4p0mB.HelixRequestBatcher({
            url: 'videos'
        }, 'id', 'id', this._client, (data)=>new $5N1SI.HelixVideo(data, this._client));
    }
    /**
     * Gets the video data for the given list of video IDs.
     *
     * @param ids The video IDs you want to look up.
     */ async getVideosByIds(ids) {
        const result = await this._getVideos('id', ids);
        return result.data;
    }
    /**
     * Gets the video data for the given video ID.
     *
     * @param id The video ID you want to look up.
     */ async getVideoById(id) {
        const videos = await this.getVideosByIds([
            id
        ]);
        return videos.length ? videos[0] : null;
    }
    /**
     * Gets the video data for the given video ID, batching multiple calls into fewer requests as the API allows.
     *
     * @param id The video ID you want to look up.
     */ async getVideoByIdBatched(id) {
        return await this._getVideoByIdBatcher.request(id);
    }
    /**
     * Gets the videos of the given user.
     *
     * @param user The user you want to get videos from.
     * @param filter
     *
     * @expandParams
     */ async getVideosByUser(user, filter = {}) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return await this._getVideos('user_id', [
            userId
        ], filter);
    }
    /**
     * Creates a paginator for videos of the given user.
     *
     * @param user The user you want to get videos from.
     * @param filter
     *
     * @expandParams
     */ getVideosByUserPaginated(user, filter = {}) {
        const userId = (0, $j0DIQ.extractUserId)(user);
        return this._getVideosPaginated('user_id', [
            userId
        ], filter);
    }
    /**
     * Gets the videos of the given game.
     *
     * @param gameId The game you want to get videos from.
     * @param filter
     *
     * @expandParams
     */ async getVideosByGame(gameId, filter = {}) {
        return await this._getVideos('game_id', [
            gameId
        ], filter);
    }
    /**
     * Creates a paginator for videos of the given game.
     *
     * @param gameId The game you want to get videos from.
     * @param filter
     *
     * @expandParams
     */ getVideosByGamePaginated(gameId, filter = {}) {
        return this._getVideosPaginated('game_id', [
            gameId
        ], filter);
    }
    /**
     * Deletes videos by its IDs.
     *
     * @param broadcaster The broadcaster to delete the videos for.
     * @param ids The IDs of the videos to delete.
     */ async deleteVideosByIds(broadcaster, ids) {
        await this._client.callApi({
            type: 'helix',
            url: 'videos',
            method: 'DELETE',
            scopes: [
                'channel:manage:videos'
            ],
            userId: (0, $j0DIQ.extractUserId)(broadcaster),
            query: {
                id: ids
            }
        });
    }
    /** @internal */ async _getVideos(filterType, filterValues, filter = {}) {
        if (!filterValues.length) return {
            data: []
        };
        const result = await this._client.callApi({
            type: 'helix',
            url: 'videos',
            userId: filterType === 'user_id' ? filterValues[0] : undefined,
            query: {
                ...$73d63aa3a8baea8f$var$HelixVideoApi_1._makeVideosQuery(filterType, filterValues, filter),
                ...(0, $4AsKM.createPaginationQuery)(filter)
            }
        });
        return (0, $7rg9J.createPaginatedResult)(result, $5N1SI.HelixVideo, this._client);
    }
    /** @internal */ _getVideosPaginated(filterType, filterValues, filter = {}) {
        return new $6tEA1.HelixPaginatedRequest({
            url: 'videos',
            userId: filterType === 'user_id' ? filterValues[0] : undefined,
            query: $73d63aa3a8baea8f$var$HelixVideoApi_1._makeVideosQuery(filterType, filterValues, filter)
        }, this._client, (data)=>new $5N1SI.HelixVideo(data, this._client));
    }
    /** @internal */ static _makeVideosQuery(filterType, filterValues, filter = {}) {
        const { language: language, period: period, orderBy: orderBy, type: type } = filter;
        return {
            [filterType]: filterValues,
            language: language,
            period: period,
            sort: orderBy,
            type: type
        };
    }
};
module.exports.HelixVideoApi = $73d63aa3a8baea8f$var$HelixVideoApi;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $73d63aa3a8baea8f$var$HelixVideoApi.prototype, "_getVideoByIdBatcher", void 0);
module.exports.HelixVideoApi = $73d63aa3a8baea8f$var$HelixVideoApi = $73d63aa3a8baea8f$var$HelixVideoApi_1 = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixVideoApi')
], $73d63aa3a8baea8f$var$HelixVideoApi);

});
parcelRegister("5N1SI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixVideo = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $cKhNr = parcelRequire("cKhNr");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A video on Twitch.
 */ let $4372fd000bc1a1e7$var$HelixVideo = class HelixVideo extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The ID of the video.
     */ get id() {
        return this[$j0DIQ.rawDataSymbol].id;
    }
    /**
     * The ID of the user who created the video.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].user_id;
    }
    /**
     * The name of the user who created the video.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].user_login;
    }
    /**
     * The display name of the user who created the video.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].user_name;
    }
    /**
     * Gets information about the user who created the video.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].user_id));
    }
    /**
     * The title of the video.
     */ get title() {
        return this[$j0DIQ.rawDataSymbol].title;
    }
    /**
     * The description of the video.
     */ get description() {
        return this[$j0DIQ.rawDataSymbol].description;
    }
    /**
     * The date when the video was created.
     */ get creationDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].created_at);
    }
    /**
     * The date when the video was published.
     */ get publishDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].published_at);
    }
    /**
     * The URL of the video.
     */ get url() {
        return this[$j0DIQ.rawDataSymbol].url;
    }
    /**
     * The URL of the thumbnail of the video.
     */ get thumbnailUrl() {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url;
    }
    /**
     * Builds the thumbnail URL of the video using the given dimensions.
     *
     * @param width The width of the thumbnail.
     * @param height The height of the thumbnail.
     */ getThumbnailUrl(width, height) {
        return this[$j0DIQ.rawDataSymbol].thumbnail_url.replace('%{width}', width.toString()).replace('%{height}', height.toString());
    }
    /**
     * Whether the video is public or not.
     */ get isPublic() {
        return this[$j0DIQ.rawDataSymbol].viewable === 'public';
    }
    /**
     * The number of views of the video.
     */ get views() {
        return this[$j0DIQ.rawDataSymbol].view_count;
    }
    /**
     * The language of the video.
     */ get language() {
        return this[$j0DIQ.rawDataSymbol].language;
    }
    /**
     * The type of the video.
     */ get type() {
        return this[$j0DIQ.rawDataSymbol].type;
    }
    /**
     * The duration of the video, as formatted by Twitch.
     */ get duration() {
        return this[$j0DIQ.rawDataSymbol].duration;
    }
    /**
     * The duration of the video, in seconds.
     */ get durationInSeconds() {
        const parts = this[$j0DIQ.rawDataSymbol].duration.match(/\d+[hms]/g);
        if (!parts) throw new $j0DIQ.HellFreezesOverError(`Could not parse duration string: ${this[$j0DIQ.rawDataSymbol].duration}`);
        return parts.map((part)=>{
            const partialMatch = /(\d+)([hms])/.exec(part);
            if (!partialMatch) throw new $j0DIQ.HellFreezesOverError(`Could not parse partial duration string: ${part}`);
            const [, num, unit] = partialMatch;
            return parseInt(num, 10) * ({
                h: 3600,
                m: 60,
                s: 1
            })[unit];
        }).reduce((a, b)=>a + b);
    }
    /**
     * The ID of the stream this video belongs to.
     *
     * Returns null if the video is not an archived stream.
     */ get streamId() {
        return this[$j0DIQ.rawDataSymbol].stream_id;
    }
    /**
     * The raw data of muted segments of the video.
     */ get mutedSegmentData() {
        var _a, _b;
        return (_b = (_a = this[$j0DIQ.rawDataSymbol].muted_segments) === null || _a === void 0 ? void 0 : _a.slice()) !== null && _b !== void 0 ? _b : [];
    }
    /**
     * Checks whether the video is muted at a given offset or range.
     *
     * @param offset The start of your range, in seconds from the start of the video,
     * or if no duration is given, the exact offset that is checked.
     * @param duration The duration of your range, in seconds.
     * @param partial Whether the range check is only partial.
     *
     * By default, this function returns true only if the passed range is entirely contained in a muted segment.
     */ isMutedAt(offset, duration, partial = false) {
        if (this[$j0DIQ.rawDataSymbol].muted_segments === null) return false;
        if (duration == null) return this[$j0DIQ.rawDataSymbol].muted_segments.some((seg)=>seg.offset <= offset && offset <= seg.offset + seg.duration);
        const end = offset + duration;
        if (partial) return this[$j0DIQ.rawDataSymbol].muted_segments.some((seg)=>{
            const segEnd = seg.offset + seg.duration;
            return offset < segEnd && seg.offset < end;
        });
        return this[$j0DIQ.rawDataSymbol].muted_segments.some((seg)=>{
            const segEnd = seg.offset + seg.duration;
            return seg.offset <= offset && end <= segEnd;
        });
    }
};
module.exports.HelixVideo = $4372fd000bc1a1e7$var$HelixVideo;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $4372fd000bc1a1e7$var$HelixVideo.prototype, "_client", void 0);
$ceFTv.__decorate([
    (0, $cKhNr.CachedGetter)()
], $4372fd000bc1a1e7$var$HelixVideo.prototype, "durationInSeconds", null);
module.exports.HelixVideo = $4372fd000bc1a1e7$var$HelixVideo = $ceFTv.__decorate([
    $cKhNr.Cacheable,
    (0, $j0DIQ.rtfm)('api', 'HelixVideo', 'id')
], $4372fd000bc1a1e7$var$HelixVideo);

});


parcelRegister("9ZuV6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixWhisperApi = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $6EsCN = parcelRequire("6EsCN");

var $lq7i7 = parcelRequire("lq7i7");
/**
 * The API methods that deal with whispers.
 *
 * Can be accessed using 'client.whispers' on an {@link ApiClient} instance
 *
 * ## Example
 * ```ts
 * const api = new ApiClient({ authProvider });
 * await api.whispers.sendWhisper('61369223', '86753099', 'Howdy, partner!');
 * ```
 *
 * @meta category helix
 * @meta categorizedTitle Whispers
 */ let $7461cb9d54247962$var$HelixWhisperApi = class HelixWhisperApi extends $lq7i7.BaseApi {
    /**
     * Sends a whisper message to the specified user.
     *
     * NOTE: The API may silently drop whispers that it suspects of violating Twitch policies. (The API does not indicate that it dropped the whisper; it returns a 204 status code as if it succeeded).
     *
     * @param from The user sending the whisper. This user must have a verified phone number and must match the user in the access token.
     * @param to The user to receive the whisper.
     * @param message The whisper message to send. The message must not be empty.
     *
     * The maximum message lengths are:
     *
     * 500 characters if the user you're sending the message to hasn't whispered you before.
     * 10,000 characters if the user you're sending the message to has whispered you before.
     *
     * Messages that exceed the maximum length are truncated.
     */ async sendWhisper(from, to, message) {
        await this._client.callApi({
            type: 'helix',
            url: 'whispers',
            method: 'POST',
            userId: (0, $j0DIQ.extractUserId)(from),
            scopes: [
                'user:manage:whispers'
            ],
            query: (0, $6EsCN.createWhisperQuery)(from, to),
            jsonBody: {
                message: message
            }
        });
    }
};
module.exports.HelixWhisperApi = $7461cb9d54247962$var$HelixWhisperApi;
module.exports.HelixWhisperApi = $7461cb9d54247962$var$HelixWhisperApi = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixWhisperApi')
], $7461cb9d54247962$var$HelixWhisperApi);

});
parcelRegister("6EsCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createWhisperQuery = void 0;

var $j0DIQ = parcelRequire("j0DIQ");
/** @internal */ function $4d7caecb9ca55774$var$createWhisperQuery(from, to) {
    return {
        from_user_id: (0, $j0DIQ.extractUserId)(from),
        to_user_id: (0, $j0DIQ.extractUserId)(to)
    };
}
module.exports.createWhisperQuery = $4d7caecb9ca55774$var$createWhisperQuery;

});


parcelRegister("ghlvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApiReportedRequest = void 0;
/**
 * Reporting details for an API request.
 */ class $bd9eeb1bb03e0c91$var$ApiReportedRequest {
    /** @internal */ constructor(_options, _httpStatus, _resolvedUserId){
        this._options = _options;
        this._httpStatus = _httpStatus;
        this._resolvedUserId = _resolvedUserId;
    }
    /**
     * The options used to call the API.
     */ get options() {
        return this._options;
    }
    /**
     * The HTTP status code returned by Twitch for the request.
     */ get httpStatus() {
        return this._httpStatus;
    }
    /**
     * The ID of the user that was used for authentication, or `null` if an app access token was used.
     */ get resolvedUserId() {
        return this._resolvedUserId;
    }
}
module.exports.ApiReportedRequest = $bd9eeb1bb03e0c91$var$ApiReportedRequest;

});


parcelRegister("e3Lkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoContextApiClient = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $81oS5 = parcelRequire("81oS5");
/** @private */ let $a3c60ede444939b9$var$NoContextApiClient = class NoContextApiClient extends $81oS5.BaseApiClient {
    /** @internal */ _getUserIdFromRequestContext() {
        return null;
    }
};
module.exports.NoContextApiClient = $a3c60ede444939b9$var$NoContextApiClient;
module.exports.NoContextApiClient = $a3c60ede444939b9$var$NoContextApiClient = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'ApiClient')
], $a3c60ede444939b9$var$NoContextApiClient);

});

parcelRegister("5mUg4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UserContextApiClient = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $j0DIQ = parcelRequire("j0DIQ");

var $81oS5 = parcelRequire("81oS5");
/** @private */ let $3e8aa5818dde9c7e$var$UserContextApiClient = class UserContextApiClient extends $81oS5.BaseApiClient {
    /** @internal */ constructor(config, logger, rateLimiter, _userId){
        super(config, logger, rateLimiter);
        this._userId = _userId;
    }
    /** @internal */ _getUserIdFromRequestContext() {
        return this._userId;
    }
};
module.exports.UserContextApiClient = $3e8aa5818dde9c7e$var$UserContextApiClient;
module.exports.UserContextApiClient = $3e8aa5818dde9c7e$var$UserContextApiClient = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'ApiClient')
], $3e8aa5818dde9c7e$var$UserContextApiClient);

});


parcelRegister("jXzvX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixFollow = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $bRvJY = parcelRequire("bRvJY");

var $j0DIQ = parcelRequire("j0DIQ");
/**
 * A relation of a user following a broadcaster.
 */ let $e87f136a37240e93$var$HelixFollow = class HelixFollow extends $j0DIQ.DataObject {
    /** @internal */ constructor(data, client){
        super(data);
        this._client = client;
    }
    /**
     * The user ID of the following user.
     */ get userId() {
        return this[$j0DIQ.rawDataSymbol].from_id;
    }
    /**
     * The name of the following user.
     */ get userName() {
        return this[$j0DIQ.rawDataSymbol].from_login;
    }
    /**
     * The display name of the following user.
     */ get userDisplayName() {
        return this[$j0DIQ.rawDataSymbol].from_name;
    }
    /**
     * Gets the data of the following user.
     */ async getUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].from_id));
    }
    /**
     * The user ID of the followed broadcaster.
     */ get followedUserId() {
        return this[$j0DIQ.rawDataSymbol].to_id;
    }
    /**
     * The name of the followed user.
     */ get followedUserName() {
        return this[$j0DIQ.rawDataSymbol].to_login;
    }
    /**
     * The display name of the followed user.
     */ get followedUserDisplayName() {
        return this[$j0DIQ.rawDataSymbol].to_name;
    }
    /**
     * Gets the data of the followed broadcaster.
     */ async getFollowedUser() {
        return (0, $j0DIQ.checkRelationAssertion)(await this._client.users.getUserById(this[$j0DIQ.rawDataSymbol].to_id));
    }
    /**
     * The date when the user followed the broadcaster.
     */ get followDate() {
        return new Date(this[$j0DIQ.rawDataSymbol].followed_at);
    }
};
module.exports.HelixFollow = $e87f136a37240e93$var$HelixFollow;
$ceFTv.__decorate([
    (0, $bRvJY.Enumerable)(false)
], $e87f136a37240e93$var$HelixFollow.prototype, "_client", void 0);
module.exports.HelixFollow = $e87f136a37240e93$var$HelixFollow = $ceFTv.__decorate([
    (0, $j0DIQ.rtfm)('api', 'HelixFollow')
], $e87f136a37240e93$var$HelixFollow);

});


parcelRegister("6ZSkA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwitchBotChannelActionType = module.exports.TwitchStreamOnlineType = module.exports.TwitchStreamEventType = void 0;
module.exports.isStreamOnlineEvent = $01508eccd53250e7$var$isStreamOnlineEvent;
module.exports.isChannelUpdateEvent = $01508eccd53250e7$var$isChannelUpdateEvent;
module.exports.isStreamOfflineEvent = $01508eccd53250e7$var$isStreamOfflineEvent;
var $01508eccd53250e7$var$TwitchStreamEventType;
(function(TwitchStreamEventType) {
    TwitchStreamEventType["STREAM_ONLINE"] = "stream.online";
    TwitchStreamEventType["CHANNEL_UPDATE"] = "channel.update";
    TwitchStreamEventType["STREAM_OFFLINE"] = "stream.offline";
})($01508eccd53250e7$var$TwitchStreamEventType || (module.exports.TwitchStreamEventType = $01508eccd53250e7$var$TwitchStreamEventType = {}));
var $01508eccd53250e7$var$TwitchStreamOnlineType;
(function(TwitchStreamOnlineType) {
    TwitchStreamOnlineType["LIVE"] = "live";
    TwitchStreamOnlineType["PLAYLIST"] = "playlist";
    TwitchStreamOnlineType["WATCH_PARTY"] = "watch_party";
    TwitchStreamOnlineType["PREMIERE"] = "premiere";
    TwitchStreamOnlineType["RERUN"] = "rerun";
})($01508eccd53250e7$var$TwitchStreamOnlineType || (module.exports.TwitchStreamOnlineType = $01508eccd53250e7$var$TwitchStreamOnlineType = {}));
var $01508eccd53250e7$var$TwitchBotChannelActionType;
(function(TwitchBotChannelActionType) {
    TwitchBotChannelActionType["JOIN"] = "join";
    TwitchBotChannelActionType["LEAVE"] = "leave";
    TwitchBotChannelActionType["CONFIG_UPDATED"] = "configUpdated";
})($01508eccd53250e7$var$TwitchBotChannelActionType || (module.exports.TwitchBotChannelActionType = $01508eccd53250e7$var$TwitchBotChannelActionType = {}));
// Type guard functions
function $01508eccd53250e7$var$isStreamOnlineEvent(event) {
    return typeof event === "object" && event !== null && "started_at" in event;
}
function $01508eccd53250e7$var$isChannelUpdateEvent(event) {
    return typeof event === "object" && event !== null && "title" in event && "category_name" in event;
}
function $01508eccd53250e7$var$isStreamOfflineEvent(event) {
    return typeof event === "object" && event !== null && "broadcaster_user_id" in event && !("started_at" in event) && !("title" in event);
}

});


parcelRegister("g84pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommandRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for bot command management
 * Handles all operations related to bot commands
 */ class $bbe0d050436facac$var$CommandRoutes extends $8qngW.ApiBase {
    /**
     * Get all commands from the API
     * @returns Promise resolving to array of commands
     * @throws Error if the API request fails
     */ async getCommands() {
        return this.apiGet($1Su43.ROUTES.COMMANDS);
    }
    /**
     * Create a new bot command
     * @param command - The command data to create (partial Command object)
     * @returns Promise resolving when command creation is complete
     * @throws Error if the API request fails or user is not authenticated
     */ async createCommand(command) {
        return this.apiPost($1Su43.ROUTES.COMMANDS, command);
    }
    /**
     * Update an existing bot command
     * @param command - The command object with updates (must include _id)
     * @returns Promise resolving when command update is complete
     * @throws Error if the API request fails or user is not authenticated
     */ async updateCommand(command) {
        return this.apiPatch(`${$1Su43.ROUTES.COMMANDS}/${command._id}`, command);
    }
    /**
     * Delete an existing bot command
     * @param command - The command object to delete
     * @returns Promise resolving when command deletion is complete
     * @throws Error if the API request fails or user is not authenticated
     */ async deleteCommand(command) {
        return this.apiDelete(`${$1Su43.ROUTES.COMMANDS}/${command._id}`, command);
    }
    /**
     * Find a specific bot command by name
     * @param query - The command search request containing command name
     * @returns Promise resolving to the found command data (if any)
     * @throws Error if the API request fails or service is not authenticated
     */ async findCommand(query) {
        return this.apiPost(`${$1Su43.ROUTES.COMMANDS}/find`, {
            command: query
        });
    }
    /**
     * Log usage of a bot command for analytics and monitoring
     * @param logData - The command usage log data including user, channel, and platform info
     * @returns Promise resolving when the log is recorded
     * @throws Error if the API request fails or service is not authenticated
     */ async logCommandUsage(logData) {
        return this.apiPost(`${$1Su43.ROUTES.COMMANDS}/logs`, logData);
    }
    /**
     * Get a specific bot command by its unique ID
     * @param commandId - The unique identifier of the command to retrieve
     * @returns Promise resolving to the command data
     * @throws Error if the API request fails or command is not found
     */ async getCommandById(commandId) {
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/${commandId}`);
    }
    /**
     * Delete a specific bot command by its unique ID
     * @param commandId - The unique identifier of the command to delete
     * @returns Promise resolving when command deletion is complete
     * @throws Error if the API request fails or command is not found
     */ async deleteCommandById(commandId) {
        return this.apiDelete(`${$1Su43.ROUTES.COMMANDS}/${commandId}`);
    }
    // ======== STATS METHODS ========
    /**
     * Get command statistics overview
     * @param timeRange - Optional time range filter (24h, 7d, 30d, 90d, all)
     * @returns Promise resolving to command statistics overview
     * @throws Error if the API request fails or user is not admin
     */ async getCommandStatsOverview(timeRange) {
        const params = timeRange ? `?timeRange=${timeRange}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/overview${params}`);
    }
    /**
     * Get top commands by usage
     * @param limit - Maximum number of commands to return (default: 10)
     * @param timeRange - Optional time range filter (24h, 7d, 30d, 90d, all)
     * @returns Promise resolving to array of top commands with usage counts
     * @throws Error if the API request fails or user is not admin
     */ async getTopCommands(limit, timeRange) {
        const params = new URLSearchParams();
        if (limit) params.append("limit", limit.toString());
        if (timeRange) params.append("timeRange", timeRange);
        const query = params.toString() ? `?${params.toString()}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/top-commands${query}`);
    }
    /**
     * Get platform breakdown statistics
     * @param timeRange - Optional time range filter (24h, 7d, 30d, 90d, all)
     * @returns Promise resolving to platform breakdown data
     * @throws Error if the API request fails or user is not admin
     */ async getPlatformBreakdown(timeRange) {
        const params = timeRange ? `?timeRange=${timeRange}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/platform-breakdown${params}`);
    }
    /**
     * Get top users by command usage
     * @param limit - Maximum number of users to return (default: 10)
     * @param timeRange - Optional time range filter (24h, 7d, 30d, 90d, all)
     * @returns Promise resolving to array of top users
     * @throws Error if the API request fails or user is not admin
     */ async getTopUsers(limit, timeRange) {
        const params = new URLSearchParams();
        if (limit) params.append("limit", limit.toString());
        if (timeRange) params.append("timeRange", timeRange);
        const query = params.toString() ? `?${params.toString()}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/top-users${query}`);
    }
    /**
     * Get command usage timeline
     * @param timeRange - Time range for the timeline (24h, 7d, 30d, 90d, all)
     * @param interval - Interval for grouping (hour, day)
     * @returns Promise resolving to timeline data
     * @throws Error if the API request fails or user is not admin
     */ async getCommandTimeline(timeRange, interval) {
        const params = new URLSearchParams();
        if (timeRange) params.append("timeRange", timeRange);
        if (interval) params.append("interval", interval);
        const query = params.toString() ? `?${params.toString()}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/timeline${query}`);
    }
    /**
     * Get recent command logs
     * @param page - Page number for pagination (default: 1)
     * @param limit - Number of items per page (default: 20)
     * @returns Promise resolving to recent command logs with pagination
     * @throws Error if the API request fails or user is not admin
     */ async getRecentCommands(page, limit) {
        const params = new URLSearchParams();
        if (page) params.append("page", page.toString());
        if (limit) params.append("limit", limit.toString());
        const query = params.toString() ? `?${params.toString()}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/recent${query}`);
    }
    /**
     * Get top channels/guilds by command usage
     * @param limit - Maximum number of channels to return (default: 10)
     * @param timeRange - Optional time range filter (24h, 7d, 30d, 90d, all)
     * @param platform - Optional platform filter ('discord', 'twitch', or undefined for both)
     * @returns Promise resolving to array of top channels with usage counts
     * @throws Error if the API request fails or user is not admin
     */ async getTopChannels(limit, timeRange, platform) {
        const params = new URLSearchParams();
        if (limit) params.append("limit", limit.toString());
        if (timeRange) params.append("timeRange", timeRange);
        if (platform) params.append("platform", platform);
        const query = params.toString() ? `?${params.toString()}` : "";
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/stats/top-channels${query}`);
    }
    /**
     * Get all unique tags currently in use
     * @returns Promise resolving to array of tag names
     * @throws Error if the API request fails
     */ async getTags() {
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/tags`);
    }
    /**
     * Get tag usage statistics
     * @returns Promise resolving to array of tag stats with counts
     * @throws Error if the API request fails
     */ async getTagStats() {
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/tags/stats`);
    }
    /**
     * Get count of commands without tags
     * @returns Promise resolving to untagged command count
     * @throws Error if the API request fails
     */ async getUntaggedCount() {
        return this.apiGet(`${$1Su43.ROUTES.COMMANDS}/untagged-count`);
    }
}
module.exports.CommandRoutes = $bbe0d050436facac$var$CommandRoutes;

});
parcelRegister("8qngW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApiBase = void 0;

var $i96EK = parcelRequire("i96EK");
/**
 * Base class providing common API functionality and helper methods
 * for all route-specific API classes
 */ class $6222cdd415a86a5b$var$ApiBase {
    api;
    constructor(api){
        this.api = api;
    }
    /**
     * Helper function to handle API responses that return data
     * @param response - The axios response object
     * @returns The data from the response
     * @throws Error if the response indicates an error
     */ handleDataResponse(response) {
        if (response.data.result === $i96EK.ApiResult.ERROR) throw new Error(response.data.message || "API request failed");
        if (response.data.result === $i96EK.ApiResult.SUCCESS && response.data.data !== undefined) return response.data.data;
        // Handle NOOP or SUCCESS without data - should not happen for data responses
        throw new Error(response.data.message || "No data returned from API");
    }
    /**
     * Helper function to handle API responses that return void
     * @param response - The axios response object
     * @throws Error if the response indicates an error
     */ handleVoidResponse(response) {
        if (response.data.result === $i96EK.ApiResult.ERROR) throw new Error(response.data.message || "API request failed");
    // SUCCESS and NOOP are both treated as success for void operations
    }
    /**
     * Helper function to execute GET requests
     * @param endpoint - The API endpoint to call
     * @returns Promise with the data from the response
     */ async apiGet(endpoint) {
        const response = await this.api.get(endpoint);
        return this.handleDataResponse(response);
    }
    /**
     * Helper function to execute POST requests
     * @param endpoint - The API endpoint to call
     * @param data - The data to send in the request body
     * @returns Promise with the data from the response or void
     */ async apiPost(endpoint, data) {
        const response = await this.api.post(endpoint, data);
        return this.handleResponse(response);
    }
    /**
     * Helper function to execute PATCH requests
     * @param endpoint - The API endpoint to call
     * @param data - The data to send in the request body
     * @returns Promise with the data from the response or void
     */ async apiPatch(endpoint, data) {
        const response = await this.api.patch(endpoint, data);
        return this.handleResponse(response);
    }
    /**
     * Helper function to execute DELETE requests
     * @param endpoint - The API endpoint to call
     * @param data - Optional data to send in the request body
     * @returns Promise with void
     */ async apiDelete(endpoint, data) {
        const response = await this.api.delete(endpoint, data ? {
            data: data
        } : undefined);
        return this.handleResponse(response);
    }
    /**
     * Generic response handler that works for both data and void responses
     * @param response - The axios response object
     * @returns The data from the response or void
     */ handleResponse(response) {
        if (response.data.result === $i96EK.ApiResult.ERROR) throw new Error(response.data.message || "API request failed");
        if (response.data.result === $i96EK.ApiResult.SUCCESS) return response.data.data;
        // NOOP is treated as success
        return response.data.data;
    }
}
module.exports.ApiBase = $6222cdd415a86a5b$var$ApiBase;

});
parcelRegister("i96EK", function(module, exports) {
"use strict";
/**
 * @helpasaur/types
 * Shared type definitions for the Helpasaur King application
 */ var $d35e3b0c02ad100f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d35e3b0c02ad100f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d35e3b0c02ad100f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d35e3b0c02ad100f$var$__exportStar((parcelRequire("2YKs8")), module.exports);

$d35e3b0c02ad100f$var$__exportStar((parcelRequire("jAGMp")), module.exports);

});


parcelRegister("1Su43", function(module, exports) {
"use strict";
/**
 * API Route Constants
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ROUTES = module.exports.API_BASE = void 0;
module.exports.API_BASE = "/api";
module.exports.ROUTES = {
    AUTH: `/auth`,
    COMMANDS: `${module.exports.API_BASE}/commands`,
    CONFIGS: `${module.exports.API_BASE}/configs`,
    DISCORD: `${module.exports.API_BASE}/discord`,
    ME: `${module.exports.API_BASE}/me`,
    PRAC: `${module.exports.API_BASE}/prac`,
    STREAM_ALERTS: `${module.exports.API_BASE}/streamAlerts`,
    STREAMS: `${module.exports.API_BASE}/streams`,
    TEST_EVENTS: `${module.exports.API_BASE}/testEvents`,
    TWITCH: `${module.exports.API_BASE}/twitch`,
    WEB: `${module.exports.API_BASE}/web`
};

});


parcelRegister("lyp8m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigsRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for Configs
 */ class $fb1044ffb08ceaa9$var$ConfigsRoutes extends $8qngW.ApiBase {
    /**
     * Get list of active Twitch bot channels from service configuration
     * @returns Promise resolving to array of active channels
     * @throws Error if the API request fails or service is not authenticated
     */ async getActiveTwitchBotChannels() {
        return this.apiGet(`${$1Su43.ROUTES.CONFIGS}/twitch/activeChannels`);
    }
}
module.exports.ConfigsRoutes = $fb1044ffb08ceaa9$var$ConfigsRoutes;

});

parcelRegister("2yxqp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscordRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for Discord bot management
 * Handles all operations related to Discord functionality
 */ class $1dc8af432e82e2ef$var$DiscordRoutes extends $8qngW.ApiBase {
    /**
     * Get Discord server join URL from the API
     * @returns Promise resolving to Discord join URL data
     * @throws Error if the API request fails
     */ async getDiscordJoinUrl() {
        return this.apiGet(`${$1Su43.ROUTES.DISCORD}/joinUrl`);
    }
    /**
     * Create Discord guild configuration for a new server
     * @param guildConfig - The guild configuration data to create
     * @returns Promise resolving to the created guild config
     * @throws Error if the API request fails or service is not authenticated
     */ async createGuildConfig(guildConfig) {
        return this.apiPost(`${$1Su43.ROUTES.DISCORD}/guild`, guildConfig);
    }
    /**
     * Update Discord guild configuration settings
     * @param guildId - The Discord guild ID to update
     * @param updates - The configuration updates to apply
     * @returns Promise resolving to the updated guild config
     * @throws Error if the API request fails or service is not authenticated
     */ async updateGuildConfig(guildId, updates) {
        return this.apiPatch(`${$1Su43.ROUTES.DISCORD}/guild/${guildId}`, updates);
    }
}
module.exports.DiscordRoutes = $1dc8af432e82e2ef$var$DiscordRoutes;

});

parcelRegister("jxgeY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MeRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for user management
 * Handles current user information and authentication
 */ class $e38db26a3148fe70$var$MeRoutes extends $8qngW.ApiBase {
    /**
     * Get current authenticated user information
     * @returns Promise resolving to current user data
     * @throws Error if the API request fails or user is not authenticated
     */ async getCurrentUser() {
        return this.apiGet($1Su43.ROUTES.ME);
    }
    /**
     * Get current user's Twitch bot configuration
     * @returns Promise resolving to user's Twitch bot config
     * @throws Error if the API request fails or user is not authenticated
     */ async getTwitchBotConfig() {
        return this.apiGet(`${$1Su43.ROUTES.ME}/twitch`);
    }
}
module.exports.MeRoutes = $e38db26a3148fe70$var$MeRoutes;

});

parcelRegister("7TguA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PracRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for practice list management
 * Handles user practice lists for speedrunning practice rooms and other lists
 */ class $5bea767aa56e0cad$var$PracRoutes extends $8qngW.ApiBase {
    /**
     * Add an entry to a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to modify
     * @param listName - The name of the practice list (e.g., "rooms")
     * @param entry - The entry text to add to the list
     * @returns Promise resolving when entry is added
     * @throws Error if the API request fails or service is not authenticated
     */ async addPracticeListEntry(targetUser, listName, entry) {
        return this.apiPost(`${$1Su43.ROUTES.PRAC}/${targetUser}/lists/${listName}/entries`, {
            entry: entry
        });
    }
    /**
     * Get all entries from a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to retrieve
     * @param listName - The name of the practice list (e.g., "rooms")
     * @returns Promise resolving to practice list entries
     * @throws Error if the API request fails or practice list is not found
     */ async getPracticeList(targetUser, listName) {
        return this.apiGet(`${$1Su43.ROUTES.PRAC}/${targetUser}/lists/${listName}`);
    }
    /**
     * Delete a specific entry from a user's practice list by its index
     * @param targetUser - The Twitch user ID whose practice list to modify
     * @param listName - The name of the practice list (e.g., "rooms")
     * @param entryId - The 1-based index of the entry to delete
     * @returns Promise resolving when entry is deleted
     * @throws Error if the API request fails or entry is not found
     */ async deletePracticeListEntry(targetUser, listName, entryId) {
        return this.apiDelete(`${$1Su43.ROUTES.PRAC}/${targetUser}/lists/${listName}/entries/${entryId}`);
    }
    /**
     * Clear all entries from a user's practice list
     * @param targetUser - The Twitch user ID whose practice list to clear
     * @param listName - The name of the practice list (e.g., "rooms")
     * @returns Promise resolving when list is cleared
     * @throws Error if the API request fails or practice list is not found
     */ async clearPracticeList(targetUser, listName) {
        return this.apiDelete(`${$1Su43.ROUTES.PRAC}/${targetUser}/lists/${listName}`);
    }
}
module.exports.PracRoutes = $5bea767aa56e0cad$var$PracRoutes;

});

parcelRegister("6yM2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamAlertsRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for stream alerts management
 * Handles monitoring and configuration of stream alert channels
 */ class $4c6b2ed3c5e1e9c2$var$StreamAlertsRoutes extends $8qngW.ApiBase {
    /**
     * Get list of channels configured for stream alerts
     * @returns Promise resolving to array of stream alert channels
     * @throws Error if the API request fails
     */ async getStreamAlertsChannels() {
        return this.apiGet(`${$1Su43.ROUTES.STREAM_ALERTS}/channels`);
    }
    /**
     * Add a Twitch channel to stream alerts monitoring
     * @param twitchUsername - The Twitch username to add to stream alerts
     * @returns Promise resolving when the channel is added
     * @throws Error if the API request fails or user is not authenticated
     */ async addChannelToStreamAlerts(twitchUsername) {
        return this.apiPost(`${$1Su43.ROUTES.STREAM_ALERTS}/channels`, {
            channels: [
                twitchUsername
            ]
        });
    }
    /**
     * Remove a Twitch channel from stream alerts monitoring
     * @param twitchUserId - The Twitch user ID to remove from stream alerts
     * @returns Promise resolving when the channel is removed
     * @throws Error if the API request fails or user is not authenticated
     */ async removeChannelFromStreamAlerts(twitchUserId) {
        return this.apiDelete(`${$1Su43.ROUTES.STREAM_ALERTS}/channels/${twitchUserId}`);
    }
    /**
     * Get current EventSub subscriptions
     * @returns Promise resolving to array of EventSub subscriptions
     */ async getEventSubSubscriptions() {
        return this.apiGet(`${$1Su43.ROUTES.STREAM_ALERTS}/subscriptions`);
    }
    /**
     * Clear all EventSub subscriptions
     * @returns Promise resolving when all subscriptions are cleared
     */ async clearAllSubscriptions() {
        return this.apiDelete(`${$1Su43.ROUTES.STREAM_ALERTS}/subscriptions/all`);
    }
    /**
     * Re-subscribe all currently watched channels
     * @returns Promise resolving with per-channel results
     */ async resubscribeAllChannels() {
        return this.apiPost(`${$1Su43.ROUTES.STREAM_ALERTS}/subscriptions/resubscribe`, {});
    }
}
module.exports.StreamAlertsRoutes = $4c6b2ed3c5e1e9c2$var$StreamAlertsRoutes;

});

parcelRegister("8rlsI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for stream management
 * Handles live stream data and monitoring
 */ class $62517e4c257c0bcb$var$StreamRoutes extends $8qngW.ApiBase {
    /**
     * Get live streams from the API
     * @returns Promise resolving to array of live Twitch streams
     * @throws Error if the API request fails
     */ async getLivestreams() {
        return this.apiGet(`${$1Su43.ROUTES.STREAMS}/live`);
    }
}
module.exports.StreamRoutes = $62517e4c257c0bcb$var$StreamRoutes;

});

parcelRegister("99BCC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestEventsRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for stream management
 * Handles live stream data and monitoring
 */ class $6aa2233ec26f426b$var$TestEventsRoutes extends $8qngW.ApiBase {
    /**
     * Trigger a test event for development/testing purposes
     */ async triggerTestEvent(payload) {
        return await this.api.post(`${$1Su43.ROUTES.TEST_EVENTS}/trigger`, payload);
    }
}
module.exports.TestEventsRoutes = $6aa2233ec26f426b$var$TestEventsRoutes;

});

parcelRegister("c9Ph7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TwitchRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for Twitch bot management
 * Handles all operations related to Twitch bot configuration and channels
 */ class $8d9e1976a4e5b45e$var$TwitchRoutes extends $8qngW.ApiBase {
    /**
     * Update Twitch bot configuration for the current authenticated user
     * @param config - The configuration updates to apply
     * @returns Promise resolving when the update is complete
     * @throws Error if the API request fails or user is not authenticated
     */ async updateTwitchBotConfig(config) {
        return this.apiPatch(`${$1Su43.ROUTES.TWITCH}/config`, config);
    }
    /**
     * Join a Twitch channel with the bot
     * @param twitchUsername - The Twitch username/channel to join
     * @returns void
     * @throws Error if the API request fails or user is not authenticated
     */ async joinTwitchChannel(twitchUsername) {
        const payload = twitchUsername ? {
            channel: twitchUsername
        } : {};
        return this.apiPost(`${$1Su43.ROUTES.TWITCH}/join`, payload);
    }
    /**
     * Leave a Twitch channel with the bot
     * @param twitchUsername - The Twitch username/channel to leave
     * @returns void
     * @throws Error if the API request fails or user is not authenticated
     */ async leaveTwitchChannel(twitchUsername) {
        const payload = twitchUsername ? {
            channel: twitchUsername
        } : {};
        return this.apiPost(`${$1Su43.ROUTES.TWITCH}/leave`, payload);
    }
    /**
     * Get list of Twitch channels that the bot is currently in
     * @returns Promise resolving to array of channel names
     * @throws Error if the API request fails or user is not authenticated
     */ async getTwitchBotChannels() {
        return this.apiGet(`${$1Su43.ROUTES.TWITCH}/channels`);
    }
}
module.exports.TwitchRoutes = $8d9e1976a4e5b45e$var$TwitchRoutes;

});

parcelRegister("fQaPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebRoutes = void 0;

var $8qngW = parcelRequire("8qngW");

var $1Su43 = parcelRequire("1Su43");
/**
 * API routes for web application configuration
 * Handles web app specific settings and configuration
 */ class $b8841c99b5bfe1ba$var$WebRoutes extends $8qngW.ApiBase {
    /**
     * Get web configuration from the API
     * @returns Promise resolving to web app configuration
     * @throws Error if the API request fails
     */ async getWebConfig() {
        return this.apiGet(`${$1Su43.ROUTES.WEB}/config`);
    }
}
module.exports.WebRoutes = $b8841c99b5bfe1ba$var$WebRoutes;

});

parcelRegister("ck9Lg", function(module, exports) {
"use strict";
var $8f8eecb256292669$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8f8eecb256292669$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8f8eecb256292669$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8f8eecb256292669$var$__exportStar((parcelRequire("cfXUJ")), module.exports);

});
parcelRegister("cfXUJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("5aEkg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCachedCommand = $3c3d2acfde4652b2$var$getCachedCommand;
/**
 * Retrieves a command from cache or fetches fresh from API
 * Handles caching logic, expiration, and error handling
 * @param commandName - The command name to look up
 * @param cache - The cache Map to store/retrieve commands
 * @param apiClient - The API client to fetch fresh commands
 * @param cacheTimeoutMinutes - How long to cache commands (in minutes)
 * @returns Promise resolving to a cachable command or null
 */ async function $3c3d2acfde4652b2$var$getCachedCommand(commandName, cache, apiClient, cacheTimeoutMinutes = 10) {
    let resolvedCommand = null;
    const cachedCommand = cache.get(commandName);
    if (!cachedCommand || cachedCommand && Date.now() > cachedCommand.staleAfter) try {
        const findCommandResult = await apiClient.commands.findCommand(commandName);
        if (findCommandResult) {
            resolvedCommand = {
                ...findCommandResult,
                staleAfter: Date.now() + cacheTimeoutMinutes * 60000
            };
            cache.set(commandName, resolvedCommand);
        }
    } catch (err) {
        console.error(`Error while fetching command: ${err}`);
        return null;
    }
    else resolvedCommand = cachedCommand;
    return resolvedCommand;
}

});

parcelRegister("5XAy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TWITCH_MAX_MESSAGE_LENGTH = void 0;
// Twitch enforces a maximum of 500 characters per chat message
module.exports.TWITCH_MAX_MESSAGE_LENGTH = 500;

});

parcelRegister("doRA7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeTags = module.exports.normalizeTag = void 0;
/**
 * Normalizes a single tag for consistency and URL safety
 * - Converts to lowercase
 * - Replaces spaces with hyphens
 * - Removes special characters except hyphens
 * - Collapses multiple hyphens to single
 * - Removes leading/trailing hyphens
 */ const $9c17146e4ba0f2f9$var$normalizeTag = (tag)=>{
    return tag.toLowerCase().trim().replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^a-z0-9-]/g, "") // Remove special characters except hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
};
module.exports.normalizeTag = $9c17146e4ba0f2f9$var$normalizeTag;
/**
 * Normalizes an array of tags, removing duplicates and empty values
 * @param tags - Array of tags to normalize (may contain null/undefined)
 * @returns Array of normalized, unique tags
 */ const $9c17146e4ba0f2f9$var$normalizeTags = (tags)=>{
    if (!tags || !Array.isArray(tags)) return [];
    const normalized = tags.filter((tag)=>tag !== null && tag !== undefined && typeof tag === "string").map((tag)=>(0, module.exports.normalizeTag)(tag)).filter((tag)=>tag.length > 0);
    // Remove duplicates using Set
    return [
        ...new Set(normalized)
    ];
};
module.exports.normalizeTags = $9c17146e4ba0f2f9$var$normalizeTags;

});

var $14024a6d51999040$exports = {};
'use strict';

$14024a6d51999040$exports = (parcelRequire("aPfka"));



var $aqdBs = parcelRequire("aqdBs");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
'use strict';

var $jVlfX = parcelRequire("jVlfX");
var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $jVlfX.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $jVlfX.hydrateRoot;



var $MQCL2 = parcelRequire("MQCL2");
var $9FOsn = parcelRequire("9FOsn");

parcelRequire("aqdBs");

var $ebiy2 = parcelRequire("ebiy2");
var $MQCL2 = parcelRequire("MQCL2");
var $847cf46359bd85a0$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $847cf46359bd85a0$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $847cf46359bd85a0$var$__typeError("Cannot " + msg);
var $847cf46359bd85a0$export$18a094aefa070634 = (obj, member, getter)=>($847cf46359bd85a0$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $847cf46359bd85a0$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $847cf46359bd85a0$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $847cf46359bd85a0$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($847cf46359bd85a0$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $847cf46359bd85a0$export$fa92d15b718fce20 = (obj, member, method)=>($847cf46359bd85a0$var$__accessCheck(obj, member, "access private method"), method);
var $847cf46359bd85a0$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $847cf46359bd85a0$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $847cf46359bd85a0$export$18a094aefa070634(obj, member, getter);
        }
    });



// src/utils.ts
var $c39459b613f68ef1$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $c39459b613f68ef1$export$8793edee2d425525() {}
function $c39459b613f68ef1$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $c39459b613f68ef1$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $c39459b613f68ef1$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $c39459b613f68ef1$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $c39459b613f68ef1$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $c39459b613f68ef1$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $c39459b613f68ef1$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$c39459b613f68ef1$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $c39459b613f68ef1$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($c39459b613f68ef1$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $c39459b613f68ef1$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$c39459b613f68ef1$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $c39459b613f68ef1$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $c39459b613f68ef1$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $c39459b613f68ef1$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$c39459b613f68ef1$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $c39459b613f68ef1$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$c39459b613f68ef1$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $c39459b613f68ef1$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $c39459b613f68ef1$export$7a8558113332b71e(a) && $c39459b613f68ef1$export$7a8558113332b71e(b);
    if (array || $c39459b613f68ef1$export$53b83ca8eaab0383(a) && $c39459b613f68ef1$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        const aItemsSet = new Set(aItems);
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItemsSet.has(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $c39459b613f68ef1$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $c39459b613f68ef1$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $c39459b613f68ef1$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $c39459b613f68ef1$export$53b83ca8eaab0383(o) {
    if (!$c39459b613f68ef1$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$c39459b613f68ef1$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $c39459b613f68ef1$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $c39459b613f68ef1$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $c39459b613f68ef1$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $c39459b613f68ef1$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $c39459b613f68ef1$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $c39459b613f68ef1$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $c39459b613f68ef1$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $c39459b613f68ef1$export$1aa5a89531b7670d = Symbol();
function $c39459b613f68ef1$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $c39459b613f68ef1$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $c39459b613f68ef1$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}





// src/notifyManager.ts
var $37ff0854118f026e$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $37ff0854118f026e$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $37ff0854118f026e$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $37ff0854118f026e$export$520687f44db6e1ab = $37ff0854118f026e$export$316a8efd03cd1458();





// src/subscribable.ts
var $aa9353a244703a16$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $7dc6f441f05492f2$var$_focused, $7dc6f441f05492f2$var$_cleanup, $7dc6f441f05492f2$var$_setup;
var $7dc6f441f05492f2$export$86f1af424b2ca4de = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $7dc6f441f05492f2$var$_focused);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $7dc6f441f05492f2$var$_cleanup);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $7dc6f441f05492f2$var$_setup);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $7dc6f441f05492f2$var$_setup, (onFocus)=>{
            if (!(0, $c39459b613f68ef1$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_cleanup)) this.setEventListener((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_cleanup)) == null || _a.call(this);
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $7dc6f441f05492f2$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $7dc6f441f05492f2$var$_setup, setup);
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_cleanup)) == null || _a.call(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $7dc6f441f05492f2$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_focused) !== focused;
        if (changed) {
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $7dc6f441f05492f2$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_focused) === "boolean") return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $7dc6f441f05492f2$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$7dc6f441f05492f2$var$_focused = new WeakMap();
$7dc6f441f05492f2$var$_cleanup = new WeakMap();
$7dc6f441f05492f2$var$_setup = new WeakMap();
var $7dc6f441f05492f2$export$6bf54661be5b02cf = new $7dc6f441f05492f2$export$86f1af424b2ca4de();





var $ce0fb52a24b9550f$var$_online, $ce0fb52a24b9550f$var$_cleanup, $ce0fb52a24b9550f$var$_setup;
var $ce0fb52a24b9550f$export$58774fb55d5ff7fc = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $ce0fb52a24b9550f$var$_online, true);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $ce0fb52a24b9550f$var$_cleanup);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $ce0fb52a24b9550f$var$_setup);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $ce0fb52a24b9550f$var$_setup, (onOnline)=>{
            if (!(0, $c39459b613f68ef1$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_cleanup)) this.setEventListener((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_cleanup)) == null || _a.call(this);
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $ce0fb52a24b9550f$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $ce0fb52a24b9550f$var$_setup, setup);
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_cleanup)) == null || _a.call(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $ce0fb52a24b9550f$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_online) !== online;
        if (changed) {
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $ce0fb52a24b9550f$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $ce0fb52a24b9550f$var$_online);
    }
};
$ce0fb52a24b9550f$var$_online = new WeakMap();
$ce0fb52a24b9550f$var$_cleanup = new WeakMap();
$ce0fb52a24b9550f$var$_setup = new WeakMap();
var $ce0fb52a24b9550f$export$b113e788b2dd3fdc = new $ce0fb52a24b9550f$export$58774fb55d5ff7fc();




function $2f77934bf23faa16$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $2f77934bf23faa16$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $c39459b613f68ef1$export$8793edee2d425525))) == null || _a.catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $9f807067f63dbf38$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $9f807067f63dbf38$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $ce0fb52a24b9550f$export$b113e788b2dd3fdc).isOnline() : true;
}
var $9f807067f63dbf38$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $9f807067f63dbf38$export$986cc6445c1d323(value) {
    return value instanceof $9f807067f63dbf38$export$a8430ed4188f35a9;
}
function $9f807067f63dbf38$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $2f77934bf23faa16$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            reject(new $9f807067f63dbf38$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $7dc6f441f05492f2$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $ce0fb52a24b9550f$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$9f807067f63dbf38$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $c39459b613f68ef1$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $9f807067f63dbf38$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $c39459b613f68ef1$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}




var $81ac71cf96e408d7$var$_gcTimeout;
var $81ac71cf96e408d7$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $81ac71cf96e408d7$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $c39459b613f68ef1$export$e539f754e934e270)(this.gcTime)) (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $81ac71cf96e408d7$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $c39459b613f68ef1$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $81ac71cf96e408d7$var$_gcTimeout)) {
            clearTimeout((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $81ac71cf96e408d7$var$_gcTimeout));
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $81ac71cf96e408d7$var$_gcTimeout, void 0);
        }
    }
};
$81ac71cf96e408d7$var$_gcTimeout = new WeakMap();


var $cff89193aafe4d4f$var$_initialState, $cff89193aafe4d4f$var$_revertState, $cff89193aafe4d4f$var$_cache, $cff89193aafe4d4f$var$_client, $cff89193aafe4d4f$var$_retryer, $cff89193aafe4d4f$var$_defaultOptions, $cff89193aafe4d4f$var$_abortSignalConsumed, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn;
var $cff89193aafe4d4f$export$62297b13309008b2 = class extends (0, $81ac71cf96e408d7$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_Query_instances);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_initialState);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_revertState);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_cache);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_client);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_retryer);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_defaultOptions);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $cff89193aafe4d4f$var$_abortSignalConsumed);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_abortSignalConsumed, false);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_client, config.client);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_cache, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_initialState, $cff89193aafe4d4f$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $c39459b613f68ef1$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $c39459b613f68ef1$export$8793edee2d425525)).catch((0, $c39459b613f68ef1$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $c39459b613f68ef1$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $c39459b613f68ef1$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $c39459b613f68ef1$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $c39459b613f68ef1$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) {
                    if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_abortSignalConsumed)) (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer)) {
                (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).continueRetry();
                return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $c39459b613f68ef1$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_retryer, (0, $9f807067f63dbf38$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onFail: (failureCount, error)=>{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $9f807067f63dbf38$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_retryer).promise;
                else if (error.revert) {
                    this.setState({
                        ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_revertState),
                        fetchStatus: "idle"
                    });
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $cff89193aafe4d4f$var$_Query_instances, $cff89193aafe4d4f$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$cff89193aafe4d4f$var$_initialState = new WeakMap();
$cff89193aafe4d4f$var$_revertState = new WeakMap();
$cff89193aafe4d4f$var$_cache = new WeakMap();
$cff89193aafe4d4f$var$_client = new WeakMap();
$cff89193aafe4d4f$var$_retryer = new WeakMap();
$cff89193aafe4d4f$var$_defaultOptions = new WeakMap();
$cff89193aafe4d4f$var$_abortSignalConsumed = new WeakMap();
$cff89193aafe4d4f$var$_Query_instances = new WeakSet();
$cff89193aafe4d4f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$cff89193aafe4d4f$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $cff89193aafe4d4f$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $cff89193aafe4d4f$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $cff89193aafe4d4f$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $9f807067f63dbf38$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $cff89193aafe4d4f$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $dfd3a34c0b01afbe$var$_queries;
var $dfd3a34c0b01afbe$export$5dde0cd941da8468 = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $dfd3a34c0b01afbe$var$_queries);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $dfd3a34c0b01afbe$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $c39459b613f68ef1$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $cff89193aafe4d4f$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).has(query.queryHash)) {
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $dfd3a34c0b01afbe$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $c39459b613f68ef1$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $c39459b613f68ef1$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$dfd3a34c0b01afbe$var$_queries = new WeakMap();










var $4e5e6991374d5c52$var$_observers, $4e5e6991374d5c52$var$_mutationCache, $4e5e6991374d5c52$var$_retryer, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn;
var $4e5e6991374d5c52$export$17b8b19c814bcf56 = class extends (0, $81ac71cf96e408d7$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4e5e6991374d5c52$var$_Mutation_instances);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4e5e6991374d5c52$var$_observers);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4e5e6991374d5c52$var$_mutationCache);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4e5e6991374d5c52$var$_retryer);
        this.mutationId = config.mutationId;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4e5e6991374d5c52$var$_mutationCache, config.mutationCache);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4e5e6991374d5c52$var$_observers, []);
        this.state = config.state || $4e5e6991374d5c52$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_observers).includes(observer)) {
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4e5e6991374d5c52$var$_observers, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const onContinue = ()=>{
            (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4e5e6991374d5c52$var$_retryer, (0, $9f807067f63dbf38$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_retryer).start();
            await ((_f = (_e = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4e5e6991374d5c52$var$_Mutation_instances, $4e5e6991374d5c52$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).runNext(this);
        }
    }
};
$4e5e6991374d5c52$var$_observers = new WeakMap();
$4e5e6991374d5c52$var$_mutationCache = new WeakMap();
$4e5e6991374d5c52$var$_retryer = new WeakMap();
$4e5e6991374d5c52$var$_Mutation_instances = new WeakSet();
$4e5e6991374d5c52$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4e5e6991374d5c52$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $4e5e6991374d5c52$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $b2d071c7ef58f301$var$_mutations, $b2d071c7ef58f301$var$_scopes, $b2d071c7ef58f301$var$_mutationId;
var $b2d071c7ef58f301$export$1fcfd9a244434844 = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $b2d071c7ef58f301$var$_mutations);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $b2d071c7ef58f301$var$_scopes);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $b2d071c7ef58f301$var$_mutationId);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $b2d071c7ef58f301$var$_mutations, /* @__PURE__ */ new Set());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $b2d071c7ef58f301$var$_scopes, /* @__PURE__ */ new Map());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $b2d071c7ef58f301$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $4e5e6991374d5c52$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $847cf46359bd85a0$export$b1fe7cbb4502036b)(this, $b2d071c7ef58f301$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_mutations).add(mutation);
        const scope = $b2d071c7ef58f301$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_mutations).delete(mutation)) {
            const scope = $b2d071c7ef58f301$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $b2d071c7ef58f301$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $b2d071c7ef58f301$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_mutations).clear();
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $b2d071c7ef58f301$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $c39459b613f68ef1$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $c39459b613f68ef1$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $c39459b613f68ef1$export$8793edee2d425525)))));
    }
};
$b2d071c7ef58f301$var$_mutations = new WeakMap();
$b2d071c7ef58f301$var$_scopes = new WeakMap();
$b2d071c7ef58f301$var$_mutationId = new WeakMap();
function $b2d071c7ef58f301$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $45bdcd78964320f5$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $c39459b613f68ef1$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $c39459b613f68ef1$export$8c6246b73dd61f4a) : (0, $c39459b613f68ef1$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45bdcd78964320f5$var$getPreviousPageParam : $45bdcd78964320f5$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $45bdcd78964320f5$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45bdcd78964320f5$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $45bdcd78964320f5$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $45bdcd78964320f5$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45bdcd78964320f5$var$getNextPageParam(options, data) != null;
}
function $45bdcd78964320f5$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45bdcd78964320f5$var$getPreviousPageParam(options, data) != null;
}


var $1de7da191eb55f71$var$_queryCache, $1de7da191eb55f71$var$_mutationCache, $1de7da191eb55f71$var$_defaultOptions, $1de7da191eb55f71$var$_queryDefaults, $1de7da191eb55f71$var$_mutationDefaults, $1de7da191eb55f71$var$_mountCount, $1de7da191eb55f71$var$_unsubscribeFocus, $1de7da191eb55f71$var$_unsubscribeOnline;
var $1de7da191eb55f71$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_queryCache);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_mutationCache);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_defaultOptions);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_queryDefaults);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_mutationDefaults);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_mountCount);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_unsubscribeFocus);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $1de7da191eb55f71$var$_unsubscribeOnline);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_queryCache, config.queryCache || new (0, $dfd3a34c0b01afbe$export$5dde0cd941da8468)());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_mutationCache, config.mutationCache || new (0, $b2d071c7ef58f301$export$1fcfd9a244434844)());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_defaultOptions, config.defaultOptions || {});
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_mountCount, 0);
    }
    mount() {
        (0, $847cf46359bd85a0$export$b1fe7cbb4502036b)(this, $1de7da191eb55f71$var$_mountCount)._++;
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mountCount) !== 1) return;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_unsubscribeFocus, (0, $7dc6f441f05492f2$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).onFocus();
            }
        }));
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_unsubscribeOnline, (0, $ce0fb52a24b9550f$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $847cf46359bd85a0$export$b1fe7cbb4502036b)(this, $1de7da191eb55f71$var$_mountCount)._--;
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mountCount) !== 0) return;
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_unsubscribeFocus, void 0);
        (_b = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $c39459b613f68ef1$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $c39459b613f68ef1$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache);
        (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache);
        return (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $c39459b613f68ef1$export$8793edee2d425525)).catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $c39459b613f68ef1$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $c39459b613f68ef1$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $c39459b613f68ef1$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $c39459b613f68ef1$export$8793edee2d425525)).catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $45bdcd78964320f5$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $c39459b613f68ef1$export$8793edee2d425525)).catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $45bdcd78964320f5$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $ce0fb52a24b9550f$export$b113e788b2dd3fdc).isOnline()) return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache);
    }
    getMutationCache() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $1de7da191eb55f71$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryDefaults).set((0, $c39459b613f68ef1$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $c39459b613f68ef1$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationDefaults).set((0, $c39459b613f68ef1$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $c39459b613f68ef1$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $c39459b613f68ef1$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $c39459b613f68ef1$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_queryCache).clear();
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $1de7da191eb55f71$var$_mutationCache).clear();
    }
};
$1de7da191eb55f71$var$_queryCache = new WeakMap();
$1de7da191eb55f71$var$_mutationCache = new WeakMap();
$1de7da191eb55f71$var$_defaultOptions = new WeakMap();
$1de7da191eb55f71$var$_queryDefaults = new WeakMap();
$1de7da191eb55f71$var$_mutationDefaults = new WeakMap();
$1de7da191eb55f71$var$_mountCount = new WeakMap();
$1de7da191eb55f71$var$_unsubscribeFocus = new WeakMap();
$1de7da191eb55f71$var$_unsubscribeOnline = new WeakMap();


var $aqdBs = parcelRequire("aqdBs");

"use client";
var $aa6eb665fb0ab93b$export$da112d31b0149f31 = $aqdBs.createContext(void 0);
var $aa6eb665fb0ab93b$export$22e77b9572c4fded = (queryClient)=>{
    const client = $aqdBs.useContext($aa6eb665fb0ab93b$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aa6eb665fb0ab93b$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $aqdBs.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $14024a6d51999040$exports.jsx)($aa6eb665fb0ab93b$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




"use client";
var $20c30cac66318740$export$fd1469cb3147d866 = function() {
    return null;
};
var $20c30cac66318740$export$6d64409a8b475869 = function() {
    return null;
};




var $aqdBs = parcelRequire("aqdBs");
const $a090e2c92c5011cf$export$f35d6afa04dbc6b3 = (state, action)=>{
    switch(action.type){
        case "ADD_TOAST":
            return {
                ...state,
                toasts: [
                    ...state.toasts,
                    action.payload
                ]
            };
        case "DELETE_TOAST":
            {
                const updatedToasts = state.toasts.filter((toast)=>toast.id !== action.payload);
                return {
                    ...state,
                    toasts: updatedToasts
                };
            }
        default:
            {
                const exhaustiveCheck = action;
                throw new Error(`Unhandled action type: ${exhaustiveCheck.type}`);
            }
    }
};



parcelRequire("aqdBs");
var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

"use client";
const $5f2dec88dec04806$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $5f2dec88dec04806$export$ff817e17bad2e091 = 'xs';
const $5f2dec88dec04806$var$ThemeContext = /*#__PURE__*/ $aqdBs.createContext({
    prefixes: {},
    breakpoints: $5f2dec88dec04806$export$666ad80b5007f835,
    minBreakpoint: $5f2dec88dec04806$export$ff817e17bad2e091
});
const { Consumer: $5f2dec88dec04806$export$b631efc24e9d5e2f, Provider: $5f2dec88dec04806$var$Provider } = $5f2dec88dec04806$var$ThemeContext;
function $5f2dec88dec04806$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $5f2dec88dec04806$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $5f2dec88dec04806$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $aqdBs.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($5f2dec88dec04806$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $5f2dec88dec04806$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $aqdBs.useContext)($5f2dec88dec04806$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $5f2dec88dec04806$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $aqdBs.useContext)($5f2dec88dec04806$var$ThemeContext);
    return breakpoints;
}
function $5f2dec88dec04806$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $aqdBs.useContext)($5f2dec88dec04806$var$ThemeContext);
    return minBreakpoint;
}
function $5f2dec88dec04806$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $aqdBs.useContext)($5f2dec88dec04806$var$ThemeContext);
    return dir === 'rtl';
}
function $5f2dec88dec04806$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $aqdBs.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $5f2dec88dec04806$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $5f2dec88dec04806$export$2e2bcd8739ae039 = $5f2dec88dec04806$var$ThemeProvider;



"use client";
const $e447ed06191afecb$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const $e447ed06191afecb$var$ToastContainer = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, position && $e447ed06191afecb$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$e447ed06191afecb$var$ToastContainer.displayName = 'ToastContainer';
var $e447ed06191afecb$export$2e2bcd8739ae039 = $e447ed06191afecb$var$ToastContainer;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
function $40e97ddf558a9e15$export$2e2bcd8739ae039() {
    const mounted = (0, $aqdBs.useRef)(true);
    const isMounted = (0, $aqdBs.useRef)(()=>mounted.current);
    (0, $aqdBs.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $aqdBs = parcelRequire("aqdBs");
function $66c04b4d36b993b4$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $aqdBs.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $aqdBs = parcelRequire("aqdBs");
function $22c98e2b45f24dde$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $66c04b4d36b993b4$export$2e2bcd8739ae039)(fn);
    (0, $aqdBs.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $acf91290c5c63471$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $acf91290c5c63471$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $acf91290c5c63471$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$acf91290c5c63471$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $acf91290c5c63471$var$MAX_DELAY_MS);
}
function $acf91290c5c63471$export$2e2bcd8739ae039() {
    const isMounted = (0, $40e97ddf558a9e15$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $aqdBs.useRef)();
    (0, $22c98e2b45f24dde$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $aqdBs.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $acf91290c5c63471$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $acf91290c5c63471$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}



var $aqdBs = parcelRequire("aqdBs");
function $ca93ab600b9848d7$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $fac5bb66bdc16401$export$2e2bcd8739ae039(t, e) {
    return $fac5bb66bdc16401$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $fac5bb66bdc16401$export$2e2bcd8739ae039(t, e);
}


function $86b3ce71dc68cc74$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $fac5bb66bdc16401$export$2e2bcd8739ae039)(t, o);
}




var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");
var $e1c2ae7a80da78aa$export$2e2bcd8739ae039 = {
    disabled: false
};




var $aqdBs = parcelRequire("aqdBs");
var $e478f5f5f9961ba0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(null);


var $8de142fdcd6e8327$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0e3db6016de1057e$export$bb38bb9a1161268 = 'unmounted';
var $0e3db6016de1057e$export$84cbff306f539230 = 'exited';
var $0e3db6016de1057e$export$df38205c966be359 = 'entering';
var $0e3db6016de1057e$export$78e9e6e3e014d60a = 'entered';
var $0e3db6016de1057e$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0e3db6016de1057e$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $86b3ce71dc68cc74$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0e3db6016de1057e$export$84cbff306f539230;
                _this.appearStatus = $0e3db6016de1057e$export$df38205c966be359;
            } else initialStatus = $0e3db6016de1057e$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0e3db6016de1057e$export$bb38bb9a1161268;
        else initialStatus = $0e3db6016de1057e$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0e3db6016de1057e$export$bb38bb9a1161268) return {
            status: $0e3db6016de1057e$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0e3db6016de1057e$export$df38205c966be359 && status !== $0e3db6016de1057e$export$78e9e6e3e014d60a) nextStatus = $0e3db6016de1057e$export$df38205c966be359;
            } else if (status === $0e3db6016de1057e$export$df38205c966be359 || status === $0e3db6016de1057e$export$78e9e6e3e014d60a) nextStatus = $0e3db6016de1057e$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0e3db6016de1057e$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8de142fdcd6e8327$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0e3db6016de1057e$export$84cbff306f539230) this.setState({
            status: $0e3db6016de1057e$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $e1c2ae7a80da78aa$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0e3db6016de1057e$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0e3db6016de1057e$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0e3db6016de1057e$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $e1c2ae7a80da78aa$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0e3db6016de1057e$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0e3db6016de1057e$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0e3db6016de1057e$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0e3db6016de1057e$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $ca93ab600b9848d7$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e478f5f5f9961ba0$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Component);
$0e3db6016de1057e$var$Transition.contextType = (0, $e478f5f5f9961ba0$export$2e2bcd8739ae039);
$0e3db6016de1057e$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0e3db6016de1057e$var$noop() {}
$0e3db6016de1057e$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0e3db6016de1057e$var$noop,
    onEntering: $0e3db6016de1057e$var$noop,
    onEntered: $0e3db6016de1057e$var$noop,
    onExit: $0e3db6016de1057e$var$noop,
    onExiting: $0e3db6016de1057e$var$noop,
    onExited: $0e3db6016de1057e$var$noop
};
$0e3db6016de1057e$var$Transition.UNMOUNTED = $0e3db6016de1057e$export$bb38bb9a1161268;
$0e3db6016de1057e$var$Transition.EXITED = $0e3db6016de1057e$export$84cbff306f539230;
$0e3db6016de1057e$var$Transition.ENTERING = $0e3db6016de1057e$export$df38205c966be359;
$0e3db6016de1057e$var$Transition.ENTERED = $0e3db6016de1057e$export$78e9e6e3e014d60a;
$0e3db6016de1057e$var$Transition.EXITING = $0e3db6016de1057e$export$4aacc83d4d59139f;
var $0e3db6016de1057e$export$2e2bcd8739ae039 = $0e3db6016de1057e$var$Transition;




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
function $2610728fd84fb0e5$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $2610728fd84fb0e5$export$13e065f3a74cfe36() {
    const parts = $aqdBs.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $2610728fd84fb0e5$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $2610728fd84fb0e5$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;



/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $53292e148448f047$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $53292e148448f047$export$2e2bcd8739ae039(element, handler) {
    const duration = $53292e148448f047$var$parseDuration(element, 'transitionDuration');
    const delay = $53292e148448f047$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $3698546853b64c13$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
const $7210c9eb4cf3b493$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $7210c9eb4cf3b493$export$c9058316764c140e(refA, refB) {
    const a = $7210c9eb4cf3b493$var$toFnRef(refA);
    const b = $7210c9eb4cf3b493$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $7210c9eb4cf3b493$var$useMergedRefs(refA, refB) {
    return (0, $aqdBs.useMemo)(()=>$7210c9eb4cf3b493$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $7210c9eb4cf3b493$export$2e2bcd8739ae039 = $7210c9eb4cf3b493$var$useMergedRefs;



var $jVlfX = parcelRequire("jVlfX");
function $9078b7d215687fcf$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $2a0df3c9886be198$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $aqdBs.useRef)(null);
    const mergedRef = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $9078b7d215687fcf$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $aqdBs.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $aqdBs.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $aqdBs.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $aqdBs.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $aqdBs.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $aqdBs.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $aqdBs.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $0e3db6016de1057e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$2a0df3c9886be198$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $2a0df3c9886be198$export$2e2bcd8739ae039 = $2a0df3c9886be198$var$TransitionWrapper;



const $88015c380507f9aa$var$fadeStyles = {
    [(0, $0e3db6016de1057e$export$df38205c966be359)]: 'show',
    [(0, $0e3db6016de1057e$export$78e9e6e3e014d60a)]: 'show'
};
const $88015c380507f9aa$var$Fade = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $aqdBs.useCallback)((node, isAppearing)=>{
        (0, $3698546853b64c13$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2a0df3c9886be198$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $53292e148448f047$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $2610728fd84fb0e5$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $aqdBs.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $88015c380507f9aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$88015c380507f9aa$var$Fade.displayName = 'Fade';
var $88015c380507f9aa$export$2e2bcd8739ae039 = $88015c380507f9aa$var$Fade;



const $b91428b09aa83388$var$fadeStyles = {
    [(0, $0e3db6016de1057e$export$df38205c966be359)]: 'showing',
    [(0, $0e3db6016de1057e$export$4aacc83d4d59139f)]: 'showing show'
};
const $b91428b09aa83388$var$ToastFade = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $88015c380507f9aa$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $b91428b09aa83388$var$fadeStyles
    }));
$b91428b09aa83388$var$ToastFade.displayName = 'ToastFade';
var $b91428b09aa83388$export$2e2bcd8739ae039 = $b91428b09aa83388$var$ToastFade;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $95d48fab5f3b40d8$var$useCommittedRef(value) {
    const ref = (0, $aqdBs.useRef)(value);
    (0, $aqdBs.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $95d48fab5f3b40d8$export$2e2bcd8739ae039 = $95d48fab5f3b40d8$var$useCommittedRef;


function $435e5257ab4445c3$export$2e2bcd8739ae039(fn) {
    const ref = (0, $95d48fab5f3b40d8$export$2e2bcd8739ae039)(fn);
    return (0, $aqdBs.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}




var $4RND8 = parcelRequire("4RND8");

var $aqdBs = parcelRequire("aqdBs");


const $c35c25be0f138db7$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
        'white'
    ])
};
const $c35c25be0f138db7$var$CloseButton = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$c35c25be0f138db7$var$CloseButton.displayName = 'CloseButton';
$c35c25be0f138db7$var$CloseButton.propTypes = $c35c25be0f138db7$var$propTypes;
var $c35c25be0f138db7$export$2e2bcd8739ae039 = $c35c25be0f138db7$var$CloseButton;



var $aqdBs = parcelRequire("aqdBs");
"use client";
const $ce2dcef6dc17b26e$var$ToastContext = /*#__PURE__*/ $aqdBs.createContext({
    onClose () {}
});
var $ce2dcef6dc17b26e$export$2e2bcd8739ae039 = $ce2dcef6dc17b26e$var$ToastContext;



"use client";
const $226417dbf4279e98$var$ToastHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    const context = (0, $aqdBs.useContext)((0, $ce2dcef6dc17b26e$export$2e2bcd8739ae039));
    const handleClick = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c35c25be0f138db7$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$226417dbf4279e98$var$ToastHeader.displayName = 'ToastHeader';
var $226417dbf4279e98$export$2e2bcd8739ae039 = $226417dbf4279e98$var$ToastHeader;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $c520eba1828fa2fb$var$ToastBody = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c520eba1828fa2fb$var$ToastBody.displayName = 'ToastBody';
var $c520eba1828fa2fb$export$2e2bcd8739ae039 = $c520eba1828fa2fb$var$ToastBody;





"use client";
const $3f76094393db86a0$var$Toast = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $b91428b09aa83388$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $aqdBs.useRef)(delay);
    const onCloseRef = (0, $aqdBs.useRef)(onClose);
    (0, $aqdBs.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $acf91290c5c63471$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $aqdBs.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $aqdBs.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $aqdBs.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ce2dcef6dc17b26e$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$3f76094393db86a0$var$Toast.displayName = 'Toast';
var $3f76094393db86a0$export$2e2bcd8739ae039 = Object.assign($3f76094393db86a0$var$Toast, {
    Body: (0, $c520eba1828fa2fb$export$2e2bcd8739ae039),
    Header: (0, $226417dbf4279e98$export$2e2bcd8739ae039)
});



var $aqdBs = parcelRequire("aqdBs");

const $2829a8981f6f0f18$export$a407b657d3044108 = ()=>(0, $aqdBs.useContext)((0, $8e399e97629ab9e4$export$29d4e2ed4674ecfc));


const $fa76e4de27b76090$var$toastVariants = {
    success: {
        icon: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
            className: "fa-regular fa-circle-check px-1 text-dark"
        }),
        bgClass: "success",
        title: "Success!",
        textClass: "text-dark",
        closeButtonClass: "toast-close-dark"
    },
    warning: {
        icon: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
            className: "fa-solid fa-triangle-exclamation px-1 text-dark"
        }),
        bgClass: "warning",
        title: "Warning!",
        textClass: "text-body-emphasis",
        closeButtonClass: "toast-close-dark"
    },
    info: {
        icon: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
            className: "fa-solid fa-circle-info px-1 text-white"
        }),
        bgClass: "info",
        title: "Info",
        textClass: "text-body-emphasis",
        closeButtonClass: "toast-close-light"
    },
    error: {
        icon: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
            className: "fa-solid fa-bug px-1 text-white"
        }),
        bgClass: "danger",
        title: "Error!",
        textClass: "text-body-emphasis",
        closeButtonClass: "toast-close-light"
    }
};
const $fa76e4de27b76090$var$DefaultToast = (props)=>{
    const { variant: variant, message: message, id: id } = props;
    const toastVariant = $fa76e4de27b76090$var$toastVariants[variant];
    const [show, setShow] = $aqdBs.useState(true);
    const toast = (0, $2829a8981f6f0f18$export$a407b657d3044108)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3f76094393db86a0$export$2e2bcd8739ae039), {
        bg: toastVariant.bgClass,
        onClose: ()=>{
            setShow(false);
        },
        onExited: ()=>{
            toast.remove(id);
        },
        show: show,
        delay: 5000,
        autohide: true,
        className: "toast-custom",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $3f76094393db86a0$export$2e2bcd8739ae039).Body, {
            className: "toast-body-custom d-flex align-items-center justify-content-between",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: "me-2",
                            children: toastVariant.icon
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                            className: toastVariant.textClass,
                            children: message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                    type: "button",
                    className: `toast-close-btn ${toastVariant.closeButtonClass} btn p-1 ms-2`,
                    "aria-label": "Close",
                    onClick: ()=>setShow(false),
                    children: "\xd7"
                })
            ]
        })
    });
};
var $fa76e4de27b76090$export$2e2bcd8739ae039 = $fa76e4de27b76090$var$DefaultToast;


const $1ac0945f21f00b2d$var$DefaultToastContainer = (props)=>{
    const { toasts: toasts } = props;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e447ed06191afecb$export$2e2bcd8739ae039), {
        position: "bottom-start",
        className: "position-fixed p-3",
        children: toasts && toasts.map((toast)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fa76e4de27b76090$export$2e2bcd8739ae039), {
                id: toast.id,
                variant: toast.variant,
                message: toast.message
            }, toast.id))
    });
};
var $1ac0945f21f00b2d$export$2e2bcd8739ae039 = $1ac0945f21f00b2d$var$DefaultToastContainer;


const $8e399e97629ab9e4$var$initialState = {
    toasts: []
};
const $8e399e97629ab9e4$export$29d4e2ed4674ecfc = /*#__PURE__*/ (0, $aqdBs.createContext)({});
const $8e399e97629ab9e4$export$f5d03d415824e0e = ({ children: children })=>{
    const [state, dispatch] = (0, $aqdBs.useReducer)((0, $a090e2c92c5011cf$export$f35d6afa04dbc6b3), $8e399e97629ab9e4$var$initialState);
    const addToast = (variant, message)=>{
        const id = Math.floor(Math.random() * 10000000);
        dispatch({
            type: "ADD_TOAST",
            payload: {
                id: id,
                message: message,
                variant: variant
            }
        });
    };
    const remove = (id)=>{
        dispatch({
            type: "DELETE_TOAST",
            payload: id
        });
    };
    const success = (message)=>{
        addToast("success", message);
    };
    const warning = (message)=>{
        addToast("warning", message);
    };
    const info = (message)=>{
        addToast("info", message);
    };
    const error = (message)=>{
        addToast("error", message);
    };
    const value = {
        success: success,
        warning: warning,
        info: info,
        error: error,
        remove: remove
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)($8e399e97629ab9e4$export$29d4e2ed4674ecfc.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1ac0945f21f00b2d$export$2e2bcd8739ae039), {
                toasts: state.toasts
            }),
            children
        ]
    });
};




parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

const $e9fb5029df099253$var$_excluded = [
    "as",
    "disabled"
];
function $e9fb5029df099253$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e9fb5029df099253$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $e9fb5029df099253$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $e9fb5029df099253$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $e9fb5029df099253$var$Button = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $e9fb5029df099253$var$_objectWithoutPropertiesLoose(_ref, $e9fb5029df099253$var$_excluded);
    const [buttonProps, { tagName: Component }] = $e9fb5029df099253$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$e9fb5029df099253$var$Button.displayName = 'Button';
var $e9fb5029df099253$export$2e2bcd8739ae039 = $e9fb5029df099253$var$Button;




"use client";
const $f068e13e24d891b9$var$Button = /*#__PURE__*/ $aqdBs.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $e9fb5029df099253$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$f068e13e24d891b9$var$Button.displayName = 'Button';
var $f068e13e24d891b9$export$2e2bcd8739ae039 = $f068e13e24d891b9$var$Button;



var $aqdBs = parcelRequire("aqdBs");

var $4RND8 = parcelRequire("4RND8");


"use client";
const $1e353161c142be0d$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool
};
const $1e353161c142be0d$var$Image = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$1e353161c142be0d$var$Image.displayName = 'Image';
var $1e353161c142be0d$export$2e2bcd8739ae039 = $1e353161c142be0d$var$Image;



var $aqdBs = parcelRequire("aqdBs");
function $5596ff548ba94494$export$2e2bcd8739ae039() {
    return $5596ff548ba94494$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5596ff548ba94494$export$2e2bcd8739ae039.apply(null, arguments);
}




var $aqdBs = parcelRequire("aqdBs");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $fa61ce19481da609$var$noop = function noop() {};
function $fa61ce19481da609$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $fa61ce19481da609$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $fa61ce19481da609$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$fa61ce19481da609$export$26cbf8c37e721e67(prop)] = $fa61ce19481da609$var$noop;
        var handler;
    });
    return propTypes;
}
function $fa61ce19481da609$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $fa61ce19481da609$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $fa61ce19481da609$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $d1750a042e9b894b$var$_toPropertyKey(arg) {
    var key = $d1750a042e9b894b$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $d1750a042e9b894b$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d1750a042e9b894b$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $aqdBs.useRef)(propValue !== undefined);
    var _useState = (0, $aqdBs.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $aqdBs.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $d1750a042e9b894b$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$fa61ce19481da609$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $ca93ab600b9848d7$export$2e2bcd8739ae039)(_ref, [
            $fa61ce19481da609$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($d1750a042e9b894b$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $d1750a042e9b894b$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $5596ff548ba94494$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $aqdBs = parcelRequire("aqdBs");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $e332024bd70030e1$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $e332024bd70030e1$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $fa61ce19481da609$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($fa61ce19481da609$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $86b3ce71dc68cc74$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $5596ff548ba94494$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$fa61ce19481da609$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $5596ff548ba94494$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$fa61ce19481da609$export$12ae2baa35bd9b8b(props, key) && $fa61ce19481da609$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$fa61ce19481da609$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $ca93ab600b9848d7$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(Component, (0, $5596ff548ba94494$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $5596ff548ba94494$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $fa61ce19481da609$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(UncontrolledComponent, (0, $5596ff548ba94494$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $e332024bd70030e1$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $e332024bd70030e1$export$2e2bcd8739ae039(newComponent, (0, $5596ff548ba94494$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
function $f6a7014a69ba84cf$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $aqdBs.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $aqdBs = parcelRequire("aqdBs");
const $820f4a0adc48f832$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $820f4a0adc48f832$export$c9058316764c140e(refA, refB) {
    const a = $820f4a0adc48f832$var$toFnRef(refA);
    const b = $820f4a0adc48f832$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $820f4a0adc48f832$var$useMergedRefs(refA, refB) {
    return (0, $aqdBs.useMemo)(()=>$820f4a0adc48f832$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $820f4a0adc48f832$export$2e2bcd8739ae039 = $820f4a0adc48f832$var$useMergedRefs;



var $aqdBs = parcelRequire("aqdBs");
const $b07a729635485a08$var$NavContext = /*#__PURE__*/ $aqdBs.createContext(null);
$b07a729635485a08$var$NavContext.displayName = 'NavContext';
var $b07a729635485a08$export$2e2bcd8739ae039 = $b07a729635485a08$var$NavContext;



var $aqdBs = parcelRequire("aqdBs");
const $6a7ed7faa5347be7$var$SelectableContext = /*#__PURE__*/ $aqdBs.createContext(null);
const $6a7ed7faa5347be7$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $6a7ed7faa5347be7$export$2e2bcd8739ae039 = $6a7ed7faa5347be7$var$SelectableContext;



var $aqdBs = parcelRequire("aqdBs");
const $e0deffa47e48b837$var$TabContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $e0deffa47e48b837$export$2e2bcd8739ae039 = $e0deffa47e48b837$var$TabContext;


const $70e2d12f9898d912$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $70e2d12f9898d912$export$635202801f9383a0 = `rrUi`;
function $70e2d12f9898d912$export$5cc3b7b83e34ade7(property) {
    return `${$70e2d12f9898d912$export$fd7bcb7e9bef4e8a}${property}`;
}
function $70e2d12f9898d912$export$7776c0a7cd2eb3e0(property) {
    return `${$70e2d12f9898d912$export$635202801f9383a0}${property}`;
}



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $cac8e1383cf8676b$var$useCommittedRef(value) {
    const ref = (0, $aqdBs.useRef)(value);
    (0, $aqdBs.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $cac8e1383cf8676b$export$2e2bcd8739ae039 = $cac8e1383cf8676b$var$useCommittedRef;


function $8f1760d1aabbeb8a$export$2e2bcd8739ae039(fn) {
    const ref = (0, $cac8e1383cf8676b$export$2e2bcd8739ae039)(fn);
    return (0, $aqdBs.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}








const $f61116ee1a7a26e5$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $f61116ee1a7a26e5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f61116ee1a7a26e5$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $aqdBs.useContext)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039));
    const navContext = (0, $aqdBs.useContext)((0, $b07a729635485a08$export$2e2bcd8739ae039));
    const tabContext = (0, $aqdBs.useContext)((0, $e0deffa47e48b837$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $f61116ee1a7a26e5$var$NavItem = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $e9fb5029df099253$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $f61116ee1a7a26e5$var$_objectWithoutPropertiesLoose(_ref, $f61116ee1a7a26e5$var$_excluded);
    const [props, meta] = $f61116ee1a7a26e5$export$d7a68693710982a(Object.assign({
        key: (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$f61116ee1a7a26e5$var$NavItem.displayName = 'NavItem';
var $f61116ee1a7a26e5$export$2e2bcd8739ae039 = $f61116ee1a7a26e5$var$NavItem;



const $734cf06dc9abe0f0$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $734cf06dc9abe0f0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $734cf06dc9abe0f0$var$noop = ()=>{};
const $734cf06dc9abe0f0$var$EVENT_KEY_ATTR = (0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('event-key');
const $734cf06dc9abe0f0$var$Nav = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $734cf06dc9abe0f0$var$_objectWithoutPropertiesLoose(_ref, $734cf06dc9abe0f0$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $f6a7014a69ba84cf$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $aqdBs.useRef)(false);
    const parentOnSelect = (0, $aqdBs.useContext)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039));
    const tabContext = (0, $aqdBs.useContext)((0, $e0deffa47e48b837$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $aqdBs.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$734cf06dc9abe0f0$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $70e2d12f9898d912$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $aqdBs.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$734cf06dc9abe0f0$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $820f4a0adc48f832$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b07a729635485a08$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $734cf06dc9abe0f0$var$noop,
                getControllerId: getControllerId || $734cf06dc9abe0f0$var$noop
            },
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$734cf06dc9abe0f0$var$Nav.displayName = 'Nav';
var $734cf06dc9abe0f0$export$2e2bcd8739ae039 = Object.assign($734cf06dc9abe0f0$var$Nav, {
    Item: (0, $f61116ee1a7a26e5$export$2e2bcd8739ae039)
});




var $aqdBs = parcelRequire("aqdBs");
"use client";
// TODO: check
const $d1f86d157e090feb$var$context = /*#__PURE__*/ $aqdBs.createContext(null);
$d1f86d157e090feb$var$context.displayName = 'NavbarContext';
var $d1f86d157e090feb$export$2e2bcd8739ae039 = $d1f86d157e090feb$var$context;



var $aqdBs = parcelRequire("aqdBs");
"use client";
const $bfd172c9514a4560$var$context = /*#__PURE__*/ $aqdBs.createContext(null);
$bfd172c9514a4560$var$context.displayName = 'CardHeaderContext';
var $bfd172c9514a4560$export$2e2bcd8739ae039 = $bfd172c9514a4560$var$context;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $6a4295ac97e7a742$var$NavItem = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6a4295ac97e7a742$var$NavItem.displayName = 'NavItem';
var $6a4295ac97e7a742$export$2e2bcd8739ae039 = $6a4295ac97e7a742$var$NavItem;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
function $eeded26aba791689$export$2e2bcd8739ae039() {
    return (0, $aqdBs.useState)(null);
}





var $aqdBs = parcelRequire("aqdBs");

function $fac33539000b66bd$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(listener);
    (0, $aqdBs.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $aqdBs = parcelRequire("aqdBs");
function $5d861f4bf014bfea$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $aqdBs.useCallback)(()=>document, []);
    return (0, $fac33539000b66bd$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $aqdBs = parcelRequire("aqdBs");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $a88a09235b7995a3$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $cac8e1383cf8676b$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cac8e1383cf8676b$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $aqdBs.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $a88a09235b7995a3$export$2e2bcd8739ae039 = $a88a09235b7995a3$var$useInterval;



var $aqdBs = parcelRequire("aqdBs");

function $2edfc309a071f4a3$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $cac8e1383cf8676b$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cac8e1383cf8676b$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $aqdBs.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $2edfc309a071f4a3$export$2e2bcd8739ae039 = $2edfc309a071f4a3$var$useRafInterval;



var $aqdBs = parcelRequire("aqdBs");
function $5b8078927fa995e6$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $aqdBs.useState)(initialState);
    const updater = (0, $aqdBs.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $1f197ab9b264bc68$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $5b8078927fa995e6$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $aqdBs = parcelRequire("aqdBs");
function $f27a0e879368208d$export$2e2bcd8739ae039() {
    const mounted = (0, $aqdBs.useRef)(true);
    const isMounted = (0, $aqdBs.useRef)(()=>mounted.current);
    (0, $aqdBs.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $aqdBs = parcelRequire("aqdBs");
function $ab165df3aa327f31$export$2e2bcd8739ae039(value) {
    const ref = (0, $aqdBs.useRef)(null);
    (0, $aqdBs.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $aqdBs = parcelRequire("aqdBs");
function $0e5c04c85dde0a65$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $aqdBs.useState)({
        image: null,
        error: null
    });
    (0, $aqdBs.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
const $d065d4521e697a75$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $d065d4521e697a75$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $d065d4521e697a75$export$2e2bcd8739ae039 = $d065d4521e697a75$var$isDOM || $d065d4521e697a75$var$isReactNative ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);


const $0f35c7e4f894c4c3$var$targetMap = new WeakMap();
let $0f35c7e4f894c4c3$var$resizeObserver;
function $0f35c7e4f894c4c3$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $0f35c7e4f894c4c3$var$resizeObserver = $0f35c7e4f894c4c3$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $0f35c7e4f894c4c3$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $0f35c7e4f894c4c3$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $aqdBs.useState)(null);
    (0, $d065d4521e697a75$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $0f35c7e4f894c4c3$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $0f35c7e4f894c4c3$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $0f35c7e4f894c4c3$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $377fed55abf08a40$var$_excluded = [
    "onKeyDown"
];
function $377fed55abf08a40$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $377fed55abf08a40$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $377fed55abf08a40$var$Anchor = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $377fed55abf08a40$var$_objectWithoutPropertiesLoose(_ref, $377fed55abf08a40$var$_excluded);
    const [buttonProps] = (0, $e9fb5029df099253$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($377fed55abf08a40$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$377fed55abf08a40$var$Anchor.displayName = 'Anchor';
var $377fed55abf08a40$export$2e2bcd8739ae039 = $377fed55abf08a40$var$Anchor;






"use client";
const $46778ebbc3b4aa22$var$NavLink = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $377fed55abf08a40$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $f61116ee1a7a26e5$export$d7a68693710982a)({
        key: (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$46778ebbc3b4aa22$var$NavLink.displayName = 'NavLink';
var $46778ebbc3b4aa22$export$2e2bcd8739ae039 = $46778ebbc3b4aa22$var$NavLink;



"use client";
const $670f5cbce0b874dd$var$Nav = /*#__PURE__*/ $aqdBs.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $aqdBs.useContext)((0, $d1f86d157e090feb$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $aqdBs.useContext)((0, $bfd172c9514a4560$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $734cf06dc9abe0f0$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$670f5cbce0b874dd$var$Nav.displayName = 'Nav';
var $670f5cbce0b874dd$export$2e2bcd8739ae039 = Object.assign($670f5cbce0b874dd$var$Nav, {
    Item: (0, $6a4295ac97e7a742$export$2e2bcd8739ae039),
    Link: (0, $46778ebbc3b4aa22$export$2e2bcd8739ae039)
});



var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");


"use client";
const $6334da406fb550e6$var$NavbarBrand = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$6334da406fb550e6$var$NavbarBrand.displayName = 'NavbarBrand';
var $6334da406fb550e6$export$2e2bcd8739ae039 = $6334da406fb550e6$var$NavbarBrand;



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $4d72e478987b878c$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $4d72e478987b878c$export$2e2bcd8739ae039 = $4d72e478987b878c$var$createChainedFunction;





const $5decc35d9948d9fe$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $5decc35d9948d9fe$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $5decc35d9948d9fe$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $5decc35d9948d9fe$var$collapseStyles = {
    [(0, $0e3db6016de1057e$export$84cbff306f539230)]: 'collapse',
    [(0, $0e3db6016de1057e$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $0e3db6016de1057e$export$df38205c966be359)]: 'collapsing',
    [(0, $0e3db6016de1057e$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $5decc35d9948d9fe$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $5decc35d9948d9fe$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $aqdBs.useMemo)(()=>(0, $4d72e478987b878c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $aqdBs.useMemo)(()=>(0, $4d72e478987b878c$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $aqdBs.useMemo)(()=>(0, $4d72e478987b878c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $aqdBs.useMemo)(()=>(0, $4d72e478987b878c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $3698546853b64c13$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $aqdBs.useMemo)(()=>(0, $4d72e478987b878c$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2a0df3c9886be198$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $53292e148448f047$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $2610728fd84fb0e5$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, $5decc35d9948d9fe$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$5decc35d9948d9fe$var$Collapse.displayName = 'Collapse';
var $5decc35d9948d9fe$export$2e2bcd8739ae039 = $5decc35d9948d9fe$var$Collapse;





"use client";
const $e96c158836c7deeb$var$NavbarCollapse = /*#__PURE__*/ $aqdBs.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $aqdBs.useContext)((0, $d1f86d157e090feb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5decc35d9948d9fe$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$e96c158836c7deeb$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $e96c158836c7deeb$export$2e2bcd8739ae039 = $e96c158836c7deeb$var$NavbarCollapse;




var $aqdBs = parcelRequire("aqdBs");




"use client";
const $788f5b39bf0fd13e$var$NavbarToggle = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $aqdBs.useContext)((0, $d1f86d157e090feb$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$788f5b39bf0fd13e$var$NavbarToggle.displayName = 'NavbarToggle';
var $788f5b39bf0fd13e$export$2e2bcd8739ae039 = $788f5b39bf0fd13e$var$NavbarToggle;



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");
const $5fef35b5e0c6895b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $5fef35b5e0c6895b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $5fef35b5e0c6895b$export$2e2bcd8739ae039 = $5fef35b5e0c6895b$var$isDOM || $5fef35b5e0c6895b$var$isReactNative ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);



var $aqdBs = parcelRequire("aqdBs");
const $ef433b9516005bd9$var$matchersByWindow = new WeakMap();
const $ef433b9516005bd9$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $ef433b9516005bd9$var$matchersByWindow.get(targetWindow) || new Map();
    $ef433b9516005bd9$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $ef433b9516005bd9$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $ef433b9516005bd9$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $aqdBs.useState)(()=>mql ? mql.matches : false);
    (0, $5fef35b5e0c6895b$export$2e2bcd8739ae039)(()=>{
        let mql = $ef433b9516005bd9$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $ef433b9516005bd9$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $aqdBs = parcelRequire("aqdBs");
function $68b11815b0dd8a85$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $aqdBs.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $ef433b9516005bd9$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $68b11815b0dd8a85$var$useBreakpoint = $68b11815b0dd8a85$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $68b11815b0dd8a85$export$2e2bcd8739ae039 = $68b11815b0dd8a85$var$useBreakpoint;




var $aqdBs = parcelRequire("aqdBs");

function $7928c6e4d5223063$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");


var $aqdBs = parcelRequire("aqdBs");
function $9fa48a0021e27259$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $aqdBs.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $aqdBs = parcelRequire("aqdBs");
function $a722fb444d332771$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $9fa48a0021e27259$export$2e2bcd8739ae039)(fn);
    (0, $aqdBs.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $d5ff0dbc58416bcb$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $67bedcadd30b6076$export$1a88c12b8b979fa0 = (0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $67bedcadd30b6076$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $d5ff0dbc58416bcb$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($67bedcadd30b6076$export$1a88c12b8b979fa0, '');
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($67bedcadd30b6076$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $67bedcadd30b6076$export$2e2bcd8739ae039 = $67bedcadd30b6076$var$ModalManager;





var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");

const $f2b1da73dc8180d6$var$Context = /*#__PURE__*/ (0, $aqdBs.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $f2b1da73dc8180d6$export$f7d306aeb1cf5fbc = $f2b1da73dc8180d6$var$Context.Provider;
function $f2b1da73dc8180d6$export$2e2bcd8739ae039() {
    return (0, $aqdBs.useContext)($f2b1da73dc8180d6$var$Context);
}


const $f70b8b012312dd3f$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $f70b8b012312dd3f$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $f2b1da73dc8180d6$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $aqdBs.useState)(()=>$f70b8b012312dd3f$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $f70b8b012312dd3f$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $aqdBs.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $aqdBs.useEffect)(()=>{
        const nextRef = $f70b8b012312dd3f$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");

function $df52c76171da2e86$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $aqdBs.useRef)(null);
    const hasEnteredRef = (0, $aqdBs.useRef)(inProp);
    const handleExited = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(onExited);
    (0, $aqdBs.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $820f4a0adc48f832$export$2e2bcd8739ae039)(ref, (0, $2610728fd84fb0e5$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $aqdBs.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $df52c76171da2e86$export$2e2bcd8739ae039 = $df52c76171da2e86$var$NoopTransition;



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");


const $14c313cb4e9d7b5f$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $14c313cb4e9d7b5f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $14c313cb4e9d7b5f$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $14c313cb4e9d7b5f$var$_objectWithoutPropertiesLoose(_ref, $14c313cb4e9d7b5f$var$_excluded);
    const nodeRef = (0, $aqdBs.useRef)(null);
    const mergedRef = (0, $820f4a0adc48f832$export$2e2bcd8739ae039)(nodeRef, (0, $2610728fd84fb0e5$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $aqdBs.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $aqdBs.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $aqdBs.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $aqdBs.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $aqdBs.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $aqdBs.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $aqdBs.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $aqdBs.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $3d0c7fae293a362c$var$_excluded = [
    "component"
];
function $3d0c7fae293a362c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $3d0c7fae293a362c$var$RTGTransition = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $3d0c7fae293a362c$var$_objectWithoutPropertiesLoose(_ref, $3d0c7fae293a362c$var$_excluded);
    const transitionProps = (0, $14c313cb4e9d7b5f$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $3d0c7fae293a362c$export$2e2bcd8739ae039 = $3d0c7fae293a362c$var$RTGTransition;




function $aa7b9676fe28c2b5$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $aqdBs.useRef)(null);
    const isInitialRef = (0, $aqdBs.useRef)(true);
    const handleTransition = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(onTransition);
    (0, $d065d4521e697a75$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $d065d4521e697a75$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $aa7b9676fe28c2b5$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $aqdBs.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $aa7b9676fe28c2b5$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $820f4a0adc48f832$export$2e2bcd8739ae039)(ref, (0, $2610728fd84fb0e5$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $aqdBs.cloneElement)(children, {
        ref: combinedRef
    });
}
function $aa7b9676fe28c2b5$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3d0c7fae293a362c$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($aa7b9676fe28c2b5$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $df52c76171da2e86$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $500f73eb3a0235fa$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $500f73eb3a0235fa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $500f73eb3a0235fa$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $500f73eb3a0235fa$var$getManager(window) {
    if (!$500f73eb3a0235fa$var$manager) $500f73eb3a0235fa$var$manager = new (0, $67bedcadd30b6076$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $500f73eb3a0235fa$var$manager;
}
function $500f73eb3a0235fa$var$useModalManager(provided) {
    const window = (0, $f2b1da73dc8180d6$export$2e2bcd8739ae039)();
    const modalManager = provided || $500f73eb3a0235fa$var$getManager(window);
    const modal = (0, $aqdBs.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $aqdBs.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $aqdBs.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $500f73eb3a0235fa$var$Modal = /*#__PURE__*/ (0, $aqdBs.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $500f73eb3a0235fa$var$_objectWithoutPropertiesLoose(_ref, $500f73eb3a0235fa$var$_excluded);
    const ownerWindow = (0, $f2b1da73dc8180d6$export$2e2bcd8739ae039)();
    const container = (0, $f70b8b012312dd3f$export$2e2bcd8739ae039)(containerRef);
    const modal = $500f73eb3a0235fa$var$useModalManager(providedManager);
    const isMounted = (0, $f27a0e879368208d$export$2e2bcd8739ae039)();
    const prevShow = (0, $ab165df3aa327f31$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $aqdBs.useState)(!show);
    const lastFocusRef = (0, $aqdBs.useRef)(null);
    (0, $aqdBs.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $aqdBs.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $aqdBs.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $a722fb444d332771$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $7928c6e4d5223063$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $2610728fd84fb0e5$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $aqdBs.useRef)();
    const removeKeydownListenerRef = (0, $aqdBs.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $aqdBs.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $aa7b9676fe28c2b5$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $aa7b9676fe28c2b5$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).createPortal(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$500f73eb3a0235fa$var$Modal.displayName = 'Modal';
var $500f73eb3a0235fa$export$2e2bcd8739ae039 = Object.assign($500f73eb3a0235fa$var$Modal, {
    Manager: (0, $67bedcadd30b6076$export$2e2bcd8739ae039)
});




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $4870a576497d7749$var$OffcanvasBody = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$4870a576497d7749$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $4870a576497d7749$export$2e2bcd8739ae039 = $4870a576497d7749$var$OffcanvasBody;




var $aqdBs = parcelRequire("aqdBs");






"use client";
const $6a44ff6a9568ae1c$var$transitionStyles = {
    [(0, $0e3db6016de1057e$export$df38205c966be359)]: 'show',
    [(0, $0e3db6016de1057e$export$78e9e6e3e014d60a)]: 'show'
};
const $6a44ff6a9568ae1c$var$OffcanvasToggling = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2a0df3c9886be198$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $53292e148448f047$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $2610728fd84fb0e5$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $aqdBs.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, (status === (0, $0e3db6016de1057e$export$df38205c966be359) || status === (0, $0e3db6016de1057e$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $6a44ff6a9568ae1c$var$transitionStyles[status])
            })
    });
});
$6a44ff6a9568ae1c$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $6a44ff6a9568ae1c$export$2e2bcd8739ae039 = $6a44ff6a9568ae1c$var$OffcanvasToggling;



var $aqdBs = parcelRequire("aqdBs");
"use client";
const $ae570a9db746b088$var$ModalContext = /*#__PURE__*/ $aqdBs.createContext({
    onHide () {}
});
var $ae570a9db746b088$export$2e2bcd8739ae039 = $ae570a9db746b088$var$ModalContext;




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");




"use client";
const $2ff09717d1c959a9$var$AbstractModalHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $aqdBs.useContext)((0, $ae570a9db746b088$export$2e2bcd8739ae039));
    const handleClick = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c35c25be0f138db7$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$2ff09717d1c959a9$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $2ff09717d1c959a9$export$2e2bcd8739ae039 = $2ff09717d1c959a9$var$AbstractModalHeader;



"use client";
const $c0e6762222af5632$var$OffcanvasHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2ff09717d1c959a9$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$c0e6762222af5632$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $c0e6762222af5632$export$2e2bcd8739ae039 = $c0e6762222af5632$var$OffcanvasHeader;



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


var $2d9f0f6de3c91ab6$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $aqdBs.forwardRef((p, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));




"use client";
const $46d3c9ce0a807d57$var$DivStyledAsH5 = (0, $2d9f0f6de3c91ab6$export$2e2bcd8739ae039)('h5');
const $46d3c9ce0a807d57$var$OffcanvasTitle = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $46d3c9ce0a807d57$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$46d3c9ce0a807d57$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $46d3c9ce0a807d57$export$2e2bcd8739ae039 = $46d3c9ce0a807d57$var$OffcanvasTitle;



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $da42d038f708cdd8$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $9bb1922ade4b5d1d$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9bb1922ade4b5d1d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9bb1922ade4b5d1d$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9bb1922ade4b5d1d$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $0eac6ee0a0a2ad2f$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $0eac6ee0a0a2ad2f$var$BootstrapModalManager extends (0, $67bedcadd30b6076$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $da42d038f708cdd8$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $9bb1922ade4b5d1d$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $e756898da11911b9$export$2e2bcd8739ae039)(container, $0eac6ee0a0a2ad2f$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $0eac6ee0a0a2ad2f$var$sharedManager;
function $0eac6ee0a0a2ad2f$export$a03641438014b436(options) {
    if (!$0eac6ee0a0a2ad2f$var$sharedManager) $0eac6ee0a0a2ad2f$var$sharedManager = new $0eac6ee0a0a2ad2f$var$BootstrapModalManager(options);
    return $0eac6ee0a0a2ad2f$var$sharedManager;
}
var $0eac6ee0a0a2ad2f$export$2e2bcd8739ae039 = $0eac6ee0a0a2ad2f$var$BootstrapModalManager;



"use client";
function $2fc94f796c0fa7d8$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a44ff6a9568ae1c$export$2e2bcd8739ae039), {
        ...props
    });
}
function $2fc94f796c0fa7d8$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $88015c380507f9aa$export$2e2bcd8739ae039), {
        ...props
    });
}
const $2fc94f796c0fa7d8$var$Offcanvas = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $aqdBs.useRef)();
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $aqdBs.useState)(false);
    const handleHide = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $68b11815b0dd8a85$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $aqdBs.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $aqdBs.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $0eac6ee0a0a2ad2f$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $0eac6ee0a0a2ad2f$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $aqdBs.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ae570a9db746b088$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $500f73eb3a0235fa$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $2fc94f796c0fa7d8$var$DialogTransition,
                    backdropTransition: $2fc94f796c0fa7d8$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$2fc94f796c0fa7d8$var$Offcanvas.displayName = 'Offcanvas';
var $2fc94f796c0fa7d8$export$2e2bcd8739ae039 = Object.assign($2fc94f796c0fa7d8$var$Offcanvas, {
    Body: (0, $4870a576497d7749$export$2e2bcd8739ae039),
    Header: (0, $c0e6762222af5632$export$2e2bcd8739ae039),
    Title: (0, $46d3c9ce0a807d57$export$2e2bcd8739ae039)
});




"use client";
const $64819d3069bc7b82$var$NavbarOffcanvas = /*#__PURE__*/ $aqdBs.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $aqdBs.useContext)((0, $d1f86d157e090feb$export$2e2bcd8739ae039));
    const handleHide = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2fc94f796c0fa7d8$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$64819d3069bc7b82$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $64819d3069bc7b82$export$2e2bcd8739ae039 = $64819d3069bc7b82$var$NavbarOffcanvas;





var $aqdBs = parcelRequire("aqdBs");



"use client";
const $26520224b701a70f$var$NavbarText = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$26520224b701a70f$var$NavbarText.displayName = 'NavbarText';
var $26520224b701a70f$export$2e2bcd8739ae039 = $26520224b701a70f$var$NavbarText;



"use client";
const $41fdb0d79be669b6$var$Navbar = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $aqdBs.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $aqdBs.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d1f86d157e090feb$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$41fdb0d79be669b6$var$Navbar.displayName = 'Navbar';
var $41fdb0d79be669b6$export$2e2bcd8739ae039 = Object.assign($41fdb0d79be669b6$var$Navbar, {
    Brand: (0, $6334da406fb550e6$export$2e2bcd8739ae039),
    Collapse: (0, $e96c158836c7deeb$export$2e2bcd8739ae039),
    Offcanvas: (0, $64819d3069bc7b82$export$2e2bcd8739ae039),
    Text: (0, $26520224b701a70f$export$2e2bcd8739ae039),
    Toggle: (0, $788f5b39bf0fd13e$export$2e2bcd8739ae039)
});



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
function $f58208d5835c9adb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f58208d5835c9adb$var$_toPropertyKey(arg) {
    var key = $f58208d5835c9adb$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f58208d5835c9adb$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f58208d5835c9adb$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f58208d5835c9adb$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $aqdBs.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $aqdBs.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $aqdBs.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $f58208d5835c9adb$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $f58208d5835c9adb$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $f58208d5835c9adb$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($f58208d5835c9adb$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $f58208d5835c9adb$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}







var $aqdBs = parcelRequire("aqdBs");
const $85d0e515bc7d6b47$var$DropdownContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $85d0e515bc7d6b47$export$2e2bcd8739ae039 = $85d0e515bc7d6b47$var$DropdownContext;



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $aqdBs = parcelRequire("aqdBs");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $503ede4c8204e528$var$useSafeState(state) {
    const isMounted = (0, $f27a0e879368208d$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $aqdBs.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $503ede4c8204e528$export$2e2bcd8739ae039 = $503ede4c8204e528$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $edbcaa69e3770b50$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


const $e47f2a1f485eb8d5$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $e47f2a1f485eb8d5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $e47f2a1f485eb8d5$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $e47f2a1f485eb8d5$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $e47f2a1f485eb8d5$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $e47f2a1f485eb8d5$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $e47f2a1f485eb8d5$var$EMPTY_MODIFIERS } = _ref, config = $e47f2a1f485eb8d5$var$_objectWithoutPropertiesLoose(_ref, $e47f2a1f485eb8d5$var$_excluded);
    const prevModifiers = (0, $aqdBs.useRef)(modifiers);
    const popperInstanceRef = (0, $aqdBs.useRef)();
    const update = (0, $aqdBs.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $aqdBs.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $503ede4c8204e528$export$2e2bcd8739ae039)((0, $aqdBs.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $aqdBs.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $aqdBs.useMemo)(()=>{
        if (!(0, $9b8288c93dde0611$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $e47f2a1f485eb8d5$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $edbcaa69e3770b50$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $e47f2a1f485eb8d5$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $e47f2a1f485eb8d5$export$2e2bcd8739ae039 = $e47f2a1f485eb8d5$var$usePopper;






var $aqdBs = parcelRequire("aqdBs");

var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


const $63ad55e651dea788$var$noop = ()=>{};
function $63ad55e651dea788$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $63ad55e651dea788$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $63ad55e651dea788$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $63ad55e651dea788$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $63ad55e651dea788$var$useClickOutside(ref, onClickOutside = $63ad55e651dea788$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $aqdBs.useRef)(false);
    const waitingForTrigger = (0, $aqdBs.useRef)(false);
    const handleMouseCapture = (0, $aqdBs.useCallback)((e)=>{
        const currentTarget = $63ad55e651dea788$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $63ad55e651dea788$var$isModifiedEvent(e) || !$63ad55e651dea788$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $63ad55e651dea788$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $aqdBs.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)($63ad55e651dea788$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($63ad55e651dea788$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, $63ad55e651dea788$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $63ad55e651dea788$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $63ad55e651dea788$export$2e2bcd8739ae039 = $63ad55e651dea788$var$useClickOutside;


function $aa8016460e78cecb$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $aa8016460e78cecb$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $aa8016460e78cecb$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $aa8016460e78cecb$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $aa8016460e78cecb$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $44eb59d9bb261bd3$var$_excluded = [
    "children",
    "usePopper"
];
function $44eb59d9bb261bd3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $44eb59d9bb261bd3$var$noop = ()=>{};
function $44eb59d9bb261bd3$export$133c4d08f3775d64(options = {}) {
    const context = (0, $aqdBs.useContext)((0, $85d0e515bc7d6b47$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $eeded26aba791689$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $aqdBs.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $e47f2a1f485eb8d5$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $aa8016460e78cecb$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $44eb59d9bb261bd3$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $63ad55e651dea788$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $44eb59d9bb261bd3$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $44eb59d9bb261bd3$var$_objectWithoutPropertiesLoose(_ref, $44eb59d9bb261bd3$var$_excluded);
    const [props, meta] = $44eb59d9bb261bd3$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: children(props, meta)
    });
}
$44eb59d9bb261bd3$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $44eb59d9bb261bd3$export$2e2bcd8739ae039 = $44eb59d9bb261bd3$var$DropdownMenu;



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $931a064f9195ac3e$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext($931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext);
const $931a064f9195ac3e$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(false);
// This is only used in React < 18.
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $aqdBs.useContext)($931a064f9195ac3e$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $931a064f9195ac3e$var$$b5e257d569688ac6$var$useCounter(cur === $931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $aqdBs.useState)(true);
    let value = (0, $aqdBs.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $aqdBs.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($931a064f9195ac3e$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($931a064f9195ac3e$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $931a064f9195ac3e$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $931a064f9195ac3e$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($931a064f9195ac3e$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $931a064f9195ac3e$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $931a064f9195ac3e$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $aqdBs.useContext)($931a064f9195ac3e$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $aqdBs.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $931a064f9195ac3e$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $931a064f9195ac3e$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $931a064f9195ac3e$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $aqdBs.useContext)($931a064f9195ac3e$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext && $931a064f9195ac3e$var$$b5e257d569688ac6$var$canUseDOM;
    let counter = $931a064f9195ac3e$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useId();
    let [didSSR] = (0, $aqdBs.useState)($931a064f9195ac3e$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$931a064f9195ac3e$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $931a064f9195ac3e$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs)))['useId'] === 'function' ? $931a064f9195ac3e$var$$b5e257d569688ac6$var$useModernSSRSafeId : $931a064f9195ac3e$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $931a064f9195ac3e$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $931a064f9195ac3e$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs)))['useSyncExternalStore']($931a064f9195ac3e$var$$b5e257d569688ac6$var$subscribe, $931a064f9195ac3e$var$$b5e257d569688ac6$var$getSnapshot, $931a064f9195ac3e$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $aqdBs.useContext)($931a064f9195ac3e$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $6a31cec02df2e2b0$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $6a31cec02df2e2b0$var$noop = ()=>{};
function $6a31cec02df2e2b0$export$96df6c7c5036b9a2() {
    const id = (0, $931a064f9195ac3e$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $6a31cec02df2e2b0$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $aqdBs.useContext)((0, $85d0e515bc7d6b47$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $aqdBs.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $6a31cec02df2e2b0$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $6a31cec02df2e2b0$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $6a31cec02df2e2b0$var$DropdownToggle({ children: children }) {
    const [props, meta] = $6a31cec02df2e2b0$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: children(props, meta)
    });
}
$6a31cec02df2e2b0$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $6a31cec02df2e2b0$export$2e2bcd8739ae039 = $6a31cec02df2e2b0$var$DropdownToggle;



var $aqdBs = parcelRequire("aqdBs");






const $e05e2a3156166f5a$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $e05e2a3156166f5a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e05e2a3156166f5a$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $aqdBs.useContext)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039));
    const navContext = (0, $aqdBs.useContext)((0, $b07a729635485a08$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $e05e2a3156166f5a$var$DropdownItem = /*#__PURE__*/ $aqdBs.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $e9fb5029df099253$export$2e2bcd8739ae039) } = _ref, props = $e05e2a3156166f5a$var$_objectWithoutPropertiesLoose(_ref, $e05e2a3156166f5a$var$_excluded);
    const [dropdownItemProps] = $e05e2a3156166f5a$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$e05e2a3156166f5a$var$DropdownItem.displayName = 'DropdownItem';
var $e05e2a3156166f5a$export$2e2bcd8739ae039 = $e05e2a3156166f5a$var$DropdownItem;






function $9a68f15d95fc8fca$var$useRefWithUpdate() {
    const forceUpdate = (0, $f6a7014a69ba84cf$export$2e2bcd8739ae039)();
    const ref = (0, $aqdBs.useRef)(null);
    const attachRef = (0, $aqdBs.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $9a68f15d95fc8fca$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $70e2d12f9898d912$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $f2b1da73dc8180d6$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $f58208d5835c9adb$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $9a68f15d95fc8fca$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $9a68f15d95fc8fca$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $ab165df3aa327f31$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $aqdBs.useRef)(null);
    const focusInDropdown = (0, $aqdBs.useRef)(false);
    const onSelectCtx = (0, $aqdBs.useContext)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039));
    const toggle = (0, $aqdBs.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $aqdBs.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $6a31cec02df2e2b0$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $aqdBs.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $aqdBs.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $fac33539000b66bd$export$2e2bcd8739ae039)((0, $aqdBs.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $85d0e515bc7d6b47$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$9a68f15d95fc8fca$var$Dropdown.displayName = 'Dropdown';
$9a68f15d95fc8fca$var$Dropdown.Menu = (0, $44eb59d9bb261bd3$export$2e2bcd8739ae039);
$9a68f15d95fc8fca$var$Dropdown.Toggle = (0, $6a31cec02df2e2b0$export$2e2bcd8739ae039);
$9a68f15d95fc8fca$var$Dropdown.Item = (0, $e05e2a3156166f5a$export$2e2bcd8739ae039);
var $9a68f15d95fc8fca$export$2e2bcd8739ae039 = $9a68f15d95fc8fca$var$Dropdown;





var $aqdBs = parcelRequire("aqdBs");
"use client";
const $f68fb76b23383f9e$var$DropdownContext = /*#__PURE__*/ $aqdBs.createContext({});
$f68fb76b23383f9e$var$DropdownContext.displayName = 'DropdownContext';
var $f68fb76b23383f9e$export$2e2bcd8739ae039 = $f68fb76b23383f9e$var$DropdownContext;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $759a5b23c5f4a213$var$DropdownDivider = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$759a5b23c5f4a213$var$DropdownDivider.displayName = 'DropdownDivider';
var $759a5b23c5f4a213$export$2e2bcd8739ae039 = $759a5b23c5f4a213$var$DropdownDivider;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $847a958a32fe6e07$var$DropdownHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$847a958a32fe6e07$var$DropdownHeader.displayName = 'DropdownHeader';
var $847a958a32fe6e07$export$2e2bcd8739ae039 = $847a958a32fe6e07$var$DropdownHeader;




var $aqdBs = parcelRequire("aqdBs");




"use client";
const $5b1d4661ec9a4051$var$DropdownItem = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $377fed55abf08a40$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $e05e2a3156166f5a$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$5b1d4661ec9a4051$var$DropdownItem.displayName = 'DropdownItem';
var $5b1d4661ec9a4051$export$2e2bcd8739ae039 = $5b1d4661ec9a4051$var$DropdownItem;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $5e2e4108a12c8a8a$var$DropdownItemText = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$5e2e4108a12c8a8a$var$DropdownItemText.displayName = 'DropdownItemText';
var $5e2e4108a12c8a8a$export$2e2bcd8739ae039 = $5e2e4108a12c8a8a$var$DropdownItemText;




var $aqdBs = parcelRequire("aqdBs");






var $aqdBs = parcelRequire("aqdBs");
"use client";
const $edc22fc6ff75e3dd$var$context = /*#__PURE__*/ $aqdBs.createContext(null);
$edc22fc6ff75e3dd$var$context.displayName = 'InputGroupContext';
var $edc22fc6ff75e3dd$export$2e2bcd8739ae039 = $edc22fc6ff75e3dd$var$context;





parcelRequire("aqdBs");

function $6f2fd97b61ec0878$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $e00b1bdff49f4bb3$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $e00b1bdff49f4bb3$var$DropdownMenu = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $aqdBs.useContext)((0, $d1f86d157e090feb$export$2e2bcd8739ae039));
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $aqdBs.useContext)((0, $f68fb76b23383f9e$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $aqdBs.useContext)((0, $edc22fc6ff75e3dd$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $e00b1bdff49f4bb3$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $44eb59d9bb261bd3$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)((0, $6f2fd97b61ec0878$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $5fef35b5e0c6895b$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$e00b1bdff49f4bb3$var$DropdownMenu.displayName = 'DropdownMenu';
var $e00b1bdff49f4bb3$export$2e2bcd8739ae039 = $e00b1bdff49f4bb3$var$DropdownMenu;







var $aqdBs = parcelRequire("aqdBs");




"use client";
const $187d6b7ee4d4bb78$var$DropdownToggle = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $f068e13e24d891b9$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $aqdBs.useContext)((0, $85d0e515bc7d6b47$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $6a31cec02df2e2b0$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)(toggleProps.ref, (0, $6f2fd97b61ec0878$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$187d6b7ee4d4bb78$var$DropdownToggle.displayName = 'DropdownToggle';
var $187d6b7ee4d4bb78$export$2e2bcd8739ae039 = $187d6b7ee4d4bb78$var$DropdownToggle;






"use client";
const $e57a69b8871951e6$var$Dropdown = /*#__PURE__*/ $aqdBs.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $aqdBs.useContext)((0, $edc22fc6ff75e3dd$export$2e2bcd8739ae039));
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $5f2dec88dec04806$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $e00b1bdff49f4bb3$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $aqdBs.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f68fb76b23383f9e$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9a68f15d95fc8fca$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$e57a69b8871951e6$var$Dropdown.displayName = 'Dropdown';
var $e57a69b8871951e6$export$2e2bcd8739ae039 = Object.assign($e57a69b8871951e6$var$Dropdown, {
    Toggle: (0, $187d6b7ee4d4bb78$export$2e2bcd8739ae039),
    Menu: (0, $e00b1bdff49f4bb3$export$2e2bcd8739ae039),
    Item: (0, $5b1d4661ec9a4051$export$2e2bcd8739ae039),
    ItemText: (0, $5e2e4108a12c8a8a$export$2e2bcd8739ae039),
    Divider: (0, $759a5b23c5f4a213$export$2e2bcd8739ae039),
    Header: (0, $847a958a32fe6e07$export$2e2bcd8739ae039)
});




"use client";
const $aee7c24792c447c0$var$NavDropdown = /*#__PURE__*/ $aqdBs.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e57a69b8871951e6$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $46778ebbc3b4aa22$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$aee7c24792c447c0$var$NavDropdown.displayName = 'NavDropdown';
var $aee7c24792c447c0$export$2e2bcd8739ae039 = Object.assign($aee7c24792c447c0$var$NavDropdown, {
    Item: (0, $e57a69b8871951e6$export$2e2bcd8739ae039).Item,
    ItemText: (0, $e57a69b8871951e6$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $e57a69b8871951e6$export$2e2bcd8739ae039).Divider,
    Header: (0, $e57a69b8871951e6$export$2e2bcd8739ae039).Header
});



var $4RND8 = parcelRequire("4RND8");

var $aqdBs = parcelRequire("aqdBs");






var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");






var $aqdBs = parcelRequire("aqdBs");



const $451add5a63442da8$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $451add5a63442da8$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $451add5a63442da8$var$noop;
    (0, $63ad55e651dea788$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $8f1760d1aabbeb8a$export$2e2bcd8739ae039)((e)=>{
        if ((0, $2610728fd84fb0e5$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $aqdBs.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $63ad55e651dea788$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $451add5a63442da8$export$2e2bcd8739ae039 = $451add5a63442da8$var$useRootClose;





/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $5cf08e7b2c753ef1$var$Overlay = /*#__PURE__*/ $aqdBs.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $eeded26aba791689$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $eeded26aba791689$export$2e2bcd8739ae039)();
    const mergedRef = (0, $820f4a0adc48f832$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $f70b8b012312dd3f$export$2e2bcd8739ae039)(props.container);
    const target = (0, $f70b8b012312dd3f$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $aqdBs.useState)(!props.show);
    const popper = (0, $e47f2a1f485eb8d5$export$2e2bcd8739ae039)(target, rootElement, (0, $aa8016460e78cecb$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $451add5a63442da8$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $aa7b9676fe28c2b5$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).createPortal(child, container) : null;
});
$5cf08e7b2c753ef1$var$Overlay.displayName = 'Overlay';
var $5cf08e7b2c753ef1$export$2e2bcd8739ae039 = $5cf08e7b2c753ef1$var$Overlay;






var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");



"use client";
const $29960a660edf34d5$var$PopoverHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$29960a660edf34d5$var$PopoverHeader.displayName = 'PopoverHeader';
var $29960a660edf34d5$export$2e2bcd8739ae039 = $29960a660edf34d5$var$PopoverHeader;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $7c35866115da3872$var$PopoverBody = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$7c35866115da3872$var$PopoverBody.displayName = 'PopoverBody';
var $7c35866115da3872$export$2e2bcd8739ae039 = $7c35866115da3872$var$PopoverBody;



var $aqdBs = parcelRequire("aqdBs");
class $bc31862ad969592e$export$34582a676b91ff07 extends $aqdBs.Component {
}
function $bc31862ad969592e$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $7e7750e73d6a1d3a$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $f64429daa0540842$var$Popover = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $5f2dec88dec04806$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $bc31862ad969592e$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $7e7750e73d6a1d3a$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7c35866115da3872$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$f64429daa0540842$var$Popover.displayName = 'Popover';
var $f64429daa0540842$export$2e2bcd8739ae039 = Object.assign($f64429daa0540842$var$Popover, {
    Header: (0, $29960a660edf34d5$export$2e2bcd8739ae039),
    Body: (0, $7c35866115da3872$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $aqdBs = parcelRequire("aqdBs");




"use client";
const $7e659b76aa221fec$var$Tooltip = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $5f2dec88dec04806$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $bc31862ad969592e$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $7e7750e73d6a1d3a$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$7e659b76aa221fec$var$Tooltip.displayName = 'Tooltip';
var $7e659b76aa221fec$export$2e2bcd8739ae039 = Object.assign($7e659b76aa221fec$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $d8b5a43df5ebb663$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $aqdBs.useRef)(null);
    const popoverClass = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $aqdBs.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $f64429daa0540842$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $7e659b76aa221fec$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $ec66cc0bc3b17924$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $9078b7d215687fcf$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $9078b7d215687fcf$export$2e2bcd8739ae039)(r)));
}
const $ec66cc0bc3b17924$var$Overlay = /*#__PURE__*/ $aqdBs.forwardRef(({ children: overlay, transition: transition = (0, $88015c380507f9aa$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $aqdBs.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $aqdBs.useState)(null);
    const [ref, modifiers] = (0, $d8b5a43df5ebb663$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $88015c380507f9aa$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $5fef35b5e0c6895b$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5cf08e7b2c753ef1$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $ec66cc0bc3b17924$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $aqdBs.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$ec66cc0bc3b17924$var$Overlay.displayName = 'Overlay';
var $ec66cc0bc3b17924$export$2e2bcd8739ae039 = $ec66cc0bc3b17924$var$Overlay;




"use client";
function $83c279669ca30b29$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $83c279669ca30b29$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $83c279669ca30b29$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $83c279669ca30b29$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $aqdBs.useRef)(null);
    const mergedRef = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)(triggerNodeRef, (0, $2610728fd84fb0e5$export$87943f2672146d57)(children));
    const timeout = (0, $acf91290c5c63471$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $aqdBs.useRef)('');
    const [show, setShow] = (0, $d1750a042e9b894b$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $83c279669ca30b29$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $aqdBs.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $9078b7d215687fcf$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $aqdBs.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $aqdBs.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $aqdBs.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $aqdBs.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $aqdBs.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $aqdBs.useCallback)((...args)=>{
        $83c279669ca30b29$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $aqdBs.useCallback)((...args)=>{
        $83c279669ca30b29$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $aqdBs.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec66cc0bc3b17924$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $83c279669ca30b29$export$2e2bcd8739ae039 = $83c279669ca30b29$var$OverlayTrigger;


var $ec74adfa88abea38$exports = {};
"use strict";
Object.defineProperty($ec74adfa88abea38$exports, "__esModule", {
    value: true
});
Object.defineProperty($ec74adfa88abea38$exports, "LinkContainer", {
    enumerable: true,
    get: function get() {
        return $ec74adfa88abea38$var$_LinkContainer["default"];
    }
});

var $ec74adfa88abea38$var$_LinkContainer = $ec74adfa88abea38$var$_interopRequireDefault((parcelRequire("5fBa6")));
function $ec74adfa88abea38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}


const $dd0e8f82c966a2e6$export$11342ff48ff25735 = (url, width, height)=>{
    return url.replace("{width}", String(width)).replace("{height}", String(height));
};
const $dd0e8f82c966a2e6$export$80d5208c4298f844 = (username)=>{
    return `https://twitch.tv/${username}`;
};
const $dd0e8f82c966a2e6$export$f6b4b72c90d2282f = ()=>{
    const twitchAppClientId = "c5yvlrck46qpcn9m9t28ord605iisi";
    const redirectUrl = encodeURIComponent(String(`${"https://api.helpasaur.com"}/auth/twitch`));
    return `https://id.twitch.tv/oauth2/authorize?client_id=${twitchAppClientId}&redirect_uri=${redirectUrl}&response_type=code&scope=`;
};
const $dd0e8f82c966a2e6$export$41b0274e64b118fa = (redirect)=>{
    return `${"https://api.helpasaur.com"}/auth/logout${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ""}`;
};
const $dd0e8f82c966a2e6$export$bd2a70aaaa2c8a18 = (streams, config)=>{
    if (streams && streams.length > 0) {
        const { blacklistedUsers: blacklistedUsers, channels: channels, statusFilters: statusFilters } = config;
        const speedrunTester = new RegExp(statusFilters, "i");
        const alertUserIds = channels.map((c)=>c.id);
        let filteredAndOrderedStreams;
        // 1. remove streams from users on the blacklist
        filteredAndOrderedStreams = streams.filter((stream)=>!blacklistedUsers.includes(stream.user_id));
        // 2. attempt to filter out most non-speedrun streams
        filteredAndOrderedStreams = filteredAndOrderedStreams.filter((stream)=>!speedrunTester.test(stream.title));
        // 3. feature streams that are in the alert list
        let featuredStreams = filteredAndOrderedStreams.filter((stream)=>alertUserIds.includes(stream.user_id));
        featuredStreams = featuredStreams.map((s)=>{
            s.isOnAlertsList = true;
            return s;
        });
        // 4. now create a merged list, with priorityStreams first, then anything in livestreams that isn't in topStreams
        const otherStreams = filteredAndOrderedStreams.filter((stream)=>{
            const matchIndex = featuredStreams.findIndex((s)=>{
                return s.id === stream.id;
            });
            return matchIndex === -1;
        });
        return {
            featured: featuredStreams,
            other: otherStreams
        };
    } else return {
        featured: [],
        other: []
    };
};
const $dd0e8f82c966a2e6$export$453882cbf4015ef3 = (commands)=>{
    commands.sort((a, b)=>{
        if (a.command < b.command) return -1;
        if (a.command > b.command) return 1;
        return 0;
    });
    return commands;
};
const $dd0e8f82c966a2e6$export$9e52b10d57ddf9e3 = (url)=>{
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
};
const $dd0e8f82c966a2e6$export$e8670ec4b2f7bbfa = (url)=>()=>$dd0e8f82c966a2e6$export$9e52b10d57ddf9e3(url);


parcelRequire("MQCL2");
var $ebiy2 = parcelRequire("ebiy2");

var $aqdBs = parcelRequire("aqdBs");





var $3df5b143c3d301bf$var$_client, $3df5b143c3d301bf$var$_currentResult, $3df5b143c3d301bf$var$_currentMutation, $3df5b143c3d301bf$var$_mutateOptions, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$updateResult_fn, $3df5b143c3d301bf$var$notify_fn;
var $3df5b143c3d301bf$export$d3c1860ee66f291a = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $3df5b143c3d301bf$var$_MutationObserver_instances);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $3df5b143c3d301bf$var$_client);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $3df5b143c3d301bf$var$_currentResult);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $3df5b143c3d301bf$var$_currentMutation);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $3df5b143c3d301bf$var$_mutateOptions);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $3df5b143c3d301bf$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_client).defaultMutationOptions(options);
        if (!(0, $c39459b613f68ef1$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $c39459b613f68ef1$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $c39459b613f68ef1$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$updateResult_fn).call(this);
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $3df5b143c3d301bf$var$_currentMutation, void 0);
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$updateResult_fn).call(this);
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $3df5b143c3d301bf$var$_MutationObserver_instances, $3df5b143c3d301bf$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $3df5b143c3d301bf$var$_mutateOptions, options);
        (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $3df5b143c3d301bf$var$_currentMutation, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_client).getMutationCache().build((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_client), this.options));
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation).addObserver(this);
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation).execute(variables);
    }
};
$3df5b143c3d301bf$var$_client = new WeakMap();
$3df5b143c3d301bf$var$_currentResult = new WeakMap();
$3df5b143c3d301bf$var$_currentMutation = new WeakMap();
$3df5b143c3d301bf$var$_mutateOptions = new WeakMap();
$3df5b143c3d301bf$var$_MutationObserver_instances = new WeakSet();
$3df5b143c3d301bf$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $4e5e6991374d5c52$export$a1659b54bac3252a)();
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $3df5b143c3d301bf$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$3df5b143c3d301bf$var$notify_fn = function(action) {
    (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentResult).variables;
            const context = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $3df5b143c3d301bf$var$_currentResult));
        });
    });
};



"use client";
function $446af12111029965$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $aa6eb665fb0ab93b$export$22e77b9572c4fded)(queryClient);
    const [observer] = $aqdBs.useState(()=>new (0, $3df5b143c3d301bf$export$d3c1860ee66f291a)(client, options));
    $aqdBs.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $aqdBs.useSyncExternalStore($aqdBs.useCallback((onStoreChange)=>observer.subscribe((0, $37ff0854118f026e$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $aqdBs.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $c39459b613f68ef1$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}








var $4d9554472b20c576$var$_client, $4d9554472b20c576$var$_currentQuery, $4d9554472b20c576$var$_currentQueryInitialState, $4d9554472b20c576$var$_currentResult, $4d9554472b20c576$var$_currentResultState, $4d9554472b20c576$var$_currentResultOptions, $4d9554472b20c576$var$_currentThenable, $4d9554472b20c576$var$_selectError, $4d9554472b20c576$var$_selectFn, $4d9554472b20c576$var$_selectResult, $4d9554472b20c576$var$_lastQueryWithDefinedData, $4d9554472b20c576$var$_staleTimeoutId, $4d9554472b20c576$var$_refetchIntervalId, $4d9554472b20c576$var$_currentRefetchInterval, $4d9554472b20c576$var$_trackedProps, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$executeFetch_fn, $4d9554472b20c576$var$updateStaleTimeout_fn, $4d9554472b20c576$var$computeRefetchInterval_fn, $4d9554472b20c576$var$updateRefetchInterval_fn, $4d9554472b20c576$var$updateTimers_fn, $4d9554472b20c576$var$clearStaleTimeout_fn, $4d9554472b20c576$var$clearRefetchInterval_fn, $4d9554472b20c576$var$updateQuery_fn, $4d9554472b20c576$var$notify_fn;
var $4d9554472b20c576$export$a06cf8c0066f0d4c = class extends (0, $aa9353a244703a16$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_QueryObserver_instances);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_client);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentQuery);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentQueryInitialState);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentResult);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentResultState);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentResultOptions);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentThenable);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_selectError);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_selectFn);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_lastQueryWithDefinedData);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_staleTimeoutId);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_refetchIntervalId);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_currentRefetchInterval);
        (0, $847cf46359bd85a0$export$addf369becd23283)(this, $4d9554472b20c576$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_client, client);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_selectError, null);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentThenable, (0, $2f77934bf23faa16$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).addObserver(this);
            if ($4d9554472b20c576$var$shouldFetchOnMount((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery), this.options)) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $4d9554472b20c576$var$shouldFetchOn((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $4d9554472b20c576$var$shouldFetchOn((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$clearStaleTimeout_fn).call(this);
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$clearRefetchInterval_fn).call(this);
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery);
        this.options = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(this.options.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateQuery_fn).call(this);
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $c39459b613f68ef1$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $4d9554472b20c576$var$shouldFetchOptionally((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery) !== prevQuery || (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(this.options.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) !== (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) || (0, $c39459b613f68ef1$export$cb3145f011bda3ac)(this.options.staleTime, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) !== (0, $c39459b613f68ef1$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)))) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery) !== prevQuery || (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(this.options.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) !== (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) || nextRefetchInterval !== (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentRefetchInterval))) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).getQueryCache().build((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client), options);
        const result = this.createResult(query, options);
        if ($4d9554472b20c576$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResult, result);
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResultOptions, this.options);
            (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResultState, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise" && !this.options.experimental_prefetchInRender && (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentThenable).status === "pending") (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).defaultQueryOptions(options);
        const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).getQueryCache().build((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult);
        const prevResultState = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResultState);
        const prevResultOptions = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $4d9554472b20c576$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $4d9554472b20c576$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $cff89193aafe4d4f$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $c39459b613f68ef1$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_selectFn)) data = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_selectResult);
            else try {
                (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $c39459b613f68ef1$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_selectResult, data);
                (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_selectError, null);
            } catch (selectError) {
                (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_selectError, selectError);
            }
        }
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_selectError)) {
            error = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_selectError);
            data = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $4d9554472b20c576$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentThenable),
            isEnabled: (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentThenable, nextResult.promise = (0, $2f77934bf23faa16$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult);
        const nextResult = this.createResult((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery), this.options);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResultState, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).state);
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResultOptions, this.options);
        if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResultState).data !== void 0) (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_lastQueryWithDefinedData, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery));
        if ((0, $c39459b613f68ef1$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateTimers_fn).call(this);
    }
};
$4d9554472b20c576$var$_client = new WeakMap();
$4d9554472b20c576$var$_currentQuery = new WeakMap();
$4d9554472b20c576$var$_currentQueryInitialState = new WeakMap();
$4d9554472b20c576$var$_currentResult = new WeakMap();
$4d9554472b20c576$var$_currentResultState = new WeakMap();
$4d9554472b20c576$var$_currentResultOptions = new WeakMap();
$4d9554472b20c576$var$_currentThenable = new WeakMap();
$4d9554472b20c576$var$_selectError = new WeakMap();
$4d9554472b20c576$var$_selectFn = new WeakMap();
$4d9554472b20c576$var$_selectResult = new WeakMap();
$4d9554472b20c576$var$_lastQueryWithDefinedData = new WeakMap();
$4d9554472b20c576$var$_staleTimeoutId = new WeakMap();
$4d9554472b20c576$var$_refetchIntervalId = new WeakMap();
$4d9554472b20c576$var$_currentRefetchInterval = new WeakMap();
$4d9554472b20c576$var$_trackedProps = new WeakMap();
$4d9554472b20c576$var$_QueryObserver_instances = new WeakSet();
$4d9554472b20c576$var$executeFetch_fn = function(fetchOptions) {
    (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateQuery_fn).call(this);
    let promise = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $c39459b613f68ef1$export$8793edee2d425525));
    return promise;
};
$4d9554472b20c576$var$updateStaleTimeout_fn = function() {
    (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $c39459b613f68ef1$export$cb3145f011bda3ac)(this.options.staleTime, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery));
    if ((0, $c39459b613f68ef1$export$6acf61af03e62db) || (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult).isStale || !(0, $c39459b613f68ef1$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $c39459b613f68ef1$export$811b83d62bcf47f0)((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$4d9554472b20c576$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$4d9554472b20c576$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$clearRefetchInterval_fn).call(this);
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentRefetchInterval, nextInterval);
    if ((0, $c39459b613f68ef1$export$6acf61af03e62db) || (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(this.options.enabled, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) === false || !(0, $c39459b613f68ef1$export$e539f754e934e270)((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentRefetchInterval)) || (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentRefetchInterval) === 0) return;
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $7dc6f441f05492f2$export$6bf54661be5b02cf).isFocused()) (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$executeFetch_fn).call(this);
    }, (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentRefetchInterval)));
};
$4d9554472b20c576$var$updateTimers_fn = function() {
    (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateStaleTimeout_fn).call(this);
    (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$updateRefetchInterval_fn).call(this, (0, $847cf46359bd85a0$export$fa92d15b718fce20)(this, $4d9554472b20c576$var$_QueryObserver_instances, $4d9554472b20c576$var$computeRefetchInterval_fn).call(this));
};
$4d9554472b20c576$var$clearStaleTimeout_fn = function() {
    if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_staleTimeoutId)) {
        clearTimeout((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_staleTimeoutId));
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_staleTimeoutId, void 0);
    }
};
$4d9554472b20c576$var$clearRefetchInterval_fn = function() {
    if ((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_refetchIntervalId)) {
        clearInterval((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_refetchIntervalId));
        (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_refetchIntervalId, void 0);
    }
};
$4d9554472b20c576$var$updateQuery_fn = function() {
    const query = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).getQueryCache().build((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client), this.options);
    if (query === (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery)) return;
    const prevQuery = (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery);
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentQuery, query);
    (0, $847cf46359bd85a0$export$42432efe6614d3b4)(this, $4d9554472b20c576$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$4d9554472b20c576$var$notify_fn = function(notifyOptions) {
    (0, $37ff0854118f026e$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentResult));
        });
        (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_client).getQueryCache().notify({
            query: (0, $847cf46359bd85a0$export$18a094aefa070634)(this, $4d9554472b20c576$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $4d9554472b20c576$var$shouldLoadOnMount(query, options) {
    return (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $4d9554472b20c576$var$shouldFetchOnMount(query, options) {
    return $4d9554472b20c576$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $4d9554472b20c576$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $4d9554472b20c576$var$shouldFetchOn(query, options, field) {
    if ((0, $c39459b613f68ef1$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $c39459b613f68ef1$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $4d9554472b20c576$var$isStale(query, options);
    }
    return false;
}
function $4d9554472b20c576$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $4d9554472b20c576$var$isStale(query, options);
}
function $4d9554472b20c576$var$isStale(query, options) {
    return (0, $c39459b613f68ef1$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $c39459b613f68ef1$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $4d9554472b20c576$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $c39459b613f68ef1$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");

"use client";
function $7e398242b27c4035$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $7e398242b27c4035$var$QueryErrorResetBoundaryContext = $aqdBs.createContext($7e398242b27c4035$var$createValue());
var $7e398242b27c4035$export$50dfac555130cafd = ()=>$aqdBs.useContext($7e398242b27c4035$var$QueryErrorResetBoundaryContext);
var $7e398242b27c4035$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $aqdBs.useState(()=>$7e398242b27c4035$var$createValue());
    return /* @__PURE__ */ (0, $14024a6d51999040$exports.jsx)($7e398242b27c4035$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $aqdBs = parcelRequire("aqdBs");

"use client";
var $1599a62dbf0d8960$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $1599a62dbf0d8960$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $aqdBs.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $1599a62dbf0d8960$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $c39459b613f68ef1$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $aqdBs = parcelRequire("aqdBs");
"use client";
var $bb16fd91324904fa$var$IsRestoringContext = $aqdBs.createContext(false);
var $bb16fd91324904fa$export$4da0178d6b5f553 = ()=>$aqdBs.useContext($bb16fd91324904fa$var$IsRestoringContext);
var $bb16fd91324904fa$export$593807d4e94f9621 = $bb16fd91324904fa$var$IsRestoringContext.Provider;


// src/suspense.ts
var $83e3d064779f4768$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $83e3d064779f4768$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? 1e3, 1e3);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $83e3d064779f4768$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $83e3d064779f4768$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $83e3d064779f4768$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $a4294ff1281a2e22$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const isRestoring = (0, $bb16fd91324904fa$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $7e398242b27c4035$export$50dfac555130cafd)();
    const client = (0, $aa6eb665fb0ab93b$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $83e3d064779f4768$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $1599a62dbf0d8960$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $1599a62dbf0d8960$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $aqdBs.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $aqdBs.useSyncExternalStore($aqdBs.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $37ff0854118f026e$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $c39459b613f68ef1$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $aqdBs.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $83e3d064779f4768$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $83e3d064779f4768$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $1599a62dbf0d8960$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $c39459b613f68ef1$export$6acf61af03e62db) && (0, $83e3d064779f4768$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $83e3d064779f4768$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $c39459b613f68ef1$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $1023973c4f7e99e0$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $a4294ff1281a2e22$export$fff0865807e996c5)(options, (0, $4d9554472b20c576$export$a06cf8c0066f0d4c), queryClient);
}


var $5b324850aad5b127$exports = {};
"use strict";
var $5b324850aad5b127$var$__createBinding = $5b324850aad5b127$exports && $5b324850aad5b127$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5b324850aad5b127$var$__exportStar = $5b324850aad5b127$exports && $5b324850aad5b127$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5b324850aad5b127$var$__createBinding(exports1, m, p);
};
Object.defineProperty($5b324850aad5b127$exports, "__esModule", {
    value: true
});
$5b324850aad5b127$exports.ApiError = $5b324850aad5b127$exports.HelpaApi = void 0;
var $935db1064a8ec900$exports = {};
"use strict";
var $935db1064a8ec900$var$__importDefault = $935db1064a8ec900$exports && $935db1064a8ec900$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($935db1064a8ec900$exports, "__esModule", {
    value: true
});
$935db1064a8ec900$exports.HelpaApi = void 0;

const $935db1064a8ec900$var$axios_1 = $935db1064a8ec900$var$__importDefault((parcelRequire("eiXmw")));

const $935db1064a8ec900$var$axios_retry_1 = $935db1064a8ec900$var$__importDefault((parcelRequire("hUxka")));

var $i96EK = parcelRequire("i96EK");
var $b2906b968263fb90$exports = {};
"use strict";
var $b2906b968263fb90$var$__createBinding = $b2906b968263fb90$exports && $b2906b968263fb90$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b2906b968263fb90$var$__exportStar = $b2906b968263fb90$exports && $b2906b968263fb90$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b2906b968263fb90$var$__createBinding(exports1, m, p);
};
Object.defineProperty($b2906b968263fb90$exports, "__esModule", {
    value: true
});

$b2906b968263fb90$var$__exportStar((parcelRequire("g84pr")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("lyp8m")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("2yxqp")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("jxgeY")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("7TguA")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("6yM2y")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("8rlsI")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("99BCC")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("c9Ph7")), $b2906b968263fb90$exports);

$b2906b968263fb90$var$__exportStar((parcelRequire("fQaPp")), $b2906b968263fb90$exports);



var $1Su43 = parcelRequire("1Su43");
/**
 * Helps external clients and internal services use the Helpa API
 */ class $935db1064a8ec900$var$HelpaApi {
    apiHost;
    apiKey;
    serviceName;
    webMode;
    accessToken = null;
    api;
    // Route-specific API endpoints
    commands;
    configs;
    discord;
    me;
    prac;
    twitch;
    streamAlerts;
    streams;
    testEvents;
    web;
    /**
     * Constructs a new HelpaApi instance.
     * @param options - The options for configuring the HelpaApi instance.
     * @throws {Error} If any of the required constructor values are missing.
     */ constructor(options){
        const { apiHost: apiHost, apiKey: apiKey, serviceName: serviceName, webMode: webMode = false } = options;
        this.apiHost = apiHost;
        this.apiKey = apiKey;
        this.serviceName = serviceName;
        this.webMode = webMode;
        // Throw an error if any of the required constructor values are missing
        if (!this.apiHost || !this.serviceName) throw new Error(`HelpaApi constructor requires apiHost and serviceName`);
        // API key is required for service mode, optional for web mode
        if (!this.webMode && !this.apiKey) throw new Error(`HelpaApi constructor requires apiKey when not in webMode`);
        this.api = $935db1064a8ec900$var$axios_1.default.create({
            baseURL: this.apiHost,
            headers: {
                "X-Service-Name": serviceName
            },
            withCredentials: this.webMode,
            validateStatus: ()=>true
        });
        (0, $935db1064a8ec900$var$axios_retry_1.default)(this.api, {
            retries: 20,
            retryDelay: ()=>10000,
            onRetry: (retryCount, error, requestConfig)=>{
                console.log(`\u{1F534} API Request Error:`, error.toString());
                console.log(`\u{1F501} Retrying call to ${requestConfig.url} (attempt #${retryCount})`);
            }
        });
        // Initialize route-specific API endpoints
        this.commands = new $b2906b968263fb90$exports.CommandRoutes(this.api);
        this.configs = new $b2906b968263fb90$exports.ConfigsRoutes(this.api);
        this.discord = new $b2906b968263fb90$exports.DiscordRoutes(this.api);
        this.me = new $b2906b968263fb90$exports.MeRoutes(this.api);
        this.prac = new $b2906b968263fb90$exports.PracRoutes(this.api);
        this.streamAlerts = new $b2906b968263fb90$exports.StreamAlertsRoutes(this.api);
        this.streams = new $b2906b968263fb90$exports.StreamRoutes(this.api);
        this.testEvents = new $b2906b968263fb90$exports.TestEventsRoutes(this.api);
        this.twitch = new $b2906b968263fb90$exports.TwitchRoutes(this.api);
        this.web = new $b2906b968263fb90$exports.WebRoutes(this.api);
    }
    /**
     * Authorizes the service with the API using the provided API key
     * In web mode, this method always returns true as user auth is handled by cookies
     * @returns Promise resolving to true if service is authorized successfully, false otherwise
     * @throws Error logged to console if authorization fails (does not throw exception)
     */ async authorizeService() {
        // Skip authorization in web mode - user auth handled by cookies
        if (this.webMode) return true;
        try {
            const response = await this.api.get(`${$1Su43.ROUTES.AUTH}/service`, {
                headers: {
                    Authorization: this.apiKey
                }
            });
            if (response.data.result === $i96EK.ApiResult.ERROR) throw new Error(response.data.message || "Authorization failed");
            if (response.data.result === $i96EK.ApiResult.SUCCESS && response.data.data?.token) {
                this.accessToken = response.data.data.token;
                // Use JWT for all subsequent calls
                this.api.defaults.headers.common["Authorization"] = `Bearer ${this.accessToken}`;
                console.log(`\u{2705} Service authorized with API!`);
                return true;
            }
            throw new Error(response.data.message || "Authorization failed");
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "Unknown error";
            console.error(`\u{1F534} Error authorizing service: ${errorMessage}`);
            return false;
        }
    }
    /**
     * Retrieves the service configuration from the API
     * Automatically authorizes the service first if not already authenticated
     * @returns Promise resolving to the service configuration object
     * @throws Error if authorization fails or the API request fails
     */ async getServiceConfig() {
        try {
            // auth first if necessary
            let authorized = this.accessToken !== null;
            if (!authorized) authorized = await this.authorizeService();
            if (!authorized) throw new Error(`\u{1F534} Unable to authorize service with API!`);
            const response = await this.api.get(`${$1Su43.ROUTES.CONFIGS}/${this.serviceName}`);
            if (response.data.result === $i96EK.ApiResult.ERROR) throw new Error(response.data.message || "Failed to get service config");
            if (response.data.result === $i96EK.ApiResult.SUCCESS && response.data.data) return response.data.data;
            throw new Error(response.data.message || "Failed to get service config");
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "Unknown error";
            throw new Error(`\u{1F534} Error fetching service config: ${errorMessage}`);
        }
    }
}
$935db1064a8ec900$exports.HelpaApi = $935db1064a8ec900$var$HelpaApi;


Object.defineProperty($5b324850aad5b127$exports, "HelpaApi", {
    enumerable: true,
    get: function() {
        return $935db1064a8ec900$exports.HelpaApi;
    }
});

// Export types
$5b324850aad5b127$var$__exportStar((parcelRequire("ck9Lg")), $5b324850aad5b127$exports);

var $eiXmw = parcelRequire("eiXmw");
Object.defineProperty($5b324850aad5b127$exports, "ApiError", {
    enumerable: true,
    get: function() {
        return $eiXmw.AxiosError;
    }
});



// Create API client for web app usage
const $2d05e1b5e9934777$var$helpaApiClient = new (0, $5b324850aad5b127$exports.HelpaApi)({
    apiHost: "https://api.helpasaur.com",
    serviceName: "web",
    webMode: true
});
const $2d05e1b5e9934777$export$7e8232793e4d788f = ()=>{
    const queryClient = (0, $aa6eb665fb0ab93b$export$22e77b9572c4fded)();
    const toast = (0, $2829a8981f6f0f18$export$a407b657d3044108)();
    // Query hooks for read operations
    const queries = {
        /**
     * Get web configuration
     */ useConfig: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "config"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.web.getWebConfig(),
                staleTime: 3600000,
                ...options
            }),
        /**
     * Get current user
     */ useUser: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "user"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.me.getCurrentUser(),
                retry: 0,
                ...options
            }),
        /**
     * Get all commands
     */ useCommands: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "commands"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getCommands(),
                ...options
            }),
        /**
     * Get live streams
     */ useLivestreams: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "livestreams"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.streams.getLivestreams(),
                refetchInterval: 60000,
                ...options
            }),
        /**
     * Get Discord join URL
     */ useDiscordJoinUrl: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "discordJoinUrl"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.discord.getDiscordJoinUrl(),
                ...options
            }),
        /**
     * Get user's Twitch bot configuration
     */ useTwitchBotConfig: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "twitchBotConfig"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.me.getTwitchBotConfig(),
                retry: 0,
                ...options
            }),
        /**
     * Get Twitch bot channels
     */ useTwitchBotChannels: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "twitchBotChannels"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.twitch.getTwitchBotChannels(),
                ...options
            }),
        /**
     * Get stream alerts channels
     */ useStreamAlertsChannels: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "streamAlertsChannels"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.getStreamAlertsChannels(),
                ...options
            }),
        /**
     * Get EventSub subscriptions
     */ useEventSubSubscriptions: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "eventSubSubscriptions"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.getEventSubSubscriptions(),
                enabled: false,
                ...options
            }),
        /**
     * Get command statistics overview
     */ useCommandStatsOverview: (timeRange, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "commandStatsOverview",
                    timeRange
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getCommandStatsOverview(timeRange),
                ...options
            }),
        /**
     * Get top commands by usage
     */ useTopCommands: (limit, timeRange, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "topCommands",
                    limit,
                    timeRange
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getTopCommands(limit, timeRange),
                ...options
            }),
        /**
     * Get platform breakdown statistics
     */ usePlatformBreakdown: (timeRange, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "platformBreakdown",
                    timeRange
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getPlatformBreakdown(timeRange),
                ...options
            }),
        /**
     * Get top users by command usage
     */ useTopUsers: (limit, timeRange, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "topUsers",
                    limit,
                    timeRange
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getTopUsers(limit, timeRange),
                ...options
            }),
        /**
     * Get command usage timeline
     */ useCommandTimeline: (timeRange, interval, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "commandTimeline",
                    timeRange,
                    interval
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getCommandTimeline(timeRange, interval),
                ...options
            }),
        /**
     * Get recent command logs
     */ useRecentCommands: (page, limit, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "recentCommands",
                    page,
                    limit
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getRecentCommands(page, limit),
                ...options
            }),
        /**
     * Get top channels/guilds by command usage
     */ useTopChannels: (limit, timeRange, platform, options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "topChannels",
                    limit,
                    timeRange,
                    platform
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getTopChannels(limit, timeRange, platform),
                ...options
            }),
        /**
     * Get all unique tags currently in use
     */ useTags: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "tags"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getTags(),
                ...options
            }),
        /**
     * Get tag usage statistics
     */ useTagStats: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "tagStats"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getTagStats(),
                ...options
            }),
        /**
     * Get count of untagged commands
     */ useUntaggedCount: (options)=>(0, $1023973c4f7e99e0$export$dd0a697e1782aedd)({
                queryKey: [
                    "untaggedCount"
                ],
                queryFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.commands.getUntaggedCount(),
                ...options
            })
    };
    // Mutation hooks for write operations
    const mutations = {
        /**
     * Update Twitch bot configuration
     */ useUpdateTwitchBotConfig: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (config)=>$2d05e1b5e9934777$var$helpaApiClient.twitch.updateTwitchBotConfig(config),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "twitchBotConfig"
                        ]
                    });
                    if (showToast) toast.success("Twitch bot configuration updated!");
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to update configuration: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Join Twitch channel
     */ useJoinTwitchChannel: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (twitchUsername)=>$2d05e1b5e9934777$var$helpaApiClient.twitch.joinTwitchChannel(twitchUsername),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "twitchBotChannels"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "twitchBotConfig"
                        ]
                    });
                    if (showToast) toast.success(`Joined ${variables || "your channel"}!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to join channel: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Leave Twitch channel
     */ useLeaveTwitchChannel: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (twitchUsername)=>$2d05e1b5e9934777$var$helpaApiClient.twitch.leaveTwitchChannel(twitchUsername),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "twitchBotChannels"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "twitchBotConfig"
                        ]
                    });
                    if (showToast) toast.success(`Left ${variables || "your channel"}!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to leave channel: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Create command
     */ useCreateCommand: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (command)=>$2d05e1b5e9934777$var$helpaApiClient.commands.createCommand(command),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "commands"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "tagStats"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "untaggedCount"
                        ]
                    });
                    if (showToast) toast.success(`Command '${variables.command}' created!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Unable to create command: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Update command
     */ useUpdateCommand: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (command)=>$2d05e1b5e9934777$var$helpaApiClient.commands.updateCommand(command),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "commands"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "tagStats"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "untaggedCount"
                        ]
                    });
                    if (showToast) toast.success(`Command '${variables.command}' updated!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Unable to update command: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Delete command
     */ useDeleteCommand: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (command)=>$2d05e1b5e9934777$var$helpaApiClient.commands.deleteCommand(command),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "commands"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "tagStats"
                        ]
                    });
                    queryClient.invalidateQueries({
                        queryKey: [
                            "untaggedCount"
                        ]
                    });
                    if (showToast) toast.success(`Command '${variables.command}' deleted!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Unable to delete command: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Add channel to stream alerts
     */ useAddChannelToStreamAlerts: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (twitchUsername)=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.addChannelToStreamAlerts(twitchUsername),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "streamAlertsChannels"
                        ]
                    });
                    if (showToast) toast.success(`Added ${variables} to stream alerts!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to add ${variables} to stream alerts: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Remove channel from stream alerts
     */ useRemoveChannelFromStreamAlerts: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (twitchUserId)=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.removeChannelFromStreamAlerts(twitchUserId),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "streamAlertsChannels"
                        ]
                    });
                    if (showToast) toast.success(`Removed ${variables} from stream alerts!`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to remove ${variables} from stream alerts: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Clear all EventSub subscriptions
     */ useClearAllSubscriptions: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.clearAllSubscriptions(),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "eventSubSubscriptions"
                        ]
                    });
                    if (showToast) toast.success("All subscriptions cleared!");
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to clear subscriptions: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Re-subscribe all currently watched channels
     */ useResubscribeAllChannels: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: ()=>$2d05e1b5e9934777$var$helpaApiClient.streamAlerts.resubscribeAllChannels(),
                onSuccess: (data, variables, context)=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "eventSubSubscriptions"
                        ]
                    });
                    if (showToast) toast.success("Re-subscribed all channels!");
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to re-subscribe channels: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        },
        /**
     * Trigger a test event
     */ useTriggerTestEvent: (options)=>{
            const { showToast: showToast = true, ...mutationOptions } = options || {};
            return (0, $446af12111029965$export$609860bf8b0084c)({
                mutationFn: (payload)=>$2d05e1b5e9934777$var$helpaApiClient.testEvents.triggerTestEvent(payload),
                onSuccess: (data, variables, context)=>{
                    if (showToast) toast.success(`Test event triggered! Check Discord/Twitch for reactions.`);
                    mutationOptions.onSuccess?.(data, variables, context);
                },
                onError: (error, variables, context)=>{
                    if (showToast) toast.error(`Failed to trigger test event: ${error.message}`);
                    mutationOptions.onError?.(error, variables, context);
                },
                ...mutationOptions
            });
        }
    };
    return {
        ...queries,
        ...mutations,
        client: $2d05e1b5e9934777$var$helpaApiClient
    };
};


const $c1640065410c8bfe$var$popover = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f64429daa0540842$export$2e2bcd8739ae039), {
    placement: "bottom",
    id: "helpa-popover",
    children: [
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f64429daa0540842$export$2e2bcd8739ae039).Header, {
            as: "h3",
            children: "Hello!"
        }),
        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f64429daa0540842$export$2e2bcd8739ae039).Body, {
            className: "bg-dark",
            children: [
                "I'm ",
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                    children: "Helpasaur King"
                }),
                " and I'm very high in potassium... like a banana! \uD83C\uDF4C"
            ]
        })
    ]
});
var $015c09f898440a6c$exports = {};
$015c09f898440a6c$exports = import.meta.resolve("gPzXY");


function $c1640065410c8bfe$var$TopNav() {
    const { data: user, isPending: userIsPending } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useUser();
    const { data: config, isPending: configIsPending } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useConfig();
    const logo = new URL($015c09f898440a6c$exports).toString();
    const location = (0, $ebiy2.useLocation)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $41fdb0d79be669b6$export$2e2bcd8739ae039), {
            expand: "lg",
            bg: "dark",
            sticky: "top",
            className: "px-3",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $83c279669ca30b29$export$2e2bcd8739ae039), {
                    placement: "bottom",
                    overlay: $c1640065410c8bfe$var$popover,
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $41fdb0d79be669b6$export$2e2bcd8739ae039).Brand, {
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("img", {
                            alt: "",
                            src: logo,
                            width: "32",
                            height: "32",
                            className: "d-inline-block align-top"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $41fdb0d79be669b6$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "top-nav"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $41fdb0d79be669b6$export$2e2bcd8739ae039).Collapse, {
                    id: "top-nav",
                    role: "",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039), {
                            className: "me-auto",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec74adfa88abea38$exports.LinkContainer), {
                                    to: "commands",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-terminal pe-1"
                                            }),
                                            "Commands"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec74adfa88abea38$exports.LinkContainer), {
                                    to: "streams",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-brands fa-twitch pe-1"
                                            }),
                                            "ALttP Streams"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec74adfa88abea38$exports.LinkContainer), {
                                    to: "twitch",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-robot pe-1"
                                            }),
                                            "Twitch Bot"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec74adfa88abea38$exports.LinkContainer), {
                                    to: "discord",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-brands fa-discord pe-1"
                                            }),
                                            "Discord Bot"
                                        ]
                                    })
                                }),
                                user && user.permissions.includes("admin") && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ec74adfa88abea38$exports.LinkContainer), {
                                    to: "admin",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-user-tie pe-1"
                                            }),
                                            "Admin"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                    href: "https://github.com/greenham/helpasaur-king",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-brands fa-github pe-1"
                                        }),
                                        "GitHub"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $aee7c24792c447c0$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-link pe-1"
                                            }),
                                            "Resources"
                                        ]
                                    }),
                                    id: "resources-dropdown",
                                    align: "end",
                                    children: !configIsPending && config && config.resources && config.resources.length > 0 && config.resources.map((resource, index)=>resource.divider ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $aee7c24792c447c0$export$2e2bcd8739ae039).Divider, {}, index) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $aee7c24792c447c0$export$2e2bcd8739ae039).Item, {
                                            href: resource.href,
                                            target: resource.target,
                                            rel: resource.rel,
                                            children: [
                                                resource.icon && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: `${resource.icon} pe-1`
                                                }),
                                                resource.text
                                            ]
                                        }, index))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039), {
                            className: "justify-content-end",
                            children: [
                                !userIsPending && user && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $aee7c24792c447c0$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1e353161c142be0d$export$2e2bcd8739ae039), {
                                        src: user.twitchUserData.profile_image_url,
                                        roundedCircle: true,
                                        className: "bg-dark ml-3",
                                        alt: `Logged in as ${user.twitchUserData.display_name}`,
                                        width: 32,
                                        height: 32
                                    }),
                                    id: "user-dropdown",
                                    align: "end",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $aee7c24792c447c0$export$2e2bcd8739ae039).Item, {
                                        href: (0, $dd0e8f82c966a2e6$export$41b0274e64b118fa)(location.pathname),
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-arrow-right-from-bracket"
                                            }),
                                            " Log Out"
                                        ]
                                    })
                                }),
                                !userIsPending && !user && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039).Link, {
                                    href: (0, $dd0e8f82c966a2e6$export$f6b4b72c90d2282f)(),
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-key pe-1"
                                            }),
                                            "Log in with Twitch"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $c1640065410c8bfe$export$2e2bcd8739ae039 = $c1640065410c8bfe$var$TopNav;


const $cbc2be53dae69283$var$App = ()=>{
    const toast = (0, $2829a8981f6f0f18$export$a407b657d3044108)();
    const queryClient = new (0, $1de7da191eb55f71$export$405d0624ed55a03f)({
        queryCache: new (0, $dfd3a34c0b01afbe$export$5dde0cd941da8468)({
            onError: (error, query)=>{
                if (query.state.data !== undefined) toast.error(`Something went wrong: ${error.message}`);
            }
        })
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $aa6eb665fb0ab93b$export$45604f0cc8ae667b), {
        client: queryClient,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $MQCL2.ScrollRestoration), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $8e399e97629ab9e4$export$f5d03d415824e0e), {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c1640065410c8bfe$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ebiy2.Outlet), {})
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $20c30cac66318740$export$fd1469cb3147d866), {
                initialIsOpen: false
            })
        ]
    });
};
var $cbc2be53dae69283$export$2e2bcd8739ae039 = $cbc2be53dae69283$var$App;




var $ebiy2 = parcelRequire("ebiy2");



var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");




"use client";
const $6b1169a67cd7225e$var$DivStyledAsH4 = (0, $2d9f0f6de3c91ab6$export$2e2bcd8739ae039)('h4');
$6b1169a67cd7225e$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $6b1169a67cd7225e$var$AlertHeading = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $6b1169a67cd7225e$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$6b1169a67cd7225e$var$AlertHeading.displayName = 'AlertHeading';
var $6b1169a67cd7225e$export$2e2bcd8739ae039 = $6b1169a67cd7225e$var$AlertHeading;



var $aqdBs = parcelRequire("aqdBs");




"use client";
const $0acb8dd4319a1ba3$var$AlertLink = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $377fed55abf08a40$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$0acb8dd4319a1ba3$var$AlertLink.displayName = 'AlertLink';
var $0acb8dd4319a1ba3$export$2e2bcd8739ae039 = $0acb8dd4319a1ba3$var$AlertLink;





"use client";
const $4ec9043b326fe2a2$var$Alert = /*#__PURE__*/ $aqdBs.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $88015c380507f9aa$export$2e2bcd8739ae039), ...props } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $88015c380507f9aa$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c35c25be0f138db7$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$4ec9043b326fe2a2$var$Alert.displayName = 'Alert';
var $4ec9043b326fe2a2$export$2e2bcd8739ae039 = Object.assign($4ec9043b326fe2a2$var$Alert, {
    Link: (0, $0acb8dd4319a1ba3$export$2e2bcd8739ae039),
    Heading: (0, $6b1169a67cd7225e$export$2e2bcd8739ae039)
});




var $aqdBs = parcelRequire("aqdBs");


"use client";
const $65e02d38214c434c$var$Container = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$65e02d38214c434c$var$Container.displayName = 'Container';
var $65e02d38214c434c$export$2e2bcd8739ae039 = $65e02d38214c434c$var$Container;


function $5f7e6ee651796020$export$2e2bcd8739ae039() {
    const error = (0, $ebiy2.useRouteError)();
    console.error(error);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c1640065410c8bfe$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                className: "mt-5",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                    variant: "info",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039).Heading, {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    class: "fa-solid fa-circle-exclamation"
                                }),
                                " Oops!"
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                            children: "Sorry, an unexpected error has occurred."
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                children: error.statusText || error.message
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $aqdBs = parcelRequire("aqdBs");

function $e15ef1230fe62e1a$export$2e2bcd8739ae039() {
    (0, $aqdBs.useEffect)(()=>{
        document.title = "Page Not Found | Helpasaur King";
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
            className: "mt-5",
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                variant: "dark",
                className: "p-5",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039).Heading, {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                class: "fa-solid fa-circle-question"
                            }),
                            " Page Not Found"
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                        children: "The page you requested does not exist."
                    })
                ]
            })
        })
    });
}




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


"use client";
const $adc2638fc2e44871$var$Spinner = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$adc2638fc2e44871$var$Spinner.displayName = 'Spinner';
var $adc2638fc2e44871$export$2e2bcd8739ae039 = $adc2638fc2e44871$var$Spinner;




var $aqdBs = parcelRequire("aqdBs");
parcelRequire("MQCL2");
var $ebiy2 = parcelRequire("ebiy2");

var $aqdBs = parcelRequire("aqdBs");
function $0e4526841ae0db4c$export$e70e6da722faba05(e, u, c, i) {
    var a = this, o = (0, $aqdBs.useRef)(null), f = (0, $aqdBs.useRef)(0), l = (0, $aqdBs.useRef)(0), v = (0, $aqdBs.useRef)(null), m = (0, $aqdBs.useRef)([]), d = (0, $aqdBs.useRef)(), g = (0, $aqdBs.useRef)(), p = (0, $aqdBs.useRef)(e), w = (0, $aqdBs.useRef)(!0);
    p.current = e;
    var s = "undefined" != typeof window, x = !u && 0 !== u && s;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    u = +u || 0;
    var h = !!(c = c || {}).leading, y = !("trailing" in c) || !!c.trailing, F = "maxWait" in c, A = "debounceOnServer" in c && !!c.debounceOnServer, D = F ? Math.max(+c.maxWait || 0, u) : null;
    (0, $aqdBs.useEffect)(function() {
        return w.current = !0, function() {
            w.current = !1;
        };
    }, []);
    var T = (0, $aqdBs.useMemo)(function() {
        var r = function(r) {
            var n = m.current, t = d.current;
            return m.current = d.current = null, f.current = r, l.current = l.current || r, g.current = p.current.apply(t, n);
        }, n = function(r, n) {
            x && cancelAnimationFrame(v.current), v.current = x ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!w.current) return !1;
            var n = r - o.current;
            return !o.current || n >= u || n < 0 || F && r - f.current >= D;
        }, e = function(n) {
            return v.current = null, y && m.current ? r(n) : (m.current = d.current = null, g.current);
        }, c = function r() {
            var c = Date.now();
            if (h && l.current === f.current && T(), t(c)) return e(c);
            if (w.current) {
                var i = u - (c - o.current), a = F ? Math.min(i, D - (c - f.current)) : i;
                n(r, a);
            }
        }, T = function() {
            i && i({});
        }, W = function() {
            if (s || A) {
                var e = Date.now(), i = t(e);
                if (m.current = [].slice.call(arguments), d.current = a, o.current = e, i) {
                    if (!v.current && w.current) return f.current = o.current, n(c, u), h ? r(o.current) : g.current;
                    if (F) return n(c, u), r(o.current);
                }
                return v.current || n(c, u), g.current;
            }
        };
        return W.cancel = function() {
            v.current && (x ? cancelAnimationFrame(v.current) : clearTimeout(v.current)), f.current = 0, m.current = o.current = d.current = v.current = null;
        }, W.isPending = function() {
            return !!v.current;
        }, W.flush = function() {
            return v.current ? e(Date.now()) : g.current;
        }, W;
    }, [
        h,
        F,
        u,
        D,
        y,
        x,
        s,
        A,
        i
    ]);
    return T;
}
function $0e4526841ae0db4c$var$i(r, n) {
    return r === n;
}
function $0e4526841ae0db4c$export$21805fee57372823(n, t, a) {
    var o = a && a.equalityFn || $0e4526841ae0db4c$var$i, f = (0, $aqdBs.useRef)(n), l = (0, $aqdBs.useState)({})[1], v = $0e4526841ae0db4c$export$e70e6da722faba05((0, $aqdBs.useCallback)(function(r) {
        f.current = r, l({});
    }, [
        l
    ]), t, a, l), m = (0, $aqdBs.useRef)(n);
    return o(m.current, n) || (v(n), m.current = n), [
        f.current,
        v
    ];
}
function $0e4526841ae0db4c$export$7158785e55df0693(r, n, t) {
    var e = void 0 === t ? {} : t, u = e.leading, i = e.trailing;
    return $0e4526841ae0db4c$export$e70e6da722faba05(r, n, {
        maxWait: n,
        leading: void 0 === u || u,
        trailing: void 0 === i || i
    });
}




var $aqdBs = parcelRequire("aqdBs");


"use client";
const $2683667890e6910d$var$Badge = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$2683667890e6910d$var$Badge.displayName = 'Badge';
var $2683667890e6910d$export$2e2bcd8739ae039 = $2683667890e6910d$var$Badge;



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");



"use client";
const $10f576f82dc360c9$var$CardBody = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$10f576f82dc360c9$var$CardBody.displayName = 'CardBody';
var $10f576f82dc360c9$export$2e2bcd8739ae039 = $10f576f82dc360c9$var$CardBody;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $9c274d151d8f8302$var$CardFooter = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$9c274d151d8f8302$var$CardFooter.displayName = 'CardFooter';
var $9c274d151d8f8302$export$2e2bcd8739ae039 = $9c274d151d8f8302$var$CardFooter;




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $7cf0f407d640213f$var$CardHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $aqdBs.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $bfd172c9514a4560$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix)
        })
    });
});
$7cf0f407d640213f$var$CardHeader.displayName = 'CardHeader';
var $7cf0f407d640213f$export$2e2bcd8739ae039 = $7cf0f407d640213f$var$CardHeader;




var $aqdBs = parcelRequire("aqdBs");


"use client";
const $ba75e1d4c09a805b$var$CardImg = /*#__PURE__*/ $aqdBs.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$ba75e1d4c09a805b$var$CardImg.displayName = 'CardImg';
var $ba75e1d4c09a805b$export$2e2bcd8739ae039 = $ba75e1d4c09a805b$var$CardImg;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $e50987736531bce0$var$CardImgOverlay = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$e50987736531bce0$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $e50987736531bce0$export$2e2bcd8739ae039 = $e50987736531bce0$var$CardImgOverlay;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $90ef3a525faeb544$var$CardLink = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$90ef3a525faeb544$var$CardLink.displayName = 'CardLink';
var $90ef3a525faeb544$export$2e2bcd8739ae039 = $90ef3a525faeb544$var$CardLink;



var $aqdBs = parcelRequire("aqdBs");




"use client";
const $8ec06d01f55a3986$var$DivStyledAsH6 = (0, $2d9f0f6de3c91ab6$export$2e2bcd8739ae039)('h6');
const $8ec06d01f55a3986$var$CardSubtitle = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $8ec06d01f55a3986$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$8ec06d01f55a3986$var$CardSubtitle.displayName = 'CardSubtitle';
var $8ec06d01f55a3986$export$2e2bcd8739ae039 = $8ec06d01f55a3986$var$CardSubtitle;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $1d45d8af9e455680$var$CardText = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1d45d8af9e455680$var$CardText.displayName = 'CardText';
var $1d45d8af9e455680$export$2e2bcd8739ae039 = $1d45d8af9e455680$var$CardText;



var $aqdBs = parcelRequire("aqdBs");




"use client";
const $98a645800c79d44f$var$DivStyledAsH5 = (0, $2d9f0f6de3c91ab6$export$2e2bcd8739ae039)('h5');
const $98a645800c79d44f$var$CardTitle = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $98a645800c79d44f$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$98a645800c79d44f$var$CardTitle.displayName = 'CardTitle';
var $98a645800c79d44f$export$2e2bcd8739ae039 = $98a645800c79d44f$var$CardTitle;



"use client";
const $386893b3d9dd26b3$var$Card = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $10f576f82dc360c9$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$386893b3d9dd26b3$var$Card.displayName = 'Card';
var $386893b3d9dd26b3$export$2e2bcd8739ae039 = Object.assign($386893b3d9dd26b3$var$Card, {
    Img: (0, $ba75e1d4c09a805b$export$2e2bcd8739ae039),
    Title: (0, $98a645800c79d44f$export$2e2bcd8739ae039),
    Subtitle: (0, $8ec06d01f55a3986$export$2e2bcd8739ae039),
    Body: (0, $10f576f82dc360c9$export$2e2bcd8739ae039),
    Link: (0, $90ef3a525faeb544$export$2e2bcd8739ae039),
    Text: (0, $1d45d8af9e455680$export$2e2bcd8739ae039),
    Header: (0, $7cf0f407d640213f$export$2e2bcd8739ae039),
    Footer: (0, $9c274d151d8f8302$export$2e2bcd8739ae039),
    ImgOverlay: (0, $e50987736531bce0$export$2e2bcd8739ae039)
});



var $aqdBs = parcelRequire("aqdBs");


"use client";
function $d6aefb3504f34578$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $5f2dec88dec04806$export$8970c8db816a5863)();
    const minBreakpoint = (0, $5f2dec88dec04806$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $d6aefb3504f34578$var$Col = /*#__PURE__*/ $aqdBs.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $d6aefb3504f34578$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$d6aefb3504f34578$var$Col.displayName = 'Col';
var $d6aefb3504f34578$export$2e2bcd8739ae039 = $d6aefb3504f34578$var$Col;



var $4RND8 = parcelRequire("4RND8");

var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");

var $4RND8 = parcelRequire("4RND8");

const $e1de891d3a0c74ee$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).elementType
};
const $e1de891d3a0c74ee$var$Feedback = /*#__PURE__*/ $aqdBs.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$e1de891d3a0c74ee$var$Feedback.displayName = 'Feedback';
$e1de891d3a0c74ee$var$Feedback.propTypes = $e1de891d3a0c74ee$var$propTypes;
var $e1de891d3a0c74ee$export$2e2bcd8739ae039 = $e1de891d3a0c74ee$var$Feedback;




var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
"use client";
// TODO
const $974695095f916e50$var$FormContext = /*#__PURE__*/ $aqdBs.createContext({});
var $974695095f916e50$export$2e2bcd8739ae039 = $974695095f916e50$var$FormContext;




"use client";
const $508e2ae4967115eb$var$FormCheckInput = /*#__PURE__*/ $aqdBs.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$508e2ae4967115eb$var$FormCheckInput.displayName = 'FormCheckInput';
var $508e2ae4967115eb$export$2e2bcd8739ae039 = $508e2ae4967115eb$var$FormCheckInput;




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $fc3dd7f3aef019bc$var$FormCheckLabel = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix)
    });
});
$fc3dd7f3aef019bc$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $fc3dd7f3aef019bc$export$2e2bcd8739ae039 = $fc3dd7f3aef019bc$var$FormCheckLabel;





var $aqdBs = parcelRequire("aqdBs");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $bae8b0130f1809ac$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $aqdBs.Children.map(children, (child)=>/*#__PURE__*/ $aqdBs.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $bae8b0130f1809ac$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $aqdBs.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $aqdBs.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $bae8b0130f1809ac$export$500fd6099226ffae(children, type) {
    return $aqdBs.Children.toArray(children).some((child)=>/*#__PURE__*/ $aqdBs.isValidElement(child) && child.type === type);
}



"use client";
const $31efd150c0b51d0f$var$FormCheck = /*#__PURE__*/ $aqdBs.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    const innerFormContext = (0, $aqdBs.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $bae8b0130f1809ac$export$500fd6099226ffae)(children, (0, $fc3dd7f3aef019bc$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $508e2ae4967115eb$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $974695095f916e50$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fc3dd7f3aef019bc$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e1de891d3a0c74ee$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$31efd150c0b51d0f$var$FormCheck.displayName = 'FormCheck';
var $31efd150c0b51d0f$export$2e2bcd8739ae039 = Object.assign($31efd150c0b51d0f$var$FormCheck, {
    Input: (0, $508e2ae4967115eb$export$2e2bcd8739ae039),
    Label: (0, $fc3dd7f3aef019bc$export$2e2bcd8739ae039)
});




var $aqdBs = parcelRequire("aqdBs");





"use client";
const $156d87e8b9fda2cf$var$FormControl = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$156d87e8b9fda2cf$var$FormControl.displayName = 'FormControl';
var $156d87e8b9fda2cf$export$2e2bcd8739ae039 = Object.assign($156d87e8b9fda2cf$var$FormControl, {
    Feedback: $e1de891d3a0c74ee$export$2e2bcd8739ae039
});



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $87e6952dbcc4457f$var$FormFloating = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$87e6952dbcc4457f$var$FormFloating.displayName = 'FormFloating';
var $87e6952dbcc4457f$export$2e2bcd8739ae039 = $87e6952dbcc4457f$var$FormFloating;



var $aqdBs = parcelRequire("aqdBs");


const $10b765e94035d150$var$FormGroup = /*#__PURE__*/ $aqdBs.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $aqdBs.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $974695095f916e50$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$10b765e94035d150$var$FormGroup.displayName = 'FormGroup';
var $10b765e94035d150$export$2e2bcd8739ae039 = $10b765e94035d150$var$FormGroup;




var $aqdBs = parcelRequire("aqdBs");





"use client";
const $c7b970155d407696$var$FormLabel = /*#__PURE__*/ $aqdBs.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$c7b970155d407696$var$FormLabel.displayName = 'FormLabel';
var $c7b970155d407696$export$2e2bcd8739ae039 = $c7b970155d407696$var$FormLabel;




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $5ee7be39ae7ba398$var$FormRange = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$5ee7be39ae7ba398$var$FormRange.displayName = 'FormRange';
var $5ee7be39ae7ba398$export$2e2bcd8739ae039 = $5ee7be39ae7ba398$var$FormRange;




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $079ce48051155103$var$FormSelect = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aqdBs.useContext)((0, $974695095f916e50$export$2e2bcd8739ae039));
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$079ce48051155103$var$FormSelect.displayName = 'FormSelect';
var $079ce48051155103$export$2e2bcd8739ae039 = $079ce48051155103$var$FormSelect;




var $aqdBs = parcelRequire("aqdBs");


"use client";
const $239411920b47ea80$var$FormText = /*#__PURE__*/ $aqdBs.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$239411920b47ea80$var$FormText.displayName = 'FormText';
var $239411920b47ea80$export$2e2bcd8739ae039 = $239411920b47ea80$var$FormText;



var $aqdBs = parcelRequire("aqdBs");


const $26631574e619a4bc$var$Switch = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $31efd150c0b51d0f$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$26631574e619a4bc$var$Switch.displayName = 'Switch';
var $26631574e619a4bc$export$2e2bcd8739ae039 = Object.assign($26631574e619a4bc$var$Switch, {
    Input: (0, $31efd150c0b51d0f$export$2e2bcd8739ae039).Input,
    Label: (0, $31efd150c0b51d0f$export$2e2bcd8739ae039).Label
});




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $9fce716723ca1c72$var$FloatingLabel = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $10b765e94035d150$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$9fce716723ca1c72$var$FloatingLabel.displayName = 'FloatingLabel';
var $9fce716723ca1c72$export$2e2bcd8739ae039 = $9fce716723ca1c72$var$FloatingLabel;



const $6aec98047d2d5a85$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).elementType
};
const $6aec98047d2d5a85$var$Form = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, validated && 'was-validated')
    }));
$6aec98047d2d5a85$var$Form.displayName = 'Form';
$6aec98047d2d5a85$var$Form.propTypes = $6aec98047d2d5a85$var$propTypes;
var $6aec98047d2d5a85$export$2e2bcd8739ae039 = Object.assign($6aec98047d2d5a85$var$Form, {
    Group: (0, $10b765e94035d150$export$2e2bcd8739ae039),
    Control: (0, $156d87e8b9fda2cf$export$2e2bcd8739ae039),
    Floating: (0, $87e6952dbcc4457f$export$2e2bcd8739ae039),
    Check: (0, $31efd150c0b51d0f$export$2e2bcd8739ae039),
    Switch: $26631574e619a4bc$export$2e2bcd8739ae039,
    Label: (0, $c7b970155d407696$export$2e2bcd8739ae039),
    Text: (0, $239411920b47ea80$export$2e2bcd8739ae039),
    Range: (0, $5ee7be39ae7ba398$export$2e2bcd8739ae039),
    Select: (0, $079ce48051155103$export$2e2bcd8739ae039),
    FloatingLabel: $9fce716723ca1c72$export$2e2bcd8739ae039
});



var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $fd6e8daa920a40a2$var$InputGroupText = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$fd6e8daa920a40a2$var$InputGroupText.displayName = 'InputGroupText';
var $fd6e8daa920a40a2$export$2e2bcd8739ae039 = $fd6e8daa920a40a2$var$InputGroupText;



"use client";
const $75a33122b50af2fb$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fd6e8daa920a40a2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $508e2ae4967115eb$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $75a33122b50af2fb$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fd6e8daa920a40a2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $508e2ae4967115eb$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $75a33122b50af2fb$var$InputGroup = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $aqdBs.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $edc22fc6ff75e3dd$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$75a33122b50af2fb$var$InputGroup.displayName = 'InputGroup';
var $75a33122b50af2fb$export$2e2bcd8739ae039 = Object.assign($75a33122b50af2fb$var$InputGroup, {
    Text: (0, $fd6e8daa920a40a2$export$2e2bcd8739ae039),
    Radio: $75a33122b50af2fb$var$InputGroupRadio,
    Checkbox: $75a33122b50af2fb$var$InputGroupCheckbox
});







var $9c19bd5bfd1a1a58$var$size;
function $9c19bd5bfd1a1a58$export$2e2bcd8739ae039(recalc) {
    if (!$9c19bd5bfd1a1a58$var$size && $9c19bd5bfd1a1a58$var$size !== 0 || recalc) {
        if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9c19bd5bfd1a1a58$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9c19bd5bfd1a1a58$var$size;
}



var $aqdBs = parcelRequire("aqdBs");
function $34f86a7eed23b346$export$2e2bcd8739ae039() {
    return (0, $aqdBs.useState)(null);
}







var $aqdBs = parcelRequire("aqdBs");




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $c878629abe0ca4a5$var$ModalBody = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c878629abe0ca4a5$var$ModalBody.displayName = 'ModalBody';
var $c878629abe0ca4a5$export$2e2bcd8739ae039 = $c878629abe0ca4a5$var$ModalBody;





var $aqdBs = parcelRequire("aqdBs");


"use client";
const $cdbf7a6af52f3537$var$ModalDialog = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$cdbf7a6af52f3537$var$ModalDialog.displayName = 'ModalDialog';
var $cdbf7a6af52f3537$export$2e2bcd8739ae039 = $cdbf7a6af52f3537$var$ModalDialog;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $711df922ebfb0b92$var$ModalFooter = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$711df922ebfb0b92$var$ModalFooter.displayName = 'ModalFooter';
var $711df922ebfb0b92$export$2e2bcd8739ae039 = $711df922ebfb0b92$var$ModalFooter;




var $aqdBs = parcelRequire("aqdBs");



"use client";
const $92d3be0678dc764f$var$ModalHeader = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2ff09717d1c959a9$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$92d3be0678dc764f$var$ModalHeader.displayName = 'ModalHeader';
var $92d3be0678dc764f$export$2e2bcd8739ae039 = $92d3be0678dc764f$var$ModalHeader;



var $aqdBs = parcelRequire("aqdBs");




"use client";
const $cee96014d75577ae$var$DivStyledAsH4 = (0, $2d9f0f6de3c91ab6$export$2e2bcd8739ae039)('h4');
const $cee96014d75577ae$var$ModalTitle = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $cee96014d75577ae$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$cee96014d75577ae$var$ModalTitle.displayName = 'ModalTitle';
var $cee96014d75577ae$export$2e2bcd8739ae039 = $cee96014d75577ae$var$ModalTitle;




"use client";
function $2d59ed3cbba7f8ad$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $88015c380507f9aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $2d59ed3cbba7f8ad$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $88015c380507f9aa$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $2d59ed3cbba7f8ad$var$Modal = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $cdbf7a6af52f3537$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $aqdBs.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $aqdBs.useState)(false);
    const waitingForMouseUpRef = (0, $aqdBs.useRef)(false);
    const ignoreBackdropClickRef = (0, $aqdBs.useRef)(false);
    const removeStaticModalAnimationRef = (0, $aqdBs.useRef)(null);
    const [modal, setModalRef] = (0, $34f86a7eed23b346$export$2e2bcd8739ae039)();
    const mergedRef = (0, $7210c9eb4cf3b493$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $5f2dec88dec04806$export$35e511eefa30ac5a)();
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $aqdBs.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $0eac6ee0a0a2ad2f$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $9c19bd5bfd1a1a58$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $22c98e2b45f24dde$export$2e2bcd8739ae039)(()=>{
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $aqdBs.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ae570a9db746b088$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $500f73eb3a0235fa$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $2d59ed3cbba7f8ad$var$DialogTransition : undefined,
            backdropTransition: animation ? $2d59ed3cbba7f8ad$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$2d59ed3cbba7f8ad$var$Modal.displayName = 'Modal';
var $2d59ed3cbba7f8ad$export$2e2bcd8739ae039 = Object.assign($2d59ed3cbba7f8ad$var$Modal, {
    Body: (0, $c878629abe0ca4a5$export$2e2bcd8739ae039),
    Header: (0, $92d3be0678dc764f$export$2e2bcd8739ae039),
    Title: (0, $cee96014d75577ae$export$2e2bcd8739ae039),
    Footer: (0, $711df922ebfb0b92$export$2e2bcd8739ae039),
    Dialog: (0, $cdbf7a6af52f3537$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $aqdBs = parcelRequire("aqdBs");


"use client";
const $1d182f2238d754ea$var$Row = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $5f2dec88dec04806$export$8970c8db816a5863)();
    const minBreakpoint = (0, $5f2dec88dec04806$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$1d182f2238d754ea$var$Row.displayName = 'Row';
var $1d182f2238d754ea$export$2e2bcd8739ae039 = $1d182f2238d754ea$var$Row;



var $aqdBs = parcelRequire("aqdBs");


var $4RND8 = parcelRequire("4RND8");

function $95fb8357b2deccd4$export$3d03cefad97f5c33(propType) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        propType,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function $95fb8357b2deccd4$export$2e2bcd8739ae039(utilityValues, breakpoints = (0, $5f2dec88dec04806$export$666ad80b5007f835), minBreakpoint = (0, $5f2dec88dec04806$export$ff817e17bad2e091)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === 'object') breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}



"use client";
const $e78ed12bdf61965d$var$Stack = /*#__PURE__*/ $aqdBs.forwardRef(({ as: Component = 'div', bsPrefix: bsPrefix, className: className, direction: direction, gap: gap, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, direction === 'horizontal' ? 'hstack' : 'vstack');
    const breakpoints = (0, $5f2dec88dec04806$export$8970c8db816a5863)();
    const minBreakpoint = (0, $5f2dec88dec04806$export$d926d6ef38f3fd32)();
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, ...(0, $95fb8357b2deccd4$export$2e2bcd8739ae039)({
            gap: gap
        }, breakpoints, minBreakpoint))
    });
});
$e78ed12bdf61965d$var$Stack.displayName = 'Stack';
var $e78ed12bdf61965d$export$2e2bcd8739ae039 = $e78ed12bdf61965d$var$Stack;



var $aqdBs = parcelRequire("aqdBs");


"use client";
const $162086630506a5b8$var$Table = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$162086630506a5b8$var$Table.displayName = 'Table';
var $162086630506a5b8$export$2e2bcd8739ae039 = $162086630506a5b8$var$Table;



parcelRequire("aqdBs");
const $b779653ac309924d$var$LinkifyText = ({ text: text })=>{
    // Regular expression to identify URLs in text
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    // Split the text into parts, where URLs are and where they are not
    const parts = text.split(urlRegex);
    // Map the parts to React elements, making URLs clickable
    const elements = parts.map((part, index)=>urlRegex.test(part) ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
            href: part,
            target: "_blank",
            rel: "noopener noreferrer",
            children: part
        }, index) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
            children: part
        }, index));
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: elements
    });
};
var $b779653ac309924d$export$2e2bcd8739ae039 = $b779653ac309924d$var$LinkifyText;




var $aqdBs = parcelRequire("aqdBs");

var $88669423f27f9541$exports = {};
"use strict";
/**
 * @helpasaur/common
 * Shared utilities and functionality for all Helpasaur services
 */ var $88669423f27f9541$var$__createBinding = $88669423f27f9541$exports && $88669423f27f9541$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88669423f27f9541$var$__exportStar = $88669423f27f9541$exports && $88669423f27f9541$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88669423f27f9541$var$__createBinding(exports1, m, p);
};
Object.defineProperty($88669423f27f9541$exports, "__esModule", {
    value: true
});

$88669423f27f9541$var$__exportStar((parcelRequire("5aEkg")), $88669423f27f9541$exports);

$88669423f27f9541$var$__exportStar((parcelRequire("5XAy2")), $88669423f27f9541$exports);

$88669423f27f9541$var$__exportStar((parcelRequire("doRA7")), $88669423f27f9541$exports);





var $aqdBs = parcelRequire("aqdBs");


const $ac24b0898fa427c7$var$TagInput = ({ tags: tags, existingTags: existingTags, onChange: onChange, placeholder: placeholder = "Type to add tags...", label: label, className: className = "" })=>{
    const [inputValue, setInputValue] = (0, $aqdBs.useState)("");
    const [showSuggestions, setShowSuggestions] = (0, $aqdBs.useState)(false);
    const [highlightedIndex, setHighlightedIndex] = (0, $aqdBs.useState)(-1);
    const inputRef = (0, $aqdBs.useRef)(null);
    const blurTimeoutRef = (0, $aqdBs.useRef)(null);
    // Filter existing tags based on input and exclude already selected tags
    const filteredSuggestions = existingTags.filter((tag)=>tag.toLowerCase().includes(inputValue.toLowerCase()) && !tags.includes(tag)).slice(0, 10) // Limit suggestions
    ;
    (0, $aqdBs.useEffect)(()=>{
        // Show suggestions if there's input and either existing suggestions OR the input can create a new tag
        const canCreateNew = Boolean(inputValue.trim() && !existingTags.includes(inputValue.trim()));
        setShowSuggestions(inputValue.length > 0 && (filteredSuggestions.length > 0 || canCreateNew));
        setHighlightedIndex(-1);
    }, [
        inputValue,
        filteredSuggestions.length,
        existingTags
    ]);
    // Cleanup timeout on unmount
    (0, $aqdBs.useEffect)(()=>{
        return ()=>{
            if (blurTimeoutRef.current) clearTimeout(blurTimeoutRef.current);
        };
    }, []);
    const addTag = (tag)=>{
        const normalizedTag = (0, $88669423f27f9541$exports.normalizeTag)(tag);
        if (normalizedTag && !tags.includes(normalizedTag)) onChange([
            ...tags,
            normalizedTag
        ]);
        setInputValue("");
        setShowSuggestions(false);
        inputRef.current?.focus();
    };
    const removeTag = (tagToRemove)=>{
        onChange(tags.filter((tag)=>tag !== tagToRemove));
        inputRef.current?.focus();
    };
    const handleInputChange = (e)=>{
        const value = e.target.value;
        // Handle comma-separated input
        if (value.includes(",")) {
            const newTags = value.split(",").map((tag)=>(0, $88669423f27f9541$exports.normalizeTag)(tag)).filter((tag)=>tag.length > 0);
            const uniqueNewTags = newTags.filter((tag)=>!tags.includes(tag));
            if (uniqueNewTags.length > 0) onChange([
                ...tags,
                ...uniqueNewTags
            ]);
            setInputValue("");
            return;
        }
        setInputValue(value);
    };
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
                e.preventDefault();
                if (highlightedIndex >= 0 && filteredSuggestions[highlightedIndex]) addTag(filteredSuggestions[highlightedIndex]);
                else if (inputValue.trim()) addTag(inputValue.trim());
                break;
            // Backspace removal disabled - use X button to remove tags
            case "ArrowDown":
                e.preventDefault();
                setHighlightedIndex(Math.min(highlightedIndex + 1, filteredSuggestions.length - 1));
                break;
            case "ArrowUp":
                e.preventDefault();
                setHighlightedIndex(Math.max(highlightedIndex - 1, -1));
                break;
            case "Escape":
                setShowSuggestions(false);
                setHighlightedIndex(-1);
                break;
        }
    };
    const highlightMatch = (text, query)=>{
        if (!query) return text;
        const index = text.toLowerCase().indexOf(query.toLowerCase());
        if (index === -1) return text;
        return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
            children: [
                text.substring(0, index),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                    children: text.substring(index, index + query.length)
                }),
                text.substring(index + query.length)
            ]
        });
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: `position-relative ${className}`,
        children: [
            label && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Label, {
                children: label
            }),
            tags.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                    direction: "horizontal",
                    gap: 1,
                    className: "flex-wrap",
                    children: tags.map((tag, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                            bg: "secondary",
                            className: "d-flex align-items-center",
                            style: {
                                fontSize: "0.9rem"
                            },
                            children: [
                                tag,
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    className: "p-0 ms-1 text-white",
                                    style: {
                                        fontSize: "0.8rem",
                                        lineHeight: 1
                                    },
                                    onClick: ()=>removeTag(tag),
                                    "aria-label": `Remove ${tag} tag`,
                                    children: "\xd7"
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                ref: inputRef,
                type: "text",
                value: inputValue,
                onChange: handleInputChange,
                onKeyDown: handleKeyDown,
                onFocus: ()=>{
                    const canCreateNew = Boolean(inputValue.trim() && !existingTags.includes(inputValue.trim()));
                    setShowSuggestions(inputValue.length > 0 && (filteredSuggestions.length > 0 || canCreateNew));
                },
                onBlur: ()=>{
                    // Clear any existing timeout
                    if (blurTimeoutRef.current) clearTimeout(blurTimeoutRef.current);
                    // Set new timeout with cleanup reference
                    blurTimeoutRef.current = setTimeout(()=>{
                        setShowSuggestions(false);
                        blurTimeoutRef.current = null;
                    }, 150);
                },
                placeholder: placeholder
            }),
            showSuggestions && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Menu, {
                show: true,
                className: "w-100 mt-1",
                style: {
                    maxHeight: "200px",
                    overflowY: "auto"
                },
                children: [
                    filteredSuggestions.map((tag, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Item, {
                            active: index === highlightedIndex,
                            onClick: ()=>{
                                // Clear blur timeout when clicking suggestion
                                if (blurTimeoutRef.current) {
                                    clearTimeout(blurTimeoutRef.current);
                                    blurTimeoutRef.current = null;
                                }
                                addTag(tag);
                            },
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    children: highlightMatch(tag, inputValue)
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                                    bg: "secondary",
                                    className: "ms-2",
                                    children: "existing"
                                })
                            ]
                        }, tag)),
                    inputValue.trim() && !existingTags.includes(inputValue.trim()) && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Item, {
                        active: highlightedIndex === filteredSuggestions.length,
                        onClick: ()=>addTag(inputValue.trim()),
                        className: "d-flex justify-content-between align-items-center border-top",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                                children: [
                                    'Add "',
                                    inputValue.trim(),
                                    '"'
                                ]
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                                bg: "success",
                                className: "ms-2",
                                children: "new"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ac24b0898fa427c7$export$2e2bcd8739ae039 = $ac24b0898fa427c7$var$TagInput;




var $aqdBs = parcelRequire("aqdBs");

const $99badf2fce5d03c6$var$AliasInput = ({ aliases: aliases, onChange: onChange, placeholder: placeholder = "Type to add aliases...", label: label, className: className = "" })=>{
    const [inputValue, setInputValue] = (0, $aqdBs.useState)("");
    const inputRef = (0, $aqdBs.useRef)(null);
    const addAlias = (alias)=>{
        const trimmedAlias = alias.trim();
        if (trimmedAlias && !aliases.includes(trimmedAlias)) onChange([
            ...aliases,
            trimmedAlias
        ]);
        setInputValue("");
        inputRef.current?.focus();
    };
    const removeAlias = (aliasToRemove)=>{
        onChange(aliases.filter((alias)=>alias !== aliasToRemove));
        inputRef.current?.focus();
    };
    const handleInputChange = (e)=>{
        const value = e.target.value;
        // Handle comma-separated input
        if (value.includes(",")) {
            const newAliases = value.split(",").map((alias)=>alias.trim()).filter((alias)=>alias.length > 0);
            const uniqueNewAliases = newAliases.filter((alias)=>!aliases.includes(alias));
            if (uniqueNewAliases.length > 0) onChange([
                ...aliases,
                ...uniqueNewAliases
            ]);
            setInputValue("");
            return;
        }
        setInputValue(value);
    };
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
                e.preventDefault();
                if (inputValue.trim()) addAlias(inputValue.trim());
                break;
        }
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Label, {
                children: label
            }),
            aliases.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                    direction: "horizontal",
                    gap: 1,
                    className: "flex-wrap",
                    children: aliases.map((alias, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                            bg: "secondary",
                            className: "d-flex align-items-center",
                            style: {
                                fontSize: "0.9rem"
                            },
                            children: [
                                alias,
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                    variant: "link",
                                    size: "sm",
                                    className: "p-0 ms-1 text-white",
                                    style: {
                                        fontSize: "0.8rem",
                                        lineHeight: 1
                                    },
                                    onClick: ()=>removeAlias(alias),
                                    "aria-label": `Remove ${alias} alias`,
                                    children: "\xd7"
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                ref: inputRef,
                type: "text",
                value: inputValue,
                onChange: handleInputChange,
                onKeyDown: handleKeyDown,
                placeholder: placeholder
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Text, {
                className: "text-muted",
                children: "Press Enter or use commas to add multiple aliases"
            })
        ]
    });
};
var $99badf2fce5d03c6$export$2e2bcd8739ae039 = $99badf2fce5d03c6$var$AliasInput;


const $3e35d167d80a8cb7$var$CommandFormModal = (props)=>{
    const [command, setCommand] = $aqdBs.useState(()=>({
            command: props.command.command || "",
            response: props.command.response || "",
            aliases: props.command.aliases || [],
            tags: props.command.tags || [],
            ...props.command
        }));
    const { show: show, onHide: onHide, onSubmit: onSubmit } = props;
    const { data: tagStats = [] } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useTagStats({
        enabled: show
    });
    // Extract tag names from stats (this is working in CommandsList)
    const existingTags = tagStats.map((stat)=>stat.tag);
    $aqdBs.useEffect(()=>{
        setCommand({
            command: props.command.command || "",
            response: props.command.response || "",
            aliases: props.command.aliases || [],
            tags: props.command.tags || [],
            ...props.command
        });
    }, [
        props.command
    ]);
    const handleChange = (e)=>{
        const key = e.target.name;
        const value = e.target.value;
        setCommand((prev)=>({
                ...prev,
                [key]: value
            }));
    };
    const responseLength = (command.response || "").length;
    const isOverLimit = responseLength > (0, $88669423f27f9541$exports.TWITCH_MAX_MESSAGE_LENGTH);
    const handleSubmit = ()=>{
        onSubmit(command);
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039), {
        show: show,
        onHide: onHide,
        centered: true,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Title, {
                    children: command._id ? `Editing: ${command.command}` : "New Command"
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                        controlId: "commandName",
                        label: "Command name",
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                            type: "text",
                            placeholder: "obaeb",
                            name: "command",
                            value: command.command || "",
                            onChange: handleChange
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                        controlId: "commandResponse",
                        label: "Response",
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                                as: "textarea",
                                placeholder: "Stop! Don't shoot fire stick in space canoe! Cause explosive decompression! You can crush me but you can't crush my spirit! Why, those are the Grunka-Lunkas! They work here in the Slurm factory. If rubbin' frozen dirt in your crotch is wrong, hey I don't wanna be right.",
                                style: {
                                    height: "200px"
                                },
                                name: "response",
                                value: command.response || "",
                                onChange: handleChange,
                                isInvalid: isOverLimit
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Text, {
                                className: isOverLimit ? "text-danger" : "text-muted",
                                children: [
                                    responseLength,
                                    "/",
                                    (0, $88669423f27f9541$exports.TWITCH_MAX_MESSAGE_LENGTH)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $99badf2fce5d03c6$export$2e2bcd8739ae039), {
                        aliases: command.aliases || [],
                        onChange: (aliases)=>setCommand((prev)=>({
                                    ...prev,
                                    aliases: aliases
                                })),
                        placeholder: "Type alias and press Enter...",
                        label: "Command Aliases",
                        className: "mb-3"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ac24b0898fa427c7$export$2e2bcd8739ae039), {
                        tags: command.tags || [],
                        existingTags: existingTags,
                        onChange: (tags)=>setCommand((prev)=>({
                                    ...prev,
                                    tags: tags
                                })),
                        placeholder: "Type to search existing tags or add new ones...",
                        label: "Tags",
                        className: "mb-3"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "primary",
                        onClick: onHide,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "dark",
                        onClick: handleSubmit,
                        disabled: isOverLimit,
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                className: "fa-regular fa-floppy-disk px-1"
                            }),
                            " Save Changes"
                        ]
                    })
                ]
            })
        ]
    });
};
var $3e35d167d80a8cb7$export$2e2bcd8739ae039 = $3e35d167d80a8cb7$var$CommandFormModal;




parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


"use client";
const $4402ef2d96a1c365$var$ButtonGroup = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$4402ef2d96a1c365$var$ButtonGroup.displayName = 'ButtonGroup';
var $4402ef2d96a1c365$export$2e2bcd8739ae039 = $4402ef2d96a1c365$var$ButtonGroup;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $e1afafe9bfd9821d$var$noop = ()=>undefined;
const $e1afafe9bfd9821d$var$ToggleButton = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, name: name, className: className, checked: checked, type: type, onChange: onChange, value: value, disabled: disabled, id: id, inputRef: inputRef, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'btn-check');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                className: bsPrefix,
                name: name,
                type: type,
                value: value,
                ref: inputRef,
                autoComplete: "off",
                checked: !!checked,
                disabled: !!disabled,
                onChange: onChange || $e1afafe9bfd9821d$var$noop,
                id: id
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, disabled && 'disabled'),
                type: undefined,
                role: undefined,
                as: "label",
                htmlFor: id
            })
        ]
    });
});
$e1afafe9bfd9821d$var$ToggleButton.displayName = 'ToggleButton';
var $e1afafe9bfd9821d$export$2e2bcd8739ae039 = $e1afafe9bfd9821d$var$ToggleButton;


const $c901317cb9beb896$var$TagFilter = ({ tagStats: tagStats, selectedTag: selectedTag, onTagChange: onTagChange, totalCommands: totalCommands })=>{
    if (tagStats.length === 0) return null;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
        className: "mb-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4402ef2d96a1c365$export$2e2bcd8739ae039), {
                className: "mb-3 flex-wrap d-flex justify-content-center",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
                        id: "tag-all",
                        type: "radio",
                        variant: "outline-primary",
                        name: "tag",
                        value: "all",
                        checked: selectedTag === "all",
                        onChange: (e)=>onTagChange(e.currentTarget.value),
                        children: [
                            "All (",
                            totalCommands,
                            ")"
                        ]
                    }, "all-tags"),
                    tagStats.map((stat)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
                            id: `tag-${stat.tag}`,
                            type: "radio",
                            variant: "outline-primary",
                            name: "tag",
                            value: stat.tag,
                            checked: selectedTag === stat.tag,
                            onChange: (e)=>onTagChange(e.currentTarget.value),
                            children: [
                                stat.tag,
                                " (",
                                stat.count,
                                ")"
                            ]
                        }, stat.tag))
                ]
            })
        })
    });
};
var $c901317cb9beb896$export$2e2bcd8739ae039 = $c901317cb9beb896$var$TagFilter;



parcelRequire("aqdBs");

const $10773b902582e472$var$AlphabetFilter = ({ selectedLetter: selectedLetter, onLetterChange: onLetterChange, getLetterCount: getLetterCount })=>{
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const numbers = "0123456789".split("");
    const renderLetterButton = (letter)=>{
        const count = getLetterCount(letter);
        const letterButton = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
            id: `letter-${letter}`,
            type: "radio",
            variant: "outline-secondary",
            name: "letter",
            value: letter,
            checked: selectedLetter === letter,
            onChange: (e)=>onLetterChange(e.currentTarget.value),
            disabled: count === 0,
            style: {
                fontSize: "1.2rem",
                fontWeight: "bold",
                minWidth: "3rem",
                opacity: count === 0 ? 0.3 : 1
            },
            children: letter
        }, letter);
        return count > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $83c279669ca30b29$export$2e2bcd8739ae039), {
            placement: "top",
            overlay: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $7e659b76aa221fec$export$2e2bcd8739ae039), {
                id: `tooltip-${letter}`,
                children: [
                    count,
                    " command",
                    count !== 1 ? "s" : "",
                    ' starting with "',
                    letter,
                    '"'
                ]
            }),
            children: letterButton
        }, letter) : letterButton;
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
        className: "mb-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                className: "mb-3 d-flex flex-wrap justify-content-center",
                style: {
                    gap: "0.25rem"
                },
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "d-flex flex-wrap justify-content-center w-100",
                        style: {
                            gap: "0.25rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
                                id: "letter-all",
                                type: "radio",
                                variant: "outline-secondary",
                                name: "letter",
                                value: "all",
                                checked: selectedLetter === "all",
                                onChange: (e)=>onLetterChange(e.currentTarget.value),
                                style: {
                                    fontSize: "1.2rem",
                                    fontWeight: "bold",
                                    minWidth: "3rem"
                                },
                                children: "All"
                            }, "all-letters"),
                            (()=>{
                                // Count commands starting with any number
                                const numberCount = numbers.reduce((sum, num)=>sum + getLetterCount(num), 0);
                                const numberButton = /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
                                    id: "letter-numbers",
                                    type: "radio",
                                    variant: "outline-secondary",
                                    name: "letter",
                                    value: "0-9",
                                    checked: selectedLetter === "0-9",
                                    onChange: (e)=>onLetterChange(e.currentTarget.value),
                                    disabled: numberCount === 0,
                                    style: {
                                        fontSize: "1.2rem",
                                        fontWeight: "bold",
                                        minWidth: "3rem",
                                        opacity: numberCount === 0 ? 0.3 : 1
                                    },
                                    children: "#"
                                }, "numbers");
                                return numberCount > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $83c279669ca30b29$export$2e2bcd8739ae039), {
                                    placement: "top",
                                    overlay: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $7e659b76aa221fec$export$2e2bcd8739ae039), {
                                        id: "tooltip-numbers",
                                        children: [
                                            numberCount,
                                            " command",
                                            numberCount !== 1 ? "s" : "",
                                            " ",
                                            "starting with numbers"
                                        ]
                                    }),
                                    children: numberButton
                                }, "numbers") : numberButton;
                            })(),
                            alphabet.slice(0, 12).map(renderLetterButton)
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                        className: "d-flex flex-wrap justify-content-center w-100",
                        style: {
                            gap: "0.25rem"
                        },
                        children: alphabet.slice(12).map(renderLetterButton)
                    })
                ]
            })
        })
    });
};
var $10773b902582e472$export$2e2bcd8739ae039 = $10773b902582e472$var$AlphabetFilter;


const $4f2af55c52197f73$var$CommandsList = (props)=>{
    const { commands: commands, userCanEdit: userCanEdit, createCommandMutation: createCommandMutation, updateCommandMutation: updateCommandMutation, deleteCommandMutation: deleteCommandMutation } = props;
    // Set up searching and filtering
    const { hash: hash } = (0, $ebiy2.useLocation)();
    const [searchQuery, setSearchQuery] = (0, $aqdBs.useState)(hash.replace("#", ""));
    const [debouncedSearchQuery] = (0, $0e4526841ae0db4c$export$21805fee57372823)(searchQuery, 500);
    const [selectedTag, setSelectedTag] = (0, $aqdBs.useState)("all");
    const [selectedLetter, setSelectedLetter] = (0, $aqdBs.useState)("all");
    const [filteredResults, setFilteredResults] = (0, $aqdBs.useState)([]);
    // Get tags for filtering
    const { data: tagStats = [] } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useTagStats();
    const filterCommands = (0, $aqdBs.useCallback)((commandsToFilter, query, tag, letter)=>{
        let filtered = commandsToFilter;
        // Apply text search filter
        if (query.length > 0) filtered = filtered.filter((c)=>c.command.toLowerCase().includes(query.toLowerCase()) || c.aliases.some((alias)=>alias.toLowerCase().includes(query.toLowerCase())) || c.response.toLowerCase().includes(query.toLowerCase()) || c.tags && c.tags.some((tag)=>tag.toLowerCase().includes(query.toLowerCase())));
        // Apply tag filter (single tag selection)
        if (tag !== "all") filtered = filtered.filter((c)=>c.tags && c.tags.includes(tag));
        // Apply alphabetical filter
        if (letter !== "all") {
            if (letter === "0-9") // Filter for commands starting with numbers
            filtered = filtered.filter((c)=>/^[0-9]/.test(c.command));
            else // Filter for commands starting with a specific letter
            filtered = filtered.filter((c)=>c.command.toLowerCase().startsWith(letter.toLowerCase()));
        }
        return filtered;
    }, [] // No dependencies, function logic doesn't depend on any external values
    );
    // Handle updates to the location hash
    (0, $aqdBs.useEffect)(()=>{
        setSearchQuery(hash.replace("#", ""));
    }, [
        hash
    ]);
    (0, $aqdBs.useEffect)(()=>{
        const filtered = filterCommands(commands, debouncedSearchQuery, selectedTag, selectedLetter);
        setFilteredResults(filtered);
        // Update URL with search query (preserve existing behavior)
        if (debouncedSearchQuery) window.location.replace(`#${debouncedSearchQuery}`);
    }, [
        debouncedSearchQuery,
        commands,
        selectedTag,
        selectedLetter
    ]);
    // Get count for each letter or number (for alpha index)
    const getLetterCount = (letter)=>{
        // Check if it's a single digit number
        if (/^[0-9]$/.test(letter)) return commands.filter((c)=>c.command.startsWith(letter)).length;
        // For letters, use case-insensitive matching
        return commands.filter((c)=>c.command.toLowerCase().startsWith(letter.toLowerCase())).length;
    };
    const freshCommand = {
        _id: "",
        command: "",
        response: "",
        aliases: [],
        enabled: true,
        category: "",
        aliasesText: ""
    };
    const [editCommandModalActive, setEditCommandModalActive] = (0, $aqdBs.useState)(false);
    const hideEditCommandModal = ()=>setEditCommandModalActive(false);
    const showEditCommandModal = ()=>setEditCommandModalActive(true);
    const [commandToEdit, setCommandToEdit] = (0, $aqdBs.useState)(freshCommand);
    const [deleteCommandModalActive, setDeleteCommandModalActive] = (0, $aqdBs.useState)(false);
    const hideDeleteCommandModal = ()=>setDeleteCommandModalActive(false);
    const showDeleteCommandModal = ()=>setDeleteCommandModalActive(true);
    const [commandToDelete, setCommandToDelete] = (0, $aqdBs.useState)(freshCommand);
    const saveCommand = async (command)=>{
        if (command._id !== "") updateCommandMutation.mutate(command);
        else createCommandMutation.mutate(command);
        hideEditCommandModal();
    };
    const handleDeleteConfirm = async ()=>{
        if (commandToDelete._id !== "") deleteCommandMutation.mutate(commandToDelete);
        hideDeleteCommandModal();
    };
    const handleNewCommandClick = ()=>{
        setCommandToEdit(freshCommand);
        showEditCommandModal();
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c901317cb9beb896$export$2e2bcd8739ae039), {
                tagStats: tagStats,
                selectedTag: selectedTag,
                onTagChange: setSelectedTag,
                totalCommands: commands.length
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                className: "sticky-top my-5 justify-content-center",
                style: {
                    top: "60px"
                },
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                    xl: 6,
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $75a33122b50af2fb$export$2e2bcd8739ae039), {
                        className: "border border-primary border-2 rounded",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                                type: "text",
                                placeholder: "Search names, aliases, or responses...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value),
                                onKeyUp: (e)=>{
                                    if (e.key === "Escape") setSearchQuery("");
                                    else if (e.key === "Enter") e.currentTarget.blur();
                                },
                                size: "lg"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $75a33122b50af2fb$export$2e2bcd8739ae039).Text, {
                                id: "search-icon",
                                children: searchQuery.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: "fa-regular fa-circle-xmark p-2",
                                    onClick: ()=>setSearchQuery(""),
                                    style: {
                                        cursor: "pointer"
                                    }
                                }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: "fa-solid fa-magnifying-glass p-2"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $10773b902582e472$export$2e2bcd8739ae039), {
                selectedLetter: selectedLetter,
                onLetterChange: setSelectedLetter,
                getLetterCount: getLetterCount
            }),
            filteredResults.length === 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                children: [
                    "No results found",
                    searchQuery.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                        children: [
                            "\xa0 for ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                                children: searchQuery
                            })
                        ]
                    }),
                    selectedTag !== "all" && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                        children: [
                            "\xa0 tagged with ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                                children: selectedTag
                            })
                        ]
                    }),
                    selectedLetter !== "all" && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                        children: [
                            "\xa0 starting with ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                                children: selectedLetter
                            })
                        ]
                    }),
                    "."
                ]
            }),
            userCanEdit && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                onClick: handleNewCommandClick,
                variant: "primary",
                className: "mb-3 mx-auto d-block",
                size: "lg",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-circle-plus px-1"
                    }),
                    " Add a new command"
                ]
            }),
            filteredResults.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                variant: "dark",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                        children: filteredResults.length
                    }),
                    " command",
                    filteredResults.length !== 1 ? "s" : "",
                    " found."
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                gap: 5,
                className: "d-xl-none",
                children: filteredResults.map((c, idx)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                                    direction: "horizontal",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                            className: "fs-3",
                                            children: c.command
                                        }),
                                        userCanEdit && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                    onClick: ()=>{
                                                        setCommandToEdit(c);
                                                        showEditCommandModal();
                                                    },
                                                    className: "ms-auto",
                                                    variant: "dark",
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                        className: "fa-regular fa-pen-to-square"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                    variant: "dark",
                                                    onClick: ()=>{
                                                        setCommandToDelete(c);
                                                        showDeleteCommandModal();
                                                    },
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                        className: "fa-regular fa-trash-can"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Title, {
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b779653ac309924d$export$2e2bcd8739ae039), {
                                            text: c.response
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Text, {
                                        as: "div",
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($4f2af55c52197f73$export$cb91c4b5218203a2, {
                                            aliases: c.aliases
                                        })
                                    })
                                ]
                            })
                        ]
                    }, idx))
            }),
            filteredResults.length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $162086630506a5b8$export$2e2bcd8739ae039), {
                striped: true,
                bordered: true,
                hover: true,
                className: "d-none d-xl-block",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                    className: "text-end w-25",
                                    children: "Command"
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                    className: "w-75",
                                    children: "Response"
                                }),
                                userCanEdit && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tbody", {
                        children: [
                            filteredResults.map((c, index)=>{
                                // Check if this command is being updated optimistically
                                const isBeingUpdated = updateCommandMutation.isPending && updateCommandMutation.variables?._id === c._id;
                                const isBeingDeleted = deleteCommandMutation.isPending && deleteCommandMutation.variables?._id === c._id;
                                // Use optimistic data if being updated, otherwise use current data
                                const displayCommand = isBeingUpdated ? updateCommandMutation.variables : c;
                                // Hide row if being deleted
                                if (isBeingDeleted) return null;
                                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                    style: {
                                        opacity: isBeingUpdated ? 0.6 : 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                            className: "align-middle text-end",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                                    className: "fs-3",
                                                    children: displayCommand.command
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($4f2af55c52197f73$export$cb91c4b5218203a2, {
                                                    aliases: displayCommand.aliases || []
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                            className: "align-middle",
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                className: "lead",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b779653ac309924d$export$2e2bcd8739ae039), {
                                                    text: displayCommand.response || ""
                                                })
                                            })
                                        }),
                                        userCanEdit && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                    variant: "dark",
                                                    disabled: isBeingUpdated || isBeingDeleted,
                                                    onClick: ()=>{
                                                        setCommandToEdit(c);
                                                        showEditCommandModal();
                                                    },
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                        className: "fa-regular fa-pen-to-square"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                    variant: "dark",
                                                    disabled: isBeingUpdated || isBeingDeleted,
                                                    onClick: ()=>{
                                                        setCommandToDelete(c);
                                                        showDeleteCommandModal();
                                                    },
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                        className: "fa-regular fa-trash-can"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, `command-${index}`);
                            }),
                            createCommandMutation.isPending && createCommandMutation.variables && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                style: {
                                    opacity: 0.6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                        className: "align-middle text-end",
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                                className: "fs-3",
                                                children: createCommandMutation.variables.command
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($4f2af55c52197f73$export$cb91c4b5218203a2, {
                                                aliases: createCommandMutation.variables.aliases || []
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                        className: "align-middle",
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                            className: "lead",
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $b779653ac309924d$export$2e2bcd8739ae039), {
                                                text: createCommandMutation.variables.response || ""
                                            })
                                        })
                                    }),
                                    userCanEdit && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                            variant: "dark",
                                            disabled: true,
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-spinner fa-spin"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            editCommandModalActive && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3e35d167d80a8cb7$export$2e2bcd8739ae039), {
                command: commandToEdit,
                show: editCommandModalActive,
                onHide: hideEditCommandModal,
                onSubmit: saveCommand
            }),
            deleteCommandModalActive && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039), {
                show: deleteCommandModalActive,
                onHide: hideDeleteCommandModal,
                centered: true,
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Title, {
                            children: [
                                "Deleting: ",
                                commandToDelete.command
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Body, {
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                            variant: "danger",
                            className: "p-3",
                            children: [
                                "Are you sure you want to delete the",
                                " ",
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                                    children: commandToDelete.command
                                }),
                                " command?"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Footer, {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "primary",
                                onClick: hideDeleteCommandModal,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "danger",
                                onClick: handleDeleteConfirm,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-solid fa-delete-left px-1"
                                    }),
                                    " Confirm Delete"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $4f2af55c52197f73$export$cb91c4b5218203a2 = (props)=>{
    const { aliases: aliases } = props;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
        direction: "horizontal",
        gap: 1,
        className: "justify-content-end flex-wrap",
        children: aliases.map((a, idx)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                bg: "secondary",
                children: a
            }, idx))
    });
};
var $4f2af55c52197f73$export$2e2bcd8739ae039 = $4f2af55c52197f73$var$CommandsList;





var $i96EK = parcelRequire("i96EK");
const $405765626b6d8e5a$var$CommandsPage = ()=>{
    (0, $aqdBs.useEffect)(()=>{
        document.title = "Commands | Helpasaur King";
    }, []);
    const { data: user } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useUser();
    const { useCommands: useCommands, useUpdateCommand: useUpdateCommand, useCreateCommand: useCreateCommand, useDeleteCommand: useDeleteCommand } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: commands, isError: commandsError, isLoading: commandsLoading } = useCommands();
    const createCommandMutation = useCreateCommand();
    const updateCommandMutation = useUpdateCommand();
    const deleteCommandMutation = useDeleteCommand();
    if (commandsError) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
        variant: "danger",
        children: commandsError
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        id: "commands",
        className: "mt-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-terminal"
                    }),
                    " Commands"
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                className: "lead",
                children: [
                    "Each of these commands will work via the Discord or Twitch bots, preceded by their configured prefix, which is ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                        children: "!"
                    }),
                    " by default. e.g. ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                        children: "!nmg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
            commandsLoading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            }),
            !commandsError && !commandsLoading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4f2af55c52197f73$export$2e2bcd8739ae039), {
                commands: (0, $dd0e8f82c966a2e6$export$453882cbf4015ef3)(commands || []),
                userCanEdit: user ? (0, $i96EK.hasAnyPermission)(user.permissions, (0, $i96EK.COMMAND_EDIT_PERMISSIONS)) : false,
                createCommandMutation: createCommandMutation,
                updateCommandMutation: updateCommandMutation,
                deleteCommandMutation: deleteCommandMutation
            })
        ]
    });
};
var $405765626b6d8e5a$export$2e2bcd8739ae039 = $405765626b6d8e5a$var$CommandsPage;




var $aqdBs = parcelRequire("aqdBs");



parcelRequire("aqdBs");



parcelRequire("aqdBs");





var $aqdBs = parcelRequire("aqdBs");
function $88d9fe644e581592$export$2e2bcd8739ae039(date) {
    const parsed = new Date(date);
    if (!Number.isNaN(parsed.valueOf())) return parsed;
    const parts = String(date).match(/\d+/g);
    if (parts == null || parts.length <= 2) return parsed;
    else {
        const [firstP, secondP, ...restPs] = parts.map((x)=>parseInt(x));
        const correctedParts = [
            firstP,
            secondP - 1,
            ...restPs
        ];
        const isoDate = new Date(Date.UTC(...correctedParts));
        return isoDate;
    }
}


function $7ac3ea91a4fea3be$export$2e2bcd8739ae039(value, _unit, suffix) {
    const unit = value !== 1 ? _unit + 's' : _unit;
    return value + ' ' + unit + ' ' + suffix;
}


function $2ae56bdcba59609a$var$_extends() {
    $2ae56bdcba59609a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2ae56bdcba59609a$var$_extends.apply(this, arguments);
}
// Just some simple constants for readability
const $2ae56bdcba59609a$var$MINUTE = 60;
const $2ae56bdcba59609a$var$HOUR = $2ae56bdcba59609a$var$MINUTE * 60;
const $2ae56bdcba59609a$var$DAY = $2ae56bdcba59609a$var$HOUR * 24;
const $2ae56bdcba59609a$var$WEEK = $2ae56bdcba59609a$var$DAY * 7;
const $2ae56bdcba59609a$var$MONTH = $2ae56bdcba59609a$var$DAY * 30;
const $2ae56bdcba59609a$var$YEAR = $2ae56bdcba59609a$var$DAY * 365;
const $2ae56bdcba59609a$var$defaultNow = ()=>Date.now();
function $2ae56bdcba59609a$export$2e2bcd8739ae039({ date: date, formatter: formatter = (0, $7ac3ea91a4fea3be$export$2e2bcd8739ae039), component: component = 'time', live: live = true, minPeriod: minPeriod = 0, maxPeriod: maxPeriod = $2ae56bdcba59609a$var$WEEK, title: title, now: now = $2ae56bdcba59609a$var$defaultNow, ...passDownProps }) {
    const [timeNow, setTimeNow] = (0, $aqdBs.useState)(now());
    (0, $aqdBs.useEffect)(()=>{
        if (!live) return;
        const tick = ()=>{
            const then = (0, $88d9fe644e581592$export$2e2bcd8739ae039)(date).valueOf();
            if (!then) {
                console.warn('[react-timeago] Invalid Date provided');
                return 0;
            }
            const seconds = Math.round(Math.abs(timeNow - then) / 1000);
            const unboundPeriod = seconds < $2ae56bdcba59609a$var$MINUTE ? 1000 : seconds < $2ae56bdcba59609a$var$HOUR ? 1000 * $2ae56bdcba59609a$var$MINUTE : seconds < $2ae56bdcba59609a$var$DAY ? 1000 * $2ae56bdcba59609a$var$HOUR : 1000 * $2ae56bdcba59609a$var$WEEK;
            const period = Math.min(Math.max(unboundPeriod, minPeriod * 1000), maxPeriod * 1000);
            if (period) return setTimeout(()=>{
                setTimeNow(now());
            }, period);
            return 0;
        };
        const timeoutId = tick();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        date,
        live,
        maxPeriod,
        minPeriod,
        now,
        timeNow
    ]);
    const Komponent = component;
    const then = (0, $88d9fe644e581592$export$2e2bcd8739ae039)(date).valueOf();
    if (!then) return null;
    const seconds = Math.round(Math.abs(timeNow - then) / 1000);
    const suffix = then < timeNow ? 'ago' : 'from now';
    const [value, unit] = seconds < $2ae56bdcba59609a$var$MINUTE ? [
        Math.round(seconds),
        'second'
    ] : seconds < $2ae56bdcba59609a$var$HOUR ? [
        Math.round(seconds / $2ae56bdcba59609a$var$MINUTE),
        'minute'
    ] : seconds < $2ae56bdcba59609a$var$DAY ? [
        Math.round(seconds / $2ae56bdcba59609a$var$HOUR),
        'hour'
    ] : seconds < $2ae56bdcba59609a$var$WEEK ? [
        Math.round(seconds / $2ae56bdcba59609a$var$DAY),
        'day'
    ] : seconds < $2ae56bdcba59609a$var$MONTH ? [
        Math.round(seconds / $2ae56bdcba59609a$var$WEEK),
        'week'
    ] : seconds < $2ae56bdcba59609a$var$YEAR ? [
        Math.round(seconds / $2ae56bdcba59609a$var$MONTH),
        'month'
    ] : [
        Math.round(seconds / $2ae56bdcba59609a$var$YEAR),
        'year'
    ];
    const passDownTitle = typeof title === 'undefined' ? typeof date === 'string' ? date : (0, $88d9fe644e581592$export$2e2bcd8739ae039)(date).toISOString().substr(0, 16).replace('T', ' ') : title;
    const spreadProps = Komponent === 'time' ? {
        ...passDownProps,
        dateTime: (0, $88d9fe644e581592$export$2e2bcd8739ae039)(date).toISOString()
    } : passDownProps;
    const nextFormatter = (0, $7ac3ea91a4fea3be$export$2e2bcd8739ae039).bind(null, value, unit, suffix);
    return /*#__PURE__*/ $aqdBs.createElement(Komponent, $2ae56bdcba59609a$var$_extends({}, spreadProps, {
        title: passDownTitle
    }), formatter(value, unit, suffix, then, nextFormatter, now));
}



function $db20718733577481$var$StreamCard(props) {
    const { stream: stream } = props;
    const thumbnailWidth = props.thumbnailWidth || 320;
    const thumbnailHeight = props.thumbnailHeight || 180;
    const twitchUrl = (0, $dd0e8f82c966a2e6$export$80d5208c4298f844)(stream.user_login);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
        className: "rounded h-100",
        bg: stream.isOnAlertsList ? "primary" : "dark",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                className: "d-grid p-0",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                    variant: stream.isOnAlertsList ? "secondary" : "primary",
                    href: twitchUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "py-3",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h5", {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                className: "fa-regular fa-user"
                            }),
                            " ",
                            stream.user_name
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
                href: twitchUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Img, {
                    variant: "top",
                    src: (0, $dd0e8f82c966a2e6$export$11342ff48ff25735)(stream.thumbnail_url, thumbnailWidth, thumbnailHeight)
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                className: "flex-grow-1",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Title, {
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                        className: "py-2 fw-bold",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("a", {
                            href: twitchUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: `text-decoration-none link-light`,
                            children: stream.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Footer, {
                className: "bg-dark",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                    gap: 1,
                    className: "font-monospace",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("small", {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: "fa-regular fa-eye"
                                }),
                                " ",
                                stream.viewer_count,
                                " viewers"
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("small", {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: "fa-solid fa-stopwatch"
                                }),
                                " Started",
                                " ",
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("em", {
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2ae56bdcba59609a$export$2e2bcd8739ae039), {
                                        date: stream.started_at
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e78ed12bdf61965d$export$2e2bcd8739ae039), {
                            direction: "horizontal",
                            gap: 1,
                            children: stream.tags.slice(0, 3).map((t, i)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                                    children: t
                                }, i))
                        })
                    ]
                })
            })
        ]
    });
}
var $db20718733577481$export$2e2bcd8739ae039 = $db20718733577481$var$StreamCard;



const $02464df3f8b22cad$var$LivestreamsList = (props)=>{
    const { streams: streams } = props;
    if (streams.length === 0) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                className: "fa-solid fa-triangle-exclamation px-1"
            }),
            " Someone needs to fire it up!"
        ]
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
        xs: 1,
        md: 2,
        lg: 3,
        className: "row-gap-5 col-gap-4",
        children: streams.map((s, streamIndex)=>{
            return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $db20718733577481$export$2e2bcd8739ae039), {
                    stream: s,
                    thumbnailWidth: 640,
                    thumbnailHeight: 360
                }, streamIndex)
            }, streamIndex);
        })
    });
};
var $02464df3f8b22cad$export$2e2bcd8739ae039 = $02464df3f8b22cad$var$LivestreamsList;



const $df47052fab0c77d5$var$LivestreamsPage = ()=>{
    const { useConfig: useConfig, useLivestreams: useLivestreams } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: webConfig, isError: configError, isLoading: configLoading } = useConfig();
    const { data: allStreams, isError: streamsError, isLoading: streamsLoading, isFetching: streamsFetching } = useLivestreams();
    const [mergedStreams, setMergedStreams] = (0, $aqdBs.useState)([]);
    (0, $aqdBs.useEffect)(()=>{
        const streamFilterConfig = webConfig?.streams || {
            blacklistedUsers: [],
            channels: [],
            statusFilters: ""
        };
        const filteredStreams = (0, $dd0e8f82c966a2e6$export$bd2a70aaaa2c8a18)(allStreams || [], streamFilterConfig);
        setMergedStreams(filteredStreams.featured.concat(filteredStreams.other));
    }, [
        allStreams
    ]);
    (0, $aqdBs.useEffect)(()=>{
        document.title = `(${mergedStreams.length}) ALttP Streams | Helpasaur King`;
    }, [
        mergedStreams
    ]);
    if (configError || streamsError) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
        variant: "danger",
        children: [
            "Error fetching data: ",
            configError,
            " ",
            streamsError
        ]
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        id: "streams",
        className: "my-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-brands fa-twitch"
                    }),
                    " ALttP Streams",
                    " ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("small", {
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                            bg: "info",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: "fa-solid fa-tower-broadcast"
                                }),
                                " ",
                                streamsLoading || streamsFetching ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                    animation: "border",
                                    size: "sm"
                                }) : mergedStreams.length,
                                " ",
                                "Live Now"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
            (configLoading || streamsLoading) && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            }),
            !configLoading && !configError && !streamsLoading && !streamsError && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $02464df3f8b22cad$export$2e2bcd8739ae039), {
                streams: mergedStreams
            })
        ]
    });
};
var $df47052fab0c77d5$export$2e2bcd8739ae039 = $df47052fab0c77d5$var$LivestreamsPage;




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");






var $aqdBs = parcelRequire("aqdBs");






"use client";
const $ec5f494be57c2d73$var$ListGroupItem = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $f61116ee1a7a26e5$export$d7a68693710982a)({
        key: (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $435e5257ab4445c3$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$ec5f494be57c2d73$var$ListGroupItem.displayName = 'ListGroupItem';
var $ec5f494be57c2d73$export$2e2bcd8739ae039 = $ec5f494be57c2d73$var$ListGroupItem;



"use client";
const $5bcb4aa607b9a37c$var$ListGroup = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $734cf06dc9abe0f0$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$5bcb4aa607b9a37c$var$ListGroup.displayName = 'ListGroup';
var $5bcb4aa607b9a37c$export$2e2bcd8739ae039 = Object.assign($5bcb4aa607b9a37c$var$ListGroup, {
    Item: (0, $ec5f494be57c2d73$export$2e2bcd8739ae039)
});





const $84f0da1af79900eb$var$TwitchBotPage = ()=>{
    (0, $aqdBs.useEffect)(()=>{
        document.title = "Twitch Bot | Helpasaur King";
    }, []);
    const { useUser: useUser, useTwitchBotConfig: useTwitchBotConfig } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: user, isPending: userLoading } = useUser();
    const { data: twitchBotConfig, isPending: twitchBotConfigLoading } = useTwitchBotConfig();
    if (userLoading || twitchBotConfigLoading) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
            animation: "border",
            role: "statues",
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        })
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        id: "twitch-bot-page",
        className: "my-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-robot"
                    }),
                    " Twitch Bot",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
            !user && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039).Link, {
                        href: (0, $dd0e8f82c966a2e6$export$f6b4b72c90d2282f)(),
                        rel: "noopener,noreferrer",
                        children: "Log in with your Twitch account"
                    }),
                    " ",
                    "to manage the bot right here, or",
                    " ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039).Link, {
                        href: "https://twitch.tv/helpasaurking",
                        target: "_blank",
                        rel: "noopener,noreferrer",
                        children: "go to the bot's Twitch chat"
                    }),
                    " ",
                    "and send ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                        children: "!join"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                        children: "!leave"
                    }),
                    "."
                ]
            }),
            user && twitchBotConfig && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($84f0da1af79900eb$var$TwitchUserBotManagement, {
                user: user,
                twitchBotConfig: twitchBotConfig
            })
        ]
    });
};
const $84f0da1af79900eb$var$ConfigToggle = ({ id: id, checked: checked, onChange: onChange, disabled: disabled, label: label })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        className: "config-toggle clickable-area",
        onClick: ()=>!disabled && onChange(!checked),
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Check, {
            type: "switch",
            id: id,
            checked: checked,
            onChange: (e)=>e.stopPropagation(),
            disabled: disabled,
            label: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: checked ? "enabled" : "disabled",
                children: label || (checked ? "Enabled" : "Disabled")
            })
        })
    });
};
const $84f0da1af79900eb$var$TwitchUserBotManagement = (props)=>{
    const { user: user, twitchBotConfig: twitchBotConfig } = props;
    const toast = (0, $2829a8981f6f0f18$export$a407b657d3044108)();
    const [showLeaveModal, setShowLeaveModal] = $aqdBs.useState(false);
    const handleShowLeaveModal = ()=>setShowLeaveModal(true);
    const handleCloseLeaveModal = ()=>setShowLeaveModal(false);
    const [showPrefixDropdown, setShowPrefixDropdown] = (0, $aqdBs.useState)(false);
    const { useJoinTwitchChannel: useJoinTwitchChannel, useLeaveTwitchChannel: useLeaveTwitchChannel, useUpdateTwitchBotConfig: useUpdateTwitchBotConfig, useConfig: useConfig } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    // Fetch config from API
    const { data: webConfig } = useConfig();
    // Get mutation objects
    const joinChannelMutation = useJoinTwitchChannel();
    const leaveChannelMutation = useLeaveTwitchChannel();
    const updateConfigMutation = useUpdateTwitchBotConfig({
        showToast: false
    });
    // Memoize allowed prefixes to avoid unnecessary recalculations
    const allowedPrefixes = (0, $aqdBs.useMemo)(()=>{
        if (!webConfig?.twitch?.commandPrefixes) return [];
        return webConfig.twitch.commandPrefixes;
    }, [
        webConfig
    ]);
    const handleJoinRequest = async ()=>{
        joinChannelMutation.mutate(undefined);
    };
    const handleLeaveRequest = async ()=>{
        leaveChannelMutation.mutate(undefined);
        handleCloseLeaveModal();
    };
    if (!twitchBotConfig?.active) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
        variant: "dark",
        className: "p-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                children: "Would you like HelpasaurKing to help your Twitch chat?"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                className: "lead my-5",
                children: "Click the button below to have the bot join your Twitch chat. You can request it to leave at any time from this page or from the bot's Twitch chat."
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                variant: "primary",
                onClick: handleJoinRequest,
                size: "lg",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-arrow-right-to-bracket pe-1"
                    }),
                    " Join my channel"
                ]
            })
        ]
    });
    const handleToggle = async (field, value, successMessage)=>{
        updateConfigMutation.mutate({
            [field]: value
        }, {
            onSuccess: ()=>{
                toast.success(successMessage);
            },
            onError: (error)=>{
                const errorMessage = error instanceof Error ? error.message : "Unknown error";
                toast.error(`Failed to update configuration: ${errorMessage}`);
            }
        });
    };
    const handlePrefixChange = async (newPrefix)=>{
        if (!twitchBotConfig || newPrefix === twitchBotConfig.commandPrefix) return; // No change needed or config not loaded
        updateConfigMutation.mutate({
            commandPrefix: newPrefix
        }, {
            onSuccess: ()=>{
                toast.success(`Command prefix changed to "${newPrefix}"`);
            },
            onError: (error)=>{
                const errorMessage = error instanceof Error ? error.message : "Unknown error";
                toast.error(`Failed to update prefix: ${errorMessage}`);
            }
        });
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                variant: "dark",
                className: "p-5",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h2", {
                        children: [
                            "Hey, ",
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                                children: user.twitchUserData.display_name
                            }),
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                        className: "text-muted",
                        children: "\u2705 HelpasaurKing is currently helping in your channel."
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: handleShowLeaveModal,
                        size: "lg",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                className: "fa-solid fa-right-from-bracket pe-1"
                            }),
                            " Leave my channel"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-sliders me-2"
                    }),
                    "Configuration"
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                        variant: "primary",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                            className: "mt-2 py-4",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                                    className: "text-info-emphasis mb-3",
                                    children: "# Commands"
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                            className: "flex-grow-1",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                    className: "mb-2 fs-5",
                                                    children: "Enable or disable all bot commands in your channel."
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                                                    className: "text-muted mb-0",
                                                    children: [
                                                        "When enabled, the bot will respond to commands like",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "helpa"
                                                            ]
                                                        }),
                                                        ",",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "nmg"
                                                            ]
                                                        }),
                                                        ", etc."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                            className: "ms-3",
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($84f0da1af79900eb$var$ConfigToggle, {
                                                id: "commands-switch",
                                                checked: updateConfigMutation.isPending && updateConfigMutation.variables?.commandsEnabled !== undefined ? updateConfigMutation.variables.commandsEnabled : twitchBotConfig.commandsEnabled,
                                                onChange: (checked)=>handleToggle("commandsEnabled", checked, checked ? "Bot commands enabled!" : "Bot commands disabled!"),
                                                disabled: updateConfigMutation.isPending
                                            })
                                        })
                                    ]
                                }),
                                twitchBotConfig.commandsEnabled && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                    className: "mt-4 ps-4 border-start border-3 border-info",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h5", {
                                            className: "text-info mb-2",
                                            children: "\xb7 Command Prefix"
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                            className: "d-flex justify-content-between align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                    className: "flex-grow-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                            className: "mb-2 fs-6",
                                                            children: "Set the character that triggers bot commands."
                                                        }),
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                            className: "text-muted mb-0",
                                                            children: "Click the current prefix to change it."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                    className: "ms-3 d-flex align-items-center",
                                                    style: {
                                                        minWidth: "100px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $e57a69b8871951e6$export$2e2bcd8739ae039), {
                                                        show: showPrefixDropdown,
                                                        onToggle: setShowPrefixDropdown,
                                                        children: [
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Toggle, {
                                                                as: "div",
                                                                className: "prefix-display clickable",
                                                                onClick: ()=>setShowPrefixDropdown(!showPrefixDropdown),
                                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                                                    className: "prefix-char",
                                                                    children: updateConfigMutation.isPending && updateConfigMutation.variables?.commandPrefix ? updateConfigMutation.variables.commandPrefix : twitchBotConfig?.commandPrefix || "!"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Menu, {
                                                                align: "end",
                                                                children: allowedPrefixes.map((prefix)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e57a69b8871951e6$export$2e2bcd8739ae039).Item, {
                                                                        active: prefix === twitchBotConfig?.commandPrefix,
                                                                        onClick: ()=>{
                                                                            handlePrefixChange(prefix);
                                                                            setShowPrefixDropdown(false);
                                                                        },
                                                                        style: {
                                                                            fontFamily: "monospace",
                                                                            fontSize: "1.2rem",
                                                                            fontWeight: "bold"
                                                                        },
                                                                        children: prefix
                                                                    }, prefix))
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                        variant: "primary",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                            className: "mt-2 py-4",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                                    className: "text-info-emphasis mb-3",
                                    children: "# Practice Lists"
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                            className: "flex-grow-1",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                    className: "mb-2 fs-5",
                                                    children: "Enable practice lists to track and randomize practice items in your channel."
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                                                    className: "text-muted",
                                                    children: [
                                                        "Commands:",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "pracadd"
                                                            ]
                                                        }),
                                                        ",",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "pracrand"
                                                            ]
                                                        }),
                                                        ",",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "praclist"
                                                            ]
                                                        }),
                                                        ",",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "pracdel"
                                                            ]
                                                        }),
                                                        ",",
                                                        " ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("code", {
                                                            children: [
                                                                twitchBotConfig?.commandPrefix || "!",
                                                                "pracclear"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                            className: "ms-3",
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($84f0da1af79900eb$var$ConfigToggle, {
                                                id: "practice-lists-switch",
                                                checked: updateConfigMutation.isPending && updateConfigMutation.variables?.practiceListsEnabled !== undefined ? updateConfigMutation.variables.practiceListsEnabled : twitchBotConfig.practiceListsEnabled,
                                                onChange: (checked)=>handleToggle("practiceListsEnabled", checked, checked ? "Practice lists enabled!" : "Practice lists disabled!"),
                                                disabled: updateConfigMutation.isPending
                                            })
                                        })
                                    ]
                                }),
                                twitchBotConfig.practiceListsEnabled && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                    className: "mt-4 ps-4 border-start border-3 border-info",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h5", {
                                            className: "text-info mb-2",
                                            children: "\xb7 Moderator Access"
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                            className: "d-flex justify-content-between align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                    className: "flex-grow-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                            className: "mb-2 fs-6",
                                                            children: "Allow moderators to manage practice lists."
                                                        }),
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                            className: "text-muted mb-0",
                                                            children: "When enabled, moderators can add, remove, and manage practice list entries. When disabled, only you can manage the practice lists."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                    className: "ms-3",
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($84f0da1af79900eb$var$ConfigToggle, {
                                                        id: "mod-access-switch",
                                                        checked: updateConfigMutation.isPending && updateConfigMutation.variables?.allowModsToManagePracticeLists !== undefined ? updateConfigMutation.variables.allowModsToManagePracticeLists : twitchBotConfig.allowModsToManagePracticeLists,
                                                        onChange: (checked)=>handleToggle("allowModsToManagePracticeLists", checked, checked ? "Mods can now manage practice lists!" : "Only you can manage practice lists now!"),
                                                        disabled: updateConfigMutation.isPending
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($84f0da1af79900eb$var$ConfirmLeaveModal, {
                show: showLeaveModal,
                handleClose: handleCloseLeaveModal,
                handleConfirm: handleLeaveRequest
            })
        ]
    });
};
const $84f0da1af79900eb$var$ConfirmLeaveModal = ({ show: show, handleClose: handleClose, handleConfirm: handleConfirm })=>{
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039), {
        show: show,
        onHide: handleClose,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Title, {
                    children: "Confirm Request"
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                    variant: "dark",
                    className: "p-3",
                    children: "Are you sure you want the bot to leave your channel? You can have it re-join at any time."
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2d59ed3cbba7f8ad$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "dark",
                        onClick: handleClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: handleConfirm,
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                className: "fa-solid fa-right-from-bracket px-1"
                            }),
                            " Yes, leave my channel"
                        ]
                    })
                ]
            })
        ]
    });
};
var $84f0da1af79900eb$export$2e2bcd8739ae039 = $84f0da1af79900eb$var$TwitchBotPage;




var $aqdBs = parcelRequire("aqdBs");


var $MQCL2 = parcelRequire("MQCL2");

const $7d08ec247cc88275$var$commandGroups = [
    {
        title: "Set the command prefix",
        commands: [
            {
                title: "",
                command: "/helpa-config",
                subcommand: "prefix",
                argument: "character",
                description: "The character to use as the prefix",
                defaultValue: "!"
            }
        ]
    },
    {
        title: "Set the cooldown for text commands",
        commands: [
            {
                title: "",
                command: "/helpa-config",
                subcommand: "cooldown",
                argument: "seconds",
                description: "Number of seconds before the same command can be used",
                defaultValue: "10"
            }
        ]
    },
    {
        title: "Manage the stream alerts feature",
        commands: [
            {
                title: "On/Off",
                command: "/helpa-config",
                subcommand: "stream-alerts",
                argument: "enable",
                description: "Enable or disable the stream alerts feature",
                defaultValue: "False"
            },
            {
                title: "Channel",
                command: "/helpa-config",
                subcommand: "stream-alerts-channel",
                argument: "channel",
                description: "The text channel where stream alerts will be posted",
                defaultValue: "None"
            }
        ]
    },
    {
        title: "Manage the weekly race alerts feature",
        commands: [
            {
                title: "One Hour Warning",
                command: "/helpa-config",
                subcommand: "weekly-warning",
                argument: "enable",
                description: "Enable or disable the 1 hour warning before the race starts",
                defaultValue: "False"
            },
            {
                title: "Race Room Alert",
                command: "/helpa-config",
                subcommand: "weekly-room-alert",
                argument: "enable",
                description: "Enable or disable the alert with the link to the race room once created",
                defaultValue: "False"
            },
            {
                title: "Channel",
                command: "/helpa-config",
                subcommand: "weekly-channel",
                argument: "channel",
                description: "The text channel where weekly alerts will be posted",
                defaultValue: "None"
            },
            {
                title: "One Hour Warning Role",
                command: "/helpa-config",
                subcommand: "weekly-warning-role",
                argument: "role",
                description: "(Optional) The role to ping for the 1 hour warning -- send this command without the role argument to clear the current role",
                defaultValue: "None"
            },
            {
                title: "Race Room Alert Role",
                command: "/helpa-config",
                subcommand: "weekly-room-role",
                argument: "role",
                description: "(Optional) The role to ping when the race room is created -- send this command without the role argument to clear the current role",
                defaultValue: "None"
            }
        ]
    }
];
const $7d08ec247cc88275$var$DiscordBotPage = ()=>{
    const { useDiscordJoinUrl: useDiscordJoinUrl } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: joinUrlResponse } = useDiscordJoinUrl();
    (0, $aqdBs.useEffect)(()=>{
        document.title = "Discord Bot | Helpasaur King";
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        id: "discord-bot-page",
        className: "my-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-brands fa-discord"
                    }),
                    " Discord Bot",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                xs: 1,
                lg: 2,
                className: "g-4",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                id: "features",
                                children: "Features"
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-regular fa-square-check pe-1"
                                            }),
                                            "Responds to ",
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $MQCL2.Link), {
                                                to: "/commands",
                                                children: "static commands"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                                                className: "text-muted",
                                                children: [
                                                    "(in a server ",
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("em", {
                                                        children: "or"
                                                    }),
                                                    " a DM)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-regular fa-square-check pe-1"
                                            }),
                                            "Posts alerts when featured ",
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $MQCL2.Link), {
                                                to: "/streams",
                                                children: "ALttP streams"
                                            }),
                                            " go live"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-regular fa-square-check pe-1"
                                            }),
                                            "Posts alerts for weekly races",
                                            " ",
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                                className: "text-muted",
                                                children: "(1 hour warning, race room creation)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                            variant: "dark",
                            className: "p-5 border-1 border-secondary",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                                    children: "Would you like HelpasaurKing to help your Discord server?"
                                }),
                                !joinUrlResponse?.url && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                    animation: "border"
                                }),
                                joinUrlResponse?.url && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    href: joinUrlResponse.url,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    size: "lg",
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-regular fa-square-plus pe-1"
                                        }),
                                        " Add to your server"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h2", {
                id: "commands",
                children: "Command List"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                children: [
                    "Start typing ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                        children: "/helpa"
                    }),
                    " in your server to see available commands."
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                variant: "dark",
                className: "border-1 border-warning",
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-pencil pe-1"
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("strong", {
                        children: "Note:"
                    }),
                    " These are only available to users with the",
                    " ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("em", {
                        children: "Administrator"
                    }),
                    " role in your server!"
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                children: "Configuration"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039), {
                children: $7d08ec247cc88275$var$commandGroups.map((group, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5bcb4aa607b9a37c$export$2e2bcd8739ae039).Item, {
                        variant: "primary",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                            className: "mt-2 py-4",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h4", {
                                    className: "text-info-emphasis",
                                    children: [
                                        "# ",
                                        group.title
                                    ]
                                }),
                                group.commands.map((command, cmdIndex)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                        children: [
                                            command.title && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h5", {
                                                children: [
                                                    "\xb7 ",
                                                    command.title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                                                className: "p-3 border border-1 border-info rounded-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                        className: "fa-solid fa-terminal pe-1"
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                                        className: "fw-bold",
                                                        children: command.command
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                                                        children: command.subcommand
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("small", {
                                                        className: "font-monospace text-muted",
                                                        children: [
                                                            "<",
                                                            command.argument,
                                                            ">"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ul", {
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("li", {
                                                    className: "font-monospace",
                                                    children: [
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("em", {
                                                            children: command.argument
                                                        }),
                                                        " - ",
                                                        command.description,
                                                        " ",
                                                        "(Default: ",
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                                            children: command.defaultValue
                                                        }),
                                                        ")"
                                                    ]
                                                })
                                            })
                                        ]
                                    }, cmdIndex))
                            ]
                        })
                    }, index))
            })
        ]
    });
};
var $7d08ec247cc88275$export$2e2bcd8739ae039 = $7d08ec247cc88275$var$DiscordBotPage;




var $aqdBs = parcelRequire("aqdBs");

var $4RND8 = parcelRequire("4RND8");

var $aqdBs = parcelRequire("aqdBs");





var $aqdBs = parcelRequire("aqdBs");




const $ab89a8652fe4b01a$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $ab89a8652fe4b01a$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $ab89a8652fe4b01a$var$_excluded3 = [
    "as"
];
function $ab89a8652fe4b01a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ab89a8652fe4b01a$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $ab89a8652fe4b01a$var$_objectWithoutPropertiesLoose(_ref, $ab89a8652fe4b01a$var$_excluded);
    const context = (0, $aqdBs.useContext)((0, $e0deffa47e48b837$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $ab89a8652fe4b01a$var$_objectWithoutPropertiesLoose(context, $ab89a8652fe4b01a$var$_excluded2);
    const key = (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $6a7ed7faa5347be7$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $ab89a8652fe4b01a$var$TabPanel = /*#__PURE__*/ $aqdBs.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $ab89a8652fe4b01a$var$_objectWithoutPropertiesLoose(_ref2, $ab89a8652fe4b01a$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $df52c76171da2e86$export$2e2bcd8739ae039) }] = $ab89a8652fe4b01a$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0deffa47e48b837$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$ab89a8652fe4b01a$var$TabPanel.displayName = 'TabPanel';
var $ab89a8652fe4b01a$export$2e2bcd8739ae039 = $ab89a8652fe4b01a$var$TabPanel;



const $26a6cccbc779e88b$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $f58208d5835c9adb$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $931a064f9195ac3e$export$619500959fc48b26)(userId);
    const generateChildId = (0, $aqdBs.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $aqdBs.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0deffa47e48b837$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$26a6cccbc779e88b$var$Tabs.Panel = (0, $ab89a8652fe4b01a$export$2e2bcd8739ae039);
var $26a6cccbc779e88b$export$2e2bcd8739ae039 = $26a6cccbc779e88b$var$Tabs;




function $0e3335376c1c8245$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $88015c380507f9aa$export$2e2bcd8739ae039) : (0, $df52c76171da2e86$export$2e2bcd8739ae039);
    return transition;
}



const $c00f864264168adf$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $26a6cccbc779e88b$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $0e3335376c1c8245$export$2e2bcd8739ae039)(transition)
    });
$c00f864264168adf$var$TabContainer.displayName = 'TabContainer';
var $c00f864264168adf$export$2e2bcd8739ae039 = $c00f864264168adf$var$TabContainer;



var $aqdBs = parcelRequire("aqdBs");



"use client";
const $1a62b65a46fc9525$var$TabContent = /*#__PURE__*/ $aqdBs.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1a62b65a46fc9525$var$TabContent.displayName = 'TabContent';
var $1a62b65a46fc9525$export$2e2bcd8739ae039 = $1a62b65a46fc9525$var$TabContent;




var $aqdBs = parcelRequire("aqdBs");







"use client";
const $609c36e7eb64cdfd$var$TabPane = /*#__PURE__*/ $aqdBs.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $88015c380507f9aa$export$2e2bcd8739ae039) }] = (0, $ab89a8652fe4b01a$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $0e3335376c1c8245$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e0deffa47e48b837$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a7ed7faa5347be7$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$609c36e7eb64cdfd$var$TabPane.displayName = 'TabPane';
var $609c36e7eb64cdfd$export$2e2bcd8739ae039 = $609c36e7eb64cdfd$var$TabPane;


const $766a6e46a0309d35$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object
};
const $766a6e46a0309d35$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$766a6e46a0309d35$var$Tab.propTypes = $766a6e46a0309d35$var$propTypes;
var $766a6e46a0309d35$export$2e2bcd8739ae039 = Object.assign($766a6e46a0309d35$var$Tab, {
    Container: (0, $c00f864264168adf$export$2e2bcd8739ae039),
    Content: (0, $1a62b65a46fc9525$export$2e2bcd8739ae039),
    Pane: (0, $609c36e7eb64cdfd$export$2e2bcd8739ae039)
});

parcelRequire("aqdBs");










function $f1e8c67065806b90$var$getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, $bae8b0130f1809ac$export$4b80e395e36b5a56)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function $f1e8c67065806b90$var$renderTab(child) {
    const { title: title, eventKey: eventKey, disabled: disabled, tabClassName: tabClassName, tabAttrs: tabAttrs, id: id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6a4295ac97e7a742$export$2e2bcd8739ae039), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $46778ebbc3b4aa22$export$2e2bcd8739ae039), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const $f1e8c67065806b90$var$Tabs = (props)=>{
    const { id: id, onSelect: onSelect, transition: transition, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, variant: variant = 'tabs', children: children, activeKey: activeKey = $f1e8c67065806b90$var$getDefaultActiveKey(children), ...controlledProps } = (0, $d1750a042e9b894b$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $26a6cccbc779e88b$export$2e2bcd8739ae039), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, $0e3335376c1c8245$export$2e2bcd8739ae039)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $670f5cbce0b874dd$export$2e2bcd8739ae039), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, $bae8b0130f1809ac$export$871de8747c9eaa88)(children, $f1e8c67065806b90$var$renderTab)
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1a62b65a46fc9525$export$2e2bcd8739ae039), {
                children: (0, $bae8b0130f1809ac$export$871de8747c9eaa88)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $609c36e7eb64cdfd$export$2e2bcd8739ae039), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
$f1e8c67065806b90$var$Tabs.displayName = 'Tabs';
var $f1e8c67065806b90$export$2e2bcd8739ae039 = $f1e8c67065806b90$var$Tabs;


parcelRequire("MQCL2");
var $ebiy2 = parcelRequire("ebiy2");



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");



"use client";
function $16fb52be9e08f69a$export$2e2bcd8739ae039({ animation: animation, bg: bg, bsPrefix: bsPrefix, size: size, ...props }) {
    bsPrefix = (0, $5f2dec88dec04806$export$7f387860ebffb32c)(bsPrefix, 'placeholder');
    const [{ className: className, ...colProps }] = (0, $d6aefb3504f34578$export$2ed43d61a0a9f5a3)(props);
    return {
        ...colProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, animation ? `${bsPrefix}-${animation}` : bsPrefix, size && `${bsPrefix}-${size}`, bg && `bg-${bg}`)
    };
}



var $aqdBs = parcelRequire("aqdBs");



const $ec2522ea502c0faa$var$PlaceholderButton = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const placeholderProps = (0, $16fb52be9e08f69a$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
        ...placeholderProps,
        ref: ref,
        disabled: true,
        tabIndex: -1
    });
});
$ec2522ea502c0faa$var$PlaceholderButton.displayName = 'PlaceholderButton';
var $ec2522ea502c0faa$export$2e2bcd8739ae039 = $ec2522ea502c0faa$var$PlaceholderButton;



const $e35a74eb296af59f$var$Placeholder = /*#__PURE__*/ $aqdBs.forwardRef(({ as: Component = 'span', ...props }, ref)=>{
    const placeholderProps = (0, $16fb52be9e08f69a$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Component, {
        ...placeholderProps,
        ref: ref
    });
});
$e35a74eb296af59f$var$Placeholder.displayName = 'Placeholder';
var $e35a74eb296af59f$export$2e2bcd8739ae039 = Object.assign($e35a74eb296af59f$var$Placeholder, {
    Button: (0, $ec2522ea502c0faa$export$2e2bcd8739ae039)
});


/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $51a365899745bf80$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $51a365899745bf80$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $51a365899745bf80$export$bcc6e673dfa14d36(v) {
    return $51a365899745bf80$export$837ba5c449269406($51a365899745bf80$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $51a365899745bf80$export$869b26d4e1bbdb63(v) {
    return $51a365899745bf80$export$837ba5c449269406($51a365899745bf80$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $51a365899745bf80$export$ed9bd8dcaeba14f6(v) {
    return $51a365899745bf80$export$837ba5c449269406($51a365899745bf80$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $51a365899745bf80$export$dbf961a8d278dbef(v) {
    return $51a365899745bf80$export$837ba5c449269406($51a365899745bf80$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $51a365899745bf80$export$aa35ef1f24408ab9(v) {
    return $51a365899745bf80$export$837ba5c449269406($51a365899745bf80$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $51a365899745bf80$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $51a365899745bf80$var$hex = [
    ...'0123456789ABCDEF'
];
const $51a365899745bf80$var$h1 = (b)=>$51a365899745bf80$var$hex[b & 0xF];
const $51a365899745bf80$var$h2 = (b)=>$51a365899745bf80$var$hex[(b & 0xF0) >> 4] + $51a365899745bf80$var$hex[b & 0xF];
const $51a365899745bf80$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $51a365899745bf80$var$isShort = (v)=>$51a365899745bf80$var$eq(v.r) && $51a365899745bf80$var$eq(v.g) && $51a365899745bf80$var$eq(v.b) && $51a365899745bf80$var$eq(v.a);
function $51a365899745bf80$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $51a365899745bf80$var$map$1[str[1]] * 17,
            g: 255 & $51a365899745bf80$var$map$1[str[2]] * 17,
            b: 255 & $51a365899745bf80$var$map$1[str[3]] * 17,
            a: len === 5 ? $51a365899745bf80$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $51a365899745bf80$var$map$1[str[1]] << 4 | $51a365899745bf80$var$map$1[str[2]],
            g: $51a365899745bf80$var$map$1[str[3]] << 4 | $51a365899745bf80$var$map$1[str[4]],
            b: $51a365899745bf80$var$map$1[str[5]] << 4 | $51a365899745bf80$var$map$1[str[6]],
            a: len === 9 ? $51a365899745bf80$var$map$1[str[7]] << 4 | $51a365899745bf80$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $51a365899745bf80$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $51a365899745bf80$export$1b06654353ef9f67(v) {
    var f = $51a365899745bf80$var$isShort(v) ? $51a365899745bf80$var$h1 : $51a365899745bf80$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $51a365899745bf80$var$alpha(v.a, f) : undefined;
}
const $51a365899745bf80$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $51a365899745bf80$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $51a365899745bf80$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $51a365899745bf80$var$hwb2rgbn(h, w, b) {
    const rgb = $51a365899745bf80$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $51a365899745bf80$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $51a365899745bf80$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $51a365899745bf80$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $51a365899745bf80$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($51a365899745bf80$export$ed9bd8dcaeba14f6);
}
function $51a365899745bf80$export$4c15bd42559b811d(h, s, l) {
    return $51a365899745bf80$var$calln($51a365899745bf80$var$hsl2rgbn, h, s, l);
}
function $51a365899745bf80$export$e2710022c70fc9ee(h, w, b) {
    return $51a365899745bf80$var$calln($51a365899745bf80$var$hwb2rgbn, h, w, b);
}
function $51a365899745bf80$export$b785a357c84e4a04(h, s, v) {
    return $51a365899745bf80$var$calln($51a365899745bf80$var$hsv2rgbn, h, s, v);
}
function $51a365899745bf80$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $51a365899745bf80$export$5e91288c399be4f9(str) {
    const m = $51a365899745bf80$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $51a365899745bf80$export$bcc6e673dfa14d36(+m[5]) : $51a365899745bf80$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $51a365899745bf80$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $51a365899745bf80$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $51a365899745bf80$export$b785a357c84e4a04(h, p1, p2);
    else v = $51a365899745bf80$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $51a365899745bf80$export$bb628a54ab399bc9(v, deg) {
    var h = $51a365899745bf80$export$b5ba70b240f8f7f(v);
    h[0] = $51a365899745bf80$var$hue(h[0] + deg);
    h = $51a365899745bf80$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $51a365899745bf80$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $51a365899745bf80$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $51a365899745bf80$export$aa35ef1f24408ab9(a[1]);
    const l = $51a365899745bf80$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$51a365899745bf80$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $51a365899745bf80$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $51a365899745bf80$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $51a365899745bf80$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($51a365899745bf80$var$names$1);
    const tkeys = Object.keys($51a365899745bf80$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $51a365899745bf80$var$map[k]);
        }
        k = parseInt($51a365899745bf80$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $51a365899745bf80$var$names;
function $51a365899745bf80$export$b2f06b640faad956(str) {
    if (!$51a365899745bf80$var$names) {
        $51a365899745bf80$var$names = $51a365899745bf80$var$unpack();
        $51a365899745bf80$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $51a365899745bf80$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $51a365899745bf80$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $51a365899745bf80$export$91aedb20f296e541(str) {
    const m = $51a365899745bf80$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $51a365899745bf80$export$bcc6e673dfa14d36(v) : $51a365899745bf80$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $51a365899745bf80$export$bcc6e673dfa14d36(r) : $51a365899745bf80$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $51a365899745bf80$export$bcc6e673dfa14d36(g) : $51a365899745bf80$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $51a365899745bf80$export$bcc6e673dfa14d36(b) : $51a365899745bf80$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $51a365899745bf80$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$51a365899745bf80$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $51a365899745bf80$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $51a365899745bf80$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $51a365899745bf80$var$interpolate(rgb1, rgb2, t) {
    const r = $51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb1.r));
    const g = $51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb1.g));
    const b = $51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $51a365899745bf80$export$ed9bd8dcaeba14f6($51a365899745bf80$var$to(r + t * ($51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $51a365899745bf80$export$ed9bd8dcaeba14f6($51a365899745bf80$var$to(g + t * ($51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $51a365899745bf80$export$ed9bd8dcaeba14f6($51a365899745bf80$var$to(b + t * ($51a365899745bf80$var$from($51a365899745bf80$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $51a365899745bf80$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $51a365899745bf80$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $51a365899745bf80$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $51a365899745bf80$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $51a365899745bf80$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $51a365899745bf80$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $51a365899745bf80$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $51a365899745bf80$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $51a365899745bf80$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $51a365899745bf80$export$91aedb20f296e541(str);
    return $51a365899745bf80$export$5e91288c399be4f9(str);
}
class $51a365899745bf80$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $51a365899745bf80$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $51a365899745bf80$var$fromObject(input);
        else if (type === 'string') v = $51a365899745bf80$export$625a38b961e8b5e9(input) || $51a365899745bf80$export$b2f06b640faad956(input) || $51a365899745bf80$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $51a365899745bf80$var$clone(this._rgb);
        if (v) v.a = $51a365899745bf80$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $51a365899745bf80$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $51a365899745bf80$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $51a365899745bf80$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $51a365899745bf80$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $51a365899745bf80$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $51a365899745bf80$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $51a365899745bf80$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $51a365899745bf80$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $51a365899745bf80$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $51a365899745bf80$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $51a365899745bf80$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $51a365899745bf80$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $51a365899745bf80$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $51a365899745bf80$export$2e2bcd8739ae039(input) {
    return new $51a365899745bf80$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $112576f3a2425ff3$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $112576f3a2425ff3$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $112576f3a2425ff3$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $112576f3a2425ff3$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $112576f3a2425ff3$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $112576f3a2425ff3$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $112576f3a2425ff3$export$c4ce752e73470fba(value, defaultValue) {
    return $112576f3a2425ff3$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $112576f3a2425ff3$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $112576f3a2425ff3$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $112576f3a2425ff3$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $112576f3a2425ff3$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $112576f3a2425ff3$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($112576f3a2425ff3$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($112576f3a2425ff3$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $112576f3a2425ff3$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $112576f3a2425ff3$export$667d3bf0c5f83305(source) {
    if ($112576f3a2425ff3$export$8b22cf2602fb60ce(source)) return source.map($112576f3a2425ff3$export$667d3bf0c5f83305);
    if ($112576f3a2425ff3$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $112576f3a2425ff3$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $112576f3a2425ff3$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $112576f3a2425ff3$export$317a3d46287192d8(key, target, source, options) {
    if (!$112576f3a2425ff3$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($112576f3a2425ff3$export$23f2a1d2818174ef(tval) && $112576f3a2425ff3$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $112576f3a2425ff3$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $112576f3a2425ff3$export$667d3bf0c5f83305(sval);
}
function $112576f3a2425ff3$export$efca4cbe5dd06740(target, source, options) {
    const sources = $112576f3a2425ff3$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$112576f3a2425ff3$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $112576f3a2425ff3$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$112576f3a2425ff3$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $112576f3a2425ff3$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $112576f3a2425ff3$export$efca4cbe5dd06740(target, source, {
        merger: $112576f3a2425ff3$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $112576f3a2425ff3$export$1ee57be6f6687d2c(key, target, source) {
    if (!$112576f3a2425ff3$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($112576f3a2425ff3$export$23f2a1d2818174ef(tval) && $112576f3a2425ff3$export$23f2a1d2818174ef(sval)) $112576f3a2425ff3$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $112576f3a2425ff3$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $112576f3a2425ff3$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $112576f3a2425ff3$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $112576f3a2425ff3$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $112576f3a2425ff3$var$_getKeyResolver(key) {
    const keys = $112576f3a2425ff3$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $112576f3a2425ff3$export$2d1720544b23b823(obj, key) {
    const resolver = $112576f3a2425ff3$var$keyResolvers[key] || ($112576f3a2425ff3$var$keyResolvers[key] = $112576f3a2425ff3$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $112576f3a2425ff3$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $112576f3a2425ff3$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $112576f3a2425ff3$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $112576f3a2425ff3$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $112576f3a2425ff3$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $112576f3a2425ff3$export$56c0d5a1e737357d = Math.PI;
const $112576f3a2425ff3$export$971d5caa766a69d7 = 2 * $112576f3a2425ff3$export$56c0d5a1e737357d;
const $112576f3a2425ff3$export$2ec5befb9e6c97d4 = $112576f3a2425ff3$export$971d5caa766a69d7 + $112576f3a2425ff3$export$56c0d5a1e737357d;
const $112576f3a2425ff3$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $112576f3a2425ff3$export$39c1cc7c062529d4 = $112576f3a2425ff3$export$56c0d5a1e737357d / 180;
const $112576f3a2425ff3$export$7f8ddf7c7c20b3cd = $112576f3a2425ff3$export$56c0d5a1e737357d / 2;
const $112576f3a2425ff3$export$7a0bdf7d4a91ea88 = $112576f3a2425ff3$export$56c0d5a1e737357d / 4;
const $112576f3a2425ff3$export$c18d01048907ea92 = $112576f3a2425ff3$export$56c0d5a1e737357d * 2 / 3;
const $112576f3a2425ff3$export$faec65b429be379 = Math.log10;
const $112576f3a2425ff3$export$2408f22a0fab9ae5 = Math.sign;
function $112576f3a2425ff3$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $112576f3a2425ff3$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $112576f3a2425ff3$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($112576f3a2425ff3$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $112576f3a2425ff3$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $112576f3a2425ff3$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $112576f3a2425ff3$export$d141bba7fdc215a3(n) {
    return !$112576f3a2425ff3$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $112576f3a2425ff3$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $112576f3a2425ff3$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $112576f3a2425ff3$export$625550452a3fa3ec(degrees) {
    return degrees * ($112576f3a2425ff3$export$56c0d5a1e737357d / 180);
}
function $112576f3a2425ff3$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $112576f3a2425ff3$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $112576f3a2425ff3$export$91477dc880baac21(x) {
    if (!$112576f3a2425ff3$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $112576f3a2425ff3$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $112576f3a2425ff3$export$56c0d5a1e737357d) angle += $112576f3a2425ff3$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $112576f3a2425ff3$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $112576f3a2425ff3$export$f074adc9fbd50943(a, b) {
    return (a - b + $112576f3a2425ff3$export$2ec5befb9e6c97d4) % $112576f3a2425ff3$export$971d5caa766a69d7 - $112576f3a2425ff3$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $112576f3a2425ff3$export$ab83b03e4111b1d0(a) {
    return (a % $112576f3a2425ff3$export$971d5caa766a69d7 + $112576f3a2425ff3$export$971d5caa766a69d7) % $112576f3a2425ff3$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $112576f3a2425ff3$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $112576f3a2425ff3$export$ab83b03e4111b1d0(angle);
    const s = $112576f3a2425ff3$export$ab83b03e4111b1d0(start);
    const e = $112576f3a2425ff3$export$ab83b03e4111b1d0(end);
    const angleToStart = $112576f3a2425ff3$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $112576f3a2425ff3$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $112576f3a2425ff3$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $112576f3a2425ff3$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $112576f3a2425ff3$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $112576f3a2425ff3$export$71cec2538cb2c617(value) {
    return $112576f3a2425ff3$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $112576f3a2425ff3$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $112576f3a2425ff3$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $112576f3a2425ff3$export$ef35774e6d314e91 = (table, key, value, last)=>$112576f3a2425ff3$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $112576f3a2425ff3$export$ebd11618f299a286 = (table, key, value)=>$112576f3a2425ff3$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $112576f3a2425ff3$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $112576f3a2425ff3$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $112576f3a2425ff3$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $112576f3a2425ff3$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $112576f3a2425ff3$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $112576f3a2425ff3$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $112576f3a2425ff3$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $112576f3a2425ff3$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $112576f3a2425ff3$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $112576f3a2425ff3$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $112576f3a2425ff3$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $112576f3a2425ff3$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $112576f3a2425ff3$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $112576f3a2425ff3$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $112576f3a2425ff3$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $112576f3a2425ff3$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $112576f3a2425ff3$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($112576f3a2425ff3$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $112576f3a2425ff3$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$112576f3a2425ff3$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $112576f3a2425ff3$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($112576f3a2425ff3$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $112576f3a2425ff3$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$112576f3a2425ff3$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $112576f3a2425ff3$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $112576f3a2425ff3$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $112576f3a2425ff3$var$atEdge = (t)=>t === 0 || t === 1;
const $112576f3a2425ff3$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $112576f3a2425ff3$export$971d5caa766a69d7 / p));
const $112576f3a2425ff3$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $112576f3a2425ff3$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $112576f3a2425ff3$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $112576f3a2425ff3$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $112576f3a2425ff3$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($112576f3a2425ff3$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$112576f3a2425ff3$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$112576f3a2425ff3$var$atEdge(t) ? t : $112576f3a2425ff3$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$112576f3a2425ff3$var$atEdge(t) ? t : $112576f3a2425ff3$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $112576f3a2425ff3$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $112576f3a2425ff3$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $112576f3a2425ff3$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $112576f3a2425ff3$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $112576f3a2425ff3$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $112576f3a2425ff3$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $112576f3a2425ff3$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $112576f3a2425ff3$export$db3b6bfb95261072(value) {
    return $112576f3a2425ff3$export$738ab4df8bf92ae9(value) ? value : new (0, $51a365899745bf80$export$892596cec99bc70e)(value);
}
function $112576f3a2425ff3$export$d377dcb2b61d6c4e(value) {
    return $112576f3a2425ff3$export$738ab4df8bf92ae9(value) ? value : new (0, $51a365899745bf80$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $112576f3a2425ff3$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $112576f3a2425ff3$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $112576f3a2425ff3$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $112576f3a2425ff3$var$colors
        },
        numbers: {
            type: 'number',
            properties: $112576f3a2425ff3$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $112576f3a2425ff3$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $112576f3a2425ff3$var$intlCache = new Map();
function $112576f3a2425ff3$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $112576f3a2425ff3$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $112576f3a2425ff3$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $112576f3a2425ff3$export$ae1af26003f05816(num, locale, options) {
    return $112576f3a2425ff3$var$getNumberFormat(locale, options).format(num);
}
const $112576f3a2425ff3$var$formatters = {
    values (value) {
        return $112576f3a2425ff3$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $112576f3a2425ff3$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $112576f3a2425ff3$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $112576f3a2425ff3$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($112576f3a2425ff3$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $112576f3a2425ff3$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $112576f3a2425ff3$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $112576f3a2425ff3$export$9f4f30ee63539e24 = {
    formatters: $112576f3a2425ff3$var$formatters
};
function $112576f3a2425ff3$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $112576f3a2425ff3$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $112576f3a2425ff3$export$6559d589eb85fbb6 = Object.create(null);
const $112576f3a2425ff3$export$2e2af4578d910ddf = Object.create(null);
function $112576f3a2425ff3$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $112576f3a2425ff3$var$set(root, scope, values) {
    if (typeof scope === 'string') return $112576f3a2425ff3$export$efca4cbe5dd06740($112576f3a2425ff3$var$getScope$1(root, scope), values);
    return $112576f3a2425ff3$export$efca4cbe5dd06740($112576f3a2425ff3$var$getScope$1(root, ''), scope);
}
class $112576f3a2425ff3$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$112576f3a2425ff3$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$112576f3a2425ff3$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$112576f3a2425ff3$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $112576f3a2425ff3$var$set(this, scope, values);
    }
    get(scope) {
        return $112576f3a2425ff3$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $112576f3a2425ff3$var$set($112576f3a2425ff3$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $112576f3a2425ff3$var$set($112576f3a2425ff3$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $112576f3a2425ff3$var$getScope$1(this, scope);
        const targetScopeObject = $112576f3a2425ff3$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($112576f3a2425ff3$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $112576f3a2425ff3$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $112576f3a2425ff3$export$4368d992c4eafac0 = /* #__PURE__ */ new $112576f3a2425ff3$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $112576f3a2425ff3$var$applyAnimationsDefaults,
    $112576f3a2425ff3$var$applyLayoutsDefaults,
    $112576f3a2425ff3$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $112576f3a2425ff3$export$e171bab687b50e0(font) {
    if (!font || $112576f3a2425ff3$export$342063e11d6c3cad(font.size) || $112576f3a2425ff3$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $112576f3a2425ff3$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $112576f3a2425ff3$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$112576f3a2425ff3$export$8b22cf2602fb60ce(thing)) longest = $112576f3a2425ff3$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($112576f3a2425ff3$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$112576f3a2425ff3$export$8b22cf2602fb60ce(nestedThing)) longest = $112576f3a2425ff3$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $112576f3a2425ff3$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $112576f3a2425ff3$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $112576f3a2425ff3$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $112576f3a2425ff3$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $112576f3a2425ff3$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $112576f3a2425ff3$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $112576f3a2425ff3$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $112576f3a2425ff3$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $112576f3a2425ff3$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $112576f3a2425ff3$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $112576f3a2425ff3$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $112576f3a2425ff3$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $112576f3a2425ff3$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $112576f3a2425ff3$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $112576f3a2425ff3$export$56c0d5a1e737357d, rad - $112576f3a2425ff3$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $112576f3a2425ff3$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $112576f3a2425ff3$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $112576f3a2425ff3$export$7f8ddf7c7c20b3cd, rad + $112576f3a2425ff3$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $112576f3a2425ff3$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $112576f3a2425ff3$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $112576f3a2425ff3$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $112576f3a2425ff3$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $112576f3a2425ff3$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $112576f3a2425ff3$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $112576f3a2425ff3$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $112576f3a2425ff3$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $112576f3a2425ff3$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$112576f3a2425ff3$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $112576f3a2425ff3$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $112576f3a2425ff3$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $112576f3a2425ff3$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $112576f3a2425ff3$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $112576f3a2425ff3$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $112576f3a2425ff3$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$112576f3a2425ff3$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $112576f3a2425ff3$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $112576f3a2425ff3$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $112576f3a2425ff3$export$56c0d5a1e737357d, $112576f3a2425ff3$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $112576f3a2425ff3$export$56c0d5a1e737357d, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$112576f3a2425ff3$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $112576f3a2425ff3$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $112576f3a2425ff3$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $112576f3a2425ff3$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($112576f3a2425ff3$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $112576f3a2425ff3$var$numberOrZero = (v)=>+v || 0;
function $112576f3a2425ff3$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $112576f3a2425ff3$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $112576f3a2425ff3$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$112576f3a2425ff3$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $112576f3a2425ff3$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $112576f3a2425ff3$export$9fa96a7d116ea3ce(value) {
    return $112576f3a2425ff3$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $112576f3a2425ff3$export$28f7fcd39efa255(value) {
    return $112576f3a2425ff3$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $112576f3a2425ff3$export$a9c23c6ac3fc3eca(value) {
    const obj = $112576f3a2425ff3$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $112576f3a2425ff3$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $112576f3a2425ff3$export$4368d992c4eafac0.font;
    let size = $112576f3a2425ff3$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $112576f3a2425ff3$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($112576f3a2425ff3$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $112576f3a2425ff3$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $112576f3a2425ff3$export$d29e374196577086($112576f3a2425ff3$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $112576f3a2425ff3$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $112576f3a2425ff3$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $112576f3a2425ff3$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $112576f3a2425ff3$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $112576f3a2425ff3$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $112576f3a2425ff3$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $112576f3a2425ff3$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $112576f3a2425ff3$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $112576f3a2425ff3$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$112576f3a2425ff3$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $112576f3a2425ff3$var$_cached(target, prop, ()=>$112576f3a2425ff3$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $112576f3a2425ff3$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $112576f3a2425ff3$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $112576f3a2425ff3$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $112576f3a2425ff3$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$112576f3a2425ff3$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$112576f3a2425ff3$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $112576f3a2425ff3$var$_cached(target, prop, ()=>$112576f3a2425ff3$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $112576f3a2425ff3$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $112576f3a2425ff3$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $112576f3a2425ff3$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $112576f3a2425ff3$var$readKey = (prefix, name)=>prefix ? prefix + $112576f3a2425ff3$export$a8550f7dbe79f93a(name) : name;
const $112576f3a2425ff3$var$needsSubResolver = (prop, value)=>$112576f3a2425ff3$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $112576f3a2425ff3$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $112576f3a2425ff3$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($112576f3a2425ff3$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $112576f3a2425ff3$var$_resolveScriptable(prop, value, target, receiver);
    if ($112576f3a2425ff3$export$8b22cf2602fb60ce(value) && value.length) value = $112576f3a2425ff3$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($112576f3a2425ff3$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $112576f3a2425ff3$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $112576f3a2425ff3$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($112576f3a2425ff3$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $112576f3a2425ff3$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $112576f3a2425ff3$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($112576f3a2425ff3$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $112576f3a2425ff3$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($112576f3a2425ff3$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $112576f3a2425ff3$var$resolveFallback(fallback, prop, value) {
    return $112576f3a2425ff3$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $112576f3a2425ff3$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $112576f3a2425ff3$export$2d1720544b23b823(parent, key) : undefined;
function $112576f3a2425ff3$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $112576f3a2425ff3$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $112576f3a2425ff3$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $112576f3a2425ff3$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $112576f3a2425ff3$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $112576f3a2425ff3$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $112576f3a2425ff3$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $112576f3a2425ff3$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$112576f3a2425ff3$var$subGetTarget(resolver, prop, value));
}
function $112576f3a2425ff3$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $112576f3a2425ff3$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $112576f3a2425ff3$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($112576f3a2425ff3$export$8b22cf2602fb60ce(target) && $112576f3a2425ff3$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $112576f3a2425ff3$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $112576f3a2425ff3$var$_resolve($112576f3a2425ff3$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $112576f3a2425ff3$var$needsSubResolver(prop, value) ? $112576f3a2425ff3$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $112576f3a2425ff3$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $112576f3a2425ff3$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $112576f3a2425ff3$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $112576f3a2425ff3$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $112576f3a2425ff3$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($112576f3a2425ff3$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $112576f3a2425ff3$var$EPSILON = Number.EPSILON || 1e-14;
const $112576f3a2425ff3$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $112576f3a2425ff3$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $112576f3a2425ff3$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $112576f3a2425ff3$export$cf2f7c5792f80b46(current, previous);
    const d12 = $112576f3a2425ff3$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $112576f3a2425ff3$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $112576f3a2425ff3$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $112576f3a2425ff3$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($112576f3a2425ff3$export$23ebac1979863676(deltaK[i], 0, $112576f3a2425ff3$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $112576f3a2425ff3$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $112576f3a2425ff3$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $112576f3a2425ff3$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $112576f3a2425ff3$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $112576f3a2425ff3$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $112576f3a2425ff3$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $112576f3a2425ff3$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $112576f3a2425ff3$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $112576f3a2425ff3$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $112576f3a2425ff3$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $112576f3a2425ff3$var$monotoneAdjust(points, deltaK, mK);
    $112576f3a2425ff3$var$monotoneCompute(points, mK, indexAxis);
}
function $112576f3a2425ff3$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $112576f3a2425ff3$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $112576f3a2425ff3$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $112576f3a2425ff3$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $112576f3a2425ff3$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $112576f3a2425ff3$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $112576f3a2425ff3$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $112576f3a2425ff3$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $112576f3a2425ff3$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $112576f3a2425ff3$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $112576f3a2425ff3$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $112576f3a2425ff3$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $112576f3a2425ff3$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $112576f3a2425ff3$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $112576f3a2425ff3$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $112576f3a2425ff3$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $112576f3a2425ff3$export$fef3dfd9bad05307(el, property) {
    return $112576f3a2425ff3$var$getComputedStyle(el).getPropertyValue(property);
}
const $112576f3a2425ff3$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $112576f3a2425ff3$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $112576f3a2425ff3$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $112576f3a2425ff3$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $112576f3a2425ff3$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($112576f3a2425ff3$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $112576f3a2425ff3$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $112576f3a2425ff3$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $112576f3a2425ff3$var$getPositionedStyle(style, 'padding');
    const borders = $112576f3a2425ff3$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $112576f3a2425ff3$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $112576f3a2425ff3$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $112576f3a2425ff3$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $112576f3a2425ff3$var$getComputedStyle(container);
            const containerBorder = $112576f3a2425ff3$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $112576f3a2425ff3$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $112576f3a2425ff3$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $112576f3a2425ff3$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $112576f3a2425ff3$export$53c86fa97d611818,
        maxHeight: maxHeight || $112576f3a2425ff3$export$53c86fa97d611818
    };
}
const $112576f3a2425ff3$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $112576f3a2425ff3$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $112576f3a2425ff3$var$getComputedStyle(canvas);
    const margins = $112576f3a2425ff3$var$getPositionedStyle(style, 'margin');
    const maxWidth = $112576f3a2425ff3$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $112576f3a2425ff3$export$53c86fa97d611818;
    const maxHeight = $112576f3a2425ff3$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $112576f3a2425ff3$export$53c86fa97d611818;
    const containerSize = $112576f3a2425ff3$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $112576f3a2425ff3$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $112576f3a2425ff3$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $112576f3a2425ff3$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $112576f3a2425ff3$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $112576f3a2425ff3$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $112576f3a2425ff3$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $112576f3a2425ff3$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $112576f3a2425ff3$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($112576f3a2425ff3$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $112576f3a2425ff3$export$b4171a6734a65d42(element, property) {
    const value = $112576f3a2425ff3$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $112576f3a2425ff3$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $112576f3a2425ff3$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $112576f3a2425ff3$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $112576f3a2425ff3$export$6554612db691658e(p1, cp1, t);
    const b = $112576f3a2425ff3$export$6554612db691658e(cp1, cp2, t);
    const c = $112576f3a2425ff3$export$6554612db691658e(cp2, p2, t);
    const d = $112576f3a2425ff3$export$6554612db691658e(a, b, t);
    const e = $112576f3a2425ff3$export$6554612db691658e(b, c, t);
    return $112576f3a2425ff3$export$6554612db691658e(d, e, t);
}
const $112576f3a2425ff3$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $112576f3a2425ff3$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $112576f3a2425ff3$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $112576f3a2425ff3$var$getRightToLeftAdapter(rectX, width) : $112576f3a2425ff3$var$getLeftToRightAdapter();
}
function $112576f3a2425ff3$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $112576f3a2425ff3$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $112576f3a2425ff3$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $112576f3a2425ff3$export$ffb5f4729a158638,
        compare: $112576f3a2425ff3$export$f074adc9fbd50943,
        normalize: $112576f3a2425ff3$export$ab83b03e4111b1d0
    };
    return {
        between: $112576f3a2425ff3$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $112576f3a2425ff3$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $112576f3a2425ff3$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $112576f3a2425ff3$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $112576f3a2425ff3$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $112576f3a2425ff3$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $112576f3a2425ff3$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($112576f3a2425ff3$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($112576f3a2425ff3$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $112576f3a2425ff3$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $112576f3a2425ff3$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $112576f3a2425ff3$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $112576f3a2425ff3$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $112576f3a2425ff3$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $112576f3a2425ff3$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $112576f3a2425ff3$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $112576f3a2425ff3$var$splitByStyles(line, $112576f3a2425ff3$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $112576f3a2425ff3$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $112576f3a2425ff3$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $112576f3a2425ff3$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $112576f3a2425ff3$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $112576f3a2425ff3$var$readStyle(segmentOptions.setContext($112576f3a2425ff3$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($112576f3a2425ff3$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $112576f3a2425ff3$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $112576f3a2425ff3$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$112576f3a2425ff3$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $112576f3a2425ff3$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $112576f3a2425ff3$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $112576f3a2425ff3$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $112576f3a2425ff3$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $112576f3a2425ff3$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $112576f3a2425ff3$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $112576f3a2425ff3$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $112576f3a2425ff3$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $efa3b0afd1a6032d$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $112576f3a2425ff3$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $efa3b0afd1a6032d$export$a424a0aa8f687495 = /* #__PURE__ */ new $efa3b0afd1a6032d$var$Animator();
const $efa3b0afd1a6032d$var$transparent = 'transparent';
const $efa3b0afd1a6032d$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $112576f3a2425ff3$export$db3b6bfb95261072)(from || $efa3b0afd1a6032d$var$transparent);
        const c1 = c0.valid && (0, $112576f3a2425ff3$export$db3b6bfb95261072)(to || $efa3b0afd1a6032d$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $efa3b0afd1a6032d$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $112576f3a2425ff3$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $112576f3a2425ff3$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $efa3b0afd1a6032d$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $112576f3a2425ff3$export$f1e1789686576879)[cfg.easing] || (0, $112576f3a2425ff3$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $112576f3a2425ff3$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $112576f3a2425ff3$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $efa3b0afd1a6032d$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $112576f3a2425ff3$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $112576f3a2425ff3$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $112576f3a2425ff3$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $efa3b0afd1a6032d$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $efa3b0afd1a6032d$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $efa3b0afd1a6032d$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $efa3b0afd1a6032d$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $efa3b0afd1a6032d$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $efa3b0afd1a6032d$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $efa3b0afd1a6032d$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $efa3b0afd1a6032d$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $efa3b0afd1a6032d$var$scaleClip(xScale, allowedOverflow);
    const y = $efa3b0afd1a6032d$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $efa3b0afd1a6032d$var$toClip(value) {
    let t, r, b, l;
    if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $efa3b0afd1a6032d$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $efa3b0afd1a6032d$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $112576f3a2425ff3$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(value) === (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $efa3b0afd1a6032d$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $efa3b0afd1a6032d$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $efa3b0afd1a6032d$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $efa3b0afd1a6032d$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $efa3b0afd1a6032d$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $efa3b0afd1a6032d$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $efa3b0afd1a6032d$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $efa3b0afd1a6032d$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $efa3b0afd1a6032d$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $efa3b0afd1a6032d$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $efa3b0afd1a6032d$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $efa3b0afd1a6032d$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $efa3b0afd1a6032d$var$createDatasetContext(parent, index) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $efa3b0afd1a6032d$var$createDataContext(parent, index, element) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $efa3b0afd1a6032d$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $efa3b0afd1a6032d$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $efa3b0afd1a6032d$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $efa3b0afd1a6032d$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $efa3b0afd1a6032d$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $efa3b0afd1a6032d$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $efa3b0afd1a6032d$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(dataset.xAxisID, $efa3b0afd1a6032d$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(dataset.yAxisID, $efa3b0afd1a6032d$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(dataset.rAxisID, $efa3b0afd1a6032d$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $112576f3a2425ff3$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $efa3b0afd1a6032d$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $efa3b0afd1a6032d$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $112576f3a2425ff3$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $efa3b0afd1a6032d$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $112576f3a2425ff3$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $efa3b0afd1a6032d$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $efa3b0afd1a6032d$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $efa3b0afd1a6032d$var$updateStacks(this, meta._parsed);
            meta._stacked = $efa3b0afd1a6032d$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $efa3b0afd1a6032d$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $112576f3a2425ff3$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $112576f3a2425ff3$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $efa3b0afd1a6032d$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $efa3b0afd1a6032d$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $efa3b0afd1a6032d$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $efa3b0afd1a6032d$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $efa3b0afd1a6032d$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $112576f3a2425ff3$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $112576f3a2425ff3$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $efa3b0afd1a6032d$var$toClip((0, $112576f3a2425ff3$export$90a7f3efeed30595)(this.options.clip, $efa3b0afd1a6032d$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $efa3b0afd1a6032d$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $efa3b0afd1a6032d$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $112576f3a2425ff3$export$dda1d9f60106f0e9)(index);
        if (cached) return $efa3b0afd1a6032d$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $112576f3a2425ff3$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($efa3b0afd1a6032d$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $efa3b0afd1a6032d$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $efa3b0afd1a6032d$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($efa3b0afd1a6032d$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$efa3b0afd1a6032d$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $efa3b0afd1a6032d$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $efa3b0afd1a6032d$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $112576f3a2425ff3$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $efa3b0afd1a6032d$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $efa3b0afd1a6032d$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $112576f3a2425ff3$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $efa3b0afd1a6032d$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $efa3b0afd1a6032d$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $efa3b0afd1a6032d$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $efa3b0afd1a6032d$var$parseValue(entry, item, vScale, i) {
    if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(entry)) $efa3b0afd1a6032d$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $efa3b0afd1a6032d$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($efa3b0afd1a6032d$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $efa3b0afd1a6032d$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $efa3b0afd1a6032d$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $efa3b0afd1a6032d$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $efa3b0afd1a6032d$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $efa3b0afd1a6032d$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$efa3b0afd1a6032d$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$efa3b0afd1a6032d$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $efa3b0afd1a6032d$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $efa3b0afd1a6032d$var$swap(edge, a, b);
        edge = $efa3b0afd1a6032d$var$startEnd(edge, b, a);
    } else edge = $efa3b0afd1a6032d$var$startEnd(edge, a, b);
    return edge;
}
function $efa3b0afd1a6032d$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $efa3b0afd1a6032d$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $efa3b0afd1a6032d$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $efa3b0afd1a6032d$export$e97d5dc64e999004 extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $efa3b0afd1a6032d$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $efa3b0afd1a6032d$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $112576f3a2425ff3$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($efa3b0afd1a6032d$var$parseValue((0, $112576f3a2425ff3$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $efa3b0afd1a6032d$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $112576f3a2425ff3$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $efa3b0afd1a6032d$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $efa3b0afd1a6032d$var$setBorderSkipped(properties, options, stack, index);
            $efa3b0afd1a6032d$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $112576f3a2425ff3$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $efa3b0afd1a6032d$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $efa3b0afd1a6032d$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(value) !== (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $112576f3a2425ff3$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $efa3b0afd1a6032d$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $efa3b0afd1a6032d$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $efa3b0afd1a6032d$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $112576f3a2425ff3$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $efa3b0afd1a6032d$export$19b5c4773f17abe extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $112576f3a2425ff3$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $efa3b0afd1a6032d$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $112576f3a2425ff3$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $112576f3a2425ff3$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $112576f3a2425ff3$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $112576f3a2425ff3$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $112576f3a2425ff3$export$56c0d5a1e737357d) + (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $efa3b0afd1a6032d$export$e04603e7d8b77172 extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $112576f3a2425ff3$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $112576f3a2425ff3$export$971d5caa766a69d7);
        let max = -(0, $112576f3a2425ff3$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $112576f3a2425ff3$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $efa3b0afd1a6032d$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $112576f3a2425ff3$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $112576f3a2425ff3$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $112576f3a2425ff3$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $112576f3a2425ff3$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $112576f3a2425ff3$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $efa3b0afd1a6032d$export$3c9b5d28c11cbfd0 extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $112576f3a2425ff3$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $112576f3a2425ff3$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $112576f3a2425ff3$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $112576f3a2425ff3$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $efa3b0afd1a6032d$export$2a270b3a0d973c85 extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $112576f3a2425ff3$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $112576f3a2425ff3$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $112576f3a2425ff3$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $efa3b0afd1a6032d$export$b21a3f1286706191 extends $efa3b0afd1a6032d$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $efa3b0afd1a6032d$export$48dbc6ac651bf8be extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $112576f3a2425ff3$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $efa3b0afd1a6032d$export$b2f2bae6713db87 extends $efa3b0afd1a6032d$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $112576f3a2425ff3$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $112576f3a2425ff3$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $112576f3a2425ff3$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $112576f3a2425ff3$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $efa3b0afd1a6032d$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $efa3b0afd1a6032d$export$e97d5dc64e999004,
    BubbleController: $efa3b0afd1a6032d$export$19b5c4773f17abe,
    DoughnutController: $efa3b0afd1a6032d$export$e04603e7d8b77172,
    LineController: $efa3b0afd1a6032d$export$3c9b5d28c11cbfd0,
    PieController: $efa3b0afd1a6032d$export$b21a3f1286706191,
    PolarAreaController: $efa3b0afd1a6032d$export$2a270b3a0d973c85,
    RadarController: $efa3b0afd1a6032d$export$48dbc6ac651bf8be,
    ScatterController: $efa3b0afd1a6032d$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $efa3b0afd1a6032d$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $efa3b0afd1a6032d$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($efa3b0afd1a6032d$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    parse() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    format() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    add() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    diff() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    startOf() {
        return $efa3b0afd1a6032d$var$abstract();
    }
    endOf() {
        return $efa3b0afd1a6032d$var$abstract();
    }
}
var $efa3b0afd1a6032d$export$f32766ea09ec8bc4 = {
    _date: $efa3b0afd1a6032d$var$DateAdapterBase
};
function $efa3b0afd1a6032d$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $112576f3a2425ff3$export$ebd11618f299a286) : (0, $112576f3a2425ff3$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $efa3b0afd1a6032d$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $efa3b0afd1a6032d$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $efa3b0afd1a6032d$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $efa3b0afd1a6032d$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $112576f3a2425ff3$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $efa3b0afd1a6032d$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $efa3b0afd1a6032d$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $112576f3a2425ff3$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $112576f3a2425ff3$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $efa3b0afd1a6032d$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $efa3b0afd1a6032d$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $efa3b0afd1a6032d$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $efa3b0afd1a6032d$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $efa3b0afd1a6032d$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $efa3b0afd1a6032d$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $efa3b0afd1a6032d$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $efa3b0afd1a6032d$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $efa3b0afd1a6032d$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $efa3b0afd1a6032d$export$a13296960cae0384 = {
    evaluateInteractionItems: $efa3b0afd1a6032d$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $efa3b0afd1a6032d$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $efa3b0afd1a6032d$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $efa3b0afd1a6032d$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $efa3b0afd1a6032d$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $efa3b0afd1a6032d$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $efa3b0afd1a6032d$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            return $efa3b0afd1a6032d$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $112576f3a2425ff3$export$df995fae86a55f06)(e, chart);
            return $efa3b0afd1a6032d$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $efa3b0afd1a6032d$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $efa3b0afd1a6032d$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $efa3b0afd1a6032d$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$efa3b0afd1a6032d$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $efa3b0afd1a6032d$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $efa3b0afd1a6032d$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $efa3b0afd1a6032d$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$efa3b0afd1a6032d$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $efa3b0afd1a6032d$var$setLayoutDims(layouts, params) {
    const stacks = $efa3b0afd1a6032d$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $efa3b0afd1a6032d$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $efa3b0afd1a6032d$var$wrapBoxes(boxes);
    const fullSize = $efa3b0afd1a6032d$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $efa3b0afd1a6032d$var$sortByWeight($efa3b0afd1a6032d$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $efa3b0afd1a6032d$var$sortByWeight($efa3b0afd1a6032d$var$filterByPosition(layoutBoxes, 'right'));
    const top = $efa3b0afd1a6032d$var$sortByWeight($efa3b0afd1a6032d$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $efa3b0afd1a6032d$var$sortByWeight($efa3b0afd1a6032d$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $efa3b0afd1a6032d$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $efa3b0afd1a6032d$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $efa3b0afd1a6032d$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $efa3b0afd1a6032d$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $efa3b0afd1a6032d$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $efa3b0afd1a6032d$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $112576f3a2425ff3$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $efa3b0afd1a6032d$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $efa3b0afd1a6032d$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $efa3b0afd1a6032d$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $efa3b0afd1a6032d$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $efa3b0afd1a6032d$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $efa3b0afd1a6032d$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $efa3b0afd1a6032d$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $efa3b0afd1a6032d$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $efa3b0afd1a6032d$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $efa3b0afd1a6032d$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $efa3b0afd1a6032d$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $112576f3a2425ff3$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $efa3b0afd1a6032d$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $efa3b0afd1a6032d$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $112576f3a2425ff3$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $efa3b0afd1a6032d$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $efa3b0afd1a6032d$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $efa3b0afd1a6032d$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $efa3b0afd1a6032d$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $112576f3a2425ff3$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $efa3b0afd1a6032d$var$updateMaxPadding(maxPadding, (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $efa3b0afd1a6032d$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $efa3b0afd1a6032d$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $efa3b0afd1a6032d$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($efa3b0afd1a6032d$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $efa3b0afd1a6032d$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $efa3b0afd1a6032d$var$handleMaxPadding(chartArea);
        $efa3b0afd1a6032d$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $efa3b0afd1a6032d$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $112576f3a2425ff3$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $efa3b0afd1a6032d$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $efa3b0afd1a6032d$export$a40a96b24b46cf35 extends $efa3b0afd1a6032d$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $efa3b0afd1a6032d$var$EXPANDO_KEY = '$chartjs';
const $efa3b0afd1a6032d$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $efa3b0afd1a6032d$var$isNullOrEmpty = (value)=>value === null || value === '';
function $efa3b0afd1a6032d$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$efa3b0afd1a6032d$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($efa3b0afd1a6032d$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $112576f3a2425ff3$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($efa3b0afd1a6032d$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $112576f3a2425ff3$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $efa3b0afd1a6032d$var$eventListenerOptions = (0, $112576f3a2425ff3$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $efa3b0afd1a6032d$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $efa3b0afd1a6032d$var$eventListenerOptions);
}
function $efa3b0afd1a6032d$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $efa3b0afd1a6032d$var$eventListenerOptions);
}
function $efa3b0afd1a6032d$var$fromNativeEvent(event, chart) {
    const type = $efa3b0afd1a6032d$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $112576f3a2425ff3$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $efa3b0afd1a6032d$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $efa3b0afd1a6032d$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $efa3b0afd1a6032d$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$efa3b0afd1a6032d$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $efa3b0afd1a6032d$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $efa3b0afd1a6032d$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$efa3b0afd1a6032d$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $efa3b0afd1a6032d$var$drpListeningCharts = new Map();
let $efa3b0afd1a6032d$var$oldDevicePixelRatio = 0;
function $efa3b0afd1a6032d$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $efa3b0afd1a6032d$var$oldDevicePixelRatio) return;
    $efa3b0afd1a6032d$var$oldDevicePixelRatio = dpr;
    $efa3b0afd1a6032d$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $efa3b0afd1a6032d$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$efa3b0afd1a6032d$var$drpListeningCharts.size) window.addEventListener('resize', $efa3b0afd1a6032d$var$onWindowResize);
    $efa3b0afd1a6032d$var$drpListeningCharts.set(chart, resize);
}
function $efa3b0afd1a6032d$var$unlistenDevicePixelRatioChanges(chart) {
    $efa3b0afd1a6032d$var$drpListeningCharts.delete(chart);
    if (!$efa3b0afd1a6032d$var$drpListeningCharts.size) window.removeEventListener('resize', $efa3b0afd1a6032d$var$onWindowResize);
}
function $efa3b0afd1a6032d$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $112576f3a2425ff3$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $112576f3a2425ff3$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $efa3b0afd1a6032d$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $efa3b0afd1a6032d$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $efa3b0afd1a6032d$var$unlistenDevicePixelRatioChanges(chart);
}
function $efa3b0afd1a6032d$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $112576f3a2425ff3$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($efa3b0afd1a6032d$var$fromNativeEvent(event, chart));
    }, chart);
    $efa3b0afd1a6032d$var$addListener(canvas, type, proxy);
    return proxy;
}
class $efa3b0afd1a6032d$export$f02da7f882cf6b2e extends $efa3b0afd1a6032d$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $efa3b0afd1a6032d$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$efa3b0afd1a6032d$var$EXPANDO_KEY]) return false;
        const initial = canvas[$efa3b0afd1a6032d$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$efa3b0afd1a6032d$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $efa3b0afd1a6032d$var$createAttachObserver,
            detach: $efa3b0afd1a6032d$var$createDetachObserver,
            resize: $efa3b0afd1a6032d$var$createResizeObserver
        };
        const handler = handlers[type] || $efa3b0afd1a6032d$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $efa3b0afd1a6032d$var$releaseObserver,
            detach: $efa3b0afd1a6032d$var$releaseObserver,
            resize: $efa3b0afd1a6032d$var$releaseObserver
        };
        const handler = handlers[type] || $efa3b0afd1a6032d$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $112576f3a2425ff3$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $112576f3a2425ff3$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $efa3b0afd1a6032d$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $112576f3a2425ff3$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $efa3b0afd1a6032d$export$a40a96b24b46cf35;
    return $efa3b0afd1a6032d$export$f02da7f882cf6b2e;
}
class $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $112576f3a2425ff3$export$d141bba7fdc215a3)(this.x) && (0, $112576f3a2425ff3$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $efa3b0afd1a6032d$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $efa3b0afd1a6032d$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $efa3b0afd1a6032d$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $efa3b0afd1a6032d$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $efa3b0afd1a6032d$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $efa3b0afd1a6032d$var$skip(ticks, newTicks, spacing, (0, $112576f3a2425ff3$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$efa3b0afd1a6032d$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $efa3b0afd1a6032d$var$skip(ticks, newTicks, spacing, last, (0, $112576f3a2425ff3$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $efa3b0afd1a6032d$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $efa3b0afd1a6032d$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $efa3b0afd1a6032d$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $efa3b0afd1a6032d$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $112576f3a2425ff3$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $efa3b0afd1a6032d$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $efa3b0afd1a6032d$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $efa3b0afd1a6032d$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $112576f3a2425ff3$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $efa3b0afd1a6032d$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $efa3b0afd1a6032d$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $efa3b0afd1a6032d$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $efa3b0afd1a6032d$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $efa3b0afd1a6032d$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $efa3b0afd1a6032d$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $efa3b0afd1a6032d$var$garbageCollect(caches, length) {
    (0, $112576f3a2425ff3$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $efa3b0afd1a6032d$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $efa3b0afd1a6032d$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $efa3b0afd1a6032d$var$createScaleContext(parent, scale) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $efa3b0afd1a6032d$var$createTickContext(parent, index, tick) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $efa3b0afd1a6032d$var$titleAlign(align, position, reverse) {
    let ret = (0, $112576f3a2425ff3$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $efa3b0afd1a6032d$var$reverseAlign(ret);
    return ret;
}
function $efa3b0afd1a6032d$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $efa3b0afd1a6032d$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $efa3b0afd1a6032d$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd) : (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $efa3b0afd1a6032d$export$d60cfc58d3c358b6 extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $112576f3a2425ff3$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $112576f3a2425ff3$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $112576f3a2425ff3$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $112576f3a2425ff3$export$c4ce752e73470fba)(min, (0, $112576f3a2425ff3$export$c4ce752e73470fba)(max, min)),
            max: (0, $112576f3a2425ff3$export$c4ce752e73470fba)(max, (0, $112576f3a2425ff3$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $112576f3a2425ff3$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $efa3b0afd1a6032d$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $efa3b0afd1a6032d$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $efa3b0afd1a6032d$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $112576f3a2425ff3$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $efa3b0afd1a6032d$var$getTickMarkLength(options.grid) - tickOpts.padding - $efa3b0afd1a6032d$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $112576f3a2425ff3$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $112576f3a2425ff3$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $112576f3a2425ff3$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $112576f3a2425ff3$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $efa3b0afd1a6032d$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $efa3b0afd1a6032d$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $efa3b0afd1a6032d$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $efa3b0afd1a6032d$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $efa3b0afd1a6032d$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(label) && !(0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(label)) {
                width = (0, $112576f3a2425ff3$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(nestedLabel) && !(0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $112576f3a2425ff3$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $efa3b0afd1a6032d$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $112576f3a2425ff3$export$71cec2538cb2c617)(this._alignToPixels ? (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $efa3b0afd1a6032d$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $efa3b0afd1a6032d$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $efa3b0afd1a6032d$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $efa3b0afd1a6032d$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $efa3b0afd1a6032d$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $112576f3a2425ff3$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $112576f3a2425ff3$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $112576f3a2425ff3$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $112576f3a2425ff3$export$34aec0b863436764)(title.font);
        const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $112576f3a2425ff3$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $efa3b0afd1a6032d$var$titleArgs(this, offset, position, align);
        (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $efa3b0afd1a6032d$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $efa3b0afd1a6032d$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $112576f3a2425ff3$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $efa3b0afd1a6032d$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($efa3b0afd1a6032d$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $efa3b0afd1a6032d$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $112576f3a2425ff3$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $112576f3a2425ff3$export$4368d992c4eafac0)[scope]) {
            delete (0, $112576f3a2425ff3$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $112576f3a2425ff3$export$6559d589eb85fbb6)[id];
        }
    }
}
function $efa3b0afd1a6032d$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $112576f3a2425ff3$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $112576f3a2425ff3$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $112576f3a2425ff3$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $112576f3a2425ff3$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $efa3b0afd1a6032d$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $112576f3a2425ff3$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $efa3b0afd1a6032d$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $112576f3a2425ff3$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $efa3b0afd1a6032d$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $efa3b0afd1a6032d$var$Registry {
    constructor(){
        this.controllers = new $efa3b0afd1a6032d$var$TypedRegistry($efa3b0afd1a6032d$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $efa3b0afd1a6032d$var$TypedRegistry($efa3b0afd1a6032d$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $efa3b0afd1a6032d$var$TypedRegistry(Object, 'plugins');
        this.scales = new $efa3b0afd1a6032d$var$TypedRegistry($efa3b0afd1a6032d$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $112576f3a2425ff3$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $112576f3a2425ff3$export$a8550f7dbe79f93a)(method);
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $efa3b0afd1a6032d$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $efa3b0afd1a6032d$var$Registry();
class $efa3b0afd1a6032d$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $112576f3a2425ff3$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $efa3b0afd1a6032d$var$allPlugins(config);
        return options === false && !all ? [] : $efa3b0afd1a6032d$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $efa3b0afd1a6032d$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($efa3b0afd1a6032d$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($efa3b0afd1a6032d$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $efa3b0afd1a6032d$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $efa3b0afd1a6032d$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $efa3b0afd1a6032d$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $efa3b0afd1a6032d$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $efa3b0afd1a6032d$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $efa3b0afd1a6032d$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $112576f3a2425ff3$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $efa3b0afd1a6032d$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $efa3b0afd1a6032d$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $efa3b0afd1a6032d$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $efa3b0afd1a6032d$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $efa3b0afd1a6032d$var$determineAxis(id, ...scaleOptions) {
    if ($efa3b0afd1a6032d$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $efa3b0afd1a6032d$var$axisFromPosition(opts.position) || id.length > 1 && $efa3b0afd1a6032d$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $efa3b0afd1a6032d$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $efa3b0afd1a6032d$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $efa3b0afd1a6032d$var$getAxisFromDataset(id, 'x', boundDs[0]) || $efa3b0afd1a6032d$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $efa3b0afd1a6032d$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $112576f3a2425ff3$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $efa3b0afd1a6032d$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $112576f3a2425ff3$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $efa3b0afd1a6032d$var$determineAxis(id, scaleConf, $efa3b0afd1a6032d$var$retrieveAxisFromDatasets(id, config), (0, $112576f3a2425ff3$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $efa3b0afd1a6032d$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $112576f3a2425ff3$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $efa3b0afd1a6032d$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $112576f3a2425ff3$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $efa3b0afd1a6032d$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $112576f3a2425ff3$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $112576f3a2425ff3$export$555508cbc6add439)(scale, [
            (0, $112576f3a2425ff3$export$4368d992c4eafac0).scales[scale.type],
            (0, $112576f3a2425ff3$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $efa3b0afd1a6032d$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $efa3b0afd1a6032d$var$mergeScaleConfig(config, options);
}
function $efa3b0afd1a6032d$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $efa3b0afd1a6032d$var$initConfig(config) {
    config = config || {};
    config.data = $efa3b0afd1a6032d$var$initData(config.data);
    $efa3b0afd1a6032d$var$initOptions(config);
    return config;
}
const $efa3b0afd1a6032d$var$keyCache = new Map();
const $efa3b0afd1a6032d$var$keysCached = new Set();
function $efa3b0afd1a6032d$var$cachedKeys(cacheKey, generate) {
    let keys = $efa3b0afd1a6032d$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $efa3b0afd1a6032d$var$keyCache.set(cacheKey, keys);
        $efa3b0afd1a6032d$var$keysCached.add(keys);
    }
    return keys;
}
const $efa3b0afd1a6032d$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $112576f3a2425ff3$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $efa3b0afd1a6032d$var$Config {
    constructor(config){
        this._config = $efa3b0afd1a6032d$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $efa3b0afd1a6032d$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $efa3b0afd1a6032d$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $efa3b0afd1a6032d$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $efa3b0afd1a6032d$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $efa3b0afd1a6032d$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $efa3b0afd1a6032d$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$efa3b0afd1a6032d$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$efa3b0afd1a6032d$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$efa3b0afd1a6032d$var$addIfFound(scopes, (0, $112576f3a2425ff3$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$efa3b0afd1a6032d$var$addIfFound(scopes, (0, $112576f3a2425ff3$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$efa3b0afd1a6032d$var$addIfFound(scopes, (0, $112576f3a2425ff3$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($efa3b0afd1a6032d$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $112576f3a2425ff3$export$6559d589eb85fbb6)[type] || {},
            (0, $112576f3a2425ff3$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $112576f3a2425ff3$export$4368d992c4eafac0),
            (0, $112576f3a2425ff3$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $efa3b0afd1a6032d$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($efa3b0afd1a6032d$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $112576f3a2425ff3$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $112576f3a2425ff3$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $efa3b0afd1a6032d$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $112576f3a2425ff3$export$23f2a1d2818174ef)(context) ? (0, $112576f3a2425ff3$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $efa3b0afd1a6032d$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $112576f3a2425ff3$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $efa3b0afd1a6032d$var$hasFunction = (value)=>(0, $112576f3a2425ff3$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $112576f3a2425ff3$export$a93c5207d687da10)(value[key]));
function $efa3b0afd1a6032d$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $112576f3a2425ff3$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $112576f3a2425ff3$export$a93c5207d687da10)(value) || $efa3b0afd1a6032d$var$hasFunction(value)) || indexable && (0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $efa3b0afd1a6032d$var$version = "4.5.0";
const $efa3b0afd1a6032d$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $efa3b0afd1a6032d$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $efa3b0afd1a6032d$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $efa3b0afd1a6032d$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $efa3b0afd1a6032d$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $efa3b0afd1a6032d$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $efa3b0afd1a6032d$var$getCanvas(item) {
    if ((0, $112576f3a2425ff3$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $efa3b0afd1a6032d$var$instances = {};
const $efa3b0afd1a6032d$var$getChart = (key)=>{
    const canvas = $efa3b0afd1a6032d$var$getCanvas(key);
    return Object.values($efa3b0afd1a6032d$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $efa3b0afd1a6032d$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $efa3b0afd1a6032d$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $efa3b0afd1a6032d$export$acaa6426d77a227e {
    static defaults = (0, $112576f3a2425ff3$export$4368d992c4eafac0);
    static instances = $efa3b0afd1a6032d$var$instances;
    static overrides = (0, $112576f3a2425ff3$export$6559d589eb85fbb6);
    static registry = $efa3b0afd1a6032d$export$4bb7493d241fd8a5;
    static version = $efa3b0afd1a6032d$var$version;
    static getChart = $efa3b0afd1a6032d$var$getChart;
    static register(...items) {
        $efa3b0afd1a6032d$export$4bb7493d241fd8a5.add(...items);
        $efa3b0afd1a6032d$var$invalidatePlugins();
    }
    static unregister(...items) {
        $efa3b0afd1a6032d$export$4bb7493d241fd8a5.remove(...items);
        $efa3b0afd1a6032d$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $efa3b0afd1a6032d$var$Config(userConfig);
        const initialCanvas = $efa3b0afd1a6032d$var$getCanvas(item);
        const existingChart = $efa3b0afd1a6032d$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $efa3b0afd1a6032d$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $112576f3a2425ff3$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $efa3b0afd1a6032d$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $112576f3a2425ff3$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $efa3b0afd1a6032d$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $efa3b0afd1a6032d$export$a424a0aa8f687495.listen(this, 'complete', $efa3b0afd1a6032d$var$onAnimationsComplete);
        $efa3b0afd1a6032d$export$a424a0aa8f687495.listen(this, 'progress', $efa3b0afd1a6032d$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $efa3b0afd1a6032d$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $112576f3a2425ff3$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $112576f3a2425ff3$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $efa3b0afd1a6032d$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$efa3b0afd1a6032d$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $112576f3a2425ff3$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $112576f3a2425ff3$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $efa3b0afd1a6032d$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $112576f3a2425ff3$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $efa3b0afd1a6032d$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $efa3b0afd1a6032d$var$positionIsHorizontal(scaleOptions.position, axis) !== $efa3b0afd1a6032d$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $efa3b0afd1a6032d$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $112576f3a2425ff3$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $112576f3a2425ff3$export$d66501df72047452)(scales, (scale)=>{
            $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $efa3b0afd1a6032d$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($efa3b0afd1a6032d$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $efa3b0afd1a6032d$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $efa3b0afd1a6032d$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $112576f3a2425ff3$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $efa3b0afd1a6032d$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $efa3b0afd1a6032d$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $112576f3a2425ff3$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($efa3b0afd1a6032d$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.scales, (scale)=>{
            $efa3b0afd1a6032d$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $112576f3a2425ff3$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $efa3b0afd1a6032d$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $112576f3a2425ff3$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $112576f3a2425ff3$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($efa3b0afd1a6032d$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$efa3b0afd1a6032d$export$a424a0aa8f687495.running(this)) $efa3b0afd1a6032d$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $efa3b0afd1a6032d$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $112576f3a2425ff3$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $112576f3a2425ff3$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $112576f3a2425ff3$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $112576f3a2425ff3$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $efa3b0afd1a6032d$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $112576f3a2425ff3$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $112576f3a2425ff3$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $efa3b0afd1a6032d$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $112576f3a2425ff3$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $efa3b0afd1a6032d$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $112576f3a2425ff3$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $112576f3a2425ff3$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $112576f3a2425ff3$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $112576f3a2425ff3$export$3b513254972cfc9c)(e);
        const lastEvent = $efa3b0afd1a6032d$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $112576f3a2425ff3$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $efa3b0afd1a6032d$var$invalidatePlugins() {
    return (0, $112576f3a2425ff3$export$d66501df72047452)($efa3b0afd1a6032d$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $efa3b0afd1a6032d$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2, startAngle + (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $efa3b0afd1a6032d$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd), startAngle - (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $efa3b0afd1a6032d$var$toRadiusCorners(value) {
    return (0, $112576f3a2425ff3$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $efa3b0afd1a6032d$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $efa3b0afd1a6032d$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $112576f3a2425ff3$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $112576f3a2425ff3$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $112576f3a2425ff3$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $efa3b0afd1a6032d$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $efa3b0afd1a6032d$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $112576f3a2425ff3$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $efa3b0afd1a6032d$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $efa3b0afd1a6032d$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $efa3b0afd1a6032d$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $efa3b0afd1a6032d$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $efa3b0afd1a6032d$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $efa3b0afd1a6032d$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $efa3b0afd1a6032d$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $efa3b0afd1a6032d$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $efa3b0afd1a6032d$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $112576f3a2425ff3$export$971d5caa766a69d7) || (0, $112576f3a2425ff3$export$971d5caa766a69d7));
    }
    $efa3b0afd1a6032d$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $efa3b0afd1a6032d$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $efa3b0afd1a6032d$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $112576f3a2425ff3$export$971d5caa766a69d7) || (0, $112576f3a2425ff3$export$971d5caa766a69d7));
    }
    if (inner) $efa3b0afd1a6032d$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $112576f3a2425ff3$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $efa3b0afd1a6032d$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $efa3b0afd1a6032d$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $efa3b0afd1a6032d$export$d48203c759d6a1fc extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $112576f3a2425ff3$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $112576f3a2425ff3$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $112576f3a2425ff3$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $112576f3a2425ff3$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $112576f3a2425ff3$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $112576f3a2425ff3$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $112576f3a2425ff3$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $efa3b0afd1a6032d$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $efa3b0afd1a6032d$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $efa3b0afd1a6032d$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $efa3b0afd1a6032d$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $efa3b0afd1a6032d$var$getLineMethod(options) {
    if (options.stepped) return 0, $112576f3a2425ff3$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $112576f3a2425ff3$export$1fbe638ecf81657e;
    return $efa3b0afd1a6032d$var$lineTo;
}
function $efa3b0afd1a6032d$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $efa3b0afd1a6032d$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $efa3b0afd1a6032d$var$pathVars(points, segment, params);
    const lineMethod = $efa3b0afd1a6032d$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $efa3b0afd1a6032d$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $efa3b0afd1a6032d$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $efa3b0afd1a6032d$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $efa3b0afd1a6032d$var$fastPathSegment : $efa3b0afd1a6032d$var$pathSegment;
}
function $efa3b0afd1a6032d$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $112576f3a2425ff3$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $112576f3a2425ff3$export$d24c54395ce0c509;
    return 0, $112576f3a2425ff3$export$6554612db691658e;
}
function $efa3b0afd1a6032d$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $efa3b0afd1a6032d$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $efa3b0afd1a6032d$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $efa3b0afd1a6032d$var$_getSegmentMethod(line);
    for (const segment of segments){
        $efa3b0afd1a6032d$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $efa3b0afd1a6032d$var$usePath2D = typeof Path2D === 'function';
function $efa3b0afd1a6032d$var$draw(ctx, line, start, count) {
    if ($efa3b0afd1a6032d$var$usePath2D && !line.options.segment) $efa3b0afd1a6032d$var$strokePathWithCache(ctx, line, start, count);
    else $efa3b0afd1a6032d$var$strokePathDirect(ctx, line, start, count);
}
class $efa3b0afd1a6032d$export$55e463fa7bcd3469 extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $112576f3a2425ff3$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $112576f3a2425ff3$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $112576f3a2425ff3$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $efa3b0afd1a6032d$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $efa3b0afd1a6032d$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $efa3b0afd1a6032d$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $efa3b0afd1a6032d$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $efa3b0afd1a6032d$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $efa3b0afd1a6032d$export$bd159b522b230b7a extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $efa3b0afd1a6032d$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $efa3b0afd1a6032d$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $112576f3a2425ff3$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $112576f3a2425ff3$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $efa3b0afd1a6032d$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $efa3b0afd1a6032d$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $112576f3a2425ff3$export$25ce5a424b770e84)(value, min, max);
}
function $efa3b0afd1a6032d$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $112576f3a2425ff3$export$9fa96a7d116ea3ce)(value);
    return {
        t: $efa3b0afd1a6032d$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $efa3b0afd1a6032d$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $efa3b0afd1a6032d$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $efa3b0afd1a6032d$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $efa3b0afd1a6032d$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $112576f3a2425ff3$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $efa3b0afd1a6032d$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $efa3b0afd1a6032d$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $efa3b0afd1a6032d$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $efa3b0afd1a6032d$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $efa3b0afd1a6032d$var$boundingRects(bar) {
    const bounds = $efa3b0afd1a6032d$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $efa3b0afd1a6032d$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $efa3b0afd1a6032d$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $efa3b0afd1a6032d$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $efa3b0afd1a6032d$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $112576f3a2425ff3$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $112576f3a2425ff3$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $efa3b0afd1a6032d$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $efa3b0afd1a6032d$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $efa3b0afd1a6032d$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $efa3b0afd1a6032d$export$a16ed71bf4b07672 extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $efa3b0afd1a6032d$var$boundingRects(this);
        const addRectPath = $efa3b0afd1a6032d$var$hasRadius(outer.radius) ? (0, $112576f3a2425ff3$export$92108d983e8ee699) : $efa3b0afd1a6032d$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $efa3b0afd1a6032d$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $efa3b0afd1a6032d$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $efa3b0afd1a6032d$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $efa3b0afd1a6032d$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $efa3b0afd1a6032d$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $efa3b0afd1a6032d$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $efa3b0afd1a6032d$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $efa3b0afd1a6032d$export$d48203c759d6a1fc,
    BarElement: $efa3b0afd1a6032d$export$a16ed71bf4b07672,
    LineElement: $efa3b0afd1a6032d$export$55e463fa7bcd3469,
    PointElement: $efa3b0afd1a6032d$export$bd159b522b230b7a
});
const $efa3b0afd1a6032d$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $efa3b0afd1a6032d$var$BACKGROUND_COLORS = /* #__PURE__ */ $efa3b0afd1a6032d$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $efa3b0afd1a6032d$var$getBorderColor(i) {
    return $efa3b0afd1a6032d$var$BORDER_COLORS[i % $efa3b0afd1a6032d$var$BORDER_COLORS.length];
}
function $efa3b0afd1a6032d$var$getBackgroundColor(i) {
    return $efa3b0afd1a6032d$var$BACKGROUND_COLORS[i % $efa3b0afd1a6032d$var$BACKGROUND_COLORS.length];
}
function $efa3b0afd1a6032d$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $efa3b0afd1a6032d$var$getBorderColor(i);
    dataset.backgroundColor = $efa3b0afd1a6032d$var$getBackgroundColor(i);
    return ++i;
}
function $efa3b0afd1a6032d$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$efa3b0afd1a6032d$var$getBorderColor(i++));
    return i;
}
function $efa3b0afd1a6032d$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$efa3b0afd1a6032d$var$getBackgroundColor(i++));
    return i;
}
function $efa3b0afd1a6032d$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $efa3b0afd1a6032d$export$e04603e7d8b77172) i = $efa3b0afd1a6032d$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $efa3b0afd1a6032d$export$2a270b3a0d973c85) i = $efa3b0afd1a6032d$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $efa3b0afd1a6032d$var$colorizeDefaultDataset(dataset, i);
    };
}
function $efa3b0afd1a6032d$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $efa3b0afd1a6032d$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $efa3b0afd1a6032d$var$containsDefaultColorsDefenitions() {
    return (0, $112576f3a2425ff3$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $112576f3a2425ff3$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $efa3b0afd1a6032d$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $efa3b0afd1a6032d$var$containsColorsDefinitions(datasets) || $efa3b0afd1a6032d$var$containsColorsDefinition(chartOptions) || elements && $efa3b0afd1a6032d$var$containsColorsDefinitions(elements) || $efa3b0afd1a6032d$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $efa3b0afd1a6032d$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $efa3b0afd1a6032d$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $efa3b0afd1a6032d$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(minIndex) && !(0, $112576f3a2425ff3$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $efa3b0afd1a6032d$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $efa3b0afd1a6032d$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $efa3b0afd1a6032d$var$cleanDecimatedDataset(dataset);
    });
}
function $efa3b0afd1a6032d$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $112576f3a2425ff3$export$25ce5a424b770e84)((0, $112576f3a2425ff3$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $112576f3a2425ff3$export$25ce5a424b770e84)((0, $112576f3a2425ff3$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $efa3b0afd1a6032d$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $efa3b0afd1a6032d$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $112576f3a2425ff3$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $efa3b0afd1a6032d$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $efa3b0afd1a6032d$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $efa3b0afd1a6032d$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $efa3b0afd1a6032d$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $efa3b0afd1a6032d$var$cleanDecimatedData(chart);
    }
};
function $efa3b0afd1a6032d$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $efa3b0afd1a6032d$var$_findSegmentEnd(start, end, points);
        const bounds = $efa3b0afd1a6032d$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $112576f3a2425ff3$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $efa3b0afd1a6032d$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $112576f3a2425ff3$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $efa3b0afd1a6032d$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $efa3b0afd1a6032d$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $efa3b0afd1a6032d$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(start);
        end = (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $efa3b0afd1a6032d$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $efa3b0afd1a6032d$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $efa3b0afd1a6032d$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $efa3b0afd1a6032d$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $efa3b0afd1a6032d$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $efa3b0afd1a6032d$var$_pointsFromSegments(boundary, line);
    return points.length ? new $efa3b0afd1a6032d$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $efa3b0afd1a6032d$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $efa3b0afd1a6032d$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $112576f3a2425ff3$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $efa3b0afd1a6032d$var$_decodeFill(line, index, count) {
    const fill = $efa3b0afd1a6032d$var$parseFillOption(line);
    if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $112576f3a2425ff3$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $efa3b0afd1a6032d$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $efa3b0afd1a6032d$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $efa3b0afd1a6032d$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $efa3b0afd1a6032d$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $112576f3a2425ff3$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $efa3b0afd1a6032d$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $efa3b0afd1a6032d$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $efa3b0afd1a6032d$var$getLinesBelow(scale, index);
    linesBelow.push($efa3b0afd1a6032d$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$efa3b0afd1a6032d$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $efa3b0afd1a6032d$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $efa3b0afd1a6032d$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $efa3b0afd1a6032d$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $efa3b0afd1a6032d$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $efa3b0afd1a6032d$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $112576f3a2425ff3$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $efa3b0afd1a6032d$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $112576f3a2425ff3$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $efa3b0afd1a6032d$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $112576f3a2425ff3$export$39b482c5e57630a8)(fill)) return $efa3b0afd1a6032d$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $efa3b0afd1a6032d$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $efa3b0afd1a6032d$var$computeBoundary(source);
    if (boundary instanceof $efa3b0afd1a6032d$var$simpleArc) return boundary;
    return $efa3b0afd1a6032d$var$_createBoundaryLine(boundary, line);
}
function $efa3b0afd1a6032d$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $efa3b0afd1a6032d$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $efa3b0afd1a6032d$var$computeCircularBoundary(source);
    return $efa3b0afd1a6032d$var$computeLinearBoundary(source);
}
function $efa3b0afd1a6032d$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $efa3b0afd1a6032d$var$_getTargetPixel(fill, scale);
    if ((0, $112576f3a2425ff3$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $efa3b0afd1a6032d$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $efa3b0afd1a6032d$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $efa3b0afd1a6032d$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $efa3b0afd1a6032d$var$_drawfill(ctx, source, area) {
    const target = $efa3b0afd1a6032d$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $112576f3a2425ff3$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $112576f3a2425ff3$export$8743009a87fcb00f)(ctx, area);
        $efa3b0afd1a6032d$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $112576f3a2425ff3$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $efa3b0afd1a6032d$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $efa3b0afd1a6032d$var$clipVertical(ctx, target, area.top);
            $efa3b0afd1a6032d$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $efa3b0afd1a6032d$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $efa3b0afd1a6032d$var$clipHorizontal(ctx, target, area.left);
            $efa3b0afd1a6032d$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $efa3b0afd1a6032d$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $efa3b0afd1a6032d$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $efa3b0afd1a6032d$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$efa3b0afd1a6032d$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $efa3b0afd1a6032d$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$efa3b0afd1a6032d$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $efa3b0afd1a6032d$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $efa3b0afd1a6032d$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $efa3b0afd1a6032d$var$clipBounds(ctx, scale, clip, notShape && $efa3b0afd1a6032d$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $efa3b0afd1a6032d$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $efa3b0afd1a6032d$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $efa3b0afd1a6032d$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $efa3b0afd1a6032d$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $efa3b0afd1a6032d$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $efa3b0afd1a6032d$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $efa3b0afd1a6032d$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $efa3b0afd1a6032d$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $efa3b0afd1a6032d$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($efa3b0afd1a6032d$var$_shouldApplyFill(source)) $efa3b0afd1a6032d$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$efa3b0afd1a6032d$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $efa3b0afd1a6032d$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $efa3b0afd1a6032d$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $efa3b0afd1a6032d$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $efa3b0afd1a6032d$var$Legend extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $efa3b0afd1a6032d$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $efa3b0afd1a6032d$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $112576f3a2425ff3$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $112576f3a2425ff3$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $112576f3a2425ff3$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $efa3b0afd1a6032d$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $112576f3a2425ff3$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $112576f3a2425ff3$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $112576f3a2425ff3$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $112576f3a2425ff3$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $112576f3a2425ff3$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $efa3b0afd1a6032d$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $112576f3a2425ff3$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $112576f3a2425ff3$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $112576f3a2425ff3$export$21579262ef46735b)(x, this.left, this.right) && (0, $112576f3a2425ff3$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $112576f3a2425ff3$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $112576f3a2425ff3$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$efa3b0afd1a6032d$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $efa3b0afd1a6032d$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $efa3b0afd1a6032d$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $efa3b0afd1a6032d$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $efa3b0afd1a6032d$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $efa3b0afd1a6032d$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $efa3b0afd1a6032d$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $efa3b0afd1a6032d$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $efa3b0afd1a6032d$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $efa3b0afd1a6032d$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $efa3b0afd1a6032d$export$ed247974535929c7 = {
    id: 'legend',
    _element: $efa3b0afd1a6032d$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $efa3b0afd1a6032d$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $efa3b0afd1a6032d$var$Title extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $112576f3a2425ff3$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $112576f3a2425ff3$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $112576f3a2425ff3$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $112576f3a2425ff3$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $112576f3a2425ff3$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $112576f3a2425ff3$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $efa3b0afd1a6032d$var$createTitle(chart, titleOpts) {
    const title = new $efa3b0afd1a6032d$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $efa3b0afd1a6032d$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $efa3b0afd1a6032d$export$f99233281efd08a0 = {
    id: 'title',
    _element: $efa3b0afd1a6032d$var$Title,
    start (chart, _args, options) {
        $efa3b0afd1a6032d$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $efa3b0afd1a6032d$var$map = new WeakMap();
var $efa3b0afd1a6032d$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $efa3b0afd1a6032d$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, title, options);
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.addBox(chart, title);
        $efa3b0afd1a6032d$var$map.set(chart, title);
    },
    stop (chart) {
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.removeBox(chart, $efa3b0afd1a6032d$var$map.get(chart));
        $efa3b0afd1a6032d$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $efa3b0afd1a6032d$var$map.get(chart);
        $efa3b0afd1a6032d$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $efa3b0afd1a6032d$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $112576f3a2425ff3$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $efa3b0afd1a6032d$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $efa3b0afd1a6032d$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $efa3b0afd1a6032d$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $efa3b0afd1a6032d$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $112576f3a2425ff3$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $112576f3a2425ff3$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $112576f3a2425ff3$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $112576f3a2425ff3$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $112576f3a2425ff3$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $112576f3a2425ff3$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $112576f3a2425ff3$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $efa3b0afd1a6032d$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $efa3b0afd1a6032d$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $efa3b0afd1a6032d$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($efa3b0afd1a6032d$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $efa3b0afd1a6032d$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $efa3b0afd1a6032d$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $efa3b0afd1a6032d$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $efa3b0afd1a6032d$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $efa3b0afd1a6032d$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $efa3b0afd1a6032d$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(cornerRadius);
    let x = $efa3b0afd1a6032d$var$alignX(size, xAlign);
    const y = $efa3b0afd1a6032d$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $112576f3a2425ff3$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $112576f3a2425ff3$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $efa3b0afd1a6032d$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $efa3b0afd1a6032d$var$getBeforeAfterBodyLines(callback) {
    return $efa3b0afd1a6032d$var$pushOrConcat([], $efa3b0afd1a6032d$var$splitNewlines(callback));
}
function $efa3b0afd1a6032d$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $efa3b0afd1a6032d$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $efa3b0afd1a6032d$var$defaultCallbacks = {
    beforeTitle: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    beforeBody: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    beforeLabel: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    afterBody: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    beforeFooter: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    footer: (0, $112576f3a2425ff3$export$53a70dd1ebbae346),
    afterFooter: (0, $112576f3a2425ff3$export$53a70dd1ebbae346)
};
function $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $efa3b0afd1a6032d$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $efa3b0afd1a6032d$var$Tooltip extends $efa3b0afd1a6032d$export$db77ccec0bb4ccac {
    static positioners = $efa3b0afd1a6032d$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $efa3b0afd1a6032d$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $efa3b0afd1a6032d$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(beforeTitle));
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(title));
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $efa3b0afd1a6032d$var$getBeforeAfterBodyLines($efa3b0afd1a6032d$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $112576f3a2425ff3$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $efa3b0afd1a6032d$var$overrideCallbacks(callbacks, context);
            $efa3b0afd1a6032d$var$pushOrConcat(bodyItem.before, $efa3b0afd1a6032d$var$splitNewlines($efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $efa3b0afd1a6032d$var$pushOrConcat(bodyItem.lines, $efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $efa3b0afd1a6032d$var$pushOrConcat(bodyItem.after, $efa3b0afd1a6032d$var$splitNewlines($efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $efa3b0afd1a6032d$var$getBeforeAfterBodyLines($efa3b0afd1a6032d$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $efa3b0afd1a6032d$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(beforeFooter));
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(footer));
        lines = $efa3b0afd1a6032d$var$pushOrConcat(lines, $efa3b0afd1a6032d$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($efa3b0afd1a6032d$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $112576f3a2425ff3$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $efa3b0afd1a6032d$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($efa3b0afd1a6032d$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $efa3b0afd1a6032d$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $efa3b0afd1a6032d$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $efa3b0afd1a6032d$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $efa3b0afd1a6032d$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $efa3b0afd1a6032d$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.bodyFont);
        const colorX = $efa3b0afd1a6032d$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $112576f3a2425ff3$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $112576f3a2425ff3$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $112576f3a2425ff3$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $112576f3a2425ff3$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $112576f3a2425ff3$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $efa3b0afd1a6032d$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $112576f3a2425ff3$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $112576f3a2425ff3$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $112576f3a2425ff3$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $112576f3a2425ff3$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $efa3b0afd1a6032d$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $efa3b0afd1a6032d$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $efa3b0afd1a6032d$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $efa3b0afd1a6032d$var$determineAlignment(chart, options, positionAndSize);
            const point = $efa3b0afd1a6032d$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $112576f3a2425ff3$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $112576f3a2425ff3$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $112576f3a2425ff3$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $112576f3a2425ff3$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $efa3b0afd1a6032d$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $efa3b0afd1a6032d$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $efa3b0afd1a6032d$var$Tooltip,
    positioners: $efa3b0afd1a6032d$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $efa3b0afd1a6032d$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $efa3b0afd1a6032d$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $efa3b0afd1a6032d$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $efa3b0afd1a6032d$export$c537fa0d021d010b,
    Decimation: $efa3b0afd1a6032d$export$be17f937e9aa7533,
    Filler: $efa3b0afd1a6032d$export$d19ba4d812bed757,
    Legend: $efa3b0afd1a6032d$export$ed247974535929c7,
    SubTitle: $efa3b0afd1a6032d$export$d5c56664638992a4,
    Title: $efa3b0afd1a6032d$export$f99233281efd08a0,
    Tooltip: $efa3b0afd1a6032d$export$28c660c63b792dea
});
const $efa3b0afd1a6032d$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $efa3b0afd1a6032d$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $efa3b0afd1a6032d$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $efa3b0afd1a6032d$var$validIndex = (index, max)=>index === null ? null : (0, $112576f3a2425ff3$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $efa3b0afd1a6032d$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $efa3b0afd1a6032d$export$29e663ba4d09fe7 extends $efa3b0afd1a6032d$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $efa3b0afd1a6032d$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $efa3b0afd1a6032d$var$findOrAddLabel(labels, raw, (0, $112576f3a2425ff3$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $efa3b0afd1a6032d$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $efa3b0afd1a6032d$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $efa3b0afd1a6032d$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $112576f3a2425ff3$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $112576f3a2425ff3$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $112576f3a2425ff3$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $112576f3a2425ff3$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $112576f3a2425ff3$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $112576f3a2425ff3$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $112576f3a2425ff3$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $112576f3a2425ff3$export$91477dc880baac21)(spacing), (0, $112576f3a2425ff3$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $112576f3a2425ff3$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $112576f3a2425ff3$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $efa3b0afd1a6032d$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $112576f3a2425ff3$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $efa3b0afd1a6032d$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $efa3b0afd1a6032d$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $112576f3a2425ff3$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $efa3b0afd1a6032d$var$LinearScaleBase extends $efa3b0afd1a6032d$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $112576f3a2425ff3$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $efa3b0afd1a6032d$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $112576f3a2425ff3$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $112576f3a2425ff3$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $efa3b0afd1a6032d$export$e7f4e5e8656f0b93 extends $efa3b0afd1a6032d$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $112576f3a2425ff3$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $efa3b0afd1a6032d$var$log10Floor = (v)=>Math.floor((0, $112576f3a2425ff3$export$faec65b429be379)(v));
const $efa3b0afd1a6032d$var$changeExponent = (v, m)=>Math.pow(10, $efa3b0afd1a6032d$var$log10Floor(v) + m);
function $efa3b0afd1a6032d$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $efa3b0afd1a6032d$var$log10Floor(tickVal));
    return remain === 1;
}
function $efa3b0afd1a6032d$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $efa3b0afd1a6032d$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $efa3b0afd1a6032d$var$log10Floor(range);
    while($efa3b0afd1a6032d$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($efa3b0afd1a6032d$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $efa3b0afd1a6032d$var$log10Floor(min));
}
function $efa3b0afd1a6032d$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $efa3b0afd1a6032d$var$log10Floor(min);
    let exp = $efa3b0afd1a6032d$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $efa3b0afd1a6032d$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $112576f3a2425ff3$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $efa3b0afd1a6032d$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $efa3b0afd1a6032d$export$85295eaf7cb3ac3e extends $efa3b0afd1a6032d$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $112576f3a2425ff3$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $efa3b0afd1a6032d$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $112576f3a2425ff3$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $112576f3a2425ff3$export$39b482c5e57630a8)(this._userMin)) this.min = min === $efa3b0afd1a6032d$var$changeExponent(this.min, 0) ? $efa3b0afd1a6032d$var$changeExponent(this.min, -1) : $efa3b0afd1a6032d$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($efa3b0afd1a6032d$var$changeExponent(min, -1));
                setMax($efa3b0afd1a6032d$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($efa3b0afd1a6032d$var$changeExponent(max, -1));
        if (max <= 0) setMax($efa3b0afd1a6032d$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $efa3b0afd1a6032d$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $112576f3a2425ff3$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $112576f3a2425ff3$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $112576f3a2425ff3$export$faec65b429be379)(start);
        this._valueRange = (0, $112576f3a2425ff3$export$faec65b429be379)(this.max) - (0, $112576f3a2425ff3$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $112576f3a2425ff3$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $efa3b0afd1a6032d$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $112576f3a2425ff3$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $112576f3a2425ff3$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $efa3b0afd1a6032d$var$measureLabelSize(ctx, font, label) {
    label = (0, $112576f3a2425ff3$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $112576f3a2425ff3$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $efa3b0afd1a6032d$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $efa3b0afd1a6032d$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(opts.font);
        const textSize = $efa3b0afd1a6032d$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $112576f3a2425ff3$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $efa3b0afd1a6032d$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $efa3b0afd1a6032d$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $efa3b0afd1a6032d$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $efa3b0afd1a6032d$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $efa3b0afd1a6032d$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $efa3b0afd1a6032d$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $112576f3a2425ff3$export$3a6d5c9ae78a2c08)((0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd))));
    const y = $efa3b0afd1a6032d$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $efa3b0afd1a6032d$var$getTextAlignForAngle(angle);
    const left = $efa3b0afd1a6032d$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $efa3b0afd1a6032d$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $112576f3a2425ff3$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $112576f3a2425ff3$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $112576f3a2425ff3$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $112576f3a2425ff3$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $efa3b0afd1a6032d$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $efa3b0afd1a6032d$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $112576f3a2425ff3$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $efa3b0afd1a6032d$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $efa3b0afd1a6032d$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $efa3b0afd1a6032d$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $efa3b0afd1a6032d$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $efa3b0afd1a6032d$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $efa3b0afd1a6032d$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $112576f3a2425ff3$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $112576f3a2425ff3$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $112576f3a2425ff3$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $efa3b0afd1a6032d$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $efa3b0afd1a6032d$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $efa3b0afd1a6032d$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $112576f3a2425ff3$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $efa3b0afd1a6032d$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $efa3b0afd1a6032d$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $efa3b0afd1a6032d$var$createPointLabelContext(parent, index, label) {
    return (0, $112576f3a2425ff3$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $efa3b0afd1a6032d$export$cfafc36d95386d38 extends $efa3b0afd1a6032d$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $112576f3a2425ff3$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)($efa3b0afd1a6032d$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $efa3b0afd1a6032d$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $efa3b0afd1a6032d$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $efa3b0afd1a6032d$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $112576f3a2425ff3$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $112576f3a2425ff3$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $112576f3a2425ff3$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $efa3b0afd1a6032d$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $112576f3a2425ff3$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $efa3b0afd1a6032d$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $efa3b0afd1a6032d$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $efa3b0afd1a6032d$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $112576f3a2425ff3$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $112576f3a2425ff3$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $112576f3a2425ff3$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $efa3b0afd1a6032d$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $efa3b0afd1a6032d$var$UNITS = /* #__PURE__ */ Object.keys($efa3b0afd1a6032d$var$INTERVALS);
function $efa3b0afd1a6032d$var$sorter(a, b) {
    return a - b;
}
function $efa3b0afd1a6032d$var$parse(scale, input) {
    if ((0, $112576f3a2425ff3$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $112576f3a2425ff3$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $112576f3a2425ff3$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $efa3b0afd1a6032d$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $efa3b0afd1a6032d$var$UNITS.length;
    for(let i = $efa3b0afd1a6032d$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $efa3b0afd1a6032d$var$INTERVALS[$efa3b0afd1a6032d$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $efa3b0afd1a6032d$var$UNITS[i];
    }
    return $efa3b0afd1a6032d$var$UNITS[ilen - 1];
}
function $efa3b0afd1a6032d$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $efa3b0afd1a6032d$var$UNITS.length - 1; i >= $efa3b0afd1a6032d$var$UNITS.indexOf(minUnit); i--){
        const unit = $efa3b0afd1a6032d$var$UNITS[i];
        if ($efa3b0afd1a6032d$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $efa3b0afd1a6032d$var$UNITS[minUnit ? $efa3b0afd1a6032d$var$UNITS.indexOf(minUnit) : 0];
}
function $efa3b0afd1a6032d$var$determineMajorUnit(unit) {
    for(let i = $efa3b0afd1a6032d$var$UNITS.indexOf(unit) + 1, ilen = $efa3b0afd1a6032d$var$UNITS.length; i < ilen; ++i){
        if ($efa3b0afd1a6032d$var$INTERVALS[$efa3b0afd1a6032d$var$UNITS[i]].common) return $efa3b0afd1a6032d$var$UNITS[i];
    }
}
function $efa3b0afd1a6032d$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $112576f3a2425ff3$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $efa3b0afd1a6032d$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $efa3b0afd1a6032d$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $efa3b0afd1a6032d$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $efa3b0afd1a6032d$export$a894c72689ff3ec extends $efa3b0afd1a6032d$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $efa3b0afd1a6032d$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $112576f3a2425ff3$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $efa3b0afd1a6032d$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $112576f3a2425ff3$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $112576f3a2425ff3$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $efa3b0afd1a6032d$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $efa3b0afd1a6032d$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $efa3b0afd1a6032d$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $efa3b0afd1a6032d$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $112576f3a2425ff3$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $112576f3a2425ff3$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $efa3b0afd1a6032d$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $112576f3a2425ff3$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $112576f3a2425ff3$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$efa3b0afd1a6032d$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $efa3b0afd1a6032d$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($efa3b0afd1a6032d$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $112576f3a2425ff3$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $112576f3a2425ff3$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $efa3b0afd1a6032d$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($efa3b0afd1a6032d$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $112576f3a2425ff3$export$71511d61b312f219)(values.sort($efa3b0afd1a6032d$var$sorter));
    }
}
function $efa3b0afd1a6032d$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $112576f3a2425ff3$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $112576f3a2425ff3$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $efa3b0afd1a6032d$export$85df64a8eb6dc986 extends $efa3b0afd1a6032d$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $efa3b0afd1a6032d$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $efa3b0afd1a6032d$var$interpolate(table, this.min);
        this._tableRange = $efa3b0afd1a6032d$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($efa3b0afd1a6032d$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $efa3b0afd1a6032d$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $efa3b0afd1a6032d$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $efa3b0afd1a6032d$export$29e663ba4d09fe7,
    LinearScale: $efa3b0afd1a6032d$export$e7f4e5e8656f0b93,
    LogarithmicScale: $efa3b0afd1a6032d$export$85295eaf7cb3ac3e,
    RadialLinearScale: $efa3b0afd1a6032d$export$cfafc36d95386d38,
    TimeScale: $efa3b0afd1a6032d$export$a894c72689ff3ec,
    TimeSeriesScale: $efa3b0afd1a6032d$export$85df64a8eb6dc986
});
const $efa3b0afd1a6032d$export$e8959e79e3af550f = [
    $efa3b0afd1a6032d$export$a6506504f799c5d5,
    $efa3b0afd1a6032d$export$7a5d735b2ab6389d,
    $efa3b0afd1a6032d$export$8b3ca321c77fdea6,
    $efa3b0afd1a6032d$export$bcac1c16f1530ec2
];



var $aqdBs = parcelRequire("aqdBs");

const $93a516b9b61c6c29$var$defaultDatasetIdKey = 'label';
function $93a516b9b61c6c29$var$reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $93a516b9b61c6c29$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $93a516b9b61c6c29$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $93a516b9b61c6c29$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $93a516b9b61c6c29$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $93a516b9b61c6c29$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $93a516b9b61c6c29$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $93a516b9b61c6c29$var$setLabels(nextData, data.labels);
    $93a516b9b61c6c29$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $93a516b9b61c6c29$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $93a516b9b61c6c29$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $93a516b9b61c6c29$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function $93a516b9b61c6c29$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $aqdBs.useRef)(null);
    const chartRef = (0, $aqdBs.useRef)(null);
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $efa3b0afd1a6032d$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $93a516b9b61c6c29$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $93a516b9b61c6c29$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $93a516b9b61c6c29$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $aqdBs.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $93a516b9b61c6c29$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!redraw && chartRef.current) $93a516b9b61c6c29$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $93a516b9b61c6c29$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $aqdBs.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $aqdBs.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("canvas", {
        ref: canvasRef,
        role: "img",
        height: height,
        width: width,
        ...canvasProps
    }, fallbackContent);
}
const $93a516b9b61c6c29$export$acaa6426d77a227e = /*#__PURE__*/ (0, $aqdBs.forwardRef)($93a516b9b61c6c29$var$ChartComponent);
function $93a516b9b61c6c29$var$createTypedChart(type, registerables) {
    (0, $efa3b0afd1a6032d$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($93a516b9b61c6c29$export$acaa6426d77a227e, {
            ...props,
            ref: ref,
            type: type
        }));
}
const $93a516b9b61c6c29$export$17d680238e50603e = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('line', (0, $efa3b0afd1a6032d$export$3c9b5d28c11cbfd0));
const $93a516b9b61c6c29$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('bar', (0, $efa3b0afd1a6032d$export$e97d5dc64e999004));
const $93a516b9b61c6c29$export$bace472c466fdd25 = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('radar', (0, $efa3b0afd1a6032d$export$48dbc6ac651bf8be));
const $93a516b9b61c6c29$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('doughnut', (0, $efa3b0afd1a6032d$export$e04603e7d8b77172));
const $93a516b9b61c6c29$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('polarArea', (0, $efa3b0afd1a6032d$export$2a270b3a0d973c85));
const $93a516b9b61c6c29$export$646feb54fbadbe06 = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('bubble', (0, $efa3b0afd1a6032d$export$19b5c4773f17abe));
const $93a516b9b61c6c29$export$2ae8800cf67c848c = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('pie', (0, $efa3b0afd1a6032d$export$b21a3f1286706191));
const $93a516b9b61c6c29$export$1c460fb4285edadc = /* #__PURE__ */ $93a516b9b61c6c29$var$createTypedChart('scatter', (0, $efa3b0afd1a6032d$export$b2f2bae6713db87));




// Register Chart.js components
(0, $efa3b0afd1a6032d$export$acaa6426d77a227e).register((0, $efa3b0afd1a6032d$export$29e663ba4d09fe7), (0, $efa3b0afd1a6032d$export$e7f4e5e8656f0b93), (0, $efa3b0afd1a6032d$export$a16ed71bf4b07672), (0, $efa3b0afd1a6032d$export$55e463fa7bcd3469), (0, $efa3b0afd1a6032d$export$bd159b522b230b7a), (0, $efa3b0afd1a6032d$export$d48203c759d6a1fc), (0, $efa3b0afd1a6032d$export$f99233281efd08a0), (0, $efa3b0afd1a6032d$export$28c660c63b792dea), (0, $efa3b0afd1a6032d$export$ed247974535929c7));
const $10110f45c8701d34$var$CommandStats = (props)=>{
    const [timeRange, setTimeRange] = (0, $aqdBs.useState)("7d");
    const [recentPage, setRecentPage] = (0, $aqdBs.useState)(1);
    const showTopCommands = props.showTopCommands || 10;
    const showTopUsers = props.showTopUsers || 10;
    const showTopChannels = props.showTopChannels || 10;
    const recentActivityPerPage = props.recentActivityPerPage || 10;
    // Helper function to get CSS variable values
    const getCSSVariable = (variable)=>{
        return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
    };
    // Convert hex to rgba
    const hexToRgba = (hex, alpha = 1)=>{
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };
    // Get platform color with optional alpha
    const getPlatformColor = (platform, alpha)=>{
        const cssVar = platform === "discord" ? "--discord-color" : "--twitch-color";
        const color = getCSSVariable(cssVar);
        return alpha !== undefined ? hexToRgba(color, alpha) : color;
    };
    const { useCommandStatsOverview: useCommandStatsOverview, useTopCommands: useTopCommands, usePlatformBreakdown: usePlatformBreakdown, useTopUsers: useTopUsers, useCommandTimeline: useCommandTimeline, useRecentCommands: useRecentCommands, useTopChannels: useTopChannels } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    // Fetch all data with selected time range
    const { data: overview, isLoading: overviewLoading } = useCommandStatsOverview(timeRange);
    const { data: topCommands, isLoading: topCommandsLoading } = useTopCommands(showTopCommands, timeRange);
    const { data: platformBreakdown, isLoading: platformLoading } = usePlatformBreakdown(timeRange);
    const { data: topUsers, isLoading: topUsersLoading } = useTopUsers(showTopUsers, timeRange);
    const { data: timeline, isLoading: timelineLoading } = useCommandTimeline(timeRange, timeRange === "24h" ? "hour" : "day");
    const { data: recentCommands, isLoading: recentCommandsLoading } = useRecentCommands(recentPage, recentActivityPerPage);
    const { data: topChannels, isLoading: topChannelsLoading } = useTopChannels(showTopChannels, timeRange, undefined);
    const timeRangeOptions = [
        {
            value: "24h",
            label: "24 Hours"
        },
        {
            value: "7d",
            label: "7 Days"
        },
        {
            value: "30d",
            label: "30 Days"
        },
        {
            value: "90d",
            label: "90 Days"
        },
        {
            value: "all",
            label: "All Time"
        }
    ];
    const isLoading = overviewLoading || topCommandsLoading || platformLoading || topUsersLoading || timelineLoading || topChannelsLoading;
    // Generate gradient colors for bar chart
    const generateBarColors = (count)=>{
        const colors = [];
        for(let i = 0; i < count; i++){
            const hue = i * 360 / count + 250 // Start from purple-ish hue
            ;
            colors.push(`hsla(${hue % 360}, 70%, 60%, 0.7)`);
        }
        return colors;
    };
    // Prepare data for bar chart
    const barChartData = {
        labels: topCommands?.map((cmd)=>cmd.command) || [],
        datasets: [
            {
                label: "Usage Count",
                data: topCommands?.map((cmd)=>cmd.count) || [],
                backgroundColor: generateBarColors(topCommands?.length || 0),
                borderColor: generateBarColors(topCommands?.length || 0).map((color)=>color.replace("0.7)", "1)")),
                borderWidth: 1
            }
        ]
    };
    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    afterLabel: (context)=>{
                        const command = topCommands?.[context.dataIndex];
                        return command ? `${command.percentage}% of total` : "";
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };
    // Prepare data for pie chart
    const pieChartData = {
        labels: platformBreakdown?.map((p)=>{
            if (!p.platform) return "Unknown";
            return p.platform.charAt(0).toUpperCase() + p.platform.slice(1);
        }) || [],
        datasets: [
            {
                data: platformBreakdown?.map((p)=>p.count) || [],
                backgroundColor: platformBreakdown?.map((p)=>getPlatformColor(p.platform || "discord", 0.8)) || [],
                borderColor: platformBreakdown?.map((p)=>getPlatformColor(p.platform || "discord", 1)) || [],
                borderWidth: 1
            }
        ]
    };
    const pieChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom"
            },
            tooltip: {
                callbacks: {
                    label: (context)=>{
                        const platform = platformBreakdown?.[context.dataIndex];
                        if (!platform) return "";
                        const percentage = overview?.totalUsage ? (platform.count / overview.totalUsage * 100).toFixed(1) : "0";
                        return `${context.label}: ${platform.count} (${percentage}%) - ${platform.uniqueUsers} users, ${platform.uniqueCommands} commands`;
                    }
                }
            }
        }
    };
    // Prepare data for line chart
    const lineChartData = {
        labels: timeline?.map((t)=>t.date) || [],
        datasets: [
            {
                label: "Discord",
                data: timeline?.map((t)=>t.discord) || [],
                borderColor: getPlatformColor("discord"),
                backgroundColor: getPlatformColor("discord", 0.1),
                tension: 0.1
            },
            {
                label: "Twitch",
                data: timeline?.map((t)=>t.twitch) || [],
                borderColor: getPlatformColor("twitch"),
                backgroundColor: getPlatformColor("twitch", 0.1),
                tension: 0.1
            },
            {
                label: "Total",
                data: timeline?.map((t)=>t.total) || [],
                borderColor: "rgb(130, 202, 157)",
                backgroundColor: "rgba(130, 202, 157, 0.1)",
                tension: 0.1
            }
        ]
    };
    const lineChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom"
            }
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                className: "mb-4",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                        className: "d-flex justify-content-between align-items-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h5", {
                                className: "mb-0",
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-solid fa-clock-rotate-left me-2"
                                    }),
                                    "Time Range"
                                ]
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4402ef2d96a1c365$export$2e2bcd8739ae039), {
                                children: timeRangeOptions.map((option)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e1afafe9bfd9821d$export$2e2bcd8739ae039), {
                                        id: `time-${option.value}`,
                                        type: "radio",
                                        variant: "outline-primary",
                                        name: "timeRange",
                                        value: option.value,
                                        checked: timeRange === option.value,
                                        onChange: (e)=>setTimeRange(e.currentTarget.value),
                                        className: "time-range-pill",
                                        children: option.label
                                    }, option.value))
                            })
                        ]
                    })
                })
            }),
            isLoading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                className: "text-center py-5",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                    animation: "border",
                    role: "status",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                })
            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                md: 3,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    className: "stats-overview-card",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                className: "stats-icon",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-chart-line"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                className: "stats-content",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                        className: "stats-label",
                                                        children: "TOTAL USAGE"
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                                        className: "stats-value",
                                                        children: overview?.totalUsage.toLocaleString() || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                md: 3,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    className: "stats-overview-card",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                className: "stats-icon",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-users"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                className: "stats-content",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                        className: "stats-label",
                                                        children: "UNIQUE USERS"
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                                        className: "stats-value",
                                                        children: overview?.uniqueUsers.toLocaleString() || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                md: 3,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    className: "stats-overview-card",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                className: "stats-icon",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-terminal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                className: "stats-content",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                        className: "stats-label",
                                                        children: "UNIQUE COMMANDS"
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                                        className: "stats-value",
                                                        children: overview?.uniqueCommands.toLocaleString() || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                md: 3,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    className: "stats-overview-card",
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                className: "stats-icon",
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-calculator"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                className: "stats-content",
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("p", {
                                                        className: "stats-label",
                                                        children: "AVG USES/USER"
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h3", {
                                                        className: "stats-value",
                                                        children: overview && overview.uniqueUsers > 0 ? (overview.totalUsage / overview.uniqueUsers).toFixed(1) : 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-clock-rotate-left pe-1"
                                            }),
                                            "Recent Activity"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        className: "p-0",
                                        children: recentCommandsLoading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $162086630506a5b8$export$2e2bcd8739ae039), {
                                            striped: true,
                                            hover: true,
                                            responsive: true,
                                            size: "sm",
                                            className: "mb-0",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Time"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "User"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Community"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Command"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                                                    children: [
                                                        ...Array(recentActivityPerPage)
                                                    ].map((_, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                        as: "span",
                                                                        animation: "glow",
                                                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                            xs: 6
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                        as: "span",
                                                                        animation: "glow",
                                                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                            xs: 8
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                        as: "span",
                                                                        animation: "glow",
                                                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                            xs: 7
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                        as: "span",
                                                                        animation: "glow",
                                                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e35a74eb296af59f$export$2e2bcd8739ae039), {
                                                                            xs: 5
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, `skeleton-${index}`))
                                                })
                                            ]
                                        }) : recentCommands && recentCommands.logs.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $162086630506a5b8$export$2e2bcd8739ae039), {
                                                    striped: true,
                                                    hover: true,
                                                    responsive: true,
                                                    size: "sm",
                                                    className: "mb-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                        children: "Time"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                        children: "User"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                        children: "Community"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                        children: "Command"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                                                            children: recentCommands.logs.map((log)=>{
                                                                const community = log.source === "discord" ? log.metadata?.guild : log.metadata?.channel?.replace("#", "");
                                                                return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $2ae56bdcba59609a$export$2e2bcd8739ae039), {
                                                                                date: log.createdAt
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                            children: log.username
                                                                        }),
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                                                    className: `fa-brands fa-${log.source} me-2`,
                                                                                    style: {
                                                                                        color: log.source === "discord" ? "var(--discord-color)" : "var(--twitch-color)",
                                                                                        fontSize: "1.2em"
                                                                                    },
                                                                                    title: log.source
                                                                                }),
                                                                                community || "Unknown"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("code", {
                                                                                children: log.command
                                                                            })
                                                                        })
                                                                    ]
                                                                }, log._id);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                recentCommands.pagination.pages > 1 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                    className: "d-flex justify-content-between align-items-center p-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                            variant: "secondary",
                                                            size: "sm",
                                                            disabled: recentPage === 1,
                                                            onClick: ()=>setRecentPage(recentPage - 1),
                                                            children: "Previous"
                                                        }),
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("span", {
                                                            children: [
                                                                "Page ",
                                                                recentPage,
                                                                " of",
                                                                " ",
                                                                recentCommands.pagination.pages
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                                            variant: "secondary",
                                                            size: "sm",
                                                            disabled: recentPage >= recentCommands.pagination.pages,
                                                            onClick: ()=>setRecentPage(recentPage + 1),
                                                            children: "Next"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                            variant: "info",
                                            children: "No recent activity"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-users pe-1"
                                            }),
                                            "Top Users"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        className: "p-0",
                                        children: topUsers && topUsers.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $162086630506a5b8$export$2e2bcd8739ae039), {
                                            striped: true,
                                            hover: true,
                                            responsive: true,
                                            className: "mb-0",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "#"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Username"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Uses"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Unique Commands"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                                                    children: topUsers.map((user, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: index + 1
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                                            className: `fa-brands fa-${user.platform} me-2`,
                                                                            style: {
                                                                                color: user.platform === "discord" ? "var(--discord-color)" : "var(--twitch-color)",
                                                                                fontSize: "1.2em"
                                                                            },
                                                                            title: user.platform
                                                                        }),
                                                                        user.username
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: user.count.toLocaleString()
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: user.uniqueCommands
                                                                })
                                                            ]
                                                        }, index))
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                            variant: "info",
                                            children: "No user data available"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-hashtag pe-1"
                                            }),
                                            "Top Communities"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        className: "p-0",
                                        children: topChannels && topChannels.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $162086630506a5b8$export$2e2bcd8739ae039), {
                                            striped: true,
                                            hover: true,
                                            responsive: true,
                                            className: "mb-0",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "#"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Channel"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Commands Used"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Unique Users"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Unique Commands"
                                                            }),
                                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("th", {
                                                                children: "Usage %"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("tbody", {
                                                    children: topChannels.map((channel, index)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: index + 1
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                                            className: `fa-brands fa-${channel.platform} me-2`,
                                                                            style: {
                                                                                color: channel.platform === "discord" ? "var(--discord-color)" : "var(--twitch-color)",
                                                                                fontSize: "1.2em"
                                                                            },
                                                                            title: channel.platform
                                                                        }),
                                                                        channel.channel || "Unknown"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: channel.count.toLocaleString()
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: channel.uniqueUsers
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("td", {
                                                                    children: channel.uniqueCommands
                                                                }),
                                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("td", {
                                                                    children: [
                                                                        channel.percentage,
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        }, index))
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                            variant: "info",
                                            children: "No channel data available"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                className: "fa-solid fa-chart-bar pe-1"
                                            }),
                                            "Top Commands"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: topCommands && topCommands.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                            style: {
                                                height: "300px"
                                            },
                                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $93a516b9b61c6c29$export$bbc6c6369b38e3d1), {
                                                data: barChartData,
                                                options: barChartOptions
                                            })
                                        }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                            variant: "info",
                                            children: "No command data available"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                lg: 8,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-chart-line pe-1"
                                                }),
                                                "Usage Timeline"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                            children: timeline && timeline.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                style: {
                                                    height: "300px"
                                                },
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $93a516b9b61c6c29$export$17d680238e50603e), {
                                                    data: lineChartData,
                                                    options: lineChartOptions
                                                })
                                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                                variant: "info",
                                                children: "No timeline data available"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                lg: 4,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Header, {
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-chart-pie pe-1"
                                                }),
                                                "Platform Breakdown"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                            children: platformBreakdown && platformBreakdown.length > 0 ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                                                style: {
                                                    height: "300px"
                                                },
                                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $93a516b9b61c6c29$export$2ae8800cf67c848c), {
                                                    data: pieChartData,
                                                    options: pieChartOptions
                                                })
                                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                                                variant: "info",
                                                children: "No platform data available"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $10110f45c8701d34$export$2e2bcd8739ae039 = $10110f45c8701d34$var$CommandStats;




var $aqdBs = parcelRequire("aqdBs");


const $dea673e5e408b0ae$var$ManageStreamAlerts = ()=>{
    const { useStreamAlertsChannels: useStreamAlertsChannels, useAddChannelToStreamAlerts: useAddChannelToStreamAlerts, useRemoveChannelFromStreamAlerts: useRemoveChannelFromStreamAlerts, useEventSubSubscriptions: useEventSubSubscriptions, useClearAllSubscriptions: useClearAllSubscriptions, useResubscribeAllChannels: useResubscribeAllChannels } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: streamAlertsChannels } = useStreamAlertsChannels();
    const addChannelMutation = useAddChannelToStreamAlerts();
    const removeChannelMutation = useRemoveChannelFromStreamAlerts();
    const { data: subscriptions, refetch: refetchSubscriptions, isFetching: isLoadingSubscriptions } = useEventSubSubscriptions();
    const clearAllMutation = useClearAllSubscriptions();
    const resubscribeMutation = useResubscribeAllChannels();
    const [channelToAdd, setChannelToAdd] = $aqdBs.useState("");
    const handleChannelToAddInputChange = (e)=>{
        const value = e.target.value;
        setChannelToAdd(value);
    };
    const handleAddChannelToStreamAlerts = async ()=>{
        addChannelMutation.mutate(channelToAdd, {
            onSuccess: ()=>{
                setChannelToAdd("");
            }
        });
    };
    const [channelToRemove, setChannelToRemove] = $aqdBs.useState("");
    const handleChannelToRemoveInputChange = (e)=>{
        const value = e.target.value;
        setChannelToRemove(value);
    };
    const handleRemoveChannelFromStreamAlerts = async ()=>{
        removeChannelMutation.mutate(channelToRemove, {
            onSuccess: ()=>{
                setChannelToRemove("");
            }
        });
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                    bg: "secondary",
                    children: [
                        "Watching ",
                        streamAlertsChannels?.length,
                        " Channels"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                                controlId: "channelToAdd",
                                label: "Twitch username",
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    placeholder: "pokimane",
                                    name: "channelToAdd",
                                    value: channelToAdd,
                                    onChange: handleChannelToAddInputChange,
                                    autoComplete: "off"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: addChannelMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "statues",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "dark",
                                onClick: handleAddChannelToStreamAlerts,
                                size: "lg",
                                disabled: addChannelMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-regular fa-square-plus pe-1"
                                    }),
                                    " Add Channel"
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                                controlId: "channelToRemove",
                                label: "Choose a channel to remove",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Select, {
                                    "aria-label": "Choose a channel to remove",
                                    value: channelToRemove,
                                    onChange: handleChannelToRemoveInputChange,
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                            children: "-"
                                        }),
                                        streamAlertsChannels?.map((channel)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                                value: channel.id,
                                                children: channel.display_name
                                            }, channel.id))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: removeChannelMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "statues",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "dark",
                                onClick: handleRemoveChannelFromStreamAlerts,
                                size: "lg",
                                disabled: removeChannelMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-regular fa-square-minus pe-1"
                                    }),
                                    " Remove Channel"
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h4", {
                children: [
                    "EventSub Subscriptions",
                    " ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                        variant: "outline-secondary",
                        size: "sm",
                        onClick: ()=>refetchSubscriptions(),
                        disabled: isLoadingSubscriptions,
                        children: [
                            isLoadingSubscriptions ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                size: "sm"
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                className: "fa-solid fa-arrows-rotate"
                            }),
                            " ",
                            "Refresh"
                        ]
                    })
                ]
            }),
            subscriptions && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                        bg: "primary",
                        children: [
                            "Total: ",
                            subscriptions.length
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                        bg: "success",
                        children: [
                            "Enabled:",
                            " ",
                            subscriptions.filter((s)=>s.status === "enabled").length
                        ]
                    }),
                    " ",
                    subscriptions.filter((s)=>s.status !== "enabled").length > 0 && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                        bg: "warning",
                        children: [
                            "Other:",
                            " ",
                            subscriptions.filter((s)=>s.status !== "enabled").length
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: clearAllMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "status",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "danger",
                                onClick: ()=>{
                                    if (window.confirm("Are you sure you want to clear ALL EventSub subscriptions?")) clearAllMutation.mutate();
                                },
                                disabled: clearAllMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-solid fa-trash pe-1"
                                    }),
                                    " Clear All Subscriptions"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: resubscribeMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "status",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "success",
                                onClick: ()=>{
                                    if (window.confirm("Are you sure you want to re-subscribe all watched channels?")) resubscribeMutation.mutate();
                                },
                                disabled: resubscribeMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-solid fa-rotate pe-1"
                                    }),
                                    " Re-subscribe All Channels"
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $dea673e5e408b0ae$export$2e2bcd8739ae039 = $dea673e5e408b0ae$var$ManageStreamAlerts;




var $aqdBs = parcelRequire("aqdBs");


const $f03b058fd5c9ee04$var$ManageTwitchBot = ()=>{
    const { useTwitchBotChannels: useTwitchBotChannels, useJoinTwitchChannel: useJoinTwitchChannel, useLeaveTwitchChannel: useLeaveTwitchChannel } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const { data: twitchBotChannels } = useTwitchBotChannels();
    const joinChannelMutation = useJoinTwitchChannel();
    const leaveChannelMutation = useLeaveTwitchChannel();
    const [channelToJoin, setChannelToJoin] = $aqdBs.useState("");
    const handleChannelToAddInputChange = (e)=>{
        const value = e.target.value;
        setChannelToJoin(value);
    };
    const handleAddChannelToTwitchBot = async ()=>{
        joinChannelMutation.mutate(channelToJoin, {
            onSuccess: ()=>{
                setChannelToJoin("");
            }
        });
    };
    const [channelToRemove, setChannelToRemove] = $aqdBs.useState("");
    const handleChannelToRemoveInputChange = (e)=>{
        const value = e.target.value;
        setChannelToRemove(value);
    };
    const handleRemoveChannelFromTwitchBot = async ()=>{
        leaveChannelMutation.mutate(channelToRemove, {
            onSuccess: ()=>{
                setChannelToRemove("");
            }
        });
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h4", {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $2683667890e6910d$export$2e2bcd8739ae039), {
                    bg: "secondary",
                    children: [
                        "In ",
                        twitchBotChannels?.length,
                        " Channels"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                                controlId: "channelToAdd",
                                label: "Twitch username",
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    placeholder: "pokimane",
                                    name: "channelToAdd",
                                    value: channelToJoin,
                                    onChange: handleChannelToAddInputChange,
                                    autoComplete: "off"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: joinChannelMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "statues",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "dark",
                                onClick: handleAddChannelToTwitchBot,
                                size: "lg",
                                disabled: joinChannelMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-regular fa-square-plus pe-1"
                                    }),
                                    " Join Channel"
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $9fce716723ca1c72$export$2e2bcd8739ae039), {
                                controlId: "channelToRemove",
                                label: "Choose a channel to leave",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Select, {
                                    "aria-label": "Choose a channel to leave",
                                    value: channelToRemove,
                                    onChange: handleChannelToRemoveInputChange,
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                            children: "-"
                                        }),
                                        twitchBotChannels?.map((channel)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                                value: channel,
                                                children: channel
                                            }, channel))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                            children: leaveChannelMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                animation: "border",
                                role: "statues",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                    className: "visually-hidden",
                                    children: "Loading..."
                                })
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                                variant: "dark",
                                onClick: handleRemoveChannelFromTwitchBot,
                                size: "lg",
                                disabled: leaveChannelMutation.isPending,
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-regular fa-square-minus pe-1"
                                    }),
                                    " Leave Channel"
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $f03b058fd5c9ee04$export$2e2bcd8739ae039 = $f03b058fd5c9ee04$var$ManageTwitchBot;




var $aqdBs = parcelRequire("aqdBs");


var $i96EK = parcelRequire("i96EK");

const $7e5810705755bb09$var$TestEvents = ()=>{
    const { useTriggerTestEvent: useTriggerTestEvent } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)();
    const triggerMutation = useTriggerTestEvent();
    const [selectedEventKey, setSelectedEventKey] = (0, $aqdBs.useState)((0, $i96EK.TwitchStreamEventType).STREAM_ONLINE);
    const [customPayload, setCustomPayload] = (0, $aqdBs.useState)({});
    const [customPayloadText, setCustomPayloadText] = (0, $aqdBs.useState)("");
    const [jsonError, setJsonError] = (0, $aqdBs.useState)("");
    const [showCustom, setShowCustom] = (0, $aqdBs.useState)(false);
    const defaultPayloads = {
        [(0, $i96EK.RelayEvent).STREAM_ALERT]: {
            streamEventType: (0, $i96EK.TwitchStreamEventType).STREAM_ONLINE,
            userId: "69420",
            userLogin: "greenham",
            displayName: "greenHam",
            gameId: "899559811",
            gameName: "The Legend of Zelda: A Link to the Past",
            title: "Testing ALttP",
            thumbnail: "https://static-cdn.jtvnw.net/jtv_user_pictures/greenham-channel_offline_image-b87d176b4fd46ebb-1920x1080.png",
            isMature: true,
            profileImage: "https://static-cdn.jtvnw.net/jtv_user_pictures/a2a41cdc-27e7-42fe-88b6-8ddd96e4fc40-profile_image-300x300.png"
        },
        [(0, $i96EK.RelayEvent).WEEKLY_RACE_ROOM_CREATED]: {
            raceRoomUrl: "https://racetime.gg/alttp/test-weekly-race",
            startTimestamp: Math.floor((Date.now() + 3600000) / 1000)
        },
        [(0, $i96EK.RelayEvent).JOIN_TWITCH_CHANNEL]: {
            channel: "greenham"
        },
        [(0, $i96EK.RelayEvent).LEAVE_TWITCH_CHANNEL]: {
            channel: "greenham"
        },
        [(0, $i96EK.RelayEvent).TWITCH_BOT_CONFIG_UPDATED]: {
            channel: "greenham",
            config: {
                active: true,
                commandsEnabled: true,
                commandPrefix: "$",
                textCommandCooldown: 10,
                practiceListsEnabled: true,
                allowModsToManagePracticeLists: true,
                weeklyRaceAlertEnabled: false
            }
        }
    };
    const testEventConfigs = [
        {
            eventType: (0, $i96EK.RelayEvent).STREAM_ALERT,
            streamEventType: (0, $i96EK.TwitchStreamEventType).STREAM_ONLINE,
            label: "Stream Online",
            icon: "fa-solid fa-broadcast-tower",
            variant: "outline-primary",
            key: (0, $i96EK.TwitchStreamEventType).STREAM_ONLINE,
            showInQuickActions: true
        },
        {
            eventType: (0, $i96EK.RelayEvent).STREAM_ALERT,
            streamEventType: (0, $i96EK.TwitchStreamEventType).CHANNEL_UPDATE,
            label: "Channel Update",
            icon: "fa-solid fa-pen-to-square",
            variant: "outline-info",
            key: (0, $i96EK.TwitchStreamEventType).CHANNEL_UPDATE,
            showInQuickActions: true
        },
        {
            eventType: (0, $i96EK.RelayEvent).WEEKLY_RACE_ROOM_CREATED,
            label: "Weekly Race",
            icon: "fa-solid fa-flag-checkered",
            variant: "outline-success",
            key: (0, $i96EK.RelayEvent).WEEKLY_RACE_ROOM_CREATED,
            showInQuickActions: true
        },
        {
            eventType: (0, $i96EK.RelayEvent).JOIN_TWITCH_CHANNEL,
            label: "Join Channel",
            icon: "fa-solid fa-right-to-bracket",
            variant: "outline-warning",
            key: (0, $i96EK.RelayEvent).JOIN_TWITCH_CHANNEL,
            showInQuickActions: true
        },
        {
            eventType: (0, $i96EK.RelayEvent).LEAVE_TWITCH_CHANNEL,
            label: "Leave Channel",
            icon: "fa-solid fa-right-from-bracket",
            variant: "outline-danger",
            key: (0, $i96EK.RelayEvent).LEAVE_TWITCH_CHANNEL,
            showInQuickActions: true
        },
        {
            eventType: (0, $i96EK.RelayEvent).TWITCH_BOT_CONFIG_UPDATED,
            label: "Config Update",
            icon: "fa-solid fa-cog",
            variant: "outline-secondary",
            key: (0, $i96EK.RelayEvent).TWITCH_BOT_CONFIG_UPDATED,
            showInQuickActions: true
        }
    ];
    const handleTriggerEvent = ()=>{
        const selectedEventConfig = testEventConfigs.find((e)=>e.key === selectedEventKey);
        if (!selectedEventConfig) return;
        const basePayload = defaultPayloads[selectedEventConfig.eventType] || {};
        const eventPayload = selectedEventConfig.streamEventType ? {
            ...basePayload,
            streamEventType: selectedEventConfig.streamEventType
        } : basePayload;
        const payload = {
            eventType: selectedEventConfig.eventType,
            payload: showCustom ? customPayload : eventPayload
        };
        triggerMutation.mutate(payload);
    };
    const handleQuickTrigger = (config)=>{
        const basePayload = defaultPayloads[config.eventType] || {};
        const payload = {
            eventType: config.eventType,
            payload: config.streamEventType ? {
                ...basePayload,
                streamEventType: config.streamEventType
            } : basePayload
        };
        triggerMutation.mutate(payload);
    };
    const getCurrentEventPayload = ()=>{
        const selectedEventConfig = testEventConfigs.find((e)=>e.key === selectedEventKey);
        if (!selectedEventConfig) return {};
        const basePayload = defaultPayloads[selectedEventConfig.eventType] || {};
        return selectedEventConfig.streamEventType ? {
            ...basePayload,
            streamEventType: selectedEventConfig.streamEventType
        } : basePayload;
    };
    (0, $aqdBs.useEffect)(()=>{
        if (showCustom) {
            const payload = getCurrentEventPayload();
            setCustomPayload(payload);
            setCustomPayloadText(JSON.stringify(payload, null, 2));
            setJsonError("");
        }
    }, [
        showCustom,
        selectedEventKey
    ]);
    const handleJsonChange = (value)=>{
        setCustomPayloadText(value);
        try {
            const parsed = JSON.parse(value);
            setCustomPayload(parsed);
            setJsonError("");
        } catch (error) {
            setJsonError(error instanceof Error ? error.message : "Invalid JSON");
        }
    };
    const eventDescriptions = {
        [(0, $i96EK.RelayEvent).STREAM_ALERT]: "Simulates a stream going live or channel update",
        [(0, $i96EK.RelayEvent).WEEKLY_RACE_ROOM_CREATED]: "Simulates the weekly race room being created",
        [(0, $i96EK.RelayEvent).JOIN_TWITCH_CHANNEL]: "Simulates bot joining a Twitch channel",
        [(0, $i96EK.RelayEvent).LEAVE_TWITCH_CHANNEL]: "Simulates bot leaving a Twitch channel",
        [(0, $i96EK.RelayEvent).TWITCH_BOT_CONFIG_UPDATED]: "Simulates a configuration update"
    };
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
        className: "mb-4",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
                    variant: "info",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                            className: "fa-solid fa-circle-info"
                        }),
                        " Use these test events to simulate WebSocket relay events without actual Twitch/Discord activity. Events will be broadcast to all connected services."
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h6", {
                    children: "Quick Actions"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4402ef2d96a1c365$export$2e2bcd8739ae039), {
                    className: "mb-4 d-flex flex-wrap",
                    children: testEventConfigs.filter((config)=>config.showInQuickActions).map((config)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                            variant: config.variant,
                            size: "sm",
                            onClick: ()=>handleQuickTrigger(config),
                            disabled: triggerMutation.isPending,
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                    className: config.icon
                                }),
                                " ",
                                config.label
                            ]
                        }, config.key))
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("h6", {
                    children: "Custom Event Trigger"
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Group, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Label, {
                                                children: "Event Type"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Select, {
                                                value: selectedEventKey,
                                                onChange: (e)=>setSelectedEventKey(e.target.value),
                                                disabled: triggerMutation.isPending,
                                                children: testEventConfigs.map((eventConfig)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("option", {
                                                        value: eventConfig.key,
                                                        children: eventConfig.label
                                                    }, eventConfig.key))
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Text, {
                                                className: "text-muted",
                                                children: [
                                                    testEventConfigs.find((e)=>e.key === selectedEventKey)?.eventType,
                                                    ":",
                                                    " ",
                                                    eventDescriptions[testEventConfigs.find((e)=>e.key === selectedEventKey)?.eventType || (0, $i96EK.RelayEvent).STREAM_ALERT]
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Group, {
                                        children: [
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Label, {
                                                children: "Payload Type"
                                            }),
                                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Check, {
                                                        inline: true,
                                                        type: "radio",
                                                        id: "default-payload",
                                                        label: "Use Default",
                                                        checked: !showCustom,
                                                        onChange: ()=>setShowCustom(false),
                                                        disabled: triggerMutation.isPending
                                                    }),
                                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Check, {
                                                        inline: true,
                                                        type: "radio",
                                                        id: "custom-payload",
                                                        label: "Custom JSON",
                                                        checked: showCustom,
                                                        onChange: ()=>setShowCustom(true),
                                                        disabled: triggerMutation.isPending
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        showCustom && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Group, {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Label, {
                                            children: "Custom Payload (JSON)"
                                        }),
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control, {
                                            as: "textarea",
                                            rows: 8,
                                            value: customPayloadText,
                                            onChange: (e)=>handleJsonChange(e.target.value),
                                            disabled: triggerMutation.isPending,
                                            placeholder: '{"userLogin": "testuser", "title": "Test Stream"}',
                                            style: {
                                                fontFamily: "monospace"
                                            },
                                            spellCheck: false,
                                            autoComplete: "off",
                                            isInvalid: !!jsonError
                                        }),
                                        jsonError && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $6aec98047d2d5a85$export$2e2bcd8739ae039).Control.Feedback, {
                                            type: "invalid",
                                            children: [
                                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                                    className: "fa-solid fa-triangle-exclamation"
                                                }),
                                                " ",
                                                jsonError
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        !showCustom && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d182f2238d754ea$export$2e2bcd8739ae039), {
                            className: "mb-3",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $d6aefb3504f34578$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                                        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("pre", {
                                            className: "mb-0",
                                            style: {
                                                fontSize: "0.85rem"
                                            },
                                            children: JSON.stringify((()=>{
                                                const selectedEventConfig = testEventConfigs.find((e)=>e.key === selectedEventKey);
                                                if (!selectedEventConfig) return {};
                                                const basePayload = defaultPayloads[selectedEventConfig.eventType] || {};
                                                return selectedEventConfig.streamEventType ? {
                                                    ...basePayload,
                                                    streamEventType: selectedEventConfig.streamEventType
                                                } : basePayload;
                                            })(), null, 2)
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f068e13e24d891b9$export$2e2bcd8739ae039), {
                            variant: "primary",
                            onClick: handleTriggerEvent,
                            disabled: triggerMutation.isPending,
                            children: triggerMutation.isPending ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                        animation: "border",
                                        size: "sm",
                                        className: "me-2"
                                    }),
                                    "Triggering..."
                                ]
                            }) : /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                        className: "fa-solid fa-bolt"
                                    }),
                                    " Trigger Event"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $7e5810705755bb09$export$2e2bcd8739ae039 = $7e5810705755bb09$var$TestEvents;


const $134f25b38ad2a913$var$AdminPage = ()=>{
    const location = (0, $ebiy2.useLocation)();
    const navigate = (0, $ebiy2.useNavigate)();
    // Get initial tab from URL hash or localStorage
    const getInitialTab = ()=>{
        const hash = location.hash.replace("#", "");
        if (hash && [
            "stats",
            "alerts",
            "bot",
            "testing"
        ].includes(hash)) return hash;
        return localStorage.getItem("adminActiveTab") || "stats";
    };
    const [activeKey, setActiveKey] = (0, $aqdBs.useState)(getInitialTab());
    (0, $aqdBs.useEffect)(()=>{
        document.title = "Admin | Helpasaur King";
    }, []);
    // Handle tab change
    const handleTabSelect = (key)=>{
        if (key) {
            setActiveKey(key);
            localStorage.setItem("adminActiveTab", key);
            navigate(`#${key}`, {
                replace: true
            });
        }
    };
    const { data: user, isLoading: userLoading } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useUser();
    const { data: streamAlertsChannels, isLoading: streamAlertsChannelsLoading } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useStreamAlertsChannels();
    const { data: twitchBotChannels, isLoading: twitchBotChannelsLoading } = (0, $2d05e1b5e9934777$export$7e8232793e4d788f)().useTwitchBotChannels();
    if (userLoading) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
            animation: "border",
            role: "statues",
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                className: "visually-hidden",
                children: "Loading..."
            })
        })
    });
    if (!user || !user.permissions.includes("admin")) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4ec9043b326fe2a2$export$2e2bcd8739ae039), {
            variant: "danger",
            children: "You do not have permission to access this!"
        })
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $65e02d38214c434c$export$2e2bcd8739ae039), {
        className: "mt-5",
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                        className: "fa-solid fa-user-tie"
                    }),
                    " Helpa Admin"
                ]
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("hr", {
                className: "my-4"
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039), {
                className: "admin-tabs-container",
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $386893b3d9dd26b3$export$2e2bcd8739ae039).Body, {
                    className: "p-0",
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $f1e8c67065806b90$export$2e2bcd8739ae039), {
                        activeKey: activeKey,
                        onSelect: handleTabSelect,
                        id: "admin-tabs",
                        className: "admin-tabs",
                        variant: "pills",
                        children: [
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $766a6e46a0309d35$export$2e2bcd8739ae039), {
                                eventKey: "stats",
                                title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-solid fa-chart-simple me-2"
                                        }),
                                        "Statistics"
                                    ]
                                }),
                                className: "p-5",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $10110f45c8701d34$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $766a6e46a0309d35$export$2e2bcd8739ae039), {
                                eventKey: "alerts",
                                title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-brands fa-watchman-monitoring me-2"
                                        }),
                                        "Stream Alerts",
                                        streamAlertsChannelsLoading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            className: "ms-2",
                                            animation: "border",
                                            style: {
                                                width: "0.8rem",
                                                height: "0.8rem"
                                            }
                                        }) : streamAlertsChannels && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                            className: "badge bg-primary ms-2",
                                            children: streamAlertsChannels.length
                                        })
                                    ]
                                }),
                                className: "p-5",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $dea673e5e408b0ae$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $766a6e46a0309d35$export$2e2bcd8739ae039), {
                                eventKey: "bot",
                                title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-solid fa-robot me-2"
                                        }),
                                        "Twitch Bot",
                                        twitchBotChannelsLoading ? /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $adc2638fc2e44871$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            className: "ms-2",
                                            animation: "border",
                                            style: {
                                                width: "0.8rem",
                                                height: "0.8rem"
                                            }
                                        }) : twitchBotChannels && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("span", {
                                            className: "badge bg-primary ms-2",
                                            children: twitchBotChannels.length
                                        })
                                    ]
                                }),
                                className: "p-5",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f03b058fd5c9ee04$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $766a6e46a0309d35$export$2e2bcd8739ae039), {
                                eventKey: "testing",
                                title: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("i", {
                                            className: "fa-solid fa-vial-circle-check me-2"
                                        }),
                                        "Test Events"
                                    ]
                                }),
                                className: "p-5",
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7e5810705755bb09$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $134f25b38ad2a913$export$2e2bcd8739ae039 = $134f25b38ad2a913$var$AdminPage;



const $da32dc6e02a3c845$var$basename = "/";
const $da32dc6e02a3c845$var$router = (0, $MQCL2.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $cbc2be53dae69283$export$2e2bcd8739ae039), {}),
        errorElement: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5f7e6ee651796020$export$2e2bcd8739ae039), {}),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $405765626b6d8e5a$export$2e2bcd8739ae039), {})
            },
            {
                path: "streams",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $df47052fab0c77d5$export$2e2bcd8739ae039), {})
            },
            {
                path: "livestreams",
                loader: async ()=>{
                    return (0, $9FOsn.redirect)("/streams");
                }
            },
            {
                path: "commands",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $405765626b6d8e5a$export$2e2bcd8739ae039), {})
            },
            {
                path: "twitch",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $84f0da1af79900eb$export$2e2bcd8739ae039), {})
            },
            {
                path: "discord",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7d08ec247cc88275$export$2e2bcd8739ae039), {})
            },
            {
                path: "admin",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $134f25b38ad2a913$export$2e2bcd8739ae039), {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $e15ef1230fe62e1a$export$2e2bcd8739ae039), {})
            }
        ]
    }
], {
    basename: $da32dc6e02a3c845$var$basename
});
const $da32dc6e02a3c845$var$container = document.getElementById("app");
if (!$da32dc6e02a3c845$var$container) throw new Error("Failed to find app container element");
const $da32dc6e02a3c845$var$root = (0, $c920eedc27eaef64$export$882461b6382ed46c)($da32dc6e02a3c845$var$container);
$da32dc6e02a3c845$var$root.render(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($aqdBs.StrictMode, {
    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $MQCL2.RouterProvider), {
        router: $da32dc6e02a3c845$var$router
    })
}));


//# sourceMappingURL=web.9e8ae15d.js.map
